var qf = Object.defineProperty, Yf = Object.defineProperties;
var Xf = Object.getOwnPropertyDescriptors;
var Bi = Object.getOwnPropertySymbols;
var Pu = Object.prototype.hasOwnProperty, Hu = Object.prototype.propertyIsEnumerable;
var Nu = (e, t, n) => t in e ? qf(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, ie = (e, t) => {
  for (var n in t || (t = {}))
    Pu.call(t, n) && Nu(e, n, t[n]);
  if (Bi)
    for (var n of Bi(t))
      Hu.call(t, n) && Nu(e, n, t[n]);
  return e;
}, he = (e, t) => Yf(e, Xf(t));
var Ha = (e, t) => {
  var n = {};
  for (var o in e)
    Pu.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && Bi)
    for (var o of Bi(e))
      t.indexOf(o) < 0 && Hu.call(e, o) && (n[o] = e[o]);
  return n;
};
import { createElementBlock as h, openBlock as d, Fragment as Y, renderList as ee, createElementVNode as c, createBlock as k, resolveDynamicComponent as K, resolveComponent as $, normalizeStyle as j, renderSlot as w, createVNode as L, normalizeClass as v, createCommentVNode as b, toDisplayString as y, createTextVNode as A, withCtx as _, TransitionGroup as Ln, resolveDirective as Ve, withDirectives as ge, withKeys as V, withModifiers as z, Transition as Ee, vModelText as Qf, unref as Jf, getCurrentScope as L0, onScopeDispose as O0, ref as Yn, computed as Si, watch as qs, vShow as Sn, nextTick as En, normalizeProps as e5, guardReactiveProps as t5, mergeProps as we, onMounted as f1, getCurrentInstance as N0, toValue as P0, shallowRef as n5, useTemplateRef as o5, createSlots as H0, defineComponent as r5, onUnmounted as i5, Comment as s5, cloneVNode as a5, h as Pr } from "vue";
function Fu(e) {
  return e.type.indexOf("mouse") !== -1 ? e.clientX : e.touches[0].clientX;
}
function Ru(e) {
  return e.type.indexOf("mouse") !== -1 ? e.clientY : e.touches[0].clientY;
}
var l5 = function() {
  var e = !1;
  try {
    var t = Object.defineProperty({}, "passive", {
      get: function() {
        e = !0;
      }
    });
    window.addEventListener("test", null, t);
  } catch (n) {
  }
  return e;
}(), u5 = {
  install: function(e, t) {
    var n = Object.assign({}, {
      disableClick: !1,
      tapTolerance: 10,
      // px
      swipeTolerance: 30,
      // px
      touchHoldTolerance: 400,
      // ms
      longTapTimeInterval: 400,
      // ms
      touchClass: "",
      dragFrequency: 100,
      // ms
      rollOverFrequency: 100,
      // ms
      namespace: "touch"
    }, t);
    function o(C) {
      var E = this.$$touchObj, P = C.type.indexOf("touch") >= 0, F = C.type.indexOf("mouse") >= 0, D = this;
      P && (E.lastTouchStartTime = C.timeStamp), !(F && E.lastTouchStartTime && C.timeStamp - E.lastTouchStartTime < 350) && (E.touchStarted || (g(this), E.touchStarted = !0, E.touchMoved = !1, E.swipeOutBounded = !1, E.startX = Fu(C), E.startY = Ru(C), E.currentX = 0, E.currentY = 0, E.touchStartTime = C.timeStamp, E.hasSwipe = u(this, "swipe") || u(this, "swipe.left") || u(this, "swipe.right") || u(this, "swipe.top") || u(this, "swipe.bottom"), u(this, "hold") && (E.touchHoldTimer = setTimeout(function() {
        E.touchHoldTimer = null, m(C, D, "hold");
      }, E.options.touchHoldTolerance)), m(C, this, "press")));
    }
    function i(C) {
      var E = this.$$touchObj, P = Fu(C), F = Ru(C), D = E.currentX != P || E.currentY != F;
      if (E.currentX = P, E.currentY = F, E.touchMoved) {
        if (E.hasSwipe && !E.swipeOutBounded) {
          var B = E.options.swipeTolerance;
          E.swipeOutBounded = Math.abs(E.startX - E.currentX) > B && Math.abs(E.startY - E.currentY) > B;
        }
      } else {
        var H = E.options.tapTolerance;
        E.touchMoved = Math.abs(E.startX - E.currentX) > H || Math.abs(E.startY - E.currentY) > H, E.touchMoved && (T(E), m(C, this, "drag.once"));
      }
      if (u(this, "rollover") && D) {
        var U = C.timeStamp, x = E.options.rollOverFrequency;
        (E.touchRollTime == null || U > E.touchRollTime + x) && (E.touchRollTime = U, m(C, this, "rollover"));
      }
      if (u(this, "drag") && E.touchStarted && E.touchMoved && D) {
        var U = C.timeStamp, x = E.options.dragFrequency;
        (E.touchDragTime == null || U > E.touchDragTime + x) && (E.touchDragTime = U, m(C, this, "drag"));
      }
    }
    function r() {
      var C = this.$$touchObj;
      T(C), p(this), C.touchStarted = C.touchMoved = !1, C.startX = C.startY = 0;
    }
    function a(C) {
      var E = this.$$touchObj, P = C.type.indexOf("touch") >= 0, F = C.type.indexOf("mouse") >= 0;
      P && (E.lastTouchEndTime = C.timeStamp);
      var D = P && !E.touchHoldTimer;
      if (T(E), E.touchStarted = !1, p(this), !(F && E.lastTouchEndTime && C.timeStamp - E.lastTouchEndTime < 350))
        if (m(C, this, "release"), E.touchMoved) {
          if (E.hasSwipe && !E.swipeOutBounded) {
            var H = E.options.swipeTolerance, B, U = Math.abs(E.startY - E.currentY), x = Math.abs(E.startX - E.currentX);
            (U > H || x > H) && (U > x ? B = E.startY > E.currentY ? "top" : "bottom" : B = E.startX > E.currentX ? "left" : "right", u(this, "swipe." + B) ? m(C, this, "swipe." + B, B) : m(C, this, "swipe", B));
          }
        } else if (u(this, "longtap") && C.timeStamp - E.touchStartTime > E.options.longTapTimeInterval)
          C.cancelable && C.preventDefault(), m(C, this, "longtap");
        else if (u(this, "hold") && D) {
          C.cancelable && C.preventDefault();
          return;
        } else
          m(C, this, "tap");
    }
    function s() {
      g(this);
    }
    function l() {
      p(this);
    }
    function u(C, E) {
      var P = C.$$touchObj.callbacks[E];
      return P != null && P.length > 0;
    }
    function m(C, E, P, F) {
      var D = E.$$touchObj, H = D.callbacks[P];
      if (H == null || H.length === 0)
        return null;
      for (var B = 0; B < H.length; B++) {
        var U = H[B];
        U.modifiers.stop && C.stopPropagation(), U.modifiers.prevent && C.preventDefault(), !(U.modifiers.self && C.target !== C.currentTarget) && typeof U.value == "function" && (F ? U.value(F, C) : U.value(C));
      }
    }
    function g(C) {
      var E = C.$$touchObj.options.touchClass;
      E && C.classList.add(E);
    }
    function p(C) {
      var E = C.$$touchObj.options.touchClass;
      E && C.classList.remove(E);
    }
    function T(C) {
      C && C.touchHoldTimer && (clearTimeout(C.touchHoldTimer), C.touchHoldTimer = null);
    }
    function M(C, E) {
      var P = C.$$touchObj || {
        // an object contains all callbacks registered,
        // key is event name, value is an array
        callbacks: {},
        // prevent bind twice, set to true when event bound
        hasBindTouchEvents: !1,
        // default options, would be override by v-touch-options
        options: n
      };
      return E && (P.options = Object.assign({}, P.options, E)), C.$$touchObj = P, C.$$touchObj;
    }
    e.directive(n.namespace, {
      beforeMount: function(C, E) {
        var P = M(C), F = l5 ? { passive: !0 } : !1, D = E.arg || "tap";
        switch (D) {
          case "swipe":
            var H = E.modifiers;
            if (H.left || H.right || H.top || H.bottom) {
              for (var B in E.modifiers)
                if (["left", "right", "top", "bottom"].indexOf(B) >= 0) {
                  var U = "swipe." + B;
                  P.callbacks[U] = P.callbacks[U] || [], P.callbacks[U].push(E);
                }
            } else
              P.callbacks.swipe = P.callbacks.swipe || [], P.callbacks.swipe.push(E);
            break;
          case "press":
          case "drag":
            E.modifiers.disablePassive && (F = !1);
          default:
            P.callbacks[D] = P.callbacks[D] || [], P.callbacks[D].push(E);
        }
        P.hasBindTouchEvents || (C.addEventListener("touchstart", o, F), C.addEventListener("touchmove", i, F), C.addEventListener("touchcancel", r), C.addEventListener("touchend", a), P.options.disableClick || (C.addEventListener("mousedown", o), C.addEventListener("mousemove", i), C.addEventListener("mouseup", a), C.addEventListener("mouseenter", s), C.addEventListener("mouseleave", l)), P.hasBindTouchEvents = !0);
      },
      unmounted: function(C) {
        T(C.$$touchObj), C.removeEventListener("touchstart", o), C.removeEventListener("touchmove", i), C.removeEventListener("touchcancel", r), C.removeEventListener("touchend", a), C.$$touchObj && !C.$$touchObj.options.disableClick && (C.removeEventListener("mousedown", o), C.removeEventListener("mousemove", i), C.removeEventListener("mouseup", a), C.removeEventListener("mouseenter", s), C.removeEventListener("mouseleave", l)), delete C.$$touchObj;
      }
    }), e.directive(`${n.namespace}-class`, {
      beforeMount: function(C, E) {
        M(C, {
          touchClass: E.value
        });
      }
    }), e.directive(`${n.namespace}-options`, {
      beforeMount: function(C, E) {
        M(C, E.value);
      }
    });
  }
}, Vi = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function br(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var d5 = Array.isArray, Do = d5, c5 = typeof Vi == "object" && Vi && Vi.Object === Object && Vi, F0 = c5, h5 = F0, m5 = typeof self == "object" && self && self.Object === Object && self, p5 = h5 || m5 || Function("return this")(), Qt = p5, f5 = Qt, g5 = f5.Symbol, Ys = g5, Bu = Ys, R0 = Object.prototype, v5 = R0.hasOwnProperty, b5 = R0.toString, Hr = Bu ? Bu.toStringTag : void 0;
function y5(e) {
  var t = v5.call(e, Hr), n = e[Hr];
  try {
    e[Hr] = void 0;
    var o = !0;
  } catch (r) {
  }
  var i = b5.call(e);
  return o && (t ? e[Hr] = n : delete e[Hr]), i;
}
var _5 = y5, C5 = Object.prototype, w5 = C5.toString;
function T5(e) {
  return w5.call(e);
}
var k5 = T5, Vu = Ys, E5 = _5, S5 = k5, M5 = "[object Null]", A5 = "[object Undefined]", ju = Vu ? Vu.toStringTag : void 0;
function $5(e) {
  return e == null ? e === void 0 ? A5 : M5 : ju && ju in Object(e) ? E5(e) : S5(e);
}
var Mi = $5;
function I5(e) {
  return e != null && typeof e == "object";
}
var yr = I5, D5 = Mi, L5 = yr, O5 = "[object Symbol]";
function N5(e) {
  return typeof e == "symbol" || L5(e) && D5(e) == O5;
}
var Xs = N5, P5 = Do, H5 = Xs, F5 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, R5 = /^\w*$/;
function B5(e, t) {
  if (P5(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || H5(e) ? !0 : R5.test(e) || !F5.test(e) || t != null && e in Object(t);
}
var V5 = B5;
function j5(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Jn = j5, U5 = Mi, G5 = Jn, z5 = "[object AsyncFunction]", K5 = "[object Function]", Z5 = "[object GeneratorFunction]", x5 = "[object Proxy]";
function W5(e) {
  if (!G5(e))
    return !1;
  var t = U5(e);
  return t == K5 || t == Z5 || t == z5 || t == x5;
}
var B0 = W5, q5 = Qt, Y5 = q5["__core-js_shared__"], X5 = Y5, Fa = X5, Uu = function() {
  var e = /[^.]+$/.exec(Fa && Fa.keys && Fa.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Q5(e) {
  return !!Uu && Uu in e;
}
var J5 = Q5, eg = Function.prototype, tg = eg.toString;
function ng(e) {
  if (e != null) {
    try {
      return tg.call(e);
    } catch (t) {
    }
    try {
      return e + "";
    } catch (t) {
    }
  }
  return "";
}
var V0 = ng, og = B0, rg = J5, ig = Jn, sg = V0, ag = /[\\^$.*+?()[\]{}|]/g, lg = /^\[object .+?Constructor\]$/, ug = Function.prototype, dg = Object.prototype, cg = ug.toString, hg = dg.hasOwnProperty, mg = RegExp(
  "^" + cg.call(hg).replace(ag, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function pg(e) {
  if (!ig(e) || rg(e))
    return !1;
  var t = og(e) ? mg : lg;
  return t.test(sg(e));
}
var fg = pg;
function gg(e, t) {
  return e == null ? void 0 : e[t];
}
var vg = gg, bg = fg, yg = vg;
function _g(e, t) {
  var n = yg(e, t);
  return bg(n) ? n : void 0;
}
var Lo = _g, Cg = Lo, wg = Cg(Object, "create"), Qs = wg, Gu = Qs;
function Tg() {
  this.__data__ = Gu ? Gu(null) : {}, this.size = 0;
}
var kg = Tg;
function Eg(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Sg = Eg, Mg = Qs, Ag = "__lodash_hash_undefined__", $g = Object.prototype, Ig = $g.hasOwnProperty;
function Dg(e) {
  var t = this.__data__;
  if (Mg) {
    var n = t[e];
    return n === Ag ? void 0 : n;
  }
  return Ig.call(t, e) ? t[e] : void 0;
}
var Lg = Dg, Og = Qs, Ng = Object.prototype, Pg = Ng.hasOwnProperty;
function Hg(e) {
  var t = this.__data__;
  return Og ? t[e] !== void 0 : Pg.call(t, e);
}
var Fg = Hg, Rg = Qs, Bg = "__lodash_hash_undefined__";
function Vg(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Rg && t === void 0 ? Bg : t, this;
}
var jg = Vg, Ug = kg, Gg = Sg, zg = Lg, Kg = Fg, Zg = jg;
function _r(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
_r.prototype.clear = Ug;
_r.prototype.delete = Gg;
_r.prototype.get = zg;
_r.prototype.has = Kg;
_r.prototype.set = Zg;
var xg = _r;
function Wg() {
  this.__data__ = [], this.size = 0;
}
var qg = Wg;
function Yg(e, t) {
  return e === t || e !== e && t !== t;
}
var g1 = Yg, Xg = g1;
function Qg(e, t) {
  for (var n = e.length; n--; )
    if (Xg(e[n][0], t))
      return n;
  return -1;
}
var Js = Qg, Jg = Js, e9 = Array.prototype, t9 = e9.splice;
function n9(e) {
  var t = this.__data__, n = Jg(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : t9.call(t, n, 1), --this.size, !0;
}
var o9 = n9, r9 = Js;
function i9(e) {
  var t = this.__data__, n = r9(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var s9 = i9, a9 = Js;
function l9(e) {
  return a9(this.__data__, e) > -1;
}
var u9 = l9, d9 = Js;
function c9(e, t) {
  var n = this.__data__, o = d9(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
var h9 = c9, m9 = qg, p9 = o9, f9 = s9, g9 = u9, v9 = h9;
function Cr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Cr.prototype.clear = m9;
Cr.prototype.delete = p9;
Cr.prototype.get = f9;
Cr.prototype.has = g9;
Cr.prototype.set = v9;
var ea = Cr, b9 = Lo, y9 = Qt, _9 = b9(y9, "Map"), v1 = _9, zu = xg, C9 = ea, w9 = v1;
function T9() {
  this.size = 0, this.__data__ = {
    hash: new zu(),
    map: new (w9 || C9)(),
    string: new zu()
  };
}
var k9 = T9;
function E9(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var S9 = E9, M9 = S9;
function A9(e, t) {
  var n = e.__data__;
  return M9(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var ta = A9, $9 = ta;
function I9(e) {
  var t = $9(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var D9 = I9, L9 = ta;
function O9(e) {
  return L9(this, e).get(e);
}
var N9 = O9, P9 = ta;
function H9(e) {
  return P9(this, e).has(e);
}
var F9 = H9, R9 = ta;
function B9(e, t) {
  var n = R9(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
var V9 = B9, j9 = k9, U9 = D9, G9 = N9, z9 = F9, K9 = V9;
function wr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
wr.prototype.clear = j9;
wr.prototype.delete = U9;
wr.prototype.get = G9;
wr.prototype.has = z9;
wr.prototype.set = K9;
var j0 = wr, U0 = j0, Z9 = "Expected a function";
function b1(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Z9);
  var n = function() {
    var o = arguments, i = t ? t.apply(this, o) : o[0], r = n.cache;
    if (r.has(i))
      return r.get(i);
    var a = e.apply(this, o);
    return n.cache = r.set(i, a) || r, a;
  };
  return n.cache = new (b1.Cache || U0)(), n;
}
b1.Cache = U0;
var x9 = b1, W9 = x9, q9 = 500;
function Y9(e) {
  var t = W9(e, function(o) {
    return n.size === q9 && n.clear(), o;
  }), n = t.cache;
  return t;
}
var X9 = Y9, Q9 = X9, J9 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, e4 = /\\(\\)?/g, t4 = Q9(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(J9, function(n, o, i, r) {
    t.push(i ? r.replace(e4, "$1") : o || n);
  }), t;
}), n4 = t4;
function o4(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, i = Array(o); ++n < o; )
    i[n] = t(e[n], n, e);
  return i;
}
var r4 = o4, Ku = Ys, i4 = r4, s4 = Do, a4 = Xs, Zu = Ku ? Ku.prototype : void 0, xu = Zu ? Zu.toString : void 0;
function G0(e) {
  if (typeof e == "string")
    return e;
  if (s4(e))
    return i4(e, G0) + "";
  if (a4(e))
    return xu ? xu.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var l4 = G0, u4 = l4;
function d4(e) {
  return e == null ? "" : u4(e);
}
var c4 = d4, h4 = Do, m4 = V5, p4 = n4, f4 = c4;
function g4(e, t) {
  return h4(e) ? e : m4(e, t) ? [e] : p4(f4(e));
}
var v4 = g4, b4 = Xs;
function y4(e) {
  if (typeof e == "string" || b4(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var _4 = y4, C4 = v4, w4 = _4;
function T4(e, t) {
  t = C4(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[w4(t[n++])];
  return n && n == o ? e : void 0;
}
var k4 = T4, E4 = k4;
function S4(e, t, n) {
  var o = e == null ? void 0 : E4(e, t);
  return o === void 0 ? n : o;
}
var M4 = S4;
const S = /* @__PURE__ */ br(M4);
function Ts(e) {
  "@babel/helpers - typeof";
  return Ts = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ts(e);
}
var A4 = /^\s+/, $4 = /\s+$/;
function ae(e, t) {
  if (e = e || "", t = t || {}, e instanceof ae)
    return e;
  if (!(this instanceof ae))
    return new ae(e, t);
  var n = I4(e);
  this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
ae.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  getLuminance: function() {
    var t = this.toRgb(), n, o, i, r, a, s;
    return n = t.r / 255, o = t.g / 255, i = t.b / 255, n <= 0.03928 ? r = n / 12.92 : r = Math.pow((n + 0.055) / 1.055, 2.4), o <= 0.03928 ? a = o / 12.92 : a = Math.pow((o + 0.055) / 1.055, 2.4), i <= 0.03928 ? s = i / 12.92 : s = Math.pow((i + 0.055) / 1.055, 2.4), 0.2126 * r + 0.7152 * a + 0.0722 * s;
  },
  setAlpha: function(t) {
    return this._a = z0(t), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var t = qu(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      v: t.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var t = qu(this._r, this._g, this._b), n = Math.round(t.h * 360), o = Math.round(t.s * 100), i = Math.round(t.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + o + "%, " + i + "%)" : "hsva(" + n + ", " + o + "%, " + i + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var t = Wu(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      l: t.l,
      a: this._a
    };
  },
  toHslString: function() {
    var t = Wu(this._r, this._g, this._b), n = Math.round(t.h * 360), o = Math.round(t.s * 100), i = Math.round(t.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + o + "%, " + i + "%)" : "hsla(" + n + ", " + o + "%, " + i + "%, " + this._roundA + ")";
  },
  toHex: function(t) {
    return Yu(this._r, this._g, this._b, t);
  },
  toHexString: function(t) {
    return "#" + this.toHex(t);
  },
  toHex8: function(t) {
    return N4(this._r, this._g, this._b, this._a, t);
  },
  toHex8String: function(t) {
    return "#" + this.toHex8(t);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(Re(this._r, 255) * 100) + "%",
      g: Math.round(Re(this._g, 255) * 100) + "%",
      b: Math.round(Re(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(Re(this._r, 255) * 100) + "%, " + Math.round(Re(this._g, 255) * 100) + "%, " + Math.round(Re(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(Re(this._r, 255) * 100) + "%, " + Math.round(Re(this._g, 255) * 100) + "%, " + Math.round(Re(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : Z4[Yu(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(t) {
    var n = "#" + Xu(this._r, this._g, this._b, this._a), o = n, i = this._gradientType ? "GradientType = 1, " : "";
    if (t) {
      var r = ae(t);
      o = "#" + Xu(r._r, r._g, r._b, r._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + i + "startColorstr=" + n + ",endColorstr=" + o + ")";
  },
  toString: function(t) {
    var n = !!t;
    t = t || this._format;
    var o = !1, i = this._a < 1 && this._a >= 0, r = !n && i && (t === "hex" || t === "hex6" || t === "hex3" || t === "hex4" || t === "hex8" || t === "name");
    return r ? t === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (o = this.toRgbString()), t === "prgb" && (o = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (o = this.toHexString()), t === "hex3" && (o = this.toHexString(!0)), t === "hex4" && (o = this.toHex8String(!0)), t === "hex8" && (o = this.toHex8String()), t === "name" && (o = this.toName()), t === "hsl" && (o = this.toHslString()), t === "hsv" && (o = this.toHsvString()), o || this.toHexString());
  },
  clone: function() {
    return ae(this.toString());
  },
  _applyModification: function(t, n) {
    var o = t.apply(null, [this].concat([].slice.call(n)));
    return this._r = o._r, this._g = o._g, this._b = o._b, this.setAlpha(o._a), this;
  },
  lighten: function() {
    return this._applyModification(R4, arguments);
  },
  brighten: function() {
    return this._applyModification(B4, arguments);
  },
  darken: function() {
    return this._applyModification(V4, arguments);
  },
  desaturate: function() {
    return this._applyModification(P4, arguments);
  },
  saturate: function() {
    return this._applyModification(H4, arguments);
  },
  greyscale: function() {
    return this._applyModification(F4, arguments);
  },
  spin: function() {
    return this._applyModification(j4, arguments);
  },
  _applyCombination: function(t, n) {
    return t.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination(z4, arguments);
  },
  complement: function() {
    return this._applyCombination(U4, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(K4, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(G4, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(Qu, [3]);
  },
  tetrad: function() {
    return this._applyCombination(Qu, [4]);
  }
};
ae.fromRatio = function(e, t) {
  if (Ts(e) == "object") {
    var n = {};
    for (var o in e)
      e.hasOwnProperty(o) && (o === "a" ? n[o] = e[o] : n[o] = ei(e[o]));
    e = n;
  }
  return ae(e, t);
};
function I4(e) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, o = null, i = null, r = null, a = !1, s = !1;
  return typeof e == "string" && (e = Y4(e)), Ts(e) == "object" && (fn(e.r) && fn(e.g) && fn(e.b) ? (t = D4(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : fn(e.h) && fn(e.s) && fn(e.v) ? (o = ei(e.s), i = ei(e.v), t = O4(e.h, o, i), a = !0, s = "hsv") : fn(e.h) && fn(e.s) && fn(e.l) && (o = ei(e.s), r = ei(e.l), t = L4(e.h, o, r), a = !0, s = "hsl"), e.hasOwnProperty("a") && (n = e.a)), n = z0(n), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
function D4(e, t, n) {
  return {
    r: Re(e, 255) * 255,
    g: Re(t, 255) * 255,
    b: Re(n, 255) * 255
  };
}
function Wu(e, t, n) {
  e = Re(e, 255), t = Re(t, 255), n = Re(n, 255);
  var o = Math.max(e, t, n), i = Math.min(e, t, n), r, a, s = (o + i) / 2;
  if (o == i)
    r = a = 0;
  else {
    var l = o - i;
    switch (a = s > 0.5 ? l / (2 - o - i) : l / (o + i), o) {
      case e:
        r = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        r = (n - e) / l + 2;
        break;
      case n:
        r = (e - t) / l + 4;
        break;
    }
    r /= 6;
  }
  return {
    h: r,
    s: a,
    l: s
  };
}
function L4(e, t, n) {
  var o, i, r;
  e = Re(e, 360), t = Re(t, 100), n = Re(n, 100);
  function a(u, m, g) {
    return g < 0 && (g += 1), g > 1 && (g -= 1), g < 1 / 6 ? u + (m - u) * 6 * g : g < 1 / 2 ? m : g < 2 / 3 ? u + (m - u) * (2 / 3 - g) * 6 : u;
  }
  if (t === 0)
    o = i = r = n;
  else {
    var s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    o = a(l, s, e + 1 / 3), i = a(l, s, e), r = a(l, s, e - 1 / 3);
  }
  return {
    r: o * 255,
    g: i * 255,
    b: r * 255
  };
}
function qu(e, t, n) {
  e = Re(e, 255), t = Re(t, 255), n = Re(n, 255);
  var o = Math.max(e, t, n), i = Math.min(e, t, n), r, a, s = o, l = o - i;
  if (a = o === 0 ? 0 : l / o, o == i)
    r = 0;
  else {
    switch (o) {
      case e:
        r = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        r = (n - e) / l + 2;
        break;
      case n:
        r = (e - t) / l + 4;
        break;
    }
    r /= 6;
  }
  return {
    h: r,
    s: a,
    v: s
  };
}
function O4(e, t, n) {
  e = Re(e, 360) * 6, t = Re(t, 100), n = Re(n, 100);
  var o = Math.floor(e), i = e - o, r = n * (1 - t), a = n * (1 - i * t), s = n * (1 - (1 - i) * t), l = o % 6, u = [n, a, r, r, s, n][l], m = [s, n, n, a, r, r][l], g = [r, r, s, n, n, a][l];
  return {
    r: u * 255,
    g: m * 255,
    b: g * 255
  };
}
function Yu(e, t, n, o) {
  var i = [Xt(Math.round(e).toString(16)), Xt(Math.round(t).toString(16)), Xt(Math.round(n).toString(16))];
  return o && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) : i.join("");
}
function N4(e, t, n, o, i) {
  var r = [Xt(Math.round(e).toString(16)), Xt(Math.round(t).toString(16)), Xt(Math.round(n).toString(16)), Xt(K0(o))];
  return i && r[0].charAt(0) == r[0].charAt(1) && r[1].charAt(0) == r[1].charAt(1) && r[2].charAt(0) == r[2].charAt(1) && r[3].charAt(0) == r[3].charAt(1) ? r[0].charAt(0) + r[1].charAt(0) + r[2].charAt(0) + r[3].charAt(0) : r.join("");
}
function Xu(e, t, n, o) {
  var i = [Xt(K0(o)), Xt(Math.round(e).toString(16)), Xt(Math.round(t).toString(16)), Xt(Math.round(n).toString(16))];
  return i.join("");
}
ae.equals = function(e, t) {
  return !e || !t ? !1 : ae(e).toRgbString() == ae(t).toRgbString();
};
ae.random = function() {
  return ae.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function P4(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ae(e).toHsl();
  return n.s -= t / 100, n.s = na(n.s), ae(n);
}
function H4(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ae(e).toHsl();
  return n.s += t / 100, n.s = na(n.s), ae(n);
}
function F4(e) {
  return ae(e).desaturate(100);
}
function R4(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ae(e).toHsl();
  return n.l += t / 100, n.l = na(n.l), ae(n);
}
function B4(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ae(e).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), ae(n);
}
function V4(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ae(e).toHsl();
  return n.l -= t / 100, n.l = na(n.l), ae(n);
}
function j4(e, t) {
  var n = ae(e).toHsl(), o = (n.h + t) % 360;
  return n.h = o < 0 ? 360 + o : o, ae(n);
}
function U4(e) {
  var t = ae(e).toHsl();
  return t.h = (t.h + 180) % 360, ae(t);
}
function Qu(e, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = ae(e).toHsl(), o = [ae(e)], i = 360 / t, r = 1; r < t; r++)
    o.push(ae({
      h: (n.h + r * i) % 360,
      s: n.s,
      l: n.l
    }));
  return o;
}
function G4(e) {
  var t = ae(e).toHsl(), n = t.h;
  return [ae(e), ae({
    h: (n + 72) % 360,
    s: t.s,
    l: t.l
  }), ae({
    h: (n + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function z4(e, t, n) {
  t = t || 6, n = n || 30;
  var o = ae(e).toHsl(), i = 360 / n, r = [ae(e)];
  for (o.h = (o.h - (i * t >> 1) + 720) % 360; --t; )
    o.h = (o.h + i) % 360, r.push(ae(o));
  return r;
}
function K4(e, t) {
  t = t || 6;
  for (var n = ae(e).toHsv(), o = n.h, i = n.s, r = n.v, a = [], s = 1 / t; t--; )
    a.push(ae({
      h: o,
      s: i,
      v: r
    })), r = (r + s) % 1;
  return a;
}
ae.mix = function(e, t, n) {
  n = n === 0 ? 0 : n || 50;
  var o = ae(e).toRgb(), i = ae(t).toRgb(), r = n / 100, a = {
    r: (i.r - o.r) * r + o.r,
    g: (i.g - o.g) * r + o.g,
    b: (i.b - o.b) * r + o.b,
    a: (i.a - o.a) * r + o.a
  };
  return ae(a);
};
ae.readability = function(e, t) {
  var n = ae(e), o = ae(t);
  return (Math.max(n.getLuminance(), o.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), o.getLuminance()) + 0.05);
};
ae.isReadable = function(e, t, n) {
  var o = ae.readability(e, t), i, r;
  switch (r = !1, i = X4(n), i.level + i.size) {
    case "AAsmall":
    case "AAAlarge":
      r = o >= 4.5;
      break;
    case "AAlarge":
      r = o >= 3;
      break;
    case "AAAsmall":
      r = o >= 7;
      break;
  }
  return r;
};
ae.mostReadable = function(e, t, n) {
  var o = null, i = 0, r, a, s, l;
  n = n || {}, a = n.includeFallbackColors, s = n.level, l = n.size;
  for (var u = 0; u < t.length; u++)
    r = ae.readability(e, t[u]), r > i && (i = r, o = ae(t[u]));
  return ae.isReadable(e, o, {
    level: s,
    size: l
  }) || !a ? o : (n.includeFallbackColors = !1, ae.mostReadable(e, ["#fff", "#000"], n));
};
var Sl = ae.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, Z4 = ae.hexNames = x4(Sl);
function x4(e) {
  var t = {};
  for (var n in e)
    e.hasOwnProperty(n) && (t[e[n]] = n);
  return t;
}
function z0(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Re(e, t) {
  W4(e) && (e = "100%");
  var n = q4(e);
  return e = Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function na(e) {
  return Math.min(1, Math.max(0, e));
}
function St(e) {
  return parseInt(e, 16);
}
function W4(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function q4(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function Xt(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function ei(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function K0(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function Ju(e) {
  return St(e) / 255;
}
var xt = function() {
  var e = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + t + ")|(?:" + e + ")", o = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", i = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + o),
    rgba: new RegExp("rgba" + i),
    hsl: new RegExp("hsl" + o),
    hsla: new RegExp("hsla" + i),
    hsv: new RegExp("hsv" + o),
    hsva: new RegExp("hsva" + i),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function fn(e) {
  return !!xt.CSS_UNIT.exec(e);
}
function Y4(e) {
  e = e.replace(A4, "").replace($4, "").toLowerCase();
  var t = !1;
  if (Sl[e])
    e = Sl[e], t = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = xt.rgb.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = xt.rgba.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = xt.hsl.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = xt.hsla.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = xt.hsv.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = xt.hsva.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = xt.hex8.exec(e)) ? {
    r: St(n[1]),
    g: St(n[2]),
    b: St(n[3]),
    a: Ju(n[4]),
    format: t ? "name" : "hex8"
  } : (n = xt.hex6.exec(e)) ? {
    r: St(n[1]),
    g: St(n[2]),
    b: St(n[3]),
    format: t ? "name" : "hex"
  } : (n = xt.hex4.exec(e)) ? {
    r: St(n[1] + "" + n[1]),
    g: St(n[2] + "" + n[2]),
    b: St(n[3] + "" + n[3]),
    a: Ju(n[4] + "" + n[4]),
    format: t ? "name" : "hex8"
  } : (n = xt.hex3.exec(e)) ? {
    r: St(n[1] + "" + n[1]),
    g: St(n[2] + "" + n[2]),
    b: St(n[3] + "" + n[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function X4(e) {
  var t, n;
  return e = e || {
    level: "AA",
    size: "small"
  }, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: t,
    size: n
  };
}
var Q4 = Qt, J4 = function() {
  return Q4.Date.now();
}, e8 = J4, t8 = /\s/;
function n8(e) {
  for (var t = e.length; t-- && t8.test(e.charAt(t)); )
    ;
  return t;
}
var o8 = n8, r8 = o8, i8 = /^\s+/;
function s8(e) {
  return e && e.slice(0, r8(e) + 1).replace(i8, "");
}
var a8 = s8, l8 = a8, ed = Jn, u8 = Xs, td = NaN, d8 = /^[-+]0x[0-9a-f]+$/i, c8 = /^0b[01]+$/i, h8 = /^0o[0-7]+$/i, m8 = parseInt;
function p8(e) {
  if (typeof e == "number")
    return e;
  if (u8(e))
    return td;
  if (ed(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ed(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = l8(e);
  var n = c8.test(e);
  return n || h8.test(e) ? m8(e.slice(2), n ? 2 : 8) : d8.test(e) ? td : +e;
}
var Z0 = p8, f8 = Jn, Ra = e8, nd = Z0, g8 = "Expected a function", v8 = Math.max, b8 = Math.min;
function y8(e, t, n) {
  var o, i, r, a, s, l, u = 0, m = !1, g = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(g8);
  t = nd(t) || 0, f8(n) && (m = !!n.leading, g = "maxWait" in n, r = g ? v8(nd(n.maxWait) || 0, t) : r, p = "trailing" in n ? !!n.trailing : p);
  function T(U) {
    var x = o, Z = i;
    return o = i = void 0, u = U, a = e.apply(Z, x), a;
  }
  function M(U) {
    return u = U, s = setTimeout(P, t), m ? T(U) : a;
  }
  function C(U) {
    var x = U - l, Z = U - u, q = t - x;
    return g ? b8(q, r - Z) : q;
  }
  function E(U) {
    var x = U - l, Z = U - u;
    return l === void 0 || x >= t || x < 0 || g && Z >= r;
  }
  function P() {
    var U = Ra();
    if (E(U))
      return F(U);
    s = setTimeout(P, C(U));
  }
  function F(U) {
    return s = void 0, p && o ? T(U) : (o = i = void 0, a);
  }
  function D() {
    s !== void 0 && clearTimeout(s), u = 0, o = l = i = s = void 0;
  }
  function H() {
    return s === void 0 ? a : F(Ra());
  }
  function B() {
    var U = Ra(), x = E(U);
    if (o = arguments, i = this, l = U, x) {
      if (s === void 0)
        return M(l);
      if (g)
        return clearTimeout(s), s = setTimeout(P, t), T(l);
    }
    return s === void 0 && (s = setTimeout(P, t)), a;
  }
  return B.cancel = D, B.flush = H, B;
}
var _8 = y8;
const pi = /* @__PURE__ */ br(_8), Tt = {
  data() {
    return {
      screenSize: "",
      debouncedSetScreenSize: () => {
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setScreenSize();
    }), this.debouncedSetScreenSize = pi(this.setScreenSize, 100), window.addEventListener("resize", this.debouncedSetScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debouncedSetScreenSize);
  },
  methods: {
    setScreenSize() {
      this.screenSize = document.documentElement.clientWidth;
    }
  }
}, O = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, C8 = {
  name: "LinesAccent"
}, w8 = { class: "lines-accent" };
function T8(e, t, n, o, i, r) {
  return d(), h("div", w8, [
    (d(), h(Y, null, ee(3, (a, s) => c("div", {
      key: s,
      class: "accent"
    })), 64))
  ]);
}
const k8 = /* @__PURE__ */ O(C8, [["render", T8], ["__scopeId", "data-v-0477e467"]]), E8 = {
  name: "DotsAccent",
  methods: {
    yOffset(e) {
      return e * 8 + 1;
    }
  }
}, S8 = { class: "dots-accent" }, M8 = {
  width: "4000",
  height: "18",
  viewBox: "0 0 4000 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, A8 = ["y1", "y2"];
function $8(e, t, n, o, i, r) {
  return d(), h("div", S8, [
    (d(), h("svg", M8, [
      (d(), h(Y, null, ee(3, (a, s) => c("line", {
        key: s,
        x1: "0",
        y1: r.yOffset(s),
        x2: "4000",
        y2: r.yOffset(s),
        "stroke-dasharray": "2, 6",
        "stroke-width": "2"
      }, null, 8, A8)), 64))
    ]))
  ]);
}
const I8 = /* @__PURE__ */ O(E8, [["render", $8], ["__scopeId", "data-v-49a600d6"]]), D8 = {
  name: "HeaderAccent",
  components: { LinesAccent: k8, DotsAccent: I8 },
  props: {
    version: {
      type: String,
      default: ""
    }
  },
  computed: {
    accentType() {
      return this.version === "dot" ? "DotsAccent" : "LinesAccent";
    }
  }
}, L8 = { class: "header-accent" };
function O8(e, t, n, o, i, r) {
  return d(), h("div", L8, [
    (d(), k(K(r.accentType)))
  ]);
}
const N8 = /* @__PURE__ */ O(D8, [["render", O8], ["__scopeId", "data-v-8bc0e22c"]]), P8 = {
  name: "SeeAllContainer",
  components: { HeaderAccent: N8 },
  mixins: [Tt],
  props: {
    themeOptions: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      headerWidth: 32
    };
  },
  computed: {
    cssVars() {
      return {
        "--width-header": `${this.headerWidth}px`
      };
    },
    accentType() {
      return S(this.themeOptions, "globalThemeSettings.accentType", "dot");
    }
  },
  watch: {
    screenSize() {
      this.resize("watch");
    }
  },
  mounted() {
    this.resize("mounted");
  },
  methods: {
    resize() {
      this.$nextTick(() => {
        if (!this.$refs["header-slot-container"]) return;
        const e = this.$refs["header-slot-container"];
        e.firstElementChild && e.firstElementChild.offsetWidth !== null && e.firstElementChild.offsetWidth > 32 && (this.headerWidth = e.firstElementChild.offsetWidth);
      });
    }
  }
}, H8 = {
  ref: "header-slot-container",
  class: "header-slot-container"
}, F8 = {
  class: "purple-header-accent",
  "data-testid": "purple-header-accent"
};
function R8(e, t, n, o, i, r) {
  const a = $("HeaderAccent");
  return d(), h("div", {
    class: "see-all-container",
    "data-testid": "header",
    style: j(r.cssVars)
  }, [
    t[0] || (t[0] = c("span", {
      "data-testid": "monterrey-header-accent-left",
      class: "monterrey-header-accent-left"
    }, null, -1)),
    c("div", H8, [
      w(e.$slots, "header", { ref: "header-slot" })
    ], 512),
    c("div", F8, [
      L(a, { version: r.accentType }, null, 8, ["version"])
    ]),
    t[1] || (t[1] = c("span", {
      "data-testid": "light-header-accent",
      class: "light-header-accent"
    }, null, -1)),
    t[2] || (t[2] = c("span", {
      "data-testid": "monterrey-header-accent",
      class: "monterrey-header-accent"
    }, null, -1)),
    w(e.$slots, "default")
  ], 4);
}
const B8 = /* @__PURE__ */ O(P8, [["render", R8], ["__scopeId", "data-v-5a17ac72"]]), mt = {
  components: { SeeAllContainer: B8 },
  mixins: [Tt],
  methods: {
    getColorOption(e, ...t) {
      const n = t.find((o) => e[o]);
      return n ? e[n] : { hex: "" };
    },
    link(e = "") {
      return this.isPreview ? "#" : `${this.pathPrefix}/${e}`;
    },
    sharedThemeColors() {
      const e = this.theme.style, n = ["light", "purple", "monterrey", "sydney"].includes(e), o = S(this.theme, "bg_color.hex", "none"), i = S(this.theme, "heading_color.hex", "#000"), r = S(this.theme, "top_heading_color.hex", "#000"), a = S(this.theme, "see_all_link_color.hex", i), s = S(this.theme, "see_all_bg_color.hex", "#000"), l = S(this.theme, "see_all_text_color.hex", "#fff"), u = S(this.theme, "button_border_color.hex", "#000"), m = n ? S(this.theme, "button_bg_color.hex", s) : "none", g = n ? S(this.theme, "button_text_color.hex", l) : a, p = S(this.theme, "header_accent_color.hex", "#000");
      return {
        "--bg-color": o,
        "--heading-color": i,
        "--top-heading-color": r,
        "--button-bg-color": m,
        "--button-text-color": g,
        "--button-border-color": u,
        "--header-accent-color": p,
        "--focus-visible-outline": ae.mostReadable(o, ["#0000FF", "#FFFFFF"], { includeFallbackColors: !0 }).toHexString(),
        "--focus-visible-box-shadow": "#FFFFFF"
      };
    }
  }
};
function x0(e = "", t = 180) {
  return e.length <= t ? e : e.slice(0, t).concat("...");
}
const od = (e = "") => e.replace(/<[^>]*>/g, "").trim(), Ml = (e = "") => {
  const t = {
    "&amp;": "&",
    "&nbsp;": " ",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#44;": ",",
    "&gt;": ">",
    "&lt;": "<"
  }, n = new RegExp(Object.keys(t).join("|"), "gi");
  return e.replace(n, (o) => t[o.toLowerCase()]);
}, V8 = (e = "", t = 180) => t ? x0(od(Ml(e)), t) : od(Ml(e)), j8 = (e = "") => e.toLowerCase().replace(/ /g, "-"), U8 = (e = "") => {
  const n = (e.match(/<[^>]*>*/g) || []).pop() || "</>";
  return n.startsWith("</") ? e : e.replace(n, "...");
}, eo = {
  mixins: [mt],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    articles: {
      type: Array,
      default: () => []
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    fallbackImage: {
      type: Object,
      default: () => ({})
    },
    isIFrame: Boolean,
    newsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: Boolean
  },
  computed: {
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    isBoldStyle() {
      return this.theme.style === "bold";
    },
    cssVars() {
      const e = this.sharedThemeColors(), t = e["--heading-color"];
      return he(ie({}, e), {
        "--article-title-color": S(this.theme, "article_title_color.hex", t),
        "--article-date-color": S(this.theme, "article_date_color.hex", "#757575"),
        "--article-link-color": S(this.theme, "article_link_color.hex", "#CC314B"),
        "--snippet-color": S(this.theme, "snippet_color.hex", "#333"),
        "--news-accent-border-color": S(
          this.theme,
          "news_image_borders_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--news-accent-image-bar": S(
          this.theme,
          "news_image_color_bar.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--top-heading-color": S(this.theme, "top_heading_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--button-border-color": S(
          this.theme,
          "button_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--pager-color": S(this.theme, "pager_color.hex", "#CC314B"),
        "--arrow-background-color": S(this.theme, "arrow_background_color.hex", "#CC314B"),
        "--event-arrow-color": S(this.theme, "event_arrow_color.hex", "#fff"),
        "--scrollbar-color": S(this.theme, "scrollbar_color.hex", "#000"),
        "--scrollbar-bg_color": S(
          this.theme,
          "scrollbar_bg_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--scrollbar-arrow-color": S(this.theme, "scrollbar_arrow_color.hex", "#000"),
        "--arrow-icon-color": S(this.theme, "arrow_icon_color.hex", "#fff"),
        "--overlay-color": S(this.theme, "overlay_color.hex", "#000"),
        "--arrow-border-color": S(this.theme, "arrow_border_color.hex", "#000"),
        "--focus-outline-width": "2px",
        "--focus-outline-offset": "1px",
        "--focus-outline-margin": "calc(var(--focus-outline-width) + var(--focus-outline-offset))",
        "--focus-outline-shadow": "0 0 0 calc(var(--focus-outline-margin) * 2)"
      });
    },
    translations() {
      return this.theme.translations;
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("news");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.newsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    }
  },
  methods: {
    saniTruncate: V8,
    replaceHTMLEntities: Ml,
    calculateFocalPoints(e) {
      var o, i;
      if (!(e != null && e.cover_image)) return "50% 50%";
      const t = (o = e == null ? void 0 : e.image_focal_point_x) != null ? o : 50, n = (i = e == null ? void 0 : e.image_focal_point_y) != null ? i : 50;
      return `${t}% ${n}%`;
    }
  }
}, G8 = {
  name: "NewsStory",
  mixins: [eo],
  props: {
    item: {
      type: Object,
      required: !0
    },
    showSnippet: {
      type: Boolean,
      default: !0
    },
    showTitle: {
      type: Boolean,
      default: !0
    },
    variant: {
      type: String,
      required: !0
    },
    showPublishedTime: {
      type: Boolean,
      default: !1
    },
    totalCards: {
      type: Number,
      default: 0
    },
    cardNumber: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    },
    showSliderAriaLabels() {
      return ["N6-story", "N5-story"].includes(this.variant);
    },
    renderSeeAllButtonOverImage() {
      return this.seeAllButtonOverImage && this.theme.style !== "bold" && this.screenSize < 481;
    }
  },
  methods: {
    formatDate(e) {
      const t = e !== void 0 ? new Date(e) : /* @__PURE__ */ new Date();
      return new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeStyle: "short" }).format(t);
    }
  }
}, z8 = ["role", "aria-roledescription", "aria-label"], K8 = ["href"], Z8 = { class: "news-image-container" }, x8 = { class: "news-image" }, W8 = ["src"], q8 = {
  key: 0,
  class: "news-date",
  "data-testid": "news-date"
};
function Y8(e, t, n, o, i, r) {
  return d(), h("div", {
    role: r.showSliderAriaLabels ? "group" : void 0,
    "aria-roledescription": r.showSliderAriaLabels ? "slide" : void 0,
    "aria-label": r.showSliderAriaLabels ? `${n.cardNumber} of ${n.totalCards}` : void 0,
    class: v(["story", e.theme.style, n.variant])
  }, [
    c("a", {
      href: e.link(`article/${n.item.id}`),
      class: "news-image-title-link"
    }, [
      c("div", Z8, [
        c("div", x8, [
          c("div", {
            class: v(["image-hidden-wrapper", { "accent-styling": r.hasAccentStyling }])
          }, [
            c("img", {
              alt: "",
              src: n.item.cover_image ? n.item.cover_image : e.fallbackImage.url,
              style: j({ objectPosition: e.calculateFocalPoints(n.item) }),
              loading: "lazy"
            }, null, 12, W8),
            t[0] || (t[0] = c("div", { class: "news-backdrop" }, null, -1))
          ], 2)
        ])
      ]),
      n.showPublishedTime ? (d(), h("div", q8, y(r.formatDate(n.item.published_at)), 1)) : b("", !0),
      n.showTitle ? (d(), h("div", {
        key: 1,
        class: v(["news-title", [e.theme.style, { "accent-styling": r.hasAccentStyling }]])
      }, [
        A(y(e.saniTruncate(n.item.title)) + " ", 1),
        c("div", {
          class: v(["news-snippet inner-snippet", e.theme.style])
        }, y(e.replaceHTMLEntities(n.item.snippet)), 3)
      ], 2)) : b("", !0)
    ], 8, K8),
    n.showSnippet ? (d(), h("div", {
      key: 0,
      class: v(["news-snippet outer-snippet", e.theme.style])
    }, y(e.replaceHTMLEntities(n.item.snippet)), 3)) : b("", !0)
  ], 10, z8);
}
const Oo = /* @__PURE__ */ O(G8, [["render", Y8], ["__scopeId", "data-v-8769d942"]]), X8 = {
  name: "N1",
  components: { NewsStory: Oo },
  mixins: [eo]
}, Q8 = ["data-testid"], J8 = { class: "news-content" };
function e6(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("NewsStory");
  return d(), h("div", {
    id: "news-n1",
    style: j(e.cssVars),
    class: v([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "n1"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Q8)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: _(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", J8, [
      (d(!0), h(Y, null, ee(e.articles.slice(0, 4), (l, u) => (d(), k(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N1-story",
        class: v({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : b("", !0)
  ], 6);
}
const t6 = /* @__PURE__ */ O(X8, [["render", e6], ["__scopeId", "data-v-9c532a68"]]), n6 = {
  name: "N2",
  components: { NewsStory: Oo },
  mixins: [eo]
}, o6 = ["data-testid"], r6 = { class: "news-content" }, i6 = {
  "data-testid": "more-headlines",
  class: "more-headlines-header"
};
function s6(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("NewsStory");
  return d(), h("div", {
    id: "news-n2",
    class: v([e.theme.style, { "is-editing": e.isEditing }]),
    style: j(e.cssVars)
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, o6)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: _(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", r6, [
      (d(!0), h(Y, null, ee(e.articles.slice(0, 2), (l, u) => (d(), k(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N2-story",
        class: v({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    c("div", i6, y(e.translations.more_headlines), 1),
    c("div", {
      class: v([e.theme.style, "more-headlines-content news-content"])
    }, [
      (d(!0), h(Y, null, ee(e.articles.slice(2, 6), (l, u) => (d(), k(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N2-more-story",
        class: v({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "show-snippet": !1,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ], 2),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : b("", !0)
  ], 6);
}
const a6 = /* @__PURE__ */ O(n6, [["render", s6], ["__scopeId", "data-v-8889f982"]]), l6 = {
  name: "N3",
  components: { NewsStory: Oo },
  mixins: [eo]
}, u6 = ["data-testid"], d6 = { class: "news-content" };
function c6(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("NewsStory");
  return d(), h("div", {
    id: "news-n3",
    class: v([e.theme.style, { "is-editing": e.isEditing }]),
    style: j(e.cssVars)
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, u6)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: _(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", d6, [
      (d(!0), h(Y, null, ee(e.articles.slice(0, 4), (l, u) => (d(), k(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N3-story",
        class: v({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "show-snippet": !1,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : b("", !0)
  ], 6);
}
const h6 = /* @__PURE__ */ O(l6, [["render", c6], ["__scopeId", "data-v-cf8b1b78"]]), m6 = {
  name: "N4",
  components: { NewsStory: Oo },
  mixins: [eo]
}, p6 = ["data-testid"], f6 = { class: "news-content" };
function g6(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("NewsStory");
  return d(), h("div", {
    id: "news-n4",
    style: j(e.cssVars),
    class: v([e.theme.style, { "is-editing": e.isEditing }])
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, p6)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: _(() => [
        !e.isPurpleStyle && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", f6, [
      (d(!0), h(Y, null, ee(e.articles.slice(0, 3), (l, u) => (d(), k(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N4-story",
        class: v({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.isPurpleStyle || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : b("", !0)
  ], 6);
}
const v6 = /* @__PURE__ */ O(m6, [["render", g6], ["__scopeId", "data-v-4b721186"]]), b6 = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, y6 = ["fill"], _6 = ["stroke"];
function C6(e, t, n, o, i, r) {
  return d(), h("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.21582 1.18164L6.21582 14.1816M6.21582 1.18164L1.21582 5.97111M6.21582 1.18164L11.2158 5.97112",
      stroke: n.fillColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _6)
  ], 8, y6);
}
const w6 = /* @__PURE__ */ O(b6, [["render", C6]]), ut = {
  data() {
    return {
      currentCard: 0,
      visibleCardNum: 0,
      allCardsVisible: !1
    };
  },
  computed: {
    pagerSectionCount() {
      return Math.ceil(this.content.length / (this.visibleCardNum <= 0 ? 1 : this.visibleCardNum));
    },
    sliderCenterElements() {
      return this.sliderCenterSize && this.sliderCenterSize >= this.screenSize;
    },
    sliderReady() {
      return !!(this.$refs[`sliderCard-${this.currentCard}`] && this.$refs["sliderCard-0"] && this.$refs[`sliderCard-${this.content.length - 1}`]);
    }
  },
  mixins: [Tt],
  mounted() {
    this.$nextTick(() => {
      this.sliderReady && this.setVisibleCardNumber();
    }), window.addEventListener("resize", this.setVisibleCardNumber);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setVisibleCardNumber);
  },
  methods: {
    setVisibleCardNumber() {
      const e = this.lastVisibleCard(), t = this.firstVisibleCard();
      this.allCardsVisible = e < 0 && t === 0, this.visibleCardNum = e - t || 1, this.calculateScroll();
    },
    calculateScroll() {
      if (this.sliderReady) {
        const e = this.getHTMLElement(this.$refs[`sliderCard-${this.currentCard}`]), t = this.getHTMLElement(this.$refs["sliderCard-0"]), n = this.getHTMLElement(this.$refs[`sliderCard-${this.content.length - 1}`]), o = this.getHTMLElement(this.$refs.scrollWrapper);
        t.style["margin-left"] = this.sliderCenterElements ? "50vw" : "0px", n.style["margin-right"] = this.sliderCenterElements ? "50vw" : "0px";
        const i = e.getBoundingClientRect().left, r = this.sliderCenterElements ? e.offsetWidth / 2 : 0, a = this.sliderCenterElements ? (o.getBoundingClientRect().left + o.getBoundingClientRect().right) / 2 : o.getBoundingClientRect().left, s = i - (a - r);
        o.scrollLeft += s;
      }
    },
    lastVisibleCard() {
      if (!this.$refs) return;
      const e = this.getHTMLElement(this.$refs.scrollWrapper);
      if (!e || !this.sliderReady)
        return null;
      const t = e.getBoundingClientRect().right;
      return this.content.findIndex((n, o) => {
        var r, a;
        return ((a = this.getHTMLElement((r = this.$refs) == null ? void 0 : r[`sliderCard-${o}`])) == null ? void 0 : a.getBoundingClientRect().right) > t;
      });
    },
    firstVisibleCard() {
      if (!this.$refs) return;
      const e = this.getHTMLElement(this.$refs.scrollWrapper);
      if (!e || !this.sliderReady)
        return null;
      const t = e.getBoundingClientRect().left;
      return this.content.findIndex((n, o) => {
        var r, a;
        const i = (a = this.getHTMLElement((r = this.$refs) == null ? void 0 : r[`sliderCard-${o}`])) == null ? void 0 : a.getBoundingClientRect().left;
        return Math.round(i) >= t;
      });
    },
    scrollLeft() {
      if (this.sliderCenterElements)
        this.currentCard = this.currentCard === 0 ? this.content.length - 1 : this.currentCard - 1;
      else {
        const e = this.firstVisibleCard() - 1;
        this.currentCard = e < 0 ? this.content.length - 1 : e;
      }
      this.calculateScroll();
    },
    scrollRight() {
      this.sliderCenterElements ? this.currentCard = this.currentCard === this.content.length - 1 ? 0 : this.currentCard + 1 : this.currentCard = this.lastVisibleCard() < 0 || this.currentCard === this.content.length - this.visibleCardNum ? 0 : this.currentCard + 1, this.calculateScroll();
    },
    goToSection(e) {
      this.currentCard = (e - 1) * this.visibleCardNum, this.calculateScroll();
    },
    getHTMLElement(e) {
      if (!this.sliderReady)
        return;
      const t = Array.isArray(e) ? e[0] : e;
      return t instanceof Element ? t : t.$el;
    }
  }
}, T6 = {
  name: "Pager",
  props: {
    pagerColor: {
      type: String,
      default: "#0F0F0F"
    },
    totalCards: {
      type: Number,
      default: 0
    },
    currentCard: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      required: !0
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    }
  },
  computed: {
    pagerStyles() {
      return {
        "--total-sections": this.pagerSectionCount,
        "--pager-color": this.pagerColor
      };
    },
    cardsPerSection() {
      return Math.ceil(this.totalCards / this.pagerSectionCount);
    }
  },
  methods: {
    activeCard(e) {
      const t = (e - 1) * this.cardsPerSection, n = e * this.cardsPerSection - 1;
      return this.currentCard >= t && this.currentCard <= n;
    },
    ariaLabel(e) {
      return this.activeCard(e) ? S(this.themeStyles, "translations.active", "Active") : S(this.themeStyles, "translations.inactive", "Inactive");
    },
    ariaText(e) {
      return `Display slide ${this.cardsPerSection * e - this.cardsPerSection + 1} through ${this.cardsPerSection * e}`;
    }
  }
}, k6 = ["aria-current", "aria-label", "onClick"];
function E6(e, t, n, o, i, r) {
  return d(), h("div", {
    class: "pager",
    style: j(r.pagerStyles)
  }, [
    (d(!0), h(Y, null, ee(n.pagerSectionCount, (a, s) => (d(), h("button", {
      key: s,
      class: v([{ active: r.activeCard(a) }, "section"]),
      "aria-current": r.ariaLabel(a),
      "aria-label": r.ariaText(a),
      onClick: (l) => e.$emit("go-to-section", a)
    }, null, 10, k6))), 128))
  ], 4);
}
const y1 = /* @__PURE__ */ O(T6, [["render", E6], ["__scopeId", "data-v-627c6375"]]), S6 = {
  name: "SliderLeftButton",
  props: {
    arrowBackgroundColor: {
      type: String,
      default: "#FFFFFF"
    },
    arrowIconColor: {
      type: String,
      default: "#FFFFFF"
    },
    translatedAria: {
      type: String,
      default: ""
    }
  }
}, M6 = ["aria-label"], A6 = {
  width: "15",
  height: "12",
  viewBox: "0 0 15 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $6 = ["stroke"];
function I6(e, t, n, o, i, r) {
  return d(), h("button", {
    class: "scroll-left",
    "aria-label": n.translatedAria,
    style: j({ "background-color": n.arrowBackgroundColor }),
    onClick: t[0] || (t[0] = (a) => e.$emit("scroll-left"))
  }, [
    (d(), h("svg", A6, [
      c("path", {
        d: "M1 6L14 6M1 6L5.78947 11M1 6L5.78947 0.999999",
        stroke: n.arrowIconColor,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, $6)
    ]))
  ], 12, M6);
}
const D6 = /* @__PURE__ */ O(S6, [["render", I6], ["__scopeId", "data-v-766a4ad9"]]), L6 = {
  name: "SliderRightButton",
  props: {
    arrowBackgroundColor: {
      type: String,
      default: "#FFFFFF"
    },
    arrowIconColor: {
      type: String,
      default: "#FFFFFF"
    },
    translatedAria: {
      type: String,
      default: ""
    }
  }
}, O6 = ["aria-label"], N6 = {
  width: "15",
  height: "12",
  viewBox: "0 0 15 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, P6 = ["stroke"];
function H6(e, t, n, o, i, r) {
  return d(), h("button", {
    class: "scroll-right",
    "aria-label": n.translatedAria,
    style: j({ "background-color": n.arrowBackgroundColor }),
    onClick: t[0] || (t[0] = (a) => e.$emit("scroll-right"))
  }, [
    (d(), h("svg", N6, [
      c("path", {
        d: "M14 6H1M14 6L9.21053 1M14 6L9.21053 11",
        stroke: n.arrowIconColor,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, P6)
    ]))
  ], 12, O6);
}
const F6 = /* @__PURE__ */ O(L6, [["render", H6], ["__scopeId", "data-v-e7f3ab3f"]]), R6 = {
  name: "NavSection",
  components: {
    Pager: y1,
    LeftSliderButton: D6,
    RightSliderButton: F6
  },
  props: {
    hasPager: Boolean,
    hasAccent: Boolean,
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    navOrientation: {
      type: String,
      default: "bottom"
    },
    pagerOrientation: {
      type: String,
      default: "right"
    },
    totalCards: {
      type: Number,
      default: 0
    },
    currentCard: {
      type: Number,
      default: 0
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    },
    sectionHeader: {
      type: String,
      default: ""
    },
    screenSize: {
      type: Number,
      default: 0
    }
  },
  computed: {
    navStyles() {
      return {
        "--nav-margin-bottom": this.navOrientation === "top" ? "32px" : "0",
        "--nav-margin-top": this.navMarginTop,
        "--button-section-margin": this.navOrientation === "top" || this.navOrientation === "wide" ? "0" : "40px"
      };
    },
    eventArrowColor() {
      return S(this.themeStyles, "event_arrow_color.hex", "#fff");
    },
    arrowIconColor() {
      return S(this.themeStyles, "arrow_icon_color.hex", this.eventArrowColor);
    },
    arrowBackgroundColor() {
      return this.themeStyles.style === "texas" ? "transparent" : S(this.themeStyles, "arrow_background_color.hex", "#000");
    },
    pagerColor() {
      return S(this.themeStyles, "pager_color.hex", "#000");
    },
    accentColor() {
      return {
        "--accent-color": S(this.themeStyles, "accent_color.hex", "#000")
      };
    },
    navMarginTop() {
      switch (this.navOrientation) {
        case "wide":
          return this.themeStyles.version === "S5" ? this.screenSize < 600 ? "0" : "80px" : "32px";
        case "bottom":
          return "32px";
        default:
          return "0";
      }
    },
    nextSlideText() {
      return S(this.themeStyles, "translations.next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return S(this.themeStyles, "translations.previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    }
  }
}, B6 = {
  class: "button-section",
  "data-testid": "slider-buttons"
}, V6 = {
  key: 0,
  class: "pager-section"
}, j6 = {
  key: 1,
  class: "accent-border",
  "data-testid": "accent-border"
};
function U6(e, t, n, o, i, r) {
  const a = $("LeftSliderButton"), s = $("RightSliderButton"), l = $("Pager");
  return d(), h("div", {
    class: v(["nav", `pager-${n.pagerOrientation}`]),
    style: j([n.themeStyles, r.navStyles]),
    role: "group",
    "aria-label": "slide controls"
  }, [
    c("div", B6, [
      L(a, {
        class: "button",
        "arrow-background-color": r.arrowBackgroundColor,
        "arrow-icon-color": r.arrowIconColor,
        "translated-aria": r.previousSlideText,
        onScrollLeft: t[0] || (t[0] = (u) => e.$emit("scroll-left"))
      }, null, 8, ["arrow-background-color", "arrow-icon-color", "translated-aria"]),
      L(s, {
        class: "button",
        "arrow-background-color": r.arrowBackgroundColor,
        "arrow-icon-color": r.arrowIconColor,
        "translated-aria": r.nextSlideText,
        onScrollRight: t[1] || (t[1] = (u) => e.$emit("scroll-right"))
      }, null, 8, ["arrow-background-color", "arrow-icon-color", "translated-aria"])
    ]),
    n.hasPager ? (d(), h("div", V6, [
      L(l, {
        "total-cards": n.totalCards,
        "pager-color": r.pagerColor,
        "theme-styles": n.themeStyles,
        "current-card": n.currentCard,
        "pager-section-count": n.pagerSectionCount,
        onGoToSection: t[2] || (t[2] = (u) => e.$emit("go-to-section", u))
      }, null, 8, ["total-cards", "pager-color", "theme-styles", "current-card", "pager-section-count"])
    ])) : b("", !0),
    n.hasAccent ? (d(), h("div", j6)) : b("", !0)
  ], 6);
}
const G6 = /* @__PURE__ */ O(R6, [["render", U6], ["__scopeId", "data-v-670020bb"]]), z6 = {
  name: "CardSlider",
  components: { NavSection: G6 },
  props: {
    navOrientation: {
      type: String,
      default: "bottom"
    },
    pagerOrientation: {
      type: String,
      default: "right"
    },
    hasPager: {
      type: Boolean,
      default: !0
    },
    hasAccent: Boolean,
    totalCards: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    currentCard: {
      type: Number,
      default: 0
    },
    allCardsVisible: Boolean,
    screenSize: {
      type: Number,
      default: 0
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    },
    sectionHeader: {
      type: String,
      required: !0
    }
  },
  emits: ["go-to-section", "scroll-left", "scroll-right"]
}, K6 = ["aria-label"];
function Z6(e, t, n, o, i, r) {
  const a = $("NavSection");
  return d(), h("div", {
    class: v([n.navOrientation, "card-slider"]),
    "aria-label": n.sectionHeader,
    role: "region",
    "aria-roledescription": "carousel"
  }, [
    n.allCardsVisible ? b("", !0) : (d(), k(a, {
      key: 0,
      "nav-orientation": n.navOrientation,
      "pager-orientation": n.pagerOrientation,
      "pager-section-count": n.pagerSectionCount,
      "has-accent": n.hasAccent,
      "current-card": n.currentCard,
      "total-cards": n.totalCards,
      "theme-styles": n.themeStyles,
      "has-pager": n.hasPager,
      "screen-size": n.screenSize,
      "section-header": n.sectionHeader,
      onGoToSection: t[0] || (t[0] = (s) => e.$emit("go-to-section", s)),
      onScrollLeft: t[1] || (t[1] = (s) => e.$emit("scroll-left")),
      onScrollRight: t[2] || (t[2] = (s) => e.$emit("scroll-right"))
    }, null, 8, ["nav-orientation", "pager-orientation", "pager-section-count", "has-accent", "current-card", "total-cards", "theme-styles", "has-pager", "screen-size", "section-header"])),
    w(e.$slots, "default")
  ], 10, K6);
}
const Jt = /* @__PURE__ */ O(z6, [["render", Z6], ["__scopeId", "data-v-fbf2997e"]]), x6 = {
  name: "N5",
  components: { NewsStory: Oo, ArrowIcon: w6, CardSlider: Jt },
  mixins: [eo, ut],
  data: () => ({
    activeNewsContainer: 0,
    newsArticles: []
  }),
  computed: {
    scrollbarArrowColor() {
      var e;
      return ((e = this.theme) == null ? void 0 : e.scrollbar_arrow_color) || { hex: "#FFF" };
    },
    cardSliderStyles() {
      var e, t;
      return he(ie({}, this.theme), {
        arrow_background_color: ((e = this.theme) == null ? void 0 : e.scrollbar_bg_color) || this.cssVars["--scrollbar-bg_color"],
        arrow_icon_color: ((t = this.theme) == null ? void 0 : t.scrollbar_arrow_color) || this.cssVars["--scrollbar-arrow-color"]
      });
    },
    totalArticles() {
      return { "--total-articles": this.articles.slice(0, 6).length };
    },
    content() {
      return this.newsArticles;
    },
    sliderCenterSize() {
      return 959;
    },
    responsiveSliderImage() {
      return {
        "--responsive-width": this.newsArticles.length > 1 && this.screenSize >= 960 ? `${this.screenSize - 80}px` : "100%"
      };
    },
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    },
    overviewImage() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.cover_image) || this.fallbackImage.url;
    },
    overviewTitle() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.title) || "";
    },
    articleTitle() {
      var e;
      return ((e = this.newsArticles[this.currentCard]) == null ? void 0 : e.title) || "";
    },
    overviewPublishedTime() {
      var t;
      const e = (t = this.newsArticles[0]) != null && t.published_at ? new Date(this.newsArticles[0].published_at) : /* @__PURE__ */ new Date();
      return new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeStyle: "short" }).format(e);
    },
    overviewLink() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.id) || "";
    },
    overviewStyles() {
      return {
        "--overview-width": this.newsArticles.length === 1 ? "100%" : "70%",
        "--overview-width-md": this.newsArticles.length === 1 ? "100%" : "55%",
        "--overview-body-width": this.newsArticles.length === 1 ? "auto" : "90%",
        "--overview-body-margin": this.newsArticles.length === 1 ? "48px" : "0",
        "--overview-margin-md": this.newsArticles.length === 1 ? "0" : "35px"
      };
    },
    scrollStyles() {
      return {
        "--wrapper-margin-bottom": this.newsArticles.length < 5 ? "0" : "-32px"
      };
    },
    articleLink() {
      var e;
      return ((e = this.newsArticles[this.currentCard]) == null ? void 0 : e.id) || "";
    },
    nextSlideText() {
      return S(this.translations, "next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return S(this.translations, "previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    },
    displaySeeAllBottom() {
      return this.isPurpleStyle || this.screenSize < 960 && !this.isBoldStyle || this.screenSize < 600;
    },
    displaySeeAllTop() {
      return !this.isPurpleStyle && this.screenSize >= 960 || this.isBoldStyle && this.screenSize < 959 && this.screenSize >= 600;
    },
    n5PagerStyle() {
      return {
        "--pager-width": `${this.screenSize / this.newsArticles.length * 0.8}px`
      };
    }
  },
  created() {
    this.newsArticles = this.articles.slice(0, 6);
  },
  methods: {
    /**
     * @name scrollUp
     * First it triggers the moveUp function.
     * Then, after the animation has ended, it re arrenges the order of the news list, removing the last element in the list and pushing it at the beginning.
     * Finally, updates the activeNewsContainer variable to update the scroll position and calls the resetTranslate function.
     */
    scrollUp() {
      const e = this.newsArticles, t = e.pop();
      e.unshift(t), this.newsArticles = e, this.activeNewsContainer === 0 ? this.activeNewsContainer = this.newsArticles.length - 1 : this.activeNewsContainer -= 1;
    },
    /**
     * @name scrollDown
     * First it triggers the moveDown function.
     * Then, after the animation has ended, it re arrenges the order of the news list, removing the first element in the list and pushing it at the end.
     * After that, it calls the function setOverviewNews to change the overview news on the left.
     * Finally, updates the activeNewsContainer variable to update the scroll position and calls the resetTranslate function.
     */
    scrollDown() {
      const e = this.newsArticles, t = e.shift();
      e.push(t), this.newsArticles = e, this.activeNewsContainer === this.newsArticles.length - 1 ? this.activeNewsContainer = 0 : this.activeNewsContainer += 1;
    }
  }
}, W6 = { class: "news-v5-title" }, q6 = ["data-testid"], Y6 = ["data-testid"], X6 = { class: "news-overview" }, Q6 = { class: "news-overview-body" }, J6 = ["href"], e3 = ["src"], t3 = { class: "news-overview-published-time" }, n3 = { class: "news-overview-title" }, o3 = { class: "news-overview-link" }, r3 = ["aria-label"], i3 = {
  key: 0,
  class: "news-scroll",
  role: "group",
  "aria-label": "slide controls"
}, s3 = ["aria-label"], a3 = ["aria-label"], l3 = ["aria-current"], u3 = { class: "article-title" }, d3 = ["href"], c3 = ["href"];
function h3(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("arrow-icon"), l = $("NewsStory"), u = $("CardSlider");
  return d(), h("div", {
    id: "news-n5",
    style: j(e.cssVars),
    class: v([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "n5"
  }, [
    c("div", W6, [
      L(a, {
        class: v([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: _(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (d(), h("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              w(e.$slots, "header-top", {}, () => [
                A(y(e.sectionHeaderTop), 1)
              ], !0)
            ], 8, Y6)) : b("", !0),
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ], 8, q6)
        ]),
        default: _(() => [
          r.displaySeeAllTop ? (d(), k(K(e.isEditing ? "button" : "a"), {
            key: 0,
            class: v(["see-all-button hide-on-xs", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (m) => e.$emit("open-modal"))
          }, {
            default: _(() => [
              A(y(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])
    ]),
    e.screenSize >= 960 ? (d(), h("div", {
      key: 0,
      class: v(["news-content", { "is-editing": e.isEditing }]),
      style: j(r.overviewStyles)
    }, [
      c("div", X6, [
        c("div", Q6, [
          c("a", {
            href: e.link(`article/${r.overviewLink}`)
          }, [
            c("div", {
              class: v([{ "accent-styling": r.hasAccentStyling }, "news-overview-image-container"])
            }, [
              (d(), h("img", {
                key: e.activeNewsContainer,
                src: r.overviewImage,
                style: j({ objectPosition: e.calculateFocalPoints(e.newsArticles[0]) }),
                alt: "",
                class: "news-overview-image"
              }, null, 12, e3)),
              t[4] || (t[4] = c("div", { class: "news-backdrop" }, null, -1))
            ], 2),
            c("p", t3, y(r.overviewPublishedTime), 1),
            c("h3", n3, y(r.overviewTitle), 1),
            c("div", o3, [
              c("p", null, y(e.translations.read_article), 1)
            ])
          ], 8, J6)
        ])
      ]),
      c("div", {
        "aria-label": e.sectionHeader,
        class: "news-scroll-wrapper",
        role: "region",
        "aria-roledescription": "carousel"
      }, [
        e.newsArticles.length > 4 ? (d(), h("div", i3, [
          c("button", {
            class: "news-scroll-up",
            "aria-label": r.previousSlideText,
            onClick: t[1] || (t[1] = (...m) => r.scrollUp && r.scrollUp(...m))
          }, [
            L(s, {
              "fill-color": r.scrollbarArrowColor.hex,
              class: "arrow"
            }, null, 8, ["fill-color"])
          ], 8, s3),
          c("button", {
            class: "news-scroll-down",
            "aria-label": r.nextSlideText,
            onClick: t[2] || (t[2] = (...m) => r.scrollDown && r.scrollDown(...m))
          }, [
            L(s, {
              "fill-color": r.scrollbarArrowColor.hex,
              class: "arrow",
              "dropdown-class": "open"
            }, null, 8, ["fill-color"])
          ], 8, a3),
          c("div", {
            class: "progress-bar",
            style: j(r.totalArticles)
          }, [
            (d(!0), h(Y, null, ee(e.newsArticles, (m, g) => (d(), h("div", {
              key: m.id,
              class: v(["progress-section", { active: e.activeNewsContainer === g }]),
              "aria-current": e.activeNewsContainer === g ? e.translations.active : e.translations.inactive
            }, null, 10, l3))), 128))
          ], 4)
        ])) : b("", !0),
        c("div", {
          class: "news-list",
          "data-testid": "list",
          style: j({ "margin-right": e.newsArticles.length < 5 ? "15px" : 0 })
        }, [
          L(Ln, {
            name: "scroll-wrapper",
            tag: "div",
            class: "scroll-wrapper",
            style: j(r.scrollStyles)
          }, {
            default: _(() => [
              (d(!0), h(Y, null, ee(e.newsArticles, (m, g) => (d(), k(l, {
                key: m.id,
                item: m,
                theme: e.theme,
                class: v([{ "is-editing": e.isEditing, "has-scroll": e.newsArticles.length > 4 }, "article-container"]),
                "show-snippet": !1,
                "is-preview": e.isPreview,
                "fallback-image": e.fallbackImage,
                "path-prefix": e.pathPrefix,
                "total-cards": e.newsArticles.length,
                "card-number": g + 1,
                variant: "N5-story",
                "data-testid": "news-story"
              }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
            ]),
            _: 1
          }, 8, ["style"])
        ], 4)
      ], 8, r3)
    ], 6)) : (d(), k(u, {
      key: 1,
      "current-card": e.currentCard,
      "pager-section-count": e.newsArticles.length,
      "all-cards-visible": e.newsArticles.length === 1,
      "total-cards": e.newsArticles.length,
      "theme-styles": r.cardSliderStyles,
      "section-header": e.sectionHeader,
      "pager-orientation": "right",
      class: v({ "all-cards-visible": e.allCardsVisible }),
      style: j(r.n5PagerStyle),
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: _(() => [
        c("div", {
          ref: "scrollWrapper",
          class: v(["scroll-wrapper", { "all-cards-visible": e.allCardsVisible }]),
          "data-testid": "blocks-array"
        }, [
          (d(), k(l, {
            ref: "`sliderCard-0",
            key: e.newsArticles[e.currentCard].id,
            item: e.newsArticles[e.currentCard],
            theme: e.theme,
            "show-snippet": !1,
            "show-title": !1,
            "show-published-time": !0,
            "is-preview": e.isPreview,
            "fallback-image": e.fallbackImage,
            "path-prefix": e.pathPrefix,
            "total-cards": e.newsArticles.length,
            "card-number": e.currentCard,
            "aria-label": `${e.currentCard} of ${e.newsArticles.length}`,
            class: v([{ "is-editing": e.isEditing }, "article"]),
            "aria-roledescription": "slide",
            role: "group",
            variant: "N5-story",
            "data-testid": "news-story",
            style: j(r.responsiveSliderImage)
          }, null, 8, ["item", "theme", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number", "aria-label", "class", "style"])),
          c("h3", u3, [
            c("a", {
              href: e.link(`article/${e.newsArticles[e.currentCard].id}`)
            }, y(r.articleTitle), 9, d3)
          ]),
          c("a", {
            href: e.link(`article/${e.newsArticles[e.currentCard].id}`),
            class: "article-link"
          }, [
            c("p", null, y(e.translations.read_article), 1)
          ], 8, c3)
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "class", "style", "onScrollRight", "onScrollLeft", "onGoToSection"])),
    r.displaySeeAllBottom ? (d(), k(a, {
      key: 2,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[3] || (t[3] = (m) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : b("", !0)
  ], 6);
}
const m3 = /* @__PURE__ */ O(x6, [["render", h3], ["__scopeId", "data-v-c67050fe"]]), p3 = {
  name: "N6",
  components: { NewsStory: Oo, CardSlider: Jt },
  mixins: [eo, ut],
  data() {
    const e = this.articles.slice(0, 6);
    return {
      newsArticles: e,
      newsArticlesLength: e.length
    };
  },
  computed: {
    content() {
      return this.newsArticles;
    },
    themeStyles() {
      return he(ie({}, this.theme), {
        arrow_background_color: { hex: this.cssVars["--arrow-background-color"] },
        pager_color: { hex: this.cssVars["--pager-color"] },
        arrow_icon_color: { hex: this.cssVars["--arrow-icon-color"] }
      });
    }
  }
}, f3 = ["data-testid"], g3 = ["data-testid"], v3 = {
  ref: "scrollWrapper",
  class: "news-wrapper"
};
function b3(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("NewsStory"), l = $("CardSlider");
  return d(), h("div", {
    id: "news-n6",
    "data-testid": "news-v6",
    style: j(e.cssVars),
    class: v([e.theme.style, { "is-editing": e.isEditing }])
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, g3)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.sectionHeader), 1)
          ], !0)
        ], 8, f3)
      ]),
      default: _(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    L(l, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "total-cards": i.newsArticles.length,
      class: v({ "is-editing": e.isEditing }),
      "theme-styles": r.themeStyles,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: _(() => [
        c("div", v3, [
          (d(!0), h(Y, null, ee(i.newsArticles, (u, m) => (d(), k(s, {
            ref_for: !0,
            ref: `sliderCard-${m}`,
            key: u.id,
            item: u,
            theme: e.theme,
            class: v({ "is-editing": e.isEditing }),
            "is-preview": e.isPreview,
            "fallback-image": e.fallbackImage,
            "path-prefix": e.pathPrefix,
            "total-cards": i.newsArticles.length,
            "card-number": m + 1,
            "show-published-time": "",
            variant: "N6-story",
            "data-testid": "news-story"
          }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
        ], 512)
      ]),
      _: 1
    }, 8, ["current-card", "pager-section-count", "total-cards", "class", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : b("", !0)
  ], 6);
}
const y3 = /* @__PURE__ */ O(p3, [["render", b3], ["__scopeId", "data-v-5893c0e6"]]), _3 = {
  name: "N7",
  components: { NewsStory: Oo, CardSlider: Jt },
  mixins: [eo, ut],
  data() {
    return {
      newsArticles: this.articles.slice(0, 6)
    };
  },
  computed: {
    content() {
      return this.newsArticles;
    },
    themeStyles() {
      return he(ie({}, this.theme), {
        arrow_background_color: { hex: this.cssVars["--arrow-background-color"] },
        pager_color: { hex: this.cssVars["--pager-color"] },
        arrow_icon_color: { hex: this.cssVars["--arrow-icon-color"] }
      });
    }
  }
}, C3 = ["data-testid"], w3 = ["data-testid"], T3 = { class: "color-overlay" }, k3 = {
  ref: "scrollWrapper",
  class: "news-wrapper"
};
function E3(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("NewsStory"), l = $("CardSlider");
  return d(), h("div", {
    "data-testid": "news-v7",
    style: j(e.cssVars),
    class: v([e.theme.style, "news-n7"])
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, w3)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.sectionHeader), 1)
          ], !0)
        ], 8, C3)
      ]),
      default: _(() => [
        e.theme.style === "bold" && e.screenSize > 480 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", T3, [
      L(l, {
        "nav-orientation": "bottom",
        "pager-orientation": "right",
        "has-pager": !1,
        "current-card": e.currentCard,
        "total-cards": i.newsArticles.length,
        "section-header": e.sectionHeader,
        "theme-styles": r.themeStyles,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        default: _(() => [
          c("div", k3, [
            (d(!0), h(Y, null, ee(i.newsArticles, (u, m) => (d(), k(s, {
              ref_for: !0,
              ref: `sliderCard-${m}`,
              key: u.id,
              item: u,
              theme: e.theme,
              "is-preview": e.isPreview,
              "fallback-image": e.fallbackImage,
              "path-prefix": e.pathPrefix,
              "total-cards": e.articles.length,
              "card-number": m + 1,
              "show-published-time": "",
              variant: "N7-story",
              "data-testid": "news-story"
            }, null, 8, ["item", "theme", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
          ], 512)
        ]),
        _: 1
      }, 8, ["current-card", "total-cards", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"]),
      e.theme.style !== "bold" || e.screenSize < 960 ? (d(), k(a, {
        key: 0,
        class: v([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme
      }, {
        default: _(() => [
          (d(), k(K(e.isEditing ? "button" : "a"), {
            class: v(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-bottom`,
            onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
          }, {
            default: _(() => [
              A(y(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options"])) : b("", !0)
    ])
  ], 6);
}
const S3 = /* @__PURE__ */ O(_3, [["render", E3], ["__scopeId", "data-v-68a98c6a"]]);
var M3 = Object.prototype;
function A3(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || M3;
  return e === n;
}
var oa = A3;
function $3(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var W0 = $3, I3 = W0, D3 = I3(Object.keys, Object), L3 = D3, O3 = oa, N3 = L3, P3 = Object.prototype, H3 = P3.hasOwnProperty;
function F3(e) {
  if (!O3(e))
    return N3(e);
  var t = [];
  for (var n in Object(e))
    H3.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var q0 = F3, R3 = Lo, B3 = Qt, V3 = R3(B3, "DataView"), j3 = V3, U3 = Lo, G3 = Qt, z3 = U3(G3, "Promise"), K3 = z3, Z3 = Lo, x3 = Qt, W3 = Z3(x3, "Set"), q3 = W3, Y3 = Lo, X3 = Qt, Q3 = Y3(X3, "WeakMap"), J3 = Q3, Al = j3, $l = v1, Il = K3, Dl = q3, Ll = J3, Y0 = Mi, Tr = V0, rd = "[object Map]", e7 = "[object Object]", id = "[object Promise]", sd = "[object Set]", ad = "[object WeakMap]", ld = "[object DataView]", t7 = Tr(Al), n7 = Tr($l), o7 = Tr(Il), r7 = Tr(Dl), i7 = Tr(Ll), mo = Y0;
(Al && mo(new Al(new ArrayBuffer(1))) != ld || $l && mo(new $l()) != rd || Il && mo(Il.resolve()) != id || Dl && mo(new Dl()) != sd || Ll && mo(new Ll()) != ad) && (mo = function(e) {
  var t = Y0(e), n = t == e7 ? e.constructor : void 0, o = n ? Tr(n) : "";
  if (o)
    switch (o) {
      case t7:
        return ld;
      case n7:
        return rd;
      case o7:
        return id;
      case r7:
        return sd;
      case i7:
        return ad;
    }
  return t;
});
var ra = mo, s7 = Mi, a7 = yr, l7 = "[object Arguments]";
function u7(e) {
  return a7(e) && s7(e) == l7;
}
var d7 = u7, ud = d7, c7 = yr, X0 = Object.prototype, h7 = X0.hasOwnProperty, m7 = X0.propertyIsEnumerable, p7 = ud(/* @__PURE__ */ function() {
  return arguments;
}()) ? ud : function(e) {
  return c7(e) && h7.call(e, "callee") && !m7.call(e, "callee");
}, Q0 = p7, f7 = 9007199254740991;
function g7(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= f7;
}
var J0 = g7, v7 = B0, b7 = J0;
function y7(e) {
  return e != null && b7(e.length) && !v7(e);
}
var ia = y7, ks = { exports: {} };
function _7() {
  return !1;
}
var C7 = _7;
ks.exports;
(function(e, t) {
  var n = Qt, o = C7, i = t && !t.nodeType && t, r = i && !0 && e && !e.nodeType && e, a = r && r.exports === i, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || o;
  e.exports = u;
})(ks, ks.exports);
var _1 = ks.exports, w7 = Mi, T7 = J0, k7 = yr, E7 = "[object Arguments]", S7 = "[object Array]", M7 = "[object Boolean]", A7 = "[object Date]", $7 = "[object Error]", I7 = "[object Function]", D7 = "[object Map]", L7 = "[object Number]", O7 = "[object Object]", N7 = "[object RegExp]", P7 = "[object Set]", H7 = "[object String]", F7 = "[object WeakMap]", R7 = "[object ArrayBuffer]", B7 = "[object DataView]", V7 = "[object Float32Array]", j7 = "[object Float64Array]", U7 = "[object Int8Array]", G7 = "[object Int16Array]", z7 = "[object Int32Array]", K7 = "[object Uint8Array]", Z7 = "[object Uint8ClampedArray]", x7 = "[object Uint16Array]", W7 = "[object Uint32Array]", He = {};
He[V7] = He[j7] = He[U7] = He[G7] = He[z7] = He[K7] = He[Z7] = He[x7] = He[W7] = !0;
He[E7] = He[S7] = He[R7] = He[M7] = He[B7] = He[A7] = He[$7] = He[I7] = He[D7] = He[L7] = He[O7] = He[N7] = He[P7] = He[H7] = He[F7] = !1;
function q7(e) {
  return k7(e) && T7(e.length) && !!He[w7(e)];
}
var Y7 = q7;
function X7(e) {
  return function(t) {
    return e(t);
  };
}
var C1 = X7, Es = { exports: {} };
Es.exports;
(function(e, t) {
  var n = F0, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, r = i && i.exports === o, a = r && n.process, s = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || a && a.binding && a.binding("util");
    } catch (u) {
    }
  }();
  e.exports = s;
})(Es, Es.exports);
var w1 = Es.exports, Q7 = Y7, J7 = C1, dd = w1, cd = dd && dd.isTypedArray, ev = cd ? J7(cd) : Q7, e2 = ev, tv = q0, nv = ra, ov = Q0, rv = Do, iv = ia, sv = _1, av = oa, lv = e2, uv = "[object Map]", dv = "[object Set]", cv = Object.prototype, hv = cv.hasOwnProperty;
function mv(e) {
  if (e == null)
    return !0;
  if (iv(e) && (rv(e) || typeof e == "string" || typeof e.splice == "function" || sv(e) || lv(e) || ov(e)))
    return !e.length;
  var t = nv(e);
  if (t == uv || t == dv)
    return !e.size;
  if (av(e))
    return !tv(e).length;
  for (var n in e)
    if (hv.call(e, n))
      return !1;
  return !0;
}
var pv = mv;
const An = /* @__PURE__ */ br(pv), fv = {
  name: "News",
  components: {
    N1: t6,
    N2: a6,
    N3: h6,
    N4: v6,
    N5: m3,
    N6: y3,
    N7: S3
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    newsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    sidebarOffset: {
      type: Number,
      default: 0
    },
    fallbackImage: {
      type: Object,
      default: () => {
      }
    },
    isIFrame: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      fallbackImageDefault: {
        url: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png",
        alt: "news default image"
      }
    };
  },
  computed: {
    cssVars() {
      return {
        "--sidebar-offset": `${this.sidebarOffset}px`
      };
    },
    fallbackImg() {
      return An(this.fallbackImage) ? this.fallbackImageDefault : this.fallbackImage;
    }
  }
}, gv = { id: "view-news" };
function vv(e, t, n, o, i, r) {
  return d(), h("div", gv, [
    (d(), k(K(n.theme.version), {
      style: j(r.cssVars),
      theme: n.theme,
      articles: n.content,
      "news-config": n.newsConfig,
      "component-id": n.componentId,
      "is-preview": n.isPreview,
      "is-editing": n.isEditing,
      "is-i-frame": n.isIFrame,
      "fallback-image": r.fallbackImg,
      "path-prefix": n.pathPrefix,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": _(() => [
        w(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: _(() => [
        w(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["style", "theme", "articles", "news-config", "component-id", "is-preview", "is-editing", "is-i-frame", "fallback-image", "path-prefix"]))
  ]);
}
const bv = /* @__PURE__ */ O(fv, [["render", vv], ["__scopeId", "data-v-b303fa92"]]);
function wn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function t2(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Dt = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, cr = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, T1, nt, Be, Bt = 1e8, Ie = 1 / Bt, Ol = Math.PI * 2, yv = Ol / 4, _v = 0, n2 = Math.sqrt, Cv = Math.cos, wv = Math.sin, Je = function(t) {
  return typeof t == "string";
}, ze = function(t) {
  return typeof t == "function";
}, $n = function(t) {
  return typeof t == "number";
}, k1 = function(t) {
  return typeof t == "undefined";
}, mn = function(t) {
  return typeof t == "object";
}, bt = function(t) {
  return t !== !1;
}, E1 = function() {
  return typeof window != "undefined";
}, ji = function(t) {
  return ze(t) || Je(t);
}, o2 = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, st = Array.isArray, Nl = /(?:-?\.?\d|\.)+/gi, r2 = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, er = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, Ba = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, i2 = /[+-]=-?[.\d]+/, s2 = /[^,'"\[\]\s]+/gi, Tv = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, je, an, Pl, S1, Lt = {}, Ss = {}, a2, l2 = function(t) {
  return (Ss = hr(t, Lt)) && wt;
}, M1 = function(t, n) {
  return console.warn("Invalid property", t, "set to", n, "Missing plugin? gsap.registerPlugin()");
}, fi = function(t, n) {
  return !n && console.warn(t);
}, u2 = function(t, n) {
  return t && (Lt[t] = n) && Ss && (Ss[t] = n) || Lt;
}, gi = function() {
  return 0;
}, kv = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, ls = {
  suppressEvents: !0,
  kill: !1
}, Ev = {
  suppressEvents: !0
}, A1 = {}, Wn = [], Hl = {}, d2, At = {}, Va = {}, hd = 30, us = [], $1 = "", I1 = function(t) {
  var n = t[0], o, i;
  if (mn(n) || ze(n) || (t = [t]), !(o = (n._gsap || {}).harness)) {
    for (i = us.length; i-- && !us[i].targetTest(n); )
      ;
    o = us[i];
  }
  for (i = t.length; i--; )
    t[i] && (t[i]._gsap || (t[i]._gsap = new N2(t[i], o))) || t.splice(i, 1);
  return t;
}, To = function(t) {
  return t._gsap || I1(Vt(t))[0]._gsap;
}, c2 = function(t, n, o) {
  return (o = t[n]) && ze(o) ? t[n]() : k1(o) && t.getAttribute && t.getAttribute(n) || o;
}, yt = function(t, n) {
  return (t = t.split(",")).forEach(n) || t;
}, Ke = function(t) {
  return Math.round(t * 1e5) / 1e5 || 0;
}, We = function(t) {
  return Math.round(t * 1e7) / 1e7 || 0;
}, rr = function(t, n) {
  var o = n.charAt(0), i = parseFloat(n.substr(2));
  return t = parseFloat(t), o === "+" ? t + i : o === "-" ? t - i : o === "*" ? t * i : t / i;
}, Sv = function(t, n) {
  for (var o = n.length, i = 0; t.indexOf(n[i]) < 0 && ++i < o; )
    ;
  return i < o;
}, Ms = function() {
  var t = Wn.length, n = Wn.slice(0), o, i;
  for (Hl = {}, Wn.length = 0, o = 0; o < t; o++)
    i = n[o], i && i._lazy && (i.render(i._lazy[0], i._lazy[1], !0)._lazy = 0);
}, D1 = function(t) {
  return !!(t._initted || t._startAt || t.add);
}, h2 = function(t, n, o, i) {
  Wn.length && !nt && Ms(), t.render(n, o, !!(nt && n < 0 && D1(t))), Wn.length && !nt && Ms();
}, m2 = function(t) {
  var n = parseFloat(t);
  return (n || n === 0) && (t + "").match(s2).length < 2 ? n : Je(t) ? t.trim() : t;
}, p2 = function(t) {
  return t;
}, Ot = function(t, n) {
  for (var o in n)
    o in t || (t[o] = n[o]);
  return t;
}, Mv = function(t) {
  return function(n, o) {
    for (var i in o)
      i in n || i === "duration" && t || i === "ease" || (n[i] = o[i]);
  };
}, hr = function(t, n) {
  for (var o in n)
    t[o] = n[o];
  return t;
}, md = function e(t, n) {
  for (var o in n)
    o !== "__proto__" && o !== "constructor" && o !== "prototype" && (t[o] = mn(n[o]) ? e(t[o] || (t[o] = {}), n[o]) : n[o]);
  return t;
}, As = function(t, n) {
  var o = {}, i;
  for (i in t)
    i in n || (o[i] = t[i]);
  return o;
}, ri = function(t) {
  var n = t.parent || je, o = t.keyframes ? Mv(st(t.keyframes)) : Ot;
  if (bt(t.inherit))
    for (; n; )
      o(t, n.vars.defaults), n = n.parent || n._dp;
  return t;
}, Av = function(t, n) {
  for (var o = t.length, i = o === n.length; i && o-- && t[o] === n[o]; )
    ;
  return o < 0;
}, f2 = function(t, n, o, i, r) {
  var a = t[i], s;
  if (r)
    for (s = n[r]; a && a[r] > s; )
      a = a._prev;
  return a ? (n._next = a._next, a._next = n) : (n._next = t[o], t[o] = n), n._next ? n._next._prev = n : t[i] = n, n._prev = a, n.parent = n._dp = t, n;
}, sa = function(t, n, o, i) {
  o === void 0 && (o = "_first"), i === void 0 && (i = "_last");
  var r = n._prev, a = n._next;
  r ? r._next = a : t[o] === n && (t[o] = a), a ? a._prev = r : t[i] === n && (t[i] = r), n._next = n._prev = n.parent = null;
}, Xn = function(t, n) {
  t.parent && (!n || t.parent.autoRemoveChildren) && t.parent.remove && t.parent.remove(t), t._act = 0;
}, ko = function(t, n) {
  if (t && (!n || n._end > t._dur || n._start < 0))
    for (var o = t; o; )
      o._dirty = 1, o = o.parent;
  return t;
}, $v = function(t) {
  for (var n = t.parent; n && n.parent; )
    n._dirty = 1, n.totalDuration(), n = n.parent;
  return t;
}, Fl = function(t, n, o, i) {
  return t._startAt && (nt ? t._startAt.revert(ls) : t.vars.immediateRender && !t.vars.autoRevert || t._startAt.render(n, !0, i));
}, Iv = function e(t) {
  return !t || t._ts && e(t.parent);
}, pd = function(t) {
  return t._repeat ? mr(t._tTime, t = t.duration() + t._rDelay) * t : 0;
}, mr = function(t, n) {
  var o = Math.floor(t = We(t / n));
  return t && o === t ? o - 1 : o;
}, $s = function(t, n) {
  return (t - n._start) * n._ts + (n._ts >= 0 ? 0 : n._dirty ? n.totalDuration() : n._tDur);
}, aa = function(t) {
  return t._end = We(t._start + (t._tDur / Math.abs(t._ts || t._rts || Ie) || 0));
}, la = function(t, n) {
  var o = t._dp;
  return o && o.smoothChildTiming && t._ts && (t._start = We(o._time - (t._ts > 0 ? n / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - n) / -t._ts)), aa(t), o._dirty || ko(o, t)), t;
}, g2 = function(t, n) {
  var o;
  if ((n._time || !n._dur && n._initted || n._start < t._time && (n._dur || !n.add)) && (o = $s(t.rawTime(), n), (!n._dur || Ai(0, n.totalDuration(), o) - n._tTime > Ie) && n.render(o, !0)), ko(t, n)._dp && t._initted && t._time >= t._dur && t._ts) {
    if (t._dur < t.duration())
      for (o = t; o._dp; )
        o.rawTime() >= 0 && o.totalTime(o._tTime), o = o._dp;
    t._zTime = -Ie;
  }
}, un = function(t, n, o, i) {
  return n.parent && Xn(n), n._start = We(($n(o) ? o : o || t !== je ? Ft(t, o, n) : t._time) + n._delay), n._end = We(n._start + (n.totalDuration() / Math.abs(n.timeScale()) || 0)), f2(t, n, "_first", "_last", t._sort ? "_start" : 0), Rl(n) || (t._recent = n), i || g2(t, n), t._ts < 0 && la(t, t._tTime), t;
}, v2 = function(t, n) {
  return (Lt.ScrollTrigger || M1("scrollTrigger", n)) && Lt.ScrollTrigger.create(n, t);
}, b2 = function(t, n, o, i, r) {
  if (O1(t, n, r), !t._initted)
    return 1;
  if (!o && t._pt && !nt && (t._dur && t.vars.lazy !== !1 || !t._dur && t.vars.lazy) && d2 !== $t.frame)
    return Wn.push(t), t._lazy = [r, i], 1;
}, Dv = function e(t) {
  var n = t.parent;
  return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || e(n));
}, Rl = function(t) {
  var n = t.data;
  return n === "isFromStart" || n === "isStart";
}, Lv = function(t, n, o, i) {
  var r = t.ratio, a = n < 0 || !n && (!t._start && Dv(t) && !(!t._initted && Rl(t)) || (t._ts < 0 || t._dp._ts < 0) && !Rl(t)) ? 0 : 1, s = t._rDelay, l = 0, u, m, g;
  if (s && t._repeat && (l = Ai(0, t._tDur, n), m = mr(l, s), t._yoyo && m & 1 && (a = 1 - a), m !== mr(t._tTime, s) && (r = 1 - a, t.vars.repeatRefresh && t._initted && t.invalidate())), a !== r || nt || i || t._zTime === Ie || !n && t._zTime) {
    if (!t._initted && b2(t, n, i, o, l))
      return;
    for (g = t._zTime, t._zTime = n || (o ? Ie : 0), o || (o = n && !g), t.ratio = a, t._from && (a = 1 - a), t._time = 0, t._tTime = l, u = t._pt; u; )
      u.r(a, u.d), u = u._next;
    n < 0 && Fl(t, n, o, !0), t._onUpdate && !o && It(t, "onUpdate"), l && t._repeat && !o && t.parent && It(t, "onRepeat"), (n >= t._tDur || n < 0) && t.ratio === a && (a && Xn(t, 1), !o && !nt && (It(t, a ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
  } else t._zTime || (t._zTime = n);
}, Ov = function(t, n, o) {
  var i;
  if (o > n)
    for (i = t._first; i && i._start <= o; ) {
      if (i.data === "isPause" && i._start > n)
        return i;
      i = i._next;
    }
  else
    for (i = t._last; i && i._start >= o; ) {
      if (i.data === "isPause" && i._start < n)
        return i;
      i = i._prev;
    }
}, pr = function(t, n, o, i) {
  var r = t._repeat, a = We(n) || 0, s = t._tTime / t._tDur;
  return s && !i && (t._time *= a / t._dur), t._dur = a, t._tDur = r ? r < 0 ? 1e10 : We(a * (r + 1) + t._rDelay * r) : a, s > 0 && !i && la(t, t._tTime = t._tDur * s), t.parent && aa(t), o || ko(t.parent, t), t;
}, fd = function(t) {
  return t instanceof ct ? ko(t) : pr(t, t._dur);
}, Nv = {
  _start: 0,
  endTime: gi,
  totalDuration: gi
}, Ft = function e(t, n, o) {
  var i = t.labels, r = t._recent || Nv, a = t.duration() >= Bt ? r.endTime(!1) : t._dur, s, l, u;
  return Je(n) && (isNaN(n) || n in i) ? (l = n.charAt(0), u = n.substr(-1) === "%", s = n.indexOf("="), l === "<" || l === ">" ? (s >= 0 && (n = n.replace(/=/, "")), (l === "<" ? r._start : r.endTime(r._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) * (u ? (s < 0 ? r : o).totalDuration() / 100 : 1)) : s < 0 ? (n in i || (i[n] = a), i[n]) : (l = parseFloat(n.charAt(s - 1) + n.substr(s + 1)), u && o && (l = l / 100 * (st(o) ? o[0] : o).totalDuration()), s > 1 ? e(t, n.substr(0, s - 1), o) + l : a + l)) : n == null ? a : +n;
}, ii = function(t, n, o) {
  var i = $n(n[1]), r = (i ? 2 : 1) + (t < 2 ? 0 : 1), a = n[r], s, l;
  if (i && (a.duration = n[1]), a.parent = o, t) {
    for (s = a, l = o; l && !("immediateRender" in s); )
      s = l.vars.defaults || {}, l = bt(l.vars.inherit) && l.parent;
    a.immediateRender = bt(s.immediateRender), t < 2 ? a.runBackwards = 1 : a.startAt = n[r - 1];
  }
  return new xe(n[0], a, n[r + 1]);
}, to = function(t, n) {
  return t || t === 0 ? n(t) : n;
}, Ai = function(t, n, o) {
  return o < t ? t : o > n ? n : o;
}, rt = function(t, n) {
  return !Je(t) || !(n = Tv.exec(t)) ? "" : n[1];
}, Pv = function(t, n, o) {
  return to(o, function(i) {
    return Ai(t, n, i);
  });
}, Bl = [].slice, y2 = function(t, n) {
  return t && mn(t) && "length" in t && (!n && !t.length || t.length - 1 in t && mn(t[0])) && !t.nodeType && t !== an;
}, Hv = function(t, n, o) {
  return o === void 0 && (o = []), t.forEach(function(i) {
    var r;
    return Je(i) && !n || y2(i, 1) ? (r = o).push.apply(r, Vt(i)) : o.push(i);
  }) || o;
}, Vt = function(t, n, o) {
  return Be && !n && Be.selector ? Be.selector(t) : Je(t) && !o && (Pl || !fr()) ? Bl.call((n || S1).querySelectorAll(t), 0) : st(t) ? Hv(t, o) : y2(t) ? Bl.call(t, 0) : t ? [t] : [];
}, Vl = function(t) {
  return t = Vt(t)[0] || fi("Invalid scope") || {}, function(n) {
    var o = t.current || t.nativeElement || t;
    return Vt(n, o.querySelectorAll ? o : o === t ? fi("Invalid scope") || S1.createElement("div") : t);
  };
}, _2 = function(t) {
  return t.sort(function() {
    return 0.5 - Math.random();
  });
}, C2 = function(t) {
  if (ze(t))
    return t;
  var n = mn(t) ? t : {
    each: t
  }, o = Eo(n.ease), i = n.from || 0, r = parseFloat(n.base) || 0, a = {}, s = i > 0 && i < 1, l = isNaN(i) || s, u = n.axis, m = i, g = i;
  return Je(i) ? m = g = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[i] || 0 : !s && l && (m = i[0], g = i[1]), function(p, T, M) {
    var C = (M || n).length, E = a[C], P, F, D, H, B, U, x, Z, q;
    if (!E) {
      if (q = n.grid === "auto" ? 0 : (n.grid || [1, Bt])[1], !q) {
        for (x = -Bt; x < (x = M[q++].getBoundingClientRect().left) && q < C; )
          ;
        q < C && q--;
      }
      for (E = a[C] = [], P = l ? Math.min(q, C) * m - 0.5 : i % q, F = q === Bt ? 0 : l ? C * g / q - 0.5 : i / q | 0, x = 0, Z = Bt, U = 0; U < C; U++)
        D = U % q - P, H = F - (U / q | 0), E[U] = B = u ? Math.abs(u === "y" ? H : D) : n2(D * D + H * H), B > x && (x = B), B < Z && (Z = B);
      i === "random" && _2(E), E.max = x - Z, E.min = Z, E.v = C = (parseFloat(n.amount) || parseFloat(n.each) * (q > C ? C - 1 : u ? u === "y" ? C / q : q : Math.max(q, C / q)) || 0) * (i === "edges" ? -1 : 1), E.b = C < 0 ? r - C : r, E.u = rt(n.amount || n.each) || 0, o = o && C < 0 ? D2(o) : o;
    }
    return C = (E[p] - E.min) / E.max || 0, We(E.b + (o ? o(C) : C) * E.v) + E.u;
  };
}, jl = function(t) {
  var n = Math.pow(10, ((t + "").split(".")[1] || "").length);
  return function(o) {
    var i = We(Math.round(parseFloat(o) / t) * t * n);
    return (i - i % 1) / n + ($n(o) ? 0 : rt(o));
  };
}, w2 = function(t, n) {
  var o = st(t), i, r;
  return !o && mn(t) && (i = o = t.radius || Bt, t.values ? (t = Vt(t.values), (r = !$n(t[0])) && (i *= i)) : t = jl(t.increment)), to(n, o ? ze(t) ? function(a) {
    return r = t(a), Math.abs(r - a) <= i ? r : a;
  } : function(a) {
    for (var s = parseFloat(r ? a.x : a), l = parseFloat(r ? a.y : 0), u = Bt, m = 0, g = t.length, p, T; g--; )
      r ? (p = t[g].x - s, T = t[g].y - l, p = p * p + T * T) : p = Math.abs(t[g] - s), p < u && (u = p, m = g);
    return m = !i || u <= i ? t[m] : a, r || m === a || $n(a) ? m : m + rt(a);
  } : jl(t));
}, T2 = function(t, n, o, i) {
  return to(st(t) ? !n : o === !0 ? !!(o = 0) : !i, function() {
    return st(t) ? t[~~(Math.random() * t.length)] : (o = o || 1e-5) && (i = o < 1 ? Math.pow(10, (o + "").length - 2) : 1) && Math.floor(Math.round((t - o / 2 + Math.random() * (n - t + o * 0.99)) / o) * o * i) / i;
  });
}, Fv = function() {
  for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
    n[o] = arguments[o];
  return function(i) {
    return n.reduce(function(r, a) {
      return a(r);
    }, i);
  };
}, Rv = function(t, n) {
  return function(o) {
    return t(parseFloat(o)) + (n || rt(o));
  };
}, Bv = function(t, n, o) {
  return E2(t, n, 0, 1, o);
}, k2 = function(t, n, o) {
  return to(o, function(i) {
    return t[~~n(i)];
  });
}, Vv = function e(t, n, o) {
  var i = n - t;
  return st(t) ? k2(t, e(0, t.length), n) : to(o, function(r) {
    return (i + (r - t) % i) % i + t;
  });
}, jv = function e(t, n, o) {
  var i = n - t, r = i * 2;
  return st(t) ? k2(t, e(0, t.length - 1), n) : to(o, function(a) {
    return a = (r + (a - t) % r) % r || 0, t + (a > i ? r - a : a);
  });
}, vi = function(t) {
  for (var n = 0, o = "", i, r, a, s; ~(i = t.indexOf("random(", n)); )
    a = t.indexOf(")", i), s = t.charAt(i + 7) === "[", r = t.substr(i + 7, a - i - 7).match(s ? s2 : Nl), o += t.substr(n, i - n) + T2(s ? r : +r[0], s ? 0 : +r[1], +r[2] || 1e-5), n = a + 1;
  return o + t.substr(n, t.length - n);
}, E2 = function(t, n, o, i, r) {
  var a = n - t, s = i - o;
  return to(r, function(l) {
    return o + ((l - t) / a * s || 0);
  });
}, Uv = function e(t, n, o, i) {
  var r = isNaN(t + n) ? 0 : function(T) {
    return (1 - T) * t + T * n;
  };
  if (!r) {
    var a = Je(t), s = {}, l, u, m, g, p;
    if (o === !0 && (i = 1) && (o = null), a)
      t = {
        p: t
      }, n = {
        p: n
      };
    else if (st(t) && !st(n)) {
      for (m = [], g = t.length, p = g - 2, u = 1; u < g; u++)
        m.push(e(t[u - 1], t[u]));
      g--, r = function(M) {
        M *= g;
        var C = Math.min(p, ~~M);
        return m[C](M - C);
      }, o = n;
    } else i || (t = hr(st(t) ? [] : {}, t));
    if (!m) {
      for (l in n)
        L1.call(s, t, l, "get", n[l]);
      r = function(M) {
        return H1(M, s) || (a ? t.p : t);
      };
    }
  }
  return to(o, r);
}, gd = function(t, n, o) {
  var i = t.labels, r = Bt, a, s, l;
  for (a in i)
    s = i[a] - n, s < 0 == !!o && s && r > (s = Math.abs(s)) && (l = a, r = s);
  return l;
}, It = function(t, n, o) {
  var i = t.vars, r = i[n], a = Be, s = t._ctx, l, u, m;
  if (r)
    return l = i[n + "Params"], u = i.callbackScope || t, o && Wn.length && Ms(), s && (Be = s), m = l ? r.apply(u, l) : r.call(u), Be = a, m;
}, ti = function(t) {
  return Xn(t), t.scrollTrigger && t.scrollTrigger.kill(!!nt), t.progress() < 1 && It(t, "onInterrupt"), t;
}, tr, S2 = [], M2 = function(t) {
  if (t)
    if (t = !t.name && t.default || t, E1() || t.headless) {
      var n = t.name, o = ze(t), i = n && !o && t.init ? function() {
        this._props = [];
      } : t, r = {
        init: gi,
        render: H1,
        add: L1,
        kill: rb,
        modifier: ob,
        rawVars: 0
      }, a = {
        targetTest: 0,
        get: 0,
        getSetter: P1,
        aliases: {},
        register: 0
      };
      if (fr(), t !== i) {
        if (At[n])
          return;
        Ot(i, Ot(As(t, r), a)), hr(i.prototype, hr(r, As(t, a))), At[i.prop = n] = i, t.targetTest && (us.push(i), A1[n] = 1), n = (n === "css" ? "CSS" : n.charAt(0).toUpperCase() + n.substr(1)) + "Plugin";
      }
      u2(n, i), t.register && t.register(wt, i, _t);
    } else
      S2.push(t);
}, $e = 255, ni = {
  aqua: [0, $e, $e],
  lime: [0, $e, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, $e],
  navy: [0, 0, 128],
  white: [$e, $e, $e],
  olive: [128, 128, 0],
  yellow: [$e, $e, 0],
  orange: [$e, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [$e, 0, 0],
  pink: [$e, 192, 203],
  cyan: [0, $e, $e],
  transparent: [$e, $e, $e, 0]
}, ja = function(t, n, o) {
  return t += t < 0 ? 1 : t > 1 ? -1 : 0, (t * 6 < 1 ? n + (o - n) * t * 6 : t < 0.5 ? o : t * 3 < 2 ? n + (o - n) * (2 / 3 - t) * 6 : n) * $e + 0.5 | 0;
}, A2 = function(t, n, o) {
  var i = t ? $n(t) ? [t >> 16, t >> 8 & $e, t & $e] : 0 : ni.black, r, a, s, l, u, m, g, p, T, M;
  if (!i) {
    if (t.substr(-1) === "," && (t = t.substr(0, t.length - 1)), ni[t])
      i = ni[t];
    else if (t.charAt(0) === "#") {
      if (t.length < 6 && (r = t.charAt(1), a = t.charAt(2), s = t.charAt(3), t = "#" + r + r + a + a + s + s + (t.length === 5 ? t.charAt(4) + t.charAt(4) : "")), t.length === 9)
        return i = parseInt(t.substr(1, 6), 16), [i >> 16, i >> 8 & $e, i & $e, parseInt(t.substr(7), 16) / 255];
      t = parseInt(t.substr(1), 16), i = [t >> 16, t >> 8 & $e, t & $e];
    } else if (t.substr(0, 3) === "hsl") {
      if (i = M = t.match(Nl), !n)
        l = +i[0] % 360 / 360, u = +i[1] / 100, m = +i[2] / 100, a = m <= 0.5 ? m * (u + 1) : m + u - m * u, r = m * 2 - a, i.length > 3 && (i[3] *= 1), i[0] = ja(l + 1 / 3, r, a), i[1] = ja(l, r, a), i[2] = ja(l - 1 / 3, r, a);
      else if (~t.indexOf("="))
        return i = t.match(r2), o && i.length < 4 && (i[3] = 1), i;
    } else
      i = t.match(Nl) || ni.transparent;
    i = i.map(Number);
  }
  return n && !M && (r = i[0] / $e, a = i[1] / $e, s = i[2] / $e, g = Math.max(r, a, s), p = Math.min(r, a, s), m = (g + p) / 2, g === p ? l = u = 0 : (T = g - p, u = m > 0.5 ? T / (2 - g - p) : T / (g + p), l = g === r ? (a - s) / T + (a < s ? 6 : 0) : g === a ? (s - r) / T + 2 : (r - a) / T + 4, l *= 60), i[0] = ~~(l + 0.5), i[1] = ~~(u * 100 + 0.5), i[2] = ~~(m * 100 + 0.5)), o && i.length < 4 && (i[3] = 1), i;
}, $2 = function(t) {
  var n = [], o = [], i = -1;
  return t.split(qn).forEach(function(r) {
    var a = r.match(er) || [];
    n.push.apply(n, a), o.push(i += a.length + 1);
  }), n.c = o, n;
}, vd = function(t, n, o) {
  var i = "", r = (t + i).match(qn), a = n ? "hsla(" : "rgba(", s = 0, l, u, m, g;
  if (!r)
    return t;
  if (r = r.map(function(p) {
    return (p = A2(p, n, 1)) && a + (n ? p[0] + "," + p[1] + "%," + p[2] + "%," + p[3] : p.join(",")) + ")";
  }), o && (m = $2(t), l = o.c, l.join(i) !== m.c.join(i)))
    for (u = t.replace(qn, "1").split(er), g = u.length - 1; s < g; s++)
      i += u[s] + (~l.indexOf(s) ? r.shift() || a + "0,0,0,0)" : (m.length ? m : r.length ? r : o).shift());
  if (!u)
    for (u = t.split(qn), g = u.length - 1; s < g; s++)
      i += u[s] + r[s];
  return i + u[g];
}, qn = function() {
  var e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", t;
  for (t in ni)
    e += "|" + t + "\\b";
  return new RegExp(e + ")", "gi");
}(), Gv = /hsl[a]?\(/, I2 = function(t) {
  var n = t.join(" "), o;
  if (qn.lastIndex = 0, qn.test(n))
    return o = Gv.test(n), t[1] = vd(t[1], o), t[0] = vd(t[0], o, $2(t[1])), !0;
}, bi, $t = function() {
  var e = Date.now, t = 500, n = 33, o = e(), i = o, r = 1e3 / 240, a = r, s = [], l, u, m, g, p, T, M = function C(E) {
    var P = e() - i, F = E === !0, D, H, B, U;
    if ((P > t || P < 0) && (o += P - n), i += P, B = i - o, D = B - a, (D > 0 || F) && (U = ++g.frame, p = B - g.time * 1e3, g.time = B = B / 1e3, a += D + (D >= r ? 4 : r - D), H = 1), F || (l = u(C)), H)
      for (T = 0; T < s.length; T++)
        s[T](B, p, U, E);
  };
  return g = {
    time: 0,
    frame: 0,
    tick: function() {
      M(!0);
    },
    deltaRatio: function(E) {
      return p / (1e3 / (E || 60));
    },
    wake: function() {
      a2 && (!Pl && E1() && (an = Pl = window, S1 = an.document || {}, Lt.gsap = wt, (an.gsapVersions || (an.gsapVersions = [])).push(wt.version), l2(Ss || an.GreenSockGlobals || !an.gsap && an || {}), S2.forEach(M2)), m = typeof requestAnimationFrame != "undefined" && requestAnimationFrame, l && g.sleep(), u = m || function(E) {
        return setTimeout(E, a - g.time * 1e3 + 1 | 0);
      }, bi = 1, M(2));
    },
    sleep: function() {
      (m ? cancelAnimationFrame : clearTimeout)(l), bi = 0, u = gi;
    },
    lagSmoothing: function(E, P) {
      t = E || 1 / 0, n = Math.min(P || 33, t);
    },
    fps: function(E) {
      r = 1e3 / (E || 240), a = g.time * 1e3 + r;
    },
    add: function(E, P, F) {
      var D = P ? function(H, B, U, x) {
        E(H, B, U, x), g.remove(D);
      } : E;
      return g.remove(E), s[F ? "unshift" : "push"](D), fr(), D;
    },
    remove: function(E, P) {
      ~(P = s.indexOf(E)) && s.splice(P, 1) && T >= P && T--;
    },
    _listeners: s
  }, g;
}(), fr = function() {
  return !bi && $t.wake();
}, _e = {}, zv = /^[\d.\-M][\d.\-,\s]/, Kv = /["']/g, Zv = function(t) {
  for (var n = {}, o = t.substr(1, t.length - 3).split(":"), i = o[0], r = 1, a = o.length, s, l, u; r < a; r++)
    l = o[r], s = r !== a - 1 ? l.lastIndexOf(",") : l.length, u = l.substr(0, s), n[i] = isNaN(u) ? u.replace(Kv, "").trim() : +u, i = l.substr(s + 1).trim();
  return n;
}, xv = function(t) {
  var n = t.indexOf("(") + 1, o = t.indexOf(")"), i = t.indexOf("(", n);
  return t.substring(n, ~i && i < o ? t.indexOf(")", o + 1) : o);
}, Wv = function(t) {
  var n = (t + "").split("("), o = _e[n[0]];
  return o && n.length > 1 && o.config ? o.config.apply(null, ~t.indexOf("{") ? [Zv(n[1])] : xv(t).split(",").map(m2)) : _e._CE && zv.test(t) ? _e._CE("", t) : o;
}, D2 = function(t) {
  return function(n) {
    return 1 - t(1 - n);
  };
}, L2 = function e(t, n) {
  for (var o = t._first, i; o; )
    o instanceof ct ? e(o, n) : o.vars.yoyoEase && (!o._yoyo || !o._repeat) && o._yoyo !== n && (o.timeline ? e(o.timeline, n) : (i = o._ease, o._ease = o._yEase, o._yEase = i, o._yoyo = n)), o = o._next;
}, Eo = function(t, n) {
  return t && (ze(t) ? t : _e[t] || Wv(t)) || n;
}, No = function(t, n, o, i) {
  o === void 0 && (o = function(l) {
    return 1 - n(1 - l);
  }), i === void 0 && (i = function(l) {
    return l < 0.5 ? n(l * 2) / 2 : 1 - n((1 - l) * 2) / 2;
  });
  var r = {
    easeIn: n,
    easeOut: o,
    easeInOut: i
  }, a;
  return yt(t, function(s) {
    _e[s] = Lt[s] = r, _e[a = s.toLowerCase()] = o;
    for (var l in r)
      _e[a + (l === "easeIn" ? ".in" : l === "easeOut" ? ".out" : ".inOut")] = _e[s + "." + l] = r[l];
  }), r;
}, O2 = function(t) {
  return function(n) {
    return n < 0.5 ? (1 - t(1 - n * 2)) / 2 : 0.5 + t((n - 0.5) * 2) / 2;
  };
}, Ua = function e(t, n, o) {
  var i = n >= 1 ? n : 1, r = (o || (t ? 0.3 : 0.45)) / (n < 1 ? n : 1), a = r / Ol * (Math.asin(1 / i) || 0), s = function(m) {
    return m === 1 ? 1 : i * Math.pow(2, -10 * m) * wv((m - a) * r) + 1;
  }, l = t === "out" ? s : t === "in" ? function(u) {
    return 1 - s(1 - u);
  } : O2(s);
  return r = Ol / r, l.config = function(u, m) {
    return e(t, u, m);
  }, l;
}, Ga = function e(t, n) {
  n === void 0 && (n = 1.70158);
  var o = function(a) {
    return a ? --a * a * ((n + 1) * a + n) + 1 : 0;
  }, i = t === "out" ? o : t === "in" ? function(r) {
    return 1 - o(1 - r);
  } : O2(o);
  return i.config = function(r) {
    return e(t, r);
  }, i;
};
yt("Linear,Quad,Cubic,Quart,Quint,Strong", function(e, t) {
  var n = t < 5 ? t + 1 : t;
  No(e + ",Power" + (n - 1), t ? function(o) {
    return Math.pow(o, n);
  } : function(o) {
    return o;
  }, function(o) {
    return 1 - Math.pow(1 - o, n);
  }, function(o) {
    return o < 0.5 ? Math.pow(o * 2, n) / 2 : 1 - Math.pow((1 - o) * 2, n) / 2;
  });
});
_e.Linear.easeNone = _e.none = _e.Linear.easeIn;
No("Elastic", Ua("in"), Ua("out"), Ua());
(function(e, t) {
  var n = 1 / t, o = 2 * n, i = 2.5 * n, r = function(s) {
    return s < n ? e * s * s : s < o ? e * Math.pow(s - 1.5 / t, 2) + 0.75 : s < i ? e * (s -= 2.25 / t) * s + 0.9375 : e * Math.pow(s - 2.625 / t, 2) + 0.984375;
  };
  No("Bounce", function(a) {
    return 1 - r(1 - a);
  }, r);
})(7.5625, 2.75);
No("Expo", function(e) {
  return Math.pow(2, 10 * (e - 1)) * e + e * e * e * e * e * e * (1 - e);
});
No("Circ", function(e) {
  return -(n2(1 - e * e) - 1);
});
No("Sine", function(e) {
  return e === 1 ? 1 : -Cv(e * yv) + 1;
});
No("Back", Ga("in"), Ga("out"), Ga());
_e.SteppedEase = _e.steps = Lt.SteppedEase = {
  config: function(t, n) {
    t === void 0 && (t = 1);
    var o = 1 / t, i = t + (n ? 0 : 1), r = n ? 1 : 0, a = 1 - Ie;
    return function(s) {
      return ((i * Ai(0, a, s) | 0) + r) * o;
    };
  }
};
cr.ease = _e["quad.out"];
yt("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(e) {
  return $1 += e + "," + e + "Params,";
});
var N2 = function(t, n) {
  this.id = _v++, t._gsap = this, this.target = t, this.harness = n, this.get = n ? n.get : c2, this.set = n ? n.getSetter : P1;
}, yi = /* @__PURE__ */ function() {
  function e(n) {
    this.vars = n, this._delay = +n.delay || 0, (this._repeat = n.repeat === 1 / 0 ? -2 : n.repeat || 0) && (this._rDelay = n.repeatDelay || 0, this._yoyo = !!n.yoyo || !!n.yoyoEase), this._ts = 1, pr(this, +n.duration, 1, 1), this.data = n.data, Be && (this._ctx = Be, Be.data.push(this)), bi || $t.wake();
  }
  var t = e.prototype;
  return t.delay = function(o) {
    return o || o === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + o - this._delay), this._delay = o, this) : this._delay;
  }, t.duration = function(o) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? o + (o + this._rDelay) * this._repeat : o) : this.totalDuration() && this._dur;
  }, t.totalDuration = function(o) {
    return arguments.length ? (this._dirty = 0, pr(this, this._repeat < 0 ? o : (o - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, t.totalTime = function(o, i) {
    if (fr(), !arguments.length)
      return this._tTime;
    var r = this._dp;
    if (r && r.smoothChildTiming && this._ts) {
      for (la(this, o), !r._dp || r.parent || g2(r, this); r && r.parent; )
        r.parent._time !== r._start + (r._ts >= 0 ? r._tTime / r._ts : (r.totalDuration() - r._tTime) / -r._ts) && r.totalTime(r._tTime, !0), r = r.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && o < this._tDur || this._ts < 0 && o > 0 || !this._tDur && !o) && un(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== o || !this._dur && !i || this._initted && Math.abs(this._zTime) === Ie || !o && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = o), h2(this, o, i)), this;
  }, t.time = function(o, i) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), o + pd(this)) % (this._dur + this._rDelay) || (o ? this._dur : 0), i) : this._time;
  }, t.totalProgress = function(o, i) {
    return arguments.length ? this.totalTime(this.totalDuration() * o, i) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  }, t.progress = function(o, i) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - o : o) + pd(this), i) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, t.iteration = function(o, i) {
    var r = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (o - 1) * r, i) : this._repeat ? mr(this._tTime, r) + 1 : 1;
  }, t.timeScale = function(o, i) {
    if (!arguments.length)
      return this._rts === -Ie ? 0 : this._rts;
    if (this._rts === o)
      return this;
    var r = this.parent && this._ts ? $s(this.parent._time, this) : this._tTime;
    return this._rts = +o || 0, this._ts = this._ps || o === -Ie ? 0 : this._rts, this.totalTime(Ai(-Math.abs(this._delay), this.totalDuration(), r), i !== !1), aa(this), $v(this);
  }, t.paused = function(o) {
    return arguments.length ? (this._ps !== o && (this._ps = o, o ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (fr(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== Ie && (this._tTime -= Ie)))), this) : this._ps;
  }, t.startTime = function(o) {
    if (arguments.length) {
      this._start = o;
      var i = this.parent || this._dp;
      return i && (i._sort || !this.parent) && un(i, this, o - this._delay), this;
    }
    return this._start;
  }, t.endTime = function(o) {
    return this._start + (bt(o) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, t.rawTime = function(o) {
    var i = this.parent || this._dp;
    return i ? o && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? $s(i.rawTime(o), this) : this._tTime : this._tTime;
  }, t.revert = function(o) {
    o === void 0 && (o = Ev);
    var i = nt;
    return nt = o, D1(this) && (this.timeline && this.timeline.revert(o), this.totalTime(-0.01, o.suppressEvents)), this.data !== "nested" && o.kill !== !1 && this.kill(), nt = i, this;
  }, t.globalTime = function(o) {
    for (var i = this, r = arguments.length ? o : i.rawTime(); i; )
      r = i._start + r / (Math.abs(i._ts) || 1), i = i._dp;
    return !this.parent && this._sat ? this._sat.globalTime(o) : r;
  }, t.repeat = function(o) {
    return arguments.length ? (this._repeat = o === 1 / 0 ? -2 : o, fd(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, t.repeatDelay = function(o) {
    if (arguments.length) {
      var i = this._time;
      return this._rDelay = o, fd(this), i ? this.time(i) : this;
    }
    return this._rDelay;
  }, t.yoyo = function(o) {
    return arguments.length ? (this._yoyo = o, this) : this._yoyo;
  }, t.seek = function(o, i) {
    return this.totalTime(Ft(this, o), bt(i));
  }, t.restart = function(o, i) {
    return this.play().totalTime(o ? -this._delay : 0, bt(i)), this._dur || (this._zTime = -Ie), this;
  }, t.play = function(o, i) {
    return o != null && this.seek(o, i), this.reversed(!1).paused(!1);
  }, t.reverse = function(o, i) {
    return o != null && this.seek(o || this.totalDuration(), i), this.reversed(!0).paused(!1);
  }, t.pause = function(o, i) {
    return o != null && this.seek(o, i), this.paused(!0);
  }, t.resume = function() {
    return this.paused(!1);
  }, t.reversed = function(o) {
    return arguments.length ? (!!o !== this.reversed() && this.timeScale(-this._rts || (o ? -Ie : 0)), this) : this._rts < 0;
  }, t.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -Ie, this;
  }, t.isActive = function() {
    var o = this.parent || this._dp, i = this._start, r;
    return !!(!o || this._ts && this._initted && o.isActive() && (r = o.rawTime(!0)) >= i && r < this.endTime(!0) - Ie);
  }, t.eventCallback = function(o, i, r) {
    var a = this.vars;
    return arguments.length > 1 ? (i ? (a[o] = i, r && (a[o + "Params"] = r), o === "onUpdate" && (this._onUpdate = i)) : delete a[o], this) : a[o];
  }, t.then = function(o) {
    var i = this;
    return new Promise(function(r) {
      var a = ze(o) ? o : p2, s = function() {
        var u = i.then;
        i.then = null, ze(a) && (a = a(i)) && (a.then || a === i) && (i.then = u), r(a), i.then = u;
      };
      i._initted && i.totalProgress() === 1 && i._ts >= 0 || !i._tTime && i._ts < 0 ? s() : i._prom = s;
    });
  }, t.kill = function() {
    ti(this);
  }, e;
}();
Ot(yi.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -Ie,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var ct = /* @__PURE__ */ function(e) {
  t2(t, e);
  function t(o, i) {
    var r;
    return o === void 0 && (o = {}), r = e.call(this, o) || this, r.labels = {}, r.smoothChildTiming = !!o.smoothChildTiming, r.autoRemoveChildren = !!o.autoRemoveChildren, r._sort = bt(o.sortChildren), je && un(o.parent || je, wn(r), i), o.reversed && r.reverse(), o.paused && r.paused(!0), o.scrollTrigger && v2(wn(r), o.scrollTrigger), r;
  }
  var n = t.prototype;
  return n.to = function(i, r, a) {
    return ii(0, arguments, this), this;
  }, n.from = function(i, r, a) {
    return ii(1, arguments, this), this;
  }, n.fromTo = function(i, r, a, s) {
    return ii(2, arguments, this), this;
  }, n.set = function(i, r, a) {
    return r.duration = 0, r.parent = this, ri(r).repeatDelay || (r.repeat = 0), r.immediateRender = !!r.immediateRender, new xe(i, r, Ft(this, a), 1), this;
  }, n.call = function(i, r, a) {
    return un(this, xe.delayedCall(0, i, r), a);
  }, n.staggerTo = function(i, r, a, s, l, u, m) {
    return a.duration = r, a.stagger = a.stagger || s, a.onComplete = u, a.onCompleteParams = m, a.parent = this, new xe(i, a, Ft(this, l)), this;
  }, n.staggerFrom = function(i, r, a, s, l, u, m) {
    return a.runBackwards = 1, ri(a).immediateRender = bt(a.immediateRender), this.staggerTo(i, r, a, s, l, u, m);
  }, n.staggerFromTo = function(i, r, a, s, l, u, m, g) {
    return s.startAt = a, ri(s).immediateRender = bt(s.immediateRender), this.staggerTo(i, r, s, l, u, m, g);
  }, n.render = function(i, r, a) {
    var s = this._time, l = this._dirty ? this.totalDuration() : this._tDur, u = this._dur, m = i <= 0 ? 0 : We(i), g = this._zTime < 0 != i < 0 && (this._initted || !u), p, T, M, C, E, P, F, D, H, B, U, x;
    if (this !== je && m > l && i >= 0 && (m = l), m !== this._tTime || a || g) {
      if (s !== this._time && u && (m += this._time - s, i += this._time - s), p = m, H = this._start, D = this._ts, P = !D, g && (u || (s = this._zTime), (i || !r) && (this._zTime = i)), this._repeat) {
        if (U = this._yoyo, E = u + this._rDelay, this._repeat < -1 && i < 0)
          return this.totalTime(E * 100 + i, r, a);
        if (p = We(m % E), m === l ? (C = this._repeat, p = u) : (B = We(m / E), C = ~~B, C && C === B && (p = u, C--), p > u && (p = u)), B = mr(this._tTime, E), !s && this._tTime && B !== C && this._tTime - B * E - this._dur <= 0 && (B = C), U && C & 1 && (p = u - p, x = 1), C !== B && !this._lock) {
          var Z = U && B & 1, q = Z === (U && C & 1);
          if (C < B && (Z = !Z), s = Z ? 0 : m % u ? u : m, this._lock = 1, this.render(s || (x ? 0 : We(C * E)), r, !u)._lock = 0, this._tTime = m, !r && this.parent && It(this, "onRepeat"), this.vars.repeatRefresh && !x && (this.invalidate()._lock = 1), s && s !== this._time || P !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (u = this._dur, l = this._tDur, q && (this._lock = 2, s = Z ? u : -1e-4, this.render(s, !0), this.vars.repeatRefresh && !x && this.invalidate()), this._lock = 0, !this._ts && !P)
            return this;
          L2(this, x);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (F = Ov(this, We(s), We(p)), F && (m -= p - (p = F._start))), this._tTime = m, this._time = p, this._act = !D, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = i, s = 0), !s && m && !r && !B && (It(this, "onStart"), this._tTime !== m))
        return this;
      if (p >= s && i >= 0)
        for (T = this._first; T; ) {
          if (M = T._next, (T._act || p >= T._start) && T._ts && F !== T) {
            if (T.parent !== this)
              return this.render(i, r, a);
            if (T.render(T._ts > 0 ? (p - T._start) * T._ts : (T._dirty ? T.totalDuration() : T._tDur) + (p - T._start) * T._ts, r, a), p !== this._time || !this._ts && !P) {
              F = 0, M && (m += this._zTime = -Ie);
              break;
            }
          }
          T = M;
        }
      else {
        T = this._last;
        for (var ue = i < 0 ? i : p; T; ) {
          if (M = T._prev, (T._act || ue <= T._end) && T._ts && F !== T) {
            if (T.parent !== this)
              return this.render(i, r, a);
            if (T.render(T._ts > 0 ? (ue - T._start) * T._ts : (T._dirty ? T.totalDuration() : T._tDur) + (ue - T._start) * T._ts, r, a || nt && D1(T)), p !== this._time || !this._ts && !P) {
              F = 0, M && (m += this._zTime = ue ? -Ie : Ie);
              break;
            }
          }
          T = M;
        }
      }
      if (F && !r && (this.pause(), F.render(p >= s ? 0 : -Ie)._zTime = p >= s ? 1 : -1, this._ts))
        return this._start = H, aa(this), this.render(i, r, a);
      this._onUpdate && !r && It(this, "onUpdate", !0), (m === l && this._tTime >= this.totalDuration() || !m && s) && (H === this._start || Math.abs(D) !== Math.abs(this._ts)) && (this._lock || ((i || !u) && (m === l && this._ts > 0 || !m && this._ts < 0) && Xn(this, 1), !r && !(i < 0 && !s) && (m || s || !l) && (It(this, m === l && i >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(m < l && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, n.add = function(i, r) {
    var a = this;
    if ($n(r) || (r = Ft(this, r, i)), !(i instanceof yi)) {
      if (st(i))
        return i.forEach(function(s) {
          return a.add(s, r);
        }), this;
      if (Je(i))
        return this.addLabel(i, r);
      if (ze(i))
        i = xe.delayedCall(0, i);
      else
        return this;
    }
    return this !== i ? un(this, i, r) : this;
  }, n.getChildren = function(i, r, a, s) {
    i === void 0 && (i = !0), r === void 0 && (r = !0), a === void 0 && (a = !0), s === void 0 && (s = -Bt);
    for (var l = [], u = this._first; u; )
      u._start >= s && (u instanceof xe ? r && l.push(u) : (a && l.push(u), i && l.push.apply(l, u.getChildren(!0, r, a)))), u = u._next;
    return l;
  }, n.getById = function(i) {
    for (var r = this.getChildren(1, 1, 1), a = r.length; a--; )
      if (r[a].vars.id === i)
        return r[a];
  }, n.remove = function(i) {
    return Je(i) ? this.removeLabel(i) : ze(i) ? this.killTweensOf(i) : (i.parent === this && sa(this, i), i === this._recent && (this._recent = this._last), ko(this));
  }, n.totalTime = function(i, r) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = We($t.time - (this._ts > 0 ? i / this._ts : (this.totalDuration() - i) / -this._ts))), e.prototype.totalTime.call(this, i, r), this._forcing = 0, this) : this._tTime;
  }, n.addLabel = function(i, r) {
    return this.labels[i] = Ft(this, r), this;
  }, n.removeLabel = function(i) {
    return delete this.labels[i], this;
  }, n.addPause = function(i, r, a) {
    var s = xe.delayedCall(0, r || gi, a);
    return s.data = "isPause", this._hasPause = 1, un(this, s, Ft(this, i));
  }, n.removePause = function(i) {
    var r = this._first;
    for (i = Ft(this, i); r; )
      r._start === i && r.data === "isPause" && Xn(r), r = r._next;
  }, n.killTweensOf = function(i, r, a) {
    for (var s = this.getTweensOf(i, a), l = s.length; l--; )
      Kn !== s[l] && s[l].kill(i, r);
    return this;
  }, n.getTweensOf = function(i, r) {
    for (var a = [], s = Vt(i), l = this._first, u = $n(r), m; l; )
      l instanceof xe ? Sv(l._targets, s) && (u ? (!Kn || l._initted && l._ts) && l.globalTime(0) <= r && l.globalTime(l.totalDuration()) > r : !r || l.isActive()) && a.push(l) : (m = l.getTweensOf(s, r)).length && a.push.apply(a, m), l = l._next;
    return a;
  }, n.tweenTo = function(i, r) {
    r = r || {};
    var a = this, s = Ft(a, i), l = r, u = l.startAt, m = l.onStart, g = l.onStartParams, p = l.immediateRender, T, M = xe.to(a, Ot({
      ease: r.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: s,
      overwrite: "auto",
      duration: r.duration || Math.abs((s - (u && "time" in u ? u.time : a._time)) / a.timeScale()) || Ie,
      onStart: function() {
        if (a.pause(), !T) {
          var E = r.duration || Math.abs((s - (u && "time" in u ? u.time : a._time)) / a.timeScale());
          M._dur !== E && pr(M, E, 0, 1).render(M._time, !0, !0), T = 1;
        }
        m && m.apply(M, g || []);
      }
    }, r));
    return p ? M.render(0) : M;
  }, n.tweenFromTo = function(i, r, a) {
    return this.tweenTo(r, Ot({
      startAt: {
        time: Ft(this, i)
      }
    }, a));
  }, n.recent = function() {
    return this._recent;
  }, n.nextLabel = function(i) {
    return i === void 0 && (i = this._time), gd(this, Ft(this, i));
  }, n.previousLabel = function(i) {
    return i === void 0 && (i = this._time), gd(this, Ft(this, i), 1);
  }, n.currentLabel = function(i) {
    return arguments.length ? this.seek(i, !0) : this.previousLabel(this._time + Ie);
  }, n.shiftChildren = function(i, r, a) {
    a === void 0 && (a = 0);
    for (var s = this._first, l = this.labels, u; s; )
      s._start >= a && (s._start += i, s._end += i), s = s._next;
    if (r)
      for (u in l)
        l[u] >= a && (l[u] += i);
    return ko(this);
  }, n.invalidate = function(i) {
    var r = this._first;
    for (this._lock = 0; r; )
      r.invalidate(i), r = r._next;
    return e.prototype.invalidate.call(this, i);
  }, n.clear = function(i) {
    i === void 0 && (i = !0);
    for (var r = this._first, a; r; )
      a = r._next, this.remove(r), r = a;
    return this._dp && (this._time = this._tTime = this._pTime = 0), i && (this.labels = {}), ko(this);
  }, n.totalDuration = function(i) {
    var r = 0, a = this, s = a._last, l = Bt, u, m, g;
    if (arguments.length)
      return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -i : i));
    if (a._dirty) {
      for (g = a.parent; s; )
        u = s._prev, s._dirty && s.totalDuration(), m = s._start, m > l && a._sort && s._ts && !a._lock ? (a._lock = 1, un(a, s, m - s._delay, 1)._lock = 0) : l = m, m < 0 && s._ts && (r -= m, (!g && !a._dp || g && g.smoothChildTiming) && (a._start += m / a._ts, a._time -= m, a._tTime -= m), a.shiftChildren(-m, !1, -1 / 0), l = 0), s._end > r && s._ts && (r = s._end), s = u;
      pr(a, a === je && a._time > r ? a._time : r, 1, 1), a._dirty = 0;
    }
    return a._tDur;
  }, t.updateRoot = function(i) {
    if (je._ts && (h2(je, $s(i, je)), d2 = $t.frame), $t.frame >= hd) {
      hd += Dt.autoSleep || 120;
      var r = je._first;
      if ((!r || !r._ts) && Dt.autoSleep && $t._listeners.length < 2) {
        for (; r && !r._ts; )
          r = r._next;
        r || $t.sleep();
      }
    }
  }, t;
}(yi);
Ot(ct.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var qv = function(t, n, o, i, r, a, s) {
  var l = new _t(this._pt, t, n, 0, 1, V2, null, r), u = 0, m = 0, g, p, T, M, C, E, P, F;
  for (l.b = o, l.e = i, o += "", i += "", (P = ~i.indexOf("random(")) && (i = vi(i)), a && (F = [o, i], a(F, t, n), o = F[0], i = F[1]), p = o.match(Ba) || []; g = Ba.exec(i); )
    M = g[0], C = i.substring(u, g.index), T ? T = (T + 1) % 5 : C.substr(-5) === "rgba(" && (T = 1), M !== p[m++] && (E = parseFloat(p[m - 1]) || 0, l._pt = {
      _next: l._pt,
      p: C || m === 1 ? C : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: E,
      c: M.charAt(1) === "=" ? rr(E, M) - E : parseFloat(M) - E,
      m: T && T < 4 ? Math.round : 0
    }, u = Ba.lastIndex);
  return l.c = u < i.length ? i.substring(u, i.length) : "", l.fp = s, (i2.test(i) || P) && (l.e = 0), this._pt = l, l;
}, L1 = function(t, n, o, i, r, a, s, l, u, m) {
  ze(i) && (i = i(r || 0, t, a));
  var g = t[n], p = o !== "get" ? o : ze(g) ? u ? t[n.indexOf("set") || !ze(t["get" + n.substr(3)]) ? n : "get" + n.substr(3)](u) : t[n]() : g, T = ze(g) ? u ? eb : R2 : N1, M;
  if (Je(i) && (~i.indexOf("random(") && (i = vi(i)), i.charAt(1) === "=" && (M = rr(p, i) + (rt(p) || 0), (M || M === 0) && (i = M))), !m || p !== i || Ul)
    return !isNaN(p * i) && i !== "" ? (M = new _t(this._pt, t, n, +p || 0, i - (p || 0), typeof g == "boolean" ? nb : B2, 0, T), u && (M.fp = u), s && M.modifier(s, this, t), this._pt = M) : (!g && !(n in t) && M1(n, i), qv.call(this, t, n, p, i, T, l || Dt.stringFilter, u));
}, Yv = function(t, n, o, i, r) {
  if (ze(t) && (t = si(t, r, n, o, i)), !mn(t) || t.style && t.nodeType || st(t) || o2(t))
    return Je(t) ? si(t, r, n, o, i) : t;
  var a = {}, s;
  for (s in t)
    a[s] = si(t[s], r, n, o, i);
  return a;
}, P2 = function(t, n, o, i, r, a) {
  var s, l, u, m;
  if (At[t] && (s = new At[t]()).init(r, s.rawVars ? n[t] : Yv(n[t], i, r, a, o), o, i, a) !== !1 && (o._pt = l = new _t(o._pt, r, t, 0, 1, s.render, s, 0, s.priority), o !== tr))
    for (u = o._ptLookup[o._targets.indexOf(r)], m = s._props.length; m--; )
      u[s._props[m]] = l;
  return s;
}, Kn, Ul, O1 = function e(t, n, o) {
  var i = t.vars, r = i.ease, a = i.startAt, s = i.immediateRender, l = i.lazy, u = i.onUpdate, m = i.runBackwards, g = i.yoyoEase, p = i.keyframes, T = i.autoRevert, M = t._dur, C = t._startAt, E = t._targets, P = t.parent, F = P && P.data === "nested" ? P.vars.targets : E, D = t._overwrite === "auto" && !T1, H = t.timeline, B, U, x, Z, q, ue, me, W, N, G, X, J, re;
  if (H && (!p || !r) && (r = "none"), t._ease = Eo(r, cr.ease), t._yEase = g ? D2(Eo(g === !0 ? r : g, cr.ease)) : 0, g && t._yoyo && !t._repeat && (g = t._yEase, t._yEase = t._ease, t._ease = g), t._from = !H && !!i.runBackwards, !H || p && !i.stagger) {
    if (W = E[0] ? To(E[0]).harness : 0, J = W && i[W.prop], B = As(i, A1), C && (C._zTime < 0 && C.progress(1), n < 0 && m && s && !T ? C.render(-1, !0) : C.revert(m && M ? ls : kv), C._lazy = 0), a) {
      if (Xn(t._startAt = xe.set(E, Ot({
        data: "isStart",
        overwrite: !1,
        parent: P,
        immediateRender: !0,
        lazy: !C && bt(l),
        startAt: null,
        delay: 0,
        onUpdate: u && function() {
          return It(t, "onUpdate");
        },
        stagger: 0
      }, a))), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (nt || !s && !T) && t._startAt.revert(ls), s && M && n <= 0 && o <= 0) {
        n && (t._zTime = n);
        return;
      }
    } else if (m && M && !C) {
      if (n && (s = !1), x = Ot({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: s && !C && bt(l),
        immediateRender: s,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: P
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, B), J && (x[W.prop] = J), Xn(t._startAt = xe.set(E, x)), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (nt ? t._startAt.revert(ls) : t._startAt.render(-1, !0)), t._zTime = n, !s)
        e(t._startAt, Ie, Ie);
      else if (!n)
        return;
    }
    for (t._pt = t._ptCache = 0, l = M && bt(l) || l && !M, U = 0; U < E.length; U++) {
      if (q = E[U], me = q._gsap || I1(E)[U]._gsap, t._ptLookup[U] = G = {}, Hl[me.id] && Wn.length && Ms(), X = F === E ? U : F.indexOf(q), W && (N = new W()).init(q, J || B, t, X, F) !== !1 && (t._pt = Z = new _t(t._pt, q, N.name, 0, 1, N.render, N, 0, N.priority), N._props.forEach(function(se) {
        G[se] = Z;
      }), N.priority && (ue = 1)), !W || J)
        for (x in B)
          At[x] && (N = P2(x, B, t, X, q, F)) ? N.priority && (ue = 1) : G[x] = Z = L1.call(t, q, x, "get", B[x], X, F, 0, i.stringFilter);
      t._op && t._op[U] && t.kill(q, t._op[U]), D && t._pt && (Kn = t, je.killTweensOf(q, G, t.globalTime(n)), re = !t.parent, Kn = 0), t._pt && l && (Hl[me.id] = 1);
    }
    ue && j2(t), t._onInit && t._onInit(t);
  }
  t._onUpdate = u, t._initted = (!t._op || t._pt) && !re, p && n <= 0 && H.render(Bt, !0, !0);
}, Xv = function(t, n, o, i, r, a, s, l) {
  var u = (t._pt && t._ptCache || (t._ptCache = {}))[n], m, g, p, T;
  if (!u)
    for (u = t._ptCache[n] = [], p = t._ptLookup, T = t._targets.length; T--; ) {
      if (m = p[T][n], m && m.d && m.d._pt)
        for (m = m.d._pt; m && m.p !== n && m.fp !== n; )
          m = m._next;
      if (!m)
        return Ul = 1, t.vars[n] = "+=0", O1(t, s), Ul = 0, l ? fi(n + " not eligible for reset") : 1;
      u.push(m);
    }
  for (T = u.length; T--; )
    g = u[T], m = g._pt || g, m.s = (i || i === 0) && !r ? i : m.s + (i || 0) + a * m.c, m.c = o - m.s, g.e && (g.e = Ke(o) + rt(g.e)), g.b && (g.b = m.s + rt(g.b));
}, Qv = function(t, n) {
  var o = t[0] ? To(t[0]).harness : 0, i = o && o.aliases, r, a, s, l;
  if (!i)
    return n;
  r = hr({}, n);
  for (a in i)
    if (a in r)
      for (l = i[a].split(","), s = l.length; s--; )
        r[l[s]] = r[a];
  return r;
}, Jv = function(t, n, o, i) {
  var r = n.ease || i || "power1.inOut", a, s;
  if (st(n))
    s = o[t] || (o[t] = []), n.forEach(function(l, u) {
      return s.push({
        t: u / (n.length - 1) * 100,
        v: l,
        e: r
      });
    });
  else
    for (a in n)
      s = o[a] || (o[a] = []), a === "ease" || s.push({
        t: parseFloat(t),
        v: n[a],
        e: r
      });
}, si = function(t, n, o, i, r) {
  return ze(t) ? t.call(n, o, i, r) : Je(t) && ~t.indexOf("random(") ? vi(t) : t;
}, H2 = $1 + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", F2 = {};
yt(H2 + ",id,stagger,delay,duration,paused,scrollTrigger", function(e) {
  return F2[e] = 1;
});
var xe = /* @__PURE__ */ function(e) {
  t2(t, e);
  function t(o, i, r, a) {
    var s;
    typeof i == "number" && (r.duration = i, i = r, r = null), s = e.call(this, a ? i : ri(i)) || this;
    var l = s.vars, u = l.duration, m = l.delay, g = l.immediateRender, p = l.stagger, T = l.overwrite, M = l.keyframes, C = l.defaults, E = l.scrollTrigger, P = l.yoyoEase, F = i.parent || je, D = (st(o) || o2(o) ? $n(o[0]) : "length" in i) ? [o] : Vt(o), H, B, U, x, Z, q, ue, me;
    if (s._targets = D.length ? I1(D) : fi("GSAP target " + o + " not found. https://gsap.com", !Dt.nullTargetWarn) || [], s._ptLookup = [], s._overwrite = T, M || p || ji(u) || ji(m)) {
      if (i = s.vars, H = s.timeline = new ct({
        data: "nested",
        defaults: C || {},
        targets: F && F.data === "nested" ? F.vars.targets : D
      }), H.kill(), H.parent = H._dp = wn(s), H._start = 0, p || ji(u) || ji(m)) {
        if (x = D.length, ue = p && C2(p), mn(p))
          for (Z in p)
            ~H2.indexOf(Z) && (me || (me = {}), me[Z] = p[Z]);
        for (B = 0; B < x; B++)
          U = As(i, F2), U.stagger = 0, P && (U.yoyoEase = P), me && hr(U, me), q = D[B], U.duration = +si(u, wn(s), B, q, D), U.delay = (+si(m, wn(s), B, q, D) || 0) - s._delay, !p && x === 1 && U.delay && (s._delay = m = U.delay, s._start += m, U.delay = 0), H.to(q, U, ue ? ue(B, q, D) : 0), H._ease = _e.none;
        H.duration() ? u = m = 0 : s.timeline = 0;
      } else if (M) {
        ri(Ot(H.vars.defaults, {
          ease: "none"
        })), H._ease = Eo(M.ease || i.ease || "none");
        var W = 0, N, G, X;
        if (st(M))
          M.forEach(function(J) {
            return H.to(D, J, ">");
          }), H.duration();
        else {
          U = {};
          for (Z in M)
            Z === "ease" || Z === "easeEach" || Jv(Z, M[Z], U, M.easeEach);
          for (Z in U)
            for (N = U[Z].sort(function(J, re) {
              return J.t - re.t;
            }), W = 0, B = 0; B < N.length; B++)
              G = N[B], X = {
                ease: G.e,
                duration: (G.t - (B ? N[B - 1].t : 0)) / 100 * u
              }, X[Z] = G.v, H.to(D, X, W), W += X.duration;
          H.duration() < u && H.to({}, {
            duration: u - H.duration()
          });
        }
      }
      u || s.duration(u = H.duration());
    } else
      s.timeline = 0;
    return T === !0 && !T1 && (Kn = wn(s), je.killTweensOf(D), Kn = 0), un(F, wn(s), r), i.reversed && s.reverse(), i.paused && s.paused(!0), (g || !u && !M && s._start === We(F._time) && bt(g) && Iv(wn(s)) && F.data !== "nested") && (s._tTime = -Ie, s.render(Math.max(0, -m) || 0)), E && v2(wn(s), E), s;
  }
  var n = t.prototype;
  return n.render = function(i, r, a) {
    var s = this._time, l = this._tDur, u = this._dur, m = i < 0, g = i > l - Ie && !m ? l : i < Ie ? 0 : i, p, T, M, C, E, P, F, D, H;
    if (!u)
      Lv(this, i, r, a);
    else if (g !== this._tTime || !i || a || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== m || this._lazy) {
      if (p = g, D = this.timeline, this._repeat) {
        if (C = u + this._rDelay, this._repeat < -1 && m)
          return this.totalTime(C * 100 + i, r, a);
        if (p = We(g % C), g === l ? (M = this._repeat, p = u) : (E = We(g / C), M = ~~E, M && M === E ? (p = u, M--) : p > u && (p = u)), P = this._yoyo && M & 1, P && (H = this._yEase, p = u - p), E = mr(this._tTime, C), p === s && !a && this._initted && M === E)
          return this._tTime = g, this;
        M !== E && (D && this._yEase && L2(D, P), this.vars.repeatRefresh && !P && !this._lock && p !== C && this._initted && (this._lock = a = 1, this.render(We(C * M), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (b2(this, m ? i : p, a, r, g))
          return this._tTime = 0, this;
        if (s !== this._time && !(a && this.vars.repeatRefresh && M !== E))
          return this;
        if (u !== this._dur)
          return this.render(i, r, a);
      }
      if (this._tTime = g, this._time = p, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = F = (H || this._ease)(p / u), this._from && (this.ratio = F = 1 - F), !s && g && !r && !E && (It(this, "onStart"), this._tTime !== g))
        return this;
      for (T = this._pt; T; )
        T.r(F, T.d), T = T._next;
      D && D.render(i < 0 ? i : D._dur * D._ease(p / this._dur), r, a) || this._startAt && (this._zTime = i), this._onUpdate && !r && (m && Fl(this, i, r, a), It(this, "onUpdate")), this._repeat && M !== E && this.vars.onRepeat && !r && this.parent && It(this, "onRepeat"), (g === this._tDur || !g) && this._tTime === g && (m && !this._onUpdate && Fl(this, i, !0, !0), (i || !u) && (g === this._tDur && this._ts > 0 || !g && this._ts < 0) && Xn(this, 1), !r && !(m && !s) && (g || s || P) && (It(this, g === l ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < l && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, n.targets = function() {
    return this._targets;
  }, n.invalidate = function(i) {
    return (!i || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(i), e.prototype.invalidate.call(this, i);
  }, n.resetTo = function(i, r, a, s, l) {
    bi || $t.wake(), this._ts || this.play();
    var u = Math.min(this._dur, (this._dp._time - this._start) * this._ts), m;
    return this._initted || O1(this, u), m = this._ease(u / this._dur), Xv(this, i, r, a, s, m, u, l) ? this.resetTo(i, r, a, s, 1) : (la(this, 0), this.parent || f2(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, n.kill = function(i, r) {
    if (r === void 0 && (r = "all"), !i && (!r || r === "all"))
      return this._lazy = this._pt = 0, this.parent ? ti(this) : this.scrollTrigger && this.scrollTrigger.kill(!!nt), this;
    if (this.timeline) {
      var a = this.timeline.totalDuration();
      return this.timeline.killTweensOf(i, r, Kn && Kn.vars.overwrite !== !0)._first || ti(this), this.parent && a !== this.timeline.totalDuration() && pr(this, this._dur * this.timeline._tDur / a, 0, 1), this;
    }
    var s = this._targets, l = i ? Vt(i) : s, u = this._ptLookup, m = this._pt, g, p, T, M, C, E, P;
    if ((!r || r === "all") && Av(s, l))
      return r === "all" && (this._pt = 0), ti(this);
    for (g = this._op = this._op || [], r !== "all" && (Je(r) && (C = {}, yt(r, function(F) {
      return C[F] = 1;
    }), r = C), r = Qv(s, r)), P = s.length; P--; )
      if (~l.indexOf(s[P])) {
        p = u[P], r === "all" ? (g[P] = r, M = p, T = {}) : (T = g[P] = g[P] || {}, M = r);
        for (C in M)
          E = p && p[C], E && ((!("kill" in E.d) || E.d.kill(C) === !0) && sa(this, E, "_pt"), delete p[C]), T !== "all" && (T[C] = 1);
      }
    return this._initted && !this._pt && m && ti(this), this;
  }, t.to = function(i, r) {
    return new t(i, r, arguments[2]);
  }, t.from = function(i, r) {
    return ii(1, arguments);
  }, t.delayedCall = function(i, r, a, s) {
    return new t(r, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: i,
      onComplete: r,
      onReverseComplete: r,
      onCompleteParams: a,
      onReverseCompleteParams: a,
      callbackScope: s
    });
  }, t.fromTo = function(i, r, a) {
    return ii(2, arguments);
  }, t.set = function(i, r) {
    return r.duration = 0, r.repeatDelay || (r.repeat = 0), new t(i, r);
  }, t.killTweensOf = function(i, r, a) {
    return je.killTweensOf(i, r, a);
  }, t;
}(yi);
Ot(xe.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
yt("staggerTo,staggerFrom,staggerFromTo", function(e) {
  xe[e] = function() {
    var t = new ct(), n = Bl.call(arguments, 0);
    return n.splice(e === "staggerFromTo" ? 5 : 4, 0, 0), t[e].apply(t, n);
  };
});
var N1 = function(t, n, o) {
  return t[n] = o;
}, R2 = function(t, n, o) {
  return t[n](o);
}, eb = function(t, n, o, i) {
  return t[n](i.fp, o);
}, tb = function(t, n, o) {
  return t.setAttribute(n, o);
}, P1 = function(t, n) {
  return ze(t[n]) ? R2 : k1(t[n]) && t.setAttribute ? tb : N1;
}, B2 = function(t, n) {
  return n.set(n.t, n.p, Math.round((n.s + n.c * t) * 1e6) / 1e6, n);
}, nb = function(t, n) {
  return n.set(n.t, n.p, !!(n.s + n.c * t), n);
}, V2 = function(t, n) {
  var o = n._pt, i = "";
  if (!t && n.b)
    i = n.b;
  else if (t === 1 && n.e)
    i = n.e;
  else {
    for (; o; )
      i = o.p + (o.m ? o.m(o.s + o.c * t) : Math.round((o.s + o.c * t) * 1e4) / 1e4) + i, o = o._next;
    i += n.c;
  }
  n.set(n.t, n.p, i, n);
}, H1 = function(t, n) {
  for (var o = n._pt; o; )
    o.r(t, o.d), o = o._next;
}, ob = function(t, n, o, i) {
  for (var r = this._pt, a; r; )
    a = r._next, r.p === i && r.modifier(t, n, o), r = a;
}, rb = function(t) {
  for (var n = this._pt, o, i; n; )
    i = n._next, n.p === t && !n.op || n.op === t ? sa(this, n, "_pt") : n.dep || (o = 1), n = i;
  return !o;
}, ib = function(t, n, o, i) {
  i.mSet(t, n, i.m.call(i.tween, o, i.mt), i);
}, j2 = function(t) {
  for (var n = t._pt, o, i, r, a; n; ) {
    for (o = n._next, i = r; i && i.pr > n.pr; )
      i = i._next;
    (n._prev = i ? i._prev : a) ? n._prev._next = n : r = n, (n._next = i) ? i._prev = n : a = n, n = o;
  }
  t._pt = r;
}, _t = /* @__PURE__ */ function() {
  function e(n, o, i, r, a, s, l, u, m) {
    this.t = o, this.s = r, this.c = a, this.p = i, this.r = s || B2, this.d = l || this, this.set = u || N1, this.pr = m || 0, this._next = n, n && (n._prev = this);
  }
  var t = e.prototype;
  return t.modifier = function(o, i, r) {
    this.mSet = this.mSet || this.set, this.set = ib, this.m = o, this.mt = r, this.tween = i;
  }, e;
}();
yt($1 + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(e) {
  return A1[e] = 1;
});
Lt.TweenMax = Lt.TweenLite = xe;
Lt.TimelineLite = Lt.TimelineMax = ct;
je = new ct({
  sortChildren: !1,
  defaults: cr,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
Dt.stringFilter = I2;
var So = [], ds = {}, sb = [], bd = 0, ab = 0, za = function(t) {
  return (ds[t] || sb).map(function(n) {
    return n();
  });
}, Gl = function() {
  var t = Date.now(), n = [];
  t - bd > 2 && (za("matchMediaInit"), So.forEach(function(o) {
    var i = o.queries, r = o.conditions, a, s, l, u;
    for (s in i)
      a = an.matchMedia(i[s]).matches, a && (l = 1), a !== r[s] && (r[s] = a, u = 1);
    u && (o.revert(), l && n.push(o));
  }), za("matchMediaRevert"), n.forEach(function(o) {
    return o.onMatch(o, function(i) {
      return o.add(null, i);
    });
  }), bd = t, za("matchMedia"));
}, U2 = /* @__PURE__ */ function() {
  function e(n, o) {
    this.selector = o && Vl(o), this.data = [], this._r = [], this.isReverted = !1, this.id = ab++, n && this.add(n);
  }
  var t = e.prototype;
  return t.add = function(o, i, r) {
    ze(o) && (r = i, i = o, o = ze);
    var a = this, s = function() {
      var u = Be, m = a.selector, g;
      return u && u !== a && u.data.push(a), r && (a.selector = Vl(r)), Be = a, g = i.apply(a, arguments), ze(g) && a._r.push(g), Be = u, a.selector = m, a.isReverted = !1, g;
    };
    return a.last = s, o === ze ? s(a, function(l) {
      return a.add(null, l);
    }) : o ? a[o] = s : s;
  }, t.ignore = function(o) {
    var i = Be;
    Be = null, o(this), Be = i;
  }, t.getTweens = function() {
    var o = [];
    return this.data.forEach(function(i) {
      return i instanceof e ? o.push.apply(o, i.getTweens()) : i instanceof xe && !(i.parent && i.parent.data === "nested") && o.push(i);
    }), o;
  }, t.clear = function() {
    this._r.length = this.data.length = 0;
  }, t.kill = function(o, i) {
    var r = this;
    if (o ? function() {
      for (var s = r.getTweens(), l = r.data.length, u; l--; )
        u = r.data[l], u.data === "isFlip" && (u.revert(), u.getChildren(!0, !0, !1).forEach(function(m) {
          return s.splice(s.indexOf(m), 1);
        }));
      for (s.map(function(m) {
        return {
          g: m._dur || m._delay || m._sat && !m._sat.vars.immediateRender ? m.globalTime(0) : -1 / 0,
          t: m
        };
      }).sort(function(m, g) {
        return g.g - m.g || -1 / 0;
      }).forEach(function(m) {
        return m.t.revert(o);
      }), l = r.data.length; l--; )
        u = r.data[l], u instanceof ct ? u.data !== "nested" && (u.scrollTrigger && u.scrollTrigger.revert(), u.kill()) : !(u instanceof xe) && u.revert && u.revert(o);
      r._r.forEach(function(m) {
        return m(o, r);
      }), r.isReverted = !0;
    }() : this.data.forEach(function(s) {
      return s.kill && s.kill();
    }), this.clear(), i)
      for (var a = So.length; a--; )
        So[a].id === this.id && So.splice(a, 1);
  }, t.revert = function(o) {
    this.kill(o || {});
  }, e;
}(), lb = /* @__PURE__ */ function() {
  function e(n) {
    this.contexts = [], this.scope = n, Be && Be.data.push(this);
  }
  var t = e.prototype;
  return t.add = function(o, i, r) {
    mn(o) || (o = {
      matches: o
    });
    var a = new U2(0, r || this.scope), s = a.conditions = {}, l, u, m;
    Be && !a.selector && (a.selector = Be.selector), this.contexts.push(a), i = a.add("onMatch", i), a.queries = o;
    for (u in o)
      u === "all" ? m = 1 : (l = an.matchMedia(o[u]), l && (So.indexOf(a) < 0 && So.push(a), (s[u] = l.matches) && (m = 1), l.addListener ? l.addListener(Gl) : l.addEventListener("change", Gl)));
    return m && i(a, function(g) {
      return a.add(null, g);
    }), this;
  }, t.revert = function(o) {
    this.kill(o || {});
  }, t.kill = function(o) {
    this.contexts.forEach(function(i) {
      return i.kill(o, !0);
    });
  }, e;
}(), Is = {
  registerPlugin: function() {
    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
      n[o] = arguments[o];
    n.forEach(function(i) {
      return M2(i);
    });
  },
  timeline: function(t) {
    return new ct(t);
  },
  getTweensOf: function(t, n) {
    return je.getTweensOf(t, n);
  },
  getProperty: function(t, n, o, i) {
    Je(t) && (t = Vt(t)[0]);
    var r = To(t || {}).get, a = o ? p2 : m2;
    return o === "native" && (o = ""), t && (n ? a((At[n] && At[n].get || r)(t, n, o, i)) : function(s, l, u) {
      return a((At[s] && At[s].get || r)(t, s, l, u));
    });
  },
  quickSetter: function(t, n, o) {
    if (t = Vt(t), t.length > 1) {
      var i = t.map(function(m) {
        return wt.quickSetter(m, n, o);
      }), r = i.length;
      return function(m) {
        for (var g = r; g--; )
          i[g](m);
      };
    }
    t = t[0] || {};
    var a = At[n], s = To(t), l = s.harness && (s.harness.aliases || {})[n] || n, u = a ? function(m) {
      var g = new a();
      tr._pt = 0, g.init(t, o ? m + o : m, tr, 0, [t]), g.render(1, g), tr._pt && H1(1, tr);
    } : s.set(t, l);
    return a ? u : function(m) {
      return u(t, l, o ? m + o : m, s, 1);
    };
  },
  quickTo: function(t, n, o) {
    var i, r = wt.to(t, Ot((i = {}, i[n] = "+=0.1", i.paused = !0, i.stagger = 0, i), o || {})), a = function(l, u, m) {
      return r.resetTo(n, l, u, m);
    };
    return a.tween = r, a;
  },
  isTweening: function(t) {
    return je.getTweensOf(t, !0).length > 0;
  },
  defaults: function(t) {
    return t && t.ease && (t.ease = Eo(t.ease, cr.ease)), md(cr, t || {});
  },
  config: function(t) {
    return md(Dt, t || {});
  },
  registerEffect: function(t) {
    var n = t.name, o = t.effect, i = t.plugins, r = t.defaults, a = t.extendTimeline;
    (i || "").split(",").forEach(function(s) {
      return s && !At[s] && !Lt[s] && fi(n + " effect requires " + s + " plugin.");
    }), Va[n] = function(s, l, u) {
      return o(Vt(s), Ot(l || {}, r), u);
    }, a && (ct.prototype[n] = function(s, l, u) {
      return this.add(Va[n](s, mn(l) ? l : (u = l) && {}, this), u);
    });
  },
  registerEase: function(t, n) {
    _e[t] = Eo(n);
  },
  parseEase: function(t, n) {
    return arguments.length ? Eo(t, n) : _e;
  },
  getById: function(t) {
    return je.getById(t);
  },
  exportRoot: function(t, n) {
    t === void 0 && (t = {});
    var o = new ct(t), i, r;
    for (o.smoothChildTiming = bt(t.smoothChildTiming), je.remove(o), o._dp = 0, o._time = o._tTime = je._time, i = je._first; i; )
      r = i._next, (n || !(!i._dur && i instanceof xe && i.vars.onComplete === i._targets[0])) && un(o, i, i._start - i._delay), i = r;
    return un(je, o, 0), o;
  },
  context: function(t, n) {
    return t ? new U2(t, n) : Be;
  },
  matchMedia: function(t) {
    return new lb(t);
  },
  matchMediaRefresh: function() {
    return So.forEach(function(t) {
      var n = t.conditions, o, i;
      for (i in n)
        n[i] && (n[i] = !1, o = 1);
      o && t.revert();
    }) || Gl();
  },
  addEventListener: function(t, n) {
    var o = ds[t] || (ds[t] = []);
    ~o.indexOf(n) || o.push(n);
  },
  removeEventListener: function(t, n) {
    var o = ds[t], i = o && o.indexOf(n);
    i >= 0 && o.splice(i, 1);
  },
  utils: {
    wrap: Vv,
    wrapYoyo: jv,
    distribute: C2,
    random: T2,
    snap: w2,
    normalize: Bv,
    getUnit: rt,
    clamp: Pv,
    splitColor: A2,
    toArray: Vt,
    selector: Vl,
    mapRange: E2,
    pipe: Fv,
    unitize: Rv,
    interpolate: Uv,
    shuffle: _2
  },
  install: l2,
  effects: Va,
  ticker: $t,
  updateRoot: ct.updateRoot,
  plugins: At,
  globalTimeline: je,
  core: {
    PropTween: _t,
    globals: u2,
    Tween: xe,
    Timeline: ct,
    Animation: yi,
    getCache: To,
    _removeLinkedListItem: sa,
    reverting: function() {
      return nt;
    },
    context: function(t) {
      return t && Be && (Be.data.push(t), t._ctx = Be), Be;
    },
    suppressOverwrites: function(t) {
      return T1 = t;
    }
  }
};
yt("to,from,fromTo,delayedCall,set,killTweensOf", function(e) {
  return Is[e] = xe[e];
});
$t.add(ct.updateRoot);
tr = Is.to({}, {
  duration: 0
});
var ub = function(t, n) {
  for (var o = t._pt; o && o.p !== n && o.op !== n && o.fp !== n; )
    o = o._next;
  return o;
}, db = function(t, n) {
  var o = t._targets, i, r, a;
  for (i in n)
    for (r = o.length; r--; )
      a = t._ptLookup[r][i], a && (a = a.d) && (a._pt && (a = ub(a, i)), a && a.modifier && a.modifier(n[i], t, o[r], i));
}, Ka = function(t, n) {
  return {
    name: t,
    headless: 1,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(i, r, a) {
      a._onInit = function(s) {
        var l, u;
        if (Je(r) && (l = {}, yt(r, function(m) {
          return l[m] = 1;
        }), r = l), n) {
          l = {};
          for (u in r)
            l[u] = n(r[u]);
          r = l;
        }
        db(s, r);
      };
    }
  };
}, wt = Is.registerPlugin({
  name: "attr",
  init: function(t, n, o, i, r) {
    var a, s, l;
    this.tween = o;
    for (a in n)
      l = t.getAttribute(a) || "", s = this.add(t, "setAttribute", (l || 0) + "", n[a], i, r, 0, 0, a), s.op = a, s.b = l, this._props.push(a);
  },
  render: function(t, n) {
    for (var o = n._pt; o; )
      nt ? o.set(o.t, o.p, o.b, o) : o.r(t, o.d), o = o._next;
  }
}, {
  name: "endArray",
  headless: 1,
  init: function(t, n) {
    for (var o = n.length; o--; )
      this.add(t, o, t[o] || 0, n[o], 0, 0, 0, 0, 0, 1);
  }
}, Ka("roundProps", jl), Ka("modifiers"), Ka("snap", w2)) || Is;
xe.version = ct.version = wt.version = "3.13.0";
a2 = 1;
E1() && fr();
_e.Power0;
_e.Power1;
_e.Power2;
_e.Power3;
_e.Power4;
_e.Linear;
_e.Quad;
_e.Cubic;
_e.Quart;
_e.Quint;
_e.Strong;
_e.Elastic;
_e.Back;
_e.SteppedEase;
_e.Bounce;
_e.Sine;
_e.Expo;
_e.Circ;
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var yd, Zn, ir, F1, _o, _d, R1, cb = function() {
  return typeof window != "undefined";
}, In = {}, po = 180 / Math.PI, sr = Math.PI / 180, zo = Math.atan2, Cd = 1e8, B1 = /([A-Z])/g, hb = /(left|right|width|margin|padding|x)/i, mb = /[\s,\(]\S/, cn = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, zl = function(t, n) {
  return n.set(n.t, n.p, Math.round((n.s + n.c * t) * 1e4) / 1e4 + n.u, n);
}, pb = function(t, n) {
  return n.set(n.t, n.p, t === 1 ? n.e : Math.round((n.s + n.c * t) * 1e4) / 1e4 + n.u, n);
}, fb = function(t, n) {
  return n.set(n.t, n.p, t ? Math.round((n.s + n.c * t) * 1e4) / 1e4 + n.u : n.b, n);
}, gb = function(t, n) {
  var o = n.s + n.c * t;
  n.set(n.t, n.p, ~~(o + (o < 0 ? -0.5 : 0.5)) + n.u, n);
}, G2 = function(t, n) {
  return n.set(n.t, n.p, t ? n.e : n.b, n);
}, z2 = function(t, n) {
  return n.set(n.t, n.p, t !== 1 ? n.b : n.e, n);
}, vb = function(t, n, o) {
  return t.style[n] = o;
}, bb = function(t, n, o) {
  return t.style.setProperty(n, o);
}, yb = function(t, n, o) {
  return t._gsap[n] = o;
}, _b = function(t, n, o) {
  return t._gsap.scaleX = t._gsap.scaleY = o;
}, Cb = function(t, n, o, i, r) {
  var a = t._gsap;
  a.scaleX = a.scaleY = o, a.renderTransform(r, a);
}, wb = function(t, n, o, i, r) {
  var a = t._gsap;
  a[n] = o, a.renderTransform(r, a);
}, Ue = "transform", Ct = Ue + "Origin", Tb = function e(t, n) {
  var o = this, i = this.target, r = i.style, a = i._gsap;
  if (t in In && r) {
    if (this.tfm = this.tfm || {}, t !== "transform")
      t = cn[t] || t, ~t.indexOf(",") ? t.split(",").forEach(function(s) {
        return o.tfm[s] = kn(i, s);
      }) : this.tfm[t] = a.x ? a[t] : kn(i, t), t === Ct && (this.tfm.zOrigin = a.zOrigin);
    else
      return cn.transform.split(",").forEach(function(s) {
        return e.call(o, s, n);
      });
    if (this.props.indexOf(Ue) >= 0)
      return;
    a.svg && (this.svgo = i.getAttribute("data-svg-origin"), this.props.push(Ct, n, "")), t = Ue;
  }
  (r || n) && this.props.push(t, n, r[t]);
}, K2 = function(t) {
  t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
}, kb = function() {
  var t = this.props, n = this.target, o = n.style, i = n._gsap, r, a;
  for (r = 0; r < t.length; r += 3)
    t[r + 1] ? t[r + 1] === 2 ? n[t[r]](t[r + 2]) : n[t[r]] = t[r + 2] : t[r + 2] ? o[t[r]] = t[r + 2] : o.removeProperty(t[r].substr(0, 2) === "--" ? t[r] : t[r].replace(B1, "-$1").toLowerCase());
  if (this.tfm) {
    for (a in this.tfm)
      i[a] = this.tfm[a];
    i.svg && (i.renderTransform(), n.setAttribute("data-svg-origin", this.svgo || "")), r = R1(), (!r || !r.isStart) && !o[Ue] && (K2(o), i.zOrigin && o[Ct] && (o[Ct] += " " + i.zOrigin + "px", i.zOrigin = 0, i.renderTransform()), i.uncache = 1);
  }
}, Z2 = function(t, n) {
  var o = {
    target: t,
    props: [],
    revert: kb,
    save: Tb
  };
  return t._gsap || wt.core.getCache(t), n && t.style && t.nodeType && n.split(",").forEach(function(i) {
    return o.save(i);
  }), o;
}, x2, Kl = function(t, n) {
  var o = Zn.createElementNS ? Zn.createElementNS((n || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : Zn.createElement(t);
  return o && o.style ? o : Zn.createElement(t);
}, jt = function e(t, n, o) {
  var i = getComputedStyle(t);
  return i[n] || i.getPropertyValue(n.replace(B1, "-$1").toLowerCase()) || i.getPropertyValue(n) || !o && e(t, gr(n) || n, 1) || "";
}, wd = "O,Moz,ms,Ms,Webkit".split(","), gr = function(t, n, o) {
  var i = n || _o, r = i.style, a = 5;
  if (t in r && !o)
    return t;
  for (t = t.charAt(0).toUpperCase() + t.substr(1); a-- && !(wd[a] + t in r); )
    ;
  return a < 0 ? null : (a === 3 ? "ms" : a >= 0 ? wd[a] : "") + t;
}, Zl = function() {
  cb() && window.document && (yd = window, Zn = yd.document, ir = Zn.documentElement, _o = Kl("div") || {
    style: {}
  }, Kl("div"), Ue = gr(Ue), Ct = Ue + "Origin", _o.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", x2 = !!gr("perspective"), R1 = wt.core.reverting, F1 = 1);
}, Td = function(t) {
  var n = t.ownerSVGElement, o = Kl("svg", n && n.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), i = t.cloneNode(!0), r;
  i.style.display = "block", o.appendChild(i), ir.appendChild(o);
  try {
    r = i.getBBox();
  } catch (a) {
  }
  return o.removeChild(i), ir.removeChild(o), r;
}, kd = function(t, n) {
  for (var o = n.length; o--; )
    if (t.hasAttribute(n[o]))
      return t.getAttribute(n[o]);
}, W2 = function(t) {
  var n, o;
  try {
    n = t.getBBox();
  } catch (i) {
    n = Td(t), o = 1;
  }
  return n && (n.width || n.height) || o || (n = Td(t)), n && !n.width && !n.x && !n.y ? {
    x: +kd(t, ["x", "cx", "x1"]) || 0,
    y: +kd(t, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : n;
}, q2 = function(t) {
  return !!(t.getCTM && (!t.parentNode || t.ownerSVGElement) && W2(t));
}, Mo = function(t, n) {
  if (n) {
    var o = t.style, i;
    n in In && n !== Ct && (n = Ue), o.removeProperty ? (i = n.substr(0, 2), (i === "ms" || n.substr(0, 6) === "webkit") && (n = "-" + n), o.removeProperty(i === "--" ? n : n.replace(B1, "-$1").toLowerCase())) : o.removeAttribute(n);
  }
}, xn = function(t, n, o, i, r, a) {
  var s = new _t(t._pt, n, o, 0, 1, a ? z2 : G2);
  return t._pt = s, s.b = i, s.e = r, t._props.push(o), s;
}, Ed = {
  deg: 1,
  rad: 1,
  turn: 1
}, Eb = {
  grid: 1,
  flex: 1
}, Qn = function e(t, n, o, i) {
  var r = parseFloat(o) || 0, a = (o + "").trim().substr((r + "").length) || "px", s = _o.style, l = hb.test(n), u = t.tagName.toLowerCase() === "svg", m = (u ? "client" : "offset") + (l ? "Width" : "Height"), g = 100, p = i === "px", T = i === "%", M, C, E, P;
  if (i === a || !r || Ed[i] || Ed[a])
    return r;
  if (a !== "px" && !p && (r = e(t, n, o, "px")), P = t.getCTM && q2(t), (T || a === "%") && (In[n] || ~n.indexOf("adius")))
    return M = P ? t.getBBox()[l ? "width" : "height"] : t[m], Ke(T ? r / M * g : r / 100 * M);
  if (s[l ? "width" : "height"] = g + (p ? a : i), C = i !== "rem" && ~n.indexOf("adius") || i === "em" && t.appendChild && !u ? t : t.parentNode, P && (C = (t.ownerSVGElement || {}).parentNode), (!C || C === Zn || !C.appendChild) && (C = Zn.body), E = C._gsap, E && T && E.width && l && E.time === $t.time && !E.uncache)
    return Ke(r / E.width * g);
  if (T && (n === "height" || n === "width")) {
    var F = t.style[n];
    t.style[n] = g + i, M = t[m], F ? t.style[n] = F : Mo(t, n);
  } else
    (T || a === "%") && !Eb[jt(C, "display")] && (s.position = jt(t, "position")), C === t && (s.position = "static"), C.appendChild(_o), M = _o[m], C.removeChild(_o), s.position = "absolute";
  return l && T && (E = To(C), E.time = $t.time, E.width = C[m]), Ke(p ? M * r / g : M && r ? g / M * r : 0);
}, kn = function(t, n, o, i) {
  var r;
  return F1 || Zl(), n in cn && n !== "transform" && (n = cn[n], ~n.indexOf(",") && (n = n.split(",")[0])), In[n] && n !== "transform" ? (r = Ci(t, i), r = n !== "transformOrigin" ? r[n] : r.svg ? r.origin : Ls(jt(t, Ct)) + " " + r.zOrigin + "px") : (r = t.style[n], (!r || r === "auto" || i || ~(r + "").indexOf("calc(")) && (r = Ds[n] && Ds[n](t, n, o) || jt(t, n) || c2(t, n) || (n === "opacity" ? 1 : 0))), o && !~(r + "").trim().indexOf(" ") ? Qn(t, n, r, o) + o : r;
}, Sb = function(t, n, o, i) {
  if (!o || o === "none") {
    var r = gr(n, t, 1), a = r && jt(t, r, 1);
    a && a !== o ? (n = r, o = a) : n === "borderColor" && (o = jt(t, "borderTopColor"));
  }
  var s = new _t(this._pt, t.style, n, 0, 1, V2), l = 0, u = 0, m, g, p, T, M, C, E, P, F, D, H, B;
  if (s.b = o, s.e = i, o += "", i += "", i.substring(0, 6) === "var(--" && (i = jt(t, i.substring(4, i.indexOf(")")))), i === "auto" && (C = t.style[n], t.style[n] = i, i = jt(t, n) || i, C ? t.style[n] = C : Mo(t, n)), m = [o, i], I2(m), o = m[0], i = m[1], p = o.match(er) || [], B = i.match(er) || [], B.length) {
    for (; g = er.exec(i); )
      E = g[0], F = i.substring(l, g.index), M ? M = (M + 1) % 5 : (F.substr(-5) === "rgba(" || F.substr(-5) === "hsla(") && (M = 1), E !== (C = p[u++] || "") && (T = parseFloat(C) || 0, H = C.substr((T + "").length), E.charAt(1) === "=" && (E = rr(T, E) + H), P = parseFloat(E), D = E.substr((P + "").length), l = er.lastIndex - D.length, D || (D = D || Dt.units[n] || H, l === i.length && (i += D, s.e += D)), H !== D && (T = Qn(t, n, C, D) || 0), s._pt = {
        _next: s._pt,
        p: F || u === 1 ? F : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: T,
        c: P - T,
        m: M && M < 4 || n === "zIndex" ? Math.round : 0
      });
    s.c = l < i.length ? i.substring(l, i.length) : "";
  } else
    s.r = n === "display" && i === "none" ? z2 : G2;
  return i2.test(i) && (s.e = 0), this._pt = s, s;
}, Sd = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, Mb = function(t) {
  var n = t.split(" "), o = n[0], i = n[1] || "50%";
  return (o === "top" || o === "bottom" || i === "left" || i === "right") && (t = o, o = i, i = t), n[0] = Sd[o] || o, n[1] = Sd[i] || i, n.join(" ");
}, Ab = function(t, n) {
  if (n.tween && n.tween._time === n.tween._dur) {
    var o = n.t, i = o.style, r = n.u, a = o._gsap, s, l, u;
    if (r === "all" || r === !0)
      i.cssText = "", l = 1;
    else
      for (r = r.split(","), u = r.length; --u > -1; )
        s = r[u], In[s] && (l = 1, s = s === "transformOrigin" ? Ct : Ue), Mo(o, s);
    l && (Mo(o, Ue), a && (a.svg && o.removeAttribute("transform"), i.scale = i.rotate = i.translate = "none", Ci(o, 1), a.uncache = 1, K2(i)));
  }
}, Ds = {
  clearProps: function(t, n, o, i, r) {
    if (r.data !== "isFromStart") {
      var a = t._pt = new _t(t._pt, n, o, 0, 0, Ab);
      return a.u = i, a.pr = -10, a.tween = r, t._props.push(o), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, _i = [1, 0, 0, 1, 0, 0], Y2 = {}, X2 = function(t) {
  return t === "matrix(1, 0, 0, 1, 0, 0)" || t === "none" || !t;
}, Md = function(t) {
  var n = jt(t, Ue);
  return X2(n) ? _i : n.substr(7).match(r2).map(Ke);
}, V1 = function(t, n) {
  var o = t._gsap || To(t), i = t.style, r = Md(t), a, s, l, u;
  return o.svg && t.getAttribute("transform") ? (l = t.transform.baseVal.consolidate().matrix, r = [l.a, l.b, l.c, l.d, l.e, l.f], r.join(",") === "1,0,0,1,0,0" ? _i : r) : (r === _i && !t.offsetParent && t !== ir && !o.svg && (l = i.display, i.display = "block", a = t.parentNode, (!a || !t.offsetParent && !t.getBoundingClientRect().width) && (u = 1, s = t.nextElementSibling, ir.appendChild(t)), r = Md(t), l ? i.display = l : Mo(t, "display"), u && (s ? a.insertBefore(t, s) : a ? a.appendChild(t) : ir.removeChild(t))), n && r.length > 6 ? [r[0], r[1], r[4], r[5], r[12], r[13]] : r);
}, xl = function(t, n, o, i, r, a) {
  var s = t._gsap, l = r || V1(t, !0), u = s.xOrigin || 0, m = s.yOrigin || 0, g = s.xOffset || 0, p = s.yOffset || 0, T = l[0], M = l[1], C = l[2], E = l[3], P = l[4], F = l[5], D = n.split(" "), H = parseFloat(D[0]) || 0, B = parseFloat(D[1]) || 0, U, x, Z, q;
  o ? l !== _i && (x = T * E - M * C) && (Z = H * (E / x) + B * (-C / x) + (C * F - E * P) / x, q = H * (-M / x) + B * (T / x) - (T * F - M * P) / x, H = Z, B = q) : (U = W2(t), H = U.x + (~D[0].indexOf("%") ? H / 100 * U.width : H), B = U.y + (~(D[1] || D[0]).indexOf("%") ? B / 100 * U.height : B)), i || i !== !1 && s.smooth ? (P = H - u, F = B - m, s.xOffset = g + (P * T + F * C) - P, s.yOffset = p + (P * M + F * E) - F) : s.xOffset = s.yOffset = 0, s.xOrigin = H, s.yOrigin = B, s.smooth = !!i, s.origin = n, s.originIsAbsolute = !!o, t.style[Ct] = "0px 0px", a && (xn(a, s, "xOrigin", u, H), xn(a, s, "yOrigin", m, B), xn(a, s, "xOffset", g, s.xOffset), xn(a, s, "yOffset", p, s.yOffset)), t.setAttribute("data-svg-origin", H + " " + B);
}, Ci = function(t, n) {
  var o = t._gsap || new N2(t);
  if ("x" in o && !n && !o.uncache)
    return o;
  var i = t.style, r = o.scaleX < 0, a = "px", s = "deg", l = getComputedStyle(t), u = jt(t, Ct) || "0", m, g, p, T, M, C, E, P, F, D, H, B, U, x, Z, q, ue, me, W, N, G, X, J, re, se, de, pe, ve, Te, ot, Xe, Et;
  return m = g = p = C = E = P = F = D = H = 0, T = M = 1, o.svg = !!(t.getCTM && q2(t)), l.translate && ((l.translate !== "none" || l.scale !== "none" || l.rotate !== "none") && (i[Ue] = (l.translate !== "none" ? "translate3d(" + (l.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (l.rotate !== "none" ? "rotate(" + l.rotate + ") " : "") + (l.scale !== "none" ? "scale(" + l.scale.split(" ").join(",") + ") " : "") + (l[Ue] !== "none" ? l[Ue] : "")), i.scale = i.rotate = i.translate = "none"), x = V1(t, o.svg), o.svg && (o.uncache ? (se = t.getBBox(), u = o.xOrigin - se.x + "px " + (o.yOrigin - se.y) + "px", re = "") : re = !n && t.getAttribute("data-svg-origin"), xl(t, re || u, !!re || o.originIsAbsolute, o.smooth !== !1, x)), B = o.xOrigin || 0, U = o.yOrigin || 0, x !== _i && (me = x[0], W = x[1], N = x[2], G = x[3], m = X = x[4], g = J = x[5], x.length === 6 ? (T = Math.sqrt(me * me + W * W), M = Math.sqrt(G * G + N * N), C = me || W ? zo(W, me) * po : 0, F = N || G ? zo(N, G) * po + C : 0, F && (M *= Math.abs(Math.cos(F * sr))), o.svg && (m -= B - (B * me + U * N), g -= U - (B * W + U * G))) : (Et = x[6], ot = x[7], pe = x[8], ve = x[9], Te = x[10], Xe = x[11], m = x[12], g = x[13], p = x[14], Z = zo(Et, Te), E = Z * po, Z && (q = Math.cos(-Z), ue = Math.sin(-Z), re = X * q + pe * ue, se = J * q + ve * ue, de = Et * q + Te * ue, pe = X * -ue + pe * q, ve = J * -ue + ve * q, Te = Et * -ue + Te * q, Xe = ot * -ue + Xe * q, X = re, J = se, Et = de), Z = zo(-N, Te), P = Z * po, Z && (q = Math.cos(-Z), ue = Math.sin(-Z), re = me * q - pe * ue, se = W * q - ve * ue, de = N * q - Te * ue, Xe = G * ue + Xe * q, me = re, W = se, N = de), Z = zo(W, me), C = Z * po, Z && (q = Math.cos(Z), ue = Math.sin(Z), re = me * q + W * ue, se = X * q + J * ue, W = W * q - me * ue, J = J * q - X * ue, me = re, X = se), E && Math.abs(E) + Math.abs(C) > 359.9 && (E = C = 0, P = 180 - P), T = Ke(Math.sqrt(me * me + W * W + N * N)), M = Ke(Math.sqrt(J * J + Et * Et)), Z = zo(X, J), F = Math.abs(Z) > 2e-4 ? Z * po : 0, H = Xe ? 1 / (Xe < 0 ? -Xe : Xe) : 0), o.svg && (re = t.getAttribute("transform"), o.forceCSS = t.setAttribute("transform", "") || !X2(jt(t, Ue)), re && t.setAttribute("transform", re))), Math.abs(F) > 90 && Math.abs(F) < 270 && (r ? (T *= -1, F += C <= 0 ? 180 : -180, C += C <= 0 ? 180 : -180) : (M *= -1, F += F <= 0 ? 180 : -180)), n = n || o.uncache, o.x = m - ((o.xPercent = m && (!n && o.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-m) ? -50 : 0))) ? t.offsetWidth * o.xPercent / 100 : 0) + a, o.y = g - ((o.yPercent = g && (!n && o.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-g) ? -50 : 0))) ? t.offsetHeight * o.yPercent / 100 : 0) + a, o.z = p + a, o.scaleX = Ke(T), o.scaleY = Ke(M), o.rotation = Ke(C) + s, o.rotationX = Ke(E) + s, o.rotationY = Ke(P) + s, o.skewX = F + s, o.skewY = D + s, o.transformPerspective = H + a, (o.zOrigin = parseFloat(u.split(" ")[2]) || !n && o.zOrigin || 0) && (i[Ct] = Ls(u)), o.xOffset = o.yOffset = 0, o.force3D = Dt.force3D, o.renderTransform = o.svg ? Ib : x2 ? Q2 : $b, o.uncache = 0, o;
}, Ls = function(t) {
  return (t = t.split(" "))[0] + " " + t[1];
}, Za = function(t, n, o) {
  var i = rt(n);
  return Ke(parseFloat(n) + parseFloat(Qn(t, "x", o + "px", i))) + i;
}, $b = function(t, n) {
  n.z = "0px", n.rotationY = n.rotationX = "0deg", n.force3D = 0, Q2(t, n);
}, so = "0deg", Fr = "0px", ao = ") ", Q2 = function(t, n) {
  var o = n || this, i = o.xPercent, r = o.yPercent, a = o.x, s = o.y, l = o.z, u = o.rotation, m = o.rotationY, g = o.rotationX, p = o.skewX, T = o.skewY, M = o.scaleX, C = o.scaleY, E = o.transformPerspective, P = o.force3D, F = o.target, D = o.zOrigin, H = "", B = P === "auto" && t && t !== 1 || P === !0;
  if (D && (g !== so || m !== so)) {
    var U = parseFloat(m) * sr, x = Math.sin(U), Z = Math.cos(U), q;
    U = parseFloat(g) * sr, q = Math.cos(U), a = Za(F, a, x * q * -D), s = Za(F, s, -Math.sin(U) * -D), l = Za(F, l, Z * q * -D + D);
  }
  E !== Fr && (H += "perspective(" + E + ao), (i || r) && (H += "translate(" + i + "%, " + r + "%) "), (B || a !== Fr || s !== Fr || l !== Fr) && (H += l !== Fr || B ? "translate3d(" + a + ", " + s + ", " + l + ") " : "translate(" + a + ", " + s + ao), u !== so && (H += "rotate(" + u + ao), m !== so && (H += "rotateY(" + m + ao), g !== so && (H += "rotateX(" + g + ao), (p !== so || T !== so) && (H += "skew(" + p + ", " + T + ao), (M !== 1 || C !== 1) && (H += "scale(" + M + ", " + C + ao), F.style[Ue] = H || "translate(0, 0)";
}, Ib = function(t, n) {
  var o = n || this, i = o.xPercent, r = o.yPercent, a = o.x, s = o.y, l = o.rotation, u = o.skewX, m = o.skewY, g = o.scaleX, p = o.scaleY, T = o.target, M = o.xOrigin, C = o.yOrigin, E = o.xOffset, P = o.yOffset, F = o.forceCSS, D = parseFloat(a), H = parseFloat(s), B, U, x, Z, q;
  l = parseFloat(l), u = parseFloat(u), m = parseFloat(m), m && (m = parseFloat(m), u += m, l += m), l || u ? (l *= sr, u *= sr, B = Math.cos(l) * g, U = Math.sin(l) * g, x = Math.sin(l - u) * -p, Z = Math.cos(l - u) * p, u && (m *= sr, q = Math.tan(u - m), q = Math.sqrt(1 + q * q), x *= q, Z *= q, m && (q = Math.tan(m), q = Math.sqrt(1 + q * q), B *= q, U *= q)), B = Ke(B), U = Ke(U), x = Ke(x), Z = Ke(Z)) : (B = g, Z = p, U = x = 0), (D && !~(a + "").indexOf("px") || H && !~(s + "").indexOf("px")) && (D = Qn(T, "x", a, "px"), H = Qn(T, "y", s, "px")), (M || C || E || P) && (D = Ke(D + M - (M * B + C * x) + E), H = Ke(H + C - (M * U + C * Z) + P)), (i || r) && (q = T.getBBox(), D = Ke(D + i / 100 * q.width), H = Ke(H + r / 100 * q.height)), q = "matrix(" + B + "," + U + "," + x + "," + Z + "," + D + "," + H + ")", T.setAttribute("transform", q), F && (T.style[Ue] = q);
}, Db = function(t, n, o, i, r) {
  var a = 360, s = Je(r), l = parseFloat(r) * (s && ~r.indexOf("rad") ? po : 1), u = l - i, m = i + u + "deg", g, p;
  return s && (g = r.split("_")[1], g === "short" && (u %= a, u !== u % (a / 2) && (u += u < 0 ? a : -a)), g === "cw" && u < 0 ? u = (u + a * Cd) % a - ~~(u / a) * a : g === "ccw" && u > 0 && (u = (u - a * Cd) % a - ~~(u / a) * a)), t._pt = p = new _t(t._pt, n, o, i, u, pb), p.e = m, p.u = "deg", t._props.push(o), p;
}, Ad = function(t, n) {
  for (var o in n)
    t[o] = n[o];
  return t;
}, Lb = function(t, n, o) {
  var i = Ad({}, o._gsap), r = "perspective,force3D,transformOrigin,svgOrigin", a = o.style, s, l, u, m, g, p, T, M;
  i.svg ? (u = o.getAttribute("transform"), o.setAttribute("transform", ""), a[Ue] = n, s = Ci(o, 1), Mo(o, Ue), o.setAttribute("transform", u)) : (u = getComputedStyle(o)[Ue], a[Ue] = n, s = Ci(o, 1), a[Ue] = u);
  for (l in In)
    u = i[l], m = s[l], u !== m && r.indexOf(l) < 0 && (T = rt(u), M = rt(m), g = T !== M ? Qn(o, l, u, M) : parseFloat(u), p = parseFloat(m), t._pt = new _t(t._pt, s, l, g, p - g, zl), t._pt.u = M || 0, t._props.push(l));
  Ad(s, i);
};
yt("padding,margin,Width,Radius", function(e, t) {
  var n = "Top", o = "Right", i = "Bottom", r = "Left", a = (t < 3 ? [n, o, i, r] : [n + r, n + o, i + o, i + r]).map(function(s) {
    return t < 2 ? e + s : "border" + s + e;
  });
  Ds[t > 1 ? "border" + e : e] = function(s, l, u, m, g) {
    var p, T;
    if (arguments.length < 4)
      return p = a.map(function(M) {
        return kn(s, M, u);
      }), T = p.join(" "), T.split(p[0]).length === 5 ? p[0] : T;
    p = (m + "").split(" "), T = {}, a.forEach(function(M, C) {
      return T[M] = p[C] = p[C] || p[(C - 1) / 2 | 0];
    }), s.init(l, T, g);
  };
});
var J2 = {
  name: "css",
  register: Zl,
  targetTest: function(t) {
    return t.style && t.nodeType;
  },
  init: function(t, n, o, i, r) {
    var a = this._props, s = t.style, l = o.vars.startAt, u, m, g, p, T, M, C, E, P, F, D, H, B, U, x, Z;
    F1 || Zl(), this.styles = this.styles || Z2(t), Z = this.styles.props, this.tween = o;
    for (C in n)
      if (C !== "autoRound" && (m = n[C], !(At[C] && P2(C, n, o, i, t, r)))) {
        if (T = typeof m, M = Ds[C], T === "function" && (m = m.call(o, i, t, r), T = typeof m), T === "string" && ~m.indexOf("random(") && (m = vi(m)), M)
          M(this, t, C, m, o) && (x = 1);
        else if (C.substr(0, 2) === "--")
          u = (getComputedStyle(t).getPropertyValue(C) + "").trim(), m += "", qn.lastIndex = 0, qn.test(u) || (E = rt(u), P = rt(m)), P ? E !== P && (u = Qn(t, C, u, P) + P) : E && (m += E), this.add(s, "setProperty", u, m, i, r, 0, 0, C), a.push(C), Z.push(C, 0, s[C]);
        else if (T !== "undefined") {
          if (l && C in l ? (u = typeof l[C] == "function" ? l[C].call(o, i, t, r) : l[C], Je(u) && ~u.indexOf("random(") && (u = vi(u)), rt(u + "") || u === "auto" || (u += Dt.units[C] || rt(kn(t, C)) || ""), (u + "").charAt(1) === "=" && (u = kn(t, C))) : u = kn(t, C), p = parseFloat(u), F = T === "string" && m.charAt(1) === "=" && m.substr(0, 2), F && (m = m.substr(2)), g = parseFloat(m), C in cn && (C === "autoAlpha" && (p === 1 && kn(t, "visibility") === "hidden" && g && (p = 0), Z.push("visibility", 0, s.visibility), xn(this, s, "visibility", p ? "inherit" : "hidden", g ? "inherit" : "hidden", !g)), C !== "scale" && C !== "transform" && (C = cn[C], ~C.indexOf(",") && (C = C.split(",")[0]))), D = C in In, D) {
            if (this.styles.save(C), T === "string" && m.substring(0, 6) === "var(--" && (m = jt(t, m.substring(4, m.indexOf(")"))), g = parseFloat(m)), H || (B = t._gsap, B.renderTransform && !n.parseTransform || Ci(t, n.parseTransform), U = n.smoothOrigin !== !1 && B.smooth, H = this._pt = new _t(this._pt, s, Ue, 0, 1, B.renderTransform, B, 0, -1), H.dep = 1), C === "scale")
              this._pt = new _t(this._pt, B, "scaleY", B.scaleY, (F ? rr(B.scaleY, F + g) : g) - B.scaleY || 0, zl), this._pt.u = 0, a.push("scaleY", C), C += "X";
            else if (C === "transformOrigin") {
              Z.push(Ct, 0, s[Ct]), m = Mb(m), B.svg ? xl(t, m, 0, U, 0, this) : (P = parseFloat(m.split(" ")[2]) || 0, P !== B.zOrigin && xn(this, B, "zOrigin", B.zOrigin, P), xn(this, s, C, Ls(u), Ls(m)));
              continue;
            } else if (C === "svgOrigin") {
              xl(t, m, 1, U, 0, this);
              continue;
            } else if (C in Y2) {
              Db(this, B, C, p, F ? rr(p, F + m) : m);
              continue;
            } else if (C === "smoothOrigin") {
              xn(this, B, "smooth", B.smooth, m);
              continue;
            } else if (C === "force3D") {
              B[C] = m;
              continue;
            } else if (C === "transform") {
              Lb(this, m, t);
              continue;
            }
          } else C in s || (C = gr(C) || C);
          if (D || (g || g === 0) && (p || p === 0) && !mb.test(m) && C in s)
            E = (u + "").substr((p + "").length), g || (g = 0), P = rt(m) || (C in Dt.units ? Dt.units[C] : E), E !== P && (p = Qn(t, C, u, P)), this._pt = new _t(this._pt, D ? B : s, C, p, (F ? rr(p, F + g) : g) - p, !D && (P === "px" || C === "zIndex") && n.autoRound !== !1 ? gb : zl), this._pt.u = P || 0, E !== P && P !== "%" && (this._pt.b = u, this._pt.r = fb);
          else if (C in s)
            Sb.call(this, t, C, u, F ? F + m : m);
          else if (C in t)
            this.add(t, C, u || t[C], F ? F + m : m, i, r);
          else if (C !== "parseTransform") {
            M1(C, m);
            continue;
          }
          D || (C in s ? Z.push(C, 0, s[C]) : typeof t[C] == "function" ? Z.push(C, 2, t[C]()) : Z.push(C, 1, u || t[C])), a.push(C);
        }
      }
    x && j2(this);
  },
  render: function(t, n) {
    if (n.tween._time || !R1())
      for (var o = n._pt; o; )
        o.r(t, o.d), o = o._next;
    else
      n.styles.revert();
  },
  get: kn,
  aliases: cn,
  getSetter: function(t, n, o) {
    var i = cn[n];
    return i && i.indexOf(",") < 0 && (n = i), n in In && n !== Ct && (t._gsap.x || kn(t, "x")) ? o && _d === o ? n === "scale" ? _b : yb : (_d = o || {}) && (n === "scale" ? Cb : wb) : t.style && !k1(t.style[n]) ? vb : ~n.indexOf("-") ? bb : P1(t, n);
  },
  core: {
    _removeProperty: Mo,
    _getMatrix: V1
  }
};
wt.utils.checkPrefix = gr;
wt.core.getStyleSaver = Z2;
(function(e, t, n, o) {
  var i = yt(e + "," + t + "," + n, function(r) {
    In[r] = 1;
  });
  yt(t, function(r) {
    Dt.units[r] = "deg", Y2[r] = 1;
  }), cn[i[13]] = e + "," + t, yt(o, function(r) {
    var a = r.split(":");
    cn[a[1]] = i[a[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
yt("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(e) {
  Dt.units[e] = "px";
});
wt.registerPlugin(J2);
var zn = wt.registerPlugin(J2) || wt;
zn.core.Tween;
const Ob = (e, t) => {
  const o = (() => {
    if (typeof t != "number")
      return "";
    switch (!0) {
      case t < 600:
        return "px600";
      case (t >= 600 && t < 960):
        return "px960";
      case (t >= 960 && t < 1280):
        return "px1280";
      case (t >= 1280 && t < 1600):
        return "px1600";
      case (t >= 1600 && t < 1920):
        return "px1920";
      case (t >= 1920 && t < 2560):
        return "px2560";
      default:
        return "";
    }
  })();
  e.forEach((i) => {
    var a;
    const r = new Image();
    r.src = o && ((a = i.sizes) == null ? void 0 : a[o]) || i.url;
  });
}, On = {
  mixins: [mt],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    gallery: {
      type: Object,
      default: () => ({})
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    hidePager: Boolean
  },
  data() {
    return {
      playSlideshow: !0,
      playVideo: !0,
      index: 0,
      activeImageIdx: 0,
      timer: null,
      transition: "right"
    };
  },
  computed: {
    imageHeight() {
      if (this.theme.version === "G1")
        return "";
      const e = this.theme.version === "G4";
      let t = "42.9vw";
      switch (this.theme.image_size) {
        case "small":
          t = e ? "47vw" : "31vw";
          break;
        case "medium":
          t = e ? "52vw" : "37vw";
          break;
        case "large":
          t = e ? "59vw" : "42.9vw";
          break;
        default:
          t = e ? "59vw" : "42.9vw";
      }
      return {
        "--image-height": t
      };
    },
    accentColor() {
      var e;
      return {
        "--gallery-accent-color": S(
          this.theme,
          "gallery_image_border_color.hex",
          (e = this.theme.globalThemeSettings) == null ? void 0 : e.secondaryColor
        )
      };
    },
    linkStyle() {
      return {
        "--link-color": this.theme.link_color.hex
      };
    },
    bgColor() {
      var e, t;
      return {
        "--bg-color": (t = (e = this.theme) == null ? void 0 : e.bg_color) == null ? void 0 : t.hex
      };
    },
    slides() {
      var e;
      return ((e = this.gallery) == null ? void 0 : e.slides) || [];
    },
    widget() {
      var e;
      return ((e = this.gallery) == null ? void 0 : e.widget) || {};
    },
    currentTransition() {
      return this.theme.fade_transition ? `${this.transition}-fade` : this.transition;
    },
    hasSmoothTransition() {
      return ["G7"].includes(this.theme.version);
    }
  },
  mounted() {
    this.preloadImages(), this.$refs.title && this.$refs.title.children[0] && (this.$refs.title.children[0].id = "galleryheading"), !(this.theme.version === "G2" && this.theme.use_video) && this.restartSlideTimer();
  },
  methods: {
    async preloadImages() {
      await this.$nextTick(), Ob(this.slides, this.screenSize);
    },
    togglePlay() {
      this.playSlideshow = !this.playSlideshow, this.restartSlideTimer();
    },
    toggleVideoPlay() {
      if (this.togglePlay(), this.playVideo = !this.playVideo, this.$refs.videoPlayer)
        return this.playVideo ? this.$refs.videoPlayer.play() : this.$refs.videoPlayer.pause();
    },
    jump(e) {
      this.activeImageIdx = e, this.restartSlideTimer();
    },
    moveForward() {
      this.transition = "right", this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.restartSlideTimer();
    },
    moveBack() {
      this.transition = "left", this.activeImageIdx === 0 ? (this.activeImageIdx = this.slides.length - 1, this.restartSlideTimer()) : (this.activeImageIdx = (this.activeImageIdx - 1) % this.slides.length, this.restartSlideTimer());
    },
    smoothForward() {
      if (this.slides.length <= 1) return;
      this.transition = "right";
      const e = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
      if (e.length === 0) {
        this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.$nextTick(() => {
          const o = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
          o.length > 0 && (zn.set(o, { opacity: 0 }), zn.to(o, {
            opacity: 1,
            duration: 0.5,
            ease: "sine.in"
          }));
        });
        return;
      }
      const t = () => {
        this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.$nextTick(() => {
          const o = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
          o.length > 0 && zn.set(o, { opacity: 0 });
        });
      }, n = 650;
      zn.to(e, {
        opacity: 0,
        duration: 0.5,
        ease: "sine.out",
        onComplete: () => {
          t(), setTimeout(() => {
            this.$nextTick(() => {
              const o = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
              o.length > 0 && zn.to(o, {
                opacity: 1,
                duration: 0.5,
                ease: "sine.in"
              });
            });
          }, n);
        },
        onError: (o) => {
          console.warn("GSAP animation error:", o);
        }
      });
    },
    restartSlideTimer() {
      var e;
      this.isEditing || (clearTimeout(this.timer), this.playSlideshow && (this.timer = setTimeout(() => {
        this.hasSmoothTransition ? this.smoothForward() : this.moveForward(), this.restartSlideTimer();
      }, ((e = this.theme) == null ? void 0 : e.gallery_speed) || 5e3)));
    },
    handleJump(e) {
      this.isEditing ? (this.$emit("jumpTo", e), this.activeImageIdx = e) : this.jump(e);
    },
    handleScrollLeft() {
      this.isEditing ? (this.activeImageIdx = (this.activeImageIdx - 1 + this.slides.length) % this.slides.length, this.$emit("scrollLeft")) : this.moveBack();
    },
    handleScrollRight() {
      this.isEditing ? (this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.$emit("scrollRight")) : this.moveForward();
    }
  }
}, Nb = {
  props: {
    image: {
      type: Object,
      required: !0
    },
    altText: {
      type: String,
      required: !0
    },
    idx: {
      type: Number,
      required: !0
    }
  },
  computed: {
    sizes() {
      return this.image.sizes || {};
    }
  }
}, Pb = ["srcset"], Hb = ["srcset"], Fb = ["srcset"], Rb = ["srcset"], Bb = ["srcset"], Vb = ["srcset"], jb = ["src", "alt"];
function Ub(e, t, n, o, i, r) {
  return d(), h("div", { key: n.idx }, [
    c("picture", null, [
      c("source", {
        srcset: r.sizes.px600,
        media: "(max-width: 600px)"
      }, null, 8, Pb),
      c("source", {
        srcset: r.sizes.px960,
        media: "(max-width: 960px)"
      }, null, 8, Hb),
      c("source", {
        srcset: r.sizes.px1280,
        media: "(max-width: 1280px)"
      }, null, 8, Fb),
      c("source", {
        srcset: r.sizes.px1600,
        media: "(max-width: 1600px)"
      }, null, 8, Rb),
      c("source", {
        srcset: r.sizes.px1920,
        media: "(max-width: 1920px)"
      }, null, 8, Bb),
      c("source", {
        srcset: r.sizes.px2560,
        media: "(max-width: 2560px)"
      }, null, 8, Vb),
      c("img", {
        src: n.image.url,
        alt: n.altText
      }, null, 8, jb)
    ])
  ]);
}
const Po = /* @__PURE__ */ O(Nb, [["render", Ub]]), Gb = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, zb = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Kb = ["fill"], Zb = ["fill"];
function xb(e, t, n, o, i, r) {
  return d(), h("svg", zb, [
    c("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, Kb),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15 10H12V22H15V10ZM20 10H17V22H20V10Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Zb)
  ]);
}
const Wb = /* @__PURE__ */ O(Gb, [["render", xb]]), qb = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Yb = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xb = ["fill"], Qb = ["fill"];
function Jb(e, t, n, o, i, r) {
  return d(), h("svg", Yb, [
    c("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, Xb),
    c("path", {
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Qb)
  ]);
}
const ey = /* @__PURE__ */ O(qb, [["render", Jb]]), ty = {
  name: "SvgReverse",
  mixins: [On],
  props: {
    theme: {
      type: Object,
      required: !0
    }
  }
}, ny = ["fill"], oy = ["fill"];
function ry(e, t, n, o, i, r) {
  return d(), h("svg", {
    width: "8",
    height: "13",
    viewBox: "0 0 8 13",
    fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.82843 6.50008L7.62132 1.70718L6.20711 0.292969L0 6.50008L6.20711 12.7072L7.62132 11.293L2.82843 6.50008Z",
      fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex
    }, null, 8, oy)
  ], 8, ny);
}
const iy = /* @__PURE__ */ O(ty, [["render", ry]]), sy = {
  name: "SvgAdvance",
  mixins: [On],
  props: {
    theme: {
      type: Object,
      required: !0
    }
  }
}, ay = ["fill"], ly = ["fill"];
function uy(e, t, n, o, i, r) {
  return d(), h("svg", {
    width: "9",
    height: "13",
    viewBox: "0 0 9 13",
    fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.4997 6.49992L0.706805 11.2928L2.12102 12.707L8.32813 6.49992L2.12102 0.292818L0.706806 1.70703L5.4997 6.49992Z",
      fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex
    }, null, 8, ly)
  ], 8, ay);
}
const dy = /* @__PURE__ */ O(sy, [["render", uy]]), cy = {
  name: "G1",
  components: {
    ResponsiveImage: Po,
    PauseSvg: Wb,
    PlaySvg: ey,
    ReverseSvg: iy,
    AdvanceSvg: dy
  },
  mixins: [On]
}, hy = { class: "text" }, my = ["innerHTML"], py = ["innerHTML"], fy = { class: "image-wrapper" }, gy = {
  key: 0,
  class: "navigation"
}, vy = { class: "button-action-content" }, by = { class: "button-action-content" }, yy = { class: "arrow-position" }, _y = { class: "button-action-content" }, Cy = { class: "position" }, wy = ["aria-label", "aria-current", "onClick", "onKeydown"], Ty = { class: "button-action-content" }, ky = { class: "button-action-content" };
function Ey(e, t, n, o, i, r) {
  const a = $("responsive-image"), s = $("PlaySvg"), l = $("PauseSvg"), u = $("ReverseSvg"), m = $("AdvanceSvg"), g = Ve("touch");
  return d(), h("div", {
    id: "g1",
    "data-testid": "G1",
    style: j([e.linkStyle, e.accentColor])
  }, [
    c("div", {
      style: j(`background-color: ${e.theme.bg_color.hex}`),
      class: "slide"
    }, [
      c("div", hy, [
        c("div", {
          ref: "title",
          class: v(["title", e.theme.style]),
          "data-testid": "gallery-title"
        }, [
          c("div", {
            style: j(`color: ${e.theme.heading_color.hex}`),
            innerHTML: e.slides[0].title
          }, null, 12, my)
        ], 2),
        c("div", {
          class: v(["description", e.theme.style])
        }, [
          c("div", {
            style: j(`color: ${e.theme.text_color.hex}`),
            innerHTML: e.slides[0].content
          }, null, 12, py)
        ], 2)
      ]),
      c("div", fy, [
        ge((d(), k(Ln, {
          tag: "div",
          class: "img-slider",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: _(() => [
            (d(), k(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            g,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            g,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.slides.length > 1 ? (d(), h("div", gy, [
          e.playSlideshow ? (d(), h("button", {
            key: 1,
            "aria-label": "Pause Gallery",
            "data-testid": "pause-button",
            class: "pause button-action",
            onClick: t[2] || (t[2] = (...p) => e.togglePlay && e.togglePlay(...p)),
            onKeydown: t[3] || (t[3] = V(z((...p) => e.togglePlay && e.togglePlay(...p), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", by, [
              L(l, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)) : (d(), h("button", {
            key: 0,
            "aria-label": "Play Gallery",
            "data-testid": "play-button",
            class: "play button-action",
            onClick: t[0] || (t[0] = (...p) => e.togglePlay && e.togglePlay(...p)),
            onKeydown: t[1] || (t[1] = V(z((...p) => e.togglePlay && e.togglePlay(...p), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", vy, [
              L(s, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)),
          c("div", yy, [
            c("button", {
              class: "left-arrow button-action",
              "aria-label": "Previous Image",
              "data-testid": "gallery-left-button",
              onClick: t[4] || (t[4] = (...p) => e.moveBack && e.moveBack(...p)),
              onKeydown: t[5] || (t[5] = V(z((...p) => e.moveBack && e.moveBack(...p), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", _y, [
                L(u, { theme: e.theme }, null, 8, ["theme"])
              ])
            ], 32),
            c("p", {
              style: j(`color: ${e.theme.text_color.hex}`)
            }, "1", 4),
            c("div", Cy, [
              (d(!0), h(Y, null, ee(e.slides, (p, T) => (d(), h("button", {
                key: p.url,
                class: "button-action",
                "aria-label": `Image ${T + 1}`,
                "aria-current": e.activeImageIdx === T ? "active" : null,
                "data-testid": "gallery-pager-button",
                onClick: (M) => e.jump(T),
                onKeydown: V(z((M) => e.jump(T), ["exact", "prevent"]), ["enter"])
              }, [
                c("div", Ty, [
                  c("div", {
                    class: v(["rectangle button-action-content", { active: e.activeImageIdx === T }]),
                    style: j({
                      "background-color": e.theme.pager_color.hex,
                      height: e.activeImageIdx === T ? "4px" : "1px"
                    })
                  }, null, 6)
                ])
              ], 40, wy))), 128))
            ]),
            c("p", {
              style: j(`color: ${e.theme.text_color.hex}`)
            }, y(e.slides.length), 5),
            c("button", {
              "aria-label": "Next Image",
              class: "right-arrow button-action",
              "data-testid": "gallery-right-button",
              onClick: t[6] || (t[6] = (...p) => e.moveForward && e.moveForward(...p)),
              onKeydown: t[7] || (t[7] = V(z((...p) => e.moveForward && e.moveForward(...p), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", ky, [
                L(m, { theme: e.theme }, null, 8, ["theme"])
              ])
            ], 32)
          ])
        ])) : b("", !0)
      ])
    ], 4)
  ], 4);
}
const Sy = /* @__PURE__ */ O(cy, [["render", Ey], ["__scopeId", "data-v-11dc02a2"]]), My = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Ay = {
  class: "pause_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $y = ["fill"], Iy = ["fill"];
function Dy(e, t, n, o, i, r) {
  return d(), h("svg", Ay, [
    c("rect", {
      class: "icon-background",
      width: "40",
      height: "40",
      fill: n.buttonBgColor.hex
    }, null, 8, $y),
    c("path", {
      class: "icon-button",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 14H16V26H19V14ZM24 14H21V26H24V14Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Iy)
  ]);
}
const Ly = /* @__PURE__ */ O(My, [["render", Dy]]), Oy = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Ny = {
  class: "play_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Py = ["fill"], Hy = ["fill"];
function Fy(e, t, n, o, i, r) {
  return d(), h("svg", Ny, [
    c("rect", {
      class: "icon-background",
      width: "32",
      height: "32",
      fill: n.buttonBgColor.hex
    }, null, 8, Py),
    c("path", {
      class: "icon-button",
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Hy)
  ]);
}
const Ry = /* @__PURE__ */ O(Oy, [["render", Fy]]), By = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Vy = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jy = ["fill"], Uy = ["fill"];
function Gy(e, t, n, o, i, r) {
  return d(), h("svg", Vy, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M-6.10352e-05 0L64 0L64 64L-6.10352e-05 64L-6.10352e-05 0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, jy),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25 32L37 19.5L35.5 18L21.9999 32.0428L35.5 46L37 44.5L25 32Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Uy)
  ]);
}
const zy = /* @__PURE__ */ O(By, [["render", Gy]]), Ky = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Zy = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xy = ["fill"], Wy = ["fill"];
function qy(e, t, n, o, i, r) {
  return d(), h("svg", Zy, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M64 64L-7.62939e-06 64L-2.03434e-06 -1.78036e-06L64 3.8147e-06L64 64Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, xy),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M39 32L27 44.5L28.5 46L42 31.9572L28.5 18L27 19.5L39 32Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Wy)
  ]);
}
const Yy = /* @__PURE__ */ O(Ky, [["render", qy]]), Xy = {
  name: "G2",
  components: {
    PauseSvg: Ly,
    PlaySvg: Ry,
    ReverseSvg: zy,
    AdvanceSvg: Yy,
    ResponsiveImage: Po
  },
  mixins: [On],
  computed: {
    titleText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.title) || "";
    },
    descriptionText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.content) || "";
    },
    colors() {
      var e, t, n, o;
      return {
        "--button-bg-color": ((t = (e = this.theme) == null ? void 0 : e.button_bg_color) == null ? void 0 : t.hex) || "",
        "--button-color": ((o = (n = this.theme) == null ? void 0 : n.button_icon_color) == null ? void 0 : o.hex) || ""
      };
    },
    arrowsVisible() {
      return this.slides.length > 1 && !this.theme.use_video && !this.theme.hasFloatingNav;
    },
    videoAltText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.alt_text) || "";
    },
    videoUrl() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.url) || "";
    },
    showPauseButton() {
      return this.theme.use_video && this.playVideo || !this.theme.use_video && this.playSlideshow && this.slides.length > 1;
    },
    showPlayButton() {
      return this.theme.use_video && !this.playVideo || !this.theme.use_video && !this.playSlideshow && this.slides.length > 1;
    }
  },
  watch: {
    "theme.use_video": {
      handler() {
        this.theme.use_video ? (this.playSlideshow = !1, this.toggleVideoPlay()) : (this.playVideo = !1, this.togglePlay());
      }
    }
  }
}, Qy = { class: "image-wrapper" }, Jy = {
  key: 1,
  class: "video-wrapper"
}, e_ = ["aria-label", "src"], t_ = { "data-testid": "video-play-pause-wrapper" }, n_ = ["data-testid"], o_ = { class: "button-action-content" }, r_ = ["data-testid"], i_ = { class: "button-action-content" }, s_ = { class: "button-action-content" }, a_ = { class: "button-action-content" }, l_ = {
  key: 4,
  class: "position"
}, u_ = ["aria-current", "aria-label", "onClick", "onKeydown"], d_ = ["innerHTML"], c_ = ["innerHTML"];
function h_(e, t, n, o, i, r) {
  const a = $("responsive-image"), s = $("PauseSvg"), l = $("PlaySvg"), u = $("ReverseSvg"), m = $("AdvanceSvg"), g = Ve("touch");
  return d(), h("div", {
    id: "g2",
    style: j([e.linkStyle, r.colors, e.imageHeight])
  }, [
    c("div", {
      class: "slide",
      style: j(`background: ${e.theme.bg_color.hex}`)
    }, [
      c("div", Qy, [
        e.theme.use_video ? b("", !0) : ge((d(), k(Ln, {
          key: 0,
          class: "img-slider",
          tag: "div",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: _(() => [
            (d(), k(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            g,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            g,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.theme.use_video ? (d(), h("div", Jy, [
          c("video", {
            ref: "videoPlayer",
            "aria-label": r.videoAltText,
            src: r.videoUrl,
            class: "video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            "data-testid": "gallery-video"
          }, " Your browser does not support videos. ", 8, e_)
        ])) : b("", !0),
        c("div", t_, [
          r.showPauseButton ? (d(), h("button", {
            key: 0,
            "aria-label": "Pause Gallery",
            "data-testid": e.theme.use_video ? "video-pause-button" : "pause-button",
            class: "pause button-action",
            onClick: t[0] || (t[0] = (p) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay()),
            onKeydown: t[1] || (t[1] = V(z((p) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay(), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", o_, [
              L(s, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 40, n_)) : r.showPlayButton ? (d(), h("button", {
            key: 1,
            "aria-label": "Play Gallery",
            "data-testid": e.theme.use_video ? "video-play-button" : "play-button",
            class: "play button-action",
            onClick: t[2] || (t[2] = (p) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay()),
            onKeydown: t[3] || (t[3] = V(z((p) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay(), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", i_, [
              L(l, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 40, r_)) : b("", !0)
        ]),
        r.arrowsVisible ? (d(), h("button", {
          key: 2,
          class: "left-arrow button-action",
          "data-testid": "gallery-left-button",
          "aria-label": "Previous Image",
          onClick: t[4] || (t[4] = (...p) => e.moveBack && e.moveBack(...p)),
          onKeydown: t[5] || (t[5] = V(z((...p) => e.moveBack && e.moveBack(...p), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", s_, [
            L(u, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : b("", !0),
        r.arrowsVisible ? (d(), h("button", {
          key: 3,
          class: "right-arrow button-action",
          "data-testid": "gallery-right-button",
          "aria-label": "Next Image",
          onClick: t[6] || (t[6] = (...p) => e.moveForward && e.moveForward(...p)),
          onKeydown: t[7] || (t[7] = V(z((...p) => e.moveForward && e.moveForward(...p), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", a_, [
            L(m, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : b("", !0),
        e.slides.length > 1 && !e.theme.use_video ? (d(), h("div", l_, [
          (d(!0), h(Y, null, ee(e.slides, (p, T) => (d(), h("div", {
            key: p.url
          }, [
            c("button", {
              class: v(["square button-action", { active: e.activeImageIdx === T }]),
              "aria-current": e.activeImageIdx === T ? "active" : null,
              "aria-label": `Image ${T + 1}`,
              style: j({
                "background-color": e.activeImageIdx === T ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
              }),
              "data-testid": "gallery-pager-button",
              onClick: (M) => e.jump(T),
              onKeydown: V(z((M) => e.jump(T), ["exact", "prevent"]), ["enter"])
            }, t[8] || (t[8] = [
              c("div", { class: "button-action-content" }, null, -1)
            ]), 46, u_)
          ]))), 128))
        ])) : b("", !0)
      ]),
      r.titleText || r.descriptionText ? (d(), h("div", {
        key: 0,
        class: "text",
        style: j(`background: ${e.theme.overlay_color.hex}CC`)
      }, [
        r.titleText ? (d(), h("div", {
          key: 0,
          class: v(["title", e.theme.style]),
          "data-testid": "gallery-title"
        }, [
          c("div", {
            ref: "title",
            style: j(`color: ${e.theme.heading_color.hex}`),
            innerHTML: r.titleText
          }, null, 12, d_)
        ], 2)) : b("", !0),
        r.descriptionText ? (d(), h("div", {
          key: 1,
          class: v(["description", e.theme.style])
        }, [
          c("div", {
            style: j(`color: ${e.theme.text_color.hex}`),
            innerHTML: r.descriptionText
          }, null, 12, c_)
        ], 2)) : b("", !0)
      ], 4)) : b("", !0)
    ], 4)
  ], 4);
}
const m_ = /* @__PURE__ */ O(Xy, [["render", h_], ["__scopeId", "data-v-802dd901"]]), p_ = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, f_ = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, g_ = ["fill", "stroke"], v_ = ["fill"];
function b_(e, t, n, o, i, r) {
  return d(), h("svg", f_, [
    c("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9",
      stroke: n.buttonIconColor.hex
    }, null, 8, g_),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex
    }, null, 8, v_)
  ]);
}
const y_ = /* @__PURE__ */ O(p_, [["render", b_]]), __ = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, C_ = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, w_ = ["fill", "stroke"], T_ = ["fill"];
function k_(e, t, n, o, i, r) {
  return d(), h("svg", C_, [
    c("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9",
      stroke: n.buttonIconColor.hex
    }, null, 8, w_),
    c("path", {
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, T_)
  ]);
}
const E_ = /* @__PURE__ */ O(__, [["render", k_]]), S_ = {
  name: "SvgReverse",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    },
    buttonBgColor: {
      type: Object,
      required: !0
    }
  }
}, M_ = ["stroke"], A_ = ["fill"];
function $_(e, t, n, o, i, r) {
  return d(), h("svg", {
    style: j({ backgroundColor: n.buttonBgColor.hex }),
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      d: "M45.5 45.4999L0.5 45.4999L0.500004 0.500007L45.5 0.500011L45.5 45.4999Z",
      fill: "black",
      "fill-opacity": "0.01",
      stroke: n.buttonIconColor.hex
    }, null, 8, M_),
    c("path", {
      d: "M19.5 33.9999L8 22.9999L19.5 10.9999L21 12.4999L12 21.9999L38 21.9999L38 23.9999L12 23.9999L21 32.4999L19.5 33.9999Z",
      fill: n.buttonIconColor.hex
    }, null, 8, A_)
  ], 4);
}
const I_ = /* @__PURE__ */ O(S_, [["render", $_]]), D_ = {
  name: "SvgAdvance",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    },
    buttonBgColor: {
      type: Object,
      required: !0
    }
  }
}, L_ = ["stroke"], O_ = ["fill"];
function N_(e, t, n, o, i, r) {
  return d(), h("svg", {
    style: j({ backgroundColor: n.buttonBgColor.hex }),
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01",
      stroke: n.buttonIconColor.hex
    }, null, 8, L_),
    c("path", {
      d: "M26.5 12L38 23L26.5 35L25 33.5L34 24H8V22H34L25 13.5L26.5 12Z",
      fill: n.buttonIconColor.hex
    }, null, 8, O_)
  ], 4);
}
const P_ = /* @__PURE__ */ O(D_, [["render", N_]]), H_ = {
  name: "G3",
  components: {
    ResponsiveImage: Po,
    PauseSvg: y_,
    ReverseSvg: I_,
    PlaySvg: E_,
    AdvanceSvg: P_
  },
  mixins: [On],
  computed: {
    cssVars() {
      return {
        "--gradient-color": `linear-gradient(180deg, rgba(1, 73, 145, 0) 0%, ${this.theme.overlay_color.hex} 80.73%)`
      };
    }
  }
}, F_ = { class: "image-wrapper" }, R_ = { class: "button-action-content" }, B_ = { class: "button-action-content" }, V_ = { class: "position-tablet" }, j_ = ["aria-current", "aria-label", "onKeydown", "onClick"], U_ = { class: "button-action-content" }, G_ = { class: "button-action-content" }, z_ = ["innerHTML"], K_ = {
  key: 0,
  class: "navigation"
}, Z_ = { class: "button-action-content" }, x_ = { class: "button-action-content" }, W_ = { class: "info" }, q_ = {
  key: 0,
  class: "position"
}, Y_ = ["aria-label", "aria-current", "onClick", "onKeydown"], X_ = ["innerHTML"], Q_ = ["innerHTML"], J_ = {
  key: 1,
  class: "arrows"
}, eC = { class: "button-action-content" }, tC = { class: "button-action-content" };
function nC(e, t, n, o, i, r) {
  const a = $("responsive-image"), s = $("PlaySvg"), l = $("PauseSvg"), u = $("ReverseSvg"), m = $("AdvanceSvg"), g = Ve("touch");
  return d(), h("div", {
    id: "g3",
    style: j([e.linkStyle, e.imageHeight, r.cssVars])
  }, [
    c("div", {
      class: "slide",
      style: j({ "background-color": e.theme.overlay_color.hex })
    }, [
      c("div", F_, [
        ge((d(), k(Ln, {
          tag: "div",
          class: "image",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: _(() => [
            (d(), k(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            g,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            g,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.slides.length > 1 ? (d(), h("div", {
          key: 0,
          class: v(["navigation-small", { "gradient-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }])
        }, [
          e.playSlideshow ? (d(), h("button", {
            key: 1,
            "aria-label": "Pause Gallery",
            "data-testid": "pause-button",
            class: "pause button-action",
            onClick: t[2] || (t[2] = (...p) => e.togglePlay && e.togglePlay(...p)),
            onKeydown: t[3] || (t[3] = V(z((...p) => e.togglePlay && e.togglePlay(...p), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", B_, [
              L(l, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)) : (d(), h("button", {
            key: 0,
            "aria-label": "Play Gallery",
            "data-testid": "play-button",
            class: "play button-action",
            onClick: t[0] || (t[0] = (...p) => e.togglePlay && e.togglePlay(...p)),
            onKeydown: t[1] || (t[1] = V(z((...p) => e.togglePlay && e.togglePlay(...p), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", R_, [
              L(s, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32)),
          c("div", V_, [
            (d(!0), h(Y, null, ee(e.slides, (p, T) => (d(), h("div", {
              key: p.url
            }, [
              c("button", {
                class: "square button-action",
                style: j({
                  "background-color": e.activeImageIdx === T ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
                }),
                "aria-current": e.activeImageIdx === T ? "active" : "inactive",
                "aria-label": `Image ${T + 1}`,
                "data-testid": "gallery-pager-button",
                onKeydown: V(z((M) => e.jump(T), ["exact", "prevent"]), ["enter"]),
                onClick: (M) => e.jump(T)
              }, null, 44, j_)
            ]))), 128))
          ]),
          c("button", {
            class: "left-arrow button-action",
            "data-testid": "gallery-left-button",
            "aria-label": "Previous Image",
            onClick: t[4] || (t[4] = (...p) => e.moveBack && e.moveBack(...p)),
            onKeydown: t[5] || (t[5] = V(z((...p) => e.moveBack && e.moveBack(...p), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", U_, [
              L(u, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32),
          c("button", {
            class: "right-arrow button-action",
            "data-testid": "gallery-right-button",
            "aria-label": "Next Image",
            onClick: t[6] || (t[6] = (...p) => e.moveForward && e.moveForward(...p)),
            onKeydown: t[7] || (t[7] = V(z((...p) => e.moveForward && e.moveForward(...p), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", G_, [
              L(m, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32)
        ], 2)) : b("", !0),
        c("div", {
          class: v(["title-on-image", [
            e.theme.style,
            { "gradient-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }
          ]])
        }, [
          c("div", {
            ref: "title",
            style: j(`color: ${e.theme.heading_color.hex}`),
            "data-testid": "gallery-title",
            innerHTML: e.slides[e.activeImageIdx].title
          }, null, 12, z_)
        ], 2)
      ]),
      e.slides.length > 1 ? (d(), h("div", K_, [
        e.playSlideshow ? (d(), h("button", {
          key: 1,
          "aria-label": "Pause Gallery",
          "data-testid": "pause-button",
          class: "pause button-action",
          onClick: t[10] || (t[10] = (...p) => e.togglePlay && e.togglePlay(...p)),
          onKeydown: t[11] || (t[11] = V(z((...p) => e.togglePlay && e.togglePlay(...p), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", x_, [
            L(l, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : (d(), h("button", {
          key: 0,
          "aria-label": "Play Gallery",
          "data-testid": "play-button",
          class: "play button-action",
          onClick: t[8] || (t[8] = (...p) => e.togglePlay && e.togglePlay(...p)),
          onKeydown: t[9] || (t[9] = V(z((...p) => e.togglePlay && e.togglePlay(...p), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", Z_, [
            L(s, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32))
      ])) : b("", !0),
      c("div", W_, [
        e.slides.length > 1 ? (d(), h("div", q_, [
          (d(!0), h(Y, null, ee(e.slides, (p, T) => (d(), h("div", {
            key: p.url
          }, [
            c("button", {
              class: "square",
              style: j({
                "background-color": e.activeImageIdx === T ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
              }),
              "aria-label": `Image ${T + 1}`,
              "aria-current": e.activeImageIdx === T ? "active" : null,
              onClick: (M) => e.jump(T),
              onKeydown: V(z((M) => e.jump(T), ["exact", "prevent"]), ["enter"])
            }, null, 44, Y_)
          ]))), 128))
        ])) : b("", !0),
        c("div", {
          class: v(["gradient", { "show-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }])
        }, [
          c("div", {
            class: v(["title", e.theme.style])
          }, [
            c("div", {
              style: j(`color: ${e.theme.heading_color.hex}`),
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 12, X_)
          ], 2),
          c("div", {
            class: v(["description", e.theme.style])
          }, [
            c("div", {
              style: j(`color: ${e.theme.text_color.hex}`),
              innerHTML: e.slides[e.activeImageIdx].content
            }, null, 12, Q_)
          ], 2)
        ], 2)
      ]),
      e.slides.length > 1 ? (d(), h("div", J_, [
        c("button", {
          class: "left-arrow button-action",
          "data-testid": "gallery-left-button",
          "aria-label": "Previous Image",
          onClick: t[12] || (t[12] = (...p) => e.moveBack && e.moveBack(...p)),
          onKeydown: t[13] || (t[13] = V(z((...p) => e.moveBack && e.moveBack(...p), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", eC, [
            L(u, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32),
        c("button", {
          class: "right-arrow button-action",
          "data-testid": "gallery-right-button",
          "aria-label": "Next Image",
          onClick: t[14] || (t[14] = (...p) => e.moveForward && e.moveForward(...p)),
          onKeydown: t[15] || (t[15] = V(z((...p) => e.moveForward && e.moveForward(...p), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", tC, [
            L(m, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)
      ])) : b("", !0)
    ], 4)
  ], 4);
}
const oC = /* @__PURE__ */ O(H_, [["render", nC], ["__scopeId", "data-v-b8acb151"]]), rC = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, iC = {
  class: "pause_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sC = ["fill"], aC = ["fill"];
function lC(e, t, n, o, i, r) {
  return d(), h("svg", iC, [
    c("rect", {
      class: "icon-background",
      width: "40",
      height: "40",
      fill: n.buttonBgColor.hex
    }, null, 8, sC),
    c("path", {
      class: "icon-button",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 14H16V26H19V14ZM24 14H21V26H24V14Z",
      fill: n.buttonIconColor.hex
    }, null, 8, aC)
  ]);
}
const uC = /* @__PURE__ */ O(rC, [["render", lC]]), dC = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, cC = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hC = ["fill"], mC = ["fill"];
function pC(e, t, n, o, i, r) {
  return d(), h("svg", cC, [
    c("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, hC),
    c("path", {
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, mC)
  ]);
}
const fC = /* @__PURE__ */ O(dC, [["render", pC]]), gC = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, vC = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bC = ["fill"], yC = ["fill"];
function _C(e, t, n, o, i, r) {
  return d(), h("svg", vC, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M-0.00012207 0H63.9999V62.9999H-0.00012207V0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, bC),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.7803 31.209L37.1333 43.8414L35.7324 45.265L21.9999 31.2222L35.9117 17L37.2991 18.4104L24.7803 31.209Z",
      fill: n.buttonIconColor.hex
    }, null, 8, yC)
  ]);
}
const CC = /* @__PURE__ */ O(gC, [["render", _C]]), wC = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, TC = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kC = ["fill"], EC = ["fill"];
function SC(e, t, n, o, i, r) {
  return d(), h("svg", TC, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 0H63.9999V62.9999H0V0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, kC),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.5191 31.209L26.1659 43.8414L27.5668 45.265L41.2995 31.2222L27.3874 17L26 18.4104L38.5191 31.209Z",
      fill: n.buttonIconColor.hex
    }, null, 8, EC)
  ]);
}
const MC = /* @__PURE__ */ O(wC, [["render", SC]]), AC = {
  name: "G4",
  components: {
    ResponsiveImage: Po,
    PauseSvg: uC,
    PlaySvg: fC,
    ReverseSvg: CC,
    AdvanceSvg: MC
  },
  mixins: [On]
}, $C = { class: "image-and-nav" }, IC = { class: "image-wrapper" }, DC = {
  key: 0,
  class: "position-and-play"
}, LC = { class: "button-action-content" }, OC = { class: "button-action-content" }, NC = { class: "position" }, PC = ["aria-current", "aria-label", "onClick", "onKeydown"], HC = {
  key: 0,
  class: "navigation"
}, FC = { class: "arrows" }, RC = { class: "button-action-content" }, BC = { class: "button-action-content" }, VC = { class: "text" }, jC = ["innerHTML"], UC = ["innerHTML"];
function GC(e, t, n, o, i, r) {
  const a = $("PlaySvg"), s = $("PauseSvg"), l = $("responsive-image"), u = $("ReverseSvg"), m = $("AdvanceSvg"), g = Ve("touch");
  return d(), h("div", {
    id: "g4",
    style: j([e.linkStyle, e.imageHeight])
  }, [
    c("div", {
      class: "slide",
      style: j(`background: ${e.theme.bg_color.hex}`)
    }, [
      c("div", $C, [
        c("div", IC, [
          e.slides.length > 1 ? (d(), h("div", DC, [
            e.playSlideshow ? (d(), h("button", {
              key: 1,
              "aria-label": "Pause Gallery",
              "data-testid": "pause-button",
              class: "pause button-action",
              onClick: t[2] || (t[2] = (...p) => e.togglePlay && e.togglePlay(...p)),
              onKeydown: t[3] || (t[3] = V(z((...p) => e.togglePlay && e.togglePlay(...p), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", OC, [
                L(s, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)) : (d(), h("button", {
              key: 0,
              "aria-label": "Play Gallery",
              "data-testid": "play-button",
              class: "play button-action",
              onClick: t[0] || (t[0] = (...p) => e.togglePlay && e.togglePlay(...p)),
              onKeydown: t[1] || (t[1] = V(z((...p) => e.togglePlay && e.togglePlay(...p), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", LC, [
                L(a, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)),
            c("div", NC, [
              (d(!0), h(Y, null, ee(e.slides, (p, T) => (d(), h("div", {
                key: p.url
              }, [
                c("button", {
                  class: v(["square", { active: e.activeImageIdx === T }]),
                  style: j({
                    "background-color": e.activeImageIdx === T ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
                  }),
                  "aria-current": e.activeImageIdx === T ? "active" : null,
                  "aria-label": `Image ${T + 1}`,
                  "data-testid": "gallery-pager-button",
                  onClick: (M) => e.jump(T),
                  onKeydown: V(z((M) => e.jump(T), ["exact", "prevent"]), ["enter"])
                }, null, 46, PC)
              ]))), 128))
            ])
          ])) : b("", !0),
          ge((d(), k(Ln, {
            tag: "div",
            class: "img-slider",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: _(() => [
              (d(), k(l, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              g,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              g,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ]),
        e.slides.length > 1 ? (d(), h("div", HC, [
          c("div", FC, [
            c("button", {
              class: "left-arrow button-action",
              "data-testid": "gallery-left-button",
              "aria-label": "Previous Image",
              onClick: t[4] || (t[4] = (...p) => e.moveBack && e.moveBack(...p)),
              onKeydown: t[5] || (t[5] = V(z((...p) => e.moveBack && e.moveBack(...p), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", RC, [
                L(u, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32),
            c("button", {
              class: "right-arrow button-action",
              "data-testid": "gallery-right-button",
              "aria-label": "Next Image",
              onClick: t[6] || (t[6] = (...p) => e.moveForward && e.moveForward(...p)),
              onKeydown: t[7] || (t[7] = V(z((...p) => e.moveForward && e.moveForward(...p), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", BC, [
                L(m, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)
          ])
        ])) : b("", !0)
      ]),
      c("div", VC, [
        c("div", {
          class: v(["title", e.theme.style])
        }, [
          c("div", {
            ref: "title",
            style: j(`color: ${e.theme.heading_color.hex}`),
            "data-testid": "gallery-title",
            innerHTML: e.slides[0].title
          }, null, 12, jC)
        ], 2),
        c("div", {
          class: v(["description", e.theme.style])
        }, [
          c("div", {
            style: j(`color: ${e.theme.text_color.hex}`),
            innerHTML: e.slides[0].content
          }, null, 12, UC)
        ], 2)
      ])
    ], 4)
  ], 4);
}
const zC = /* @__PURE__ */ O(AC, [["render", GC], ["__scopeId", "data-v-958685b9"]]), KC = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, ZC = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, xC = ["fill"], WC = ["fill"];
function qC(e, t, n, o, i, r) {
  return d(), h("svg", ZC, [
    c("path", {
      fill: n.buttonBgColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.0700684 0.910156L66.2576 0.910156L66.2576 65.0005L0.0700684 65.0005L0.0700684 0.910156Z"
    }, null, 8, xC),
    c("path", {
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25.9246 32.9568L38.3347 20.4391L36.7834 18.937L22.822 32.9997L36.7834 46.9766L38.3347 45.4744L25.9246 32.9568Z"
    }, null, 8, WC)
  ]);
}
const YC = /* @__PURE__ */ O(KC, [["render", qC]]), XC = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, QC = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, JC = ["fill"], ew = ["stroke"];
function tw(e, t, n, o, i, r) {
  return d(), h("svg", QC, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.88353 22.6238L8.11814 22.8624L7.57617 23.4133L19.2807 35.3118L20.6718 33.899L10.9346 23.9994H38.3765V21.9993H11.2035L20.6718 12.373L19.3191 10.998L7.88353 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, JC),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, ew)
  ]);
}
const nw = /* @__PURE__ */ O(XC, [["render", tw]]), ow = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, rw = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, iw = ["fill"], sw = ["stroke"];
function aw(e, t, n, o, i, r) {
  return d(), h("svg", rw, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.361 22.6238L38.1264 22.8624L38.6684 23.4133L26.9641 35.3118L25.5731 33.899L35.3101 23.9994H7.86816V21.9993H35.0411L25.5731 12.373L26.9257 10.998L38.361 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, iw),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, sw)
  ]);
}
const lw = /* @__PURE__ */ O(ow, [["render", aw]]), uw = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, dw = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cw = ["fill"], hw = ["fill"];
function mw(e, t, n, o, i, r) {
  return d(), h("svg", dw, [
    c("path", {
      fill: n.buttonBgColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M66.6326 65L0.445007 65L0.445013 0.909601L66.6326 0.909607L66.6326 65Z"
    }, null, 8, cw),
    c("path", {
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M40.7781 32.9534L28.3679 45.471L29.9192 46.9731L43.8806 32.9105L29.9192 18.9336L28.3679 20.4357L40.7781 32.9534Z"
    }, null, 8, hw)
  ]);
}
const pw = /* @__PURE__ */ O(uw, [["render", mw]]), fw = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, gw = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vw = ["stroke"], bw = ["fill"], yw = ["fill"];
function _w(e, t, n, o, i, r) {
  return d(), h("svg", gw, [
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, vw),
    n.paused ? (d(), h("path", {
      key: 0,
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, bw)) : (d(), h("path", {
      key: 1,
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, null, 8, yw))
  ]);
}
const Cw = /* @__PURE__ */ O(fw, [["render", _w]]), ww = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, Tw = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kw = ["fill"], Ew = ["fill"], Sw = ["fill"];
function Mw(e, t, n, o, i, r) {
  return d(), h("svg", Tw, [
    c("rect", {
      fill: n.buttonBgColor.hex,
      x: "0.257568",
      y: "0.910156",
      width: "66.1876",
      height: "64.0904"
    }, null, 8, kw),
    n.paused ? (d(), h("path", {
      key: 0,
      fill: n.buttonIconColor.hex,
      d: "M29.2146 44.9734L41.6248 32.9564L29.2146 20.9395V44.9734Z"
    }, null, 8, Ew)) : (d(), h("path", {
      key: 1,
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31 20H25V44H31V20ZM41 20H35V44H41V20Z"
    }, null, 8, Sw))
  ]);
}
const Aw = /* @__PURE__ */ O(ww, [["render", Mw]]), $w = {
  name: "G5Buttons",
  components: { ReverseASvg: nw, ReverseBSvg: YC, AdvanceASvg: lw, AdvanceBSvg: pw, PlayPauseASvg: Cw, PlayPauseBSvg: Aw },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    activeImageIdx: {
      type: Number,
      default: 0
    },
    pagerNumber: {
      type: Number,
      default: 0
    },
    hidePager: Boolean,
    playSlideshow: Boolean,
    onlyPlayButton: Boolean,
    smallPager: Boolean,
    isEditing: Boolean
  },
  computed: {
    cssVars() {
      var e, t, n, o;
      return {
        "--gallery-button-color": ((e = this.theme.button_icon_color) == null ? void 0 : e.hex) || "#FFFFFF",
        "--gallery-button-bg-color": ((t = this.theme.button_bg_color) == null ? void 0 : t.hex) || "#333333",
        "--gallery-pager-color": ((n = this.theme.pager_color) == null ? void 0 : n.hex) || "#333333",
        "--gallery-pager-active-color": ((o = this.theme.pager_active_color) == null ? void 0 : o.hex) || "#0000FF"
      };
    }
  }
}, Iw = { class: "gallery-buttons" }, Dw = ["aria-label", "data-testid", "disabled"], Lw = {
  key: 0,
  class: "gallery-pager"
}, Ow = ["aria-label", "aria-current", "onClick"], Nw = {
  key: 0,
  class: "pager-bottom"
}, Pw = {
  key: 1,
  class: "gallery-small-pager"
}, Hw = ["aria-label", "aria-current", "onClick"];
function Fw(e, t, n, o, i, r) {
  const a = $("PlayPauseASvg"), s = $("PlayPauseBSvg"), l = $("ReverseASvg"), u = $("ReverseBSvg"), m = $("AdvanceASvg"), g = $("AdvanceBSvg");
  return d(), h("div", {
    style: j(r.cssVars),
    class: v(["gallery-button-wrapper", `type-${n.theme.type}`])
  }, [
    c("div", Iw, [
      c("button", {
        style: { order: 2 },
        "aria-label": n.playSlideshow ? "Pause Gallery" : "Play Gallery",
        "data-testid": n.playSlideshow ? "pause-button" : "play-button ",
        class: v(["pause-play-button", { hasWidget: n.theme.cta_widget }]),
        disabled: n.isEditing,
        onClick: t[0] || (t[0] = (p) => e.$emit("togglePlay")),
        onKeydown: t[1] || (t[1] = V(z((p) => e.$emit("togglePlay"), ["exact", "prevent"]), ["enter"]))
      }, [
        n.theme.type === "A" ? (d(), k(a, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"])) : (d(), k(s, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"]))
      ], 42, Dw),
      n.onlyPlayButton ? b("", !0) : (d(), h("button", {
        key: 0,
        "aria-label": "Previous Image",
        "data-testid": "gallery-left-button",
        style: { order: 1 },
        onClick: t[2] || (t[2] = (p) => e.$emit("scrollLeft")),
        onKeydown: t[3] || (t[3] = V(z((p) => e.$emit("scrollLeft"), ["exact", "prevent"]), ["enter"]))
      }, [
        n.theme.type === "A" ? (d(), k(l, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])) : (d(), k(u, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"]))
      ], 32)),
      n.onlyPlayButton ? b("", !0) : (d(), h("button", {
        key: 1,
        "aria-label": "Next Image",
        "data-testid": "gallery-right-button",
        style: { order: 3 },
        onClick: t[4] || (t[4] = (p) => e.$emit("scrollRight")),
        onKeydown: t[5] || (t[5] = V(z((p) => e.$emit("scrollRight"), ["exact", "prevent"]), ["enter"]))
      }, [
        n.theme.type === "A" ? (d(), k(m, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])) : (d(), k(g, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"]))
      ], 32))
    ]),
    n.hidePager ? b("", !0) : (d(), h(Y, { key: 0 }, [
      n.pagerNumber && !n.smallPager ? (d(), h("div", Lw, [
        (d(!0), h(Y, null, ee(n.pagerNumber, (p, T) => (d(), h("button", {
          key: p,
          class: v({ active: n.activeImageIdx === T }),
          "aria-label": `Image ${T + 1}`,
          "aria-current": n.activeImageIdx === T ? "active" : null,
          "data-testid": "gallery-pager-button",
          onClick: (M) => e.$emit("jumpTo", T)
        }, [
          c("span", null, y(p), 1),
          n.theme.type === "A" ? (d(), h("div", Nw)) : b("", !0)
        ], 10, Ow))), 128))
      ])) : (d(), h("div", Pw, [
        (d(!0), h(Y, null, ee(n.pagerNumber, (p, T) => (d(), h("button", {
          key: p,
          "aria-label": `Image ${T + 1}`,
          "aria-current": n.activeImageIdx === T,
          class: v([{ active: n.activeImageIdx === T }, "circle"]),
          "data-testid": "gallery-pager-button",
          onClick: (M) => e.$emit("jumpTo", T)
        }, null, 10, Hw))), 128))
      ]))
    ], 64))
  ], 6);
}
const Rw = /* @__PURE__ */ O($w, [["render", Fw], ["__scopeId", "data-v-099308b8"]]), Bw = {
  name: "G5",
  components: {
    ResponsiveImage: Po,
    G5Buttons: Rw
  },
  mixins: [On],
  props: {
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    cssVars() {
      return {
        "--gallery-heading-color": S(this.theme, "heading_color.hex", "#fff"),
        "--gallery-link-color": S(this.theme, "link_color.hex", "#fff"),
        "--gradient-color": `linear-gradient(0deg, ${this.theme.overlay_color.hex} 0%, rgba(19, 19, 19, 0) 71.87%)`
      };
    }
  }
}, Vw = { class: "slide-wrapper" }, jw = { class: "bottom-content gradient" }, Uw = ["innerHTML"], Gw = {
  key: 0,
  class: "navigation"
};
function zw(e, t, n, o, i, r) {
  const a = $("responsive-image"), s = $("G5Buttons"), l = Ve("touch");
  return d(), h("div", {
    id: "g5",
    "data-testid": "G5",
    class: v(`type-${e.theme.type}`),
    style: j([r.cssVars, e.imageHeight])
  }, [
    c("div", {
      class: "slide",
      style: j({ "background-color": e.theme.overlay_color.hex })
    }, [
      c("div", Vw, [
        w(e.$slots, "controls"),
        w(e.$slots, "image", {}, () => [
          ge((d(), k(Ln, {
            tag: "div",
            class: "image",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: _(() => [
              (d(), k(a, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              l,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              l,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ])
      ]),
      c("div", jw, [
        c("div", {
          class: v(["left-text", e.theme.style])
        }, [
          w(e.$slots, "title", {}, () => [
            c("div", {
              class: "title",
              "data-testid": "gallery-title",
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 8, Uw)
          ])
        ], 2),
        e.slides.length > 1 ? (d(), h("div", Gw, [
          L(s, {
            theme: e.theme,
            "pager-number": e.slides.length,
            "active-image-idx": e.activeImageIdx,
            "play-slideshow": e.playSlideshow,
            "is-editing": n.isEditing,
            "hide-pager": e.screenSize < 600,
            onJumpTo: e.handleJump,
            onScrollLeft: e.handleScrollLeft,
            onScrollRight: e.handleScrollRight,
            onTogglePlay: e.togglePlay
          }, null, 8, ["theme", "pager-number", "active-image-idx", "play-slideshow", "is-editing", "hide-pager", "onJumpTo", "onScrollLeft", "onScrollRight", "onTogglePlay"])
        ])) : b("", !0)
      ])
    ], 4)
  ], 6);
}
const Kw = /* @__PURE__ */ O(Bw, [["render", zw], ["__scopeId", "data-v-5e12fa68"]]), Zw = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, xw = ["fill"], Ww = ["stroke"];
function qw(e, t, n, o, i, r) {
  return d(), h("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: j({ backgroundColor: n.buttonBgColor.hex })
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.88353 22.6238L8.11814 22.8624L7.57617 23.4133L19.2807 35.3118L20.6718 33.899L10.9346 23.9994H38.3765V21.9993H11.2035L20.6718 12.373L19.3191 10.998L7.88353 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, xw),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, Ww)
  ], 4);
}
const Yw = /* @__PURE__ */ O(Zw, [["render", qw]]), Xw = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Qw = ["fill"], Jw = ["stroke"];
function eT(e, t, n, o, i, r) {
  return d(), h("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: j({ backgroundColor: n.buttonBgColor.hex })
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.361 22.6238L38.1264 22.8624L38.6684 23.4133L26.9641 35.3118L25.5731 33.899L35.3101 23.9994H7.86816V21.9993H35.0411L25.5731 12.373L26.9257 10.998L38.361 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Qw),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, Jw)
  ], 4);
}
const tT = /* @__PURE__ */ O(Xw, [["render", eT]]), nT = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, oT = ["stroke"], rT = ["fill"], iT = ["fill"];
function sT(e, t, n, o, i, r) {
  return d(), h("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: j({ backgroundColor: n.buttonBgColor.hex })
  }, [
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, oT),
    n.paused ? (d(), h("path", {
      key: 0,
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, rT)) : (d(), h("path", {
      key: 1,
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, null, 8, iT))
  ], 4);
}
const aT = /* @__PURE__ */ O(nT, [["render", sT]]), lT = {
  name: "G6Buttons",
  components: { ReverseSvg: Yw, AdvanceSvg: tT, PlayPauseSvg: aT },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    pagerNumber: {
      type: Number,
      default: 0
    },
    activeImageIdx: {
      type: Number,
      default: 0
    },
    hidePager: Boolean,
    playSlideshow: Boolean,
    isEditing: Boolean
  },
  computed: {
    cssVars() {
      return {
        "--gallery-button-color": S(this.theme, "button_icon_color.hex", "#FFFFFF"),
        "--gallery-button-bg-color": S(this.theme, "button_bg_color.hex", "#333333"),
        "--gallery-pager-color": S(this.theme, "pager_color.hex", "#333333"),
        "--gallery-pager-active-color": S(this.theme, "pager_active_color.hex", "#0000FF")
      };
    }
  }
}, uT = ["aria-label", "data-testid", "disabled"], dT = {
  key: 0,
  class: "gallery-pager"
}, cT = ["aria-label", "aria-current", "onClick"];
function hT(e, t, n, o, i, r) {
  const a = $("PlayPauseSvg"), s = $("ReverseSvg"), l = $("AdvanceSvg");
  return d(), h("div", {
    style: j(r.cssVars),
    class: v(["gallery-button-wrapper"])
  }, [
    c("div", {
      class: v(["gallery-buttons", { hasWidget: n.theme.cta_widget }])
    }, [
      c("button", {
        style: { order: 2 },
        "aria-label": n.playSlideshow ? "Pause Gallery" : "Play Gallery",
        "data-testid": n.playSlideshow ? "pause-button" : "play-button ",
        class: "pause-play-button",
        disabled: n.isEditing,
        onClick: t[0] || (t[0] = (u) => e.$emit("togglePlay")),
        onKeydown: t[1] || (t[1] = V(z((u) => e.$emit("togglePlay"), ["exact", "prevent"]), ["enter"]))
      }, [
        L(a, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"])
      ], 40, uT),
      c("button", {
        "aria-label": "Previous Image",
        "data-testid": "gallery-left-button",
        style: { order: 1 },
        onClick: t[2] || (t[2] = (u) => e.$emit("scrollLeft")),
        onKeydown: t[3] || (t[3] = V(z((u) => e.$emit("scrollLeft"), ["exact", "prevent"]), ["enter"]))
      }, [
        L(s, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])
      ], 32),
      c("button", {
        "aria-label": "Next Image",
        "data-testid": "gallery-right-button",
        style: { order: 3 },
        onClick: t[4] || (t[4] = (u) => e.$emit("scrollRight")),
        onKeydown: t[5] || (t[5] = V(z((u) => e.$emit("scrollRight"), ["exact", "prevent"]), ["enter"]))
      }, [
        L(l, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])
      ], 32)
    ], 2),
    n.hidePager ? b("", !0) : (d(), h("div", dT, [
      (d(!0), h(Y, null, ee(n.pagerNumber, (u, m) => (d(), h("button", {
        key: u,
        class: v({ active: n.activeImageIdx === m }),
        "aria-label": `Image ${m + 1}`,
        "aria-current": n.activeImageIdx === m ? "active" : null,
        "data-testid": "gallery-pager-button",
        onClick: (g) => e.$emit("jumpTo", m)
      }, [
        c("span", null, y(u), 1),
        t[6] || (t[6] = c("div", { class: "pager-bottom" }, null, -1))
      ], 10, cT))), 128))
    ]))
  ], 4);
}
const mT = /* @__PURE__ */ O(lT, [["render", hT], ["__scopeId", "data-v-b6c5f932"]]), pT = {
  name: "G6",
  components: {
    ResponsiveImage: Po,
    G6Buttons: mT
  },
  mixins: [On],
  props: {
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    displayWidget() {
      return this.theme.cta_widget && (!An(this.widget) || this.isEditing);
    },
    cssVars() {
      var e, t;
      return {
        "--gallery-heading-color": S(this.theme, "heading_color.hex", "#fff"),
        "--gallery-link-color": S(this.theme, "link_color.hex", "#fff"),
        "--gradient-color": `radial-gradient( ${(t = (e = this.theme) == null ? void 0 : e.overlay_color) == null ? void 0 : t.hex}, rgba(255, 255, 255, 0) 75%)`,
        "--widget-line-color": S(this.theme, "widget_line_color.hex", "#B9770E"),
        "--widget-background-color": S(this.theme, "widget_background_color.hex", "#fff"),
        "--widget-text-color": S(this.theme, "widget_text_color.hex", "#000000"),
        "--widget-button-icon-color": S(this.theme, "widget_button_icon_color.hex", "#fff"),
        "--widget-button-background-color": S(this.theme, "widget_button_background_color.hex", "#B9770E")
      };
    },
    widgetLinkName() {
      var e, t;
      return (t = (e = this.widget) == null ? void 0 : e.link) != null && t.name ? this.widget.link.name : this.widgetLinkHref;
    },
    widgetBody() {
      var e;
      return ((e = this.widget) == null ? void 0 : e.body) || "";
    },
    widgetLinkHref() {
      var e, t;
      return ((t = (e = this.widget) == null ? void 0 : e.link) == null ? void 0 : t.href) || "";
    },
    widgetLinkTarget() {
      var e, t;
      return ((t = (e = this.widget) == null ? void 0 : e.link) == null ? void 0 : t.target) || "_blank";
    }
  }
}, fT = { class: "slide" }, gT = ["innerHTML"], vT = {
  key: 0,
  class: "main-content-button"
}, bT = { class: "slide-wrapper" }, yT = {
  key: 0,
  class: "widget",
  "data-testid": "cta-widget"
}, _T = ["innerHTML"];
function CT(e, t, n, o, i, r) {
  const a = $("G6Buttons"), s = $("responsive-image"), l = Ve("touch");
  return d(), h("div", {
    class: "g6",
    "data-testid": "G6",
    style: j([r.cssVars, e.imageHeight, e.bgColor])
  }, [
    c("div", fT, [
      c("div", {
        class: v(["main-content", { "has-widget": e.theme.cta_widget }])
      }, [
        c("div", {
          class: v([
            e.slides[e.activeImageIdx].title ? "main-content-title" : "main-content-title-empty",
            "left-text",
            e.theme.style
          ])
        }, [
          w(e.$slots, "title", {}, () => [
            c("div", {
              class: "title",
              "data-testid": "gallery-title",
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 8, gT)
          ])
        ], 2),
        e.slides.length > 1 ? (d(), h("div", vT, [
          L(a, {
            theme: e.theme,
            "pager-number": e.slides.length,
            "active-image-idx": e.activeImageIdx,
            "hide-pager": e.screenSize < 600,
            "play-slideshow": e.playSlideshow,
            "is-editing": n.isEditing,
            onJumpTo: e.handleJump,
            onScrollLeft: e.handleScrollLeft,
            onScrollRight: e.handleScrollRight,
            onTogglePlay: e.togglePlay
          }, null, 8, ["theme", "pager-number", "active-image-idx", "hide-pager", "play-slideshow", "is-editing", "onJumpTo", "onScrollLeft", "onScrollRight", "onTogglePlay"])
        ])) : b("", !0)
      ], 2),
      c("div", bT, [
        r.displayWidget ? (d(), h("div", yT, [
          w(e.$slots, "widget", {}, () => [
            c("div", {
              class: v(["widget-body", e.theme.style]),
              "data-testid": "cta-widget-body",
              innerHTML: r.widgetBody
            }, null, 10, _T)
          ]),
          (d(), k(K(n.isEditing ? "button" : "a"), {
            class: "widget-button",
            "aria-label": r.widgetLinkName,
            href: r.widgetLinkHref,
            target: r.widgetLinkTarget,
            "data-testid": "cta-widget-button",
            onClick: t[0] || (t[0] = (u) => e.$emit("openLinkModal"))
          }, {
            default: _(() => t[1] || (t[1] = [
              c("svg", {
                width: "15",
                height: "12",
                viewBox: "0 0 15 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                c("path", {
                  d: "M14 6H1M14 6L9.21053 1M14 6L9.21053 11",
                  stroke: "var(--widget-button-icon-color)",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ])),
            _: 1
          }, 8, ["aria-label", "href", "target"]))
        ])) : b("", !0),
        t[2] || (t[2] = c("div", { class: "gallery-decoration" }, [
          c("div", { class: "gallery-decoration-left" }),
          c("div", { class: "gallery-decoration-right" })
        ], -1)),
        w(e.$slots, "controls"),
        w(e.$slots, "image", {}, () => [
          ge((d(), k(Ln, {
            tag: "div",
            class: "image",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: _(() => [
              (d(), k(s, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              l,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              l,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ])
      ])
    ])
  ], 4);
}
const wT = /* @__PURE__ */ O(pT, [["render", CT], ["__scopeId", "data-v-c1112145"]]), TT = {
  name: "PauseSvg",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, kT = {
  viewBox: "0 0 64 64",
  "aria-hidden": "true"
}, ET = { id: "Layer_1" }, ST = ["fill"], MT = ["fill"];
function AT(e, t, n, o, i, r) {
  return d(), h("svg", kT, [
    c("g", null, [
      c("g", ET, [
        c("g", null, [
          c("rect", {
            x: "26",
            y: "24",
            width: "3",
            height: "16",
            fill: n.buttonIconColor.hex
          }, null, 8, ST),
          c("rect", {
            x: "34",
            y: "24",
            width: "3",
            height: "16",
            fill: n.buttonIconColor.hex
          }, null, 8, MT)
        ])
      ])
    ])
  ]);
}
const $T = /* @__PURE__ */ O(TT, [["render", AT]]), IT = {
  name: "PlaySVG",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, DT = {
  viewBox: "0 0 64 64",
  "aria-hidden": "true"
}, LT = ["fill"];
function OT(e, t, n, o, i, r) {
  return d(), h("svg", DT, [
    c("g", null, [
      c("g", null, [
        c("path", {
          d: "M26,39.8l11-8-11-8v16Z",
          fill: n.buttonIconColor.hex
        }, null, 8, LT)
      ])
    ])
  ]);
}
const NT = /* @__PURE__ */ O(IT, [["render", OT]]), PT = {
  name: "ArrowSvg",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    },
    forward: {
      type: Boolean,
      default: !1
    }
  }
}, HT = {
  id: "Layer_11",
  "data-name": "Layer_1"
}, FT = ["fill"];
function RT(e, t, n, o, i, r) {
  return d(), h("svg", {
    id: "Layer_1",
    class: v({ forward: n.forward }),
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    version: "1.1",
    viewBox: "0 0 64 64",
    "aria-hidden": "true"
  }, [
    c("g", HT, [
      c("polygon", {
        fill: n.buttonIconColor.hex,
        points: "25.5 38.5 19 32 25.5 25.5 26.5 26.5 21.8 31.2 44 31.2 44 32.8 21.8 32.8 26.5 37.5 25.5 38.5"
      }, null, 8, FT)
    ])
  ], 2);
}
const BT = /* @__PURE__ */ O(PT, [["render", RT], ["__scopeId", "data-v-ccc04a6e"]]), VT = {
  name: "G7",
  components: {
    PauseSvg: $T,
    PlaySvg: NT,
    ArrowSvg: BT,
    ResponsiveImage: Po
  },
  mixins: [On],
  props: {
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["openLinkModal"],
  data() {
    return {
      headerHeight: 0
    };
  },
  computed: {
    titleText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.title) || "";
    },
    descriptionText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.content) || "";
    },
    link() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.href) || "";
    },
    linkName() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.name) || "";
    },
    linkTarget() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.target) || "";
    },
    arrowsVisible() {
      return this.slides.length > 1 && !this.theme.hasFloatingNav;
    },
    videoAltText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[0]) == null ? void 0 : t.alt_text) || "";
    },
    videoUrl() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[0]) == null ? void 0 : t.url) || "";
    },
    isPlaying() {
      return this.theme.use_video ? this.playVideo : this.playSlideshow;
    },
    displayButton() {
      return this.theme.use_video || !this.theme.use_video && this.slides.length > 1;
    },
    colors() {
      var e, t, n, o, i, r, a, s, l, u, m, g, p, T, M, C, E, P, F, D, H, B, U, x, Z, q, ue, me;
      return {
        "--image-height": `calc(100vh - ${this.headerHeight}px)`,
        "--image-brightness": `${(t = (e = this.theme) == null ? void 0 : e.image_brightness) != null ? t : 60}%`,
        "--bg-color": ((o = (n = this.theme) == null ? void 0 : n.bg_color) == null ? void 0 : o.hex) || "",
        "--heading-color": ((r = (i = this.theme) == null ? void 0 : i.heading_color) == null ? void 0 : r.hex) || "",
        "--text-color": ((s = (a = this.theme) == null ? void 0 : a.text_color) == null ? void 0 : s.hex) || "",
        "--button-text-color": ((u = (l = this.theme) == null ? void 0 : l.widget_button_text_color) == null ? void 0 : u.hex) || "",
        "--button-bg-color": ((g = (m = this.theme) == null ? void 0 : m.widget_button_background_color) == null ? void 0 : g.hex) || "",
        "--button-bg-hover-color": ((T = (p = this.theme) == null ? void 0 : p.widget_button_background_hover_color) == null ? void 0 : T.hex) || "",
        "--pager-border-color": ((C = (M = this.theme) == null ? void 0 : M.pager_border_color) == null ? void 0 : C.hex) || "",
        "--pager-active-color": ((P = (E = this.theme) == null ? void 0 : E.pager_active_color) == null ? void 0 : P.hex) || "",
        "--play-pause-border-color": ((D = (F = this.theme) == null ? void 0 : F.button_border_color) == null ? void 0 : D.hex) || "",
        "--play-pause-border-hover-color": ((B = (H = this.theme) == null ? void 0 : H.button_border_hover_color) == null ? void 0 : B.hex) || "",
        "--play-pause-icon-color": ((x = (U = this.theme) == null ? void 0 : U.button_icon_color) == null ? void 0 : x.hex) || "",
        "--play-pause-icon-hover-color": ((q = (Z = this.theme) == null ? void 0 : Z.button_icon_hover_color) == null ? void 0 : q.hex) || "",
        "--play-pause-hover-color": ((me = (ue = this.theme) == null ? void 0 : ue.button_hover_color) == null ? void 0 : me.hex) || ""
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isPreview || this.isEditing) return;
      const e = document.getElementById("cms-header");
      if (!e) return;
      window.getComputedStyle(e).position !== "absolute" && (this.headerHeight = e.offsetHeight);
    });
  },
  methods: {
    handleClick() {
      if (!this.isPreview) {
        if (this.isEditing) {
          this.$emit("openLinkModal");
          return;
        }
        this.link && window.open(this.link, this.linkTarget || "_self");
      }
    }
  }
}, jT = {
  ref: "galleryContainer",
  class: "gallery-container"
}, UT = {
  key: 1,
  class: "video-wrapper"
}, GT = ["aria-label", "src"], zT = { class: "gallery-content" }, KT = ["innerHTML"], ZT = ["innerHTML"], xT = {
  key: 2,
  ref: "link",
  class: "button-link"
}, WT = ["aria-label"], qT = {
  key: 0,
  class: "gallery-controls"
}, YT = {
  key: 2,
  class: "pager"
}, XT = ["aria-current", "aria-label", "onClick"];
function QT(e, t, n, o, i, r) {
  const a = $("responsive-image"), s = $("PauseSvg"), l = $("PlaySvg"), u = $("ArrowSvg"), m = Ve("touch");
  return d(), h("div", {
    id: "G7",
    class: v(["gallery-v7", { "is-editing": n.isEditing }]),
    style: j([e.linkStyle, r.colors])
  }, [
    c("div", jT, [
      w(e.$slots, "controls", {}, void 0, !0),
      w(e.$slots, "image", {}, () => [
        e.theme.use_video ? b("", !0) : ge((d(), k(Ln, {
          key: 0,
          class: "image-wrapper",
          tag: "div",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: _(() => [
            (d(), k(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx]
            }, null, 8, ["idx", "image"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            m,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            m,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.theme.use_video ? (d(), h("div", UT, [
          c("video", {
            ref: "videoPlayer",
            "aria-label": r.videoAltText,
            src: r.videoUrl,
            class: "video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            "data-testid": "gallery-video"
          }, " Your browser does not support videos. ", 8, GT)
        ])) : b("", !0)
      ], !0),
      c("div", zT, [
        r.titleText || n.isEditing ? (d(), h("div", {
          key: 0,
          class: v(["title", e.theme.style]),
          "data-testid": "gallery-title"
        }, [
          w(e.$slots, "title", {}, () => [
            c("div", {
              ref: "title",
              tabindex: "0",
              innerHTML: r.titleText
            }, null, 8, KT)
          ], !0)
        ], 2)) : b("", !0),
        r.descriptionText || n.isEditing ? (d(), h("div", {
          key: 1,
          class: v(["description", e.theme.style])
        }, [
          w(e.$slots, "description", {}, () => [
            c("div", {
              ref: "description",
              tabindex: "0",
              innerHTML: r.descriptionText
            }, null, 8, ZT)
          ], !0)
        ], 2)) : b("", !0),
        r.link || n.isEditing ? (d(), h("div", xT, [
          c("button", {
            type: "button",
            "aria-label": `Link to ${r.linkName}`,
            onClick: t[0] || (t[0] = (...g) => r.handleClick && r.handleClick(...g))
          }, [
            w(e.$slots, "link", {}, () => [
              A(y(r.linkName), 1)
            ], !0)
          ], 8, WT)
        ], 512)) : b("", !0)
      ]),
      n.isEditing ? b("", !0) : (d(), h("div", qT, [
        r.displayButton ? (d(), h("button", {
          key: 0,
          "aria-label": "Play Pause Gallery",
          "data-testid": "pause-button",
          class: "pause button",
          onClick: t[1] || (t[1] = (g) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay())
        }, [
          r.isPlaying ? (d(), k(s, {
            key: 0,
            "button-icon-color": e.theme.button_icon_color
          }, null, 8, ["button-icon-color"])) : (d(), k(l, {
            key: 1,
            "button-icon-color": e.theme.button_icon_color
          }, null, 8, ["button-icon-color"]))
        ])) : b("", !0),
        r.arrowsVisible ? (d(), h("button", {
          key: 1,
          class: "left-arrow button",
          "data-testid": "gallery-left-button",
          "aria-label": "Previous Image",
          onClick: t[2] || (t[2] = (...g) => e.moveBack && e.moveBack(...g))
        }, [
          L(u, {
            "button-icon-color": e.theme.pager_arrow_color
          }, null, 8, ["button-icon-color"])
        ])) : b("", !0),
        e.slides.length > 1 ? (d(), h("div", YT, [
          (d(!0), h(Y, null, ee(e.slides, (g, p) => (d(), h("button", {
            key: g.url,
            class: v(["item", { active: e.activeImageIdx === p }]),
            "aria-current": e.activeImageIdx === p ? "active" : null,
            "aria-label": `Image ${p + 1}`,
            "data-testid": "gallery-pager-button",
            onClick: (T) => e.jump(p)
          }, null, 10, XT))), 128))
        ])) : b("", !0),
        r.arrowsVisible ? (d(), h("button", {
          key: 3,
          class: "right-arrow button",
          "data-testid": "gallery-right-button",
          "aria-label": "Next Image",
          onClick: t[3] || (t[3] = (...g) => e.moveForward && e.moveForward(...g))
        }, [
          L(u, {
            forward: "",
            "button-icon-color": e.theme.pager_arrow_color
          }, null, 8, ["button-icon-color"])
        ])) : b("", !0)
      ]))
    ], 512)
  ], 6);
}
const JT = /* @__PURE__ */ O(VT, [["render", QT], ["__scopeId", "data-v-aa32b36f"]]), ek = {
  name: "CmsGallery",
  components: {
    G1: Sy,
    G2: m_,
    G3: oC,
    G4: zC,
    G5: Kw,
    G6: wT,
    G7: JT
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    gallery: {
      type: Object,
      default: () => ({})
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    isEditing: Boolean
  },
  computed: {
    skipButtonText() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.skipButtonText) || "Skip Gallery";
    },
    galleryEndText() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.galleryEndText) || "End of Gallery";
    }
  },
  methods: {
    jumpTo(e) {
      this.$emit("jumpTo", e);
    },
    focusEnd() {
      this.$refs.galleryEnd.focus();
    }
  }
}, tk = { id: "cms-gallery" };
function nk(e, t, n, o, i, r) {
  return d(), h("div", tk, [
    c("button", {
      class: "skip-button",
      type: "button",
      tabindex: "0",
      onKeydown: t[0] || (t[0] = V(z((...a) => r.focusEnd && r.focusEnd(...a), ["exact", "prevent"]), ["enter"]))
    }, y(r.skipButtonText), 33),
    (d(), k(K(n.theme.version), {
      theme: n.theme,
      gallery: n.gallery,
      "is-preview": n.isPreview,
      "is-iframe": n.isIFrame,
      "is-editing": n.isEditing,
      onScrollLeft: t[1] || (t[1] = (a) => e.$emit("scrollLeft")),
      onScrollRight: t[2] || (t[2] = (a) => e.$emit("scrollRight")),
      onJumpTo: r.jumpTo,
      onOpenLinkModal: t[3] || (t[3] = (a) => e.$emit("openLinkModal"))
    }, {
      widget: _(({ widget: a }) => [
        w(e.$slots, "widget", { widget: a }, void 0, !0)
      ]),
      controls: _(({ controls: a }) => [
        w(e.$slots, "controls", { controls: a }, void 0, !0)
      ]),
      image: _(({ image: a }) => [
        w(e.$slots, "image", { image: a }, void 0, !0)
      ]),
      title: _(({ title: a }) => [
        w(e.$slots, "title", { title: a }, void 0, !0)
      ]),
      description: _(({ description: a }) => [
        w(e.$slots, "description", { description: a }, void 0, !0)
      ]),
      link: _(({ link: a }) => [
        w(e.$slots, "link", { link: a }, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "gallery", "is-preview", "is-iframe", "is-editing", "onJumpTo"])),
    c("div", {
      ref: "galleryEnd",
      class: "gallery-end",
      tabindex: "-1"
    }, y(r.galleryEndText), 513)
  ]);
}
const ok = /* @__PURE__ */ O(ek, [["render", nk], ["__scopeId", "data-v-6c54c528"]]), em = function() {
  return document.ontouchstart !== null ? "click" : "touchstart";
}, Os = "__vue_click_away__", tm = function(e, t, n) {
  nm(e);
  let o = n.context, i = t.value, r = !1;
  setTimeout(function() {
    r = !0;
  }, 0), e[Os] = function(a) {
    if ((!e || !e.contains(a.target)) && i && r && typeof i == "function")
      return i.call(o, a);
  }, document.addEventListener(em(), e[Os], !1);
}, nm = function(e) {
  document.removeEventListener(em(), e[Os], !1), delete e[Os];
}, rk = function(e, t, n) {
  t.value !== t.oldValue && tm(e, t, n);
}, ik = {
  mounted: tm,
  updated: rk,
  unmounted: nm
}, ht = {
  directives: {
    ClickAway: ik
  }
}, sk = {
  name: "HamburgerIcon",
  props: {
    themeStyle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    },
    fillPathColor: {
      type: String,
      default: "#fff"
    },
    rx: {
      type: [String, Number],
      default: null
    }
  }
}, ak = { "clip-path": "url(#clip0)" }, lk = ["fill", "rx"], uk = ["fill"];
function dk(e, t, n, o, i, r) {
  return d(), h("svg", {
    class: v(n.themeStyle),
    fill: "#fff",
    width: "23",
    height: "23",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, [
    c("g", ak, [
      c("rect", {
        fill: n.fillColor,
        rx: n.rx,
        width: "23",
        height: "23"
      }, null, 8, lk),
      c("path", {
        fill: n.fillPathColor,
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6.00195 7H17V8H6.00195V7ZM6.00195 11H17V12H6.00195V11ZM17 15H6.00195V16H17V15Z"
      }, null, 8, uk)
    ]),
    t[0] || (t[0] = c("defs", null, [
      c("clipPath", { id: "clip0" }, [
        c("rect", {
          width: "23",
          height: "23",
          fill: "#fff"
        })
      ])
    ], -1))
  ], 2);
}
const j1 = /* @__PURE__ */ O(sk, [["render", dk]]), ck = {
  name: "PlusIcon",
  props: {
    fillColor: {
      type: String,
      default: "#000"
    },
    fillPathColor: {
      type: String,
      default: "#fff"
    },
    rx: {
      type: [String, Number],
      default: null
    }
  }
}, hk = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, mk = ["fill", "rx"], pk = ["fill"], fk = ["fill"];
function gk(e, t, n, o, i, r) {
  return d(), h("svg", hk, [
    c("rect", {
      fill: n.fillColor,
      rx: n.rx,
      width: "23",
      height: "23"
    }, null, 8, mk),
    c("path", {
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11 18L11 5L12 5L12 18L11 18Z"
    }, null, 8, pk),
    c("path", {
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 11L18 11L18 12L5 12L5 11Z"
    }, null, 8, fk)
  ]);
}
const U1 = /* @__PURE__ */ O(ck, [["render", gk]]), vk = {
  name: "MenuSearchIcon",
  props: {
    iconColor: {
      type: String,
      default: "#fff"
    }
  }
}, bk = ["fill"];
function yk(e, t, n, o, i, r) {
  return d(), h("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.iconColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    "data-cy": "search-icon"
  }, t[0] || (t[0] = [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.03661 17.8C13.362 17.8 16.8683 14.3078 16.8683 10C16.8683 5.69218 13.362 2.2 9.03661 2.2C4.71127 2.2 1.20488 5.69218 1.20488 10C1.20488 14.3078 4.71127 17.8 9.03661 17.8ZM9.03661 19C14.0274 19 18.0732 14.9706 18.0732 10C18.0732 5.02944 14.0274 1 9.03661 1C4.04583 1 0 5.02944 0 10C0 14.9706 4.04583 19 9.03661 19Z"
    }, null, -1),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.3011 24L15.1138 16.1179L15.8128 15.3968L24.0001 23.2789L23.3011 24Z"
    }, null, -1)
  ]), 8, bk);
}
const _k = /* @__PURE__ */ O(vk, [["render", yk]]), Ck = {
  props: {
    fillColor: {
      type: String,
      default: "#000"
    }
  }
}, wk = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Tk = ["fill"], kk = ["fill"];
function Ek(e, t, n, o, i, r) {
  return d(), h("svg", wk, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.9503 17.7175L11.5 19.1679V15.875H14.3893C13.996 16.5319 13.5163 17.1516 12.9503 17.7175ZM18.5666 15.875C17.1619 18.0508 14.8443 19.5819 12.1556 19.9265L13.6575 18.4247C14.4285 17.6536 15.0546 16.7924 15.5357 15.875H18.5666ZM19.125 14.875H15.9945C16.4244 13.7905 16.6666 12.6489 16.721 11.5H19.9863C19.9204 12.7035 19.6181 13.844 19.125 14.8758V14.875ZM11.5 11.5H15.7198C15.6593 12.6546 15.3892 13.8002 14.9094 14.875H11.5V11.5ZM11.5 10.5H15.7198C15.6593 9.34543 15.3892 8.19979 14.9094 7.125H11.5V10.5ZM19.9863 10.5H16.721C16.6666 9.35113 16.4244 8.20949 15.9945 7.125H19.125V7.12417C19.6181 8.15604 19.9204 9.29654 19.9863 10.5ZM18.5666 6.125H15.5357C15.0546 5.20762 14.4285 4.34646 13.6574 3.57538L12.1555 2.07349C14.8443 2.41811 17.1619 3.9492 18.5666 6.125ZM11.5 6.125H14.3892C13.996 5.46809 13.5163 4.84847 12.9503 4.28249L11.5 2.83217V6.125ZM10.5 19.1679V15.875H7.61071C8.00401 16.5319 8.48364 17.1515 9.04962 17.7175L10.5 19.1679ZM9.84439 19.9265C7.15566 19.5819 4.83807 18.0508 3.43337 15.875H6.46427C6.94536 16.7924 7.57144 17.6535 8.34252 18.4246L9.84439 19.9265ZM7.09055 14.875H10.5V11.5H6.28022C6.3407 12.6546 6.61081 13.8002 7.09055 14.875ZM5.27898 11.5C5.33341 12.6489 5.57557 13.7905 6.00545 14.875H2.875V14.8758C2.38189 13.844 2.07955 12.7035 2.01365 11.5H5.27898ZM6.28022 10.5H10.5V7.125H7.09055C6.61081 8.19979 6.3407 9.34543 6.28022 10.5ZM6.00545 7.125C5.57556 8.20949 5.33341 9.35113 5.27898 10.5H2.01365C2.07955 9.29654 2.38189 8.15604 2.875 7.12417V7.125H6.00545ZM7.61071 6.125H10.5V2.83211L9.04962 4.28248C8.48364 4.84846 8.004 5.46809 7.61071 6.125ZM9.84439 2.0735L8.34251 3.57538C7.57144 4.34646 6.94536 5.20762 6.46427 6.125H3.43337C4.83807 3.94922 7.15566 2.41814 9.84439 2.0735ZM11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
      fill: n.fillColor
    }, null, 8, Tk),
    c("path", {
      fill: n.fillColor,
      d: "M11.5 19.1679H11.35V19.53L11.6061 19.274L11.5 19.1679ZM11.5 15.875V15.725H11.35V15.875H11.5ZM14.3893 15.875L14.518 15.9521L14.6539 15.725H14.3893V15.875ZM12.1556 19.9265L12.0495 19.8204L11.7388 20.1311L12.1747 20.0753L12.1556 19.9265ZM18.5666 15.875L18.6926 15.9564L18.842 15.725H18.5666V15.875ZM15.5357 15.875V15.725H15.445L15.4029 15.8053L15.5357 15.875ZM15.9945 14.875L15.8551 14.8197L15.7737 15.025H15.9945V14.875ZM19.125 14.875H19.275V14.725H19.125V14.875ZM16.721 11.5V11.35H16.5779L16.5712 11.4929L16.721 11.5ZM19.9863 11.5L20.1361 11.5082L20.1448 11.35H19.9863V11.5ZM19.125 14.8758H18.975L19.2603 14.9405L19.125 14.8758ZM15.7198 11.5L15.8695 11.5078L15.8778 11.35H15.7198V11.5ZM11.5 11.5V11.35H11.35V11.5H11.5ZM14.9094 14.875V15.025H15.0067L15.0464 14.9361L14.9094 14.875ZM11.5 14.875H11.35V15.025H11.5V14.875ZM15.7198 10.5V10.65H15.8778L15.8695 10.4922L15.7198 10.5ZM11.5 10.5H11.35V10.65H11.5V10.5ZM14.9094 7.125L15.0464 7.06386L15.0067 6.975H14.9094V7.125ZM11.5 7.125V6.975H11.35V7.125H11.5ZM16.721 10.5L16.5712 10.5071L16.5779 10.65H16.721V10.5ZM19.9863 10.5V10.65H20.1448L20.1361 10.4918L19.9863 10.5ZM15.9945 7.125V6.975H15.7737L15.8551 7.18027L15.9945 7.125ZM19.125 7.125V7.275H19.275V7.125H19.125ZM19.125 7.12417L19.2603 7.0595L18.975 7.12417H19.125ZM15.5357 6.125L15.4028 6.19466L15.445 6.275H15.5357V6.125ZM18.5666 6.125V6.275H18.842L18.6926 6.04364L18.5666 6.125ZM13.6574 3.57538L13.5514 3.68144L13.6574 3.57538ZM12.1555 2.07349L12.1746 1.92471L11.7388 1.86885L12.0495 2.17956L12.1555 2.07349ZM14.3892 6.125V6.275H14.6539L14.5179 6.04795L14.3892 6.125ZM11.5 6.125H11.35V6.275H11.5V6.125ZM12.9503 4.28249L12.8443 4.38855L12.9503 4.28249ZM11.5 2.83217L11.6061 2.7261L11.35 2.47004V2.83217H11.5ZM10.5 15.875H10.65V15.725H10.5V15.875ZM10.5 19.1679L10.3939 19.274L10.65 19.53V19.1679H10.5ZM7.61071 15.875V15.725H7.34608L7.48202 15.9521L7.61071 15.875ZM9.04962 17.7175L9.15569 17.6115L9.04962 17.7175ZM9.84439 19.9265L9.82532 20.0753L10.2612 20.1311L9.95046 19.8204L9.84439 19.9265ZM3.43337 15.875V15.725H3.15798L3.30735 15.9564L3.43337 15.875ZM6.46427 15.875L6.59711 15.8053L6.55499 15.725H6.46427V15.875ZM8.34252 18.4246L8.44858 18.3186L8.34252 18.4246ZM7.09055 14.875L6.95358 14.9361L6.99324 15.025H7.09055V14.875ZM10.5 14.875V15.025H10.65V14.875H10.5ZM10.5 11.5H10.65V11.35H10.5V11.5ZM6.28022 11.5V11.35H6.12216L6.13043 11.5078L6.28022 11.5ZM5.27898 11.5L5.42881 11.4929L5.42204 11.35H5.27898V11.5ZM6.00545 14.875V15.025H6.22626L6.14489 14.8197L6.00545 14.875ZM2.875 14.875V14.725H2.725V14.875H2.875ZM2.875 14.8758L2.73966 14.9405L3.025 14.8758H2.875ZM2.01365 11.5V11.35H1.85522L1.86388 11.5082L2.01365 11.5ZM6.28022 10.5L6.13043 10.4922L6.12216 10.65H6.28022V10.5ZM10.5 10.5V10.65H10.65V10.5H10.5ZM10.5 7.125H10.65V6.975H10.5V7.125ZM7.09055 7.125V6.975H6.99324L6.95358 7.06386L7.09055 7.125ZM6.00545 7.125L6.14489 7.18027L6.22626 6.975H6.00545V7.125ZM5.27898 10.5V10.65H5.42204L5.42881 10.5071L5.27898 10.5ZM2.01365 10.5L1.86388 10.4918L1.85522 10.65H2.01365V10.5ZM2.875 7.12417H3.025L2.73966 7.05949L2.875 7.12417ZM2.875 7.125H2.725V7.275H2.875V7.125ZM7.61071 6.125L7.48201 6.04795L7.34608 6.275H7.61071V6.125ZM10.5 6.125V6.275H10.65V6.125H10.5ZM10.5 2.83211H10.65V2.46997L10.3939 2.72604L10.5 2.83211ZM9.04962 4.28248L8.94356 4.17642H8.94356L9.04962 4.28248ZM9.84439 2.0735L9.95046 2.17957L10.2612 1.86885L9.82532 1.92472L9.84439 2.0735ZM8.34251 3.57538L8.44858 3.68144L8.34251 3.57538ZM6.46427 6.125V6.275H6.55499L6.59711 6.19466L6.46427 6.125ZM3.43337 6.125L3.30735 6.04364L3.15798 6.275H3.43337V6.125ZM11.6061 19.274L13.0564 17.8236L12.8443 17.6115L11.3939 19.0618L11.6061 19.274ZM11.35 15.875V19.1679H11.65V15.875H11.35ZM14.3893 15.725H11.5V16.025H14.3893V15.725ZM13.0564 17.8236C13.6312 17.2488 14.1184 16.6194 14.518 15.9521L14.2606 15.7979C13.8736 16.4444 13.4015 17.0543 12.8443 17.6115L13.0564 17.8236ZM12.1747 20.0753C14.9087 19.7248 17.2648 18.1681 18.6926 15.9564L18.4406 15.7936C17.0591 17.9335 14.78 19.4389 12.1365 19.7777L12.1747 20.0753ZM13.5514 18.3186L12.0495 19.8204L12.2617 20.0326L13.7635 18.5307L13.5514 18.3186ZM15.4029 15.8053C14.9287 16.7095 14.3116 17.5583 13.5514 18.3186L13.7635 18.5307C14.5454 17.7488 15.1805 16.8753 15.6686 15.9447L15.4029 15.8053ZM18.5666 15.725H15.5357V16.025H18.5666V15.725ZM15.9945 15.025H19.125V14.725H15.9945V15.025ZM16.5712 11.4929C16.5175 12.6255 16.2788 13.7508 15.8551 14.8197L16.134 14.9303C16.57 13.8302 16.8156 12.6723 16.8708 11.5071L16.5712 11.4929ZM19.9863 11.35H16.721V11.65H19.9863V11.35ZM19.2603 14.9405C19.7617 13.8913 20.0691 12.7316 20.1361 11.5082L19.8366 11.4918C19.7718 12.6753 19.4745 13.7966 18.9897 14.8112L19.2603 14.9405ZM18.975 14.875V14.8758H19.275V14.875H18.975ZM15.7198 11.35H11.5V11.65H15.7198V11.35ZM15.0464 14.9361C15.5338 13.8443 15.8081 12.6805 15.8695 11.5078L15.57 11.4922C15.5104 12.6286 15.2446 13.7562 14.7725 14.8139L15.0464 14.9361ZM11.5 15.025H14.9094V14.725H11.5V15.025ZM11.35 11.5V14.875H11.65V11.5H11.35ZM15.7198 10.35H11.5V10.65H15.7198V10.35ZM14.7724 7.18614C15.2446 8.24383 15.5104 9.37137 15.57 10.5078L15.8695 10.4922C15.8081 9.31948 15.5338 8.15574 15.0464 7.06386L14.7724 7.18614ZM11.5 7.275H14.9094V6.975H11.5V7.275ZM11.65 10.5V7.125H11.35V10.5H11.65ZM16.721 10.65H19.9863V10.35H16.721V10.65ZM15.8551 7.18027C16.2788 8.24918 16.5175 9.37452 16.5712 10.5071L16.8708 10.4929C16.8156 9.32773 16.57 8.1698 16.134 7.06973L15.8551 7.18027ZM19.125 6.975H15.9945V7.275H19.125V6.975ZM18.975 7.12417V7.125H19.275V7.12417H18.975ZM20.1361 10.4918C20.0691 9.26836 19.7617 8.10871 19.2603 7.0595L18.9897 7.18885C19.4745 8.20338 19.7718 9.32472 19.8366 10.5082L20.1361 10.4918ZM15.5357 6.275H18.5666V5.975H15.5357V6.275ZM13.5514 3.68144C14.3116 4.44169 14.9287 5.29055 15.4028 6.19466L15.6685 6.05534C15.1805 5.1247 14.5454 4.25122 13.7635 3.46931L13.5514 3.68144ZM12.0495 2.17956L13.5514 3.68144L13.7635 3.46931L12.2616 1.96742L12.0495 2.17956ZM18.6926 6.04364C17.2647 3.83192 14.9086 2.27513 12.1746 1.92471L12.1365 2.22227C14.78 2.56109 17.0591 4.06648 18.4406 6.20636L18.6926 6.04364ZM14.3892 5.975H11.5V6.275H14.3892V5.975ZM12.8443 4.38855C13.4015 4.94576 13.8735 5.55562 14.2606 6.20205L14.5179 6.04795C14.1184 5.38056 13.6312 4.75118 13.0564 4.17642L12.8443 4.38855ZM11.3939 2.93823L12.8443 4.38855L13.0564 4.17642L11.6061 2.7261L11.3939 2.93823ZM11.65 6.125V2.83217H11.35V6.125H11.65ZM10.35 15.875V19.1679H10.65V15.875H10.35ZM7.61071 16.025H10.5V15.725H7.61071V16.025ZM9.15569 17.6115C8.59848 17.0542 8.12643 16.4444 7.73941 15.7979L7.48202 15.9521C7.88158 16.6194 8.3688 17.2488 8.94356 17.8236L9.15569 17.6115ZM10.6061 19.0618L9.15569 17.6115L8.94356 17.8236L10.3939 19.274L10.6061 19.0618ZM9.86346 19.7777C7.21998 19.4389 4.9409 17.9335 3.55939 15.7936L3.30735 15.9564C4.73524 18.1681 7.09133 19.7248 9.82532 20.0753L9.86346 19.7777ZM3.43337 16.025H6.46427V15.725H3.43337V16.025ZM6.33143 15.9447C6.81947 16.8753 7.45454 17.7488 8.23645 18.5307L8.44858 18.3186C7.68834 17.5583 7.07124 16.7094 6.59711 15.8053L6.33143 15.9447ZM8.23645 18.5307L9.73833 20.0326L9.95046 19.8204L8.44858 18.3186L8.23645 18.5307ZM7.09055 15.025H10.5V14.725H7.09055V15.025ZM10.65 14.875V11.5H10.35V14.875H10.65ZM10.5 11.35H6.28022V11.65H10.5V11.35ZM7.22753 14.8139C6.75542 13.7562 6.48955 12.6286 6.43002 11.4922L6.13043 11.5078C6.19185 12.6805 6.46621 13.8443 6.95358 14.9361L7.22753 14.8139ZM5.12914 11.5071C5.18435 12.6723 5.42994 13.8302 5.866 14.9303L6.14489 14.8197C5.72119 13.7508 5.48247 12.6255 5.42881 11.4929L5.12914 11.5071ZM2.875 15.025H6.00545V14.725H2.875V15.025ZM3.025 14.8758V14.875H2.725V14.8758H3.025ZM1.86388 11.5082C1.93087 12.7316 2.23826 13.8913 2.73966 14.9405L3.01034 14.8112C2.52552 13.7966 2.22823 12.6753 2.16343 11.4918L1.86388 11.5082ZM5.27898 11.35H2.01365V11.65H5.27898V11.35ZM6.28022 10.65H10.5V10.35H6.28022V10.65ZM10.65 10.5V7.125H10.35V10.5H10.65ZM10.5 6.975H7.09055V7.275H10.5V6.975ZM6.43002 10.5078C6.48955 9.37137 6.75542 8.24383 7.22753 7.18614L6.95358 7.06386C6.4662 8.15575 6.19185 9.31948 6.13043 10.4922L6.43002 10.5078ZM5.866 7.06973C5.42994 8.1698 5.18435 9.32773 5.12914 10.4929L5.42881 10.5071C5.48247 9.37452 5.72119 8.24918 6.14489 7.18027L5.866 7.06973ZM2.01365 10.65H5.27898V10.35H2.01365V10.65ZM2.73966 7.05949C2.23826 8.10871 1.93087 9.26836 1.86388 10.4918L2.16343 10.5082C2.22823 9.32472 2.52552 8.20337 3.01034 7.18885L2.73966 7.05949ZM3.025 7.125V7.12417H2.725V7.125H3.025ZM6.00545 6.975H2.875V7.275H6.00545V6.975ZM7.61071 6.275H10.5V5.975H7.61071V6.275ZM10.65 6.125V2.83211H10.35V6.125H10.65ZM9.15569 4.38855L10.6061 2.93817L10.3939 2.72604L8.94356 4.17642L9.15569 4.38855ZM7.73941 6.20205C8.12643 5.55562 8.59848 4.94576 9.15569 4.38855L8.94356 4.17642C8.3688 4.75117 7.88158 5.38056 7.48201 6.04795L7.73941 6.20205ZM9.73833 1.96743L8.23645 3.46931L8.44858 3.68144L9.95046 2.17957L9.73833 1.96743ZM8.23645 3.46931C7.45454 4.25122 6.81947 5.1247 6.33143 6.05534L6.59711 6.19466C7.07124 5.29055 7.68834 4.44169 8.44858 3.68144L8.23645 3.46931ZM3.43337 6.275H6.46427V5.975H3.43337V6.275ZM9.82532 1.92472C7.09133 2.27516 4.73524 3.83194 3.30735 6.04364L3.55939 6.20636C4.9409 4.0665 7.21998 2.56112 9.86346 2.22228L9.82532 1.92472ZM20.85 11C20.85 16.44 16.44 20.85 11 20.85V21.15C16.6057 21.15 21.15 16.6057 21.15 11H20.85ZM11 1.15C16.44 1.15 20.85 5.56 20.85 11H21.15C21.15 5.39431 16.6057 0.85 11 0.85V1.15ZM1.15 11C1.15 5.56 5.56 1.15 11 1.15V0.85C5.39431 0.85 0.85 5.39431 0.85 11H1.15ZM11 20.85C5.56 20.85 1.15 16.44 1.15 11H0.85C0.85 16.6057 5.39431 21.15 11 21.15V20.85Z"
    }, null, 8, kk)
  ]);
}
const Sk = /* @__PURE__ */ O(Ck, [["render", Ek], ["__scopeId", "data-v-ffbe6fac"]]), Mk = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    fillPathColor: {
      type: String,
      default: "#000"
    },
    dropdownClass: {
      type: String,
      default: "close"
    },
    circleBackground: {
      type: Boolean
    }
  }
}, Ak = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, $k = ["fill", "rx"], Ik = ["fill"];
function Dk(e, t, n, o, i, r) {
  return d(), h("svg", Ak, [
    c("rect", {
      fill: n.fillColor,
      rx: n.circleBackground ? 50 : 4,
      width: "23",
      height: "23"
    }, null, 8, $k),
    c("path", {
      class: v([n.dropdownClass, "arrow"]),
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.14645 8.14645C5.34171 7.95118 5.65829 7.95118 5.85355 8.14645L11.5 13.7929L17.1464 8.14645C17.3417 7.95118 17.6583 7.95118 17.8536 8.14645C18.0488 8.34171 18.0488 8.65829 17.8536 8.85355L11.8536 14.8536C11.6583 15.0488 11.3417 15.0488 11.1464 14.8536L5.14645 8.85355C4.95118 8.65829 4.95118 8.34171 5.14645 8.14645Z"
    }, null, 10, Ik)
  ]);
}
const Lk = /* @__PURE__ */ O(Mk, [["render", Dk], ["__scopeId", "data-v-964bccff"]]), Ok = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    dropdownClass: {
      type: String,
      default: "close"
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  }
}, Nk = ["fill"];
function Pk(e, t, n, o, i, r) {
  return d(), h("svg", {
    class: v({
      [n.dropdownClass]: !0,
      open: n.isOpen,
      close: !n.isOpen
    }),
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 14 11",
    fill: "none"
  }, [
    c("path", {
      d: "M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z",
      fill: n.fillColor
    }, null, 8, Nk)
  ], 2);
}
const om = /* @__PURE__ */ O(Ok, [["render", Pk], ["__scopeId", "data-v-174954e1"]]), Hk = {
  name: "SvgClose",
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, Fk = ["fill"], Rk = ["fill"], Bk = ["fill"];
function Vk(e, t, n, o, i, r) {
  return d(), h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.fillColor,
    "aria-label": "Close icon"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.439341 0.43934C1.02513 -0.146447 1.97488 -0.146447 2.56066 0.43934L23.5607 21.4393C24.1464 22.0251 24.1464 22.9749 23.5607 23.5607C22.9749 24.1464 22.0251 24.1464 21.4393 23.5607L0.439341 2.56066C-0.146445 1.97487 -0.146445 1.02513 0.439341 0.43934Z",
      fill: n.fillColor
    }, null, 8, Rk),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.5607 0.43934C24.1464 1.02513 24.1464 1.97487 23.5607 2.56066L2.56066 23.5607C1.97487 24.1464 1.02513 24.1464 0.43934 23.5607C-0.146447 22.9749 -0.146447 22.0251 0.43934 21.4393L21.4393 0.43934C22.0251 -0.146447 22.9749 -0.146447 23.5607 0.43934Z",
      fill: n.fillColor
    }, null, 8, Bk)
  ], 8, Fk);
}
const $i = /* @__PURE__ */ O(Hk, [["render", Vk]]), jk = {
  name: "MenuItem",
  components: {
    FilledDropdownArrow: Lk,
    HamburgerIcon: j1,
    PlusIcon: U1,
    SearchIcon: _k,
    LanguageIcon: Sk,
    TriangleIcon: om,
    Close: $i
  },
  props: {
    item: {
      type: String,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    },
    themeOverrides: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      required: !0
    },
    focusVisibleColor: {
      type: String,
      default: "#0000FF"
    },
    mobileTextColor: {
      type: String,
      default: "#0000FF"
    },
    isMobile: Boolean,
    dropdownOpen: Boolean,
    showText: {
      type: Boolean,
      default: !0
    },
    screenSize: {
      type: Number,
      default: 0
    }
  },
  emits: ["toggle-dropdown", "toggle-search"],
  computed: {
    showTitleTop() {
      return this.showText && ["schoolsbutton", "explore-button", "languagebutton"].includes(this.menuItem.id) || this.menuItem.id === "searchbutton" && ["H6", "H7", "H8"].includes(this.theme.version) && this.screenSize > 599;
    },
    showTitleBottom() {
      return this.showText && this.menuItem.id === "menubutton" && !this.isMobile || this.menuItem.id === "searchbutton";
    },
    focusColor() {
      return { "--focus-visible-color": this.focusVisibleColor };
    },
    menuItem() {
      const t = [
        this.menuButton,
        this.exploreButton,
        this.schoolsButton,
        this.languagesButton,
        this.searchButton,
        this.closeButton
      ].find((n) => n.id === this.item);
      return he(ie(ie({}, t), this.themeOverrides), {
        colors: ie(ie({}, t.colors), this.themeOverrides.colors)
      });
    },
    menuButton() {
      var e, t, n, o;
      return {
        id: "menubutton",
        class: ["menu", { "m4-menu": this.content.menuOptions.version === "M4" }, "button-action", this.theme.style],
        iconClass: this.theme.menu_icon,
        dataTestId: "menu-button",
        ariaExpanded: this.content.showMenu,
        ariaControls: this.content.showMenu ? "mainmenu" : null,
        ariaLabel: this.content.newMobileHeader && this.screenSize < 600 ? this.theme.translations.open_mobile_menu : null,
        translatedTitle: this.theme.translations.menu_dropdown_title || "Menu",
        icon: this.theme.menu_icon === "plus" ? "PlusIcon" : "HamburgerIcon",
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex,
          "--fill-path-color": (t = this.theme.navigation_icon_color) == null ? void 0 : t.hex,
          "--bg-color": (n = this.theme.bg_color) == null ? void 0 : n.hex,
          "--nav-color": (o = this.theme.navigation_color) == null ? void 0 : o.hex
        }
      };
    },
    exploreButton() {
      var e, t, n, o, i, r;
      return {
        id: "explore-button",
        ref: "explore-button",
        class: ["explore", "button-action", "menu", this.theme.style],
        dataTestId: "explore-button",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.dropdownOpen ? "explore-menu" : null,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.menu_dropdown_title) || ((t = this.theme.translations) == null ? void 0 : t.explore_dropdown_title) || "Explore",
        icon: "FilledDropdownArrow",
        colors: {
          "--fill-color": (n = this.theme.navigation_color) == null ? void 0 : n.hex,
          "--fill-path-color": (o = this.theme.navigation_icon_color) == null ? void 0 : o.hex,
          "--bg-color": (i = this.theme.bg_color) == null ? void 0 : i.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": (r = this.theme.navigation_color) == null ? void 0 : r.hex
        }
      };
    },
    schoolsButton() {
      var e, t, n, o;
      return {
        id: "schoolsbutton",
        ref: "schoolsbutton",
        class: ["schools", "button-action", "menu", this.theme.style],
        dataTestId: "schools-button",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.ariaControlsSchoolsMenu,
        icon: "FilledDropdownArrow",
        translatedTitle: this.content.orgDropdownTitle,
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex,
          "--fill-path-color": (t = this.theme.navigation_icon_color) == null ? void 0 : t.hex,
          "--bg-color": (n = this.theme.bg_color) == null ? void 0 : n.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": (o = this.theme.navigation_color) == null ? void 0 : o.hex
        }
      };
    },
    ariaControlsSchoolsMenu() {
      return this.dropdownOpen ? this.content.hasCustomSchoolsMenu ? "schools-menu-sm1" : "schoolsmenu" : null;
    },
    languagesButton() {
      var e, t, n, o, i, r;
      return {
        id: "languagebutton",
        class: ["languages", "button-action", "menu", this.theme.style],
        dataTestId: "language-button",
        menuItemType: "languagebutton",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.dropdownOpen ? "languagesmenu" : null,
        icon: this.isMobile && this.content.newMobileHeader || this.isMobile && this.theme.version === "H3" ? "LanguageIcon" : "FilledDropdownArrow",
        ariaLabel: this.theme.translations.translate_site,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.translate_dropdown_title) || ((n = (t = this.theme.translations) == null ? void 0 : t.header) == null ? void 0 : n.translate_dropdown_title) || "Translate",
        colors: {
          "--fill-color": this.languageButtonColor,
          "--fill-path-color": ((o = this.theme.navigation_icon_color) == null ? void 0 : o.hex) || "#FFFFFF",
          "--bg-color": (i = this.theme.bg_color) == null ? void 0 : i.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": ((r = this.theme.navigation_color) == null ? void 0 : r.hex) || "#0000FF"
        }
      };
    },
    languageButtonColor() {
      var e, t;
      return this.isMobile && this.theme.version === "H3" ? this.mobileTextColor : this.theme.version === "H2" ? (e = this.theme.navigation_icon_bg_color) == null ? void 0 : e.hex : (t = this.theme.navigation_color) == null ? void 0 : t.hex;
    },
    searchButton() {
      var e, t;
      return {
        id: "searchbutton",
        class: [
          "search",
          "focus-search-icon",
          "button-action",
          "menu",
          this.theme.style,
          { shrinkCSSClass: !this.isMobile || !this.content.newMobileHeader }
        ],
        dataTestId: this.searchTestIdByHeader,
        icon: "SearchIcon",
        translatedTitle: this.theme.translations.search_title || "Search Site",
        colors: {
          "--icon-color": this.isMobile ? this.mobileTextColor : (e = this.theme.search_icon_color) == null ? void 0 : e.hex,
          "--bg-color": (t = this.theme.bg_color) == null ? void 0 : t.hex
        }
      };
    },
    closeButton() {
      var e;
      return {
        id: "closebutton",
        class: ["menu", this.theme.style, "close-icon"],
        dataTestId: "close-button",
        icon: "Close",
        ariaLabel: this.content.newMobileHeader && this.screenSize < 600 ? this.theme.translations.close_mobile_menu : null,
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex
        }
      };
    },
    searchTestIdByHeader() {
      return this.theme.version === "H2" ? this.isMobile ? "small-utilities-search-button" : "large-utilities-search-button" : "search-button";
    }
  },
  methods: {
    itemAction(e) {
      e === "searchbutton" ? this.$emit("toggle-search") : this.$emit("toggle-dropdown", e);
    }
  }
}, Uk = ["id", "data-testid", "aria-expanded", "aria-controls", "aria-label"], Gk = { class: "button-action-content" };
function zk(e, t, n, o, i, r) {
  return d(), h("button", {
    id: r.menuItem.id,
    "data-testid": r.menuItem.dataTestId,
    "aria-haspopup": "true",
    "aria-expanded": r.menuItem.ariaExpanded,
    "aria-controls": r.menuItem.ariaControls,
    "aria-label": r.menuItem.ariaLabel,
    class: v(["menu-item", r.menuItem.class]),
    style: j(r.focusColor),
    onClick: t[0] || (t[0] = (a) => r.itemAction(r.menuItem.id))
  }, [
    c("span", Gk, [
      r.showTitleTop ? (d(), h("span", {
        key: 0,
        class: "menu-field",
        style: j({
          color: r.menuItem.colors["--nav-color"]
        })
      }, y(r.menuItem.translatedTitle), 5)) : b("", !0),
      (d(), k(K(r.menuItem.icon), {
        class: v(r.menuItem.iconClass),
        "theme-style": n.theme.style,
        "bg-color": r.menuItem.colors["--bg-color"] || null,
        "icon-color": r.menuItem.colors["--icon-color"] || null,
        rx: n.theme.style === "purple" ? "50" : "4",
        "fill-color": r.menuItem.colors["--fill-color"] || null,
        "fill-path-color": r.menuItem.colors["--fill-path-color"] || null,
        "fill-background": r.menuItem.colors["--fill-background"] || null,
        "circle-background": r.menuItem.colors["--circle-background"] || null,
        "dropdown-class": r.menuItem.colors["--dropdown-class"],
        "nav-color": r.menuItem.colors["--nav-color"]
      }, null, 8, ["class", "theme-style", "bg-color", "icon-color", "rx", "fill-color", "fill-path-color", "fill-background", "circle-background", "dropdown-class", "nav-color"])),
      r.showTitleBottom ? (d(), h("span", {
        key: 1,
        class: v(["menu-field", { "sr-only": r.menuItem.id === "searchbutton" && n.theme.version !== "H4" }])
      }, y(r.menuItem.translatedTitle), 3)) : b("", !0)
    ])
  ], 14, Uk);
}
const Nt = /* @__PURE__ */ O(jk, [["render", zk], ["__scopeId", "data-v-5573ec1c"]]), Kk = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    dropdownClass: {
      type: String,
      default: "close"
    }
  }
}, Zk = ["fill"];
function xk(e, t, n, o, i, r) {
  return d(), h("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    class: v(n.dropdownClass),
    "aria-hidden": "true"
  }, t[0] || (t[0] = [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.7144 9L11.5003 14.3919L5.28389 9L4 10.4956L11.5003 17L18.9997 10.4956L17.7144 9Z"
    }, null, -1)
  ]), 10, Zk);
}
const kr = /* @__PURE__ */ O(Kk, [["render", xk], ["__scopeId", "data-v-5678f690"]]), Wk = {
  name: "SchoolsMenuHeader",
  components: {
    DropdownArrowIcon: kr
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    isMobile: Boolean,
    isMobileActive: Boolean
  }
}, qk = ["tabindex"];
function Yk(e, t, n, o, i, r) {
  const a = $("DropdownArrowIcon");
  return d(), h("div", {
    class: v({ "mobile-cursor": n.isMobile }),
    style: j(`color: ${n.theme.schools_menu_text_color.hex}`),
    tabindex: n.isMobile ? "0" : "-1",
    onKeydown: [
      t[0] || (t[0] = V(z((s) => e.$emit("set-active-header"), ["exact", "prevent"]), ["enter"])),
      t[1] || (t[1] = V(z((s) => e.$emit("set-active-header"), ["exact", "prevent"]), ["space"])),
      t[2] || (t[2] = V(z((s) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[3] || (t[3] = V((s) => e.$emit("tab-action", s), ["tab"]))
    ]
  }, [
    c("h2", {
      class: v(["schools-menu-header", n.theme.style])
    }, y(n.item.name), 3),
    n.isMobile && n.item.children ? (d(), k(a, {
      key: 0,
      class: "schools-menu-arrow",
      "fill-color": `${n.theme.schools_menu_text_color.hex}`,
      "dropdown-class": n.isMobileActive ? "open" : "close"
    }, null, 8, ["fill-color", "dropdown-class"])) : b("", !0)
  ], 46, qk);
}
const Xk = /* @__PURE__ */ O(Wk, [["render", Yk], ["__scopeId", "data-v-0ee6ab64"]]), Qk = "sites.thrillshare.com", Jk = "sites.thrillshare.ca", eE = "develop.thrillshare.com", tE = "qa.thrillshare.com", nE = "localhost:4000", oE = [Qk, Jk, eE, tE, nE], xa = "/", rE = (e) => !!oE.find((t) => e && !!e.toLowerCase().includes(t)), Ho = (e, { isPreview: t, currentDomain: n }) => e ? rE(n) || t ? e.path_prefix || xa : e.org_url ? e.org_url === e.path_prefix ? e.path_prefix || xa : `https://${e.org_url}` : e.path_prefix || xa : "#", G1 = (e, t, { isPreview: n }) => {
  const o = j8(e.link), i = t.find(
    (a) => a && a.alias && e.alias && a.alias.toLowerCase() === e.alias.toLowerCase()
  ), r = {
    isPreview: n,
    currentDomain: window.location.href
  };
  return i ? Ho(i, r) : o;
}, iE = {
  name: "SchoolsMenuOrg",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    organizations: {
      type: Array,
      default: () => []
    },
    isPreview: Boolean
  },
  computed: {
    link() {
      return G1(this.item, this.organizations, {
        isPreview: this.isPreview
      });
    }
  }
}, sE = ["href"];
function aE(e, t, n, o, i, r) {
  return d(), h("a", {
    href: r.link,
    style: j(`color: ${n.theme.schools_menu_text_color.hex}`),
    onKeydown: [
      t[0] || (t[0] = V(z((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[1] || (t[1] = V((a) => e.$emit("tab-action", a), ["tab"]))
    ]
  }, y(n.item.name), 45, sE);
}
const lE = /* @__PURE__ */ O(iE, [["render", aE], ["__scopeId", "data-v-40d9da4e"]]), uE = {
  name: "SchoolsMenuOrg",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    organizations: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    linkTarget() {
      return this.item.opens_in_new_tab ? "_blank" : "_self";
    }
  }
}, dE = ["href", "target"];
function cE(e, t, n, o, i, r) {
  return d(), h("a", {
    href: n.item.link,
    target: r.linkTarget,
    style: j(`color: ${n.theme.schools_menu_text_color.hex}`),
    onKeydown: [
      t[0] || (t[0] = V(z((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[1] || (t[1] = V((a) => e.$emit("tab-action", a), ["tab"]))
    ]
  }, y(n.item.name), 45, dE);
}
const hE = /* @__PURE__ */ O(uE, [["render", cE], ["__scopeId", "data-v-ca9c8a65"]]), mE = {
  name: "SchoolsMenuImage",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    }
  },
  computed: {
    opensInNewTab() {
      return this.item.open_in_new_tab ? "_blank" : "_self";
    },
    width() {
      return this.item.display === "percentage" ? `${this.item.set_ratio * 100}%` : `${this.item.preferred_width}px`;
    },
    height() {
      let e = `max-height: ${this.item.preferred_height}px`;
      return this.item.display === "percentage" && (e = "auto"), e;
    },
    isDecorativeImage() {
      return !!this.item.decorative_image;
    }
  }
}, pE = { key: 0 }, fE = ["src", "alt"], gE = { key: 1 }, vE = ["href", "target"], bE = ["src", "alt"];
function yE(e, t, n, o, i, r) {
  return d(), h("div", {
    class: v([n.item.image_alignment, "image-container"])
  }, [
    n.item.action_on_click === "no_action" ? (d(), h("div", pE, [
      c("img", {
        src: n.item.url,
        alt: r.isDecorativeImage ? "" : n.item.alt_text,
        style: j({ width: r.width, height: r.height })
      }, null, 12, fE)
    ])) : (d(), h("div", gE, [
      c("a", {
        href: n.item.link_url,
        target: r.opensInNewTab,
        onKeydown: [
          t[0] || (t[0] = V(z((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
          t[1] || (t[1] = V((a) => e.$emit("tab-action", a), ["tab"]))
        ]
      }, [
        c("img", {
          src: n.item.url,
          alt: r.isDecorativeImage ? "" : n.item.alt_text,
          style: j({ width: r.width, height: r.height })
        }, null, 12, bE)
      ], 40, vE)
    ]))
  ], 2);
}
const _E = /* @__PURE__ */ O(mE, [["render", yE], ["__scopeId", "data-v-92129cf0"]]), CE = {
  name: "SM1",
  components: {
    SchoolsMenuHeader: Xk,
    SchoolsMenuOrg: lE,
    SchoolsMenuLink: hE,
    SchoolsMenuImage: _E
  },
  props: {
    headerTheme: {
      type: Object,
      required: !0
    },
    columns: {
      type: Array,
      default: () => []
    },
    organizations: {
      type: Array,
      default: () => []
    },
    stickyHeader: Boolean,
    shrinkHeader: Boolean,
    isPreview: Boolean
  },
  data() {
    return {
      debounceSetScreenSize: () => {
      },
      screenSize: "",
      activeHeader: "",
      allFocusableElements: []
    };
  },
  computed: {
    isMobile() {
      return this.screenSize < 540;
    },
    styles() {
      return {
        background: this.headerTheme.version === "H4" ? "transparent" : this.headerTheme.schools_menu_bg_color.hex
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setScreenSize();
    }), this.debounceSetScreenSize = pi(this.setScreenSize, 100), window.addEventListener("resize", this.debounceSetScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debounceSetScreenSize);
  },
  methods: {
    setScreenSize() {
      this.screenSize = window.innerWidth;
    },
    setActiveHeader(e) {
      this.activeHeader = e === this.activeHeader ? "" : e;
    },
    determineFocusableElements() {
      this.allFocusableElements = this.$refs["menu-wrapper"].querySelectorAll("[href], .mobile-cursor");
    },
    tabAction(e, t) {
      var u, m;
      this.determineFocusableElements();
      const n = t.shiftKey, o = this.allFocusableElements[0], i = this.allFocusableElements[this.allFocusableElements.length - 1];
      let r = "", a = "";
      e.type === "SchoolsMenuImage" && (r = (u = o == null ? void 0 : o.href) == null ? void 0 : u.toString().slice(0, -1), a = (m = i == null ? void 0 : i.href) == null ? void 0 : m.toString().slice(0, -1));
      const s = o.innerText === e.name || r === e.link_url, l = i.innerText === e.name || a === e.link_url;
      s && n && this.$emit("focus-lost"), l && !n && this.$emit("focus-lost");
    }
  }
}, wE = {
  ref: "menu-wrapper",
  class: "wrapper"
}, TE = ["id", "onClick"], kE = ["aria-describedby"];
function EE(e, t, n, o, i, r) {
  return d(), h("div", {
    id: "schools-menu-sm1",
    class: v([
      n.headerTheme.version,
      {
        sticky: n.stickyHeader,
        shrink: n.shrinkHeader
      }
    ]),
    style: j(r.styles)
  }, [
    c("div", wE, [
      (d(!0), h(Y, null, ee(n.columns, (a, s) => (d(), h("div", {
        key: `sm1-col-${s}`,
        class: "column"
      }, [
        c("ul", null, [
          (d(!0), h(Y, null, ee(a, (l, u) => (d(), h("li", {
            id: `parent-item-${s}-${u}`,
            key: `parent-item-${s}-${u}`,
            class: v(["parent-item", l.type]),
            onClick: (m) => r.setActiveHeader(`${s}-${u}`)
          }, [
            (d(), k(K(l.type), {
              item: l,
              organizations: n.organizations,
              theme: n.headerTheme,
              "is-mobile": r.isMobile,
              "is-preview": n.isPreview,
              "is-mobile-active": i.activeHeader === `${s}-${u}`,
              onHideOnEsc: t[0] || (t[0] = (m) => e.$emit("hide-on-esc")),
              onSetActiveHeader: (m) => r.setActiveHeader(`${s}-${u}`),
              onTabAction: (m) => r.tabAction(l, m)
            }, null, 40, ["item", "organizations", "theme", "is-mobile", "is-preview", "is-mobile-active", "onSetActiveHeader", "onTabAction"])),
            L(Ee, {
              name: r.isMobile ? "slide" : ""
            }, {
              default: _(() => [
                l.type === "SchoolsMenuHeader" && !r.isMobile || r.isMobile && i.activeHeader === `${s}-${u}` ? (d(), h("ul", {
                  key: 0,
                  class: "child-ul",
                  "aria-describedby": `parent-item-${s}-${u}`
                }, [
                  (d(!0), h(Y, null, ee(l.children, (m, g) => (d(), h("li", {
                    key: `child-item-${s}-${u}-${g}`,
                    class: "child-item"
                  }, [
                    (d(), k(K(m.type), {
                      organizations: n.organizations,
                      item: m,
                      theme: n.headerTheme,
                      onHideOnEsc: t[1] || (t[1] = (p) => e.$emit("hide-on-esc")),
                      onTabAction: (p) => r.tabAction(m, p)
                    }, null, 40, ["organizations", "item", "theme", "onTabAction"]))
                  ]))), 128))
                ], 8, kE)) : b("", !0)
              ]),
              _: 2
            }, 1032, ["name"])
          ], 10, TE))), 128))
        ])
      ]))), 128))
    ], 512)
  ], 6);
}
const SE = /* @__PURE__ */ O(CE, [["render", EE], ["__scopeId", "data-v-fa1c07e4"]]), ME = {
  name: "SchoolsMenu",
  components: {
    SM1: SE
  },
  mixins: [ht],
  props: {
    headerTheme: {
      type: Object,
      required: !0
    },
    orgMenuContent: {
      type: Array,
      default: () => []
    },
    organizations: {
      type: Array,
      default: () => []
    },
    showCustomSchoolsMenu: Boolean,
    stickyHeader: Boolean,
    shrinkHeader: Boolean,
    isPreview: Boolean,
    isIFrame: Boolean
  },
  methods: {
    hideOnClickaway() {
      this.$emit("hide-on-clickaway");
    },
    onFocusLost() {
      this.$emit("focus-lost");
    }
  }
};
function AE(e, t, n, o, i, r) {
  const a = Ve("click-away");
  return d(), h("div", {
    onKeydown: t[0] || (t[0] = V(z((...s) => r.hideOnClickaway && r.hideOnClickaway(...s), ["exact", "prevent"]), ["esc"]))
  }, [
    L(Ee, { name: "slide" }, {
      default: _(() => [
        n.showCustomSchoolsMenu ? ge((d(), k(K("SM1"), {
          key: 0,
          "header-theme": n.headerTheme,
          columns: n.orgMenuContent,
          organizations: n.organizations,
          "sticky-header": n.stickyHeader,
          "shrink-header": n.shrinkHeader,
          "is-preview": n.isPreview,
          onHideOnEsc: r.hideOnClickaway,
          onFocusLost: r.onFocusLost
        }, null, 40, ["header-theme", "columns", "organizations", "sticky-header", "shrink-header", "is-preview", "onHideOnEsc", "onFocusLost"])), [
          [a, r.hideOnClickaway]
        ]) : b("", !0)
      ]),
      _: 1
    })
  ], 32);
}
const no = /* @__PURE__ */ O(ME, [["render", AE], ["__scopeId", "data-v-e9ebd598"]]), $E = {
  name: "HeaderDropdown",
  props: {
    id: {
      type: String,
      default: ""
    },
    role: {
      type: String,
      default: ""
    },
    labelledby: {
      type: String,
      default: ""
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    data: {
      type: Array,
      default: () => []
    },
    isVisible: Boolean,
    menuV4Enabled: Boolean,
    isPreview: Boolean,
    isLanguageMenuHidden: Boolean,
    pathPrefix: {
      type: String,
      default: ""
    },
    isShrink: Boolean
  },
  data() {
    return {
      focusedIndex: 0,
      headerHeight: 200
    };
  },
  computed: {
    colors() {
      const e = this.isShrink ? 46 : this.headerHeight;
      return {
        "--school-bg-color": this.styles.schools_menu_bg_color.hex,
        "--school-text-color": this.styles.schools_menu_text_color.hex,
        "--explore-bg-color": S(
          this.styles,
          "explore_menu_bg_color.hex",
          this.styles.language_menu_dropdown_color.hex
        ),
        "--explore-text-color": S(
          this.styles,
          "explore_menu_text_color.hex",
          this.styles.language_menu_text_color.hex
        ),
        "--lang-bg-color": this.styles.language_menu_dropdown_color.hex,
        "--lang-text-color": this.styles.language_menu_text_color.hex,
        "--header-height": `${e + 12}px`
      };
    },
    isSchoolMenu() {
      return this.id === "schoolsmenu";
    },
    isMenuV4() {
      return this.menuV4Enabled && this.id === "explore-menu";
    }
  },
  mounted() {
    typeof window != "undefined" && window.addEventListener("resize", this.calculateParentHeight);
  },
  beforeUnmount() {
    typeof window != "undefined" && window.removeEventListener("resize", this.calculateParentHeight);
  },
  beforeUpdate() {
    this.calculateParentHeight();
  },
  updated() {
    this.isVisible && this.$refs.dropdown && (this.focusedIndex = 0);
  },
  methods: {
    calculateParentHeight() {
      this.$parent.$parent.$refs.cmsHeader && (this.headerHeight = this.$parent.$parent.$refs.cmsHeader.clientHeight);
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.pathPrefix}${e}` : e;
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    changeFocus(e, t) {
      const n = this.focusedIndex + e;
      if (n < 0 || n > this.data.length - 1) {
        this.closeDropdown();
        return;
      }
      this.focusedIndex = n, t ? this.focusItem() : this.focusArrowNavigation();
    },
    focusPrevious(e, t) {
      this.changeFocus(-1, t);
    },
    focusNext(e, t) {
      this.changeFocus(1, t);
    },
    focusItem() {
      this.$refs.dropdown.children[this.focusedIndex].focus();
    },
    focusArrowNavigation() {
      this.$refs.dropdown.children[this.focusedIndex].children[0].focus();
    },
    updateLanguageCode(e) {
      this.$emit("setLanguage", e);
    },
    closeDropdown(e) {
      this.$emit("close-dropdown", e);
    },
    orgLink(e) {
      return Ho(e, {
        isPreview: this.isPreview,
        currentDomain: window.location.href
      });
    }
  }
}, IE = ["id", "role", "aria-labelledby"], DE = { ref: "dropdown" }, LE = ["href", "target"], OE = ["href"], NE = ["onKeydown"], PE = ["onClick"], HE = {
  class: "button-action-content",
  tabindex: "-1"
};
function FE(e, t, n, o, i, r) {
  return d(), k(Ee, { name: "fade" }, {
    default: _(() => [
      n.isVisible ? (d(), h("div", {
        key: 0,
        class: "header--dropdown-wrapper",
        style: j(r.colors)
      }, [
        c("div", {
          id: n.id,
          role: n.role,
          "aria-labelledby": n.labelledby,
          class: v(["dropdown", {
            "dropdown--school": r.isSchoolMenu,
            "dropdown--explore": r.isMenuV4,
            "dropdown--lang": !r.isSchoolMenu && !r.isMenuV4,
            "no-language-menu": n.isLanguageMenuHidden
          }]),
          onClick: z(() => {
          }, ["stop"]),
          onKeydown: t[14] || (t[14] = V(z((a) => r.closeDropdown(!0), ["exact", "prevent"]), ["esc"]))
        }, [
          c("ul", DE, [
            r.isMenuV4 ? (d(!0), h(Y, { key: 0 }, ee(n.data, (a) => (d(), h("li", {
              key: a.id,
              role: "menuitem",
              onKeydown: [
                t[0] || (t[0] = V(z((...s) => r.focusPrevious && r.focusPrevious(...s), ["exact", "prevent"]), ["up"])),
                t[1] || (t[1] = V(z((...s) => r.focusNext && r.focusNext(...s), ["exact", "prevent"]), ["down"])),
                t[2] || (t[2] = V(z((s) => r.focusPrevious(s, !0), ["shift", "exact"]), ["tab"])),
                t[3] || (t[3] = V(z((s) => r.focusNext(s, !0), ["exact"]), ["tab"]))
              ],
              onClick: t[4] || (t[4] = (...s) => r.closeDropdown && r.closeDropdown(...s))
            }, [
              c("a", {
                href: r.getLink(a.url),
                class: "link-explore",
                target: r.targetWindow(a)
              }, y(a.name), 9, LE)
            ], 32))), 128)) : r.isSchoolMenu ? (d(!0), h(Y, { key: 1 }, ee(n.data, (a, s) => (d(), h("li", {
              key: s,
              role: "menuitem",
              onKeydown: [
                t[5] || (t[5] = V(z((...l) => r.focusPrevious && r.focusPrevious(...l), ["exact", "prevent"]), ["up"])),
                t[6] || (t[6] = V(z((...l) => r.focusNext && r.focusNext(...l), ["exact", "prevent"]), ["down"])),
                t[7] || (t[7] = V(z((l) => r.focusPrevious(l, !0), ["shift", "exact"]), ["tab"])),
                t[8] || (t[8] = V(z((l) => r.focusNext(l, !0), ["exact"]), ["tab"]))
              ],
              onClick: t[9] || (t[9] = (...l) => r.closeDropdown && r.closeDropdown(...l))
            }, [
              c("a", {
                href: r.orgLink(a),
                class: "link-school"
              }, y(a.name), 9, OE)
            ], 32))), 128)) : (d(!0), h(Y, { key: 2 }, ee(n.data, (a, s) => (d(), h("li", {
              key: s,
              role: "menuitem",
              onKeydown: [
                V(z((l) => r.updateLanguageCode(a), ["exact", "prevent"]), ["enter"]),
                t[10] || (t[10] = V(z((...l) => r.focusPrevious && r.focusPrevious(...l), ["exact", "prevent"]), ["up"])),
                t[11] || (t[11] = V(z((...l) => r.focusNext && r.focusNext(...l), ["exact", "prevent"]), ["down"])),
                t[12] || (t[12] = V(z((l) => r.focusPrevious(l, !0), ["shift", "exact"]), ["tab"])),
                t[13] || (t[13] = V(z((l) => r.focusNext(l, !0), ["exact"]), ["tab"]))
              ]
            }, [
              c("button", {
                class: "button-action link-lang",
                onClick: (l) => r.updateLanguageCode(a)
              }, [
                c("div", HE, y(a.language), 1)
              ], 8, PE)
            ], 40, NE))), 128))
          ], 512)
        ], 42, IE)
      ], 4)) : b("", !0)
    ]),
    _: 1
  });
}
const RE = /* @__PURE__ */ O($E, [["render", FE], ["__scopeId", "data-v-49b8bc7d"]]), BE = {
  props: {
    color: {
      type: String,
      default: ""
    }
  }
}, VE = {
  width: "176",
  height: "16",
  viewBox: "0 0 176 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  "aria-labelledby": "googleTranslateLogoID"
}, jE = ["fill"], UE = ["fill"], GE = ["fill"], zE = ["fill"], KE = ["fill"], ZE = ["fill"], xE = ["fill"], WE = ["fill"], qE = ["fill"], YE = ["fill"], XE = ["fill"], QE = ["fill"], JE = ["fill"], eS = ["fill"], tS = ["fill"], nS = ["fill"], oS = ["fill"], rS = ["fill"], iS = ["fill"], sS = ["fill"], aS = ["fill"], lS = ["fill"], uS = ["fill"], dS = ["fill"];
function cS(e, t, n, o, i, r) {
  return d(), h("svg", VE, [
    t[0] || (t[0] = c("title", { id: "googleTranslateLogoID" }, "powered by Google Translate", -1)),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M128.97 4.67C128.23 4.67 127.2 5.19 126.91 6H126.85V4.78H125.58V11.88H126.91V8.06C126.91 6.76 127.84 5.99 128.75 5.99C129.04 5.99 129.27 6.02 129.46 6.09L129.97 4.84C129.69 4.72 129.4 4.67 128.97 4.67",
      fill: n.color || "#757575"
    }, null, 8, jE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M152.98 1.33H154.31V11.87H152.98V1.33Z",
      fill: n.color || "#757575"
    }, null, 8, UE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M148.84 4.67C147.41 4.67 146.07 5.47 146.07 6.72C146.07 7.97 147.28 8.48 147.91 8.63L149.34 8.97C150.07 9.15 150.32 9.53 150.32 9.88C150.32 10.46 149.7 10.83 148.9 10.83C148.1 10.83 147.36 10.43 146.99 9.54L145.84 10.02C146.25 11.02 147.23 12 148.89 12C150.55 12 151.64 11.06 151.64 9.84C151.64 9 151.07 8.15 149.7 7.83L148.3 7.51C147.75 7.38 147.39 7.15 147.39 6.71C147.39 6.15 148.06 5.84 148.79 5.84C149.46 5.84 150.14 6.11 150.4 6.75L151.52 6.29C151.1 5.24 150.02 4.67 148.82 4.67",
      fill: n.color || "#757575"
    }, null, 8, GE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M158.76 10.8C158.09 10.8 157.25 10.45 157.25 9.72C157.25 9.09 157.86 8.4 159.22 8.4C160.32 8.4 160.84 8.81 160.84 8.81C160.84 9.93 159.78 10.8 158.75 10.8M159.03 4.67C157.3 4.67 156.33 5.68 156.09 6.31L157.27 6.82C157.51 6.17 158.34 5.87 159.06 5.87C160.03 5.87 160.84 6.47 160.84 7.56V7.76C160.57 7.61 159.92 7.34 158.99 7.34C157.37 7.34 155.87 8.14 155.87 9.7C155.87 11.13 157.13 12 158.54 12C159.72 12 160.4 11.36 160.78 10.79H160.84V11.87H162.1V7.61C162.1 5.67 160.72 4.66 159.04 4.66",
      fill: n.color || "#757575"
    }, null, 8, zE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M133.5 10.8C132.83 10.8 131.99 10.45 131.99 9.72C131.99 9.09 132.6 8.4 133.96 8.4C135.06 8.4 135.58 8.81 135.58 8.81C135.58 9.93 134.52 10.8 133.49 10.8M133.77 4.67C132.04 4.67 131.07 5.68 130.83 6.31L132.01 6.82C132.25 6.17 133.08 5.87 133.8 5.87C134.77 5.87 135.58 6.47 135.58 7.56V7.76C135.31 7.61 134.66 7.34 133.73 7.34C132.11 7.34 130.61 8.14 130.61 9.7C130.61 11.13 131.87 12 133.28 12C134.46 12 135.14 11.36 135.52 10.79H135.58V11.87H136.84V7.61C136.84 5.67 135.46 4.66 133.78 4.66",
      fill: n.color || "#757575"
    }, null, 8, KE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M169.58 7.5C169.84 6.5 170.61 5.87 171.58 5.87C173.08 5.87 173.59 6.91 173.63 7.5H169.58ZM171.61 4.67C169.56 4.67 168.19 6.38 168.19 8.34C168.19 10.42 169.62 12.01 171.76 12.01C173.37 12.01 174.4 11.11 174.81 10.13L173.64 9.65C173.27 10.52 172.5 10.81 171.73 10.81C170.65 10.81 169.58 10.04 169.5 8.59H175.02C175.02 8.59 175.03 8.44 175.03 8.34C175.03 6.12 173.69 4.67 171.61 4.67",
      fill: n.color || "#757575"
    }, null, 8, ZE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M141.96 4.67C140.99 4.67 140.09 5.23 139.71 5.89H139.65V4.78H138.38V11.88H139.71V8.08C139.71 6.99 140.42 5.89 141.58 5.89C142.59 5.89 143.33 6.38 143.33 7.86V11.88H144.66V7.66C144.66 5.91 143.76 4.68 141.95 4.68",
      fill: n.color || "#757575"
    }, null, 8, xE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M165.58 2.67H164.25V4.78H163V6.01H164.25V9.73C164.25 11.18 165.05 12 166.54 12C166.99 12 167.31 11.94 167.61 11.81L167.15 10.67C166.96 10.76 166.79 10.79 166.54 10.79C165.92 10.79 165.58 10.43 165.58 9.63V6.01H167.32V4.78H165.58V2.67",
      fill: n.color || "#757575"
    }, null, 8, WE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M125.13 1.33H117.91V2.7H120.84V11.87H122.19V2.7H125.12V1.33",
      fill: n.color || "#757575"
    }, null, 8, qE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M72.34 5.46V7.1H76.26C76.14 8.02 75.84 8.7 75.37 9.16C74.8 9.73 73.91 10.36 72.34 10.36C69.92 10.36 68.04 8.41 68.04 6C68.04 3.59 69.93 1.64 72.34 1.64C73.64 1.64 74.59 2.15 75.3 2.81L76.46 1.65C75.48 0.71 74.18 0 72.35 0C69.04 0 66.26 2.69 66.26 6C66.26 9.31 69.04 12 72.35 12C74.13 12 75.48 11.41 76.54 10.32C77.62 9.24 77.96 7.71 77.96 6.49C77.96 6.11 77.93 5.76 77.87 5.47H72.35",
      fill: n.color || "#4285F4"
    }, null, 8, YE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M82.85 4.13C80.71 4.13 78.96 5.76 78.96 8C78.96 10.24 80.71 11.87 82.85 11.87C84.99 11.87 86.74 10.23 86.74 8C86.74 5.77 84.99 4.13 82.85 4.13ZM82.85 10.35C81.68 10.35 80.66 9.38 80.66 8C80.66 6.62 81.67 5.65 82.85 5.65C84.03 5.65 85.04 6.6 85.04 8C85.04 9.4 84.03 10.35 82.85 10.35Z",
      fill: n.color || "#EB4335"
    }, null, 8, XE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M101.9 4.99H101.84C101.46 4.53 100.72 4.12 99.8001 4.12C97.8601 4.12 96.1801 5.81 96.1801 7.99C96.1801 10.17 97.8701 11.86 99.8001 11.86C100.72 11.86 101.46 11.45 101.84 10.98H101.9V11.52C101.9 13 101.11 13.79 99.8301 13.79C98.7901 13.79 98.1401 13.04 97.8801 12.41L96.4001 13.03C96.8301 14.06 97.9501 15.32 99.8301 15.32C101.83 15.32 103.51 14.15 103.51 11.29V4.32H101.9V4.99V4.99ZM99.9501 10.34C98.7801 10.34 97.8801 9.34 97.8801 7.99C97.8801 6.64 98.7701 5.64 99.9501 5.64C101.13 5.64 102.02 6.64 102.02 8C102.02 9.36 101.11 10.33 99.9501 10.33V10.34Z",
      fill: n.color || "#4285F4"
    }, null, 8, QE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M91.51 4.13C89.37 4.13 87.62 5.76 87.62 8C87.62 10.24 89.37 11.87 91.51 11.87C93.65 11.87 95.4 10.23 95.4 8C95.4 5.77 93.65 4.13 91.51 4.13ZM91.51 10.35C90.34 10.35 89.32 9.38 89.32 8C89.32 6.62 90.33 5.65 91.51 5.65C92.69 5.65 93.7 6.6 93.7 8C93.7 9.4 92.69 10.35 91.51 10.35Z",
      fill: n.color || "#FBBC05"
    }, null, 8, JE),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M104.85 0.160004H106.52V11.87H104.85V0.160004Z",
      fill: n.color || "#34A853"
    }, null, 8, eS),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M111.69 10.35C110.82 10.35 110.21 9.95 109.81 9.18L114.99 7.04L114.81 6.6C114.49 5.73 113.5 4.14 111.5 4.14C109.5 4.14 107.85 5.71 107.85 8.01C107.85 10.18 109.49 11.88 111.69 11.88C113.46 11.88 114.49 10.79 114.92 10.16L113.6 9.28C113.16 9.93 112.56 10.35 111.69 10.35V10.35ZM111.56 5.58C112.25 5.58 112.83 5.93 113.03 6.43L109.53 7.88C109.53 6.25 110.68 5.58 111.56 5.58Z",
      fill: n.color || "#EB4335"
    }, null, 8, tS),
    c("path", {
      d: "M5.36 8.77C5.36 9.73 5.14 10.51 4.7 11.1C4.26 11.69 3.66 11.98 2.91 11.98C2.16 11.98 1.53 11.74 1.09 11.25V14.3H0V5.53H0.99L1.04 6.23C1.48 5.68 2.09 5.41 2.88 5.41C3.67 5.41 4.24 5.7 4.69 6.27C5.14 6.84 5.36 7.64 5.36 8.67V8.77V8.77ZM4.28 8.65C4.28 7.94 4.13 7.37 3.82 6.96C3.51 6.55 3.1 6.34 2.57 6.34C1.91 6.34 1.42 6.63 1.09 7.21V10.24C1.41 10.82 1.91 11.11 2.58 11.11C3.1 11.11 3.51 10.9 3.82 10.49C4.13 10.08 4.28 9.47 4.28 8.65Z",
      fill: n.color || "black"
    }, null, 8, nS),
    c("path", {
      d: "M6.44995 8.64C6.44995 8.02 6.56995 7.46 6.81995 6.96C7.06995 6.46 7.39995 6.08 7.83995 5.81C8.27995 5.54 8.76995 5.41 9.32995 5.41C10.19 5.41 10.89 5.71 11.42 6.31C11.95 6.91 12.22 7.7 12.22 8.69V8.77C12.22 9.39 12.1 9.94 11.87 10.43C11.64 10.92 11.3 11.3 10.86 11.58C10.42 11.86 9.91995 11.99 9.34995 11.99C8.48995 11.99 7.78995 11.69 7.25995 11.09C6.72995 10.49 6.45995 9.7 6.45995 8.72V8.64H6.44995ZM7.53995 8.77C7.53995 9.47 7.69995 10.04 8.02995 10.46C8.35995 10.88 8.78995 11.1 9.33995 11.1C9.88995 11.1 10.33 10.88 10.65 10.45C10.97 10.02 11.14 9.41 11.14 8.64C11.14 7.94 10.97 7.38 10.64 6.95C10.31 6.52 9.86995 6.3 9.31995 6.3C8.76995 6.3 8.34995 6.51 8.02995 6.94C7.70995 7.37 7.53995 7.98 7.53995 8.77V8.77Z",
      fill: n.color || "black"
    }, null, 8, oS),
    c("path", {
      d: "M19.19 10.38L20.41 5.53H21.49L19.64 11.87H18.76L17.22 7.07L15.72 11.87H14.84L13 5.53H14.08L15.33 10.28L16.81 5.53H17.68L19.19 10.38V10.38Z",
      fill: n.color || "black"
    }, null, 8, rS),
    c("path", {
      d: "M25.2201 11.99C24.3601 11.99 23.6601 11.71 23.1201 11.14C22.5801 10.57 22.3101 9.82 22.3101 8.88V8.68C22.3101 8.05 22.4301 7.49 22.6701 7C22.9101 6.51 23.2501 6.12 23.6801 5.84C24.1101 5.56 24.5801 5.42 25.0801 5.42C25.9001 5.42 26.5401 5.69 27.0001 6.23C27.4601 6.77 27.6901 7.55 27.6901 8.56V9.01H23.4001C23.4201 9.63 23.6001 10.14 23.9501 10.52C24.3001 10.9 24.7401 11.1 25.2801 11.1C25.6601 11.1 25.9901 11.02 26.2501 10.87C26.5101 10.72 26.7501 10.51 26.9501 10.25L27.6101 10.77C27.0801 11.59 26.2801 11.99 25.2201 11.99V11.99ZM25.0901 6.31C24.6501 6.31 24.2901 6.47 23.9901 6.79C23.6901 7.11 23.5101 7.55 23.4401 8.13H26.6201V8.05C26.5901 7.5 26.4401 7.07 26.1701 6.77C25.9001 6.47 25.5501 6.32 25.0901 6.32V6.31Z",
      fill: n.color || "black"
    }, null, 8, iS),
    c("path", {
      d: "M32.02 6.51C31.86 6.48 31.68 6.47 31.49 6.47C30.78 6.47 30.3 6.77 30.04 7.38V11.88H28.96V5.54H30.01L30.03 6.27C30.39 5.7 30.89 5.42 31.54 5.42C31.75 5.42 31.91 5.45 32.02 5.5V6.51Z",
      fill: n.color || "black"
    }, null, 8, sS),
    c("path", {
      d: "M35.64 11.99C34.78 11.99 34.08 11.71 33.54 11.14C33 10.57 32.73 9.82 32.73 8.88V8.68C32.73 8.05 32.85 7.49 33.09 7C33.33 6.51 33.67 6.12 34.1 5.84C34.53 5.56 35 5.42 35.5 5.42C36.32 5.42 36.96 5.69 37.42 6.23C37.88 6.77 38.11 7.55 38.11 8.56V9.01H33.82C33.84 9.63 34.02 10.14 34.37 10.52C34.72 10.9 35.16 11.1 35.7 11.1C36.08 11.1 36.41 11.02 36.67 10.87C36.93 10.72 37.17 10.51 37.37 10.25L38.03 10.77C37.5 11.59 36.7 11.99 35.64 11.99V11.99ZM35.51 6.31C35.07 6.31 34.71 6.47 34.41 6.79C34.11 7.11 33.93 7.55 33.86 8.13H37.04V8.05C37.01 7.5 36.86 7.07 36.59 6.77C36.32 6.47 35.97 6.32 35.51 6.32V6.31Z",
      fill: n.color || "black"
    }, null, 8, aS),
    c("path", {
      d: "M39.11 8.64999C39.11 7.67999 39.34 6.9 39.8 6.3C40.26 5.7 40.86 5.41 41.61 5.41C42.36 5.41 42.94 5.66 43.37 6.17V2.87H44.45V11.87H43.45L43.4 11.19C42.97 11.72 42.36 11.99 41.59 11.99C40.82 11.99 40.26 11.69 39.79 11.09C39.32 10.49 39.1 9.69999 39.1 8.72999V8.64999H39.11ZM40.19 8.77C40.19 9.49 40.34 10.05 40.64 10.46C40.94 10.87 41.35 11.07 41.87 11.07C42.56 11.07 43.06 10.76 43.38 10.14V7.23C43.06 6.63 42.56 6.33 41.89 6.33C41.36 6.33 40.94 6.54 40.65 6.95C40.36 7.36 40.2 7.97 40.2 8.77H40.19Z",
      fill: n.color || "black"
    }, null, 8, lS),
    c("path", {
      d: "M54.47 8.77C54.47 9.74 54.25 10.52 53.8 11.1C53.35 11.68 52.76 11.98 52.01 11.98C51.21 11.98 50.59 11.7 50.15 11.13L50.1 11.86H49.1V2.87H50.18V6.23C50.62 5.69 51.22 5.42 51.99 5.42C52.76 5.42 53.36 5.71 53.8 6.29C54.24 6.87 54.46 7.67 54.46 8.68V8.77H54.47ZM53.39 8.64999C53.39 7.90999 53.25 7.34 52.96 6.94C52.67 6.54 52.26 6.34 51.73 6.34C51.02 6.34 50.5 6.67 50.19 7.34V10.08C50.52 10.74 51.04 11.08 51.74 11.08C52.26 11.08 52.66 10.88 52.95 10.48C53.24 10.08 53.38 9.47 53.38 8.66L53.39 8.64999Z",
      fill: n.color || "black"
    }, null, 8, uS),
    c("path", {
      d: "M57.91 10.29L59.39 5.53999H60.55L58 12.86C57.61 13.91 56.98 14.44 56.12 14.44L55.91 14.42L55.51 14.34V13.46L55.8 13.48C56.17 13.48 56.45 13.41 56.66 13.26C56.87 13.11 57.03 12.84 57.17 12.45L57.41 11.81L55.15 5.53999H56.33L57.91 10.29V10.29Z",
      fill: n.color || "black"
    }, null, 8, dS)
  ]);
}
const hS = /* @__PURE__ */ O(BE, [["render", cS]]), mS = {
  props: {
    color: {
      type: String,
      default: "#662E80"
    }
  }
}, pS = {
  width: "12",
  height: "10",
  viewBox: "0 0 12 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fS = ["stroke"];
function gS(e, t, n, o, i, r) {
  return d(), h("svg", pS, [
    c("path", {
      d: "M1 5.53089L4.75 8.95946L11 0.959457",
      stroke: n.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, fS)
  ]);
}
const vS = /* @__PURE__ */ O(mS, [["render", gS]]), bS = {
  name: "LanguageDropdown",
  components: {
    SelectedIcon: vS,
    PoweredByGoogle: hS
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "All Languages"
    },
    data: {
      type: Array,
      default: () => []
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    currentLanguage: {
      type: String,
      default: "en"
    },
    role: {
      type: String,
      default: ""
    },
    isVisible: Boolean
  },
  data() {
    return {
      bottomListReached: !1,
      focusedIndex: 0,
      inputValue: "",
      selectedLanguage: ""
    };
  },
  computed: {
    colors() {
      return {
        "--lang-bg-color": this.styles.language_menu_dropdown_color.hex || "#fff",
        "--lang-text-color": this.langTextColor || "#000",
        "--column-count": this.data.length < 5 ? 2 : 3,
        "--inner-shadow-height": this.data.length > 18 && !this.bottomListReached ? "35px" : "0px"
      };
    },
    googleLogoColor() {
      return this.colors["--lang-bg-color"] === "#fff" ? "" : ae(this.colors["--lang-bg-color"]).isLight() ? "#000" : "#fff";
    },
    langTextColor() {
      return this.styles.language_menu_text_color.hex || "#000";
    },
    filteredLanguages() {
      const e = this.inputValue.trim().toLowerCase();
      return e.length === 0 ? this.data : this.data.filter(
        ({ language: t, code: n }) => t.toLowerCase().includes(e) || n.toLowerCase().includes(e)
      );
    }
  },
  mounted() {
    this.selectedLanguage = this.currentLanguage;
  },
  methods: {
    listScroll(e) {
      const { scrollTop: t, offsetHeight: n, scrollHeight: o } = e.target, i = 10;
      this.bottomListReached = t + n + i >= o;
    },
    inputSearch() {
      var e;
      !this.inputValue.trim().length || !this.filteredLanguages.length || (this.selectedLanguage = (e = this.filteredLanguages[0]) == null ? void 0 : e.code, this.confirmLanguageSelection(this.selectedLanguage));
    },
    selectLanguage(e) {
      this.selectedLanguage = e, this.confirmLanguageSelection(this.selectedLanguage);
    },
    confirmLanguageSelection(e) {
      this.$emit("set-language", { code: e });
    },
    changeFocus(e, t = !1) {
      const n = this.focusedIndex + e;
      if (n < 0) {
        this.focusedIndex = 0, this.$refs["language-input"].focus();
        return;
      }
      if (n > this.filteredLanguages.length - 1) {
        this.focusedIndex = 0, this.$emit("close-dropdown");
        return;
      }
      this.focusedIndex = n, t || this.$refs["languages-list"].children[this.focusedIndex].focus();
    }
  }
}, yS = ["id", "role"], _S = { class: "header" }, CS = { class: "title" }, wS = { class: "body" }, TS = {
  ref: "languages-list",
  class: "languages-list"
}, kS = ["onClick", "onKeydown"], ES = { class: "language-text" }, SS = { class: "footer" };
function MS(e, t, n, o, i, r) {
  const a = $("selected-icon"), s = $("powered-by-google");
  return d(), k(Ee, { name: "fade" }, {
    default: _(() => [
      n.isVisible ? (d(), h("div", {
        key: 0,
        id: n.id,
        style: j(r.colors),
        role: n.role,
        class: "dropdown-wrapper"
      }, [
        c("div", _S, [
          c("h1", CS, y(n.title), 1),
          ge(c("input", {
            ref: "language-input",
            "onUpdate:modelValue": t[0] || (t[0] = (l) => i.inputValue = l),
            class: "search-input",
            type: "text",
            placeholder: "search languages...",
            onKeydown: [
              t[1] || (t[1] = V(z((...l) => r.inputSearch && r.inputSearch(...l), ["exact", "prevent"]), ["enter"])),
              t[2] || (t[2] = V(z((l) => e.$emit("close-dropdown"), ["shift", "exact"]), ["tab"]))
            ],
            onFocus: t[3] || (t[3] = (l) => i.focusedIndex = 0)
          }, null, 544), [
            [Qf, i.inputValue]
          ])
        ]),
        c("div", wS, [
          c("div", {
            class: "languages-container",
            onScroll: t[8] || (t[8] = (...l) => r.listScroll && r.listScroll(...l))
          }, [
            c("ul", TS, [
              (d(!0), h(Y, null, ee(r.filteredLanguages, ({ language: l, code: u }) => (d(), h("li", {
                key: u,
                role: "menuitem",
                tabindex: "0",
                class: "language",
                onClick: (m) => r.selectLanguage(u),
                onKeydown: [
                  V(z((m) => r.selectLanguage(u), ["exact", "prevent"]), ["enter"]),
                  t[4] || (t[4] = V(z((m) => r.changeFocus(-1), ["exact", "prevent"]), ["up"])),
                  t[5] || (t[5] = V(z((m) => r.changeFocus(1), ["exact", "prevent"]), ["down"])),
                  t[6] || (t[6] = V(z((m) => r.changeFocus(-1), ["shift", "exact", "prevent"]), ["tab"])),
                  t[7] || (t[7] = V(z((m) => r.changeFocus(1, !0), ["exact"]), ["tab"]))
                ]
              }, [
                i.selectedLanguage === u ? (d(), k(a, {
                  key: 0,
                  color: r.langTextColor,
                  class: "selected-icon"
                }, null, 8, ["color"])) : b("", !0),
                c("div", ES, y(l), 1)
              ], 40, kS))), 128))
            ], 512)
          ], 32)
        ]),
        c("div", SS, [
          L(s, { color: r.googleLogoColor }, null, 8, ["color"])
        ])
      ], 12, yS)) : b("", !0)
    ]),
    _: 1
  });
}
const ua = /* @__PURE__ */ O(bS, [["render", MS], ["__scopeId", "data-v-f1cc0f89"]]), AS = [
  [
    {
      type: "SchoolsMenuOrg",
      name: "School District",
      link: "#"
    },
    {
      type: "SchoolsMenuHeader",
      name: "High Schools",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Bella High School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Northside High School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "No-Link High School"
        }
      ]
    }
  ],
  [
    {
      type: "SchoolsMenuHeader",
      name: "Middle Schools",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Bella Middle School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Northside Intermediate",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Parkway Middle School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Bohr Science Magnet",
          link: "#"
        }
      ]
    }
  ],
  [
    {
      type: "SchoolsMenuHeader",
      name: "Elementary Schools",
      children: [
        {
          type: "SchoolsMenuOrg",
          name: "Bella Elementary School",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Northside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Parkway Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Eastside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Southside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Burnside Elementary",
          link: "#"
        },
        {
          type: "SchoolsMenuOrg",
          name: "Gibbs Magnet School",
          link: "#"
        }
      ]
    }
  ],
  [
    {
      url: "https://d2kzwze52p8717.cloudfront.net/youth_program.jpeg",
      type: "SchoolsMenuImage",
      caption: "Girl walking up steps to school",
      display: "actual-size",
      alt_text: "Girl walking up steps to school",
      asset_id: 206,
      link_url: "",
      set_ratio: 1,
      cropped_width: {},
      cropped_height: {},
      action_on_click: "no_action",
      image_alignment: "center",
      preferred_width: null,
      preferred_height: null,
      caption_alignment: "center",
      open_link_in_new_tab: !1
    }
  ]
], rm = {
  menu: AS
}, et = {
  components: {
    HeaderDropdown: RE,
    LanguageDropdown: ua
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    shouldShrink: Boolean,
    shouldBeSticky: Boolean,
    isMobile: Boolean,
    isHomepage: Boolean,
    showSignInButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    }
  },
  emits: ["language-change", "toggle-search", "toggle-menu", "toggle-mobile-menu"],
  data() {
    return {
      customSchoolsMenuVisible: !1,
      schoolDropdownVisible: !1,
      exploreMenuVisible: !1,
      languageDropdownVisible: !1,
      containerHeight: "auto"
    };
  },
  computed: {
    isCustomSchoolsMenuVisible() {
      return this.content.hasCustomSchoolsMenu && this.customSchoolsMenuVisible;
    },
    isSchoolDropdownVisible() {
      return !this.content.hasCustomSchoolsMenu && this.schoolDropdownVisible;
    },
    logoLink() {
      const e = this.content.pathPrefix ? this.content.pathPrefix : "/";
      return this.content.isIFrame ? "" : e;
    },
    shrinkCSSClass() {
      return this.shouldShrink && !this.content.isIFrame ? "shrink" : "";
    },
    logoCircleCSSClass() {
      return this.theme.logo_circle ? "logo-circle" : "";
    },
    menuV4Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4";
    },
    menuV5Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M5";
    },
    menuV6Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M6";
    },
    shouldDisplaySchoolsDropdown() {
      var e;
      return ((e = this.content.organizations) == null ? void 0 : e.length) > 1 || this.content.hasCustomSchoolsMenu;
    },
    shouldDisplayLanguagesDropdown() {
      var e;
      return ((e = this.content.languages) == null ? void 0 : e.length) > 1;
    },
    customSchoolsMenu() {
      var e, t;
      return this.content.isPreview || this.content.isIFrame ? rm : (t = (e = this.content.globals) == null ? void 0 : e.homepage) == null ? void 0 : t.schools_menu;
    },
    menuIdByType() {
      let e = null;
      return this.isSchoolDropdownVisible ? e = "schoolsmenu" : this.isCustomSchoolsMenuVisible && (e = "schools-menu-sm1"), e;
    },
    mobileHeaderBgColor() {
      var e, t, n, o;
      return this.menuV4Enabled && this.theme.version !== "H3" ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : this.menuV5Enabled && this.theme.version === "H3" ? "transparent" : ((o = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : o.hex) || "#fff";
    },
    mobileMenuBgColor() {
      var e, t, n, o;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : ((o = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : o.hex) || "#fff";
    },
    mobileMenuTextColor() {
      var e, t, n, o;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_text_color) == null ? void 0 : t.hex : ((o = (n = this.content.menuOptions) == null ? void 0 : n.text_color) == null ? void 0 : o.hex) || "#000";
    },
    hasLanguages() {
      var e;
      return ((e = this.content.languages) == null ? void 0 : e.length) > 0;
    },
    signInColors() {
      var e, t, n, o;
      return {
        "--sign-in-border": (e = this.theme.sign_in_button_border) == null ? void 0 : e.hex,
        "--sign-in-color": (t = this.theme.sign_in_button_color) == null ? void 0 : t.hex,
        "--sign-in-bg": (n = this.theme.sign_in_button_bg) == null ? void 0 : n.hex,
        "--sign-in-bg-hover": `${(o = this.theme.sign_in_button_bg) == null ? void 0 : o.hex}CC`
      };
    },
    signInText() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.translations) == null ? void 0 : t.sign_in_button_title) || "Sign in";
    },
    hasExploreMenuContent() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.customMenuItems) == null ? void 0 : t.length) >= 1;
    },
    colors() {
      var e, t, n, o, i;
      return ie({
        "--bg-color": this.theme.bg_color ? this.theme.bg_color.hex : "#014990",
        "--logo-container-height": this.containerHeight,
        "--mobile-logo-height": (t = (e = this.content.globals) == null ? void 0 : e.info) != null && t.customHeader ? "auto" : "100%",
        "--more-text-color": this.theme.more_text_color ? this.theme.more_text_color.hex : "FFFFFF",
        "--more-bg-color": this.theme.more_bg_color ? this.theme.more_bg_color.hex : "#014990",
        "--dropdown-text-color": this.theme.dropdown_text_color ? this.theme.dropdown_text_color.hex : "#000000",
        "--dropdown-bg-color": this.theme.dropdown_bg_color ? this.theme.dropdown_bg_color.hex : "#FFFFFF",
        "--explore-menu-text-color": this.theme.explore_menu_text_color ? this.theme.explore_menu_text_color.hex : "#333333",
        "--explore-menu-bg-color": this.theme.explore_menu_bg_color ? this.theme.explore_menu_bg_color.hex : "#FFFFFF",
        "--schools-menu-text-color": this.theme.schools_menu_text_color ? this.theme.schools_menu_text_color.hex : "#333333",
        "--schools-menu-bg-color": this.theme.schools_menu_bg_color ? this.theme.schools_menu_bg_color.hex : "#FFFFFF",
        "--icon-bg-color": this.theme.icon_bg_color ? this.theme.icon_bg_color.hex : "#014990",
        "--icon-text-color": this.theme.icon_bg_color ? this.theme.icon_text_color.hex : "#014990",
        "--icon-color": this.theme.icon_color ? this.theme.icon_color.hex : "#014990",
        "--nav-color": this.theme.navigation_color ? this.theme.navigation_color.hex : "#014990",
        "--nav-icon-color": this.theme.navigation_icon_color ? this.theme.navigation_icon_color.hex : "#FFFFFF",
        "--text-color": this.theme.text_color ? this.theme.text_color.hex : "#FFFFFF",
        "--menu-heading-line-color": (o = (n = this.theme) == null ? void 0 : n.menu_heading_line_color) == null ? void 0 : o.hex,
        "--utility-link-color": this.theme.utility_link_color ? this.theme.utility_link_color.hex : "#000000",
        "--utility-bg-color": this.theme.utility_bg_color ? this.theme.utility_bg_color.hex : "#FFFFFF",
        searchIcon: (i = this.theme.search_icon_color) == null ? void 0 : i.hex,
        "--mobile-header-bg-color": this.mobileHeaderBgColor,
        "--mobile-menu-bg-color": this.mobileMenuBgColor,
        "--mobile-menu-text-color": this.mobileMenuTextColor,
        "--logo-container-height": this.containerHeight,
        "--mobile-logo-height": this.content.globals.info.customHeader ? "auto" : "100%"
      }, this.signInColors);
    }
  },
  mounted() {
    typeof window != "undefined" && (this.resizeLogoContainer(), window.addEventListener("resize", this.resizeLogoContainer));
  },
  beforeUnmount() {
    typeof window != "undefined" && window.removeEventListener("resize", this.resizeLogoContainer);
  },
  methods: {
    resizeLogoContainer() {
      var e, t, n;
      (n = (t = (e = this.content) == null ? void 0 : e.globals) == null ? void 0 : t.info) != null && n.customHeader ? this.containerHeight = `${window.document.getElementsByClassName("logo")[0].offsetHeight + 15}px` : this.containerHeight = "auto";
    },
    setLanguage(e) {
      this.languageDropdownVisible = !1, this.$emit("language-change", e);
    },
    toggleSearch() {
      this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.$emit("toggle-search");
    },
    clickedMenu(e) {
      this.setDropdownVisibility(e);
    },
    setDropdownVisibility(e) {
      switch (e) {
        case "menubutton":
          this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.$emit("toggle-menu", !this.content.showMenu);
          break;
        case "explore-button":
          this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.exploreMenuVisible = !this.exploreMenuVisible;
          break;
        case "schoolsbutton":
          this.exploreMenuVisible = !1, this.languageDropdownVisible = !1, this.content.hasCustomSchoolsMenu ? this.customSchoolsMenuVisible = !this.customSchoolsMenuVisible : this.schoolDropdownVisible = !this.schoolDropdownVisible;
          break;
        case "languagebutton":
          this.exploreMenuVisible = !1, this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !this.languageDropdownVisible;
          break;
        case "closebutton":
          this.$emit("toggle-menu", !1);
      }
    },
    closeAllMenus() {
      this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.exploreMenuVisible = !1;
    }
  }
};
function $S(e) {
  return L0() ? (O0(e), !0) : !1;
}
function Wl(e) {
  return typeof e == "function" ? e() : Jf(e);
}
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const IS = (e) => e != null;
function DS(e) {
  var t;
  const n = Wl(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var im = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Ns = /* @__PURE__ */ im.join(","), sm = typeof Element == "undefined", Ao = sm ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Ps = !sm && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Hs = function e(t, n) {
  var o;
  n === void 0 && (n = !0);
  var i = t == null || (o = t.getAttribute) === null || o === void 0 ? void 0 : o.call(t, "inert"), r = i === "" || i === "true", a = r || n && t && e(t.parentNode);
  return a;
}, LS = function(t) {
  var n, o = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return o === "" || o === "true";
}, am = function(t, n, o) {
  if (Hs(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(Ns));
  return n && Ao.call(t, Ns) && i.unshift(t), i = i.filter(o), i;
}, lm = function e(t, n, o) {
  for (var i = [], r = Array.from(t); r.length; ) {
    var a = r.shift();
    if (!Hs(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, u = e(l, !0, o);
        o.flatten ? i.push.apply(i, u) : i.push({
          scopeParent: a,
          candidates: u
        });
      } else {
        var m = Ao.call(a, Ns);
        m && o.filter(a) && (n || !t.includes(a)) && i.push(a);
        var g = a.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(a), p = !Hs(g, !1) && (!o.shadowRootFilter || o.shadowRootFilter(a));
        if (g && p) {
          var T = e(g === !0 ? a.children : g.children, !0, o);
          o.flatten ? i.push.apply(i, T) : i.push({
            scopeParent: a,
            candidates: T
          });
        } else
          r.unshift.apply(r, a.children);
      }
  }
  return i;
}, um = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, yo = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || LS(t)) && !um(t) ? 0 : t.tabIndex;
}, OS = function(t, n) {
  var o = yo(t);
  return o < 0 && n && !um(t) ? 0 : o;
}, NS = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, dm = function(t) {
  return t.tagName === "INPUT";
}, PS = function(t) {
  return dm(t) && t.type === "hidden";
}, HS = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return n;
}, FS = function(t, n) {
  for (var o = 0; o < t.length; o++)
    if (t[o].checked && t[o].form === n)
      return t[o];
}, RS = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Ps(t), o = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window != "undefined" && typeof window.CSS != "undefined" && typeof window.CSS.escape == "function")
    i = o(window.CSS.escape(t.name));
  else
    try {
      i = o(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var r = FS(i, t.form);
  return !r || r === t;
}, BS = function(t) {
  return dm(t) && t.type === "radio";
}, VS = function(t) {
  return BS(t) && !RS(t);
}, jS = function(t) {
  var n, o = t && Ps(t), i = (n = o) === null || n === void 0 ? void 0 : n.host, r = !1;
  if (o && o !== t) {
    var a, s, l;
    for (r = !!((a = i) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(i) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !r && i; ) {
      var u, m, g;
      o = Ps(i), i = (u = o) === null || u === void 0 ? void 0 : u.host, r = !!((m = i) !== null && m !== void 0 && (g = m.ownerDocument) !== null && g !== void 0 && g.contains(i));
    }
  }
  return r;
}, $d = function(t) {
  var n = t.getBoundingClientRect(), o = n.width, i = n.height;
  return o === 0 && i === 0;
}, US = function(t, n) {
  var o = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var r = Ao.call(t, "details>summary:first-of-type"), a = r ? t.parentElement : t;
  if (Ao.call(a, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || o === "legacy-full") {
    if (typeof i == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, u = Ps(t);
        if (l && !l.shadowRoot && i(l) === !0)
          return $d(t);
        t.assignedSlot ? t = t.assignedSlot : !l && u !== t.ownerDocument ? t = u.host : t = l;
      }
      t = s;
    }
    if (jS(t))
      return !t.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return $d(t);
  return !1;
}, GS = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var o = 0; o < n.children.length; o++) {
          var i = n.children.item(o);
          if (i.tagName === "LEGEND")
            return Ao.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Fs = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Hs(n) || PS(n) || US(n, t) || // For a details element with a summary, the summary element gets the focus
  HS(n) || GS(n));
}, ql = function(t, n) {
  return !(VS(n) || yo(n) < 0 || !Fs(t, n));
}, zS = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, KS = function e(t) {
  var n = [], o = [];
  return t.forEach(function(i, r) {
    var a = !!i.scopeParent, s = a ? i.scopeParent : i, l = OS(s, a), u = a ? e(i.candidates) : s;
    l === 0 ? a ? n.push.apply(n, u) : n.push(s) : o.push({
      documentOrder: r,
      tabIndex: l,
      item: i,
      isScope: a,
      content: u
    });
  }), o.sort(NS).reduce(function(i, r) {
    return r.isScope ? i.push.apply(i, r.content) : i.push(r.content), i;
  }, []).concat(n);
}, ZS = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = lm([t], n.includeContainer, {
    filter: ql.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: zS
  }) : o = am(t, n.includeContainer, ql.bind(null, n)), KS(o);
}, xS = function(t, n) {
  n = n || {};
  var o;
  return n.getShadowRoot ? o = lm([t], n.includeContainer, {
    filter: Fs.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : o = am(t, n.includeContainer, Fs.bind(null, n)), o;
}, Ko = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ao.call(t, Ns) === !1 ? !1 : ql(n, t);
}, WS = /* @__PURE__ */ im.concat("iframe").join(","), Wa = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Ao.call(t, WS) === !1 ? !1 : Fs(n, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Yl(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function qS(e) {
  if (Array.isArray(e)) return Yl(e);
}
function YS(e, t, n) {
  return (t = tM(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function XS(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function QS() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Id(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function Dd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Id(Object(n), !0).forEach(function(o) {
      YS(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Id(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function JS(e) {
  return qS(e) || XS(e) || nM(e) || QS();
}
function eM(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function tM(e) {
  var t = eM(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function nM(e, t) {
  if (e) {
    if (typeof e == "string") return Yl(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Yl(e, t) : void 0;
  }
}
var Ld = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var o = t[t.length - 1];
      o !== n && o._setPausedState(!0);
    }
    var i = t.indexOf(n);
    i === -1 || t.splice(i, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var o = t.indexOf(n);
    o !== -1 && t.splice(o, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, oM = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, rM = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, ai = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, iM = function(t) {
  return ai(t) && !t.shiftKey;
}, sM = function(t) {
  return ai(t) && t.shiftKey;
}, Od = function(t) {
  return setTimeout(t, 0);
}, Rr = function(t) {
  for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    o[i - 1] = arguments[i];
  return typeof t == "function" ? t.apply(void 0, o) : t;
}, Ui = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, aM = [], cm = function(t, n) {
  var o = (n == null ? void 0 : n.document) || document, i = (n == null ? void 0 : n.trapStack) || aM, r = Dd({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: iM,
    isKeyBackward: sM
  }, n), a = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(N, G, X) {
    return N && N[G] !== void 0 ? N[G] : r[X || G];
  }, u = function(N, G) {
    var X = typeof (G == null ? void 0 : G.composedPath) == "function" ? G.composedPath() : void 0;
    return a.containerGroups.findIndex(function(J) {
      var re = J.container, se = J.tabbableNodes;
      return re.contains(N) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (X == null ? void 0 : X.includes(re)) || se.find(function(de) {
        return de === N;
      });
    });
  }, m = function(N) {
    var G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, X = G.hasFallback, J = X === void 0 ? !1 : X, re = G.params, se = re === void 0 ? [] : re, de = r[N];
    if (typeof de == "function" && (de = de.apply(void 0, JS(se))), de === !0 && (de = void 0), !de) {
      if (de === void 0 || de === !1)
        return de;
      throw new Error("`".concat(N, "` was specified but was not a node, or did not return a node"));
    }
    var pe = de;
    if (typeof de == "string") {
      try {
        pe = o.querySelector(de);
      } catch (ve) {
        throw new Error("`".concat(N, '` appears to be an invalid selector; error="').concat(ve.message, '"'));
      }
      if (!pe && !J)
        throw new Error("`".concat(N, "` as selector refers to no known node"));
    }
    return pe;
  }, g = function() {
    var N = m("initialFocus", {
      hasFallback: !0
    });
    if (N === !1)
      return !1;
    if (N === void 0 || N && !Wa(N, r.tabbableOptions))
      if (u(o.activeElement) >= 0)
        N = o.activeElement;
      else {
        var G = a.tabbableGroups[0], X = G && G.firstTabbableNode;
        N = X || m("fallbackFocus");
      }
    else N === null && (N = m("fallbackFocus"));
    if (!N)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return N;
  }, p = function() {
    if (a.containerGroups = a.containers.map(function(N) {
      var G = ZS(N, r.tabbableOptions), X = xS(N, r.tabbableOptions), J = G.length > 0 ? G[0] : void 0, re = G.length > 0 ? G[G.length - 1] : void 0, se = X.find(function(ve) {
        return Ko(ve);
      }), de = X.slice().reverse().find(function(ve) {
        return Ko(ve);
      }), pe = !!G.find(function(ve) {
        return yo(ve) > 0;
      });
      return {
        container: N,
        tabbableNodes: G,
        focusableNodes: X,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: pe,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: J,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: re,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: se,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: de,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(Te) {
          var ot = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Xe = G.indexOf(Te);
          return Xe < 0 ? ot ? X.slice(X.indexOf(Te) + 1).find(function(Et) {
            return Ko(Et);
          }) : X.slice(0, X.indexOf(Te)).reverse().find(function(Et) {
            return Ko(Et);
          }) : G[Xe + (ot ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(N) {
      return N.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !m("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(N) {
      return N.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, T = function(N) {
    var G = N.activeElement;
    if (G)
      return G.shadowRoot && G.shadowRoot.activeElement !== null ? T(G.shadowRoot) : G;
  }, M = function(N) {
    if (N !== !1 && N !== T(document)) {
      if (!N || !N.focus) {
        M(g());
        return;
      }
      N.focus({
        preventScroll: !!r.preventScroll
      }), a.mostRecentlyFocusedNode = N, oM(N) && N.select();
    }
  }, C = function(N) {
    var G = m("setReturnFocus", {
      params: [N]
    });
    return G || (G === !1 ? !1 : N);
  }, E = function(N) {
    var G = N.target, X = N.event, J = N.isBackward, re = J === void 0 ? !1 : J;
    G = G || Ui(X), p();
    var se = null;
    if (a.tabbableGroups.length > 0) {
      var de = u(G, X), pe = de >= 0 ? a.containerGroups[de] : void 0;
      if (de < 0)
        re ? se = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : se = a.tabbableGroups[0].firstTabbableNode;
      else if (re) {
        var ve = a.tabbableGroups.findIndex(function(Na) {
          var Pa = Na.firstTabbableNode;
          return G === Pa;
        });
        if (ve < 0 && (pe.container === G || Wa(G, r.tabbableOptions) && !Ko(G, r.tabbableOptions) && !pe.nextTabbableNode(G, !1)) && (ve = de), ve >= 0) {
          var Te = ve === 0 ? a.tabbableGroups.length - 1 : ve - 1, ot = a.tabbableGroups[Te];
          se = yo(G) >= 0 ? ot.lastTabbableNode : ot.lastDomTabbableNode;
        } else ai(X) || (se = pe.nextTabbableNode(G, !1));
      } else {
        var Xe = a.tabbableGroups.findIndex(function(Na) {
          var Pa = Na.lastTabbableNode;
          return G === Pa;
        });
        if (Xe < 0 && (pe.container === G || Wa(G, r.tabbableOptions) && !Ko(G, r.tabbableOptions) && !pe.nextTabbableNode(G)) && (Xe = de), Xe >= 0) {
          var Et = Xe === a.tabbableGroups.length - 1 ? 0 : Xe + 1, Ou = a.tabbableGroups[Et];
          se = yo(G) >= 0 ? Ou.firstTabbableNode : Ou.firstDomTabbableNode;
        } else ai(X) || (se = pe.nextTabbableNode(G));
      }
    } else
      se = m("fallbackFocus");
    return se;
  }, P = function(N) {
    var G = Ui(N);
    if (!(u(G, N) >= 0)) {
      if (Rr(r.clickOutsideDeactivates, N)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: r.returnFocusOnDeactivate
        });
        return;
      }
      Rr(r.allowOutsideClick, N) || N.preventDefault();
    }
  }, F = function(N) {
    var G = Ui(N), X = u(G, N) >= 0;
    if (X || G instanceof Document)
      X && (a.mostRecentlyFocusedNode = G);
    else {
      N.stopImmediatePropagation();
      var J, re = !0;
      if (a.mostRecentlyFocusedNode)
        if (yo(a.mostRecentlyFocusedNode) > 0) {
          var se = u(a.mostRecentlyFocusedNode), de = a.containerGroups[se].tabbableNodes;
          if (de.length > 0) {
            var pe = de.findIndex(function(ve) {
              return ve === a.mostRecentlyFocusedNode;
            });
            pe >= 0 && (r.isKeyForward(a.recentNavEvent) ? pe + 1 < de.length && (J = de[pe + 1], re = !1) : pe - 1 >= 0 && (J = de[pe - 1], re = !1));
          }
        } else
          a.containerGroups.some(function(ve) {
            return ve.tabbableNodes.some(function(Te) {
              return yo(Te) > 0;
            });
          }) || (re = !1);
      else
        re = !1;
      re && (J = E({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: r.isKeyBackward(a.recentNavEvent)
      })), M(J || a.mostRecentlyFocusedNode || g());
    }
    a.recentNavEvent = void 0;
  }, D = function(N) {
    var G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = N;
    var X = E({
      event: N,
      isBackward: G
    });
    X && (ai(N) && N.preventDefault(), M(X));
  }, H = function(N) {
    (r.isKeyForward(N) || r.isKeyBackward(N)) && D(N, r.isKeyBackward(N));
  }, B = function(N) {
    rM(N) && Rr(r.escapeDeactivates, N) !== !1 && (N.preventDefault(), s.deactivate());
  }, U = function(N) {
    var G = Ui(N);
    u(G, N) >= 0 || Rr(r.clickOutsideDeactivates, N) || Rr(r.allowOutsideClick, N) || (N.preventDefault(), N.stopImmediatePropagation());
  }, x = function() {
    if (a.active)
      return Ld.activateTrap(i, s), a.delayInitialFocusTimer = r.delayInitialFocus ? Od(function() {
        M(g());
      }) : M(g()), o.addEventListener("focusin", F, !0), o.addEventListener("mousedown", P, {
        capture: !0,
        passive: !1
      }), o.addEventListener("touchstart", P, {
        capture: !0,
        passive: !1
      }), o.addEventListener("click", U, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", H, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", B), s;
  }, Z = function() {
    if (a.active)
      return o.removeEventListener("focusin", F, !0), o.removeEventListener("mousedown", P, !0), o.removeEventListener("touchstart", P, !0), o.removeEventListener("click", U, !0), o.removeEventListener("keydown", H, !0), o.removeEventListener("keydown", B), s;
  }, q = function(N) {
    var G = N.some(function(X) {
      var J = Array.from(X.removedNodes);
      return J.some(function(re) {
        return re === a.mostRecentlyFocusedNode;
      });
    });
    G && M(g());
  }, ue = typeof window != "undefined" && "MutationObserver" in window ? new MutationObserver(q) : void 0, me = function() {
    ue && (ue.disconnect(), a.active && !a.paused && a.containers.map(function(N) {
      ue.observe(N, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(N) {
      if (a.active)
        return this;
      var G = l(N, "onActivate"), X = l(N, "onPostActivate"), J = l(N, "checkCanFocusTrap");
      J || p(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = o.activeElement, G == null || G();
      var re = function() {
        J && p(), x(), me(), X == null || X();
      };
      return J ? (J(a.containers.concat()).then(re, re), this) : (re(), this);
    },
    deactivate: function(N) {
      if (!a.active)
        return this;
      var G = Dd({
        onDeactivate: r.onDeactivate,
        onPostDeactivate: r.onPostDeactivate,
        checkCanReturnFocus: r.checkCanReturnFocus
      }, N);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, Z(), a.active = !1, a.paused = !1, me(), Ld.deactivateTrap(i, s);
      var X = l(G, "onDeactivate"), J = l(G, "onPostDeactivate"), re = l(G, "checkCanReturnFocus"), se = l(G, "returnFocus", "returnFocusOnDeactivate");
      X == null || X();
      var de = function() {
        Od(function() {
          se && M(C(a.nodeFocusedBeforeActivation)), J == null || J();
        });
      };
      return se && re ? (re(C(a.nodeFocusedBeforeActivation)).then(de, de), this) : (de(), this);
    },
    pause: function(N) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, N)) : this;
    },
    unpause: function(N) {
      return a.active ? (a.manuallyPaused = !1, i[i.length - 1] !== this ? this : this._setPausedState(!1, N)) : this;
    },
    updateContainerElements: function(N) {
      var G = [].concat(N).filter(Boolean);
      return a.containers = G.map(function(X) {
        return typeof X == "string" ? o.querySelector(X) : X;
      }), a.active && p(), me(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(N, G) {
        if (a.paused === N)
          return this;
        if (a.paused = N, N) {
          var X = l(G, "onPause"), J = l(G, "onPostPause");
          X == null || X(), Z(), me(), J == null || J();
        } else {
          var re = l(G, "onUnpause"), se = l(G, "onPostUnpause");
          re == null || re(), p(), x(), me(), se == null || se();
        }
        return this;
      }
    }
  }), s.updateContainerElements(t), s;
};
function z1(e, t = {}) {
  let n;
  const p = t, { immediate: o } = p, i = Ha(p, ["immediate"]), r = Yn(!1), a = Yn(!1), s = (T) => n && n.activate(T), l = (T) => n && n.deactivate(T), u = () => {
    n && (n.pause(), a.value = !0);
  }, m = () => {
    n && (n.unpause(), a.value = !1);
  }, g = Si(() => {
    const T = Wl(e);
    return (Array.isArray(T) ? T : [T]).map((M) => {
      const C = Wl(M);
      return typeof C == "string" ? C : DS(C);
    }).filter(IS);
  });
  return qs(
    g,
    (T) => {
      T.length && (n = cm(T, he(ie({}, i), {
        onActivate() {
          r.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          r.value = !1, t.onDeactivate && t.onDeactivate();
        }
      })), o && s());
    },
    { flush: "post" }
  ), $S(() => l()), {
    hasFocus: r,
    isPaused: a,
    activate: s,
    deactivate: l,
    pause: u,
    unpause: m
  };
}
const lM = {
  name: "MenuElement",
  props: {
    element: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    toggleFn: {
      type: Function,
      default: () => {
      }
    },
    isParent: {
      type: Boolean,
      default: !1
    },
    isSubParent: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: null
    },
    cursorPointer: {
      type: Boolean,
      default: !1
    }
  }
}, uM = ["href"], dM = {
  class: "link-content",
  tabindex: "-1"
}, cM = ["href"], hM = {
  class: "link-content",
  tabindex: "-1"
}, mM = ["href", "target"], pM = {
  class: "link-content",
  tabindex: "-1"
}, fM = ["href", "target"], gM = {
  class: "link-content",
  tabindex: "-1"
};
function vM(e, t, n, o, i, r) {
  return d(), h("span", {
    class: "menu-element",
    style: j(n.theme),
    onClick: t[5] || (t[5] = (a) => n.toggleFn(n.element.id, n.isParent))
  }, [
    n.element.type === "page" ? (d(), h("a", {
      key: 0,
      href: `${n.pathPrefix}/page/${n.element.slug}`,
      class: "link",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[0] || (t[0] = z(() => {
      }, ["stop"])),
      onKeydown: t[1] || (t[1] = V(z(() => {
      }, ["stop"]), ["enter"]))
    }, [
      c("span", dM, y(n.element.name), 1)
    ], 40, uM)) : n.element.mailto ? (d(), h("a", {
      key: 1,
      href: `mailto:${n.element.email_address}`,
      class: "link",
      style: { color: "inherit", "text-decoration": "none" }
    }, [
      c("span", hM, y(n.element.name), 1)
    ], 8, cM)) : n.element.type === "link" && n.element.ipAddress ? (d(), h("a", {
      key: 2,
      href: `http://${n.element.url}`,
      target: n.element.opens_in_new_tab ? "_blank" : "",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[2] || (t[2] = z(() => {
      }, ["stop"]))
    }, [
      c("span", pM, y(n.element.name), 1)
    ], 8, mM)) : n.element.type === "link" && !n.element.ipAddress ? (d(), h("a", {
      key: 3,
      href: n.element.url,
      class: "link",
      target: n.element.opens_in_new_tab ? "_blank" : "",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[3] || (t[3] = z(() => {
      }, ["stop"])),
      onKeydown: t[4] || (t[4] = V(z(() => {
      }, ["stop"]), ["enter"]))
    }, [
      c("span", gM, y(n.element.name), 1)
    ], 40, fM)) : (d(), h("span", {
      key: 4,
      style: j({
        color: "inherit",
        "text-decoration": "none",
        cursor: n.isSubParent || n.cursorPointer ? "pointer" : "initial"
      })
    }, y(n.element.name), 5))
  ], 4);
}
const bM = /* @__PURE__ */ O(lM, [["render", vM], ["__scopeId", "data-v-90cb0a6b"]]), da = {
  components: {
    MenuElement: bM
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: Boolean
  },
  data() {
    return {
      activeIds: []
    };
  },
  computed: {
    menuIconStyle() {
      return {
        "--icon-color": this.theme.icon_color.hex
      };
    },
    translations() {
      return this.theme.translations;
    }
  },
  methods: {
    getLink(e) {
      return e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    },
    toggleOpen(e, t) {
      const n = this.activeIds.indexOf(e);
      n > -1 ? this.activeIds.splice(n, 1) : (t && (this.activeIds = []), this.activeIds.length > 1 && this.activeIds.splice(1, 1), this.activeIds.push(e));
    },
    clickStaticLink(e) {
      this.$route.fullPath !== e && this.$router.push({ path: `${e}` });
    },
    clickGeneratedLink(e, t) {
      e.type === "page" && this.$route.fullPath !== `/page/${e.slug}` ? this.$router.push({ path: `/page/${e.slug}` }) : e.type === "link" ? document.getElementById(`${e.slug || e.id}-${e.type}`).getElementsByTagName("a")[0].click() : e.children.length && this.toggleOpen(e.id, t);
    },
    getUrl(e) {
      return !e || e.type === "header" ? "" : e.type === "page" ? `${this.content.pathPrefix}/page/${e.slug}` : e.mailto && e.email_address ? `mailto:${e.email_address}` : e.ipAddress ? `http://${e.url}` : e.url;
    },
    closeMenu() {
      this.$emit("close-menu");
    }
  }
}, hm = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    currentDomain: {
      type: String,
      default: null
    },
    showSignInButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    }
  },
  components: {
    Close: $i
  },
  mixins: [ht],
  emits: ["close-menu", "toggle-search"],
  data() {
    return {
      displayMoreButton: !0,
      isMoreDropdownVisible: !1,
      isTemporarilyHideMenu: !1,
      visibleItems: [],
      underLappedItems: [],
      activeItem: null,
      parentWidth: 0,
      totalElementsWidth: 0,
      timer: null,
      moreMenuTimeout: null,
      hideMenuTimeOut: null,
      menuTimeout: null,
      debounceParentWidth: () => {
      },
      openMoreMenuDropDown: null,
      loadingMenu: !0,
      preventMouseLeaveClose: !1
    };
  },
  computed: {
    colors() {
      var e;
      return {
        "--text-color": this.theme.text_color ? this.theme.text_color.hex : "#FFFFFF",
        "--bg-color": this.theme.bg_color ? this.theme.bg_color.hex : "#014990",
        "--more-text-color": this.theme.more_text_color ? this.theme.more_text_color.hex : "FFFFFF",
        "--more-bg-color": this.theme.more_bg_color ? this.theme.more_bg_color.hex : "#014990",
        "--dropdown-text-color": this.theme.dropdown_text_color ? this.theme.dropdown_text_color.hex : "#333",
        "--dropdown-bg-color": this.theme.dropdown_bg_color ? this.theme.dropdown_bg_color.hex : "#FFFFFF",
        "--explore-menu-text-color": this.theme.explore_menu_text_color ? this.theme.explore_menu_text_color.hex : "#333333",
        "--explore-menu-bg-color": this.theme.explore_menu_bg_color ? this.theme.explore_menu_bg_color.hex : "#FFFFFF",
        "--schools-menu-text-color": this.theme.schools_menu_text_color ? this.theme.schools_menu_text_color.hex : "#333333",
        "--schools-menu-bg-color": this.theme.schools_menu_bg_color ? this.theme.schools_menu_bg_color.hex : "#FFFFFF",
        "--icon-bg-color": this.theme.icon_bg_color ? this.theme.icon_bg_color.hex : "#014990",
        "--icon-text-color": this.theme.icon_bg_color ? this.theme.icon_text_color.hex : "#014990",
        "--icon-color": this.theme.icon_color ? this.theme.icon_color.hex : "#014990",
        "--nav-color": this.theme.navigation_color ? this.theme.navigation_color.hex : "#014990",
        "--nav-icon-color": this.theme.navigation_icon_color ? this.theme.navigation_icon_color.hex : "#FFFFFF",
        "--nav-icon-bg-color": this.theme.navigation_icon_bg_color ? (e = this.theme.navigation_icon_bg_color) == null ? void 0 : e.hex : "#014990",
        "--utility-link-color": this.theme.utility_link_color ? this.theme.utility_link_color.hex : "#000000",
        "--utility-bg-color": this.theme.utility_bg_color ? this.theme.utility_bg_color.hex : "#FFFFFF"
      };
    },
    mobileMenuItems() {
      return [
        {
          id: "explore-header",
          name: "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    barNavOptions() {
      return he(ie(ie({}, this.theme), this.content.menuOptions), {
        translations: this.theme.translations || this.content.menuOptions.translations
      });
    },
    signInText() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.translations) == null ? void 0 : t.sign_in_button_title) || "Sign in";
    }
  },
  watch: {
    parentWidth() {
      this.displayMoreButton = !0, this.debounceParentWidth.flush(), this.$nextTick(this.calculateUnderlappedItems.bind(this));
    },
    isMoreDropdownVisible() {
      this.isMoreDropdownVisible && this.handleDrawerToggle();
    }
  },
  mounted() {
    this.loadingMenu = !1;
    let e = 0;
    if (this.isMobile) return;
    const t = this.$refs["bar-nav-item-wrapper"];
    Object.entries(t.childNodes).forEach((n) => {
      var o;
      if (this.theme.version === "M5") {
        const r = Array.from(n[1].childNodes).find((a) => a.className === "bar-menu-item");
        r && (e += r.clientWidth);
      } else ((o = n[1]) == null ? void 0 : o.className) === "m4--menu-item" && (e += n[1].clientWidth);
    }), this.totalElementsWidth = e, this.updateParentWidth(), this.debounceParentWidth = pi(this.updateParentWidth.bind(this), 30), window.addEventListener("resize", this.debounceParentWidth), window.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debounceParentWidth), window.removeEventListener("keydown", this.onKeydown);
  },
  created() {
    this.visibleItems = this.content.sitemapMenuItems;
  },
  methods: {
    canTriggerCloseFirstItem(e, t, n) {
      const o = (r) => n === "exploreButton" || n === "schoolsButton" || r.type !== "header" && r.children.length === 0 || r.type !== "header" && r.children.length > 0 && !t || r.type === "header" && t && r.children.length > 0, i = this.activeItem.children.findIndex(o);
      if (i !== -1) {
        const r = this.activeItem.children[i];
        return e === r.id;
      }
      return !1;
    },
    canTriggerCloseLastItem(e, t, n) {
      const o = (u) => n === "exploreButton" || n === "schoolsButton" || u.type !== "header" && u.children.length === 0 || !!u.children.length, i = this.activeItem.children.findLastIndex(o), r = this.activeItem.children[i];
      if (n === "exploreButton" || n === "schoolsButton")
        return e === r.id;
      const a = e === r.id && !r.children.length, s = e === r.id && t && !r.childrenVisible, l = e === r.id && t && (r.children.length === 0 || r.children.findLastIndex(o) === -1);
      if (a || s || l)
        return e === r.id;
      if (r.childrenVisible && r.children.findLastIndex(o) !== -1) {
        const u = r.children.findLastIndex(o), m = r.children[u].id;
        return e == m;
      }
    },
    toggleParentCollapsible({ itemId: e }) {
      const t = this.activeItem.children.findIndex((o) => o.id === e);
      this.activeItem.children.filter((o) => o.id !== e).forEach(
        (o) => this.activeItem.children[this.activeItem.children.indexOf(o)].childrenVisible = !1
      ), this.activeItem.children[t].childrenVisible = !this.activeItem.children[t].childrenVisible;
    },
    nextTabAction({ itemId: e, isIconButton: t, isBackwardsTab: n }, o) {
      const i = this.canTriggerCloseFirstItem(e, t, o), r = this.canTriggerCloseLastItem(e, t, o);
      if (i && n) {
        this.handleClose();
        return;
      }
      if (r && !n) {
        this.handleClose();
        return;
      }
    },
    onKeydown(e) {
      e.key === "Escape" && !An(this.activeItem) && this.handleClose();
    },
    temporalHide() {
      this.isMoreDropdownVisible = !1, this.isTemporarilyHideMenu = !0;
    },
    handleDropdownMenuOpen(e) {
      clearTimeout(this.openMoreMenuDropDown), this.openMoreMenuDropDown = setTimeout(() => {
        this.onMenuItemClick(e);
      }, 300);
    },
    preventClose(e) {
      this.preventMouseLeaveClose = !1, clearTimeout(this.moreMenuTimeout), clearTimeout(this.menuTimeout), clearTimeout(this.hideMenuTimeOut), clearTimeout(this.openMoreMenuDropDown), this.onMenuItemClick(e, !0);
    },
    preventCloseDrawer() {
      this.preventMouseLeaveClose = !0;
    },
    onMenuItemClick(e, t) {
      if (t && this.hideMoreMenu(), !e) {
        this.hideDrawer();
        return;
      }
      this.$emit("close-menu"), this.activeItem = e;
    },
    focusSubMenu(e) {
      this.activeItem = e;
      const n = this.$refs[`drawer-${e.id}`][0].$refs["drawer-wrapper"];
      n.tabIndex = 0, n.focus(), this.hideMoreMenu();
    },
    handleDrawerToggle(e) {
      if (e) {
        if (e.id === "schoolsbutton" && this.content.hasCustomSchoolsMenu && this.customSchoolsMenuVisible === !1 ? this.showItem(e) : this.customSchoolsMenuVisible = !1, !this.activeItem) {
          this.hideDrawer(), this.activeItem = e;
          return;
        }
        if (!e || !e.children || !e.children.length) {
          this.hideDrawer();
          return;
        }
        e.id === this.activeItem.id ? this.hideDrawer() : this.activeItem = e;
      }
    },
    handleMoreMenuToggle(e) {
      clearTimeout(this.moreMenuTimeout), clearTimeout(this.hideMenuTimeOut), clearTimeout(this.menuTimeout), this.moreMenuTimeout = setTimeout(() => {
        this.$emit("close-menu"), e ? this.isMoreDropdownVisible = e : this.isMoreDropdownVisible = !this.isMoreDropdownVisible;
      }, 220);
    },
    handleClose(e) {
      this.hideDrawer(e), this.hideMoreMenu();
    },
    hideMoreMenu() {
      this.isMoreDropdownVisible = !1;
    },
    showDrawer(e) {
      var t, n, o;
      return ((t = this.activeItem) == null ? void 0 : t.id) === e.id && ((o = (n = this.activeItem) == null ? void 0 : n.children) == null ? void 0 : o.length) > 0;
    },
    hideDrawer(e) {
      (!this.preventMouseLeaveClose || e !== "mouseleave") && (this.activeItem = null);
    },
    updateParentWidth() {
      this.parentWidth = this.getWrapperWidth();
    },
    getWrapperWidth() {
      const e = this.theme.version === "M5" ? this.$refs["bar-nav-menu-bar"] : this.$refs["m4-menu--bar"], t = window.getComputedStyle(e, null).getPropertyValue("padding-left"), n = window.getComputedStyle(e, null).getPropertyValue("padding-right");
      return e.clientWidth - parseInt(t, 10) - parseInt(n, 10);
    },
    calculateUnderlappedItems() {
      var i;
      let e = 0;
      const t = {}, n = this.$refs["bar-nav-item-wrapper"];
      let o = this.getWrapperWidth();
      if (this.theme.version === "M5") {
        this.$refs["bar-end-options"];
        const r = ((i = this.$refs["bar-end-options"]) == null ? void 0 : i.clientWidth) || 0;
        o -= r;
      }
      this.visibleItems = this.content.sitemapMenuItems, clearTimeout(this.timer), this.timer = setTimeout(() => {
        this.totalElementsWidth > o ? (this.displayMoreButton = !0, o -= this.moreBtnWidth) : this.displayMoreButton = !1, Object.entries(n.childNodes).forEach((s) => {
          if (this.theme.version === "M5") {
            const u = Array.from(s[1].childNodes).find((m) => m.className === "bar-menu-item");
            u && (e += u.clientWidth, e > o && (t[u.id] = u));
          } else s[1].className === "m4--menu-item" && (e += s[1].clientWidth, e > o && (t[s[1].id] = s[1]));
        });
        const r = Object.entries(t).map(([s, l]) => this.content.sitemapMenuItems.find((u) => +u.id == +s)).sort((s, l) => s.position - l.position), a = this.content.sitemapMenuItems.filter((s) => !r.find((l) => s && l && s.id === l.id)).sort((s, l) => s.position - l.position);
        this.underLappedItems = r, this.visibleItems = a;
      }, 50);
    },
    navigate(e) {
      let t;
      if (!e)
        return null;
      switch (e.type) {
        case "page":
          t = `${this.content.pathPrefix}/page/${e.slug}`;
          break;
        case "link":
          e.mailto && e.email_address ? t = `mailto:${e.email_address}` : t = e.url;
          break;
        case "explore":
          t = this.content.pathPrefix + e.slug;
          break;
        default:
          return null;
      }
      return e.opens_in_new_tab ? window.open(t) : window.location.href = t, null;
    },
    showItem(e) {
      this.customSchoolsMenuVisible = !1, e.id === "schoolsbutton" && this.content.hasCustomSchoolsMenu && (this.customSchoolsMenuVisible = !0), clearTimeout(this.menuTimeout), this.menuTimeout = setTimeout(() => {
        this.onMenuItemClick(e, !0);
      }, 220);
    },
    mouseLeaveMenu() {
      clearTimeout(this.menuTimeout), clearTimeout(this.moreMenuTimeout), clearTimeout(this.hideMenuTimeOut), this.hideMenuTimeOut = setTimeout(() => {
        this.content.hasCustomSchoolsMenu && (this.customSchoolsMenuVisible = !1), this.handleClose("mouseleave");
      }, 600);
    },
    mouseEnterMenu() {
      this.hideMenuTimeOut && clearTimeout(this.hideMenuTimeOut);
    }
  }
}, yM = {
  name: "MenuItemType",
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    moreMenuTitle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    }
  },
  emits: ["handle-header-click"],
  computed: {
    href() {
      if (!this.item)
        return null;
      switch (this.item.type) {
        case "page":
          return `${this.pathPrefix}/page/${this.item.slug}`;
        case "link":
          return this.getLinkHref;
        case "explore":
          return this.getExploreHref;
        case "header":
          return null;
        default:
          return null;
      }
    },
    iconVisible() {
      return (this.item.icon || this.item.icon_cms) && this.item.id !== "explore-button" && this.item.id !== "schoolsbutton";
    },
    noChildren() {
      var e;
      return ((e = this.item.children) == null ? void 0 : e.length) === 0;
    },
    getExploreHref() {
      var e;
      return (e = this.item.slug) != null && e.includes("http") ? this.item.slug : this.pathPrefix + this.item.slug;
    },
    getLinkHref() {
      return this.item ? this.item.mailto && this.item.email_address ? `mailto:${this.item.email_address}` : this.item.ipAddress ? `http://${this.item.url}` : this.item.url : null;
    },
    colors() {
      return {
        "--icon-fill-color": this.fillColor
      };
    }
  }
}, _M = { class: "m4--menu-item-focusable" }, CM = ["innerHTML"], wM = ["href", "target"], TM = { key: 0 };
function kM(e, t, n, o, i, r) {
  return d(), h("span", _M, [
    r.iconVisible ? (d(), h("div", {
      key: 0,
      class: v(["item-icon", { "global-icon": n.item.cms_icon_id }]),
      style: j(r.colors),
      innerHTML: n.item.cms_icon_id ? n.item.icon_cms : n.item.icon
    }, null, 14, CM)) : r.href ? (d(), h("a", {
      key: 1,
      href: r.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "m4--menu-item-link"
    }, y(n.item.name), 9, wM)) : (d(), h(Y, { key: 2 }, [
      n.moreMenuTitle ? (d(), h("span", TM, y(n.moreMenuTitle), 1)) : (d(), h("span", {
        key: 1,
        class: v(["item-type-header", { "no-children": r.noChildren }]),
        onClick: t[0] || (t[0] = (a) => e.$emit("handle-header-click"))
      }, y(n.item.translatedTitle || n.item.name), 3))
    ], 64))
  ]);
}
const mm = /* @__PURE__ */ O(yM, [["render", kM], ["__scopeId", "data-v-09de12df"]]), EM = {
  name: "M4MainItem",
  components: { MenuItemType: mm, DropdownArrowIcon: kr },
  props: {
    item: {
      type: Object,
      default: void 0
    },
    forceShow: Boolean,
    moreMenuItem: {
      type: String,
      default: null
    },
    moreMenuVisible: Boolean,
    isMoreMenuItem: Boolean,
    themeStyle: {
      type: String,
      default: null
    },
    colors: {
      type: Object,
      default: null
    },
    activeId: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    firstItemId: {
      type: Number,
      default: 0
    },
    lastItemId: {
      type: Number,
      default: 0
    }
  },
  emits: ["toggle-more-menu", "close", "toggle-drawer", "navigate", "mouseover", "focus-sub-menu"],
  computed: {
    isActive() {
      var e;
      return this.moreMenuItem ? this.moreMenuVisible : ((e = this.item) == null ? void 0 : e.id) === this.activeId;
    },
    iconClass() {
      return this.isActive ? "open" : void 0;
    },
    iconColor() {
      if (this.colors)
        return this.isMoreMenuItem ? this.colors["--more-text-color"] : this.colors["--text-color"];
    },
    itemId() {
      return this.moreMenuItem ? "more-menu-item" : this.item ? this.item.id : "";
    },
    hasChildren() {
      var e, t;
      return !!((t = (e = this.item) == null ? void 0 : e.children) != null && t.length);
    },
    hasFocusableChildren() {
      var t, n, o;
      const e = (i) => {
        var r;
        return [i, ...((r = i.children) == null ? void 0 : r.map((a) => e(a))) || []].flat();
      };
      return (o = (n = (t = this.item.children) == null ? void 0 : t.map((i) => e(i))) == null ? void 0 : n.flat()) == null ? void 0 : o.filter((i) => i.type !== "header").length;
    },
    isHeader() {
      var e;
      return ((e = this.item) == null ? void 0 : e.type) === "header";
    },
    hasSlug() {
      var e;
      return (e = this.item) == null ? void 0 : e.slug;
    },
    ariaId() {
      return this.moreMenuItem ? "menu-button-more" : `menu-button-${this.item ? this.item.id : ""}`;
    },
    ariaHasPopup() {
      return this.moreMenuItem ? "true" : this.hasChildren ? "dialog" : "false";
    },
    ariaControls() {
      return this.moreMenuItem ? "more-menu-dropdown" : this.hasChildren ? `drawer-${this.item ? this.item.id : ""}` : void 0;
    },
    ariaExpanded() {
      if (this.moreMenuItem)
        return this.moreMenuVisible ? "true" : "false";
      if (this.hasChildren)
        return this.isActive ? "true" : "false";
    },
    ariaLabel() {
      if (!this.isHeader && this.hasChildren)
        return `Toggle ${this.item.name} Submenu`;
    },
    showTransition() {
      var e, t;
      return ((t = (e = this.item) == null ? void 0 : e.children) == null ? void 0 : t.length) > 0 && !this.isMoreMenuItem && !this.moreMenuItem && this.isActive;
    }
  },
  methods: {
    handleEnterEvent(e) {
      if (this.moreMenuItem) {
        this.$emit("toggle-more-menu", !this.moreMenuVisible);
        return;
      }
      if (!this.item) {
        this.$emit("close");
        return;
      }
      if (this.isHeader || e === !0) {
        this.$emit("toggle-drawer", this.item);
        return;
      }
      this.$emit("navigate", this.item);
    },
    /**  handling this behavior here because M4MainItem is shared.
     M4MainItem is found in the top level of the Menu Items in the bar
     and within the More Dropdown**/
    handleNextTab(e, t) {
      var s, l;
      const n = e.shiftKey, o = this.isActive, i = this.activeId && o, r = ((s = this.item) == null ? void 0 : s.id) === this.firstItemId, a = ((l = this.item) == null ? void 0 : l.id) === this.lastItemId;
      if (n) {
        if (this.isMoreMenuItem && r && !t) {
          this.$emit("close");
          return;
        }
        if (!this.isMoreMenuItem && o) {
          this.$emit("close");
          return;
        }
        if (a && t && this.hasChildren && i) {
          this.$emit("close");
          return;
        }
      } else {
        if (i && (t && this.hasFocusableChildren || this.isHeader)) {
          this.$emit("focus-sub-menu", this.item);
          return;
        }
        if (this.moreMenuItem === "More") return;
        this.hasFocusableChildren === 0 && !this.isMoreMenuItem && o && this.$emit("close"), a && (!this.hasChildren || t && this.hasChildren && !i) && this.$emit("close");
      }
    }
  }
}, SM = ["id"], MM = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-label"], AM = ["id"], $M = ["aria-expanded", "aria-label", "aria-haspopup", "aria-controls"], IM = {
  class: "m4--menu-item-focusable",
  tabindex: "-1"
}, DM = { class: "sr-only" }, LM = { class: "sr-only" }, OM = {
  key: 0,
  class: "m4--menu-item-active-line"
};
function NM(e, t, n, o, i, r) {
  const a = $("MenuItemType"), s = $("DropdownArrowIcon");
  return n.forceShow || n.moreMenuItem || n.item ? (d(), h("div", {
    key: 0,
    id: r.itemId,
    ref: r.itemId,
    class: v(["m4--menu-item", {
      "m4--menu-dropdown-item": n.isMoreMenuItem,
      "m4--menu-item-active": !n.isMoreMenuItem && r.isActive
    }]),
    onMouseover: t[13] || (t[13] = z((l) => e.$emit("mouseover", n.item), ["stop", "prevent"])),
    onClick: t[14] || (t[14] = z((...l) => r.handleEnterEvent && r.handleEnterEvent(...l), ["exact", "stop", "prevent"])),
    onTouchstart: t[15] || (t[15] = z((...l) => r.handleEnterEvent && r.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
  }, [
    n.item && n.item.type === "header" && r.hasChildren || n.moreMenuItem === "More" ? (d(), h("button", {
      key: 0,
      id: r.ariaId,
      "aria-controls": r.ariaControls,
      "aria-expanded": r.ariaExpanded,
      "aria-haspopup": r.ariaHasPopup,
      class: v(["m4--menu-item-text", {
        "m4--menu-dropdown-item-active": r.isActive,
        [n.themeStyle]: !!n.themeStyle
      }]),
      "aria-label": n.moreMenuItem === "More" ? "Show submenu for More" : `Show submenu for ${n.item && n.item.name}`,
      onKeydown: [
        t[0] || (t[0] = V(z((l) => r.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"])),
        t[1] || (t[1] = V((l) => r.handleNextTab(l, !0), ["tab"]))
      ],
      onTouchstart: t[2] || (t[2] = z((...l) => r.handleEnterEvent && r.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
    }, [
      L(a, {
        "path-prefix": n.pathPrefix,
        "more-menu-title": n.moreMenuItem,
        item: n.item
      }, null, 8, ["path-prefix", "more-menu-title", "item"])
    ], 42, MM)) : (d(), h("div", {
      key: 1,
      id: r.ariaId,
      class: v(["m4--menu-item-text", {
        "m4--menu-dropdown-item-active": r.isActive,
        [n.themeStyle]: !!n.themeStyle
      }])
    }, [
      L(a, {
        "path-prefix": n.pathPrefix,
        "more-menu-title": n.moreMenuItem,
        item: n.item,
        onKeydown: t[3] || (t[3] = V((l) => r.handleNextTab(l), ["tab"]))
      }, null, 8, ["path-prefix", "more-menu-title", "item"])
    ], 10, AM)),
    r.isHeader ? b("", !0) : (d(), h(Y, { key: 2 }, [
      r.hasChildren ? (d(), h("button", {
        key: 0,
        class: "m4--menu-item-icon",
        "aria-expanded": r.ariaExpanded,
        "aria-label": r.ariaLabel,
        "aria-haspopup": r.ariaHasPopup,
        "aria-controls": r.ariaControls,
        onKeydown: [
          t[4] || (t[4] = V(z((l) => r.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"])),
          t[5] || (t[5] = V((l) => r.handleNextTab(l, !0), ["tab"]))
        ],
        onTouchstart: t[6] || (t[6] = z((l) => r.handleEnterEvent(!0), ["exact", "stop", "prevent"])),
        onClick: t[7] || (t[7] = z((l) => r.handleEnterEvent(!0), ["stop", "prevent"]))
      }, [
        c("span", IM, [
          L(s, {
            "dropdown-class": r.iconClass,
            "fill-color": r.iconColor
          }, null, 8, ["dropdown-class", "fill-color"]),
          c("span", DM, " Show submenu for " + y(n.item && n.item.name), 1)
        ])
      ], 40, $M)) : b("", !0)
    ], 64)),
    r.isHeader || n.moreMenuItem ? (d(), h(Y, { key: 3 }, [
      n.moreMenuItem || r.hasChildren ? (d(), h("span", {
        key: 0,
        class: "m4--menu-item-icon",
        onMouseover: t[8] || (t[8] = z(() => {
        }, ["stop", "prevent"])),
        onTouchstart: t[9] || (t[9] = z((...l) => r.handleEnterEvent && r.handleEnterEvent(...l), ["exact", "stop", "prevent"])),
        onKeydown: [
          t[10] || (t[10] = V((l) => r.handleNextTab(l, !0), ["tab"])),
          t[12] || (t[12] = V(z((l) => r.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"]))
        ],
        onClick: t[11] || (t[11] = z((...l) => r.handleEnterEvent && r.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
      }, [
        L(s, {
          "dropdown-class": r.iconClass,
          "fill-color": r.iconColor
        }, null, 8, ["dropdown-class", "fill-color"]),
        c("span", LM, " Show submenu for " + y(n.item && n.item.name), 1)
      ], 32)) : b("", !0)
    ], 64)) : b("", !0),
    L(Ee, { name: "slide-fade-up" }, {
      default: _(() => [
        r.showTransition ? (d(), h("hr", OM)) : b("", !0)
      ]),
      _: 1
    })
  ], 42, SM)) : b("", !0);
}
const pm = /* @__PURE__ */ O(EM, [["render", NM], ["__scopeId", "data-v-b1ec7e1d"]]), PM = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, HM = ["fill"];
function FM(e, t, n, o, i, r) {
  return d(), h("svg", {
    class: "plus",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, t[0] || (t[0] = [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.85721 0H7.14293V7.14283H0V7.85714H7.14293V15H7.85721V7.85714H15V7.14283H7.85721V0Z"
    }, null, -1)
  ]), 8, HM);
}
const fm = /* @__PURE__ */ O(PM, [["render", FM]]), RM = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, BM = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, VM = ["fill"];
function jM(e, t, n, o, i, r) {
  return d(), h("svg", BM, [
    c("path", {
      fill: n.fillColor,
      d: "M2 7.5V8.5H14V7.5H2Z"
    }, null, 8, VM)
  ]);
}
const gm = /* @__PURE__ */ O(RM, [["render", jM]]), UM = {
  name: "ImageElement",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    href() {
      return this.item ? this.item.url : null;
    }
  }
}, GM = {
  class: "m4--menu-item-focusable",
  tabindex: "-1"
}, zM = ["src", "alt"];
function KM(e, t, n, o, i, r) {
  return d(), h("span", GM, [
    (d(), k(K(r.href ? "a" : "div"), {
      href: r.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "m4--menu-item-link",
      tabindex: "-1"
    }, {
      default: _(() => [
        c("img", {
          src: n.item.imgSrc,
          alt: n.item.altText
        }, null, 8, zM)
      ]),
      _: 1
    }, 8, ["href", "target"]))
  ]);
}
const ZM = /* @__PURE__ */ O(UM, [["render", KM], ["__scopeId", "data-v-a0cf2cf9"]]), xM = {
  name: "M4DrawerElement",
  components: { MenuItemType: mm, ImageElement: ZM, MenuPlusIcon: fm, MenuMinusIcon: gm, DropdownArrowIcon: kr },
  props: {
    elemData: {
      type: Object,
      default: null
    },
    themeStyle: {
      type: String,
      default: ""
    },
    isMobile: Boolean,
    colors: {
      type: Object,
      default: void 0
    },
    activeParent: {
      type: [String, Number],
      default: null
    },
    activeChild: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    nestLevel: {
      type: Number,
      default: 0
    },
    newMobileHeaderElement: Boolean
  },
  emits: ["navigate", "toggle-child", "toggle-parent", "next-tab"],
  computed: {
    iconColor() {
      if (this.colors)
        return this.isMobile && this.newMobileHeaderElement ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"];
    },
    hasChildren() {
      var e;
      return !!((e = this.elemData) != null && e.children.length);
    },
    showChildren() {
      return Number.isNaN(+this.activeParent) ? this.activeParent === this.elemData.id : +this.activeParent == +this.elemData.id;
    },
    isChild() {
      return this.nestLevel >= 1;
    },
    isSubChild() {
      return this.nestLevel >= 2;
    },
    ariaParentId() {
      return `menu-button-${this.elemData.id}`;
    },
    ariaExpanded() {
      if (this.hasChildren)
        return this.showChildren ? "true" : "false";
    },
    ariaControls() {
      if (this.hasChildren)
        return this.ariaChildId;
    },
    ariaChildId() {
      return `${this.elemData.id}-collapsible`;
    },
    ariaHasPopup() {
      return this.hasChildren ? "true" : "false";
    }
  },
  methods: {
    toggleParentCollapsible() {
      this.$emit("toggle-parent", this.elemData);
    },
    handleEnterEvent() {
      this.$emit("navigate", this.elemData);
    },
    handleNextTab(e, t, n) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    }
  }
}, WM = ["id"], qM = ["id"], YM = ["aria-expanded", "aria-controls", "aria-haspopup"], XM = {
  class: "m4--drawer-element-focusable",
  tabindex: "-1"
}, QM = {
  key: 3,
  class: "sr-only"
}, JM = ["id", "aria-labelledby"];
function eA(e, t, n, o, i, r) {
  const a = $("ImageElement"), s = $("MenuItemType"), l = $("MenuPlusIcon"), u = $("MenuMinusIcon"), m = $("DropdownArrowIcon"), g = $("M4DrawerElement", !0);
  return d(), h("div", {
    role: "menuitem",
    class: v(["m4--drawer-element", {
      "mobile-element": n.isMobile,
      "new-mobile-header": n.newMobileHeaderElement,
      "child-element": r.isChild,
      "has-children": r.hasChildren,
      "has-icon": n.elemData.icon || n.elemData.icon_cms,
      "sub-child": r.isSubChild,
      "image-element": n.elemData.type === "image"
    }]),
    style: j(n.colors)
  }, [
    c("div", {
      id: n.elemData.id,
      class: "m4--drawer-element-title",
      onClick: t[4] || (t[4] = (...p) => r.toggleParentCollapsible && r.toggleParentCollapsible(...p))
    }, [
      c("div", {
        id: r.ariaParentId,
        class: v(["m4--drawer-element-title-text", n.themeStyle]),
        onClick: t[1] || (t[1] = z(() => {
        }, ["stop"]))
      }, [
        n.elemData.type === "image" ? (d(), k(a, {
          key: 0,
          item: n.elemData
        }, null, 8, ["item"])) : (d(), k(s, {
          key: 1,
          "path-prefix": n.pathPrefix,
          item: n.elemData,
          "fill-color": r.iconColor,
          onHandleHeaderClick: r.toggleParentCollapsible,
          onKeydown: [
            t[0] || (t[0] = V((p) => r.handleNextTab(n.elemData.id, !1, p.shiftKey), ["tab"])),
            V(r.handleEnterEvent, ["enter"])
          ]
        }, null, 8, ["path-prefix", "item", "fill-color", "onHandleHeaderClick", "onKeydown"]))
      ], 10, qM),
      n.elemData.children.length ? (d(), h(Y, { key: 0 }, [
        n.elemData.children.length ? (d(), h("button", {
          key: 0,
          "aria-expanded": r.ariaExpanded,
          "aria-controls": r.ariaControls,
          "aria-haspopup": r.ariaHasPopup,
          class: "m4--drawer-element-title-icon",
          onClick: t[2] || (t[2] = z((...p) => r.toggleParentCollapsible && r.toggleParentCollapsible(...p), ["stop", "prevent"])),
          onKeydown: t[3] || (t[3] = V((p) => r.handleNextTab(n.elemData.id, !0, p.shiftKey), ["tab"]))
        }, [
          c("span", XM, [
            n.isMobile && !r.showChildren ? (d(), k(l, {
              key: 0,
              "fill-color": r.iconColor
            }, null, 8, ["fill-color"])) : n.isMobile && r.showChildren ? (d(), k(u, {
              key: 1,
              "fill-color": r.iconColor
            }, null, 8, ["fill-color"])) : b("", !0),
            n.isMobile ? b("", !0) : (d(), k(m, {
              key: 2,
              "fill-color": r.iconColor,
              "dropdown-class": r.showChildren ? "open" : "close"
            }, null, 8, ["fill-color", "dropdown-class"])),
            n.elemData && n.elemData.name ? (d(), h("span", QM, " Show submenu for " + y(n.elemData.name), 1)) : b("", !0)
          ])
        ], 40, YM)) : b("", !0)
      ], 64)) : b("", !0)
    ], 8, WM),
    L(Ee, { name: "collapse-in" }, {
      default: _(() => [
        r.hasChildren ? ge((d(), h("div", {
          key: 0,
          id: r.ariaChildId,
          "aria-labelledby": r.ariaParentId,
          class: v(["m4--drawer-children", { "show-children": r.showChildren }])
        }, [
          (d(!0), h(Y, null, ee(n.elemData.children, (p) => (d(), k(g, {
            key: p.id,
            "elem-data": p,
            "is-mobile": n.isMobile,
            "theme-style": n.themeStyle,
            "active-parent": n.activeChild,
            "path-prefix": n.pathPrefix,
            colors: n.colors,
            "new-mobile-header-element": n.newMobileHeaderElement,
            "nest-level": n.nestLevel + 1,
            onToggleParent: t[5] || (t[5] = (T) => e.$emit("toggle-child", T)),
            onNextTab: (T) => r.handleNextTab(p.id, !1, T.isBackwardsTab),
            onNavigate: t[6] || (t[6] = (T) => e.$emit("navigate", T))
          }, null, 8, ["elem-data", "is-mobile", "theme-style", "active-parent", "path-prefix", "colors", "new-mobile-header-element", "nest-level", "onNextTab"]))), 128))
        ], 10, JM)), [
          [Sn, r.showChildren]
        ]) : b("", !0)
      ]),
      _: 1
    })
  ], 6);
}
const vm = /* @__PURE__ */ O(xM, [["render", eA], ["__scopeId", "data-v-4331a2f6"]]), tA = {
  name: "M4MobileMenu",
  components: { M4DrawerElement: vm },
  props: {
    isVisible: {
      type: Boolean,
      default: !1
    },
    menuItems: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Object,
      default: void 0
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  emits: ["navigate", "close-menu"],
  data() {
    return {
      activeParent: null,
      activeChild: null,
      localItems: []
    };
  },
  computed: {
    styles() {
      return ie({}, this.colors);
    }
  },
  beforeUpdate() {
    this.isVisible || (this.activeParent = null, this.activeChild = null);
  },
  mounted() {
    this.localItems = this.menuItems.filter((e) => e.name === "Explore" ? e.children && e.children.length >= 1 : !0), this.$parent.$parent.$refs.schoolsbutton && this.$parent.$parent.$refs.schoolsbutton.$el.addEventListener("focus", this.$emit("close-menu")), this.$parent.$parent.$refs.schoolsbuttonMobile && this.$parent.$parent.$refs.schoolsbuttonMobile.$el.addEventListener("focus", this.$emit("close-menu"));
  },
  beforeUnmount() {
    this.$parent.$parent.$refs.schoolsbutton && this.$parent.$parent.$refs.schoolsbutton.$el.removeEventListener("focus", this.$emit("close-menu")), this.$parent.$parent.$refs.schoolsbuttonMobile && this.$parent.$parent.$refs.schoolsbuttonMobile.$el.removeEventListener("focus", this.$emit("close-menu"));
  },
  methods: {
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null;
        return;
      }
      this.activeParent = e.id;
    },
    handleToggleChild(e) {
      if (!e) {
        this.activeChild = null;
        return;
      }
      if (e.id === this.activeChild) {
        this.activeChild = null;
        return;
      }
      this.activeChild = e.id;
    },
    handleNavigate(e) {
      this.$emit("navigate", e);
    }
  }
};
function nA(e, t, n, o, i, r) {
  const a = $("M4DrawerElement");
  return d(), k(Ee, { name: "slide-fade-up" }, {
    default: _(() => [
      ge(c("div", {
        style: j(r.styles),
        class: "m4-menu--mobile-wrapper"
      }, [
        (d(!0), h(Y, null, ee(i.localItems, (s) => (d(), k(a, {
          ref_for: !0,
          ref: "drawerElement",
          key: `${s.name}-${s.id}`,
          "elem-data": s,
          "is-mobile": !0,
          colors: n.colors,
          "active-parent": i.activeParent,
          "active-child": i.activeChild,
          "path-prefix": n.pathPrefix,
          onToggleParent: r.handleToggleParent,
          onToggleChild: r.handleToggleChild,
          onNavigate: r.handleNavigate
        }, null, 8, ["elem-data", "colors", "active-parent", "active-child", "path-prefix", "onToggleParent", "onToggleChild", "onNavigate"]))), 128))
      ], 4), [
        [Sn, n.isVisible]
      ])
    ]),
    _: 1
  });
}
const oA = /* @__PURE__ */ O(tA, [["render", nA], ["__scopeId", "data-v-5d2991ec"]]), rA = {
  name: "M4MoreMenuDropdown",
  components: { M4MainItem: pm },
  props: {
    isVisible: {
      type: Boolean,
      default: !1
    },
    dropdownId: {
      type: String,
      default: "h4-menu--dropdown"
    },
    moreItems: {
      type: Array,
      default: () => []
    },
    activeId: {
      type: [String, Number],
      default: null
    },
    colors: {
      type: Object,
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  emits: ["mouseleave", "toggle-drawer", "navigate", "open", "close", "toggle-more-menu", "focus-sub-menu"],
  computed: {
    ariaId() {
      return "more-menu-dropdown";
    },
    ariaLabelledBy() {
      return "menu-button-more";
    },
    ariaExpanded() {
      return this.isVisible ? "true" : "false";
    },
    lastItemId() {
      const e = (n) => {
        var o;
        return n.type !== "header" || ((o = n.children) == null ? void 0 : o.length) > 0;
      }, t = this.moreItems.findLastIndex(e);
      return this.moreItems[t].id;
    },
    firstItemId() {
      var n;
      const e = (o) => {
        var i;
        return o.type !== "header" || ((i = o.children) == null ? void 0 : i.length) > 0;
      }, t = this.moreItems.findIndex(e);
      return (n = this.moreItems[t]) == null ? void 0 : n.id;
    }
  }
}, iA = ["id", "aria-labelledby", "aria-expanded"];
function sA(e, t, n, o, i, r) {
  const a = $("M4MainItem");
  return d(), h("div", {
    id: r.ariaId,
    "aria-labelledby": r.ariaLabelledBy,
    "aria-expanded": r.ariaExpanded,
    class: "m4-menu--dropdown-item-wrapper",
    onMouseleave: t[4] || (t[4] = (s) => e.$emit("mouseleave"))
  }, [
    (d(!0), h(Y, null, ee(n.moreItems, (s) => (d(), h(Y, null, [
      s ? (d(), k(a, {
        ref_for: !0,
        ref: `more-${s.id}`,
        key: s.id,
        item: s,
        "force-show": !0,
        "is-more-menu-item": !0,
        "first-item-id": r.firstItemId,
        "last-item-id": r.lastItemId,
        "active-id": n.activeId,
        "is-active": s.id === n.activeId,
        colors: n.colors,
        "path-prefix": n.pathPrefix,
        onNavigate: (l) => e.$emit("navigate", s),
        onMouseover: (l) => e.$emit("open", s),
        onToggleMoreMenu: t[0] || (t[0] = (l) => e.$emit("toggle-more-menu", l)),
        onToggleDrawer: t[1] || (t[1] = (l) => e.$emit("toggle-drawer", l)),
        onClose: t[2] || (t[2] = (l) => e.$emit("close")),
        onFocusSubMenu: t[3] || (t[3] = (l) => e.$emit("focus-sub-menu", l))
      }, null, 8, ["item", "first-item-id", "last-item-id", "active-id", "is-active", "colors", "path-prefix", "onNavigate", "onMouseover"])) : b("", !0)
    ], 64))), 256))
  ], 40, iA);
}
const aA = /* @__PURE__ */ O(rA, [["render", sA], ["__scopeId", "data-v-b58cb58f"]]), lA = {
  name: "M4Drawer",
  components: { M4DrawerElement: vm },
  props: {
    activeItem: {
      type: Object,
      default: void 0
    },
    themeStyle: {
      type: String,
      default: "light"
    },
    colors: {
      type: Object,
      default: void 0
    },
    isMoreMenuActive: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isOpen: {
      type: Boolean,
      default: !1
    },
    isTemporarilyHideMenu: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["mouseenter", "mouseleave", "hide-drawer", "close", "prevent-close", "toggle-parent", "next-tab", "navigate"],
  data() {
    return {
      activeParent: null,
      scrollWidth: !1
    };
  },
  computed: {
    itemId() {
      return `drawer-${this.activeItem.id}`;
    }
  },
  watch: {
    isOpen(e) {
      if (e) {
        const { scrollWidth: t, clientWidth: n } = this.$refs["drawer-wrapper"];
        t > n && (this.scrollWidth = !0);
      }
    }
  },
  methods: {
    hideDrawer() {
      this.$emit("hide-drawer");
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null, this.$emit("toggle-parent", { itemId: e.id });
        return;
      }
      this.$emit("prevent-close"), this.activeParent = e.id, this.$emit("toggle-parent", { itemId: e.id });
    }
  }
}, uA = ["id", "aria-labelledby"], dA = { class: "m4-menu--drawer-title" };
function cA(e, t, n, o, i, r) {
  const a = $("M4DrawerElement");
  return d(), h("div", {
    id: r.itemId,
    ref: r.itemId,
    "aria-labelledby": `menu-button-${n.activeItem.id}`,
    "aria-modal": "true",
    class: "m4-menu--drawer",
    style: j({ flexDirection: i.scrollWidth ? "column" : "row" }),
    onMouseleave: t[2] || (t[2] = z((s) => e.$emit("mouseleave"), ["exact", "stop", "prevent"])),
    onMouseenter: t[3] || (t[3] = (s) => e.$emit("mouseenter"))
  }, [
    c("div", dA, [
      c("h2", {
        class: v(n.themeStyle)
      }, y(n.activeItem.name), 3)
    ]),
    c("div", {
      ref: "drawer-wrapper",
      class: v(["m4-menu--drawer-content-wrapper", { scrollWidth: i.scrollWidth }])
    }, [
      (d(!0), h(Y, null, ee(n.activeItem.children, (s) => (d(), k(a, {
        key: s.id,
        "elem-data": s,
        colors: n.colors,
        "theme-style": n.themeStyle,
        "active-parent": i.activeParent,
        "path-prefix": n.pathPrefix,
        onToggleParent: r.handleToggleParent,
        onNextTab: t[0] || (t[0] = (l) => e.$emit("next-tab", l)),
        onNavigate: t[1] || (t[1] = (l) => e.$emit("navigate", l))
      }, null, 8, ["elem-data", "colors", "theme-style", "active-parent", "path-prefix", "onToggleParent"]))), 128))
    ], 2)
  ], 44, uA);
}
const hA = /* @__PURE__ */ O(lA, [["render", cA], ["__scopeId", "data-v-6a36474b"]]), mA = {
  name: "M4",
  components: {
    M4Drawer: hA,
    M4MobileMenu: oA,
    M4MoreMenuDropdown: aA,
    M4MainItem: pm
  },
  mixins: [da, hm],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: Boolean,
    isMobile: Boolean
  },
  emits: ["close-menus", "toggle-mobile-menu"],
  setup() {
    const e = Yn(), { hasFocus: t, activate: n, deactivate: o } = z1(e);
    return {
      activate: n,
      deactivate: o,
      hasFocus: t,
      m4MobileMenu: e
    };
  },
  computed: {
    showMobileMenu() {
      return this.content.showMenu;
    },
    moreBtnWidth() {
      var e, t;
      return ((t = (e = this.$refs) == null ? void 0 : e["m4-menu--more-wrapper"]) == null ? void 0 : t.clientWidth) || 10;
    },
    mobileMenuItems() {
      return [
        {
          id: "explore-header",
          name: "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    }
  },
  watch: {
    async showMobileMenu() {
      this.isMobile && (this.showMobileMenu ? (await En(), this.activate()) : (await En(), this.deactivate()));
    }
  }
}, pA = { class: "m4-menu--align-right" }, fA = {
  ref: "bar-nav-item-wrapper",
  class: "m4-menu--bar-item-wrapper"
}, gA = {
  ref: "m4-menu--more-wrapper",
  class: "m4-menu--bar-dropdown-wrapper"
}, vA = { ref: "m4MobileMenu" };
function bA(e, t, n, o, i, r) {
  const a = $("M4MainItem"), s = $("M4Drawer"), l = $("M4MoreMenuDropdown"), u = $("Close"), m = $("M4MobileMenu"), g = Ve("click-away");
  return d(), h("div", {
    id: "m4",
    style: j(e.colors),
    class: v(["m4-menu", { loadingMenu: e.loadingMenu }])
  }, [
    c("div", {
      ref: "m4-menu--bar",
      class: "m4-menu--bar",
      onMouseleave: t[13] || (t[13] = (p) => e.mouseLeaveMenu()),
      onMouseenter: t[14] || (t[14] = (p) => e.mouseEnterMenu())
    }, [
      c("div", pA, [
        ge((d(), h("div", fA, [
          (d(!0), h(Y, null, ee(n.content.sitemapMenuItems, (p) => (d(), h(Y, {
            key: p.id
          }, [
            ge(L(a, {
              item: p,
              "active-id": e.activeItem ? e.activeItem.id : null,
              "theme-style": n.theme.style,
              colors: e.colors,
              "path-prefix": n.content.pathPrefix,
              onNavigate: e.navigate,
              onMouseover: (T) => e.showItem(p),
              onToggleDrawer: (T) => e.handleDrawerToggle(p),
              onClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme-style", "colors", "path-prefix", "onNavigate", "onMouseover", "onToggleDrawer", "onClose"]), [
              [Sn, e.visibleItems.find(({ id: T }) => T === p.id)]
            ]),
            L(Ee, { name: "slide-fade-up" }, {
              default: _(() => [
                c("div", {
                  onMousemove: t[5] || (t[5] = (T) => e.preventMouseLeaveClose = !1)
                }, [
                  ge(L(s, {
                    id: `drawer-${p.id}`,
                    ref_for: !0,
                    ref: `drawer-${p.id}`,
                    "active-item": p,
                    "theme-style": n.theme.style,
                    colors: e.colors,
                    "is-more-menu-active": e.isMoreDropdownVisible,
                    "is-open": e.activeItem && e.activeItem.id === p.id,
                    "path-prefix": n.content.pathPrefix,
                    "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                    onToggleParent: e.toggleParentCollapsible,
                    onPreventClose: t[0] || (t[0] = (T) => e.preventCloseDrawer(T)),
                    onNavigate: t[1] || (t[1] = (T) => e.navigate(T)),
                    onMouseleave: t[2] || (t[2] = (T) => e.hideDrawer("mouseleave")),
                    onClose: e.handleClose,
                    onHideDrawer: e.hideDrawer,
                    onMouseenter: t[3] || (t[3] = (T) => e.preventClose(e.activeItem)),
                    onNextTab: t[4] || (t[4] = (T) => e.nextTabAction(T))
                  }, null, 8, ["id", "active-item", "theme-style", "colors", "is-more-menu-active", "is-open", "path-prefix", "is-temporarily-hide-menu", "onToggleParent", "onClose", "onHideDrawer"]), [
                    [Sn, e.showDrawer(p)]
                  ])
                ], 32)
              ]),
              _: 2
            }, 1024)
          ], 64))), 128))
        ])), [
          [g, e.hideDrawer]
        ]),
        ge(c("div", gA, [
          L(a, {
            id: "m4-menu--bar-dropdown-button",
            "more-menu-item": e.translations.more_dropdown_title,
            "more-menu-visible": e.isMoreDropdownVisible,
            "force-show": !0,
            "theme-style": n.theme.style,
            colors: e.colors,
            "path-prefix": n.content.pathPrefix,
            onNavigate: e.navigate,
            onToggleMoreMenu: t[6] || (t[6] = (p) => e.handleMoreMenuToggle(p)),
            onMouseover: t[7] || (t[7] = (p) => e.handleMoreMenuToggle(!0)),
            onClose: e.handleClose
          }, null, 8, ["more-menu-item", "more-menu-visible", "theme-style", "colors", "path-prefix", "onNavigate", "onClose"]),
          L(Ee, { name: "slide-fade-up" }, {
            default: _(() => [
              e.underLappedItems && e.isMoreDropdownVisible ? ge((d(), k(l, {
                key: 0,
                ref: "moreDropdown",
                "active-id": e.activeItem ? e.activeItem.id : null,
                "is-visible": e.isMoreDropdownVisible,
                "more-items": e.underLappedItems,
                "theme-style": n.theme.style,
                colors: e.colors,
                "path-prefix": n.content.pathPrefix,
                onNavigate: e.navigate,
                onOpen: t[8] || (t[8] = (p) => e.handleDropdownMenuOpen(p)),
                onToggleMoreMenu: t[9] || (t[9] = (p) => e.handleMoreMenuToggle(p)),
                onToggleDrawer: t[10] || (t[10] = (p) => e.handleDrawerToggle(p)),
                onMouseleave: t[11] || (t[11] = (p) => e.preventClose(e.activeItem)),
                onFocusSubMenu: t[12] || (t[12] = (p) => e.focusSubMenu(p)),
                onClose: e.handleClose,
                onTemporarilyHideMenu: e.temporalHide
              }, null, 8, ["active-id", "is-visible", "more-items", "theme-style", "colors", "path-prefix", "onNavigate", "onClose", "onTemporarilyHideMenu"])), [
                [g, e.hideMoreMenu]
              ]) : b("", !0)
            ]),
            _: 1
          })
        ], 512), [
          [Sn, e.displayMoreButton]
        ])
      ])
    ], 544),
    n.isMobile ? (d(), h("div", {
      key: 0,
      id: "mainmenu",
      ref: "mainmenu",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      class: v(["m4-menu--mobile", n.content.showMenu && "is-visible"])
    }, [
      c("div", vA, [
        c("button", {
          ref: "closeButton",
          class: "close-icon",
          "aria-label": "close",
          onClick: t[15] || (t[15] = (p) => e.$emit("toggle-mobile-menu", !1))
        }, [
          L(u, {
            tabindex: "-1",
            "fill-color": e.colors["--dropdown-text-color"]
          }, null, 8, ["fill-color"])
        ], 512),
        L(m, {
          "menu-items": r.mobileMenuItems,
          "is-visible": n.content.showMenu,
          colors: e.colors,
          "path-prefix": n.content.pathPrefix,
          onNavigate: e.navigate,
          onCloseMenu: t[16] || (t[16] = (p) => e.$emit("close-menus"))
        }, null, 8, ["menu-items", "is-visible", "colors", "path-prefix", "onNavigate"])
      ], 512)
    ], 2)) : b("", !0)
  ], 6);
}
const K1 = /* @__PURE__ */ O(mA, [["render", bA], ["__scopeId", "data-v-d6ea7a9e"]]), yA = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    globals: {
      type: Object,
      required: !0
    },
    logoLink: {
      type: String,
      required: !0
    },
    shouldShrink: {
      type: Boolean,
      default: !1
    },
    isMobile: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      return {
        "--nav-color": this.theme.navigation_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--school-name-color": this.theme.school_name_color.hex,
        "--school-tagline-color": this.theme.school_tagline_color.hex
      };
    },
    aClass() {
      return {
        "logo-circle": this.theme.logo_circle && ["H1", "H2"].includes(this.theme.version),
        shrink: this.shouldShrink,
        mobile: this.isMobile
      };
    },
    slogan() {
      const e = S(this.theme, "translations.school_tag_line"), t = S(this.globals, "info.school_tag_line");
      return e || t;
    }
  }
}, _A = ["href"], CA = {
  key: 0,
  class: "clipping-rect"
}, wA = { class: "logo" }, TA = ["src"], kA = {
  key: 0,
  class: "circle"
}, EA = { class: "school-info" }, SA = {
  key: 1,
  class: "name"
};
function MA(e, t, n, o, i, r) {
  return d(), h("a", {
    href: n.logoLink,
    class: v(r.aClass),
    style: j(r.colors)
  }, [
    n.theme.logo_circle ? (d(), h("div", CA)) : b("", !0),
    c("div", wA, [
      c("img", {
        src: n.globals.logo.url,
        alt: "Return to Home"
      }, null, 8, TA),
      n.theme.logo_circle ? (d(), h("div", kA)) : b("", !0)
    ]),
    c("div", EA, [
      n.globals.info.customHeader ? (d(), h("h1", {
        key: 0,
        class: v({ "sr-only": n.globals.info.customHeader })
      }, y(n.globals.info.school_name) + " - " + y(r.slogan), 3)) : b("", !0),
      n.globals.info.customHeader ? b("", !0) : (d(), h("div", SA, [
        c("h1", {
          class: v([n.theme.style, "org-name"])
        }, y(n.globals.info.school_name), 3),
        c("div", {
          class: v(["slogan", { [n.theme.style]: n.theme.style }])
        }, y(r.slogan), 3)
      ]))
    ])
  ], 14, _A);
}
const oo = /* @__PURE__ */ O(yA, [["render", MA], ["__scopeId", "data-v-a845ad16"]]), AA = {
  name: "MenuElementType",
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    moreMenuTitle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    },
    moreMenuVisible: Boolean,
    ariaExpanded: {
      type: String,
      default: "false"
    },
    ariaHasPopup: {
      type: String,
      default: "false"
    },
    ariaControls: {
      type: String,
      default: ""
    }
  },
  emits: ["handle-header-click"],
  computed: {
    href() {
      if (!this.item)
        return null;
      switch (this.item.type) {
        case "page":
          return `${this.pathPrefix}/page/${this.item.slug}`;
        case "link":
          return this.getLinkHref;
        case "explore":
          return this.getExploreHref;
        case "header":
          return null;
        default:
          return null;
      }
    },
    iconVisible() {
      return (this.item.icon || this.item.icon_cms) && this.item.id !== "explore-button" && this.item.id !== "schoolsbutton";
    },
    noChildren() {
      var e;
      return ((e = this.item.children) == null ? void 0 : e.length) === 0;
    },
    getExploreHref() {
      var e;
      return (e = this.item.slug) != null && e.includes("http") ? this.item.slug : this.pathPrefix + this.item.slug;
    },
    getLinkHref() {
      return this.item ? this.item.mailto && this.item.email_address ? `mailto:${this.item.email_address}` : this.item.ipAddress ? `http://${this.item.url}` : this.item.url : null;
    },
    colors() {
      return {
        "--icon-fill-color": this.fillColor
      };
    }
  }
}, $A = { class: "bar-nav-element" }, IA = ["innerHTML"], DA = ["href", "target"], LA = { key: 0 };
function OA(e, t, n, o, i, r) {
  return d(), h("div", $A, [
    r.href ? (d(), h(Y, { key: 0 }, [
      r.iconVisible ? (d(), h("div", {
        key: 0,
        class: v(["item-icon", { "global-icon": n.item.cms_icon_id }]),
        style: j(r.colors),
        innerHTML: n.item.cms_icon_id ? n.item.icon_cms : n.item.icon
      }, null, 14, IA)) : b("", !0),
      c("a", {
        href: r.href,
        target: n.item.opens_in_new_tab ? "_blank" : void 0,
        class: "link"
      }, y(n.item.translatedTitle || n.item.name), 9, DA)
    ], 64)) : (d(), h(Y, { key: 1 }, [
      n.moreMenuTitle && n.item.name === "more" ? (d(), h("span", LA, y(n.moreMenuTitle), 1)) : (d(), h("span", {
        key: 1,
        class: v(["item-type-header", { "no-children": r.noChildren }]),
        onClick: t[0] || (t[0] = (a) => e.$emit("handle-header-click"))
      }, y(n.item.translatedTitle || n.item.name), 3))
    ], 64))
  ]);
}
const bm = /* @__PURE__ */ O(AA, [["render", OA], ["__scopeId", "data-v-5589e202"]]), NA = {
  name: "ImageElement",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    href() {
      return this.item ? this.item.url : null;
    }
  }
}, PA = {
  class: "menu-item-focusable",
  tabindex: "-1"
}, HA = ["src", "alt"];
function FA(e, t, n, o, i, r) {
  return d(), h("span", PA, [
    (d(), k(K(r.href ? "a" : "div"), {
      href: r.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "menu-item-link",
      tabindex: "-1"
    }, {
      default: _(() => [
        c("img", {
          src: n.item.imgSrc,
          alt: n.item.altText
        }, null, 8, HA)
      ]),
      _: 1
    }, 8, ["href", "target"]))
  ]);
}
const RA = /* @__PURE__ */ O(NA, [["render", FA], ["__scopeId", "data-v-e7e5596a"]]), BA = {
  name: "BarNavDrawerItem",
  components: { MenuElementType: bm, ImageElement: RA, MenuPlusIcon: fm, MenuMinusIcon: gm, DropdownArrowIcon: kr },
  props: {
    elemData: {
      type: Object,
      default: null
    },
    themeStyle: {
      type: String,
      default: ""
    },
    isMobile: Boolean,
    colors: {
      type: Object,
      default: void 0
    },
    activeParent: {
      type: [String, Number],
      default: null
    },
    activeChild: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    nestLevel: {
      type: Number,
      default: 0
    },
    newMobileHeaderElement: Boolean
  },
  emits: ["toggle-child", "toggle-parent", "next-tab", "navigate"],
  computed: {
    iconColor() {
      return this.isMobile && this.newMobileHeaderElement ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"];
    },
    itemBgColor() {
      return {
        "--item-bg-color": this.isMobile ? this.colors["--mobile-menu-bg-color"] : this.colors["--dropdown-bg-color"]
      };
    },
    itemTextColor() {
      return {
        "--item-text-color": this.isMobile ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"]
      };
    },
    hasChildren() {
      var e;
      return !!((e = this.elemData) != null && e.children.length);
    },
    showChildren() {
      return Number.isNaN(+this.activeParent) ? this.activeParent === this.elemData.id : +this.activeParent == +this.elemData.id;
    },
    isChild() {
      return this.nestLevel >= 1;
    },
    isSubChild() {
      return this.nestLevel >= 2;
    },
    ariaParentId() {
      return `menu-button-${this.elemData.id}`;
    },
    ariaExpanded() {
      if (this.hasChildren)
        return this.showChildren ? "true" : "false";
    },
    ariaControls() {
      if (this.hasChildren)
        return this.ariaChildId;
    },
    ariaChildId() {
      return `${this.elemData.id}-collapsible`;
    },
    ariaHasPopup() {
      return this.hasChildren ? "true" : "false";
    }
  },
  methods: {
    toggleParentCollapsible() {
      this.$emit("toggle-parent", this.elemData);
    },
    handleEnterEvent() {
      this.$emit("navigate", this.elemData);
    },
    handleNextTab(e, t, n) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    }
  }
}, VA = ["id"], jA = ["id"], UA = ["aria-expanded", "aria-controls", "aria-haspopup"], GA = {
  class: "bar-nav--drawer-element-focusable",
  tabindex: "-1"
}, zA = {
  key: 3,
  class: "sr-only"
}, KA = ["id", "aria-labelledby"];
function ZA(e, t, n, o, i, r) {
  const a = $("ImageElement"), s = $("MenuElementType"), l = $("MenuPlusIcon"), u = $("MenuMinusIcon"), m = $("DropdownArrowIcon"), g = $("BarNavDrawerItem", !0);
  return d(), h("div", {
    role: "menuitem",
    class: v(["bar-nav--drawer-element", {
      "mobile-element": n.isMobile,
      "new-mobile-header": n.newMobileHeaderElement,
      "child-element": r.isChild,
      "has-children": r.hasChildren,
      "has-icon": n.elemData.icon || n.elemData.icon_cms,
      "sub-child": r.isSubChild,
      "image-element": n.elemData.type === "image"
    }]),
    style: j([r.itemBgColor, r.itemTextColor]),
    onClick: t[7] || (t[7] = (...p) => r.toggleParentCollapsible && r.toggleParentCollapsible(...p))
  }, [
    c("div", {
      id: n.elemData.id,
      class: "bar-nav--drawer-element-title"
    }, [
      c("div", {
        id: r.ariaParentId,
        class: v(["bar-nav--drawer-element-title-text", n.themeStyle]),
        onClick: t[1] || (t[1] = z(() => {
        }, ["stop"]))
      }, [
        n.elemData.type === "image" ? (d(), k(a, {
          key: 0,
          item: n.elemData
        }, null, 8, ["item"])) : (d(), k(s, {
          key: 1,
          "path-prefix": n.pathPrefix,
          item: n.elemData,
          "fill-color": r.iconColor,
          "aria-expanded": r.ariaExpanded,
          "aria-has-popup": r.ariaHasPopup,
          "aria-controls": r.ariaControls,
          onHandleHeaderClick: r.toggleParentCollapsible,
          onKeydown: [
            V(r.handleEnterEvent, ["enter"]),
            t[0] || (t[0] = V((p) => r.handleNextTab(n.elemData.id, !1, p.shiftKey), ["tab"]))
          ]
        }, null, 8, ["path-prefix", "item", "fill-color", "aria-expanded", "aria-has-popup", "aria-controls", "onHandleHeaderClick", "onKeydown"]))
      ], 10, jA),
      n.elemData.children.length ? (d(), h(Y, { key: 0 }, [
        n.elemData.children.length ? (d(), h("button", {
          key: 0,
          "aria-expanded": r.ariaExpanded,
          "aria-controls": r.ariaControls,
          "aria-haspopup": r.ariaHasPopup,
          class: "bar-nav--drawer-element-title-icon",
          onClick: t[2] || (t[2] = z((...p) => r.toggleParentCollapsible && r.toggleParentCollapsible(...p), ["stop", "prevent"])),
          onKeydown: t[3] || (t[3] = V((p) => r.handleNextTab(n.elemData.id, !0, p.shiftKey), ["tab"]))
        }, [
          c("span", GA, [
            n.isMobile && !r.showChildren ? (d(), k(l, {
              key: 0,
              "fill-color": r.iconColor
            }, null, 8, ["fill-color"])) : n.isMobile && r.showChildren ? (d(), k(u, {
              key: 1,
              "fill-color": r.iconColor
            }, null, 8, ["fill-color"])) : b("", !0),
            n.isMobile ? b("", !0) : (d(), k(m, {
              key: 2,
              "fill-color": r.iconColor,
              "dropdown-class": r.showChildren ? "open" : "close"
            }, null, 8, ["fill-color", "dropdown-class"])),
            n.elemData ? (d(), h("span", zA, " Show submenu for " + y(n.elemData.name || n.elemData.translatedTitle), 1)) : b("", !0)
          ])
        ], 40, UA)) : b("", !0)
      ], 64)) : b("", !0)
    ], 8, VA),
    L(Ee, { name: "collapse-in" }, {
      default: _(() => [
        ge(c("div", {
          id: r.ariaChildId,
          "aria-labelledby": r.ariaParentId,
          class: v(["bar-nav--drawer-children", { "show-children": r.showChildren }])
        }, [
          (d(!0), h(Y, null, ee(n.elemData.children, (p) => (d(), k(g, {
            key: p.id,
            "elem-data": p,
            "is-mobile": n.isMobile,
            "theme-style": n.themeStyle,
            "active-parent": n.activeChild,
            "path-prefix": n.pathPrefix,
            colors: n.colors,
            "new-mobile-header-element": n.newMobileHeaderElement,
            "nest-level": n.nestLevel + 1,
            onToggleParent: t[4] || (t[4] = (T) => e.$emit("toggle-child", T)),
            onNextTab: t[5] || (t[5] = (T) => e.$emit("next-tab", T)),
            onNavigate: t[6] || (t[6] = (T) => e.$emit("navigate", T))
          }, null, 8, ["elem-data", "is-mobile", "theme-style", "active-parent", "path-prefix", "colors", "new-mobile-header-element", "nest-level"]))), 128))
        ], 10, KA), [
          [Sn, r.hasChildren & r.showChildren]
        ])
      ]),
      _: 1
    })
  ], 6);
}
const ym = /* @__PURE__ */ O(BA, [["render", ZA], ["__scopeId", "data-v-1e9b1b42"]]), xA = {
  name: "MobileMenu",
  components: {
    BarNavDrawerItem: ym,
    MenuItem: Nt,
    LanguageDropdown: ua
  },
  mixins: [ht],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    },
    colors: {
      type: Object,
      default: () => ({})
    },
    showUtilities: Boolean,
    signInColors: {
      type: Object,
      default: () => ({})
    },
    signInUrl: {
      type: String,
      default: ""
    },
    signInText: {
      type: String,
      default: ""
    },
    showSignInButton: Boolean,
    showMenuButtons: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close-menu", "set-language", "toggle-search"],
  data() {
    return {
      activeParent: null,
      activeChild: null,
      languageDropdownVisible: !1
    };
  },
  mounted() {
    window.addEventListener("keydown", this.keydownHandler);
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydownHandler);
  },
  methods: {
    keydownHandler(e) {
      e.key === "Escape" && this.$emit("close-menu");
    },
    setLanguage(e) {
      this.toggleLanguageDropdown(), this.$emit("set-language", e);
    },
    toggleLanguageDropdown() {
      this.languageDropdownVisible = !this.languageDropdownVisible;
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null;
        return;
      }
      this.activeParent = e.id;
    },
    handleToggleChild(e) {
      if (!e) {
        this.activeChild = null;
        return;
      }
      if (e.id === this.activeChild) {
        this.activeChild = null;
        return;
      }
      this.activeChild = e.id;
    }
  }
}, WA = {
  key: 0,
  class: "mobile-menu-wrapper"
}, qA = {
  key: 0,
  class: "search-translate-buttons"
}, YA = ["href"], XA = {
  key: 1,
  class: "utilities-wrapper"
}, QA = ["href", ":href", "target"], JA = {
  key: 2,
  class: "icon-links-container"
}, e$ = ["href", ":href", "target", "aria-label"], t$ = ["innerHTML"];
function n$(e, t, n, o, i, r) {
  const a = $("MenuItem"), s = $("LanguageDropdown"), l = $("BarNavDrawerItem"), u = Ve("click-away");
  return d(), k(Ee, { name: "slide-fade-up" }, {
    default: _(() => [
      n.content.showMenu ? (d(), h("nav", WA, [
        n.showMenuButtons ? (d(), h("div", qA, [
          L(a, {
            item: "searchbutton",
            theme: n.theme,
            content: n.content,
            "is-mobile": "",
            "theme-overrides": {
              colors: {
                "--icon-color": n.colors["--mobile-menu-text-color"],
                "--bg-color": "transparent"
              }
            },
            "mobile-text-color": n.colors["--mobile-menu-text-color"],
            onToggleSearch: t[0] || (t[0] = (m) => e.$emit("toggle-search"))
          }, null, 8, ["theme", "content", "theme-overrides", "mobile-text-color"]),
          n.content.languages.length > 1 ? (d(), k(a, {
            key: 0,
            item: "languagebutton",
            theme: n.theme,
            content: n.content,
            "is-mobile": "",
            "theme-overrides": {
              colors: {
                "--fill-color": n.colors["--mobile-menu-text-color"],
                "--fill-path-color": n.colors["--mobile-menu-text-color"],
                "--nav-color": n.colors["--mobile-menu-text-color"]
              }
            },
            "mobile-text-color": n.colors["--mobile-menu-text-color"],
            onToggleDropdown: r.toggleLanguageDropdown
          }, null, 8, ["theme", "content", "theme-overrides", "mobile-text-color", "onToggleDropdown"])) : b("", !0),
          ge(L(s, {
            id: "languagesmenu",
            data: n.content.languages,
            styles: n.theme,
            "is-visible": i.languageDropdownVisible,
            "current-language": n.content.langCode,
            class: "language-dropdown",
            onSetLanguage: r.setLanguage,
            onCloseDropdown: r.toggleLanguageDropdown
          }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage", "onCloseDropdown"]), [
            [
              u,
              () => {
                i.languageDropdownVisible = !1;
              }
            ]
          ]),
          n.showSignInButton ? (d(), h("a", {
            key: 1,
            href: n.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, y(n.signInText), 9, YA)) : b("", !0)
        ])) : b("", !0),
        w(e.$slots, "menu-top", {}, void 0, !0),
        n.showUtilities ? (d(), h("div", XA, [
          (d(!0), h(Y, null, ee(n.content.utilities, (m, g) => (d(), h("a", {
            key: g,
            href: m.link,
            ":href": m.link,
            target: m.opens_in_new_tab ? "_blank" : "",
            class: "utility",
            style: j({ color: n.colors["--mobile-menu-text-color"] })
          }, y(m.name), 13, QA))), 128))
        ])) : b("", !0),
        n.theme.version === "H8" && n.theme.style === "texas" ? (d(), h("div", JA, [
          (d(!0), h(Y, null, ee(n.content.iconLinks, (m) => (d(), h("a", {
            key: m.icon_id,
            href: m.link,
            ":href": m.link,
            target: m.opens_in_new_tab ? "_blank" : "",
            class: "icon-link",
            "aria-label": m.name,
            style: j({ color: n.colors["--mobile-menu-text-color"] })
          }, [
            c("span", {
              "data-testid": "svg",
              innerHTML: m.icon
            }, null, 8, t$)
          ], 12, e$))), 128))
        ])) : b("", !0),
        (d(!0), h(Y, null, ee(n.content.menuItems, (m) => (d(), k(l, {
          key: `${m.name}-${m.id}`,
          "elem-data": m,
          "is-mobile": "",
          colors: n.colors,
          "active-parent": i.activeParent,
          "active-child": i.activeChild,
          "path-prefix": n.content.pathPrefix,
          "new-mobile-header-element": "",
          onToggleParent: r.handleToggleParent,
          onToggleChild: r.handleToggleChild
        }, null, 8, ["elem-data", "colors", "active-parent", "active-child", "path-prefix", "onToggleParent", "onToggleChild"]))), 128))
      ])) : b("", !0)
    ]),
    _: 3
  });
}
const o$ = /* @__PURE__ */ O(xA, [["render", n$], ["__scopeId", "data-v-5814f1b4"]]), r$ = {
  name: "MobileHeader",
  components: {
    MenuItem: Nt,
    OrgBanner: oo,
    MobileMenu: o$
  },
  mixins: [et],
  props: {
    isShrink: Boolean,
    showUtilities: Boolean,
    showSignInButton: Boolean,
    hideMenuButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    },
    menuButtonBgColor: {
      type: String,
      default: ""
    },
    menuButtonIconColor: {
      type: String,
      default: ""
    },
    showMenuButtons: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["toggle-mobile-menu", "toggle-search", "set-language"],
  setup() {
    const e = Yn(), { hasFocus: t, activate: n, deactivate: o } = z1(e);
    return {
      activate: n,
      deactivate: o,
      hasFocus: t,
      mobileHeader: e
    };
  },
  computed: {
    mobileContent() {
      return he(ie({}, this.content), { menuItems: this.mobileMenuItems });
    },
    mobileMenuItems() {
      return [
        ...this.shouldDisplaySchoolsDropdown ? [
          {
            id: "schools-header",
            name: this.theme.schools_field || "Schools",
            slug: "schools",
            type: "header",
            children: this.buildSchoolsMenu(
              this.content.hasCustomSchoolsMenu ? this.content.orgMenuContent.flat() : this.content.organizations
            )
          }
        ] : [{}],
        {
          id: "explore-header",
          name: this.theme.menu_field || "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            icon: e.icon,
            cms_icon_id: e.cms_icon_id,
            icon_cms: e.icon_cms,
            opens_in_new_tab: e.opens_in_new_tab,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    mobileHeaderBgColor() {
      var e, t, n, o;
      return this.menuV4Enabled || this.content.newMobileHeader && this.theme.version !== "H3" ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : this.menuV5Enabled && this.theme.version === "H3" ? "transparent" : ((o = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : o.hex) || "#fff";
    },
    mobileMenuBgColor() {
      var e, t, n, o;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : ((o = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : o.hex) || "#fff";
    },
    mobileMenuTextColor() {
      var e, t, n, o;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_text_color) == null ? void 0 : t.hex : ((o = (n = this.content.menuOptions) == null ? void 0 : n.text_color) == null ? void 0 : o.hex) || "#000";
    },
    colors() {
      var e, t, n, o, i, r, a, s, l, u;
      return {
        "--nav-color": ((e = this.theme.navigation_color) == null ? void 0 : e.hex) || "#fff",
        searchIcon: (t = this.theme.search_icon_color) == null ? void 0 : t.hex,
        "--mobile-menu-bg-color": (this.menuV4Enabled ? (o = (n = this.content.menuOptions) == null ? void 0 : n.dropdown_bg_color) == null ? void 0 : o.hex : (r = (i = this.content.menuOptions) == null ? void 0 : i.bg_color) == null ? void 0 : r.hex) || "#fff",
        "--mobile-menu-text-color": (this.menuV4Enabled ? (s = (a = this.content.menuOptions) == null ? void 0 : a.dropdown_text_color) == null ? void 0 : s.hex : (u = (l = this.content.menuOptions) == null ? void 0 : l.text_color) == null ? void 0 : u.hex) || "#000"
      };
    },
    focusHighlightColor() {
      return ae.mostReadable(this.mobileHeaderBgColor, ["#0000FF", "#FFFFFF"]).toHexString();
    },
    isSearchOpen() {
      return this.$route.query.openSearch === "true";
    }
  },
  watch: {
    "content.isSearchOpen": {
      async handler(e) {
        e ? (await En(), this.deactivate()) : (await En(), this.activate());
      }
    },
    "content.showMenu": {
      async handler(e) {
        e ? (await En(), this.activate()) : (await En(), this.deactivate());
      }
    }
  },
  methods: {
    async toggleSearch() {
      this.$emit("toggle-search");
    },
    buildSchoolsMenu(e) {
      if (An(e))
        return [];
      const t = (o) => {
        let i = "";
        switch (o) {
          case "SchoolsMenuOrg":
            i = "link";
            break;
          case "SchoolsMenuLink":
            i = "link";
            break;
          case "SchoolsMenuImage":
            i = "image";
            break;
          case "SchoolsMenuHeader":
            i = "header";
            break;
          default:
            i = "link";
            break;
        }
        return i;
      }, n = (o) => o.type === "SchoolsMenuLink" ? o.link : o.type === "SchoolsMenuOrg" && this.content.hasCustomSchoolsMenu ? G1(o, this.content.organizations, {
        isPreview: this.content.isPreview
      }) : Ho(o, {
        isPreview: this.content.isPreview,
        currentDomain: window.location.href
      });
      return e.map((o, i) => ({
        id: `schools-${i}`,
        name: o.name,
        slug: o.link || o.path_prefix,
        url: n(o),
        imgSrc: o.url,
        altText: o.alt_text,
        imgHasLink: o.action_on_click === "no_action",
        opens_in_new_tab: o.opens_in_new_tab,
        type: t(o.type),
        children: this.buildSchoolsMenu(o.children)
      }));
    }
  }
}, i$ = {
  key: 0,
  class: "left-icon"
}, s$ = { class: "main-content" }, a$ = {
  key: 0,
  class: "right-icon"
}, l$ = {
  key: 0,
  id: "mainmenu",
  "aria-labelledby": "menubutton",
  "aria-modal": "true",
  class: "menu-mobile"
};
function u$(e, t, n, o, i, r) {
  const a = $("MenuItem"), s = $("OrgBanner"), l = $("MobileMenu");
  return d(), h("div", {
    ref: "mobileHeader",
    "data-testid": "mobile-header",
    class: v(["mobile-header", e.theme.version, { "menu-open": e.content.showMenu, shrink: n.isShrink }]),
    style: j(r.colors)
  }, [
    w(e.$slots, "default", {}, () => [
      n.hideMenuButton ? b("", !0) : (d(), h("div", i$, [
        e.content.showMenu ? (d(), k(a, {
          key: 1,
          item: "closebutton",
          "show-text": !1,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": n.menuButtonIconColor
            }
          },
          "is-mobile-header": "",
          "focus-visible-color": r.focusHighlightColor,
          onToggleDropdown: t[1] || (t[1] = (u) => e.$emit("toggle-mobile-menu", !1))
        }, null, 8, ["theme", "content", "theme-overrides", "focus-visible-color"])) : (d(), k(a, {
          key: 0,
          item: "menubutton",
          theme: e.theme,
          content: e.content,
          "show-text": !1,
          "theme-overrides": {
            colors: {
              "--fill-color": n.menuButtonBgColor,
              "--fill-path-color": n.menuButtonIconColor
            }
          },
          "is-mobile-header": "",
          "focus-visible-color": r.focusHighlightColor,
          onToggleDropdown: t[0] || (t[0] = (u) => e.$emit("toggle-mobile-menu", !0))
        }, null, 8, ["theme", "content", "theme-overrides", "focus-visible-color"]))
      ])),
      c("div", s$, [
        L(s, {
          "logo-link": e.logoLink,
          "should-shrink": n.isShrink,
          theme: e.theme,
          globals: e.content.globals,
          "is-mobile": e.theme.version !== "H3",
          class: v(e.theme.version)
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals", "is-mobile", "class"]),
        e.theme.version === "H3" ? (d(), h("div", a$, [
          e.content.showMenu ? (d(), k(a, {
            key: 1,
            item: "closebutton",
            theme: e.theme,
            content: e.content,
            "focus-visible-color": r.focusHighlightColor,
            onToggleDropdown: t[3] || (t[3] = (u) => e.$emit("toggle-mobile-menu", !1))
          }, null, 8, ["theme", "content", "focus-visible-color"])) : (d(), k(a, {
            key: 0,
            item: "menubutton",
            theme: e.theme,
            content: e.content,
            "is-mobile": "",
            "focus-visible-color": r.focusHighlightColor,
            onToggleDropdown: t[2] || (t[2] = (u) => e.$emit("toggle-mobile-menu", !0))
          }, null, 8, ["theme", "content", "focus-visible-color"]))
        ])) : b("", !0)
      ])
    ], !0),
    w(e.$slots, "bottom", {}, void 0, !0),
    e.content.showMenu ? (d(), h("div", l$, [
      L(l, {
        theme: e.theme,
        "show-utilities": n.showUtilities,
        utilities: e.content.utilities,
        "lang-code": e.content.langCode,
        "show-menu-buttons": n.showMenuButtons,
        content: r.mobileContent,
        colors: r.colors,
        "sign-in-colors": e.signInColors,
        "sigin-in-url": n.signInUrl,
        "show-sign-in-button": n.showSignInButton,
        "sign-in-text": e.signInText,
        "sign-in-url": n.signInUrl,
        onCloseMenu: t[4] || (t[4] = (u) => e.$emit("toggle-mobile-menu", !1)),
        onToggleSearch: t[5] || (t[5] = (u) => e.$emit("toggle-search")),
        onSetLanguage: t[6] || (t[6] = (u) => e.$emit("set-language", u))
      }, {
        "menu-top": _(() => [
          w(e.$slots, "menu-top", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["theme", "show-utilities", "utilities", "lang-code", "show-menu-buttons", "content", "colors", "sign-in-colors", "sigin-in-url", "show-sign-in-button", "sign-in-text", "sign-in-url"])
    ])) : b("", !0)
  ], 6);
}
const Fo = /* @__PURE__ */ O(r$, [["render", u$], ["__scopeId", "data-v-45e3684c"]]), d$ = {
  name: "Header1",
  components: {
    CmsSchoolsMenu: no,
    M4: K1,
    OrgBanner: oo,
    MobileHeader: Fo,
    MenuItem: Nt
  },
  mixins: [et, ht],
  emits: ["language-change", "toggle-search"]
}, c$ = { class: "left" }, h$ = { class: "right" }, m$ = { class: "right-left-menu" }, p$ = { class: "explore-menu-container" }, f$ = {
  key: 0,
  class: "schools-menu-container"
}, g$ = { key: 0 }, v$ = ["href"];
function b$(e, t, n, o, i, r) {
  var M, C, E, P, F;
  const a = $("OrgBanner"), s = $("MenuItem"), l = $("HeaderDropdown"), u = $("M4"), m = $("cms-schools-menu"), g = $("LanguageDropdown"), p = $("MobileHeader"), T = Ve("click-away");
  return ge((d(), h("div", {
    id: "h1",
    style: j(e.colors)
  }, [
    !e.isMobile || !e.content.newMobileHeader ? (d(), h("div", {
      key: 0,
      "data-testid": "large-screen-header",
      class: v(["header-container", e.shrinkCSSClass, e.logoCircleCSSClass])
    }, [
      c("div", c$, [
        L(a, {
          "logo-link": e.logoLink,
          "should-shrink": e.shouldShrink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals"])
      ]),
      c("div", h$, [
        c("div", m$, [
          c("div", p$, [
            L(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (M = e.theme.navigation_color) == null ? void 0 : M.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.hasExploreMenuContent && !e.isMobile ? (d(), k(s, {
              key: 0,
              item: "explore-button",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (C = e.theme.navigation_color) == null ? void 0 : C.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility,
              onKeydown: t[0] || (t[0] = V(z((D) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"]))
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"])) : b("", !0),
            e.menuV4Enabled && e.exploreMenuVisible ? ge((d(), k(l, {
              key: 1,
              id: "explore-menu",
              "data-testid": "explore-menu",
              role: "menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.customMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[1] || (t[1] = (D) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])), [
              [
                T,
                () => {
                  e.exploreMenuVisible = !1;
                }
              ]
            ]) : b("", !0),
            e.menuV4Enabled && e.isMobile ? (d(), k(u, {
              key: 2,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[2] || (t[2] = (D) => e.$emit("toggle-mobile-menu", D))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : b("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (d(), h("div", f$, [
            L(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (E = e.theme.navigation_color) == null ? void 0 : E.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[3] || (t[3] = V(z((D) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? b("", !0) : (d(), k(l, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-preview": e.content.isPreview,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[4] || (t[4] = (D) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
            L(Ee, { name: "slide" }, {
              default: _(() => [
                e.content.hasCustomSchoolsMenu ? (d(), k(m, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.customSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onHideOnClickaway: t[5] || (t[5] = (D) => e.customSchoolsMenuVisible = !1),
                  onFocusLost: t[6] || (t[6] = (D) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : b("", !0)
              ]),
              _: 1
            })
          ])) : b("", !0)
        ]),
        c("div", {
          class: v(["right-right-menu", { "show-sign-in-button": e.showSignInButton }])
        }, [
          e.shouldDisplayLanguagesDropdown ? (d(), h("div", g$, [
            L(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (P = e.theme.navigation_color) == null ? void 0 : P.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[7] || (t[7] = V(z((D) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            ge(L(g, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[8] || (t[8] = (D) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
              [
                T,
                () => {
                  e.languageDropdownVisible = !1;
                }
              ]
            ])
          ])) : b("", !0),
          L(s, {
            item: "searchbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--bg-color": "transparent",
                "--fill-color": "transparent"
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["theme", "content", "onToggleSearch"]),
          e.showSignInButton ? (d(), h("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, y(e.signInText), 9, v$)) : b("", !0)
        ], 2)
      ])
    ], 2)) : (d(), k(p, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": "transparent",
      "menu-button-icon-color": (F = e.theme.navigation_color) == null ? void 0 : F.hex,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onToggleMobileMenu: t[9] || (t[9] = (D) => e.$emit("toggle-mobile-menu", D)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-icon-color", "is-shrink", "show-sign-in-button", "sign-in-url", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4)), [
    [T, e.closeAllMenus]
  ]);
}
const y$ = /* @__PURE__ */ O(d$, [["render", b$], ["__scopeId", "data-v-3506f7af"]]), _$ = {
  name: "DraggableWrapper",
  props: {
    modelValue: {
      type: Array,
      required: !0
    },
    itemKey: {
      type: String,
      required: !0
    }
  }
};
function C$(e, t, n, o, i, r) {
  return d(), h("div", e5(t5(e.$attrs)), [
    (d(!0), h(Y, null, ee(n.modelValue, (a, s) => w(e.$slots, "item", {
      key: s,
      element: a,
      index: s
    })), 128))
  ], 16);
}
const at = /* @__PURE__ */ O(_$, [["render", C$]]), w$ = {
  name: "UtilityBar",
  props: {
    utilities: {
      type: Array,
      required: !0
    },
    textColor: {
      type: String,
      required: !0
    },
    bgColor: {
      type: String,
      required: !0
    },
    themeVersion: {
      type: String,
      default: ""
    },
    translatedTitle: {
      type: String,
      default: ""
    },
    languageDropdownOpen: Boolean,
    hasLanguages: Boolean,
    isEditing: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  components: {
    DropdownArrowIcon: kr,
    DraggableWrapper: at
  },
  computed: {
    iconClass() {
      return this.languageDropdownOpen ? "open" : void 0;
    }
  }
};
function T$(e, t, n, o, i, r) {
  const a = $("DropdownArrowIcon");
  return d(), h(Y, null, [
    (d(), k(K(n.wrapperComponent), we({ "item-key": "idx" }, n.wrapperProps, {
      "model-value": n.utilities,
      style: [{ color: n.textColor }, { background: n.bgColor }],
      class: ["utility-bar", [n.themeVersion, e.$attrs.class, { "is-editing": n.isEditing }]],
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.$emit("update:utilities", s))
    }), {
      item: _(({ element: s, index: l }) => [
        (d(), k(K(n.isEditing ? "div" : "a"), {
          class: "utilities",
          href: n.isEditing ? "" : s.link,
          target: s.opens_in_new_tab ? "_blank" : ""
        }, {
          default: _(() => [
            w(e.$slots, "utility", { idx: l }, () => [
              A(y(s.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value", "style", "class"])),
    n.themeVersion === "H3" && n.hasLanguages ? (d(), h("button", {
      key: 0,
      class: "translate-button",
      "data-testid": "language-dropdown-button",
      onClick: t[1] || (t[1] = (s) => e.$emit("toggle-language-dropdown"))
    }, [
      c("span", {
        class: "translate-text",
        style: j({ color: n.textColor })
      }, y(n.translatedTitle), 5),
      L(a, {
        "dropdown-class": r.iconClass,
        "fill-color": n.textColor
      }, null, 8, ["dropdown-class", "fill-color"])
    ])) : b("", !0)
  ], 64);
}
const _m = /* @__PURE__ */ O(w$, [["render", T$], ["__scopeId", "data-v-6e681a3d"]]), k$ = {
  name: "Header2",
  components: {
    CmsSchoolsMenu: no,
    MenuItem: Nt,
    M4: K1,
    OrgBanner: oo,
    UtilityBar: _m,
    MobileHeader: Fo
  },
  mixins: [et, ht],
  emits: ["toggle-menu", "toggle-mobile-menu", "close-menu", "language-change", "toggle-search", "update:utilities"]
}, E$ = { class: "left" }, S$ = { class: "right" }, M$ = ["fill"], A$ = { class: "right-menu-items" }, $$ = { key: 0 }, I$ = { key: 1 }, D$ = ["href"], L$ = { class: "right-mobile" }, O$ = { class: "right-left-menu" }, N$ = { class: "explore-menu-container" }, P$ = {
  key: 0,
  class: "schools-menu-container"
}, H$ = {
  key: 0,
  class: "language-icon"
}, F$ = ["href"];
function R$(e, t, n, o, i, r) {
  var C, E, P, F, D, H, B, U, x, Z;
  const a = $("UtilityBar"), s = $("MenuItem"), l = $("OrgBanner"), u = $("HeaderDropdown"), m = $("M4"), g = $("cms-schools-menu"), p = $("LanguageDropdown"), T = $("MobileHeader"), M = Ve("click-away");
  return ge((d(), h("div", {
    id: "h2",
    style: j(e.colors)
  }, [
    c("div", {
      "data-testid": "small-utilities-bar",
      class: v([e.shrinkCSSClass, "utilities utilities-top"])
    }, [
      L(a, {
        class: v([[{ "is-mobile": e.isMobile }, e.shrinkCSSClass], "utility-bar-items"]),
        utilities: e.content.utilities,
        "theme-version": e.theme.version,
        "text-color": e.colors["--utility-link-color"],
        "bg-color": e.colors["--utility-bg-color"]
      }, null, 8, ["class", "utilities", "theme-version", "text-color", "bg-color"]),
      !e.isMobile || !e.content.newMobileHeader ? (d(), k(s, {
        key: 0,
        item: "searchbutton",
        class: v(e.shrinkCSSClass),
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (C = e.theme.search_icon_color) == null ? void 0 : C.hex
          }
        },
        "is-mobile": "",
        onToggleSearch: e.toggleSearch
      }, null, 8, ["class", "theme", "content", "theme-overrides", "onToggleSearch"])) : b("", !0)
    ], 2),
    !e.isMobile || !e.content.newMobileHeader ? (d(), h("div", {
      key: 0,
      "data-testid": "large-screen-header",
      class: v(["header-container", e.shrinkCSSClass, e.logoCircleCSSClass])
    }, [
      c("div", E$, [
        L(l, {
          "logo-link": e.logoLink,
          "should-shrink": e.shouldShrink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals"])
      ]),
      c("div", S$, [
        c("div", {
          "data-testid": "large-utilities-bar",
          class: v([e.shrinkCSSClass, "utilities utilities-right"])
        }, [
          (d(), h("svg", {
            class: v([e.shrinkCSSClass, "sloped-edge"]),
            width: "97",
            height: "56",
            viewBox: "0 0 97 56",
            preserveAspectRatio: "none",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true"
          }, [
            c("path", {
              d: "M94.5015 56H97V0H1.00114C0.188275 0 -0.284554 0.919373 0.187909 1.58124L6.79574 10.8378C27.0277 39.1796 59.6932 56 94.5015 56Z",
              fill: e.colors["--utility-bg-color"]
            }, null, 8, M$)
          ], 2)),
          L(a, {
            utilities: e.content.utilities,
            class: v([e.shrinkCSSClass, "utility-bar-items"]),
            "theme-version": e.theme.version,
            "text-color": e.colors["--utility-link-color"],
            "bg-color": e.colors["--utility-bg-color"]
          }, null, 8, ["utilities", "class", "theme-version", "text-color", "bg-color"]),
          L(s, {
            item: "searchbutton",
            class: v(e.shrinkCSSClass),
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--icon-color": (E = e.theme.search_icon_color) == null ? void 0 : E.hex
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["class", "theme", "content", "theme-overrides", "onToggleSearch"])
        ], 2),
        c("div", A$, [
          c("div", null, [
            L(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (P = e.theme.navigation_icon_bg_color) == null ? void 0 : P.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.hasExploreMenuContent && !e.isMobile ? (d(), k(s, {
              key: 0,
              item: "explore-button",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (F = e.theme.navigation_icon_bg_color) == null ? void 0 : F.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onKeydown: t[0] || (t[0] = V(z((q) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"])) : b("", !0),
            e.menuV4Enabled && e.exploreMenuVisible ? (d(), k(u, {
              key: 1,
              id: "explore-menu",
              "data-testid": "explore-menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.customMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[1] || (t[1] = (q) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : b("", !0),
            e.menuV4Enabled && e.isMobile ? (d(), k(m, {
              key: 2,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[2] || (t[2] = (q) => e.$emit("toggle-mobile-menu", q))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : b("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (d(), h("div", $$, [
            L(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (D = e.theme.navigation_icon_bg_color) == null ? void 0 : D.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[3] || (t[3] = V(z((q) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? b("", !0) : (d(), k(u, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[4] || (t[4] = (q) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-language-menu-hidden", "is-shrink"])),
            L(Ee, { name: "slide" }, {
              default: _(() => [
                e.content.hasCustomSchoolsMenu ? (d(), k(g, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: t[5] || (t[5] = (q) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : b("", !0)
              ]),
              _: 1
            })
          ])) : b("", !0),
          e.shouldDisplayLanguagesDropdown ? (d(), h("div", I$, [
            L(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (H = e.theme.navigation_icon_bg_color) == null ? void 0 : H.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[6] || (t[6] = V(z((q) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            L(p, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[7] || (t[7] = (q) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
          ])) : b("", !0),
          e.showSignInButton ? (d(), h("a", {
            key: 2,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, y(e.signInText), 9, D$)) : b("", !0)
        ])
      ]),
      c("div", L$, [
        c("div", O$, [
          c("div", N$, [
            L(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (B = e.theme.navigation_icon_bg_color) == null ? void 0 : B.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onKeydown: t[8] || (t[8] = V(z((q) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.exploreMenuVisible ? (d(), k(u, {
              key: 0,
              id: "explore-menu",
              "data-testid": "explore-menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.sitemapMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[9] || (t[9] = (q) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : b("", !0),
            e.menuV4Enabled && e.isMobile ? (d(), k(m, {
              key: 1,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[10] || (t[10] = (q) => e.$emit("toggle-mobile-menu", q))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : b("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (d(), h("div", P$, [
            L(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (U = e.theme.navigation_icon_bg_color) == null ? void 0 : U.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[11] || (t[11] = V(z((q) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? b("", !0) : (d(), k(u, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-preview": e.content.isPreview,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[12] || (t[12] = (q) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
            L(Ee, { name: "slide" }, {
              default: _(() => [
                e.content.hasCustomSchoolsMenu ? (d(), k(g, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "schools-menu",
                  "header-theme": e.theme,
                  content: e.content.globals.homepage,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: t[13] || (t[13] = (q) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : b("", !0)
              ]),
              _: 1
            })
          ])) : b("", !0)
        ]),
        c("div", {
          class: v(["right-right-menu", { "show-sign-in-button": e.showSignInButton }])
        }, [
          e.shouldDisplayLanguagesDropdown ? (d(), h("div", H$, [
            L(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (x = e.theme.navigation_icon_bg_color) == null ? void 0 : x.hex
                }
              },
              "is-mobile": "",
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[14] || (t[14] = V(z((q) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            L(p, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[15] || (t[15] = (q) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
          ])) : b("", !0),
          e.showSignInButton ? (d(), h("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, y(e.signInText), 9, F$)) : b("", !0)
        ], 2)
      ])
    ], 2)) : (d(), k(T, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": "transparent",
      "menu-button-icon-color": (Z = e.theme.navigation_color) == null ? void 0 : Z.hex,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onToggleMobileMenu: t[16] || (t[16] = (q) => e.$emit("toggle-mobile-menu", q)),
      onToggleSearch: t[17] || (t[17] = (q) => e.$emit("toggle-search")),
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-icon-color", "is-shrink", "show-sign-in-button", "sign-in-url", "onSetLanguage", "onCloseMenu"]))
  ], 4)), [
    [M, e.closeAllMenus]
  ]);
}
const B$ = /* @__PURE__ */ O(k$, [["render", R$], ["__scopeId", "data-v-fb2a625c"]]), V$ = {
  mixins: [et, ht],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-language-dropdown"],
  components: {
    OrgBanner: oo,
    UtilityBar: _m,
    LanguageDropdown: ua,
    MobileHeader: Fo
  },
  mixins: [et, ht]
};
function j$(e, t, n, o, i, r) {
  var g, p;
  const a = $("MobileHeader"), s = $("OrgBanner"), l = $("UtilityBar"), u = $("LanguageDropdown"), m = Ve("click-away");
  return ge((d(), h("div", {
    id: "h3",
    style: j(e.colors)
  }, [
    e.isMobile ? (d(), k(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": (g = e.theme.navigation_icon_bg_color) == null ? void 0 : g.hex,
      "menu-button-icon-color": (p = e.theme.navigation_icon_color) == null ? void 0 : p.hex,
      "show-utilities": !0,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "hide-menu-button": "",
      onToggleMenu: t[0] || (t[0] = (T) => e.$emit("toggle-menu")),
      onToggleMobileMenu: t[1] || (t[1] = (T) => e.$emit("toggle-mobile-menu", T)),
      onToggleSearch: t[2] || (t[2] = (T) => e.$emit("toggle-search")),
      onLanguageChange: t[3] || (t[3] = (T) => e.$emit("language-change")),
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-bg-color", "menu-button-icon-color", "show-sign-in-button", "sign-in-url", "is-shrink", "onCloseMenu"])) : (d(), h("div", {
      key: 1,
      class: v(["utility-menu", [e.theme.shadow_type, { isIframe: e.content.isIFrame }]])
    }, [
      L(s, {
        "logo-link": e.logoLink,
        "should-shrink": e.shouldShrink,
        theme: e.theme,
        globals: e.content.globals
      }, null, 8, ["logo-link", "should-shrink", "theme", "globals"]),
      c("div", {
        "data-testid": "utilities-bar",
        class: v([e.shrinkCSSClass, "utilities-bar"])
      }, [
        L(l, {
          class: v([[e.theme.style, e.theme.version, e.shrinkCSSClass], "utility-bar-items"]),
          utilities: e.content.utilities,
          "is-editing": e.content.isEditing,
          "theme-version": e.theme.version,
          "translated-title": e.theme.translations.translate_dropdown_title,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "text-color": e.colors["--utility-link-color"],
          "bg-color": "transparent",
          "language-dropdown-open": e.languageDropdownVisible,
          "has-languages": e.hasLanguages,
          onToggleLanguageDropdown: t[4] || (t[4] = (T) => e.setDropdownVisibility("languagebutton")),
          "onUpdate:utilities": t[5] || (t[5] = (T) => e.$emit("update:utilities", T))
        }, {
          utility: _(({ idx: T }) => [
            w(e.$slots, "utility", { idx: T }, void 0, !0)
          ]),
          _: 3
        }, 8, ["class", "utilities", "is-editing", "theme-version", "translated-title", "wrapper-component", "wrapper-props", "text-color", "language-dropdown-open", "has-languages"]),
        L(u, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[6] || (t[6] = (T) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
      ], 2)
    ], 2))
  ], 4)), [
    [m, e.closeAllMenus]
  ]);
}
const U$ = /* @__PURE__ */ O(V$, [["render", j$], ["__scopeId", "data-v-04771afc"]]), G$ = {
  name: "UtilityBar",
  components: {
    DraggableWrapper: at
  },
  props: {
    utilities: {
      type: Array,
      required: !0
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    textColor: {
      type: String,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"]
};
function z$(e, t, n, o, i, r) {
  return d(), k(K(n.wrapperComponent), we(n.wrapperProps, {
    "model-value": n.utilities,
    "item-key": "idx",
    class: "utility-bar",
    "onUpdate:modelValue": t[0] || (t[0] = (a) => e.$emit("update:utilities", a))
  }), {
    item: _(({ element: a, index: s }) => [
      (d(), k(K(n.isEditing ? "div" : "a"), {
        class: "utilities",
        href: a.link,
        style: j({ color: n.textColor }),
        target: a.opens_in_new_tab ? "_blank" : ""
      }, {
        default: _(() => [
          w(e.$slots, "utility", { idx: s }, () => [
            A(y(a.name), 1)
          ], !0)
        ]),
        _: 2
      }, 1032, ["href", "style", "target"]))
    ]),
    _: 3
  }, 16, ["model-value"]);
}
const K$ = /* @__PURE__ */ O(G$, [["render", z$], ["__scopeId", "data-v-f4ecbd63"]]), Z$ = {
  name: "MenuIcon",
  props: {
    type: {
      type: String,
      default: "arrow-1"
    }
  }
}, x$ = {
  key: 0,
  class: "menu-icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, W$ = {
  key: 1,
  class: "menu-icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
};
function q$(e, t, n, o, i, r) {
  return d(), h(Y, null, [
    n.type === "arrow-2" ? (d(), h("svg", x$, t[0] || (t[0] = [
      c("path", {
        d: "M6 13L11 8L6 3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ]))) : b("", !0),
    n.type === "arrow-1" ? (d(), h("svg", W$, t[1] || (t[1] = [
      c("g", null, [
        c("path", {
          d: "M1.5 8L14.5 8M14.5 8L10.4375 12.875M14.5 8L10.4375 3.125",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]))) : b("", !0)
  ], 64);
}
const Y$ = /* @__PURE__ */ O(Z$, [["render", q$]]), X$ = {
  name: "M6",
  components: {
    MenuIcon: Y$
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isMobile: Boolean
  },
  data() {
    return {
      currentPath: []
    };
  },
  computed: {
    breadcrumbTrail() {
      return this.currentPath;
    },
    currentLevelItems() {
      return this.currentPath.length === 0 ? this.isMobile ? this.mobileMenuItems : this.content.sitemapMenuItems : this.currentPath[this.currentPath.length - 1].children || [];
    },
    mobileContent() {
      return he(ie({}, this.content), { menuItems: this.mobileMenuItems });
    },
    shouldDisplaySchoolsDropdown() {
      var e;
      return ((e = this.content.organizations) == null ? void 0 : e.length) > 1 || this.content.hasCustomSchoolsMenu;
    },
    shouldDisplayUtilities() {
      return this.isMobile ? this.currentPath.length === 0 : !0;
    },
    mobileMenuItems() {
      return [
        ...this.shouldDisplaySchoolsDropdown ? [
          {
            id: "schools-header",
            name: this.theme.schools_field || "Schools",
            slug: "schools",
            type: "header",
            children: this.buildSchoolsMenu(
              this.content.hasCustomSchoolsMenu ? this.content.orgMenuContent.flat() : this.content.organizations
            )
          }
        ] : [{}],
        {
          id: "explore-header",
          name: this.theme.menu_field || "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            icon: e.icon,
            cms_icon_id: e.cms_icon_id,
            icon_cms: e.icon_cms,
            opens_in_new_tab: e.opens_in_new_tab,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    colors() {
      return {
        "--heading-color": this.theme.menu_heading_color.hex,
        "--heading-line-color": this.theme.menu_heading_line_color.hex,
        "--icon-color": this.content.menuOptions.icon_color.hex,
        "--icon-bg-color": this.content.menuOptions.icon_bg_color.hex,
        "--icon-text-color": this.content.menuOptions.icon_text_color.hex,
        "--icon-text-hover-color": this.content.menuOptions.icon_text_hover_color.hex,
        "--text-color": this.content.menuOptions.text_color.hex,
        "--text-hover-color": this.content.menuOptions.text_hover_color.hex,
        "--utilities-color": this.theme.utility_link_color.hex
      };
    }
  },
  methods: {
    getPageUrl(e) {
      return e ? `${this.content.pathPrefix}/page/${e.slug}` : "";
    },
    getLinkUrl(e) {
      return e ? e.mailto && e.email_address ? `mailto:${e.email_address}` : e.ipAddress ? `http://${e.url}` : e.url : "";
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    },
    selectItem(e) {
      e.children && e.children.length > 0 && this.currentPath.push(e);
    },
    navigateTo(e) {
      this.currentPath = this.currentPath.slice(0, e + 1);
    },
    resetToMenu() {
      this.currentPath = [];
    },
    buildSchoolsMenu(e) {
      if (An(e))
        return [];
      const t = (o) => {
        let i = "";
        switch (o) {
          case "SchoolsMenuOrg":
            i = "link";
            break;
          case "SchoolsMenuLink":
            i = "link";
            break;
          case "SchoolsMenuImage":
            i = "image";
            break;
          case "SchoolsMenuHeader":
            i = "header";
            break;
          default:
            i = "link";
            break;
        }
        return i;
      }, n = (o) => o.type === "SchoolsMenuLink" ? o.link : o.type === "SchoolsMenuOrg" && this.content.hasCustomSchoolsMenu ? G1(o, this.content.organizations, {
        isPreview: this.content.isPreview
      }) : Ho(o, {
        isPreview: this.content.isPreview,
        currentDomain: window.location.href
      });
      return e.map((o, i) => ({
        id: `schools-${i}`,
        name: o.name,
        slug: o.link || o.path_prefix,
        url: n(o),
        imgSrc: o.url,
        altText: o.alt_text,
        imgHasLink: o.action_on_click === "no_action",
        opens_in_new_tab: o.opens_in_new_tab,
        type: t(o.type),
        children: this.buildSchoolsMenu(o.children)
      }));
    }
  }
}, Q$ = {
  key: 0,
  class: "heading"
}, J$ = ["onClick", "onKeydown"], eI = { key: 1 }, tI = { class: "custom-menu-items" }, nI = ["innerHTML"], oI = ["href", "target"], rI = {
  key: 1,
  class: "utilities"
}, iI = ["href", "target"], sI = {
  key: 2,
  class: "heading-mobile"
}, aI = ["onClick", "onKeydown"], lI = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, uI = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, dI = ["onClick", "onKeydown"], cI = { class: "name" }, hI = ["src", "alt"], mI = ["innerHTML"], pI = ["href", "target"], fI = ["onClick", "onKeydown"];
function gI(e, t, n, o, i, r) {
  const a = $("MenuIcon");
  return d(), h("div", {
    id: "m6",
    class: "menu",
    style: j(r.colors)
  }, [
    n.content.menuOptions.menu_titles ? (d(), h("div", Q$, [
      c("div", {
        class: v(["breadcrumb", { [n.theme.style]: n.theme.style }])
      }, [
        c("div", {
          class: v(["breadcrumb-item", { active: i.currentPath.length === 0 }])
        }, [
          c("div", {
            tabindex: "0",
            role: "button",
            class: "home",
            onClick: t[0] || (t[0] = (...s) => r.resetToMenu && r.resetToMenu(...s)),
            onKeydown: [
              t[1] || (t[1] = V((...s) => r.resetToMenu && r.resetToMenu(...s), ["enter"])),
              t[2] || (t[2] = V((...s) => r.resetToMenu && r.resetToMenu(...s), ["space"]))
            ]
          }, [
            i.currentPath.length > 0 ? (d(), k(a, {
              key: 0,
              type: n.content.menuOptions.link_icon
            }, null, 8, ["type"])) : b("", !0),
            A(" " + y(n.theme.translations.menu_dropdown_title), 1)
          ], 32)
        ], 2),
        (d(!0), h(Y, null, ee(r.breadcrumbTrail, (s, l) => (d(), h("div", {
          key: s.id,
          class: v(["breadcrumb-item", { active: l === r.breadcrumbTrail.length - 1 }])
        }, [
          l !== r.breadcrumbTrail.length - 1 ? (d(), h("div", {
            key: 0,
            tabindex: "0",
            role: "button",
            onClick: (u) => r.navigateTo(l),
            onKeydown: [
              V((u) => r.navigateTo(l), ["enter"]),
              V((u) => r.navigateTo(l), ["space"])
            ]
          }, y(s.name), 41, J$)) : (d(), h("span", eI, y(s.name), 1))
        ], 2))), 128))
      ], 2),
      t[3] || (t[3] = c("div", { class: "line" }, null, -1))
    ])) : b("", !0),
    c("div", tI, [
      (d(!0), h(Y, null, ee(n.content.customMenuItems, (s) => (d(), h("div", {
        key: s.id,
        class: "item"
      }, [
        s.icon || s.icon_cms ? (d(), h("span", {
          key: 0,
          class: v(["icon", s.icon_cms && "global-icon"]),
          innerHTML: s.icon || s.icon_cms
        }, null, 10, nI)) : b("", !0),
        c("a", {
          class: "name",
          href: r.getLink(s.url),
          target: r.targetWindow(s)
        }, y(s.name), 9, oI)
      ]))), 128))
    ]),
    r.shouldDisplayUtilities ? (d(), h("div", rI, [
      (d(!0), h(Y, null, ee(n.content.utilities, (s) => (d(), h("a", {
        key: s.id,
        href: s.link,
        target: s.opens_in_new_tab ? "_blank" : "",
        class: "utility"
      }, y(s.name), 9, iI))), 128))
    ])) : b("", !0),
    i.currentPath.length > 0 && n.isMobile ? (d(), h("div", sI, [
      (d(!0), h(Y, null, ee(r.breadcrumbTrail, (s, l) => (d(), h("div", {
        key: s.id,
        class: v(["breadcrumb", { [n.theme.style]: n.theme.style }])
      }, [
        c("div", {
          tabindex: "0",
          role: "button",
          class: v(["breadcrumb-item", { active: l === r.breadcrumbTrail.length - 1 }]),
          onClick: (u) => r.navigateTo(l - 1),
          onKeydown: [
            V((u) => r.navigateTo(l - 1), ["enter"]),
            V((u) => r.navigateTo(l - 1), ["space"])
          ]
        }, [
          n.content.menuOptions.link_icon === "arrow-2" ? (d(), h("svg", lI, t[4] || (t[4] = [
            c("path", {
              d: "M6 13L11 8L6 3",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))) : (d(), h("svg", uI, t[5] || (t[5] = [
            c("g", null, [
              c("path", {
                d: "M1.5 8L14.5 8M14.5 8L10.4375 12.875M14.5 8L10.4375 3.125",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]))),
          c("span", null, y(s.name), 1)
        ], 42, aI)
      ], 2))), 128)),
      t[6] || (t[6] = c("div", { class: "line" }, null, -1))
    ])) : b("", !0),
    c("div", {
      class: v(["sitemap-menu-items", { "first-level": i.currentPath.length === 0 && n.isMobile }])
    }, [
      (d(!0), h(Y, null, ee(r.currentLevelItems, (s) => (d(), h("div", {
        key: s.id,
        class: v(["item", s.type])
      }, [
        s.type === "header" ? (d(), h("div", {
          key: 0,
          class: "wrapper",
          role: "button",
          tabindex: "0",
          onClick: (l) => r.selectItem(s),
          onKeydown: [
            V((l) => r.selectItem(s), ["enter"]),
            V((l) => r.selectItem(s), ["space"])
          ]
        }, [
          c("span", cI, y(s.name), 1),
          L(a, {
            type: n.content.menuOptions.link_icon
          }, null, 8, ["type"])
        ], 40, dI)) : s.type === "image" ? (d(), h("img", {
          key: 1,
          src: s.imgSrc,
          alt: s.altText
        }, null, 8, hI)) : (d(), h(Y, { key: 2 }, [
          s.icon || s.icon_cms ? (d(), h("span", {
            key: 0,
            class: v(["icon", s.icon_cms && "global-icon"]),
            innerHTML: s.icon || s.icon_cms
          }, null, 10, mI)) : b("", !0),
          c("a", {
            class: "name",
            href: s.type === "page" ? r.getPageUrl(s) : r.getLinkUrl(s),
            target: r.targetWindow(s)
          }, y(s.name), 9, pI),
          s.children && s.children.length > 0 ? (d(), h("div", {
            key: 1,
            class: "icon-wrapper",
            role: "button",
            tabindex: "0",
            onClick: (l) => r.selectItem(s),
            onKeydown: [
              V((l) => r.selectItem(s), ["enter"]),
              V((l) => r.selectItem(s), ["space"])
            ]
          }, [
            L(a, {
              type: n.content.menuOptions.link_icon
            }, null, 8, ["type"])
          ], 40, fI)) : b("", !0)
        ], 64))
      ], 2))), 128))
    ], 2)
  ], 4);
}
const vI = /* @__PURE__ */ O(X$, [["render", gI], ["__scopeId", "data-v-3b4053dc"]]), bI = {
  components: {
    UtilityBar: K$,
    LanguageDropdown: ua,
    MenuItem: Nt,
    CmsSchoolsMenu: no,
    M6: vI
  },
  mixins: [et, ht],
  mixins: [et, ht],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  computed: {
    slogan() {
      var n, o, i, r, a;
      const e = (o = (n = this.theme) == null ? void 0 : n.translations) == null ? void 0 : o.school_tag_line, t = (a = (r = (i = this.content) == null ? void 0 : i.globals) == null ? void 0 : r.info) == null ? void 0 : a.school_tag_line;
      return e || t;
    },
    menuButtonIcon() {
      return {
        arrow: "TriangleIcon",
        plus: "PlusIcon",
        hamburger: "HamburgerIcon"
      }[this.theme.menu_icon];
    },
    menuButtonColors() {
      var n, o, i;
      const e = {
        "--dropdown-class": this.content.showMenu ? "open" : "close"
      }, t = {
        plus: {
          "--fill-color": "transparent",
          "--fill-path-color": (n = this.theme.navigation_color) == null ? void 0 : n.hex
        },
        hamburger: {
          "--fill-color": "transparent",
          "--fill-path-color": (o = this.theme.navigation_color) == null ? void 0 : o.hex
        },
        arrow: {
          "--fill-color": (i = this.theme.navigation_color) == null ? void 0 : i.hex
        }
      };
      return ie(ie({}, e), t[this.theme.menu_icon]);
    },
    colors() {
      var e, t, n, o, i, r, a, s, l, u, m, g, p, T, M, C, E, P, F, D, H, B;
      return ie({
        "--bg-color": this.theme.bg_color.hex,
        "--nav-color": (t = (e = this.theme) == null ? void 0 : e.navigation_color) == null ? void 0 : t.hex,
        "--menu-heading-color": (o = (n = this.theme) == null ? void 0 : n.menu_heading_color) == null ? void 0 : o.hex,
        "--menu-heading-line-color": (r = (i = this.theme) == null ? void 0 : i.menu_heading_line_color) == null ? void 0 : r.hex,
        "--school-name-color": (s = (a = this.theme) == null ? void 0 : a.school_name_color) == null ? void 0 : s.hex,
        "--school-menu-text-color": (u = (l = this.theme) == null ? void 0 : l.schools_menu_text_color) == null ? void 0 : u.hex,
        "--school-tagline-color": (g = (m = this.theme) == null ? void 0 : m.school_tagline_color) == null ? void 0 : g.hex,
        "--school-tagline-bg-color": (T = (p = this.theme) == null ? void 0 : p.utility_bg_color) == null ? void 0 : T.hex,
        "--navigation-links": (C = (M = this.theme) == null ? void 0 : M.utility_link_color) == null ? void 0 : C.hex,
        "--language-color": (P = (E = this.theme) == null ? void 0 : E.language_color) == null ? void 0 : P.hex,
        "--search-color": (D = (F = this.theme) == null ? void 0 : F.search_color) == null ? void 0 : D.hex,
        "--background-opacity": `${(B = (H = this.theme) == null ? void 0 : H.background_opacity) != null ? B : "80"}%`
      }, this.signInColors);
    }
  },
  methods: {
    orgLink(e) {
      return Ho(e, {
        isPreview: this.isPreview,
        currentDomain: window.location.href
      });
    },
    schoolButtonClick() {
      this.setDropdownVisibility("schoolsbutton"), this.content.showMenu && this.$emit("toggle-menu", !1);
    }
  }
}, yI = { class: "top-header" }, _I = { class: "slogan" }, CI = { class: "menu" }, wI = { class: "wrapper" }, TI = { class: "org-banner" }, kI = ["href"], EI = ["src"], SI = { class: "school-info" }, MI = ["href"], AI = { class: "menu-buttons" }, $I = {
  key: 0,
  id: "sign-in-button-wrapper"
}, II = ["href"], DI = { class: "menus" }, LI = {
  key: 1,
  class: "schools-menu",
  "data-testid": "schools-menu"
}, OI = { class: "school-links" }, NI = ["href"], PI = {
  key: 2,
  class: "schools-menu",
  "data-testid": "schools-menu"
};
function HI(e, t, n, o, i, r) {
  var p, T, M, C;
  const a = $("MenuItem"), s = $("LanguageDropdown"), l = $("UtilityBar"), u = $("M6"), m = $("CmsSchoolsMenu"), g = Ve("click-away");
  return ge((d(), h("div", {
    class: "h4",
    style: j(r.colors)
  }, [
    c("div", yI, [
      c("span", _I, y(r.slogan), 1),
      c("div", CI, [
        L(a, {
          item: "languagebutton",
          theme: e.theme,
          content: e.content,
          "is-uppercase": !0,
          "dropdown-open": e.languageDropdownVisible,
          "theme-overrides": {
            icon: "TriangleIcon",
            colors: {
              "--fill-color": (p = e.theme.language_color) == null ? void 0 : p.hex,
              "--nav-color": (T = e.theme.language_color) == null ? void 0 : T.hex
            }
          },
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides", "onToggleDropdown"]),
        L(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[0] || (t[0] = (E) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]),
        L(a, {
          item: "searchbutton",
          class: "search-button",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--icon-color": (M = e.theme.search_color) == null ? void 0 : M.hex,
              "--nav-color": (C = e.theme.search_color) == null ? void 0 : C.hex
            }
          },
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "theme-overrides", "onToggleSearch"])
      ])
    ]),
    c("div", {
      class: v(["bottom-header", [
        e.theme.shadow_type,
        e.theme.bg_type,
        { expanded: e.isCustomSchoolsMenuVisible || e.schoolDropdownVisible || e.content.showMenu }
      ]])
    }, [
      c("div", wI, [
        c("div", TI, [
          c("a", {
            href: e.logoLink,
            class: "logo"
          }, [
            c("img", {
              src: e.content.globals.logo.url,
              alt: "Return to Home"
            }, null, 8, EI)
          ], 8, kI),
          c("div", SI, [
            e.content.globals.info.customHeader ? (d(), h("h1", {
              key: 0,
              class: v({ "sr-only": e.content.globals.info.customHeader })
            }, y(e.content.globals.info.school_name) + " - " + y(r.slogan), 3)) : b("", !0),
            e.content.globals.info.customHeader ? b("", !0) : (d(), h("a", {
              key: 1,
              href: e.logoLink,
              class: "name"
            }, [
              c("h1", {
                class: v([e.theme.style, "org-name"])
              }, y(e.content.globals.info.school_name), 3),
              c("div", {
                class: v(["slogan", { [e.theme.style]: e.theme.style }])
              }, y(r.slogan), 3)
            ], 8, MI)),
            c("div", AI, [
              L(a, {
                item: "schoolsbutton",
                class: "schools-button",
                theme: e.theme,
                content: e.content,
                "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
                "theme-overrides": {
                  icon: "TriangleIcon"
                },
                onToggleDropdown: r.schoolButtonClick
              }, null, 8, ["theme", "content", "dropdown-open", "onToggleDropdown"]),
              L(a, {
                item: "menubutton",
                class: "desktop-menu-button",
                theme: e.theme,
                content: e.content,
                "theme-overrides": {
                  icon: r.menuButtonIcon,
                  colors: r.menuButtonColors
                },
                onToggleDropdown: e.setDropdownVisibility
              }, null, 8, ["theme", "content", "theme-overrides", "onToggleDropdown"])
            ])
          ])
        ]),
        L(a, {
          item: "menubutton",
          class: "mobile-menu-button",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            icon: r.menuButtonIcon,
            colors: r.menuButtonColors
          },
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "theme-overrides", "onToggleDropdown"]),
        L(l, {
          class: v([[e.theme.style, e.theme.version, e.shrinkCSSClass], "utility-bar-items"]),
          "data-testid": "utility-bar",
          utilities: e.content.utilities,
          "is-editing": e.content.isEditing,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "text-color": e.theme.utility_link_color.hex,
          "onUpdate:utilities": t[1] || (t[1] = (E) => e.$emit("update:utilities", E))
        }, {
          utility: _(({ idx: E }) => [
            w(e.$slots, "utility", { idx: E }, void 0, !0)
          ]),
          _: 3
        }, 8, ["class", "utilities", "is-editing", "wrapper-component", "wrapper-props", "text-color"]),
        e.showSignInButton ? (d(), h("div", $I, [
          c("a", {
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, y(e.signInText), 9, II)
        ])) : b("", !0)
      ]),
      c("div", DI, [
        e.menuV6Enabled && e.content.showMenu ? (d(), k(u, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "is-mobile": e.isMobile
        }, null, 8, ["theme", "content", "is-mobile"])) : b("", !0),
        !e.content.hasCustomSchoolsMenu && e.schoolDropdownVisible ? (d(), h("div", LI, [
          c("div", {
            class: v(["heading", { [e.theme.style]: e.theme.style }])
          }, [
            c("div", null, y(e.theme.translations.schools_dropdown_title), 1),
            t[3] || (t[3] = c("div", { class: "line" }, null, -1))
          ], 2),
          c("div", OI, [
            (d(!0), h(Y, null, ee(e.content.organizations, (E, P) => (d(), h("a", {
              key: P,
              href: r.orgLink(E),
              class: "link"
            }, y(E.name), 9, NI))), 128))
          ])
        ])) : b("", !0),
        e.content.hasCustomSchoolsMenu && e.isCustomSchoolsMenuVisible ? (d(), h("div", PI, [
          c("div", {
            class: v(["heading", { [e.theme.style]: e.theme.style }])
          }, [
            c("div", null, y(e.theme.translations.schools_dropdown_title), 1),
            t[4] || (t[4] = c("div", { class: "line" }, null, -1))
          ], 2),
          L(m, {
            id: "schoolsmenu",
            ref: "schoolsmenu",
            "data-testid": "custom-schools-menu",
            role: "menu",
            "header-theme": e.theme,
            "org-menu-content": e.content.orgMenuContent,
            organizations: e.content.organizations,
            "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
            "shrink-header": e.shouldShrink,
            "is-preview": e.content.isPreview,
            onFocusLost: t[2] || (t[2] = (E) => e.customSchoolsMenuVisible = !1)
          }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "shrink-header", "is-preview"])
        ])) : b("", !0)
      ])
    ], 2)
  ], 4)), [
    [g, e.closeAllMenus]
  ]);
}
const FI = /* @__PURE__ */ O(bI, [["render", HI], ["__scopeId", "data-v-c349998d"]]), RI = ["fill"], BI = {
  __name: "FilledTriangleArrow",
  props: {
    iconColor: {
      type: String,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (d(), h("svg", {
      class: v(e.isOpen ? "open" : "close"),
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 14 11",
      fill: "none"
    }, [
      c("path", {
        d: "M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z",
        fill: e.iconColor
      }, null, 8, RI)
    ], 2));
  }
}, VI = /* @__PURE__ */ O(BI, [["__scopeId", "data-v-23478d63"]]), jI = {
  components: {
    DraggableWrapper: at,
    HamburgerIcon: j1,
    TriangleIcon: om,
    FilledTriangleArrow: VI,
    PlusIcon: U1,
    MenuItem: Nt,
    CmsSchoolsMenu: no
  },
  mixins: [et, ht],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  computed: {
    colors() {
      return ie({
        "--utility-bg-color": this.theme.main_nav_bg === "solid" || !this.isHomepage ? this.theme.utility_bg_color.hex : ae(this.theme.utility_bg_color.hex).setAlpha(0.75).toRgbString(),
        "--utility-text-color": this.theme.utility_link_color.hex,
        "--utility-nav-position": this.theme.main_nav_bg === "solid" || !this.isHomepage ? "block" : "absolute",
        "--box-shadow": this.theme.nav_inner_drop_shadow ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25) inset" : "unset",
        "--utility-nav-overflow": this.exploreMenuVisible || this.schoolDropdownVisible || this.customSchoolsMenuVisible || this.isMobile ? "unset" : "auto"
      }, this.signInColors);
    },
    menuDropdownIcon() {
      switch (this.theme.menu_icon) {
        case "arrow":
          return "FilledTriangleArrow";
        case "hamburger":
          return "HamburgerIcon";
        case "plus":
          return "PlusIcon";
        default:
          return "FilledTriangleArrow";
      }
    },
    showTemplateWithSignInButton() {
      return this.showSignInButton && this.isMobile && !this.content.isEditing;
    },
    schoolDropdownAriaControlsValue() {
      return (this.isSchoolDropdownVisible || this.isCustomSchoolsMenuVisible) && this.content.hasCustomSchoolsMenu ? "schoolsmenu" : void 0;
    },
    getExploreDropdownText() {
      var e, t, n, o, i;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.menu_dropdown_title) || ((i = (o = (n = this.theme) == null ? void 0 : n.translations) == null ? void 0 : o.header) == null ? void 0 : i.explore_dropdown_title) || "Explore";
    }
  }
}, UI = ["aria-expanded", "aria-controls"], GI = ["href"], zI = { class: "bottom-bar-item schools-dropdown-wrapper" }, KI = ["aria-expanded", "aria-controls"], ZI = { class: "bottom-bar-item mobile-right" }, xI = ["aria-expanded", "aria-controls"], WI = { class: "bottom-bar-item mobile-right" }, qI = ["aria-expanded", "aria-controls"], YI = { class: "bottom-bar-item schools-dropdown-wrapper" }, XI = ["aria-expanded", "aria-controls"];
function QI(e, t, n, o, i, r) {
  const a = $("TriangleIcon"), s = $("HeaderDropdown"), l = $("cms-schools-menu"), u = $("MenuItem"), m = $("LanguageDropdown"), g = Ve("click-away");
  return d(), h("div", {
    style: j(r.colors),
    class: v(["bottom-bar", { "show-sign-in-button": e.showSignInButton }]),
    "data-testid": "utility-bar"
  }, [
    r.showTemplateWithSignInButton ? (d(), h(Y, { key: 0 }, [
      e.isMobile ? (d(), h("button", {
        key: 0,
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        onClick: t[0] || (t[0] = (p) => e.clickedMenu("menubutton"))
      }, [
        A(y(r.getExploreDropdownText) + " ", 1),
        L(a, {
          "fill-color": r.colors["--utility-text-color"],
          "is-open": e.exploreMenuVisible || e.content.showMenu
        }, null, 8, ["fill-color", "is-open"])
      ], 8, UI)) : b("", !0),
      e.showSignInButton ? (d(), h("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        target: "_blank"
      }, y(e.signInText), 9, GI)) : b("", !0),
      c("div", zI, [
        c("button", {
          id: "schoolsbutton",
          "aria-expanded": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          "aria-controls": r.schoolDropdownAriaControlsValue,
          class: "bottom-bar-item",
          "aria-haspopup": "true",
          onClick: t[1] || (t[1] = (p) => e.clickedMenu("schoolsbutton"))
        }, [
          A(y(e.content.orgDropdownTitle) + " ", 1),
          L(a, {
            "fill-color": r.colors["--utility-text-color"],
            "is-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible
          }, null, 8, ["fill-color", "is-open"])
        ], 8, KI),
        e.content.hasCustomSchoolsMenu ? b("", !0) : (d(), k(s, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          onCloseDropdown: t[2] || (t[2] = (p) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden"])),
        L(Ee, { name: "slide" }, {
          default: _(() => [
            e.content.hasCustomSchoolsMenu ? (d(), k(l, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "custom-schools-menu",
              "header-theme": e.theme,
              content: e.customSchoolsMenu,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.customSchoolsMenuVisible,
              "is-preview": e.content.isPreview,
              onHideOnClickaway: t[3] || (t[3] = (p) => e.customSchoolsMenuVisible = !1),
              onFocusLost: t[4] || (t[4] = (p) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "is-preview"])) : b("", !0)
          ]),
          _: 1
        })
      ]),
      c("div", ZI, [
        e.shouldDisplayLanguagesDropdown ? (d(), k(u, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--nav-color": void 0
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[5] || (t[5] = (p) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "dropdown-open"])) : b("", !0),
        ge(L(m, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[6] || (t[6] = (p) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            g,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ]),
        L(u, {
          theme: e.theme,
          content: e.content,
          "is-mobile-header": e.isMobile,
          item: "searchbutton",
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "is-mobile-header", "onToggleSearch"])
      ])
    ], 64)) : e.isMobile && !e.content.isEditing ? (d(), h(Y, { key: 1 }, [
      e.isMobile ? (d(), h("button", {
        key: 0,
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        onClick: t[7] || (t[7] = (p) => e.clickedMenu("menubutton"))
      }, [
        A(y(r.getExploreDropdownText) + " ", 1),
        L(a, {
          "fill-color": r.colors["--utility-text-color"],
          "is-open": e.exploreMenuVisible || e.content.showMenu
        }, null, 8, ["fill-color", "is-open"])
      ], 8, xI)) : b("", !0),
      c("div", WI, [
        e.shouldDisplayLanguagesDropdown ? (d(), k(u, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--nav-color": void 0
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[8] || (t[8] = (p) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "dropdown-open"])) : b("", !0),
        ge(L(m, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[9] || (t[9] = (p) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            g,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ]),
        L(u, {
          theme: e.theme,
          content: e.content,
          "is-mobile-header": e.isMobile,
          item: "searchbutton",
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "is-mobile-header", "onToggleSearch"])
      ])
    ], 64)) : (d(), h(Y, { key: 2 }, [
      c("button", {
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        "aria-haspopup": "true",
        onClick: t[10] || (t[10] = (p) => e.clickedMenu("menubutton"))
      }, [
        A(y(e.theme.translations.menu_dropdown_title || "Menu") + " ", 1),
        (d(), k(K(r.menuDropdownIcon), {
          "theme-style": e.theme.style,
          "bg-color": r.colors["--utility-bg-color"],
          "icon-color": r.colors["--utility-text-color"],
          "fill-color": "transparent",
          "fill-path-color": r.colors["--utility-text-color"],
          rx: e.theme.style === "purple" ? "50" : "4",
          "is-open": e.content.showMenu || e.exploreMenuVisible
        }, null, 8, ["theme-style", "bg-color", "icon-color", "fill-path-color", "rx", "is-open"]))
      ], 8, qI),
      c("div", YI, [
        c("button", {
          id: "schoolsbutton",
          "aria-expanded": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          "aria-controls": r.schoolDropdownAriaControlsValue,
          class: "bottom-bar-item",
          "aria-haspopup": "true",
          onClick: t[11] || (t[11] = (p) => e.clickedMenu("schoolsbutton"))
        }, [
          A(y(e.content.orgDropdownTitle) + " ", 1),
          (d(), k(K(r.menuDropdownIcon), {
            "theme-style": e.theme.style,
            "bg-color": r.colors["--utility-bg-color"],
            "icon-color": r.colors["--utility-text-color"],
            "fill-color": "transparent",
            "fill-path-color": r.colors["--utility-text-color"],
            rx: e.theme.style === "purple" ? "50" : "4",
            "is-open": e.isSchoolDropdownVisible || e.customSchoolsMenuVisible
          }, null, 8, ["theme-style", "bg-color", "icon-color", "fill-path-color", "rx", "is-open"]))
        ], 8, XI),
        e.content.hasCustomSchoolsMenu ? b("", !0) : (d(), k(s, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          onCloseDropdown: t[12] || (t[12] = (p) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden"])),
        L(Ee, { name: "slide" }, {
          default: _(() => [
            e.content.hasCustomSchoolsMenu ? (d(), k(l, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "custom-schools-menu",
              "header-theme": e.theme,
              content: e.customSchoolsMenu,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.customSchoolsMenuVisible,
              "is-preview": e.content.isPreview,
              onHideOnClickaway: t[13] || (t[13] = (p) => e.customSchoolsMenuVisible = !1),
              onFocusLost: t[14] || (t[14] = (p) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "is-preview"])) : b("", !0)
          ]),
          _: 1
        })
      ]),
      (d(), k(K(n.wrapperComponent), we(n.wrapperProps, {
        "model-value": e.content.utilities,
        "item-key": "idx",
        class: "bottom-bar-utilities-wrapper",
        "onUpdate:modelValue": t[15] || (t[15] = (p) => e.$emit("update:utilities", p))
      }), {
        item: _(({ element: p, index: T }) => [
          (d(), k(K(e.content.isEditing ? "div" : "a"), {
            class: "bottom-bar-item utilities",
            href: p.link,
            target: p.opens_in_new_tab ? "_blank" : ""
          }, {
            default: _(() => [
              w(e.$slots, "utility", { idx: T }, () => [
                A(y(p.name), 1)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ]),
        _: 3
      }, 16, ["model-value"]))
    ], 64))
  ], 6);
}
const JI = /* @__PURE__ */ O(jI, [["render", QI], ["__scopeId", "data-v-2e458f1f"]]), eD = {
  name: "Header5",
  components: {
    UtilityBar: JI,
    OrgBanner: oo,
    MobileHeader: Fo,
    MenuItem: Nt
  },
  mixins: [et, ht],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  computed: {
    colors() {
      var e, t;
      return ie({
        "--top-bar": this.theme.show_top_bar ? `8px solid ${this.theme.top_bar_color.hex}` : "none",
        "--bg-color": this.theme.bg_color.hex,
        "--nav-color": (t = (e = this.theme) == null ? void 0 : e.navigation_color) == null ? void 0 : t.hex
      }, this.signInColors);
    }
  }
}, tD = {
  key: 0,
  "data-testid": "large-screen-header",
  class: "header-container"
}, nD = { class: "left" }, oD = { class: "right" }, rD = { class: "right-right-menu" }, iD = { key: 0 }, sD = ["href"];
function aD(e, t, n, o, i, r) {
  var p, T, M;
  const a = $("OrgBanner"), s = $("MenuItem"), l = $("LanguageDropdown"), u = $("UtilityBar"), m = $("MobileHeader"), g = Ve("click-away");
  return d(), h("div", {
    style: j(r.colors),
    class: "h5"
  }, [
    !e.isMobile || e.isEditing ? (d(), h("div", tD, [
      c("div", nD, [
        L(a, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      c("div", oD, [
        c("div", rD, [
          e.shouldDisplayLanguagesDropdown ? (d(), h("div", iD, [
            L(s, {
              theme: e.theme,
              content: e.content,
              item: "languagebutton",
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--icon-color": (p = e.theme.navigation_color) == null ? void 0 : p.hex,
                  "--fill-color": "transparent",
                  "--fill-path-color": (T = e.theme.navigation_color) == null ? void 0 : T.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onToggleDropdown: t[0] || (t[0] = (C) => e.clickedMenu("languagebutton"))
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
            ge(L(l, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[1] || (t[1] = (C) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
              [
                g,
                () => {
                  e.languageDropdownVisible = !1;
                }
              ]
            ])
          ])) : b("", !0),
          L(s, {
            theme: e.theme,
            content: e.content,
            item: "searchbutton",
            "theme-overrides": {
              colors: {
                "--bg-color": "transparent",
                "--fill-color": "transparent",
                "--fill-path-color": (M = e.theme.navigation_color) == null ? void 0 : M.hex
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["theme", "content", "theme-overrides", "onToggleSearch"]),
          e.showSignInButton ? (d(), h("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, y(e.signInText), 9, sD)) : b("", !0)
        ])
      ])
    ])) : (d(), k(m, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "hide-menu-button": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onCloseMenu: e.closeAllMenus
    }, {
      bottom: _(() => [
        L(u, {
          content: e.content,
          "is-homepage": e.isHomepage,
          "is-mobile": e.isMobile,
          theme: e.theme,
          "show-sign-in-button": e.showSignInButton,
          onToggleMenu: t[2] || (t[2] = (C) => e.$emit("toggle-mobile-menu", C)),
          onToggleSearch: e.toggleSearch,
          onLanguageChange: t[3] || (t[3] = (C) => e.$emit("language-change", C))
        }, null, 8, ["content", "is-homepage", "is-mobile", "theme", "show-sign-in-button", "onToggleSearch"])
      ]),
      _: 1
    }, 8, ["theme", "content", "onCloseMenu"])),
    !e.isMobile || e.isEditing ? (d(), k(u, {
      key: 2,
      content: e.content,
      "is-homepage": e.isHomepage,
      "is-mobile": e.isMobile,
      theme: e.theme,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      onToggleMenu: t[4] || (t[4] = (C) => e.$emit("toggle-menu", C)),
      "onUpdate:utilities": t[5] || (t[5] = (C) => e.$emit("update:utilities", C))
    }, {
      utility: _(({ idx: C }) => [
        w(e.$slots, "utility", { idx: C }, void 0, !0)
      ]),
      _: 3
    }, 8, ["content", "is-homepage", "is-mobile", "theme", "wrapper-component", "wrapper-props"])) : b("", !0)
  ], 4);
}
const lD = /* @__PURE__ */ O(eD, [["render", aD], ["__scopeId", "data-v-da475bf3"]]), uD = {
  components: {
    CmsSchoolsMenu: no,
    MenuItem: Nt
  },
  mixins: [et, ht, Tt],
  props: {
    textColor: {
      type: String,
      required: !0
    },
    largeSize: {
      type: Boolean,
      default: !1
    }
  }
}, dD = { class: "header-nav-wrapper" }, cD = { class: "left button-group" }, hD = {
  key: 1,
  class: "language-button-wrapper"
}, mD = { class: "center" }, pD = {
  key: 0,
  class: "schools-menu-container"
}, fD = ["href"];
function gD(e, t, n, o, i, r) {
  var g, p, T, M, C, E, P, F, D, H, B, U, x;
  const a = $("MenuItem"), s = $("LanguageDropdown"), l = $("HeaderDropdown"), u = $("CmsSchoolsMenu"), m = Ve("click-away");
  return d(), h("div", dD, [
    c("div", cD, [
      n.largeSize ? b("", !0) : (d(), k(a, {
        key: 0,
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (g = e.theme.utility_link_color) == null ? void 0 : g.hex
          }
        },
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "theme-overrides", "screen-size", "onToggleSearch"])),
      e.shouldDisplayLanguagesDropdown ? (d(), h("div", hD, [
        L(a, {
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (p = e.theme.navigation_color) == null ? void 0 : p.hex : (T = e.theme.utility_link_color) == null ? void 0 : T.hex,
              "--nav-color": n.largeSize ? (M = e.theme.navigation_color) == null ? void 0 : M.hex : (C = e.theme.utility_link_color) == null ? void 0 : C.hex
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[0] || (t[0] = (Z) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
        ge(L(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[1] || (t[1] = (Z) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            m,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ])
      ])) : b("", !0),
      n.largeSize ? (d(), k(a, {
        key: 2,
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (E = e.theme.navigation_color) == null ? void 0 : E.hex,
            "--nav-color": (P = e.theme.navigation_color) == null ? void 0 : P.hex
          }
        },
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "theme-overrides", "screen-size", "onToggleSearch"])) : b("", !0)
    ]),
    c("div", mD, [
      w(e.$slots, "default", {}, void 0, !0)
    ]),
    c("div", {
      class: v([[n.largeSize ? "" : "small-bar"], "right button-group"])
    }, [
      e.shouldDisplaySchoolsDropdown && !e.isMobile ? (d(), h("div", pD, [
        L(a, {
          item: "schoolsbutton",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (F = e.theme.navigation_color) == null ? void 0 : F.hex : (D = e.theme.utility_link_color) == null ? void 0 : D.hex,
              "--nav-color": n.largeSize ? (H = e.theme.navigation_color) == null ? void 0 : H.hex : (B = e.theme.utility_link_color) == null ? void 0 : B.hex
            }
          },
          "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
        e.content.hasCustomSchoolsMenu ? b("", !0) : (d(), k(l, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          "is-shrink": e.shrinkCSSClass === "shrink",
          onCloseDropdown: t[2] || (t[2] = (Z) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
        L(Ee, { name: "slide" }, {
          default: _(() => [
            e.content.hasCustomSchoolsMenu ? (d(), k(u, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "schools-menu",
              "header-theme": e.theme,
              content: e.content.globals.homepage,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
              "sticky-header": e.shouldBeSticky,
              "shrink-header": e.shouldShrink,
              "is-preview": e.content.isPreview,
              onFocusLost: t[3] || (t[3] = (Z) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : b("", !0)
          ]),
          _: 1
        })
      ])) : b("", !0),
      c("div", null, [
        L(a, {
          theme: e.theme,
          content: e.content,
          "dropdown-open": e.content.showMenu,
          "theme-overrides": {
            icon: "HamburgerIcon",
            colors: {
              "--nav-color": n.textColor,
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (U = e.theme.navigation_color) == null ? void 0 : U.hex : (x = e.theme.utility_link_color) == null ? void 0 : x.hex
            }
          },
          item: "explore-button",
          onToggleDropdown: t[4] || (t[4] = (Z) => e.clickedMenu("menubutton"))
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
        e.menuV4Enabled && e.content.showMenu ? (d(), k(l, {
          key: 0,
          id: "explore-menu",
          "data-testid": "explore-menu",
          "aria-labelledby": "explore-button",
          styles: e.theme,
          data: e.content.sitemapMenuItems,
          "menu-v4-enabled": e.menuV4Enabled,
          "is-visible": e.exploreMenuVisible,
          "path-prefix": e.content.pathPrefix,
          "is-shrink": e.shrinkCSSClass === "shrink",
          onCloseDropdown: t[5] || (t[5] = (Z) => e.exploreMenuVisible = !1)
        }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : b("", !0)
      ]),
      e.showSignInButton ? (d(), h("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        "data-testid": "desktop-signin-button",
        target: "_blank"
      }, y(e.signInText), 9, fD)) : b("", !0)
    ], 2)
  ]);
}
const vD = /* @__PURE__ */ O(uD, [["render", gD], ["__scopeId", "data-v-950897bb"]]);
function bD(e) {
  return L0() ? (O0(e), !0) : !1;
}
const yD = typeof window != "undefined" && typeof document != "undefined";
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
function _D(e) {
  return N0();
}
function CD(e) {
  return Array.isArray(e) ? e : [e];
}
function wD(e, t = !0, n) {
  _D() ? f1(e, n) : t ? e() : En(e);
}
const Cm = yD ? window : void 0;
function nr(e) {
  var t;
  const n = P0(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function TD() {
  const e = n5(!1), t = N0();
  return t && f1(() => {
    e.value = !0;
  }, t), e;
}
function kD(e) {
  const t = TD();
  return Si(() => (t.value, !!e()));
}
function ED(e, t, n = {}) {
  const g = n, { window: o = Cm } = g, i = Ha(g, ["window"]);
  let r;
  const a = kD(() => o && "ResizeObserver" in o), s = () => {
    r && (r.disconnect(), r = void 0);
  }, l = Si(() => {
    const p = P0(e);
    return Array.isArray(p) ? p.map((T) => nr(T)) : [nr(p)];
  }), u = qs(
    l,
    (p) => {
      if (s(), a.value && o) {
        r = new ResizeObserver(t);
        for (const T of p)
          T && r.observe(T, i);
      }
    },
    { immediate: !0, flush: "post" }
  ), m = () => {
    s(), u();
  };
  return bD(m), {
    isSupported: a,
    stop: m
  };
}
function SD(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: o = Cm, box: i = "content-box" } = n, r = Si(() => {
    var g, p;
    return (p = (g = nr(e)) == null ? void 0 : g.namespaceURI) == null ? void 0 : p.includes("svg");
  }), a = Yn(t.width), s = Yn(t.height), { stop: l } = ED(
    e,
    ([g]) => {
      const p = i === "border-box" ? g.borderBoxSize : i === "content-box" ? g.contentBoxSize : g.devicePixelContentBoxSize;
      if (o && r.value) {
        const T = nr(e);
        if (T) {
          const M = T.getBoundingClientRect();
          a.value = M.width, s.value = M.height;
        }
      } else if (p) {
        const T = CD(p);
        a.value = T.reduce((M, { inlineSize: C }) => M + C, 0), s.value = T.reduce((M, { blockSize: C }) => M + C, 0);
      } else
        a.value = g.contentRect.width, s.value = g.contentRect.height;
    },
    n
  );
  wD(() => {
    const g = nr(e);
    g && (a.value = "offsetWidth" in g ? g.offsetWidth : t.width, s.value = "offsetHeight" in g ? g.offsetHeight : t.height);
  });
  const u = qs(
    () => nr(e),
    (g) => {
      a.value = g ? t.width : 0, s.value = g ? t.height : 0;
    }
  );
  function m() {
    l(), u();
  }
  return {
    width: a,
    height: s,
    stop: m
  };
}
const MD = {
  name: "Header6",
  components: {
    OrgBanner: oo,
    MobileHeader: Fo,
    HeaderNav: vD
  },
  mixins: [et],
  setup() {
    const e = o5("headerElement"), { width: t } = SD(e);
    return {
      headerWidth: t
    };
  },
  computed: {
    colors() {
      return ie({
        "--utility-bg-color": this.theme.utility_bg_color.hex,
        "--utility-text-color": this.theme.utility_link_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--bg-color": this.theme.bg_color.hex
      }, this.signInColors);
    }
  }
}, AD = {
  key: 0,
  class: "header-container"
}, $D = { class: "org-banner-wrapper" }, ID = {
  key: 1,
  class: "org-banner-wrapper smaller-screen"
}, DD = {
  key: 2,
  class: "bottom-nav"
}, LD = { class: "mobile-header-top" }, OD = { class: "org-banner-wrapper" }, ND = { class: "bottom-nav" }, PD = ["href"];
function HD(e, t, n, o, i, r) {
  const a = $("OrgBanner"), s = $("HeaderNav"), l = $("MobileHeader");
  return d(), h("div", {
    ref: "headerElement",
    style: j(r.colors),
    class: "h6"
  }, [
    e.isMobile ? (d(), k(l, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[9] || (t[9] = (u) => e.$emit("toggle-mobile-menu")),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: _(() => [
        c("div", LD, [
          c("div", OD, [
            L(a, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          c("div", ND, [
            L(s, {
              theme: e.theme,
              content: e.content,
              "show-sign-in-button": e.showSignInButton,
              "sign-in-url": e.signInUrl,
              "text-color": e.theme.utility_link_color.hex,
              "bg-color": e.theme.utility_bg_color.hex,
              "is-mobile": "",
              onLanguageChange: t[6] || (t[6] = (u) => e.$emit("language-change", u)),
              onToggleSearch: t[7] || (t[7] = (u) => e.$emit("toggle-search")),
              onToggleMenu: t[8] || (t[8] = (u) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
            }, null, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color", "bg-color"])
          ])
        ])
      ]),
      "menu-top": _(() => [
        e.showSignInButton && o.headerWidth <= 320 ? (d(), h("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, y(e.signInText), 9, PD)) : b("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"])) : (d(), h("div", AD, [
      o.headerWidth > 1280 ? (d(), k(s, {
        key: 0,
        theme: e.theme,
        content: e.content,
        "show-sign-in-button": e.showSignInButton,
        "sign-in-url": e.signInUrl,
        "large-size": "",
        "text-color": e.theme.navigation_color.hex,
        onLanguageChange: t[0] || (t[0] = (u) => e.$emit("language-change", u)),
        onToggleSearch: t[1] || (t[1] = (u) => e.$emit("toggle-search")),
        onToggleMenu: t[2] || (t[2] = (u) => e.$emit("toggle-menu", u))
      }, {
        default: _(() => [
          c("div", $D, [
            L(a, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ])
        ]),
        _: 1
      }, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color"])) : (d(), h("div", ID, [
        L(a, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals,
          class: "org-banner"
        }, null, 8, ["logo-link", "theme", "globals"])
      ])),
      o.headerWidth <= 1280 ? (d(), h("div", DD, [
        L(s, {
          theme: e.theme,
          content: e.content,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "text-color": e.theme.utility_link_color.hex,
          onLanguageChange: t[3] || (t[3] = (u) => e.$emit("language-change", u)),
          onToggleSearch: t[4] || (t[4] = (u) => e.$emit("toggle-search")),
          onToggleMenu: t[5] || (t[5] = (u) => e.$emit("toggle-menu", u))
        }, null, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color"])
      ])) : b("", !0)
    ]))
  ], 4);
}
const FD = /* @__PURE__ */ O(MD, [["render", HD], ["__scopeId", "data-v-e1b257fb"]]), RD = {
  name: "H7TopBar",
  components: { DraggableWrapper: at, MenuItem: Nt },
  mixins: [et, ht, Tt],
  props: {
    content: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-mobile-menu"]
}, BD = { class: "right-icons" }, VD = { key: 0 }, jD = ["href"];
function UD(e, t, n, o, i, r) {
  const a = $("MenuItem"), s = $("LanguageDropdown"), l = Ve("click-away");
  return d(), h("div", {
    class: "top-bar",
    style: j({
      "--nav-color": n.theme.utility_link_color.hex
    })
  }, [
    n.content.isEditing || !e.isMobile ? (d(), k(K(n.wrapperComponent), we({ key: 0 }, n.wrapperProps, {
      "model-value": n.content.utilities,
      "item-key": "idx",
      class: "utilities-container",
      "data-testid": "utility-bar",
      "onUpdate:modelValue": t[0] || (t[0] = (u) => e.$emit("update:utilities", u))
    }), {
      item: _(({ element: u, index: m }) => [
        (d(), k(K(n.content.isEditing ? "div" : "a"), {
          class: "utility",
          href: u.link,
          target: u.opens_in_new_tab ? "_blank" : ""
        }, {
          default: _(() => [
            w(e.$slots, "utility", { idx: m }, () => [
              A(y(u.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value"])) : b("", !0),
    c("div", BD, [
      e.shouldDisplayLanguagesDropdown ? (d(), h("div", VD, [
        L(a, {
          theme: n.theme,
          content: n.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.theme.utility_link_color.hex,
              "--bg-color": "transparent",
              "--nav-color": n.theme.utility_link_color.hex
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[1] || (t[1] = (u) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
        ge(L(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: n.content.languages,
          styles: n.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": n.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[2] || (t[2] = (u) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            l,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ])
      ])) : b("", !0),
      L(a, {
        theme: n.theme,
        content: n.content,
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "screen-size", "onToggleSearch"]),
      e.showSignInButton && e.screenSize > 320 ? (d(), h("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        "data-testid": "desktop-signin-button",
        target: "_blank"
      }, y(e.signInText), 9, jD)) : b("", !0),
      e.screenSize <= 320 ? (d(), k(a, {
        key: 2,
        theme: n.theme,
        content: n.content,
        "dropdown-open": n.content.showMenu,
        "theme-overrides": {
          icon: "HamburgerIcon",
          colors: {
            "--fill-color": "transparent",
            "--fill-path-color": n.theme.utility_link_color.hex,
            "--bg-color": "transparent"
          }
        },
        item: "explore-button",
        onToggleDropdown: t[3] || (t[3] = (u) => e.$emit("toggle-mobile-menu", !n.content.showMenu))
      }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"])) : b("", !0)
    ])
  ], 4);
}
const GD = /* @__PURE__ */ O(RD, [["render", UD], ["__scopeId", "data-v-5fbe6bc7"]]), zD = {
  name: "Header7",
  components: {
    CmsSchoolsMenu: no,
    OrgBanner: oo,
    MobileHeader: Fo,
    MenuItem: Nt,
    TopBar: GD
  },
  mixins: [et, Tt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-mobile-menu"],
  computed: {
    colors() {
      return ie({
        "--top-bar-bg-color": this.theme.utility_bg_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--top-bar-text-color": this.theme.utility_link_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--text-color": this.theme.bg_color.hex
      }, this.signInColors);
    }
  }
}, KD = {
  key: 1,
  class: "header-container"
}, ZD = { class: "header-container-left" }, xD = { class: "header-container-right" }, WD = {
  key: 0,
  class: "schools-menu-container"
}, qD = { class: "mobile-header-top" }, YD = { class: "org-banner-wrapper" }, XD = ["href"];
function QD(e, t, n, o, i, r) {
  const a = $("TopBar"), s = $("OrgBanner"), l = $("MenuItem"), u = $("HeaderDropdown"), m = $("CmsSchoolsMenu"), g = $("MobileHeader");
  return d(), h("div", {
    style: j(r.colors),
    class: "h7"
  }, [
    !e.isMobile || e.content.isEditing ? (d(), k(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onToggleSearch: e.toggleSearch,
      "onUpdate:utilities": t[0] || (t[0] = (p) => e.$emit("update:utilities", p))
    }, {
      utility: _(({ idx: p }) => [
        w(e.$slots, "utility", { idx: p }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"])) : b("", !0),
    !e.isMobile || e.content.isEditing ? (d(), h("div", KD, [
      c("div", ZD, [
        L(s, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      c("div", xD, [
        e.shouldDisplaySchoolsDropdown ? (d(), h("div", WD, [
          L(l, {
            item: "schoolsbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
            onToggleDropdown: e.setDropdownVisibility
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
          e.content.hasCustomSchoolsMenu ? b("", !0) : (d(), k(u, {
            key: 0,
            id: "schoolsmenu",
            "data-testid": "schools-menu",
            "aria-labelledby": "schoolsbutton",
            styles: e.theme,
            data: e.content.organizations,
            "is-visible": e.schoolDropdownVisible,
            "is-preview": e.content.isPreview,
            "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[1] || (t[1] = (p) => e.schoolDropdownVisible = !1)
          }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
          L(Ee, { name: "slide" }, {
            default: _(() => [
              e.content.hasCustomSchoolsMenu ? (d(), k(m, {
                key: 0,
                id: "schoolsmenu",
                ref: "schoolsmenu",
                "data-testid": "schools-menu",
                "header-theme": e.theme,
                content: e.content.globals.homepage,
                "org-menu-content": e.content.orgMenuContent,
                organizations: e.content.organizations,
                "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                "sticky-header": e.shouldBeSticky,
                "shrink-header": e.shouldShrink,
                "is-preview": e.content.isPreview,
                onFocusLost: t[2] || (t[2] = (p) => e.customSchoolsMenuVisible = !1)
              }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : b("", !0)
            ]),
            _: 1
          })
        ])) : b("", !0),
        c("div", null, [
          L(l, {
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            item: "explore-button",
            onToggleDropdown: t[3] || (t[3] = (p) => e.clickedMenu("menubutton"))
          }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
          e.menuV4Enabled && e.content.showMenu ? (d(), k(u, {
            key: 0,
            id: "explore-menu",
            "data-testid": "explore-menu",
            "aria-labelledby": "explore-button",
            styles: e.theme,
            data: e.content.sitemapMenuItems,
            "menu-v4-enabled": e.menuV4Enabled,
            "is-visible": e.exploreMenuVisible,
            "path-prefix": e.content.pathPrefix,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[4] || (t[4] = (p) => e.exploreMenuVisible = !1)
          }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : b("", !0)
        ])
      ])
    ])) : (d(), k(g, {
      key: 2,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[7] || (t[7] = (p) => e.$emit("toggle-mobile-menu", p)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: _(() => [
        L(a, {
          theme: e.theme,
          content: e.content,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "is-mobile": "",
          onToggleMobileMenu: t[5] || (t[5] = (p) => e.$emit("toggle-mobile-menu", p)),
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"]),
        c("div", qD, [
          c("div", YD, [
            L(s, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          e.screenSize > 320 ? (d(), k(l, {
            key: 0,
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            item: "explore-button",
            onToggleDropdown: t[6] || (t[6] = (p) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
          }, null, 8, ["theme", "content", "dropdown-open"])) : b("", !0)
        ])
      ]),
      "menu-top": _(() => [
        e.showSignInButton && e.screenSize <= 320 ? (d(), h("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, y(e.signInText), 9, XD)) : b("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4);
}
const JD = /* @__PURE__ */ O(zD, [["render", QD], ["__scopeId", "data-v-672a1ae1"]]), eL = {
  name: "H8TopBar",
  components: { DraggableWrapper: at, MenuItem: Nt },
  mixins: [et, ht, Tt],
  props: {
    content: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "update:icon-links", "toggle-mobile-menu", "open-icon-modal"]
}, tL = { class: "right-utilities-wrapper" }, nL = ["innerHTML"], oL = { class: "other-utility-options" }, rL = { key: 0 }, iL = ["href"];
function sL(e, t, n, o, i, r) {
  const a = $("MenuItem"), s = $("LanguageDropdown"), l = Ve("click-away");
  return d(), h("div", {
    class: "top-bar",
    style: j({
      "--nav-color": n.theme.utility_link_color.hex
    })
  }, [
    n.content.isEditing || !e.isMobile ? (d(), k(K(n.wrapperComponent), we({ key: 0 }, n.wrapperProps, {
      "model-value": n.content.utilities,
      "item-key": "idx",
      class: "utilities-container",
      "data-testid": "utility-bar",
      "onUpdate:modelValue": t[0] || (t[0] = (u) => e.$emit("update:utilities", u))
    }), {
      item: _(({ element: u, index: m }) => [
        (d(), k(K(n.content.isEditing ? "div" : "a"), {
          class: "utility",
          href: u.link,
          target: u.opens_in_new_tab ? "_blank" : ""
        }, {
          default: _(() => [
            w(e.$slots, "utility", { idx: m }, () => [
              A(y(u.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value"])) : b("", !0),
    c("div", tL, [
      n.content.isEditing || !e.isMobile ? (d(), k(K(n.wrapperComponent), we({ key: 0 }, n.wrapperProps, {
        "model-value": n.content.iconLinks,
        "item-key": "idx",
        class: "icon-links-container",
        "data-testid": "icon-links-section",
        "onUpdate:modelValue": t[2] || (t[2] = (u) => e.$emit("update:icon-links", u))
      }), {
        item: _(({ element: u, index: m }) => [
          n.theme.version === "H8" && n.theme.style === "texas" ? (d(), k(K(n.content.isEditing ? "div" : "a"), {
            key: 0,
            class: "icon-link",
            href: u.link,
            target: u.opens_in_new_tab ? "_blank" : "",
            "aria-label": u.name
          }, {
            default: _(() => [
              w(e.$slots, "iconLink", { idx: m }, () => [
                c("span", {
                  "data-testid": "svg",
                  onClick: t[1] || (t[1] = (g) => e.$emit("open-icon-modal")),
                  innerHTML: u.icon
                }, null, 8, nL)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target", "aria-label"])) : b("", !0)
        ]),
        _: 3
      }, 16, ["model-value"])) : b("", !0),
      c("div", oL, [
        e.shouldDisplayLanguagesDropdown ? (d(), h("div", rL, [
          L(a, {
            theme: n.theme,
            content: n.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": n.theme.utility_link_color.hex,
                "--bg-color": "transparent",
                "--nav-color": n.theme.utility_link_color.hex
              }
            },
            item: "languagebutton",
            "dropdown-open": e.languageDropdownVisible,
            onToggleDropdown: t[3] || (t[3] = (u) => e.clickedMenu("languagebutton"))
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
          ge(L(s, {
            id: "languagesmenu",
            "data-testid": "languages-menu",
            role: "menu",
            data: n.content.languages,
            styles: n.theme,
            "is-visible": e.languageDropdownVisible,
            "current-language": n.content.langCode,
            onSetLanguage: e.setLanguage,
            onCloseDropdown: t[4] || (t[4] = (u) => e.languageDropdownVisible = !1)
          }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
            [
              l,
              () => {
                e.languageDropdownVisible = !1;
              }
            ]
          ])
        ])) : b("", !0),
        L(a, {
          theme: n.theme,
          content: n.content,
          item: "searchbutton",
          "screen-size": e.screenSize,
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "screen-size", "onToggleSearch"]),
        e.showSignInButton && e.screenSize > 320 ? (d(), h("a", {
          key: 1,
          href: e.signInUrl,
          class: "sign-in-button",
          "data-testid": "desktop-signin-button",
          target: "_blank"
        }, y(e.signInText), 9, iL)) : b("", !0),
        e.screenSize <= 320 ? (d(), k(a, {
          key: 2,
          theme: n.theme,
          content: n.content,
          "dropdown-open": n.content.showMenu,
          "theme-overrides": {
            icon: "HamburgerIcon",
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.theme.utility_link_color.hex,
              "--bg-color": "transparent"
            }
          },
          item: "explore-button",
          onToggleDropdown: t[5] || (t[5] = (u) => e.$emit("toggle-mobile-menu", !n.content.showMenu))
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"])) : b("", !0)
      ])
    ])
  ], 4);
}
const aL = /* @__PURE__ */ O(eL, [["render", sL], ["__scopeId", "data-v-50c1cbcc"]]), lL = {
  name: "Header8",
  components: {
    CmsSchoolsMenu: no,
    OrgBanner: oo,
    MobileHeader: Fo,
    MenuItem: Nt,
    H8TopBar: aL
  },
  mixins: [et, Tt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "update:icon-links", "open-icon-modal", "toggle-mobile-menu"],
  computed: {
    colors() {
      return ie({
        "--top-bar-bg-color": this.theme.utility_bg_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--top-bar-text-color": this.theme.utility_link_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--icon-link-color": this.theme.icon_link_color.hex
      }, this.signInColors);
    }
  }
}, uL = {
  key: 1,
  class: "header-container"
}, dL = { class: "header-container-left" }, cL = { class: "header-container-right" }, hL = {
  key: 0,
  class: "schools-menu-container"
}, mL = { class: "mobile-header-top" }, pL = { class: "org-banner-wrapper" }, fL = ["href"];
function gL(e, t, n, o, i, r) {
  const a = $("H8TopBar"), s = $("OrgBanner"), l = $("MenuItem"), u = $("HeaderDropdown"), m = $("CmsSchoolsMenu"), g = $("MobileHeader");
  return d(), h("div", {
    style: j(r.colors),
    class: "h8"
  }, [
    !e.isMobile || e.content.isEditing ? (d(), k(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onOpenIconModal: t[0] || (t[0] = (p) => e.$emit("open-icon-modal", p)),
      onToggleSearch: e.toggleSearch,
      "onUpdate:utilities": t[1] || (t[1] = (p) => e.$emit("update:utilities", p)),
      "onUpdate:iconLinks": t[2] || (t[2] = (p) => e.$emit("update:icon-links", p))
    }, {
      utility: _(({ idx: p }) => [
        w(e.$slots, "utility", { idx: p }, void 0, !0)
      ]),
      iconLink: _(({ idx: p }) => [
        w(e.$slots, "iconLink", { idx: p }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"])) : b("", !0),
    !e.isMobile || e.content.isEditing ? (d(), h("div", uL, [
      c("div", dL, [
        L(s, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      c("div", cL, [
        e.shouldDisplaySchoolsDropdown ? (d(), h("div", hL, [
          L(l, {
            item: "schoolsbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
            onToggleDropdown: e.setDropdownVisibility
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
          e.content.hasCustomSchoolsMenu ? b("", !0) : (d(), k(u, {
            key: 0,
            id: "schoolsmenu",
            "data-testid": "schools-menu",
            "aria-labelledby": "schoolsbutton",
            styles: e.theme,
            data: e.content.organizations,
            "is-visible": e.schoolDropdownVisible,
            "is-preview": e.content.isPreview,
            "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[3] || (t[3] = (p) => e.schoolDropdownVisible = !1)
          }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
          L(Ee, { name: "slide" }, {
            default: _(() => [
              e.content.hasCustomSchoolsMenu ? (d(), k(m, {
                key: 0,
                id: "schoolsmenu",
                ref: "schoolsmenu",
                "data-testid": "schools-menu",
                "header-theme": e.theme,
                content: e.content.globals.homepage,
                "org-menu-content": e.content.orgMenuContent,
                organizations: e.content.organizations,
                "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                "sticky-header": e.shouldBeSticky,
                "shrink-header": e.shouldShrink,
                "is-preview": e.content.isPreview,
                onFocusLost: t[4] || (t[4] = (p) => e.customSchoolsMenuVisible = !1)
              }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : b("", !0)
            ]),
            _: 1
          })
        ])) : b("", !0),
        c("div", null, [
          L(l, {
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            item: "explore-button",
            onToggleDropdown: t[5] || (t[5] = (p) => e.clickedMenu("menubutton"))
          }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
          e.menuV4Enabled && e.content.showMenu ? (d(), k(u, {
            key: 0,
            id: "explore-menu",
            "data-testid": "explore-menu",
            "aria-labelledby": "explore-button",
            styles: e.theme,
            data: e.content.sitemapMenuItems,
            "menu-v4-enabled": e.menuV4Enabled,
            "is-visible": e.exploreMenuVisible,
            "path-prefix": e.content.pathPrefix,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[6] || (t[6] = (p) => e.exploreMenuVisible = !1)
          }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : b("", !0)
        ])
      ])
    ])) : (d(), k(g, {
      key: 2,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[9] || (t[9] = (p) => e.$emit("toggle-mobile-menu", p)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: _(() => [
        L(a, {
          theme: e.theme,
          content: e.content,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "is-mobile": "",
          onToggleMobileMenu: t[7] || (t[7] = (p) => e.$emit("toggle-mobile-menu", p)),
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"]),
        c("div", mL, [
          c("div", pL, [
            L(s, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          e.screenSize > 320 ? (d(), k(l, {
            key: 0,
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            item: "explore-button",
            onToggleDropdown: t[8] || (t[8] = (p) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
          }, null, 8, ["theme", "content", "dropdown-open"])) : b("", !0)
        ])
      ]),
      "menu-top": _(() => [
        e.showSignInButton && e.screenSize <= 320 ? (d(), h("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, y(e.signInText), 9, fL)) : b("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4);
}
const vL = /* @__PURE__ */ O(lL, [["render", gL], ["__scopeId", "data-v-3ee389b0"]]);
var bL = Object.defineProperty, yL = Object.defineProperties, _L = Object.getOwnPropertyDescriptors, Nd = Object.getOwnPropertySymbols, CL = Object.prototype.hasOwnProperty, wL = Object.prototype.propertyIsEnumerable, Pd = (e, t, n) => t in e ? bL(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Tn = (e, t) => {
  for (var n in t || (t = {}))
    CL.call(t, n) && Pd(e, n, t[n]);
  if (Nd)
    for (var n of Nd(t))
      wL.call(t, n) && Pd(e, n, t[n]);
  return e;
}, Z1 = (e, t) => yL(e, _L(t));
function Hd(e) {
  if (e)
    throw e;
}
var Gi = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Er(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var TL = function(e) {
  return e != null && e.constructor != null && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
};
const wm = /* @__PURE__ */ Er(TL);
var cs = Object.prototype.hasOwnProperty, Tm = Object.prototype.toString, Fd = Object.defineProperty, Rd = Object.getOwnPropertyDescriptor, Bd = function(e) {
  return typeof Array.isArray == "function" ? Array.isArray(e) : Tm.call(e) === "[object Array]";
}, Vd = function(e) {
  if (!e || Tm.call(e) !== "[object Object]")
    return !1;
  var t = cs.call(e, "constructor"), n = e.constructor && e.constructor.prototype && cs.call(e.constructor.prototype, "isPrototypeOf");
  if (e.constructor && !t && !n)
    return !1;
  var o;
  for (o in e)
    ;
  return typeof o == "undefined" || cs.call(e, o);
}, jd = function(e, t) {
  Fd && t.name === "__proto__" ? Fd(e, t.name, {
    enumerable: !0,
    configurable: !0,
    value: t.newValue,
    writable: !0
  }) : e[t.name] = t.newValue;
}, Ud = function(e, t) {
  if (t === "__proto__")
    if (cs.call(e, t)) {
      if (Rd)
        return Rd(e, t).value;
    } else return;
  return e[t];
}, kL = function e() {
  var t, n, o, i, r, a, s = arguments[0], l = 1, u = arguments.length, m = !1;
  for (typeof s == "boolean" && (m = s, s = arguments[1] || {}, l = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); l < u; ++l)
    if (t = arguments[l], t != null)
      for (n in t)
        o = Ud(s, n), i = Ud(t, n), s !== i && (m && i && (Vd(i) || (r = Bd(i))) ? (r ? (r = !1, a = o && Bd(o) ? o : []) : a = o && Vd(o) ? o : {}, jd(s, { name: n, newValue: e(m, a, i) })) : typeof i != "undefined" && jd(s, { name: n, newValue: i }));
  return s;
};
const Gd = /* @__PURE__ */ Er(kL);
function Xl(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function EL() {
  const e = [], t = { run: n, use: o };
  return t;
  function n(...i) {
    let r = -1;
    const a = i.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    s(null, ...i);
    function s(l, ...u) {
      const m = e[++r];
      let g = -1;
      if (l) {
        a(l);
        return;
      }
      for (; ++g < i.length; )
        (u[g] === null || u[g] === void 0) && (u[g] = i[g]);
      i = u, m ? SL(m, s)(...u) : a(null, ...u);
    }
  }
  function o(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function SL(e, t) {
  let n;
  return o;
  function o(...a) {
    const s = e.length > a.length;
    let l;
    s && a.push(i);
    try {
      l = e.apply(this, a);
    } catch (u) {
      const m = (
        /** @type {Error} */
        u
      );
      if (s && n)
        throw m;
      return i(m);
    }
    s || (l && l.then && typeof l.then == "function" ? l.then(r, i) : l instanceof Error ? i(l) : r(l));
  }
  function i(a, ...s) {
    n || (n = !0, t(a, ...s));
  }
  function r(a) {
    i(null, a);
  }
}
function ML(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? zd(e.position) : "start" in e || "end" in e ? zd(e) : "line" in e || "column" in e ? Ql(e) : "";
}
function Ql(e) {
  return Kd(e && e.line) + ":" + Kd(e && e.column);
}
function zd(e) {
  return Ql(e && e.start) + "-" + Ql(e && e.end);
}
function Kd(e) {
  return e && typeof e == "number" ? e : 1;
}
class Gt extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(t, n, o) {
    const i = [null, null];
    let r = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (o = n, n = void 0), typeof o == "string") {
      const a = o.indexOf(":");
      a === -1 ? i[1] = o : (i[0] = o.slice(0, a), i[1] = o.slice(a + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (r = n.position) : "start" in n || "end" in n ? r = n : ("line" in n || "column" in n) && (r.start = n)), this.name = ML(n) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = "", typeof t == "object" && t.stack && (this.stack = t.stack), this.reason = this.message, this.fatal, this.line = r.start.line, this.column = r.start.column, this.position = r, this.source = i[0], this.ruleId = i[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
Gt.prototype.file = "";
Gt.prototype.name = "";
Gt.prototype.reason = "";
Gt.prototype.message = "";
Gt.prototype.stack = "";
Gt.prototype.fatal = null;
Gt.prototype.column = null;
Gt.prototype.line = null;
Gt.prototype.source = null;
Gt.prototype.ruleId = null;
Gt.prototype.position = null;
const rn = { basename: AL, dirname: $L, extname: IL, join: DL, sep: "/" };
function AL(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Ii(e);
  let n = 0, o = -1, i = e.length, r;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.charCodeAt(i) === 47) {
        if (r) {
          n = i + 1;
          break;
        }
      } else o < 0 && (r = !0, o = i + 1);
    return o < 0 ? "" : e.slice(n, o);
  }
  if (t === e)
    return "";
  let a = -1, s = t.length - 1;
  for (; i--; )
    if (e.charCodeAt(i) === 47) {
      if (r) {
        n = i + 1;
        break;
      }
    } else
      a < 0 && (r = !0, a = i + 1), s > -1 && (e.charCodeAt(i) === t.charCodeAt(s--) ? s < 0 && (o = i) : (s = -1, o = a));
  return n === o ? o = a : o < 0 && (o = e.length), e.slice(n, o);
}
function $L(e) {
  if (Ii(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, o;
  for (; --n; )
    if (e.charCodeAt(n) === 47) {
      if (o) {
        t = n;
        break;
      }
    } else o || (o = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function IL(e) {
  Ii(e);
  let t = e.length, n = -1, o = 0, i = -1, r = 0, a;
  for (; t--; ) {
    const s = e.charCodeAt(t);
    if (s === 47) {
      if (a) {
        o = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), s === 46 ? i < 0 ? i = t : r !== 1 && (r = 1) : i > -1 && (r = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  r === 0 || // The (right-most) trimmed path component is exactly `..`.
  r === 1 && i === n - 1 && i === o + 1 ? "" : e.slice(i, n);
}
function DL(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Ii(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : LL(n);
}
function LL(e) {
  Ii(e);
  const t = e.charCodeAt(0) === 47;
  let n = OL(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function OL(e, t) {
  let n = "", o = 0, i = -1, r = 0, a = -1, s, l;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      s = e.charCodeAt(a);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === a - 1 || r === 1)) if (i !== a - 1 && r === 2) {
        if (n.length < 2 || o !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (l = n.lastIndexOf("/"), l !== n.length - 1) {
              l < 0 ? (n = "", o = 0) : (n = n.slice(0, l), o = n.length - 1 - n.lastIndexOf("/")), i = a, r = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", o = 0, i = a, r = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", o = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, a) : n = e.slice(i + 1, a), o = a - i - 1;
      i = a, r = 0;
    } else s === 46 && r > -1 ? r++ : r = -1;
  }
  return n;
}
function Ii(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const NL = { cwd: PL };
function PL() {
  return "/";
}
function Jl(e) {
  return e !== null && typeof e == "object" && // @ts-expect-error: indexable.
  e.href && // @ts-expect-error: indexable.
  e.origin;
}
function HL(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Jl(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return FL(e);
}
function FL(e) {
  if (e.hostname !== "") {
    const o = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw o.code = "ERR_INVALID_FILE_URL_HOST", o;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.charCodeAt(n) === 37 && t.charCodeAt(n + 1) === 50) {
      const o = t.charCodeAt(n + 2);
      if (o === 70 || o === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const qa = ["history", "path", "basename", "stem", "extname", "dirname"];
class RL {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? typeof t == "string" || BL(t) ? n = { value: t } : Jl(t) ? n = { path: t } : n = t : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = NL.cwd(), this.value, this.stored, this.result, this.map;
    let o = -1;
    for (; ++o < qa.length; ) {
      const r = qa[o];
      r in n && n[r] !== void 0 && n[r] !== null && (this[r] = r === "history" ? [...n[r]] : n[r]);
    }
    let i;
    for (i in n)
      qa.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(t) {
    Jl(t) && (t = HL(t)), Xa(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? rn.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(t) {
    Zd(this.basename, "dirname"), this.path = rn.join(t || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? rn.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(t) {
    Xa(t, "basename"), Ya(t, "basename"), this.path = rn.join(this.dirname || "", t);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? rn.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(t) {
    if (Ya(t, "extname"), Zd(this.dirname, "extname"), t) {
      if (t.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = rn.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? rn.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(t) {
    Xa(t, "stem"), Ya(t, "stem"), this.path = rn.join(this.dirname || "", t + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return (this.value || "").toString(t || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, o) {
    const i = new Gt(t, n, o);
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, o) {
    const i = this.message(t, n, o);
    return i.fatal = null, i;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, o) {
    const i = this.message(t, n, o);
    throw i.fatal = !0, i;
  }
}
function Ya(e, t) {
  if (e && e.includes(rn.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + rn.sep + "`"
    );
}
function Xa(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Zd(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function BL(e) {
  return wm(e);
}
const e1 = Em().freeze(), km = {}.hasOwnProperty;
function Em() {
  const e = EL(), t = [];
  let n = {}, o, i = -1;
  return r.data = a, r.Parser = void 0, r.Compiler = void 0, r.freeze = s, r.attachers = t, r.use = l, r.parse = u, r.stringify = m, r.run = g, r.runSync = p, r.process = T, r.processSync = M, r;
  function r() {
    const C = Em();
    let E = -1;
    for (; ++E < t.length; )
      C.use(...t[E]);
    return C.data(Gd(!0, {}, n)), C;
  }
  function a(C, E) {
    return typeof C == "string" ? arguments.length === 2 ? (el("data", o), n[C] = E, r) : km.call(n, C) && n[C] || null : C ? (el("data", o), n = C, r) : n;
  }
  function s() {
    if (o)
      return r;
    for (; ++i < t.length; ) {
      const [C, ...E] = t[i];
      if (E[0] === !1)
        continue;
      E[0] === !0 && (E[0] = void 0);
      const P = C.call(r, ...E);
      typeof P == "function" && e.use(P);
    }
    return o = !0, i = Number.POSITIVE_INFINITY, r;
  }
  function l(C, ...E) {
    let P;
    if (el("use", o), C != null) if (typeof C == "function")
      B(C, ...E);
    else if (typeof C == "object")
      Array.isArray(C) ? H(C) : D(C);
    else
      throw new TypeError("Expected usable value, not `" + C + "`");
    return P && (n.settings = Object.assign(n.settings || {}, P)), r;
    function F(U) {
      if (typeof U == "function")
        B(U);
      else if (typeof U == "object")
        if (Array.isArray(U)) {
          const [x, ...Z] = U;
          B(x, ...Z);
        } else
          D(U);
      else
        throw new TypeError("Expected usable value, not `" + U + "`");
    }
    function D(U) {
      H(U.plugins), U.settings && (P = Object.assign(P || {}, U.settings));
    }
    function H(U) {
      let x = -1;
      if (U != null) if (Array.isArray(U))
        for (; ++x < U.length; ) {
          const Z = U[x];
          F(Z);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + U + "`");
    }
    function B(U, x) {
      let Z = -1, q;
      for (; ++Z < t.length; )
        if (t[Z][0] === U) {
          q = t[Z];
          break;
        }
      q ? (Xl(q[1]) && Xl(x) && (x = Gd(!0, q[1], x)), q[1] = x) : t.push([...arguments]);
    }
  }
  function u(C) {
    r.freeze();
    const E = Br(C), P = r.Parser;
    return Qa("parse", P), xd(P, "parse") ? new P(String(E), E).parse() : P(String(E), E);
  }
  function m(C, E) {
    r.freeze();
    const P = Br(E), F = r.Compiler;
    return Ja("stringify", F), Wd(C), xd(F, "compile") ? new F(C, P).compile() : F(C, P);
  }
  function g(C, E, P) {
    if (Wd(C), r.freeze(), !P && typeof E == "function" && (P = E, E = void 0), !P)
      return new Promise(F);
    F(null, P);
    function F(D, H) {
      e.run(C, Br(E), B);
      function B(U, x, Z) {
        x = x || C, U ? H(U) : D ? D(x) : P(null, x, Z);
      }
    }
  }
  function p(C, E) {
    let P, F;
    return r.run(C, E, D), qd("runSync", "run", F), P;
    function D(H, B) {
      Hd(H), P = B, F = !0;
    }
  }
  function T(C, E) {
    if (r.freeze(), Qa("process", r.Parser), Ja("process", r.Compiler), !E)
      return new Promise(P);
    P(null, E);
    function P(F, D) {
      const H = Br(C);
      r.run(r.parse(H), H, (U, x, Z) => {
        if (U || !x || !Z)
          B(U);
        else {
          const q = r.stringify(x, Z);
          q == null || (UL(q) ? Z.value = q : Z.result = q), B(U, Z);
        }
      });
      function B(U, x) {
        U || !x ? D(U) : F ? F(x) : E(null, x);
      }
    }
  }
  function M(C) {
    let E;
    r.freeze(), Qa("processSync", r.Parser), Ja("processSync", r.Compiler);
    const P = Br(C);
    return r.process(P, F), qd("processSync", "process", E), P;
    function F(D) {
      E = !0, Hd(D);
    }
  }
}
function xd(e, t) {
  return typeof e == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  e.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (VL(e.prototype) || t in e.prototype);
}
function VL(e) {
  let t;
  for (t in e)
    if (km.call(e, t))
      return !0;
  return !1;
}
function Qa(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function Ja(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function el(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Wd(e) {
  if (!Xl(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function qd(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Br(e) {
  return jL(e) ? e : new RL(e);
}
function jL(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function UL(e) {
  return typeof e == "string" || wm(e);
}
var en = {};
const GL = [
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
];
en.REPLACEMENT_CHARACTER = "�";
en.CODE_POINTS = {
  EOF: -1,
  NULL: 0,
  TABULATION: 9,
  CARRIAGE_RETURN: 13,
  LINE_FEED: 10,
  FORM_FEED: 12,
  SPACE: 32,
  EXCLAMATION_MARK: 33,
  QUOTATION_MARK: 34,
  NUMBER_SIGN: 35,
  AMPERSAND: 38,
  APOSTROPHE: 39,
  HYPHEN_MINUS: 45,
  SOLIDUS: 47,
  DIGIT_0: 48,
  DIGIT_9: 57,
  SEMICOLON: 59,
  LESS_THAN_SIGN: 60,
  EQUALS_SIGN: 61,
  GREATER_THAN_SIGN: 62,
  QUESTION_MARK: 63,
  LATIN_CAPITAL_A: 65,
  LATIN_CAPITAL_F: 70,
  LATIN_CAPITAL_X: 88,
  LATIN_CAPITAL_Z: 90,
  RIGHT_SQUARE_BRACKET: 93,
  GRAVE_ACCENT: 96,
  LATIN_SMALL_A: 97,
  LATIN_SMALL_F: 102,
  LATIN_SMALL_X: 120,
  LATIN_SMALL_Z: 122,
  REPLACEMENT_CHARACTER: 65533
};
en.CODE_POINT_SEQUENCES = {
  DASH_DASH_STRING: [45, 45],
  //--
  DOCTYPE_STRING: [68, 79, 67, 84, 89, 80, 69],
  //DOCTYPE
  CDATA_START_STRING: [91, 67, 68, 65, 84, 65, 91],
  //[CDATA[
  SCRIPT_STRING: [115, 99, 114, 105, 112, 116],
  //script
  PUBLIC_STRING: [80, 85, 66, 76, 73, 67],
  //PUBLIC
  SYSTEM_STRING: [83, 89, 83, 84, 69, 77]
  //SYSTEM
};
en.isSurrogate = function(e) {
  return e >= 55296 && e <= 57343;
};
en.isSurrogatePair = function(e) {
  return e >= 56320 && e <= 57343;
};
en.getSurrogatePairCodePoint = function(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
};
en.isControlCodePoint = function(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
};
en.isUndefinedCodePoint = function(e) {
  return e >= 64976 && e <= 65007 || GL.indexOf(e) > -1;
};
var x1 = {
  controlCharacterInInputStream: "control-character-in-input-stream",
  noncharacterInInputStream: "noncharacter-in-input-stream",
  surrogateInInputStream: "surrogate-in-input-stream",
  nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
  endTagWithAttributes: "end-tag-with-attributes",
  endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
  unexpectedSolidusInTag: "unexpected-solidus-in-tag",
  unexpectedNullCharacter: "unexpected-null-character",
  unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
  invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
  unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
  missingEndTagName: "missing-end-tag-name",
  unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
  unknownNamedCharacterReference: "unknown-named-character-reference",
  missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
  unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
  unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
  eofBeforeTagName: "eof-before-tag-name",
  eofInTag: "eof-in-tag",
  missingAttributeValue: "missing-attribute-value",
  missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
  missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
  missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
  missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
  missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
  missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
  missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
  abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
  abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
  cdataInHtmlContent: "cdata-in-html-content",
  incorrectlyOpenedComment: "incorrectly-opened-comment",
  eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
  eofInDoctype: "eof-in-doctype",
  nestedComment: "nested-comment",
  abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
  eofInComment: "eof-in-comment",
  incorrectlyClosedComment: "incorrectly-closed-comment",
  eofInCdata: "eof-in-cdata",
  absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
  nullCharacterReference: "null-character-reference",
  surrogateCharacterReference: "surrogate-character-reference",
  characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
  controlCharacterReference: "control-character-reference",
  noncharacterCharacterReference: "noncharacter-character-reference",
  missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
  missingDoctypeName: "missing-doctype-name",
  invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
  duplicateAttribute: "duplicate-attribute",
  nonConformingDoctype: "non-conforming-doctype",
  missingDoctype: "missing-doctype",
  misplacedDoctype: "misplaced-doctype",
  endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
  closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
  disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
  openElementsLeftAfterEof: "open-elements-left-after-eof",
  abandonedHeadElementChild: "abandoned-head-element-child",
  misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
  nestedNoscriptInHead: "nested-noscript-in-head",
  eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
};
const Xo = en, tl = x1, lo = Xo.CODE_POINTS, zL = 65536;
let KL = class {
  constructor() {
    this.html = null, this.pos = -1, this.lastGapPos = -1, this.lastCharPos = -1, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = zL;
  }
  _err() {
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(e) {
    if (this.pos !== this.lastCharPos) {
      const t = this.html.charCodeAt(this.pos + 1);
      if (Xo.isSurrogatePair(t))
        return this.pos++, this._addGap(), Xo.getSurrogatePairCodePoint(e, t);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, lo.EOF;
    return this._err(tl.surrogateInInputStream), e;
  }
  dropParsedChunk() {
    this.pos > this.bufferWaterline && (this.lastCharPos -= this.pos, this.html = this.html.substring(this.pos), this.pos = 0, this.lastGapPos = -1, this.gapStack = []);
  }
  write(e, t) {
    this.html ? this.html += e : this.html = e, this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1, this.lastChunkWritten = t;
  }
  insertHtmlAtCurrentPos(e) {
    this.html = this.html.substring(0, this.pos + 1) + e + this.html.substring(this.pos + 1, this.html.length), this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1;
  }
  advance() {
    if (this.pos++, this.pos > this.lastCharPos)
      return this.endOfChunkHit = !this.lastChunkWritten, lo.EOF;
    let e = this.html.charCodeAt(this.pos);
    return this.skipNextNewLine && e === lo.LINE_FEED ? (this.skipNextNewLine = !1, this._addGap(), this.advance()) : e === lo.CARRIAGE_RETURN ? (this.skipNextNewLine = !0, lo.LINE_FEED) : (this.skipNextNewLine = !1, Xo.isSurrogate(e) && (e = this._processSurrogate(e)), e > 31 && e < 127 || e === lo.LINE_FEED || e === lo.CARRIAGE_RETURN || e > 159 && e < 64976 || this._checkForProblematicCharacters(e), e);
  }
  _checkForProblematicCharacters(e) {
    Xo.isControlCodePoint(e) ? this._err(tl.controlCharacterInInputStream) : Xo.isUndefinedCodePoint(e) && this._err(tl.noncharacterInInputStream);
  }
  retreat() {
    this.pos === this.lastGapPos && (this.lastGapPos = this.gapStack.pop(), this.pos--), this.pos--;
  }
};
var ZL = KL, xL = new Uint16Array([4, 52, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 106, 303, 412, 810, 1432, 1701, 1796, 1987, 2114, 2360, 2420, 2484, 3170, 3251, 4140, 4393, 4575, 4610, 5106, 5512, 5728, 6117, 6274, 6315, 6345, 6427, 6516, 7002, 7910, 8733, 9323, 9870, 10170, 10631, 10893, 11318, 11386, 11467, 12773, 13092, 14474, 14922, 15448, 15542, 16419, 17666, 18166, 18611, 19004, 19095, 19298, 19397, 4, 16, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 140, 150, 158, 169, 176, 194, 199, 210, 216, 222, 226, 242, 256, 266, 283, 294, 108, 105, 103, 5, 198, 1, 59, 148, 1, 198, 80, 5, 38, 1, 59, 156, 1, 38, 99, 117, 116, 101, 5, 193, 1, 59, 167, 1, 193, 114, 101, 118, 101, 59, 1, 258, 4, 2, 105, 121, 182, 191, 114, 99, 5, 194, 1, 59, 189, 1, 194, 59, 1, 1040, 114, 59, 3, 55349, 56580, 114, 97, 118, 101, 5, 192, 1, 59, 208, 1, 192, 112, 104, 97, 59, 1, 913, 97, 99, 114, 59, 1, 256, 100, 59, 1, 10835, 4, 2, 103, 112, 232, 237, 111, 110, 59, 1, 260, 102, 59, 3, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 1, 8289, 105, 110, 103, 5, 197, 1, 59, 264, 1, 197, 4, 2, 99, 115, 272, 277, 114, 59, 3, 55349, 56476, 105, 103, 110, 59, 1, 8788, 105, 108, 100, 101, 5, 195, 1, 59, 292, 1, 195, 109, 108, 5, 196, 1, 59, 301, 1, 196, 4, 8, 97, 99, 101, 102, 111, 114, 115, 117, 321, 350, 354, 383, 388, 394, 400, 405, 4, 2, 99, 114, 327, 336, 107, 115, 108, 97, 115, 104, 59, 1, 8726, 4, 2, 118, 119, 342, 345, 59, 1, 10983, 101, 100, 59, 1, 8966, 121, 59, 1, 1041, 4, 3, 99, 114, 116, 362, 369, 379, 97, 117, 115, 101, 59, 1, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 1, 8492, 97, 59, 1, 914, 114, 59, 3, 55349, 56581, 112, 102, 59, 3, 55349, 56633, 101, 118, 101, 59, 1, 728, 99, 114, 59, 1, 8492, 109, 112, 101, 113, 59, 1, 8782, 4, 14, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 442, 447, 456, 504, 542, 547, 569, 573, 577, 616, 678, 784, 790, 796, 99, 121, 59, 1, 1063, 80, 89, 5, 169, 1, 59, 454, 1, 169, 4, 3, 99, 112, 121, 464, 470, 497, 117, 116, 101, 59, 1, 262, 4, 2, 59, 105, 476, 478, 1, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8517, 108, 101, 121, 115, 59, 1, 8493, 4, 4, 97, 101, 105, 111, 514, 520, 530, 535, 114, 111, 110, 59, 1, 268, 100, 105, 108, 5, 199, 1, 59, 528, 1, 199, 114, 99, 59, 1, 264, 110, 105, 110, 116, 59, 1, 8752, 111, 116, 59, 1, 266, 4, 2, 100, 110, 553, 560, 105, 108, 108, 97, 59, 1, 184, 116, 101, 114, 68, 111, 116, 59, 1, 183, 114, 59, 1, 8493, 105, 59, 1, 935, 114, 99, 108, 101, 4, 4, 68, 77, 80, 84, 591, 596, 603, 609, 111, 116, 59, 1, 8857, 105, 110, 117, 115, 59, 1, 8854, 108, 117, 115, 59, 1, 8853, 105, 109, 101, 115, 59, 1, 8855, 111, 4, 2, 99, 115, 623, 646, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8754, 101, 67, 117, 114, 108, 121, 4, 2, 68, 81, 658, 671, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8221, 117, 111, 116, 101, 59, 1, 8217, 4, 4, 108, 110, 112, 117, 688, 701, 736, 753, 111, 110, 4, 2, 59, 101, 696, 698, 1, 8759, 59, 1, 10868, 4, 3, 103, 105, 116, 709, 717, 722, 114, 117, 101, 110, 116, 59, 1, 8801, 110, 116, 59, 1, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8750, 4, 2, 102, 114, 742, 745, 59, 1, 8450, 111, 100, 117, 99, 116, 59, 1, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8755, 111, 115, 115, 59, 1, 10799, 99, 114, 59, 3, 55349, 56478, 112, 4, 2, 59, 67, 803, 805, 1, 8915, 97, 112, 59, 1, 8781, 4, 11, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 834, 850, 855, 860, 865, 888, 903, 916, 921, 1011, 1415, 4, 2, 59, 111, 840, 842, 1, 8517, 116, 114, 97, 104, 100, 59, 1, 10513, 99, 121, 59, 1, 1026, 99, 121, 59, 1, 1029, 99, 121, 59, 1, 1039, 4, 3, 103, 114, 115, 873, 879, 883, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8609, 104, 118, 59, 1, 10980, 4, 2, 97, 121, 894, 900, 114, 111, 110, 59, 1, 270, 59, 1, 1044, 108, 4, 2, 59, 116, 910, 912, 1, 8711, 97, 59, 1, 916, 114, 59, 3, 55349, 56583, 4, 2, 97, 102, 927, 998, 4, 2, 99, 109, 933, 992, 114, 105, 116, 105, 99, 97, 108, 4, 4, 65, 68, 71, 84, 950, 957, 978, 985, 99, 117, 116, 101, 59, 1, 180, 111, 4, 2, 116, 117, 964, 967, 59, 1, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 1, 733, 114, 97, 118, 101, 59, 1, 96, 105, 108, 100, 101, 59, 1, 732, 111, 110, 100, 59, 1, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8518, 4, 4, 112, 116, 117, 119, 1021, 1026, 1048, 1249, 102, 59, 3, 55349, 56635, 4, 3, 59, 68, 69, 1034, 1036, 1041, 1, 168, 111, 116, 59, 1, 8412, 113, 117, 97, 108, 59, 1, 8784, 98, 108, 101, 4, 6, 67, 68, 76, 82, 85, 86, 1065, 1082, 1101, 1189, 1211, 1236, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8751, 111, 4, 2, 116, 119, 1089, 1092, 59, 1, 168, 110, 65, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 101, 111, 1107, 1141, 102, 116, 4, 3, 65, 82, 84, 1117, 1124, 1136, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8660, 101, 101, 59, 1, 10980, 110, 103, 4, 2, 76, 82, 1149, 1177, 101, 102, 116, 4, 2, 65, 82, 1158, 1165, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10233, 105, 103, 104, 116, 4, 2, 65, 84, 1199, 1206, 114, 114, 111, 119, 59, 1, 8658, 101, 101, 59, 1, 8872, 112, 4, 2, 65, 68, 1218, 1225, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8741, 110, 4, 6, 65, 66, 76, 82, 84, 97, 1264, 1292, 1299, 1352, 1391, 1408, 114, 114, 111, 119, 4, 3, 59, 66, 85, 1276, 1278, 1283, 1, 8595, 97, 114, 59, 1, 10515, 112, 65, 114, 114, 111, 119, 59, 1, 8693, 114, 101, 118, 101, 59, 1, 785, 101, 102, 116, 4, 3, 82, 84, 86, 1310, 1323, 1334, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 1, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10590, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1345, 1347, 1, 8637, 97, 114, 59, 1, 10582, 105, 103, 104, 116, 4, 2, 84, 86, 1362, 1373, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10591, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1384, 1386, 1, 8641, 97, 114, 59, 1, 10583, 101, 101, 4, 2, 59, 65, 1399, 1401, 1, 8868, 114, 114, 111, 119, 59, 1, 8615, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 99, 116, 1421, 1426, 114, 59, 3, 55349, 56479, 114, 111, 107, 59, 1, 272, 4, 16, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1466, 1470, 1478, 1489, 1515, 1520, 1525, 1536, 1544, 1593, 1609, 1617, 1650, 1664, 1668, 1677, 71, 59, 1, 330, 72, 5, 208, 1, 59, 1476, 1, 208, 99, 117, 116, 101, 5, 201, 1, 59, 1487, 1, 201, 4, 3, 97, 105, 121, 1497, 1503, 1512, 114, 111, 110, 59, 1, 282, 114, 99, 5, 202, 1, 59, 1510, 1, 202, 59, 1, 1069, 111, 116, 59, 1, 278, 114, 59, 3, 55349, 56584, 114, 97, 118, 101, 5, 200, 1, 59, 1534, 1, 200, 101, 109, 101, 110, 116, 59, 1, 8712, 4, 2, 97, 112, 1550, 1555, 99, 114, 59, 1, 274, 116, 121, 4, 2, 83, 86, 1563, 1576, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9643, 4, 2, 103, 112, 1599, 1604, 111, 110, 59, 1, 280, 102, 59, 3, 55349, 56636, 115, 105, 108, 111, 110, 59, 1, 917, 117, 4, 2, 97, 105, 1624, 1640, 108, 4, 2, 59, 84, 1631, 1633, 1, 10869, 105, 108, 100, 101, 59, 1, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8652, 4, 2, 99, 105, 1656, 1660, 114, 59, 1, 8496, 109, 59, 1, 10867, 97, 59, 1, 919, 109, 108, 5, 203, 1, 59, 1675, 1, 203, 4, 2, 105, 112, 1683, 1689, 115, 116, 115, 59, 1, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 1, 8519, 4, 5, 99, 102, 105, 111, 115, 1713, 1717, 1722, 1762, 1791, 121, 59, 1, 1060, 114, 59, 3, 55349, 56585, 108, 108, 101, 100, 4, 2, 83, 86, 1732, 1745, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9642, 4, 3, 112, 114, 117, 1770, 1775, 1781, 102, 59, 3, 55349, 56637, 65, 108, 108, 59, 1, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 1, 8497, 99, 114, 59, 1, 8497, 4, 12, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1822, 1827, 1834, 1848, 1855, 1877, 1882, 1887, 1890, 1896, 1978, 1984, 99, 121, 59, 1, 1027, 5, 62, 1, 59, 1832, 1, 62, 109, 109, 97, 4, 2, 59, 100, 1843, 1845, 1, 915, 59, 1, 988, 114, 101, 118, 101, 59, 1, 286, 4, 3, 101, 105, 121, 1863, 1869, 1874, 100, 105, 108, 59, 1, 290, 114, 99, 59, 1, 284, 59, 1, 1043, 111, 116, 59, 1, 288, 114, 59, 3, 55349, 56586, 59, 1, 8921, 112, 102, 59, 3, 55349, 56638, 101, 97, 116, 101, 114, 4, 6, 69, 70, 71, 76, 83, 84, 1915, 1933, 1944, 1953, 1959, 1971, 113, 117, 97, 108, 4, 2, 59, 76, 1925, 1927, 1, 8805, 101, 115, 115, 59, 1, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8807, 114, 101, 97, 116, 101, 114, 59, 1, 10914, 101, 115, 115, 59, 1, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10878, 105, 108, 100, 101, 59, 1, 8819, 99, 114, 59, 3, 55349, 56482, 59, 1, 8811, 4, 8, 65, 97, 99, 102, 105, 111, 115, 117, 2005, 2012, 2026, 2032, 2036, 2049, 2073, 2089, 82, 68, 99, 121, 59, 1, 1066, 4, 2, 99, 116, 2018, 2023, 101, 107, 59, 1, 711, 59, 1, 94, 105, 114, 99, 59, 1, 292, 114, 59, 1, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 1, 8459, 4, 2, 112, 114, 2055, 2059, 102, 59, 1, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 1, 9472, 4, 2, 99, 116, 2079, 2083, 114, 59, 1, 8459, 114, 111, 107, 59, 1, 294, 109, 112, 4, 2, 68, 69, 2097, 2107, 111, 119, 110, 72, 117, 109, 112, 59, 1, 8782, 113, 117, 97, 108, 59, 1, 8783, 4, 14, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 2144, 2149, 2155, 2160, 2171, 2189, 2194, 2198, 2209, 2245, 2307, 2329, 2334, 2341, 99, 121, 59, 1, 1045, 108, 105, 103, 59, 1, 306, 99, 121, 59, 1, 1025, 99, 117, 116, 101, 5, 205, 1, 59, 2169, 1, 205, 4, 2, 105, 121, 2177, 2186, 114, 99, 5, 206, 1, 59, 2184, 1, 206, 59, 1, 1048, 111, 116, 59, 1, 304, 114, 59, 1, 8465, 114, 97, 118, 101, 5, 204, 1, 59, 2207, 1, 204, 4, 3, 59, 97, 112, 2217, 2219, 2238, 1, 8465, 4, 2, 99, 103, 2225, 2229, 114, 59, 1, 298, 105, 110, 97, 114, 121, 73, 59, 1, 8520, 108, 105, 101, 115, 59, 1, 8658, 4, 2, 116, 118, 2251, 2281, 4, 2, 59, 101, 2257, 2259, 1, 8748, 4, 2, 103, 114, 2265, 2271, 114, 97, 108, 59, 1, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8898, 105, 115, 105, 98, 108, 101, 4, 2, 67, 84, 2293, 2300, 111, 109, 109, 97, 59, 1, 8291, 105, 109, 101, 115, 59, 1, 8290, 4, 3, 103, 112, 116, 2315, 2320, 2325, 111, 110, 59, 1, 302, 102, 59, 3, 55349, 56640, 97, 59, 1, 921, 99, 114, 59, 1, 8464, 105, 108, 100, 101, 59, 1, 296, 4, 2, 107, 109, 2347, 2352, 99, 121, 59, 1, 1030, 108, 5, 207, 1, 59, 2358, 1, 207, 4, 5, 99, 102, 111, 115, 117, 2372, 2386, 2391, 2397, 2414, 4, 2, 105, 121, 2378, 2383, 114, 99, 59, 1, 308, 59, 1, 1049, 114, 59, 3, 55349, 56589, 112, 102, 59, 3, 55349, 56641, 4, 2, 99, 101, 2403, 2408, 114, 59, 3, 55349, 56485, 114, 99, 121, 59, 1, 1032, 107, 99, 121, 59, 1, 1028, 4, 7, 72, 74, 97, 99, 102, 111, 115, 2436, 2441, 2446, 2452, 2467, 2472, 2478, 99, 121, 59, 1, 1061, 99, 121, 59, 1, 1036, 112, 112, 97, 59, 1, 922, 4, 2, 101, 121, 2458, 2464, 100, 105, 108, 59, 1, 310, 59, 1, 1050, 114, 59, 3, 55349, 56590, 112, 102, 59, 3, 55349, 56642, 99, 114, 59, 3, 55349, 56486, 4, 11, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2508, 2513, 2520, 2562, 2585, 2981, 2986, 3004, 3011, 3146, 3167, 99, 121, 59, 1, 1033, 5, 60, 1, 59, 2518, 1, 60, 4, 5, 99, 109, 110, 112, 114, 2532, 2538, 2544, 2548, 2558, 117, 116, 101, 59, 1, 313, 98, 100, 97, 59, 1, 923, 103, 59, 1, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 1, 8466, 114, 59, 1, 8606, 4, 3, 97, 101, 121, 2570, 2576, 2582, 114, 111, 110, 59, 1, 317, 100, 105, 108, 59, 1, 315, 59, 1, 1051, 4, 2, 102, 115, 2591, 2907, 116, 4, 10, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2614, 2663, 2672, 2728, 2735, 2760, 2820, 2870, 2888, 2895, 4, 2, 110, 114, 2620, 2633, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10216, 114, 111, 119, 4, 3, 59, 66, 82, 2644, 2646, 2651, 1, 8592, 97, 114, 59, 1, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8646, 101, 105, 108, 105, 110, 103, 59, 1, 8968, 111, 4, 2, 117, 119, 2679, 2692, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10214, 110, 4, 2, 84, 86, 2699, 2710, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10593, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2721, 2723, 1, 8643, 97, 114, 59, 1, 10585, 108, 111, 111, 114, 59, 1, 8970, 105, 103, 104, 116, 4, 2, 65, 86, 2745, 2752, 114, 114, 111, 119, 59, 1, 8596, 101, 99, 116, 111, 114, 59, 1, 10574, 4, 2, 101, 114, 2766, 2792, 101, 4, 3, 59, 65, 86, 2775, 2777, 2784, 1, 8867, 114, 114, 111, 119, 59, 1, 8612, 101, 99, 116, 111, 114, 59, 1, 10586, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 2806, 2808, 2813, 1, 8882, 97, 114, 59, 1, 10703, 113, 117, 97, 108, 59, 1, 8884, 112, 4, 3, 68, 84, 86, 2829, 2841, 2852, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10592, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2863, 2865, 1, 8639, 97, 114, 59, 1, 10584, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2881, 2883, 1, 8636, 97, 114, 59, 1, 10578, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8660, 115, 4, 6, 69, 70, 71, 76, 83, 84, 2922, 2936, 2947, 2956, 2962, 2974, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8806, 114, 101, 97, 116, 101, 114, 59, 1, 8822, 101, 115, 115, 59, 1, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10877, 105, 108, 100, 101, 59, 1, 8818, 114, 59, 3, 55349, 56591, 4, 2, 59, 101, 2992, 2994, 1, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8666, 105, 100, 111, 116, 59, 1, 319, 4, 3, 110, 112, 119, 3019, 3110, 3115, 103, 4, 4, 76, 82, 108, 114, 3030, 3058, 3070, 3098, 101, 102, 116, 4, 2, 65, 82, 3039, 3046, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10230, 101, 102, 116, 4, 2, 97, 114, 3079, 3086, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10233, 102, 59, 3, 55349, 56643, 101, 114, 4, 2, 76, 82, 3123, 3134, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8600, 4, 3, 99, 104, 116, 3154, 3158, 3161, 114, 59, 1, 8466, 59, 1, 8624, 114, 111, 107, 59, 1, 321, 59, 1, 8810, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 3188, 3192, 3196, 3222, 3227, 3237, 3243, 3248, 112, 59, 1, 10501, 121, 59, 1, 1052, 4, 2, 100, 108, 3202, 3213, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8287, 108, 105, 110, 116, 114, 102, 59, 1, 8499, 114, 59, 3, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 1, 8723, 112, 102, 59, 3, 55349, 56644, 99, 114, 59, 1, 8499, 59, 1, 924, 4, 9, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3271, 3276, 3283, 3306, 3422, 3427, 4120, 4126, 4137, 99, 121, 59, 1, 1034, 99, 117, 116, 101, 59, 1, 323, 4, 3, 97, 101, 121, 3291, 3297, 3303, 114, 111, 110, 59, 1, 327, 100, 105, 108, 59, 1, 325, 59, 1, 1053, 4, 3, 103, 115, 119, 3314, 3380, 3415, 97, 116, 105, 118, 101, 4, 3, 77, 84, 86, 3327, 3340, 3365, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8203, 104, 105, 4, 2, 99, 110, 3348, 3357, 107, 83, 112, 97, 99, 101, 59, 1, 8203, 83, 112, 97, 99, 101, 59, 1, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8203, 116, 101, 100, 4, 2, 71, 76, 3389, 3405, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 1, 8810, 76, 105, 110, 101, 59, 1, 10, 114, 59, 3, 55349, 56593, 4, 4, 66, 110, 112, 116, 3437, 3444, 3460, 3464, 114, 101, 97, 107, 59, 1, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 1, 160, 102, 59, 1, 8469, 4, 13, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3492, 3494, 3517, 3536, 3578, 3657, 3685, 3784, 3823, 3860, 3915, 4066, 4107, 1, 10988, 4, 2, 111, 117, 3500, 3510, 110, 103, 114, 117, 101, 110, 116, 59, 1, 8802, 112, 67, 97, 112, 59, 1, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8742, 4, 3, 108, 113, 120, 3544, 3552, 3571, 101, 109, 101, 110, 116, 59, 1, 8713, 117, 97, 108, 4, 2, 59, 84, 3561, 3563, 1, 8800, 105, 108, 100, 101, 59, 3, 8770, 824, 105, 115, 116, 115, 59, 1, 8708, 114, 101, 97, 116, 101, 114, 4, 7, 59, 69, 70, 71, 76, 83, 84, 3600, 3602, 3609, 3621, 3631, 3637, 3650, 1, 8815, 113, 117, 97, 108, 59, 1, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 3, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 3, 8811, 824, 101, 115, 115, 59, 1, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10878, 824, 105, 108, 100, 101, 59, 1, 8821, 117, 109, 112, 4, 2, 68, 69, 3666, 3677, 111, 119, 110, 72, 117, 109, 112, 59, 3, 8782, 824, 113, 117, 97, 108, 59, 3, 8783, 824, 101, 4, 2, 102, 115, 3692, 3724, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3709, 3711, 3717, 1, 8938, 97, 114, 59, 3, 10703, 824, 113, 117, 97, 108, 59, 1, 8940, 115, 4, 6, 59, 69, 71, 76, 83, 84, 3739, 3741, 3748, 3757, 3764, 3777, 1, 8814, 113, 117, 97, 108, 59, 1, 8816, 114, 101, 97, 116, 101, 114, 59, 1, 8824, 101, 115, 115, 59, 3, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10877, 824, 105, 108, 100, 101, 59, 1, 8820, 101, 115, 116, 101, 100, 4, 2, 71, 76, 3795, 3812, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 3, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 3, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 4, 3, 59, 69, 83, 3838, 3840, 3848, 1, 8832, 113, 117, 97, 108, 59, 3, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8928, 4, 2, 101, 105, 3866, 3881, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 1, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3900, 3902, 3908, 1, 8939, 97, 114, 59, 3, 10704, 824, 113, 117, 97, 108, 59, 1, 8941, 4, 2, 113, 117, 3921, 3973, 117, 97, 114, 101, 83, 117, 4, 2, 98, 112, 3933, 3952, 115, 101, 116, 4, 2, 59, 69, 3942, 3945, 3, 8847, 824, 113, 117, 97, 108, 59, 1, 8930, 101, 114, 115, 101, 116, 4, 2, 59, 69, 3963, 3966, 3, 8848, 824, 113, 117, 97, 108, 59, 1, 8931, 4, 3, 98, 99, 112, 3981, 4e3, 4045, 115, 101, 116, 4, 2, 59, 69, 3990, 3993, 3, 8834, 8402, 113, 117, 97, 108, 59, 1, 8840, 99, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 4015, 4017, 4025, 4037, 1, 8833, 113, 117, 97, 108, 59, 3, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8929, 105, 108, 100, 101, 59, 3, 8831, 824, 101, 114, 115, 101, 116, 4, 2, 59, 69, 4056, 4059, 3, 8835, 8402, 113, 117, 97, 108, 59, 1, 8841, 105, 108, 100, 101, 4, 4, 59, 69, 70, 84, 4080, 4082, 4089, 4100, 1, 8769, 113, 117, 97, 108, 59, 1, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8775, 105, 108, 100, 101, 59, 1, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8740, 99, 114, 59, 3, 55349, 56489, 105, 108, 100, 101, 5, 209, 1, 59, 4135, 1, 209, 59, 1, 925, 4, 14, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 4170, 4176, 4187, 4205, 4212, 4217, 4228, 4253, 4259, 4292, 4295, 4316, 4337, 4346, 108, 105, 103, 59, 1, 338, 99, 117, 116, 101, 5, 211, 1, 59, 4185, 1, 211, 4, 2, 105, 121, 4193, 4202, 114, 99, 5, 212, 1, 59, 4200, 1, 212, 59, 1, 1054, 98, 108, 97, 99, 59, 1, 336, 114, 59, 3, 55349, 56594, 114, 97, 118, 101, 5, 210, 1, 59, 4226, 1, 210, 4, 3, 97, 101, 105, 4236, 4241, 4246, 99, 114, 59, 1, 332, 103, 97, 59, 1, 937, 99, 114, 111, 110, 59, 1, 927, 112, 102, 59, 3, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 4, 2, 68, 81, 4272, 4285, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8220, 117, 111, 116, 101, 59, 1, 8216, 59, 1, 10836, 4, 2, 99, 108, 4301, 4306, 114, 59, 3, 55349, 56490, 97, 115, 104, 5, 216, 1, 59, 4314, 1, 216, 105, 4, 2, 108, 109, 4323, 4332, 100, 101, 5, 213, 1, 59, 4330, 1, 213, 101, 115, 59, 1, 10807, 109, 108, 5, 214, 1, 59, 4344, 1, 214, 101, 114, 4, 2, 66, 80, 4354, 4380, 4, 2, 97, 114, 4360, 4364, 114, 59, 1, 8254, 97, 99, 4, 2, 101, 107, 4372, 4375, 59, 1, 9182, 101, 116, 59, 1, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9180, 4, 9, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4413, 4422, 4426, 4431, 4435, 4438, 4448, 4471, 4561, 114, 116, 105, 97, 108, 68, 59, 1, 8706, 121, 59, 1, 1055, 114, 59, 3, 55349, 56595, 105, 59, 1, 934, 59, 1, 928, 117, 115, 77, 105, 110, 117, 115, 59, 1, 177, 4, 2, 105, 112, 4454, 4467, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 1, 8460, 102, 59, 1, 8473, 4, 4, 59, 101, 105, 111, 4481, 4483, 4526, 4531, 1, 10939, 99, 101, 100, 101, 115, 4, 4, 59, 69, 83, 84, 4498, 4500, 4507, 4519, 1, 8826, 113, 117, 97, 108, 59, 1, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8828, 105, 108, 100, 101, 59, 1, 8830, 109, 101, 59, 1, 8243, 4, 2, 100, 112, 4537, 4543, 117, 99, 116, 59, 1, 8719, 111, 114, 116, 105, 111, 110, 4, 2, 59, 97, 4555, 4557, 1, 8759, 108, 59, 1, 8733, 4, 2, 99, 105, 4567, 4572, 114, 59, 3, 55349, 56491, 59, 1, 936, 4, 4, 85, 102, 111, 115, 4585, 4594, 4599, 4604, 79, 84, 5, 34, 1, 59, 4592, 1, 34, 114, 59, 3, 55349, 56596, 112, 102, 59, 1, 8474, 99, 114, 59, 3, 55349, 56492, 4, 12, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4636, 4642, 4650, 4681, 4704, 4763, 4767, 4771, 5047, 5069, 5081, 5094, 97, 114, 114, 59, 1, 10512, 71, 5, 174, 1, 59, 4648, 1, 174, 4, 3, 99, 110, 114, 4658, 4664, 4668, 117, 116, 101, 59, 1, 340, 103, 59, 1, 10219, 114, 4, 2, 59, 116, 4675, 4677, 1, 8608, 108, 59, 1, 10518, 4, 3, 97, 101, 121, 4689, 4695, 4701, 114, 111, 110, 59, 1, 344, 100, 105, 108, 59, 1, 342, 59, 1, 1056, 4, 2, 59, 118, 4710, 4712, 1, 8476, 101, 114, 115, 101, 4, 2, 69, 85, 4722, 4748, 4, 2, 108, 113, 4728, 4736, 101, 109, 101, 110, 116, 59, 1, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10607, 114, 59, 1, 8476, 111, 59, 1, 929, 103, 104, 116, 4, 8, 65, 67, 68, 70, 84, 85, 86, 97, 4792, 4840, 4849, 4905, 4912, 4972, 5022, 5040, 4, 2, 110, 114, 4798, 4811, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10217, 114, 111, 119, 4, 3, 59, 66, 76, 4822, 4824, 4829, 1, 8594, 97, 114, 59, 1, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8644, 101, 105, 108, 105, 110, 103, 59, 1, 8969, 111, 4, 2, 117, 119, 4856, 4869, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10215, 110, 4, 2, 84, 86, 4876, 4887, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10589, 101, 99, 116, 111, 114, 4, 2, 59, 66, 4898, 4900, 1, 8642, 97, 114, 59, 1, 10581, 108, 111, 111, 114, 59, 1, 8971, 4, 2, 101, 114, 4918, 4944, 101, 4, 3, 59, 65, 86, 4927, 4929, 4936, 1, 8866, 114, 114, 111, 119, 59, 1, 8614, 101, 99, 116, 111, 114, 59, 1, 10587, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 4958, 4960, 4965, 1, 8883, 97, 114, 59, 1, 10704, 113, 117, 97, 108, 59, 1, 8885, 112, 4, 3, 68, 84, 86, 4981, 4993, 5004, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10588, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5015, 5017, 1, 8638, 97, 114, 59, 1, 10580, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5033, 5035, 1, 8640, 97, 114, 59, 1, 10579, 114, 114, 111, 119, 59, 1, 8658, 4, 2, 112, 117, 5053, 5057, 102, 59, 1, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 1, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8667, 4, 2, 99, 104, 5087, 5091, 114, 59, 1, 8475, 59, 1, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 1, 10740, 4, 13, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 5134, 5150, 5157, 5164, 5198, 5203, 5259, 5265, 5277, 5283, 5374, 5380, 5385, 4, 2, 67, 99, 5140, 5146, 72, 99, 121, 59, 1, 1065, 121, 59, 1, 1064, 70, 84, 99, 121, 59, 1, 1068, 99, 117, 116, 101, 59, 1, 346, 4, 5, 59, 97, 101, 105, 121, 5176, 5178, 5184, 5190, 5195, 1, 10940, 114, 111, 110, 59, 1, 352, 100, 105, 108, 59, 1, 350, 114, 99, 59, 1, 348, 59, 1, 1057, 114, 59, 3, 55349, 56598, 111, 114, 116, 4, 4, 68, 76, 82, 85, 5216, 5227, 5238, 5250, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8594, 112, 65, 114, 114, 111, 119, 59, 1, 8593, 103, 109, 97, 59, 1, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 1, 8728, 112, 102, 59, 3, 55349, 56650, 4, 2, 114, 117, 5289, 5293, 116, 59, 1, 8730, 97, 114, 101, 4, 4, 59, 73, 83, 85, 5306, 5308, 5322, 5367, 1, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8851, 117, 4, 2, 98, 112, 5329, 5347, 115, 101, 116, 4, 2, 59, 69, 5338, 5340, 1, 8847, 113, 117, 97, 108, 59, 1, 8849, 101, 114, 115, 101, 116, 4, 2, 59, 69, 5358, 5360, 1, 8848, 113, 117, 97, 108, 59, 1, 8850, 110, 105, 111, 110, 59, 1, 8852, 99, 114, 59, 3, 55349, 56494, 97, 114, 59, 1, 8902, 4, 4, 98, 99, 109, 112, 5395, 5420, 5475, 5478, 4, 2, 59, 115, 5401, 5403, 1, 8912, 101, 116, 4, 2, 59, 69, 5411, 5413, 1, 8912, 113, 117, 97, 108, 59, 1, 8838, 4, 2, 99, 104, 5426, 5468, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 5440, 5442, 5449, 5461, 1, 8827, 113, 117, 97, 108, 59, 1, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8829, 105, 108, 100, 101, 59, 1, 8831, 84, 104, 97, 116, 59, 1, 8715, 59, 1, 8721, 4, 3, 59, 101, 115, 5486, 5488, 5507, 1, 8913, 114, 115, 101, 116, 4, 2, 59, 69, 5498, 5500, 1, 8835, 113, 117, 97, 108, 59, 1, 8839, 101, 116, 59, 1, 8913, 4, 11, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5536, 5546, 5552, 5567, 5579, 5602, 5607, 5655, 5695, 5701, 5711, 79, 82, 78, 5, 222, 1, 59, 5544, 1, 222, 65, 68, 69, 59, 1, 8482, 4, 2, 72, 99, 5558, 5563, 99, 121, 59, 1, 1035, 121, 59, 1, 1062, 4, 2, 98, 117, 5573, 5576, 59, 1, 9, 59, 1, 932, 4, 3, 97, 101, 121, 5587, 5593, 5599, 114, 111, 110, 59, 1, 356, 100, 105, 108, 59, 1, 354, 59, 1, 1058, 114, 59, 3, 55349, 56599, 4, 2, 101, 105, 5613, 5631, 4, 2, 114, 116, 5619, 5627, 101, 102, 111, 114, 101, 59, 1, 8756, 97, 59, 1, 920, 4, 2, 99, 110, 5637, 5647, 107, 83, 112, 97, 99, 101, 59, 3, 8287, 8202, 83, 112, 97, 99, 101, 59, 1, 8201, 108, 100, 101, 4, 4, 59, 69, 70, 84, 5668, 5670, 5677, 5688, 1, 8764, 113, 117, 97, 108, 59, 1, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8773, 105, 108, 100, 101, 59, 1, 8776, 112, 102, 59, 3, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 1, 8411, 4, 2, 99, 116, 5717, 5722, 114, 59, 3, 55349, 56495, 114, 111, 107, 59, 1, 358, 4, 14, 97, 98, 99, 100, 102, 103, 109, 110, 111, 112, 114, 115, 116, 117, 5758, 5789, 5805, 5823, 5830, 5835, 5846, 5852, 5921, 5937, 6089, 6095, 6101, 6108, 4, 2, 99, 114, 5764, 5774, 117, 116, 101, 5, 218, 1, 59, 5772, 1, 218, 114, 4, 2, 59, 111, 5781, 5783, 1, 8607, 99, 105, 114, 59, 1, 10569, 114, 4, 2, 99, 101, 5796, 5800, 121, 59, 1, 1038, 118, 101, 59, 1, 364, 4, 2, 105, 121, 5811, 5820, 114, 99, 5, 219, 1, 59, 5818, 1, 219, 59, 1, 1059, 98, 108, 97, 99, 59, 1, 368, 114, 59, 3, 55349, 56600, 114, 97, 118, 101, 5, 217, 1, 59, 5844, 1, 217, 97, 99, 114, 59, 1, 362, 4, 2, 100, 105, 5858, 5905, 101, 114, 4, 2, 66, 80, 5866, 5892, 4, 2, 97, 114, 5872, 5876, 114, 59, 1, 95, 97, 99, 4, 2, 101, 107, 5884, 5887, 59, 1, 9183, 101, 116, 59, 1, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9181, 111, 110, 4, 2, 59, 80, 5913, 5915, 1, 8899, 108, 117, 115, 59, 1, 8846, 4, 2, 103, 112, 5927, 5932, 111, 110, 59, 1, 370, 102, 59, 3, 55349, 56652, 4, 8, 65, 68, 69, 84, 97, 100, 112, 115, 5955, 5985, 5996, 6009, 6026, 6033, 6044, 6075, 114, 114, 111, 119, 4, 3, 59, 66, 68, 5967, 5969, 5974, 1, 8593, 97, 114, 59, 1, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10606, 101, 101, 4, 2, 59, 65, 6017, 6019, 1, 8869, 114, 114, 111, 119, 59, 1, 8613, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 4, 2, 76, 82, 6052, 6063, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8599, 105, 4, 2, 59, 108, 6082, 6084, 1, 978, 111, 110, 59, 1, 933, 105, 110, 103, 59, 1, 366, 99, 114, 59, 3, 55349, 56496, 105, 108, 100, 101, 59, 1, 360, 109, 108, 5, 220, 1, 59, 6115, 1, 220, 4, 9, 68, 98, 99, 100, 101, 102, 111, 115, 118, 6137, 6143, 6148, 6152, 6166, 6250, 6255, 6261, 6267, 97, 115, 104, 59, 1, 8875, 97, 114, 59, 1, 10987, 121, 59, 1, 1042, 97, 115, 104, 4, 2, 59, 108, 6161, 6163, 1, 8873, 59, 1, 10982, 4, 2, 101, 114, 6172, 6175, 59, 1, 8897, 4, 3, 98, 116, 121, 6183, 6188, 6238, 97, 114, 59, 1, 8214, 4, 2, 59, 105, 6194, 6196, 1, 8214, 99, 97, 108, 4, 4, 66, 76, 83, 84, 6209, 6214, 6220, 6231, 97, 114, 59, 1, 8739, 105, 110, 101, 59, 1, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 1, 10072, 105, 108, 100, 101, 59, 1, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8202, 114, 59, 3, 55349, 56601, 112, 102, 59, 3, 55349, 56653, 99, 114, 59, 3, 55349, 56497, 100, 97, 115, 104, 59, 1, 8874, 4, 5, 99, 101, 102, 111, 115, 6286, 6292, 6298, 6303, 6309, 105, 114, 99, 59, 1, 372, 100, 103, 101, 59, 1, 8896, 114, 59, 3, 55349, 56602, 112, 102, 59, 3, 55349, 56654, 99, 114, 59, 3, 55349, 56498, 4, 4, 102, 105, 111, 115, 6325, 6330, 6333, 6339, 114, 59, 3, 55349, 56603, 59, 1, 926, 112, 102, 59, 3, 55349, 56655, 99, 114, 59, 3, 55349, 56499, 4, 9, 65, 73, 85, 97, 99, 102, 111, 115, 117, 6365, 6370, 6375, 6380, 6391, 6405, 6410, 6416, 6422, 99, 121, 59, 1, 1071, 99, 121, 59, 1, 1031, 99, 121, 59, 1, 1070, 99, 117, 116, 101, 5, 221, 1, 59, 6389, 1, 221, 4, 2, 105, 121, 6397, 6402, 114, 99, 59, 1, 374, 59, 1, 1067, 114, 59, 3, 55349, 56604, 112, 102, 59, 3, 55349, 56656, 99, 114, 59, 3, 55349, 56500, 109, 108, 59, 1, 376, 4, 8, 72, 97, 99, 100, 101, 102, 111, 115, 6445, 6450, 6457, 6472, 6477, 6501, 6505, 6510, 99, 121, 59, 1, 1046, 99, 117, 116, 101, 59, 1, 377, 4, 2, 97, 121, 6463, 6469, 114, 111, 110, 59, 1, 381, 59, 1, 1047, 111, 116, 59, 1, 379, 4, 2, 114, 116, 6483, 6497, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 1, 8203, 97, 59, 1, 918, 114, 59, 1, 8488, 112, 102, 59, 1, 8484, 99, 114, 59, 3, 55349, 56501, 4, 16, 97, 98, 99, 101, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 119, 6550, 6561, 6568, 6612, 6622, 6634, 6645, 6672, 6699, 6854, 6870, 6923, 6933, 6963, 6974, 6983, 99, 117, 116, 101, 5, 225, 1, 59, 6559, 1, 225, 114, 101, 118, 101, 59, 1, 259, 4, 6, 59, 69, 100, 105, 117, 121, 6582, 6584, 6588, 6591, 6600, 6609, 1, 8766, 59, 3, 8766, 819, 59, 1, 8767, 114, 99, 5, 226, 1, 59, 6598, 1, 226, 116, 101, 5, 180, 1, 59, 6607, 1, 180, 59, 1, 1072, 108, 105, 103, 5, 230, 1, 59, 6620, 1, 230, 4, 2, 59, 114, 6628, 6630, 1, 8289, 59, 3, 55349, 56606, 114, 97, 118, 101, 5, 224, 1, 59, 6643, 1, 224, 4, 2, 101, 112, 6651, 6667, 4, 2, 102, 112, 6657, 6663, 115, 121, 109, 59, 1, 8501, 104, 59, 1, 8501, 104, 97, 59, 1, 945, 4, 2, 97, 112, 6678, 6692, 4, 2, 99, 108, 6684, 6688, 114, 59, 1, 257, 103, 59, 1, 10815, 5, 38, 1, 59, 6697, 1, 38, 4, 2, 100, 103, 6705, 6737, 4, 5, 59, 97, 100, 115, 118, 6717, 6719, 6724, 6727, 6734, 1, 8743, 110, 100, 59, 1, 10837, 59, 1, 10844, 108, 111, 112, 101, 59, 1, 10840, 59, 1, 10842, 4, 7, 59, 101, 108, 109, 114, 115, 122, 6753, 6755, 6758, 6762, 6814, 6835, 6848, 1, 8736, 59, 1, 10660, 101, 59, 1, 8736, 115, 100, 4, 2, 59, 97, 6770, 6772, 1, 8737, 4, 8, 97, 98, 99, 100, 101, 102, 103, 104, 6790, 6793, 6796, 6799, 6802, 6805, 6808, 6811, 59, 1, 10664, 59, 1, 10665, 59, 1, 10666, 59, 1, 10667, 59, 1, 10668, 59, 1, 10669, 59, 1, 10670, 59, 1, 10671, 116, 4, 2, 59, 118, 6821, 6823, 1, 8735, 98, 4, 2, 59, 100, 6830, 6832, 1, 8894, 59, 1, 10653, 4, 2, 112, 116, 6841, 6845, 104, 59, 1, 8738, 59, 1, 197, 97, 114, 114, 59, 1, 9084, 4, 2, 103, 112, 6860, 6865, 111, 110, 59, 1, 261, 102, 59, 3, 55349, 56658, 4, 7, 59, 69, 97, 101, 105, 111, 112, 6886, 6888, 6891, 6897, 6900, 6904, 6908, 1, 8776, 59, 1, 10864, 99, 105, 114, 59, 1, 10863, 59, 1, 8778, 100, 59, 1, 8779, 115, 59, 1, 39, 114, 111, 120, 4, 2, 59, 101, 6917, 6919, 1, 8776, 113, 59, 1, 8778, 105, 110, 103, 5, 229, 1, 59, 6931, 1, 229, 4, 3, 99, 116, 121, 6941, 6946, 6949, 114, 59, 3, 55349, 56502, 59, 1, 42, 109, 112, 4, 2, 59, 101, 6957, 6959, 1, 8776, 113, 59, 1, 8781, 105, 108, 100, 101, 5, 227, 1, 59, 6972, 1, 227, 109, 108, 5, 228, 1, 59, 6981, 1, 228, 4, 2, 99, 105, 6989, 6997, 111, 110, 105, 110, 116, 59, 1, 8755, 110, 116, 59, 1, 10769, 4, 16, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 7036, 7041, 7119, 7135, 7149, 7155, 7219, 7224, 7347, 7354, 7463, 7489, 7786, 7793, 7814, 7866, 111, 116, 59, 1, 10989, 4, 2, 99, 114, 7047, 7094, 107, 4, 4, 99, 101, 112, 115, 7058, 7064, 7073, 7080, 111, 110, 103, 59, 1, 8780, 112, 115, 105, 108, 111, 110, 59, 1, 1014, 114, 105, 109, 101, 59, 1, 8245, 105, 109, 4, 2, 59, 101, 7088, 7090, 1, 8765, 113, 59, 1, 8909, 4, 2, 118, 119, 7100, 7105, 101, 101, 59, 1, 8893, 101, 100, 4, 2, 59, 103, 7113, 7115, 1, 8965, 101, 59, 1, 8965, 114, 107, 4, 2, 59, 116, 7127, 7129, 1, 9141, 98, 114, 107, 59, 1, 9142, 4, 2, 111, 121, 7141, 7146, 110, 103, 59, 1, 8780, 59, 1, 1073, 113, 117, 111, 59, 1, 8222, 4, 5, 99, 109, 112, 114, 116, 7167, 7181, 7188, 7193, 7199, 97, 117, 115, 4, 2, 59, 101, 7176, 7178, 1, 8757, 59, 1, 8757, 112, 116, 121, 118, 59, 1, 10672, 115, 105, 59, 1, 1014, 110, 111, 117, 59, 1, 8492, 4, 3, 97, 104, 119, 7207, 7210, 7213, 59, 1, 946, 59, 1, 8502, 101, 101, 110, 59, 1, 8812, 114, 59, 3, 55349, 56607, 103, 4, 7, 99, 111, 115, 116, 117, 118, 119, 7241, 7262, 7288, 7305, 7328, 7335, 7340, 4, 3, 97, 105, 117, 7249, 7253, 7258, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 4, 3, 100, 112, 116, 7270, 7275, 7281, 111, 116, 59, 1, 10752, 108, 117, 115, 59, 1, 10753, 105, 109, 101, 115, 59, 1, 10754, 4, 2, 113, 116, 7294, 7300, 99, 117, 112, 59, 1, 10758, 97, 114, 59, 1, 9733, 114, 105, 97, 110, 103, 108, 101, 4, 2, 100, 117, 7318, 7324, 111, 119, 110, 59, 1, 9661, 112, 59, 1, 9651, 112, 108, 117, 115, 59, 1, 10756, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 97, 114, 111, 119, 59, 1, 10509, 4, 3, 97, 107, 111, 7362, 7436, 7458, 4, 2, 99, 110, 7368, 7432, 107, 4, 3, 108, 115, 116, 7377, 7386, 7394, 111, 122, 101, 110, 103, 101, 59, 1, 10731, 113, 117, 97, 114, 101, 59, 1, 9642, 114, 105, 97, 110, 103, 108, 101, 4, 4, 59, 100, 108, 114, 7411, 7413, 7419, 7425, 1, 9652, 111, 119, 110, 59, 1, 9662, 101, 102, 116, 59, 1, 9666, 105, 103, 104, 116, 59, 1, 9656, 107, 59, 1, 9251, 4, 2, 49, 51, 7442, 7454, 4, 2, 50, 52, 7448, 7451, 59, 1, 9618, 59, 1, 9617, 52, 59, 1, 9619, 99, 107, 59, 1, 9608, 4, 2, 101, 111, 7469, 7485, 4, 2, 59, 113, 7475, 7478, 3, 61, 8421, 117, 105, 118, 59, 3, 8801, 8421, 116, 59, 1, 8976, 4, 4, 112, 116, 119, 120, 7499, 7504, 7517, 7523, 102, 59, 3, 55349, 56659, 4, 2, 59, 116, 7510, 7512, 1, 8869, 111, 109, 59, 1, 8869, 116, 105, 101, 59, 1, 8904, 4, 12, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7549, 7571, 7597, 7619, 7655, 7660, 7682, 7708, 7715, 7721, 7728, 7750, 4, 4, 76, 82, 108, 114, 7559, 7562, 7565, 7568, 59, 1, 9559, 59, 1, 9556, 59, 1, 9558, 59, 1, 9555, 4, 5, 59, 68, 85, 100, 117, 7583, 7585, 7588, 7591, 7594, 1, 9552, 59, 1, 9574, 59, 1, 9577, 59, 1, 9572, 59, 1, 9575, 4, 4, 76, 82, 108, 114, 7607, 7610, 7613, 7616, 59, 1, 9565, 59, 1, 9562, 59, 1, 9564, 59, 1, 9561, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7635, 7637, 7640, 7643, 7646, 7649, 7652, 1, 9553, 59, 1, 9580, 59, 1, 9571, 59, 1, 9568, 59, 1, 9579, 59, 1, 9570, 59, 1, 9567, 111, 120, 59, 1, 10697, 4, 4, 76, 82, 108, 114, 7670, 7673, 7676, 7679, 59, 1, 9557, 59, 1, 9554, 59, 1, 9488, 59, 1, 9484, 4, 5, 59, 68, 85, 100, 117, 7694, 7696, 7699, 7702, 7705, 1, 9472, 59, 1, 9573, 59, 1, 9576, 59, 1, 9516, 59, 1, 9524, 105, 110, 117, 115, 59, 1, 8863, 108, 117, 115, 59, 1, 8862, 105, 109, 101, 115, 59, 1, 8864, 4, 4, 76, 82, 108, 114, 7738, 7741, 7744, 7747, 59, 1, 9563, 59, 1, 9560, 59, 1, 9496, 59, 1, 9492, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7766, 7768, 7771, 7774, 7777, 7780, 7783, 1, 9474, 59, 1, 9578, 59, 1, 9569, 59, 1, 9566, 59, 1, 9532, 59, 1, 9508, 59, 1, 9500, 114, 105, 109, 101, 59, 1, 8245, 4, 2, 101, 118, 7799, 7804, 118, 101, 59, 1, 728, 98, 97, 114, 5, 166, 1, 59, 7812, 1, 166, 4, 4, 99, 101, 105, 111, 7824, 7829, 7834, 7846, 114, 59, 3, 55349, 56503, 109, 105, 59, 1, 8271, 109, 4, 2, 59, 101, 7841, 7843, 1, 8765, 59, 1, 8909, 108, 4, 3, 59, 98, 104, 7855, 7857, 7860, 1, 92, 59, 1, 10693, 115, 117, 98, 59, 1, 10184, 4, 2, 108, 109, 7872, 7885, 108, 4, 2, 59, 101, 7879, 7881, 1, 8226, 116, 59, 1, 8226, 112, 4, 3, 59, 69, 101, 7894, 7896, 7899, 1, 8782, 59, 1, 10926, 4, 2, 59, 113, 7905, 7907, 1, 8783, 59, 1, 8783, 4, 15, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 116, 117, 119, 121, 7942, 8021, 8075, 8080, 8121, 8126, 8157, 8279, 8295, 8430, 8446, 8485, 8491, 8707, 8726, 4, 3, 99, 112, 114, 7950, 7956, 8007, 117, 116, 101, 59, 1, 263, 4, 6, 59, 97, 98, 99, 100, 115, 7970, 7972, 7977, 7984, 7998, 8003, 1, 8745, 110, 100, 59, 1, 10820, 114, 99, 117, 112, 59, 1, 10825, 4, 2, 97, 117, 7990, 7994, 112, 59, 1, 10827, 112, 59, 1, 10823, 111, 116, 59, 1, 10816, 59, 3, 8745, 65024, 4, 2, 101, 111, 8013, 8017, 116, 59, 1, 8257, 110, 59, 1, 711, 4, 4, 97, 101, 105, 117, 8031, 8046, 8056, 8061, 4, 2, 112, 114, 8037, 8041, 115, 59, 1, 10829, 111, 110, 59, 1, 269, 100, 105, 108, 5, 231, 1, 59, 8054, 1, 231, 114, 99, 59, 1, 265, 112, 115, 4, 2, 59, 115, 8069, 8071, 1, 10828, 109, 59, 1, 10832, 111, 116, 59, 1, 267, 4, 3, 100, 109, 110, 8088, 8097, 8104, 105, 108, 5, 184, 1, 59, 8095, 1, 184, 112, 116, 121, 118, 59, 1, 10674, 116, 5, 162, 2, 59, 101, 8112, 8114, 1, 162, 114, 100, 111, 116, 59, 1, 183, 114, 59, 3, 55349, 56608, 4, 3, 99, 101, 105, 8134, 8138, 8154, 121, 59, 1, 1095, 99, 107, 4, 2, 59, 109, 8146, 8148, 1, 10003, 97, 114, 107, 59, 1, 10003, 59, 1, 967, 114, 4, 7, 59, 69, 99, 101, 102, 109, 115, 8174, 8176, 8179, 8258, 8261, 8268, 8273, 1, 9675, 59, 1, 10691, 4, 3, 59, 101, 108, 8187, 8189, 8193, 1, 710, 113, 59, 1, 8791, 101, 4, 2, 97, 100, 8200, 8223, 114, 114, 111, 119, 4, 2, 108, 114, 8210, 8216, 101, 102, 116, 59, 1, 8634, 105, 103, 104, 116, 59, 1, 8635, 4, 5, 82, 83, 97, 99, 100, 8235, 8238, 8241, 8246, 8252, 59, 1, 174, 59, 1, 9416, 115, 116, 59, 1, 8859, 105, 114, 99, 59, 1, 8858, 97, 115, 104, 59, 1, 8861, 59, 1, 8791, 110, 105, 110, 116, 59, 1, 10768, 105, 100, 59, 1, 10991, 99, 105, 114, 59, 1, 10690, 117, 98, 115, 4, 2, 59, 117, 8288, 8290, 1, 9827, 105, 116, 59, 1, 9827, 4, 4, 108, 109, 110, 112, 8305, 8326, 8376, 8400, 111, 110, 4, 2, 59, 101, 8313, 8315, 1, 58, 4, 2, 59, 113, 8321, 8323, 1, 8788, 59, 1, 8788, 4, 2, 109, 112, 8332, 8344, 97, 4, 2, 59, 116, 8339, 8341, 1, 44, 59, 1, 64, 4, 3, 59, 102, 108, 8352, 8354, 8358, 1, 8705, 110, 59, 1, 8728, 101, 4, 2, 109, 120, 8365, 8371, 101, 110, 116, 59, 1, 8705, 101, 115, 59, 1, 8450, 4, 2, 103, 105, 8382, 8395, 4, 2, 59, 100, 8388, 8390, 1, 8773, 111, 116, 59, 1, 10861, 110, 116, 59, 1, 8750, 4, 3, 102, 114, 121, 8408, 8412, 8417, 59, 3, 55349, 56660, 111, 100, 59, 1, 8720, 5, 169, 2, 59, 115, 8424, 8426, 1, 169, 114, 59, 1, 8471, 4, 2, 97, 111, 8436, 8441, 114, 114, 59, 1, 8629, 115, 115, 59, 1, 10007, 4, 2, 99, 117, 8452, 8457, 114, 59, 3, 55349, 56504, 4, 2, 98, 112, 8463, 8474, 4, 2, 59, 101, 8469, 8471, 1, 10959, 59, 1, 10961, 4, 2, 59, 101, 8480, 8482, 1, 10960, 59, 1, 10962, 100, 111, 116, 59, 1, 8943, 4, 7, 100, 101, 108, 112, 114, 118, 119, 8507, 8522, 8536, 8550, 8600, 8697, 8702, 97, 114, 114, 4, 2, 108, 114, 8516, 8519, 59, 1, 10552, 59, 1, 10549, 4, 2, 112, 115, 8528, 8532, 114, 59, 1, 8926, 99, 59, 1, 8927, 97, 114, 114, 4, 2, 59, 112, 8545, 8547, 1, 8630, 59, 1, 10557, 4, 6, 59, 98, 99, 100, 111, 115, 8564, 8566, 8573, 8587, 8592, 8596, 1, 8746, 114, 99, 97, 112, 59, 1, 10824, 4, 2, 97, 117, 8579, 8583, 112, 59, 1, 10822, 112, 59, 1, 10826, 111, 116, 59, 1, 8845, 114, 59, 1, 10821, 59, 3, 8746, 65024, 4, 4, 97, 108, 114, 118, 8610, 8623, 8663, 8672, 114, 114, 4, 2, 59, 109, 8618, 8620, 1, 8631, 59, 1, 10556, 121, 4, 3, 101, 118, 119, 8632, 8651, 8656, 113, 4, 2, 112, 115, 8639, 8645, 114, 101, 99, 59, 1, 8926, 117, 99, 99, 59, 1, 8927, 101, 101, 59, 1, 8910, 101, 100, 103, 101, 59, 1, 8911, 101, 110, 5, 164, 1, 59, 8670, 1, 164, 101, 97, 114, 114, 111, 119, 4, 2, 108, 114, 8684, 8690, 101, 102, 116, 59, 1, 8630, 105, 103, 104, 116, 59, 1, 8631, 101, 101, 59, 1, 8910, 101, 100, 59, 1, 8911, 4, 2, 99, 105, 8713, 8721, 111, 110, 105, 110, 116, 59, 1, 8754, 110, 116, 59, 1, 8753, 108, 99, 116, 121, 59, 1, 9005, 4, 19, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8773, 8778, 8783, 8821, 8839, 8854, 8887, 8914, 8930, 8944, 9036, 9041, 9058, 9197, 9227, 9258, 9281, 9297, 9305, 114, 114, 59, 1, 8659, 97, 114, 59, 1, 10597, 4, 4, 103, 108, 114, 115, 8793, 8799, 8805, 8809, 103, 101, 114, 59, 1, 8224, 101, 116, 104, 59, 1, 8504, 114, 59, 1, 8595, 104, 4, 2, 59, 118, 8816, 8818, 1, 8208, 59, 1, 8867, 4, 2, 107, 108, 8827, 8834, 97, 114, 111, 119, 59, 1, 10511, 97, 99, 59, 1, 733, 4, 2, 97, 121, 8845, 8851, 114, 111, 110, 59, 1, 271, 59, 1, 1076, 4, 3, 59, 97, 111, 8862, 8864, 8880, 1, 8518, 4, 2, 103, 114, 8870, 8876, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8650, 116, 115, 101, 113, 59, 1, 10871, 4, 3, 103, 108, 109, 8895, 8902, 8907, 5, 176, 1, 59, 8900, 1, 176, 116, 97, 59, 1, 948, 112, 116, 121, 118, 59, 1, 10673, 4, 2, 105, 114, 8920, 8926, 115, 104, 116, 59, 1, 10623, 59, 3, 55349, 56609, 97, 114, 4, 2, 108, 114, 8938, 8941, 59, 1, 8643, 59, 1, 8642, 4, 5, 97, 101, 103, 115, 118, 8956, 8986, 8989, 8996, 9001, 109, 4, 3, 59, 111, 115, 8965, 8967, 8983, 1, 8900, 110, 100, 4, 2, 59, 115, 8975, 8977, 1, 8900, 117, 105, 116, 59, 1, 9830, 59, 1, 9830, 59, 1, 168, 97, 109, 109, 97, 59, 1, 989, 105, 110, 59, 1, 8946, 4, 3, 59, 105, 111, 9009, 9011, 9031, 1, 247, 100, 101, 5, 247, 2, 59, 111, 9020, 9022, 1, 247, 110, 116, 105, 109, 101, 115, 59, 1, 8903, 110, 120, 59, 1, 8903, 99, 121, 59, 1, 1106, 99, 4, 2, 111, 114, 9048, 9053, 114, 110, 59, 1, 8990, 111, 112, 59, 1, 8973, 4, 5, 108, 112, 116, 117, 119, 9070, 9076, 9081, 9130, 9144, 108, 97, 114, 59, 1, 36, 102, 59, 3, 55349, 56661, 4, 5, 59, 101, 109, 112, 115, 9093, 9095, 9109, 9116, 9122, 1, 729, 113, 4, 2, 59, 100, 9102, 9104, 1, 8784, 111, 116, 59, 1, 8785, 105, 110, 117, 115, 59, 1, 8760, 108, 117, 115, 59, 1, 8724, 113, 117, 97, 114, 101, 59, 1, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 1, 8966, 110, 4, 3, 97, 100, 104, 9153, 9160, 9172, 114, 114, 111, 119, 59, 1, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 1, 8650, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 9184, 9190, 101, 102, 116, 59, 1, 8643, 105, 103, 104, 116, 59, 1, 8642, 4, 2, 98, 99, 9203, 9211, 107, 97, 114, 111, 119, 59, 1, 10512, 4, 2, 111, 114, 9217, 9222, 114, 110, 59, 1, 8991, 111, 112, 59, 1, 8972, 4, 3, 99, 111, 116, 9235, 9248, 9252, 4, 2, 114, 121, 9241, 9245, 59, 3, 55349, 56505, 59, 1, 1109, 108, 59, 1, 10742, 114, 111, 107, 59, 1, 273, 4, 2, 100, 114, 9264, 9269, 111, 116, 59, 1, 8945, 105, 4, 2, 59, 102, 9276, 9278, 1, 9663, 59, 1, 9662, 4, 2, 97, 104, 9287, 9292, 114, 114, 59, 1, 8693, 97, 114, 59, 1, 10607, 97, 110, 103, 108, 101, 59, 1, 10662, 4, 2, 99, 105, 9311, 9315, 121, 59, 1, 1119, 103, 114, 97, 114, 114, 59, 1, 10239, 4, 18, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 9361, 9376, 9398, 9439, 9444, 9447, 9462, 9495, 9531, 9585, 9598, 9614, 9659, 9755, 9771, 9792, 9808, 9826, 4, 2, 68, 111, 9367, 9372, 111, 116, 59, 1, 10871, 116, 59, 1, 8785, 4, 2, 99, 115, 9382, 9392, 117, 116, 101, 5, 233, 1, 59, 9390, 1, 233, 116, 101, 114, 59, 1, 10862, 4, 4, 97, 105, 111, 121, 9408, 9414, 9430, 9436, 114, 111, 110, 59, 1, 283, 114, 4, 2, 59, 99, 9421, 9423, 1, 8790, 5, 234, 1, 59, 9428, 1, 234, 108, 111, 110, 59, 1, 8789, 59, 1, 1101, 111, 116, 59, 1, 279, 59, 1, 8519, 4, 2, 68, 114, 9453, 9458, 111, 116, 59, 1, 8786, 59, 3, 55349, 56610, 4, 3, 59, 114, 115, 9470, 9472, 9482, 1, 10906, 97, 118, 101, 5, 232, 1, 59, 9480, 1, 232, 4, 2, 59, 100, 9488, 9490, 1, 10902, 111, 116, 59, 1, 10904, 4, 4, 59, 105, 108, 115, 9505, 9507, 9515, 9518, 1, 10905, 110, 116, 101, 114, 115, 59, 1, 9191, 59, 1, 8467, 4, 2, 59, 100, 9524, 9526, 1, 10901, 111, 116, 59, 1, 10903, 4, 3, 97, 112, 115, 9539, 9544, 9564, 99, 114, 59, 1, 275, 116, 121, 4, 3, 59, 115, 118, 9554, 9556, 9561, 1, 8709, 101, 116, 59, 1, 8709, 59, 1, 8709, 112, 4, 2, 49, 59, 9571, 9583, 4, 2, 51, 52, 9577, 9580, 59, 1, 8196, 59, 1, 8197, 1, 8195, 4, 2, 103, 115, 9591, 9594, 59, 1, 331, 112, 59, 1, 8194, 4, 2, 103, 112, 9604, 9609, 111, 110, 59, 1, 281, 102, 59, 3, 55349, 56662, 4, 3, 97, 108, 115, 9622, 9635, 9640, 114, 4, 2, 59, 115, 9629, 9631, 1, 8917, 108, 59, 1, 10723, 117, 115, 59, 1, 10865, 105, 4, 3, 59, 108, 118, 9649, 9651, 9656, 1, 949, 111, 110, 59, 1, 949, 59, 1, 1013, 4, 4, 99, 115, 117, 118, 9669, 9686, 9716, 9747, 4, 2, 105, 111, 9675, 9680, 114, 99, 59, 1, 8790, 108, 111, 110, 59, 1, 8789, 4, 2, 105, 108, 9692, 9696, 109, 59, 1, 8770, 97, 110, 116, 4, 2, 103, 108, 9705, 9710, 116, 114, 59, 1, 10902, 101, 115, 115, 59, 1, 10901, 4, 3, 97, 101, 105, 9724, 9729, 9734, 108, 115, 59, 1, 61, 115, 116, 59, 1, 8799, 118, 4, 2, 59, 68, 9741, 9743, 1, 8801, 68, 59, 1, 10872, 112, 97, 114, 115, 108, 59, 1, 10725, 4, 2, 68, 97, 9761, 9766, 111, 116, 59, 1, 8787, 114, 114, 59, 1, 10609, 4, 3, 99, 100, 105, 9779, 9783, 9788, 114, 59, 1, 8495, 111, 116, 59, 1, 8784, 109, 59, 1, 8770, 4, 2, 97, 104, 9798, 9801, 59, 1, 951, 5, 240, 1, 59, 9806, 1, 240, 4, 2, 109, 114, 9814, 9822, 108, 5, 235, 1, 59, 9820, 1, 235, 111, 59, 1, 8364, 4, 3, 99, 105, 112, 9834, 9838, 9843, 108, 59, 1, 33, 115, 116, 59, 1, 8707, 4, 2, 101, 111, 9849, 9859, 99, 116, 97, 116, 105, 111, 110, 59, 1, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 1, 8519, 4, 12, 97, 99, 101, 102, 105, 106, 108, 110, 111, 112, 114, 115, 9896, 9910, 9914, 9921, 9954, 9960, 9967, 9989, 9994, 10027, 10036, 10164, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8786, 121, 59, 1, 1092, 109, 97, 108, 101, 59, 1, 9792, 4, 3, 105, 108, 114, 9929, 9935, 9950, 108, 105, 103, 59, 1, 64259, 4, 2, 105, 108, 9941, 9945, 103, 59, 1, 64256, 105, 103, 59, 1, 64260, 59, 3, 55349, 56611, 108, 105, 103, 59, 1, 64257, 108, 105, 103, 59, 3, 102, 106, 4, 3, 97, 108, 116, 9975, 9979, 9984, 116, 59, 1, 9837, 105, 103, 59, 1, 64258, 110, 115, 59, 1, 9649, 111, 102, 59, 1, 402, 4, 2, 112, 114, 1e4, 10005, 102, 59, 3, 55349, 56663, 4, 2, 97, 107, 10011, 10016, 108, 108, 59, 1, 8704, 4, 2, 59, 118, 10022, 10024, 1, 8916, 59, 1, 10969, 97, 114, 116, 105, 110, 116, 59, 1, 10765, 4, 2, 97, 111, 10042, 10159, 4, 2, 99, 115, 10048, 10155, 4, 6, 49, 50, 51, 52, 53, 55, 10062, 10102, 10114, 10135, 10139, 10151, 4, 6, 50, 51, 52, 53, 54, 56, 10076, 10083, 10086, 10093, 10096, 10099, 5, 189, 1, 59, 10081, 1, 189, 59, 1, 8531, 5, 188, 1, 59, 10091, 1, 188, 59, 1, 8533, 59, 1, 8537, 59, 1, 8539, 4, 2, 51, 53, 10108, 10111, 59, 1, 8532, 59, 1, 8534, 4, 3, 52, 53, 56, 10122, 10129, 10132, 5, 190, 1, 59, 10127, 1, 190, 59, 1, 8535, 59, 1, 8540, 53, 59, 1, 8536, 4, 2, 54, 56, 10145, 10148, 59, 1, 8538, 59, 1, 8541, 56, 59, 1, 8542, 108, 59, 1, 8260, 119, 110, 59, 1, 8994, 99, 114, 59, 3, 55349, 56507, 4, 17, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 10206, 10217, 10247, 10254, 10268, 10273, 10358, 10363, 10374, 10380, 10385, 10406, 10458, 10464, 10470, 10497, 10610, 4, 2, 59, 108, 10212, 10214, 1, 8807, 59, 1, 10892, 4, 3, 99, 109, 112, 10225, 10231, 10244, 117, 116, 101, 59, 1, 501, 109, 97, 4, 2, 59, 100, 10239, 10241, 1, 947, 59, 1, 989, 59, 1, 10886, 114, 101, 118, 101, 59, 1, 287, 4, 2, 105, 121, 10260, 10265, 114, 99, 59, 1, 285, 59, 1, 1075, 111, 116, 59, 1, 289, 4, 4, 59, 108, 113, 115, 10283, 10285, 10288, 10308, 1, 8805, 59, 1, 8923, 4, 3, 59, 113, 115, 10296, 10298, 10301, 1, 8805, 59, 1, 8807, 108, 97, 110, 116, 59, 1, 10878, 4, 4, 59, 99, 100, 108, 10318, 10320, 10324, 10345, 1, 10878, 99, 59, 1, 10921, 111, 116, 4, 2, 59, 111, 10332, 10334, 1, 10880, 4, 2, 59, 108, 10340, 10342, 1, 10882, 59, 1, 10884, 4, 2, 59, 101, 10351, 10354, 3, 8923, 65024, 115, 59, 1, 10900, 114, 59, 3, 55349, 56612, 4, 2, 59, 103, 10369, 10371, 1, 8811, 59, 1, 8921, 109, 101, 108, 59, 1, 8503, 99, 121, 59, 1, 1107, 4, 4, 59, 69, 97, 106, 10395, 10397, 10400, 10403, 1, 8823, 59, 1, 10898, 59, 1, 10917, 59, 1, 10916, 4, 4, 69, 97, 101, 115, 10416, 10419, 10434, 10453, 59, 1, 8809, 112, 4, 2, 59, 112, 10426, 10428, 1, 10890, 114, 111, 120, 59, 1, 10890, 4, 2, 59, 113, 10440, 10442, 1, 10888, 4, 2, 59, 113, 10448, 10450, 1, 10888, 59, 1, 8809, 105, 109, 59, 1, 8935, 112, 102, 59, 3, 55349, 56664, 97, 118, 101, 59, 1, 96, 4, 2, 99, 105, 10476, 10480, 114, 59, 1, 8458, 109, 4, 3, 59, 101, 108, 10489, 10491, 10494, 1, 8819, 59, 1, 10894, 59, 1, 10896, 5, 62, 6, 59, 99, 100, 108, 113, 114, 10512, 10514, 10527, 10532, 10538, 10545, 1, 62, 4, 2, 99, 105, 10520, 10523, 59, 1, 10919, 114, 59, 1, 10874, 111, 116, 59, 1, 8919, 80, 97, 114, 59, 1, 10645, 117, 101, 115, 116, 59, 1, 10876, 4, 5, 97, 100, 101, 108, 115, 10557, 10574, 10579, 10599, 10605, 4, 2, 112, 114, 10563, 10570, 112, 114, 111, 120, 59, 1, 10886, 114, 59, 1, 10616, 111, 116, 59, 1, 8919, 113, 4, 2, 108, 113, 10586, 10592, 101, 115, 115, 59, 1, 8923, 108, 101, 115, 115, 59, 1, 10892, 101, 115, 115, 59, 1, 8823, 105, 109, 59, 1, 8819, 4, 2, 101, 110, 10616, 10626, 114, 116, 110, 101, 113, 113, 59, 3, 8809, 65024, 69, 59, 3, 8809, 65024, 4, 10, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 10653, 10658, 10713, 10718, 10724, 10760, 10765, 10786, 10850, 10875, 114, 114, 59, 1, 8660, 4, 4, 105, 108, 109, 114, 10668, 10674, 10678, 10684, 114, 115, 112, 59, 1, 8202, 102, 59, 1, 189, 105, 108, 116, 59, 1, 8459, 4, 2, 100, 114, 10690, 10695, 99, 121, 59, 1, 1098, 4, 3, 59, 99, 119, 10703, 10705, 10710, 1, 8596, 105, 114, 59, 1, 10568, 59, 1, 8621, 97, 114, 59, 1, 8463, 105, 114, 99, 59, 1, 293, 4, 3, 97, 108, 114, 10732, 10748, 10754, 114, 116, 115, 4, 2, 59, 117, 10741, 10743, 1, 9829, 105, 116, 59, 1, 9829, 108, 105, 112, 59, 1, 8230, 99, 111, 110, 59, 1, 8889, 114, 59, 3, 55349, 56613, 115, 4, 2, 101, 119, 10772, 10779, 97, 114, 111, 119, 59, 1, 10533, 97, 114, 111, 119, 59, 1, 10534, 4, 5, 97, 109, 111, 112, 114, 10798, 10803, 10809, 10839, 10844, 114, 114, 59, 1, 8703, 116, 104, 116, 59, 1, 8763, 107, 4, 2, 108, 114, 10816, 10827, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8618, 102, 59, 3, 55349, 56665, 98, 97, 114, 59, 1, 8213, 4, 3, 99, 108, 116, 10858, 10863, 10869, 114, 59, 3, 55349, 56509, 97, 115, 104, 59, 1, 8463, 114, 111, 107, 59, 1, 295, 4, 2, 98, 112, 10881, 10887, 117, 108, 108, 59, 1, 8259, 104, 101, 110, 59, 1, 8208, 4, 15, 97, 99, 101, 102, 103, 105, 106, 109, 110, 111, 112, 113, 115, 116, 117, 10925, 10936, 10958, 10977, 10990, 11001, 11039, 11045, 11101, 11192, 11220, 11226, 11237, 11285, 11299, 99, 117, 116, 101, 5, 237, 1, 59, 10934, 1, 237, 4, 3, 59, 105, 121, 10944, 10946, 10955, 1, 8291, 114, 99, 5, 238, 1, 59, 10953, 1, 238, 59, 1, 1080, 4, 2, 99, 120, 10964, 10968, 121, 59, 1, 1077, 99, 108, 5, 161, 1, 59, 10975, 1, 161, 4, 2, 102, 114, 10983, 10986, 59, 1, 8660, 59, 3, 55349, 56614, 114, 97, 118, 101, 5, 236, 1, 59, 10999, 1, 236, 4, 4, 59, 105, 110, 111, 11011, 11013, 11028, 11034, 1, 8520, 4, 2, 105, 110, 11019, 11024, 110, 116, 59, 1, 10764, 116, 59, 1, 8749, 102, 105, 110, 59, 1, 10716, 116, 97, 59, 1, 8489, 108, 105, 103, 59, 1, 307, 4, 3, 97, 111, 112, 11053, 11092, 11096, 4, 3, 99, 103, 116, 11061, 11065, 11088, 114, 59, 1, 299, 4, 3, 101, 108, 112, 11073, 11076, 11082, 59, 1, 8465, 105, 110, 101, 59, 1, 8464, 97, 114, 116, 59, 1, 8465, 104, 59, 1, 305, 102, 59, 1, 8887, 101, 100, 59, 1, 437, 4, 5, 59, 99, 102, 111, 116, 11113, 11115, 11121, 11136, 11142, 1, 8712, 97, 114, 101, 59, 1, 8453, 105, 110, 4, 2, 59, 116, 11129, 11131, 1, 8734, 105, 101, 59, 1, 10717, 100, 111, 116, 59, 1, 305, 4, 5, 59, 99, 101, 108, 112, 11154, 11156, 11161, 11179, 11186, 1, 8747, 97, 108, 59, 1, 8890, 4, 2, 103, 114, 11167, 11173, 101, 114, 115, 59, 1, 8484, 99, 97, 108, 59, 1, 8890, 97, 114, 104, 107, 59, 1, 10775, 114, 111, 100, 59, 1, 10812, 4, 4, 99, 103, 112, 116, 11202, 11206, 11211, 11216, 121, 59, 1, 1105, 111, 110, 59, 1, 303, 102, 59, 3, 55349, 56666, 97, 59, 1, 953, 114, 111, 100, 59, 1, 10812, 117, 101, 115, 116, 5, 191, 1, 59, 11235, 1, 191, 4, 2, 99, 105, 11243, 11248, 114, 59, 3, 55349, 56510, 110, 4, 5, 59, 69, 100, 115, 118, 11261, 11263, 11266, 11271, 11282, 1, 8712, 59, 1, 8953, 111, 116, 59, 1, 8949, 4, 2, 59, 118, 11277, 11279, 1, 8948, 59, 1, 8947, 59, 1, 8712, 4, 2, 59, 105, 11291, 11293, 1, 8290, 108, 100, 101, 59, 1, 297, 4, 2, 107, 109, 11305, 11310, 99, 121, 59, 1, 1110, 108, 5, 239, 1, 59, 11316, 1, 239, 4, 6, 99, 102, 109, 111, 115, 117, 11332, 11346, 11351, 11357, 11363, 11380, 4, 2, 105, 121, 11338, 11343, 114, 99, 59, 1, 309, 59, 1, 1081, 114, 59, 3, 55349, 56615, 97, 116, 104, 59, 1, 567, 112, 102, 59, 3, 55349, 56667, 4, 2, 99, 101, 11369, 11374, 114, 59, 3, 55349, 56511, 114, 99, 121, 59, 1, 1112, 107, 99, 121, 59, 1, 1108, 4, 8, 97, 99, 102, 103, 104, 106, 111, 115, 11404, 11418, 11433, 11438, 11445, 11450, 11455, 11461, 112, 112, 97, 4, 2, 59, 118, 11413, 11415, 1, 954, 59, 1, 1008, 4, 2, 101, 121, 11424, 11430, 100, 105, 108, 59, 1, 311, 59, 1, 1082, 114, 59, 3, 55349, 56616, 114, 101, 101, 110, 59, 1, 312, 99, 121, 59, 1, 1093, 99, 121, 59, 1, 1116, 112, 102, 59, 3, 55349, 56668, 99, 114, 59, 3, 55349, 56512, 4, 23, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 11515, 11538, 11544, 11555, 11560, 11721, 11780, 11818, 11868, 12136, 12160, 12171, 12203, 12208, 12246, 12275, 12327, 12509, 12523, 12569, 12641, 12732, 12752, 4, 3, 97, 114, 116, 11523, 11528, 11532, 114, 114, 59, 1, 8666, 114, 59, 1, 8656, 97, 105, 108, 59, 1, 10523, 97, 114, 114, 59, 1, 10510, 4, 2, 59, 103, 11550, 11552, 1, 8806, 59, 1, 10891, 97, 114, 59, 1, 10594, 4, 9, 99, 101, 103, 109, 110, 112, 113, 114, 116, 11580, 11586, 11594, 11600, 11606, 11624, 11627, 11636, 11694, 117, 116, 101, 59, 1, 314, 109, 112, 116, 121, 118, 59, 1, 10676, 114, 97, 110, 59, 1, 8466, 98, 100, 97, 59, 1, 955, 103, 4, 3, 59, 100, 108, 11615, 11617, 11620, 1, 10216, 59, 1, 10641, 101, 59, 1, 10216, 59, 1, 10885, 117, 111, 5, 171, 1, 59, 11634, 1, 171, 114, 4, 8, 59, 98, 102, 104, 108, 112, 115, 116, 11655, 11657, 11669, 11673, 11677, 11681, 11685, 11690, 1, 8592, 4, 2, 59, 102, 11663, 11665, 1, 8676, 115, 59, 1, 10527, 115, 59, 1, 10525, 107, 59, 1, 8617, 112, 59, 1, 8619, 108, 59, 1, 10553, 105, 109, 59, 1, 10611, 108, 59, 1, 8610, 4, 3, 59, 97, 101, 11702, 11704, 11709, 1, 10923, 105, 108, 59, 1, 10521, 4, 2, 59, 115, 11715, 11717, 1, 10925, 59, 3, 10925, 65024, 4, 3, 97, 98, 114, 11729, 11734, 11739, 114, 114, 59, 1, 10508, 114, 107, 59, 1, 10098, 4, 2, 97, 107, 11745, 11758, 99, 4, 2, 101, 107, 11752, 11755, 59, 1, 123, 59, 1, 91, 4, 2, 101, 115, 11764, 11767, 59, 1, 10635, 108, 4, 2, 100, 117, 11774, 11777, 59, 1, 10639, 59, 1, 10637, 4, 4, 97, 101, 117, 121, 11790, 11796, 11811, 11815, 114, 111, 110, 59, 1, 318, 4, 2, 100, 105, 11802, 11807, 105, 108, 59, 1, 316, 108, 59, 1, 8968, 98, 59, 1, 123, 59, 1, 1083, 4, 4, 99, 113, 114, 115, 11828, 11832, 11845, 11864, 97, 59, 1, 10550, 117, 111, 4, 2, 59, 114, 11840, 11842, 1, 8220, 59, 1, 8222, 4, 2, 100, 117, 11851, 11857, 104, 97, 114, 59, 1, 10599, 115, 104, 97, 114, 59, 1, 10571, 104, 59, 1, 8626, 4, 5, 59, 102, 103, 113, 115, 11880, 11882, 12008, 12011, 12031, 1, 8804, 116, 4, 5, 97, 104, 108, 114, 116, 11895, 11913, 11935, 11947, 11996, 114, 114, 111, 119, 4, 2, 59, 116, 11905, 11907, 1, 8592, 97, 105, 108, 59, 1, 8610, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 11925, 11931, 111, 119, 110, 59, 1, 8637, 112, 59, 1, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8647, 105, 103, 104, 116, 4, 3, 97, 104, 115, 11959, 11974, 11984, 114, 114, 111, 119, 4, 2, 59, 115, 11969, 11971, 1, 8596, 59, 1, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8907, 59, 1, 8922, 4, 3, 59, 113, 115, 12019, 12021, 12024, 1, 8804, 59, 1, 8806, 108, 97, 110, 116, 59, 1, 10877, 4, 5, 59, 99, 100, 103, 115, 12043, 12045, 12049, 12070, 12083, 1, 10877, 99, 59, 1, 10920, 111, 116, 4, 2, 59, 111, 12057, 12059, 1, 10879, 4, 2, 59, 114, 12065, 12067, 1, 10881, 59, 1, 10883, 4, 2, 59, 101, 12076, 12079, 3, 8922, 65024, 115, 59, 1, 10899, 4, 5, 97, 100, 101, 103, 115, 12095, 12103, 12108, 12126, 12131, 112, 112, 114, 111, 120, 59, 1, 10885, 111, 116, 59, 1, 8918, 113, 4, 2, 103, 113, 12115, 12120, 116, 114, 59, 1, 8922, 103, 116, 114, 59, 1, 10891, 116, 114, 59, 1, 8822, 105, 109, 59, 1, 8818, 4, 3, 105, 108, 114, 12144, 12150, 12156, 115, 104, 116, 59, 1, 10620, 111, 111, 114, 59, 1, 8970, 59, 3, 55349, 56617, 4, 2, 59, 69, 12166, 12168, 1, 8822, 59, 1, 10897, 4, 2, 97, 98, 12177, 12198, 114, 4, 2, 100, 117, 12184, 12187, 59, 1, 8637, 4, 2, 59, 108, 12193, 12195, 1, 8636, 59, 1, 10602, 108, 107, 59, 1, 9604, 99, 121, 59, 1, 1113, 4, 5, 59, 97, 99, 104, 116, 12220, 12222, 12227, 12235, 12241, 1, 8810, 114, 114, 59, 1, 8647, 111, 114, 110, 101, 114, 59, 1, 8990, 97, 114, 100, 59, 1, 10603, 114, 105, 59, 1, 9722, 4, 2, 105, 111, 12252, 12258, 100, 111, 116, 59, 1, 320, 117, 115, 116, 4, 2, 59, 97, 12267, 12269, 1, 9136, 99, 104, 101, 59, 1, 9136, 4, 4, 69, 97, 101, 115, 12285, 12288, 12303, 12322, 59, 1, 8808, 112, 4, 2, 59, 112, 12295, 12297, 1, 10889, 114, 111, 120, 59, 1, 10889, 4, 2, 59, 113, 12309, 12311, 1, 10887, 4, 2, 59, 113, 12317, 12319, 1, 10887, 59, 1, 8808, 105, 109, 59, 1, 8934, 4, 8, 97, 98, 110, 111, 112, 116, 119, 122, 12345, 12359, 12364, 12421, 12446, 12467, 12474, 12490, 4, 2, 110, 114, 12351, 12355, 103, 59, 1, 10220, 114, 59, 1, 8701, 114, 107, 59, 1, 10214, 103, 4, 3, 108, 109, 114, 12373, 12401, 12409, 101, 102, 116, 4, 2, 97, 114, 12382, 12389, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10231, 97, 112, 115, 116, 111, 59, 1, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10230, 112, 97, 114, 114, 111, 119, 4, 2, 108, 114, 12433, 12439, 101, 102, 116, 59, 1, 8619, 105, 103, 104, 116, 59, 1, 8620, 4, 3, 97, 102, 108, 12454, 12458, 12462, 114, 59, 1, 10629, 59, 3, 55349, 56669, 117, 115, 59, 1, 10797, 105, 109, 101, 115, 59, 1, 10804, 4, 2, 97, 98, 12480, 12485, 115, 116, 59, 1, 8727, 97, 114, 59, 1, 95, 4, 3, 59, 101, 102, 12498, 12500, 12506, 1, 9674, 110, 103, 101, 59, 1, 9674, 59, 1, 10731, 97, 114, 4, 2, 59, 108, 12517, 12519, 1, 40, 116, 59, 1, 10643, 4, 5, 97, 99, 104, 109, 116, 12535, 12540, 12548, 12561, 12564, 114, 114, 59, 1, 8646, 111, 114, 110, 101, 114, 59, 1, 8991, 97, 114, 4, 2, 59, 100, 12556, 12558, 1, 8651, 59, 1, 10605, 59, 1, 8206, 114, 105, 59, 1, 8895, 4, 6, 97, 99, 104, 105, 113, 116, 12583, 12589, 12594, 12597, 12614, 12635, 113, 117, 111, 59, 1, 8249, 114, 59, 3, 55349, 56513, 59, 1, 8624, 109, 4, 3, 59, 101, 103, 12606, 12608, 12611, 1, 8818, 59, 1, 10893, 59, 1, 10895, 4, 2, 98, 117, 12620, 12623, 59, 1, 91, 111, 4, 2, 59, 114, 12630, 12632, 1, 8216, 59, 1, 8218, 114, 111, 107, 59, 1, 322, 5, 60, 8, 59, 99, 100, 104, 105, 108, 113, 114, 12660, 12662, 12675, 12680, 12686, 12692, 12698, 12705, 1, 60, 4, 2, 99, 105, 12668, 12671, 59, 1, 10918, 114, 59, 1, 10873, 111, 116, 59, 1, 8918, 114, 101, 101, 59, 1, 8907, 109, 101, 115, 59, 1, 8905, 97, 114, 114, 59, 1, 10614, 117, 101, 115, 116, 59, 1, 10875, 4, 2, 80, 105, 12711, 12716, 97, 114, 59, 1, 10646, 4, 3, 59, 101, 102, 12724, 12726, 12729, 1, 9667, 59, 1, 8884, 59, 1, 9666, 114, 4, 2, 100, 117, 12739, 12746, 115, 104, 97, 114, 59, 1, 10570, 104, 97, 114, 59, 1, 10598, 4, 2, 101, 110, 12758, 12768, 114, 116, 110, 101, 113, 113, 59, 3, 8808, 65024, 69, 59, 3, 8808, 65024, 4, 14, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 12803, 12809, 12893, 12908, 12914, 12928, 12933, 12937, 13011, 13025, 13032, 13049, 13052, 13069, 68, 111, 116, 59, 1, 8762, 4, 4, 99, 108, 112, 114, 12819, 12827, 12849, 12887, 114, 5, 175, 1, 59, 12825, 1, 175, 4, 2, 101, 116, 12833, 12836, 59, 1, 9794, 4, 2, 59, 101, 12842, 12844, 1, 10016, 115, 101, 59, 1, 10016, 4, 2, 59, 115, 12855, 12857, 1, 8614, 116, 111, 4, 4, 59, 100, 108, 117, 12869, 12871, 12877, 12883, 1, 8614, 111, 119, 110, 59, 1, 8615, 101, 102, 116, 59, 1, 8612, 112, 59, 1, 8613, 107, 101, 114, 59, 1, 9646, 4, 2, 111, 121, 12899, 12905, 109, 109, 97, 59, 1, 10793, 59, 1, 1084, 97, 115, 104, 59, 1, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 1, 8737, 114, 59, 3, 55349, 56618, 111, 59, 1, 8487, 4, 3, 99, 100, 110, 12945, 12954, 12985, 114, 111, 5, 181, 1, 59, 12952, 1, 181, 4, 4, 59, 97, 99, 100, 12964, 12966, 12971, 12976, 1, 8739, 115, 116, 59, 1, 42, 105, 114, 59, 1, 10992, 111, 116, 5, 183, 1, 59, 12983, 1, 183, 117, 115, 4, 3, 59, 98, 100, 12995, 12997, 13e3, 1, 8722, 59, 1, 8863, 4, 2, 59, 117, 13006, 13008, 1, 8760, 59, 1, 10794, 4, 2, 99, 100, 13017, 13021, 112, 59, 1, 10971, 114, 59, 1, 8230, 112, 108, 117, 115, 59, 1, 8723, 4, 2, 100, 112, 13038, 13044, 101, 108, 115, 59, 1, 8871, 102, 59, 3, 55349, 56670, 59, 1, 8723, 4, 2, 99, 116, 13058, 13063, 114, 59, 3, 55349, 56514, 112, 111, 115, 59, 1, 8766, 4, 3, 59, 108, 109, 13077, 13079, 13087, 1, 956, 116, 105, 109, 97, 112, 59, 1, 8888, 97, 112, 59, 1, 8888, 4, 24, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 13142, 13165, 13217, 13229, 13247, 13330, 13359, 13414, 13420, 13508, 13513, 13579, 13602, 13626, 13631, 13762, 13767, 13855, 13936, 13995, 14214, 14285, 14312, 14432, 4, 2, 103, 116, 13148, 13152, 59, 3, 8921, 824, 4, 2, 59, 118, 13158, 13161, 3, 8811, 8402, 59, 3, 8811, 824, 4, 3, 101, 108, 116, 13173, 13200, 13204, 102, 116, 4, 2, 97, 114, 13181, 13188, 114, 114, 111, 119, 59, 1, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8654, 59, 3, 8920, 824, 4, 2, 59, 118, 13210, 13213, 3, 8810, 8402, 59, 3, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8655, 4, 2, 68, 100, 13235, 13241, 97, 115, 104, 59, 1, 8879, 97, 115, 104, 59, 1, 8878, 4, 5, 98, 99, 110, 112, 116, 13259, 13264, 13270, 13275, 13308, 108, 97, 59, 1, 8711, 117, 116, 101, 59, 1, 324, 103, 59, 3, 8736, 8402, 4, 5, 59, 69, 105, 111, 112, 13287, 13289, 13293, 13298, 13302, 1, 8777, 59, 3, 10864, 824, 100, 59, 3, 8779, 824, 115, 59, 1, 329, 114, 111, 120, 59, 1, 8777, 117, 114, 4, 2, 59, 97, 13316, 13318, 1, 9838, 108, 4, 2, 59, 115, 13325, 13327, 1, 9838, 59, 1, 8469, 4, 2, 115, 117, 13336, 13344, 112, 5, 160, 1, 59, 13342, 1, 160, 109, 112, 4, 2, 59, 101, 13352, 13355, 3, 8782, 824, 59, 3, 8783, 824, 4, 5, 97, 101, 111, 117, 121, 13371, 13385, 13391, 13407, 13411, 4, 2, 112, 114, 13377, 13380, 59, 1, 10819, 111, 110, 59, 1, 328, 100, 105, 108, 59, 1, 326, 110, 103, 4, 2, 59, 100, 13399, 13401, 1, 8775, 111, 116, 59, 3, 10861, 824, 112, 59, 1, 10818, 59, 1, 1085, 97, 115, 104, 59, 1, 8211, 4, 7, 59, 65, 97, 100, 113, 115, 120, 13436, 13438, 13443, 13466, 13472, 13478, 13494, 1, 8800, 114, 114, 59, 1, 8663, 114, 4, 2, 104, 114, 13450, 13454, 107, 59, 1, 10532, 4, 2, 59, 111, 13460, 13462, 1, 8599, 119, 59, 1, 8599, 111, 116, 59, 3, 8784, 824, 117, 105, 118, 59, 1, 8802, 4, 2, 101, 105, 13484, 13489, 97, 114, 59, 1, 10536, 109, 59, 3, 8770, 824, 105, 115, 116, 4, 2, 59, 115, 13503, 13505, 1, 8708, 59, 1, 8708, 114, 59, 3, 55349, 56619, 4, 4, 69, 101, 115, 116, 13523, 13527, 13563, 13568, 59, 3, 8807, 824, 4, 3, 59, 113, 115, 13535, 13537, 13559, 1, 8817, 4, 3, 59, 113, 115, 13545, 13547, 13551, 1, 8817, 59, 3, 8807, 824, 108, 97, 110, 116, 59, 3, 10878, 824, 59, 3, 10878, 824, 105, 109, 59, 1, 8821, 4, 2, 59, 114, 13574, 13576, 1, 8815, 59, 1, 8815, 4, 3, 65, 97, 112, 13587, 13592, 13597, 114, 114, 59, 1, 8654, 114, 114, 59, 1, 8622, 97, 114, 59, 1, 10994, 4, 3, 59, 115, 118, 13610, 13612, 13623, 1, 8715, 4, 2, 59, 100, 13618, 13620, 1, 8956, 59, 1, 8954, 59, 1, 8715, 99, 121, 59, 1, 1114, 4, 7, 65, 69, 97, 100, 101, 115, 116, 13647, 13652, 13656, 13661, 13665, 13737, 13742, 114, 114, 59, 1, 8653, 59, 3, 8806, 824, 114, 114, 59, 1, 8602, 114, 59, 1, 8229, 4, 4, 59, 102, 113, 115, 13675, 13677, 13703, 13725, 1, 8816, 116, 4, 2, 97, 114, 13684, 13691, 114, 114, 111, 119, 59, 1, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8622, 4, 3, 59, 113, 115, 13711, 13713, 13717, 1, 8816, 59, 3, 8806, 824, 108, 97, 110, 116, 59, 3, 10877, 824, 4, 2, 59, 115, 13731, 13734, 3, 10877, 824, 59, 1, 8814, 105, 109, 59, 1, 8820, 4, 2, 59, 114, 13748, 13750, 1, 8814, 105, 4, 2, 59, 101, 13757, 13759, 1, 8938, 59, 1, 8940, 105, 100, 59, 1, 8740, 4, 2, 112, 116, 13773, 13778, 102, 59, 3, 55349, 56671, 5, 172, 3, 59, 105, 110, 13787, 13789, 13829, 1, 172, 110, 4, 4, 59, 69, 100, 118, 13800, 13802, 13806, 13812, 1, 8713, 59, 3, 8953, 824, 111, 116, 59, 3, 8949, 824, 4, 3, 97, 98, 99, 13820, 13823, 13826, 59, 1, 8713, 59, 1, 8951, 59, 1, 8950, 105, 4, 2, 59, 118, 13836, 13838, 1, 8716, 4, 3, 97, 98, 99, 13846, 13849, 13852, 59, 1, 8716, 59, 1, 8958, 59, 1, 8957, 4, 3, 97, 111, 114, 13863, 13892, 13899, 114, 4, 4, 59, 97, 115, 116, 13874, 13876, 13883, 13888, 1, 8742, 108, 108, 101, 108, 59, 1, 8742, 108, 59, 3, 11005, 8421, 59, 3, 8706, 824, 108, 105, 110, 116, 59, 1, 10772, 4, 3, 59, 99, 101, 13907, 13909, 13914, 1, 8832, 117, 101, 59, 1, 8928, 4, 2, 59, 99, 13920, 13923, 3, 10927, 824, 4, 2, 59, 101, 13929, 13931, 1, 8832, 113, 59, 3, 10927, 824, 4, 4, 65, 97, 105, 116, 13946, 13951, 13971, 13982, 114, 114, 59, 1, 8655, 114, 114, 4, 3, 59, 99, 119, 13961, 13963, 13967, 1, 8603, 59, 3, 10547, 824, 59, 3, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8603, 114, 105, 4, 2, 59, 101, 13990, 13992, 1, 8939, 59, 1, 8941, 4, 7, 99, 104, 105, 109, 112, 113, 117, 14011, 14036, 14060, 14080, 14085, 14090, 14106, 4, 4, 59, 99, 101, 114, 14021, 14023, 14028, 14032, 1, 8833, 117, 101, 59, 1, 8929, 59, 3, 10928, 824, 59, 3, 55349, 56515, 111, 114, 116, 4, 2, 109, 112, 14045, 14050, 105, 100, 59, 1, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8742, 109, 4, 2, 59, 101, 14067, 14069, 1, 8769, 4, 2, 59, 113, 14075, 14077, 1, 8772, 59, 1, 8772, 105, 100, 59, 1, 8740, 97, 114, 59, 1, 8742, 115, 117, 4, 2, 98, 112, 14098, 14102, 101, 59, 1, 8930, 101, 59, 1, 8931, 4, 3, 98, 99, 112, 14114, 14157, 14171, 4, 4, 59, 69, 101, 115, 14124, 14126, 14130, 14133, 1, 8836, 59, 3, 10949, 824, 59, 1, 8840, 101, 116, 4, 2, 59, 101, 14141, 14144, 3, 8834, 8402, 113, 4, 2, 59, 113, 14151, 14153, 1, 8840, 59, 3, 10949, 824, 99, 4, 2, 59, 101, 14164, 14166, 1, 8833, 113, 59, 3, 10928, 824, 4, 4, 59, 69, 101, 115, 14181, 14183, 14187, 14190, 1, 8837, 59, 3, 10950, 824, 59, 1, 8841, 101, 116, 4, 2, 59, 101, 14198, 14201, 3, 8835, 8402, 113, 4, 2, 59, 113, 14208, 14210, 1, 8841, 59, 3, 10950, 824, 4, 4, 103, 105, 108, 114, 14224, 14228, 14238, 14242, 108, 59, 1, 8825, 108, 100, 101, 5, 241, 1, 59, 14236, 1, 241, 103, 59, 1, 8824, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 14254, 14269, 101, 102, 116, 4, 2, 59, 101, 14263, 14265, 1, 8938, 113, 59, 1, 8940, 105, 103, 104, 116, 4, 2, 59, 101, 14279, 14281, 1, 8939, 113, 59, 1, 8941, 4, 2, 59, 109, 14291, 14293, 1, 957, 4, 3, 59, 101, 115, 14301, 14303, 14308, 1, 35, 114, 111, 59, 1, 8470, 112, 59, 1, 8199, 4, 9, 68, 72, 97, 100, 103, 105, 108, 114, 115, 14332, 14338, 14344, 14349, 14355, 14369, 14376, 14408, 14426, 97, 115, 104, 59, 1, 8877, 97, 114, 114, 59, 1, 10500, 112, 59, 3, 8781, 8402, 97, 115, 104, 59, 1, 8876, 4, 2, 101, 116, 14361, 14365, 59, 3, 8805, 8402, 59, 3, 62, 8402, 110, 102, 105, 110, 59, 1, 10718, 4, 3, 65, 101, 116, 14384, 14389, 14393, 114, 114, 59, 1, 10498, 59, 3, 8804, 8402, 4, 2, 59, 114, 14399, 14402, 3, 60, 8402, 105, 101, 59, 3, 8884, 8402, 4, 2, 65, 116, 14414, 14419, 114, 114, 59, 1, 10499, 114, 105, 101, 59, 3, 8885, 8402, 105, 109, 59, 3, 8764, 8402, 4, 3, 65, 97, 110, 14440, 14445, 14468, 114, 114, 59, 1, 8662, 114, 4, 2, 104, 114, 14452, 14456, 107, 59, 1, 10531, 4, 2, 59, 111, 14462, 14464, 1, 8598, 119, 59, 1, 8598, 101, 97, 114, 59, 1, 10535, 4, 18, 83, 97, 99, 100, 101, 102, 103, 104, 105, 108, 109, 111, 112, 114, 115, 116, 117, 118, 14512, 14515, 14535, 14560, 14597, 14603, 14618, 14643, 14657, 14662, 14701, 14741, 14747, 14769, 14851, 14877, 14907, 14916, 59, 1, 9416, 4, 2, 99, 115, 14521, 14531, 117, 116, 101, 5, 243, 1, 59, 14529, 1, 243, 116, 59, 1, 8859, 4, 2, 105, 121, 14541, 14557, 114, 4, 2, 59, 99, 14548, 14550, 1, 8858, 5, 244, 1, 59, 14555, 1, 244, 59, 1, 1086, 4, 5, 97, 98, 105, 111, 115, 14572, 14577, 14583, 14587, 14591, 115, 104, 59, 1, 8861, 108, 97, 99, 59, 1, 337, 118, 59, 1, 10808, 116, 59, 1, 8857, 111, 108, 100, 59, 1, 10684, 108, 105, 103, 59, 1, 339, 4, 2, 99, 114, 14609, 14614, 105, 114, 59, 1, 10687, 59, 3, 55349, 56620, 4, 3, 111, 114, 116, 14626, 14630, 14640, 110, 59, 1, 731, 97, 118, 101, 5, 242, 1, 59, 14638, 1, 242, 59, 1, 10689, 4, 2, 98, 109, 14649, 14654, 97, 114, 59, 1, 10677, 59, 1, 937, 110, 116, 59, 1, 8750, 4, 4, 97, 99, 105, 116, 14672, 14677, 14693, 14698, 114, 114, 59, 1, 8634, 4, 2, 105, 114, 14683, 14687, 114, 59, 1, 10686, 111, 115, 115, 59, 1, 10683, 110, 101, 59, 1, 8254, 59, 1, 10688, 4, 3, 97, 101, 105, 14709, 14714, 14719, 99, 114, 59, 1, 333, 103, 97, 59, 1, 969, 4, 3, 99, 100, 110, 14727, 14733, 14736, 114, 111, 110, 59, 1, 959, 59, 1, 10678, 117, 115, 59, 1, 8854, 112, 102, 59, 3, 55349, 56672, 4, 3, 97, 101, 108, 14755, 14759, 14764, 114, 59, 1, 10679, 114, 112, 59, 1, 10681, 117, 115, 59, 1, 8853, 4, 7, 59, 97, 100, 105, 111, 115, 118, 14785, 14787, 14792, 14831, 14837, 14841, 14848, 1, 8744, 114, 114, 59, 1, 8635, 4, 4, 59, 101, 102, 109, 14802, 14804, 14817, 14824, 1, 10845, 114, 4, 2, 59, 111, 14811, 14813, 1, 8500, 102, 59, 1, 8500, 5, 170, 1, 59, 14822, 1, 170, 5, 186, 1, 59, 14829, 1, 186, 103, 111, 102, 59, 1, 8886, 114, 59, 1, 10838, 108, 111, 112, 101, 59, 1, 10839, 59, 1, 10843, 4, 3, 99, 108, 111, 14859, 14863, 14873, 114, 59, 1, 8500, 97, 115, 104, 5, 248, 1, 59, 14871, 1, 248, 108, 59, 1, 8856, 105, 4, 2, 108, 109, 14884, 14893, 100, 101, 5, 245, 1, 59, 14891, 1, 245, 101, 115, 4, 2, 59, 97, 14901, 14903, 1, 8855, 115, 59, 1, 10806, 109, 108, 5, 246, 1, 59, 14914, 1, 246, 98, 97, 114, 59, 1, 9021, 4, 12, 97, 99, 101, 102, 104, 105, 108, 109, 111, 114, 115, 117, 14948, 14992, 14996, 15033, 15038, 15068, 15090, 15189, 15192, 15222, 15427, 15441, 114, 4, 4, 59, 97, 115, 116, 14959, 14961, 14976, 14989, 1, 8741, 5, 182, 2, 59, 108, 14968, 14970, 1, 182, 108, 101, 108, 59, 1, 8741, 4, 2, 105, 108, 14982, 14986, 109, 59, 1, 10995, 59, 1, 11005, 59, 1, 8706, 121, 59, 1, 1087, 114, 4, 5, 99, 105, 109, 112, 116, 15009, 15014, 15019, 15024, 15027, 110, 116, 59, 1, 37, 111, 100, 59, 1, 46, 105, 108, 59, 1, 8240, 59, 1, 8869, 101, 110, 107, 59, 1, 8241, 114, 59, 3, 55349, 56621, 4, 3, 105, 109, 111, 15046, 15057, 15063, 4, 2, 59, 118, 15052, 15054, 1, 966, 59, 1, 981, 109, 97, 116, 59, 1, 8499, 110, 101, 59, 1, 9742, 4, 3, 59, 116, 118, 15076, 15078, 15087, 1, 960, 99, 104, 102, 111, 114, 107, 59, 1, 8916, 59, 1, 982, 4, 2, 97, 117, 15096, 15119, 110, 4, 2, 99, 107, 15103, 15115, 107, 4, 2, 59, 104, 15110, 15112, 1, 8463, 59, 1, 8462, 118, 59, 1, 8463, 115, 4, 9, 59, 97, 98, 99, 100, 101, 109, 115, 116, 15140, 15142, 15148, 15151, 15156, 15168, 15171, 15179, 15184, 1, 43, 99, 105, 114, 59, 1, 10787, 59, 1, 8862, 105, 114, 59, 1, 10786, 4, 2, 111, 117, 15162, 15165, 59, 1, 8724, 59, 1, 10789, 59, 1, 10866, 110, 5, 177, 1, 59, 15177, 1, 177, 105, 109, 59, 1, 10790, 119, 111, 59, 1, 10791, 59, 1, 177, 4, 3, 105, 112, 117, 15200, 15208, 15213, 110, 116, 105, 110, 116, 59, 1, 10773, 102, 59, 3, 55349, 56673, 110, 100, 5, 163, 1, 59, 15220, 1, 163, 4, 10, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 15244, 15246, 15249, 15253, 15258, 15334, 15347, 15367, 15416, 15421, 1, 8826, 59, 1, 10931, 112, 59, 1, 10935, 117, 101, 59, 1, 8828, 4, 2, 59, 99, 15264, 15266, 1, 10927, 4, 6, 59, 97, 99, 101, 110, 115, 15280, 15282, 15290, 15299, 15303, 15329, 1, 8826, 112, 112, 114, 111, 120, 59, 1, 10935, 117, 114, 108, 121, 101, 113, 59, 1, 8828, 113, 59, 1, 10927, 4, 3, 97, 101, 115, 15311, 15319, 15324, 112, 112, 114, 111, 120, 59, 1, 10937, 113, 113, 59, 1, 10933, 105, 109, 59, 1, 8936, 105, 109, 59, 1, 8830, 109, 101, 4, 2, 59, 115, 15342, 15344, 1, 8242, 59, 1, 8473, 4, 3, 69, 97, 115, 15355, 15358, 15362, 59, 1, 10933, 112, 59, 1, 10937, 105, 109, 59, 1, 8936, 4, 3, 100, 102, 112, 15375, 15378, 15404, 59, 1, 8719, 4, 3, 97, 108, 115, 15386, 15392, 15398, 108, 97, 114, 59, 1, 9006, 105, 110, 101, 59, 1, 8978, 117, 114, 102, 59, 1, 8979, 4, 2, 59, 116, 15410, 15412, 1, 8733, 111, 59, 1, 8733, 105, 109, 59, 1, 8830, 114, 101, 108, 59, 1, 8880, 4, 2, 99, 105, 15433, 15438, 114, 59, 3, 55349, 56517, 59, 1, 968, 110, 99, 115, 112, 59, 1, 8200, 4, 6, 102, 105, 111, 112, 115, 117, 15462, 15467, 15472, 15478, 15485, 15491, 114, 59, 3, 55349, 56622, 110, 116, 59, 1, 10764, 112, 102, 59, 3, 55349, 56674, 114, 105, 109, 101, 59, 1, 8279, 99, 114, 59, 3, 55349, 56518, 4, 3, 97, 101, 111, 15499, 15520, 15534, 116, 4, 2, 101, 105, 15506, 15515, 114, 110, 105, 111, 110, 115, 59, 1, 8461, 110, 116, 59, 1, 10774, 115, 116, 4, 2, 59, 101, 15528, 15530, 1, 63, 113, 59, 1, 8799, 116, 5, 34, 1, 59, 15540, 1, 34, 4, 21, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 15586, 15609, 15615, 15620, 15796, 15855, 15893, 15931, 15977, 16001, 16039, 16183, 16204, 16222, 16228, 16285, 16312, 16318, 16363, 16408, 16416, 4, 3, 97, 114, 116, 15594, 15599, 15603, 114, 114, 59, 1, 8667, 114, 59, 1, 8658, 97, 105, 108, 59, 1, 10524, 97, 114, 114, 59, 1, 10511, 97, 114, 59, 1, 10596, 4, 7, 99, 100, 101, 110, 113, 114, 116, 15636, 15651, 15656, 15664, 15687, 15696, 15770, 4, 2, 101, 117, 15642, 15646, 59, 3, 8765, 817, 116, 101, 59, 1, 341, 105, 99, 59, 1, 8730, 109, 112, 116, 121, 118, 59, 1, 10675, 103, 4, 4, 59, 100, 101, 108, 15675, 15677, 15680, 15683, 1, 10217, 59, 1, 10642, 59, 1, 10661, 101, 59, 1, 10217, 117, 111, 5, 187, 1, 59, 15694, 1, 187, 114, 4, 11, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 15721, 15723, 15727, 15739, 15742, 15746, 15750, 15754, 15758, 15763, 15767, 1, 8594, 112, 59, 1, 10613, 4, 2, 59, 102, 15733, 15735, 1, 8677, 115, 59, 1, 10528, 59, 1, 10547, 115, 59, 1, 10526, 107, 59, 1, 8618, 112, 59, 1, 8620, 108, 59, 1, 10565, 105, 109, 59, 1, 10612, 108, 59, 1, 8611, 59, 1, 8605, 4, 2, 97, 105, 15776, 15781, 105, 108, 59, 1, 10522, 111, 4, 2, 59, 110, 15788, 15790, 1, 8758, 97, 108, 115, 59, 1, 8474, 4, 3, 97, 98, 114, 15804, 15809, 15814, 114, 114, 59, 1, 10509, 114, 107, 59, 1, 10099, 4, 2, 97, 107, 15820, 15833, 99, 4, 2, 101, 107, 15827, 15830, 59, 1, 125, 59, 1, 93, 4, 2, 101, 115, 15839, 15842, 59, 1, 10636, 108, 4, 2, 100, 117, 15849, 15852, 59, 1, 10638, 59, 1, 10640, 4, 4, 97, 101, 117, 121, 15865, 15871, 15886, 15890, 114, 111, 110, 59, 1, 345, 4, 2, 100, 105, 15877, 15882, 105, 108, 59, 1, 343, 108, 59, 1, 8969, 98, 59, 1, 125, 59, 1, 1088, 4, 4, 99, 108, 113, 115, 15903, 15907, 15914, 15927, 97, 59, 1, 10551, 100, 104, 97, 114, 59, 1, 10601, 117, 111, 4, 2, 59, 114, 15922, 15924, 1, 8221, 59, 1, 8221, 104, 59, 1, 8627, 4, 3, 97, 99, 103, 15939, 15966, 15970, 108, 4, 4, 59, 105, 112, 115, 15950, 15952, 15957, 15963, 1, 8476, 110, 101, 59, 1, 8475, 97, 114, 116, 59, 1, 8476, 59, 1, 8477, 116, 59, 1, 9645, 5, 174, 1, 59, 15975, 1, 174, 4, 3, 105, 108, 114, 15985, 15991, 15997, 115, 104, 116, 59, 1, 10621, 111, 111, 114, 59, 1, 8971, 59, 3, 55349, 56623, 4, 2, 97, 111, 16007, 16028, 114, 4, 2, 100, 117, 16014, 16017, 59, 1, 8641, 4, 2, 59, 108, 16023, 16025, 1, 8640, 59, 1, 10604, 4, 2, 59, 118, 16034, 16036, 1, 961, 59, 1, 1009, 4, 3, 103, 110, 115, 16047, 16167, 16171, 104, 116, 4, 6, 97, 104, 108, 114, 115, 116, 16063, 16081, 16103, 16130, 16143, 16155, 114, 114, 111, 119, 4, 2, 59, 116, 16073, 16075, 1, 8594, 97, 105, 108, 59, 1, 8611, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 16093, 16099, 111, 119, 110, 59, 1, 8641, 112, 59, 1, 8640, 101, 102, 116, 4, 2, 97, 104, 16112, 16120, 114, 114, 111, 119, 115, 59, 1, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8908, 103, 59, 1, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8787, 4, 3, 97, 104, 109, 16191, 16196, 16201, 114, 114, 59, 1, 8644, 97, 114, 59, 1, 8652, 59, 1, 8207, 111, 117, 115, 116, 4, 2, 59, 97, 16214, 16216, 1, 9137, 99, 104, 101, 59, 1, 9137, 109, 105, 100, 59, 1, 10990, 4, 4, 97, 98, 112, 116, 16238, 16252, 16257, 16278, 4, 2, 110, 114, 16244, 16248, 103, 59, 1, 10221, 114, 59, 1, 8702, 114, 107, 59, 1, 10215, 4, 3, 97, 102, 108, 16265, 16269, 16273, 114, 59, 1, 10630, 59, 3, 55349, 56675, 117, 115, 59, 1, 10798, 105, 109, 101, 115, 59, 1, 10805, 4, 2, 97, 112, 16291, 16304, 114, 4, 2, 59, 103, 16298, 16300, 1, 41, 116, 59, 1, 10644, 111, 108, 105, 110, 116, 59, 1, 10770, 97, 114, 114, 59, 1, 8649, 4, 4, 97, 99, 104, 113, 16328, 16334, 16339, 16342, 113, 117, 111, 59, 1, 8250, 114, 59, 3, 55349, 56519, 59, 1, 8625, 4, 2, 98, 117, 16348, 16351, 59, 1, 93, 111, 4, 2, 59, 114, 16358, 16360, 1, 8217, 59, 1, 8217, 4, 3, 104, 105, 114, 16371, 16377, 16383, 114, 101, 101, 59, 1, 8908, 109, 101, 115, 59, 1, 8906, 105, 4, 4, 59, 101, 102, 108, 16394, 16396, 16399, 16402, 1, 9657, 59, 1, 8885, 59, 1, 9656, 116, 114, 105, 59, 1, 10702, 108, 117, 104, 97, 114, 59, 1, 10600, 59, 1, 8478, 4, 19, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 111, 112, 113, 114, 115, 116, 117, 119, 122, 16459, 16466, 16472, 16572, 16590, 16672, 16687, 16746, 16844, 16850, 16924, 16963, 16988, 17115, 17121, 17154, 17206, 17614, 17656, 99, 117, 116, 101, 59, 1, 347, 113, 117, 111, 59, 1, 8218, 4, 10, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 16494, 16496, 16499, 16513, 16518, 16531, 16536, 16556, 16564, 16569, 1, 8827, 59, 1, 10932, 4, 2, 112, 114, 16505, 16508, 59, 1, 10936, 111, 110, 59, 1, 353, 117, 101, 59, 1, 8829, 4, 2, 59, 100, 16524, 16526, 1, 10928, 105, 108, 59, 1, 351, 114, 99, 59, 1, 349, 4, 3, 69, 97, 115, 16544, 16547, 16551, 59, 1, 10934, 112, 59, 1, 10938, 105, 109, 59, 1, 8937, 111, 108, 105, 110, 116, 59, 1, 10771, 105, 109, 59, 1, 8831, 59, 1, 1089, 111, 116, 4, 3, 59, 98, 101, 16582, 16584, 16587, 1, 8901, 59, 1, 8865, 59, 1, 10854, 4, 7, 65, 97, 99, 109, 115, 116, 120, 16606, 16611, 16634, 16642, 16646, 16652, 16668, 114, 114, 59, 1, 8664, 114, 4, 2, 104, 114, 16618, 16622, 107, 59, 1, 10533, 4, 2, 59, 111, 16628, 16630, 1, 8600, 119, 59, 1, 8600, 116, 5, 167, 1, 59, 16640, 1, 167, 105, 59, 1, 59, 119, 97, 114, 59, 1, 10537, 109, 4, 2, 105, 110, 16659, 16665, 110, 117, 115, 59, 1, 8726, 59, 1, 8726, 116, 59, 1, 10038, 114, 4, 2, 59, 111, 16679, 16682, 3, 55349, 56624, 119, 110, 59, 1, 8994, 4, 4, 97, 99, 111, 121, 16697, 16702, 16716, 16739, 114, 112, 59, 1, 9839, 4, 2, 104, 121, 16708, 16713, 99, 121, 59, 1, 1097, 59, 1, 1096, 114, 116, 4, 2, 109, 112, 16724, 16729, 105, 100, 59, 1, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8741, 5, 173, 1, 59, 16744, 1, 173, 4, 2, 103, 109, 16752, 16770, 109, 97, 4, 3, 59, 102, 118, 16762, 16764, 16767, 1, 963, 59, 1, 962, 59, 1, 962, 4, 8, 59, 100, 101, 103, 108, 110, 112, 114, 16788, 16790, 16795, 16806, 16817, 16828, 16832, 16838, 1, 8764, 111, 116, 59, 1, 10858, 4, 2, 59, 113, 16801, 16803, 1, 8771, 59, 1, 8771, 4, 2, 59, 69, 16812, 16814, 1, 10910, 59, 1, 10912, 4, 2, 59, 69, 16823, 16825, 1, 10909, 59, 1, 10911, 101, 59, 1, 8774, 108, 117, 115, 59, 1, 10788, 97, 114, 114, 59, 1, 10610, 97, 114, 114, 59, 1, 8592, 4, 4, 97, 101, 105, 116, 16860, 16883, 16891, 16904, 4, 2, 108, 115, 16866, 16878, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 1, 8726, 104, 112, 59, 1, 10803, 112, 97, 114, 115, 108, 59, 1, 10724, 4, 2, 100, 108, 16897, 16900, 59, 1, 8739, 101, 59, 1, 8995, 4, 2, 59, 101, 16910, 16912, 1, 10922, 4, 2, 59, 115, 16918, 16920, 1, 10924, 59, 3, 10924, 65024, 4, 3, 102, 108, 112, 16932, 16938, 16958, 116, 99, 121, 59, 1, 1100, 4, 2, 59, 98, 16944, 16946, 1, 47, 4, 2, 59, 97, 16952, 16954, 1, 10692, 114, 59, 1, 9023, 102, 59, 3, 55349, 56676, 97, 4, 2, 100, 114, 16970, 16985, 101, 115, 4, 2, 59, 117, 16978, 16980, 1, 9824, 105, 116, 59, 1, 9824, 59, 1, 8741, 4, 3, 99, 115, 117, 16996, 17028, 17089, 4, 2, 97, 117, 17002, 17015, 112, 4, 2, 59, 115, 17009, 17011, 1, 8851, 59, 3, 8851, 65024, 112, 4, 2, 59, 115, 17022, 17024, 1, 8852, 59, 3, 8852, 65024, 117, 4, 2, 98, 112, 17035, 17062, 4, 3, 59, 101, 115, 17043, 17045, 17048, 1, 8847, 59, 1, 8849, 101, 116, 4, 2, 59, 101, 17056, 17058, 1, 8847, 113, 59, 1, 8849, 4, 3, 59, 101, 115, 17070, 17072, 17075, 1, 8848, 59, 1, 8850, 101, 116, 4, 2, 59, 101, 17083, 17085, 1, 8848, 113, 59, 1, 8850, 4, 3, 59, 97, 102, 17097, 17099, 17112, 1, 9633, 114, 4, 2, 101, 102, 17106, 17109, 59, 1, 9633, 59, 1, 9642, 59, 1, 9642, 97, 114, 114, 59, 1, 8594, 4, 4, 99, 101, 109, 116, 17131, 17136, 17142, 17148, 114, 59, 3, 55349, 56520, 116, 109, 110, 59, 1, 8726, 105, 108, 101, 59, 1, 8995, 97, 114, 102, 59, 1, 8902, 4, 2, 97, 114, 17160, 17172, 114, 4, 2, 59, 102, 17167, 17169, 1, 9734, 59, 1, 9733, 4, 2, 97, 110, 17178, 17202, 105, 103, 104, 116, 4, 2, 101, 112, 17188, 17197, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 104, 105, 59, 1, 981, 115, 59, 1, 175, 4, 5, 98, 99, 109, 110, 112, 17218, 17351, 17420, 17423, 17427, 4, 9, 59, 69, 100, 101, 109, 110, 112, 114, 115, 17238, 17240, 17243, 17248, 17261, 17267, 17279, 17285, 17291, 1, 8834, 59, 1, 10949, 111, 116, 59, 1, 10941, 4, 2, 59, 100, 17254, 17256, 1, 8838, 111, 116, 59, 1, 10947, 117, 108, 116, 59, 1, 10945, 4, 2, 69, 101, 17273, 17276, 59, 1, 10955, 59, 1, 8842, 108, 117, 115, 59, 1, 10943, 97, 114, 114, 59, 1, 10617, 4, 3, 101, 105, 117, 17299, 17335, 17339, 116, 4, 3, 59, 101, 110, 17308, 17310, 17322, 1, 8834, 113, 4, 2, 59, 113, 17317, 17319, 1, 8838, 59, 1, 10949, 101, 113, 4, 2, 59, 113, 17330, 17332, 1, 8842, 59, 1, 10955, 109, 59, 1, 10951, 4, 2, 98, 112, 17345, 17348, 59, 1, 10965, 59, 1, 10963, 99, 4, 6, 59, 97, 99, 101, 110, 115, 17366, 17368, 17376, 17385, 17389, 17415, 1, 8827, 112, 112, 114, 111, 120, 59, 1, 10936, 117, 114, 108, 121, 101, 113, 59, 1, 8829, 113, 59, 1, 10928, 4, 3, 97, 101, 115, 17397, 17405, 17410, 112, 112, 114, 111, 120, 59, 1, 10938, 113, 113, 59, 1, 10934, 105, 109, 59, 1, 8937, 105, 109, 59, 1, 8831, 59, 1, 8721, 103, 59, 1, 9834, 4, 13, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 17455, 17462, 17469, 17476, 17478, 17481, 17496, 17509, 17524, 17530, 17536, 17548, 17554, 5, 185, 1, 59, 17460, 1, 185, 5, 178, 1, 59, 17467, 1, 178, 5, 179, 1, 59, 17474, 1, 179, 1, 8835, 59, 1, 10950, 4, 2, 111, 115, 17487, 17491, 116, 59, 1, 10942, 117, 98, 59, 1, 10968, 4, 2, 59, 100, 17502, 17504, 1, 8839, 111, 116, 59, 1, 10948, 115, 4, 2, 111, 117, 17516, 17520, 108, 59, 1, 10185, 98, 59, 1, 10967, 97, 114, 114, 59, 1, 10619, 117, 108, 116, 59, 1, 10946, 4, 2, 69, 101, 17542, 17545, 59, 1, 10956, 59, 1, 8843, 108, 117, 115, 59, 1, 10944, 4, 3, 101, 105, 117, 17562, 17598, 17602, 116, 4, 3, 59, 101, 110, 17571, 17573, 17585, 1, 8835, 113, 4, 2, 59, 113, 17580, 17582, 1, 8839, 59, 1, 10950, 101, 113, 4, 2, 59, 113, 17593, 17595, 1, 8843, 59, 1, 10956, 109, 59, 1, 10952, 4, 2, 98, 112, 17608, 17611, 59, 1, 10964, 59, 1, 10966, 4, 3, 65, 97, 110, 17622, 17627, 17650, 114, 114, 59, 1, 8665, 114, 4, 2, 104, 114, 17634, 17638, 107, 59, 1, 10534, 4, 2, 59, 111, 17644, 17646, 1, 8601, 119, 59, 1, 8601, 119, 97, 114, 59, 1, 10538, 108, 105, 103, 5, 223, 1, 59, 17664, 1, 223, 4, 13, 97, 98, 99, 100, 101, 102, 104, 105, 111, 112, 114, 115, 119, 17694, 17709, 17714, 17737, 17742, 17749, 17754, 17860, 17905, 17957, 17964, 18090, 18122, 4, 2, 114, 117, 17700, 17706, 103, 101, 116, 59, 1, 8982, 59, 1, 964, 114, 107, 59, 1, 9140, 4, 3, 97, 101, 121, 17722, 17728, 17734, 114, 111, 110, 59, 1, 357, 100, 105, 108, 59, 1, 355, 59, 1, 1090, 111, 116, 59, 1, 8411, 108, 114, 101, 99, 59, 1, 8981, 114, 59, 3, 55349, 56625, 4, 4, 101, 105, 107, 111, 17764, 17805, 17836, 17851, 4, 2, 114, 116, 17770, 17786, 101, 4, 2, 52, 102, 17777, 17780, 59, 1, 8756, 111, 114, 101, 59, 1, 8756, 97, 4, 3, 59, 115, 118, 17795, 17797, 17802, 1, 952, 121, 109, 59, 1, 977, 59, 1, 977, 4, 2, 99, 110, 17811, 17831, 107, 4, 2, 97, 115, 17818, 17826, 112, 112, 114, 111, 120, 59, 1, 8776, 105, 109, 59, 1, 8764, 115, 112, 59, 1, 8201, 4, 2, 97, 115, 17842, 17846, 112, 59, 1, 8776, 105, 109, 59, 1, 8764, 114, 110, 5, 254, 1, 59, 17858, 1, 254, 4, 3, 108, 109, 110, 17868, 17873, 17901, 100, 101, 59, 1, 732, 101, 115, 5, 215, 3, 59, 98, 100, 17884, 17886, 17898, 1, 215, 4, 2, 59, 97, 17892, 17894, 1, 8864, 114, 59, 1, 10801, 59, 1, 10800, 116, 59, 1, 8749, 4, 3, 101, 112, 115, 17913, 17917, 17953, 97, 59, 1, 10536, 4, 4, 59, 98, 99, 102, 17927, 17929, 17934, 17939, 1, 8868, 111, 116, 59, 1, 9014, 105, 114, 59, 1, 10993, 4, 2, 59, 111, 17945, 17948, 3, 55349, 56677, 114, 107, 59, 1, 10970, 97, 59, 1, 10537, 114, 105, 109, 101, 59, 1, 8244, 4, 3, 97, 105, 112, 17972, 17977, 18082, 100, 101, 59, 1, 8482, 4, 7, 97, 100, 101, 109, 112, 115, 116, 17993, 18051, 18056, 18059, 18066, 18072, 18076, 110, 103, 108, 101, 4, 5, 59, 100, 108, 113, 114, 18009, 18011, 18017, 18032, 18035, 1, 9653, 111, 119, 110, 59, 1, 9663, 101, 102, 116, 4, 2, 59, 101, 18026, 18028, 1, 9667, 113, 59, 1, 8884, 59, 1, 8796, 105, 103, 104, 116, 4, 2, 59, 101, 18045, 18047, 1, 9657, 113, 59, 1, 8885, 111, 116, 59, 1, 9708, 59, 1, 8796, 105, 110, 117, 115, 59, 1, 10810, 108, 117, 115, 59, 1, 10809, 98, 59, 1, 10701, 105, 109, 101, 59, 1, 10811, 101, 122, 105, 117, 109, 59, 1, 9186, 4, 3, 99, 104, 116, 18098, 18111, 18116, 4, 2, 114, 121, 18104, 18108, 59, 3, 55349, 56521, 59, 1, 1094, 99, 121, 59, 1, 1115, 114, 111, 107, 59, 1, 359, 4, 2, 105, 111, 18128, 18133, 120, 116, 59, 1, 8812, 104, 101, 97, 100, 4, 2, 108, 114, 18143, 18154, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8608, 4, 18, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 18204, 18209, 18214, 18234, 18250, 18268, 18292, 18308, 18319, 18343, 18379, 18397, 18413, 18504, 18547, 18553, 18584, 18603, 114, 114, 59, 1, 8657, 97, 114, 59, 1, 10595, 4, 2, 99, 114, 18220, 18230, 117, 116, 101, 5, 250, 1, 59, 18228, 1, 250, 114, 59, 1, 8593, 114, 4, 2, 99, 101, 18241, 18245, 121, 59, 1, 1118, 118, 101, 59, 1, 365, 4, 2, 105, 121, 18256, 18265, 114, 99, 5, 251, 1, 59, 18263, 1, 251, 59, 1, 1091, 4, 3, 97, 98, 104, 18276, 18281, 18287, 114, 114, 59, 1, 8645, 108, 97, 99, 59, 1, 369, 97, 114, 59, 1, 10606, 4, 2, 105, 114, 18298, 18304, 115, 104, 116, 59, 1, 10622, 59, 3, 55349, 56626, 114, 97, 118, 101, 5, 249, 1, 59, 18317, 1, 249, 4, 2, 97, 98, 18325, 18338, 114, 4, 2, 108, 114, 18332, 18335, 59, 1, 8639, 59, 1, 8638, 108, 107, 59, 1, 9600, 4, 2, 99, 116, 18349, 18374, 4, 2, 111, 114, 18355, 18369, 114, 110, 4, 2, 59, 101, 18363, 18365, 1, 8988, 114, 59, 1, 8988, 111, 112, 59, 1, 8975, 114, 105, 59, 1, 9720, 4, 2, 97, 108, 18385, 18390, 99, 114, 59, 1, 363, 5, 168, 1, 59, 18395, 1, 168, 4, 2, 103, 112, 18403, 18408, 111, 110, 59, 1, 371, 102, 59, 3, 55349, 56678, 4, 6, 97, 100, 104, 108, 115, 117, 18427, 18434, 18445, 18470, 18475, 18494, 114, 114, 111, 119, 59, 1, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8597, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 18457, 18463, 101, 102, 116, 59, 1, 8639, 105, 103, 104, 116, 59, 1, 8638, 117, 115, 59, 1, 8846, 105, 4, 3, 59, 104, 108, 18484, 18486, 18489, 1, 965, 59, 1, 978, 111, 110, 59, 1, 965, 112, 97, 114, 114, 111, 119, 115, 59, 1, 8648, 4, 3, 99, 105, 116, 18512, 18537, 18542, 4, 2, 111, 114, 18518, 18532, 114, 110, 4, 2, 59, 101, 18526, 18528, 1, 8989, 114, 59, 1, 8989, 111, 112, 59, 1, 8974, 110, 103, 59, 1, 367, 114, 105, 59, 1, 9721, 99, 114, 59, 3, 55349, 56522, 4, 3, 100, 105, 114, 18561, 18566, 18572, 111, 116, 59, 1, 8944, 108, 100, 101, 59, 1, 361, 105, 4, 2, 59, 102, 18579, 18581, 1, 9653, 59, 1, 9652, 4, 2, 97, 109, 18590, 18595, 114, 114, 59, 1, 8648, 108, 5, 252, 1, 59, 18601, 1, 252, 97, 110, 103, 108, 101, 59, 1, 10663, 4, 15, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 18643, 18648, 18661, 18667, 18847, 18851, 18857, 18904, 18909, 18915, 18931, 18937, 18943, 18949, 18996, 114, 114, 59, 1, 8661, 97, 114, 4, 2, 59, 118, 18656, 18658, 1, 10984, 59, 1, 10985, 97, 115, 104, 59, 1, 8872, 4, 2, 110, 114, 18673, 18679, 103, 114, 116, 59, 1, 10652, 4, 7, 101, 107, 110, 112, 114, 115, 116, 18695, 18704, 18711, 18720, 18742, 18754, 18810, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 97, 112, 112, 97, 59, 1, 1008, 111, 116, 104, 105, 110, 103, 59, 1, 8709, 4, 3, 104, 105, 114, 18728, 18732, 18735, 105, 59, 1, 981, 59, 1, 982, 111, 112, 116, 111, 59, 1, 8733, 4, 2, 59, 104, 18748, 18750, 1, 8597, 111, 59, 1, 1009, 4, 2, 105, 117, 18760, 18766, 103, 109, 97, 59, 1, 962, 4, 2, 98, 112, 18772, 18791, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18784, 18787, 3, 8842, 65024, 59, 3, 10955, 65024, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18803, 18806, 3, 8843, 65024, 59, 3, 10956, 65024, 4, 2, 104, 114, 18816, 18822, 101, 116, 97, 59, 1, 977, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 18834, 18840, 101, 102, 116, 59, 1, 8882, 105, 103, 104, 116, 59, 1, 8883, 121, 59, 1, 1074, 97, 115, 104, 59, 1, 8866, 4, 3, 101, 108, 114, 18865, 18884, 18890, 4, 3, 59, 98, 101, 18873, 18875, 18880, 1, 8744, 97, 114, 59, 1, 8891, 113, 59, 1, 8794, 108, 105, 112, 59, 1, 8942, 4, 2, 98, 116, 18896, 18901, 97, 114, 59, 1, 124, 59, 1, 124, 114, 59, 3, 55349, 56627, 116, 114, 105, 59, 1, 8882, 115, 117, 4, 2, 98, 112, 18923, 18927, 59, 3, 8834, 8402, 59, 3, 8835, 8402, 112, 102, 59, 3, 55349, 56679, 114, 111, 112, 59, 1, 8733, 116, 114, 105, 59, 1, 8883, 4, 2, 99, 117, 18955, 18960, 114, 59, 3, 55349, 56523, 4, 2, 98, 112, 18966, 18981, 110, 4, 2, 69, 101, 18973, 18977, 59, 3, 10955, 65024, 59, 3, 8842, 65024, 110, 4, 2, 69, 101, 18988, 18992, 59, 3, 10956, 65024, 59, 3, 8843, 65024, 105, 103, 122, 97, 103, 59, 1, 10650, 4, 7, 99, 101, 102, 111, 112, 114, 115, 19020, 19026, 19061, 19066, 19072, 19075, 19089, 105, 114, 99, 59, 1, 373, 4, 2, 100, 105, 19032, 19055, 4, 2, 98, 103, 19038, 19043, 97, 114, 59, 1, 10847, 101, 4, 2, 59, 113, 19050, 19052, 1, 8743, 59, 1, 8793, 101, 114, 112, 59, 1, 8472, 114, 59, 3, 55349, 56628, 112, 102, 59, 3, 55349, 56680, 59, 1, 8472, 4, 2, 59, 101, 19081, 19083, 1, 8768, 97, 116, 104, 59, 1, 8768, 99, 114, 59, 3, 55349, 56524, 4, 14, 99, 100, 102, 104, 105, 108, 109, 110, 111, 114, 115, 117, 118, 119, 19125, 19146, 19152, 19157, 19173, 19176, 19192, 19197, 19202, 19236, 19252, 19269, 19286, 19291, 4, 3, 97, 105, 117, 19133, 19137, 19142, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 116, 114, 105, 59, 1, 9661, 114, 59, 3, 55349, 56629, 4, 2, 65, 97, 19163, 19168, 114, 114, 59, 1, 10234, 114, 114, 59, 1, 10231, 59, 1, 958, 4, 2, 65, 97, 19182, 19187, 114, 114, 59, 1, 10232, 114, 114, 59, 1, 10229, 97, 112, 59, 1, 10236, 105, 115, 59, 1, 8955, 4, 3, 100, 112, 116, 19210, 19215, 19230, 111, 116, 59, 1, 10752, 4, 2, 102, 108, 19221, 19225, 59, 3, 55349, 56681, 117, 115, 59, 1, 10753, 105, 109, 101, 59, 1, 10754, 4, 2, 65, 97, 19242, 19247, 114, 114, 59, 1, 10233, 114, 114, 59, 1, 10230, 4, 2, 99, 113, 19258, 19263, 114, 59, 3, 55349, 56525, 99, 117, 112, 59, 1, 10758, 4, 2, 112, 116, 19275, 19281, 108, 117, 115, 59, 1, 10756, 114, 105, 59, 1, 9651, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 19316, 19335, 19349, 19357, 19362, 19367, 19373, 19379, 99, 4, 2, 117, 121, 19323, 19332, 116, 101, 5, 253, 1, 59, 19330, 1, 253, 59, 1, 1103, 4, 2, 105, 121, 19341, 19346, 114, 99, 59, 1, 375, 59, 1, 1099, 110, 5, 165, 1, 59, 19355, 1, 165, 114, 59, 3, 55349, 56630, 99, 121, 59, 1, 1111, 112, 102, 59, 3, 55349, 56682, 99, 114, 59, 3, 55349, 56526, 4, 2, 99, 109, 19385, 19389, 121, 59, 1, 1102, 108, 5, 255, 1, 59, 19395, 1, 255, 4, 10, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 19419, 19426, 19441, 19446, 19462, 19467, 19472, 19480, 19486, 19492, 99, 117, 116, 101, 59, 1, 378, 4, 2, 97, 121, 19432, 19438, 114, 111, 110, 59, 1, 382, 59, 1, 1079, 111, 116, 59, 1, 380, 4, 2, 101, 116, 19452, 19458, 116, 114, 102, 59, 1, 8488, 97, 59, 1, 950, 114, 59, 3, 55349, 56631, 99, 121, 59, 1, 1078, 103, 114, 97, 114, 114, 59, 1, 8669, 112, 102, 59, 3, 55349, 56683, 99, 114, 59, 3, 55349, 56527, 4, 2, 106, 110, 19498, 19501, 59, 1, 8205, 106, 59, 1, 8204]);
const WL = ZL, Se = en, Co = xL, Q = x1, I = Se.CODE_POINTS, uo = Se.CODE_POINT_SEQUENCES, qL = {
  128: 8364,
  130: 8218,
  131: 402,
  132: 8222,
  133: 8230,
  134: 8224,
  135: 8225,
  136: 710,
  137: 8240,
  138: 352,
  139: 8249,
  140: 338,
  142: 381,
  145: 8216,
  146: 8217,
  147: 8220,
  148: 8221,
  149: 8226,
  150: 8211,
  151: 8212,
  152: 732,
  153: 8482,
  154: 353,
  155: 8250,
  156: 339,
  158: 382,
  159: 376
}, Sm = 1, Mm = 2, Am = 4, YL = Sm | Mm | Am, be = "DATA_STATE", Qo = "RCDATA_STATE", oi = "RAWTEXT_STATE", Cn = "SCRIPT_DATA_STATE", $m = "PLAINTEXT_STATE", Yd = "TAG_OPEN_STATE", Xd = "END_TAG_OPEN_STATE", nl = "TAG_NAME_STATE", Qd = "RCDATA_LESS_THAN_SIGN_STATE", Jd = "RCDATA_END_TAG_OPEN_STATE", ec = "RCDATA_END_TAG_NAME_STATE", tc = "RAWTEXT_LESS_THAN_SIGN_STATE", nc = "RAWTEXT_END_TAG_OPEN_STATE", oc = "RAWTEXT_END_TAG_NAME_STATE", rc = "SCRIPT_DATA_LESS_THAN_SIGN_STATE", ic = "SCRIPT_DATA_END_TAG_OPEN_STATE", sc = "SCRIPT_DATA_END_TAG_NAME_STATE", ac = "SCRIPT_DATA_ESCAPE_START_STATE", lc = "SCRIPT_DATA_ESCAPE_START_DASH_STATE", Zt = "SCRIPT_DATA_ESCAPED_STATE", uc = "SCRIPT_DATA_ESCAPED_DASH_STATE", ol = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE", zi = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE", dc = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE", cc = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE", hc = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE", gn = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE", mc = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE", pc = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE", Ki = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE", fc = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE", on = "BEFORE_ATTRIBUTE_NAME_STATE", Zi = "ATTRIBUTE_NAME_STATE", rl = "AFTER_ATTRIBUTE_NAME_STATE", il = "BEFORE_ATTRIBUTE_VALUE_STATE", xi = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE", Wi = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE", qi = "ATTRIBUTE_VALUE_UNQUOTED_STATE", sl = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE", Pn = "SELF_CLOSING_START_TAG_STATE", Vr = "BOGUS_COMMENT_STATE", gc = "MARKUP_DECLARATION_OPEN_STATE", vc = "COMMENT_START_STATE", bc = "COMMENT_START_DASH_STATE", Hn = "COMMENT_STATE", yc = "COMMENT_LESS_THAN_SIGN_STATE", _c = "COMMENT_LESS_THAN_SIGN_BANG_STATE", Cc = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE", wc = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE", Yi = "COMMENT_END_DASH_STATE", Xi = "COMMENT_END_STATE", Tc = "COMMENT_END_BANG_STATE", kc = "DOCTYPE_STATE", Qi = "BEFORE_DOCTYPE_NAME_STATE", Ji = "DOCTYPE_NAME_STATE", Ec = "AFTER_DOCTYPE_NAME_STATE", Sc = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE", Mc = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE", al = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE", ll = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE", ul = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE", Ac = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE", $c = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE", Ic = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE", jr = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE", Ur = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE", dl = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE", vn = "BOGUS_DOCTYPE_STATE", es = "CDATA_SECTION_STATE", Dc = "CDATA_SECTION_BRACKET_STATE", Lc = "CDATA_SECTION_END_STATE", Zo = "CHARACTER_REFERENCE_STATE", Oc = "NAMED_CHARACTER_REFERENCE_STATE", Nc = "AMBIGUOS_AMPERSAND_STATE", Pc = "NUMERIC_CHARACTER_REFERENCE_STATE", Hc = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE", Fc = "DECIMAL_CHARACTER_REFERENCE_START_STATE", Rc = "HEXADEMICAL_CHARACTER_REFERENCE_STATE", Bc = "DECIMAL_CHARACTER_REFERENCE_STATE", Gr = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
function Pe(e) {
  return e === I.SPACE || e === I.LINE_FEED || e === I.TABULATION || e === I.FORM_FEED;
}
function li(e) {
  return e >= I.DIGIT_0 && e <= I.DIGIT_9;
}
function Wt(e) {
  return e >= I.LATIN_CAPITAL_A && e <= I.LATIN_CAPITAL_Z;
}
function fo(e) {
  return e >= I.LATIN_SMALL_A && e <= I.LATIN_SMALL_Z;
}
function Vn(e) {
  return fo(e) || Wt(e);
}
function cl(e) {
  return Vn(e) || li(e);
}
function Im(e) {
  return e >= I.LATIN_CAPITAL_A && e <= I.LATIN_CAPITAL_F;
}
function Dm(e) {
  return e >= I.LATIN_SMALL_A && e <= I.LATIN_SMALL_F;
}
function XL(e) {
  return li(e) || Im(e) || Dm(e);
}
function hs(e) {
  return e + 32;
}
function Ge(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode(e >>> 10 & 1023 | 55296) + String.fromCharCode(56320 | e & 1023));
}
function Fn(e) {
  return String.fromCharCode(hs(e));
}
function Vc(e, t) {
  const n = Co[++e];
  let o = ++e, i = o + n - 1;
  for (; o <= i; ) {
    const r = o + i >>> 1, a = Co[r];
    if (a < t)
      o = r + 1;
    else if (a > t)
      i = r - 1;
    else
      return Co[r + n];
  }
  return -1;
}
let zt = class pt {
  constructor() {
    this.preprocessor = new WL(), this.tokenQueue = [], this.allowCDATA = !1, this.state = be, this.returnState = "", this.charRefCode = -1, this.tempBuff = [], this.lastStartTagName = "", this.consumedAfterSnapshot = -1, this.active = !1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = null;
  }
  //Errors
  _err() {
  }
  _errOnNextCodePoint(t) {
    this._consume(), this._err(t), this._unconsume();
  }
  //API
  getNextToken() {
    for (; !this.tokenQueue.length && this.active; ) {
      this.consumedAfterSnapshot = 0;
      const t = this._consume();
      this._ensureHibernation() || this[this.state](t);
    }
    return this.tokenQueue.shift();
  }
  write(t, n) {
    this.active = !0, this.preprocessor.write(t, n);
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t);
  }
  //Hibernation
  _ensureHibernation() {
    if (this.preprocessor.endOfChunkHit) {
      for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
        this.preprocessor.retreat();
      return this.active = !1, this.tokenQueue.push({ type: pt.HIBERNATION_TOKEN }), !0;
    }
    return !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _unconsume() {
    this.consumedAfterSnapshot--, this.preprocessor.retreat();
  }
  _reconsumeInState(t) {
    this.state = t, this._unconsume();
  }
  _consumeSequenceIfMatch(t, n, o) {
    let i = 0, r = !0;
    const a = t.length;
    let s = 0, l = n, u;
    for (; s < a; s++) {
      if (s > 0 && (l = this._consume(), i++), l === I.EOF) {
        r = !1;
        break;
      }
      if (u = t[s], l !== u && (o || l !== hs(u))) {
        r = !1;
        break;
      }
    }
    if (!r)
      for (; i--; )
        this._unconsume();
    return r;
  }
  //Temp buffer
  _isTempBufferEqualToScriptString() {
    if (this.tempBuff.length !== uo.SCRIPT_STRING.length)
      return !1;
    for (let t = 0; t < this.tempBuff.length; t++)
      if (this.tempBuff[t] !== uo.SCRIPT_STRING[t])
        return !1;
    return !0;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: pt.START_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: []
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: pt.END_TAG_TOKEN,
      tagName: "",
      selfClosing: !1,
      attrs: []
    };
  }
  _createCommentToken() {
    this.currentToken = {
      type: pt.COMMENT_TOKEN,
      data: ""
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: pt.DOCTYPE_TOKEN,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null
    };
  }
  _createCharacterToken(t, n) {
    this.currentCharacterToken = {
      type: t,
      chars: n
    };
  }
  _createEOFToken() {
    this.currentToken = { type: pt.EOF_TOKEN };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    };
  }
  _leaveAttrName(t) {
    pt.getTokenAttr(this.currentToken, this.currentAttr.name) === null ? this.currentToken.attrs.push(this.currentAttr) : this._err(Q.duplicateAttribute), this.state = t;
  }
  _leaveAttrValue(t) {
    this.state = t;
  }
  //Token emission
  _emitCurrentToken() {
    this._emitCurrentCharacterToken();
    const t = this.currentToken;
    this.currentToken = null, t.type === pt.START_TAG_TOKEN ? this.lastStartTagName = t.tagName : t.type === pt.END_TAG_TOKEN && (t.attrs.length > 0 && this._err(Q.endTagWithAttributes), t.selfClosing && this._err(Q.endTagWithTrailingSolidus)), this.tokenQueue.push(t);
  }
  _emitCurrentCharacterToken() {
    this.currentCharacterToken && (this.tokenQueue.push(this.currentCharacterToken), this.currentCharacterToken = null);
  }
  _emitEOFToken() {
    this._createEOFToken(), this._emitCurrentToken();
  }
  //Characters emission
  //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, n) {
    this.currentCharacterToken && this.currentCharacterToken.type !== t && this._emitCurrentCharacterToken(), this.currentCharacterToken ? this.currentCharacterToken.chars += n : this._createCharacterToken(t, n);
  }
  _emitCodePoint(t) {
    let n = pt.CHARACTER_TOKEN;
    Pe(t) ? n = pt.WHITESPACE_CHARACTER_TOKEN : t === I.NULL && (n = pt.NULL_CHARACTER_TOKEN), this._appendCharToCurrentCharacterToken(n, Ge(t));
  }
  _emitSeveralCodePoints(t) {
    for (let n = 0; n < t.length; n++)
      this._emitCodePoint(t[n]);
  }
  //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
  //So we can avoid additional checks here.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(pt.CHARACTER_TOKEN, t);
  }
  // Character reference helpers
  _matchNamedCharacterReference(t) {
    let n = null, o = 1, i = Vc(0, t);
    for (this.tempBuff.push(t); i > -1; ) {
      const r = Co[i], a = r < YL;
      a && r & Sm && (n = r & Mm ? [Co[++i], Co[++i]] : [Co[++i]], o = 0);
      const s = this._consume();
      if (this.tempBuff.push(s), o++, s === I.EOF)
        break;
      a ? i = r & Am ? Vc(i, s) : -1 : i = s === r ? ++i : -1;
    }
    for (; o--; )
      this.tempBuff.pop(), this._unconsume();
    return n;
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === xi || this.returnState === Wi || this.returnState === qi;
  }
  _isCharacterReferenceAttributeQuirk(t) {
    if (!t && this._isCharacterReferenceInAttribute()) {
      const n = this._consume();
      return this._unconsume(), n === I.EQUALS_SIGN || cl(n);
    }
    return !1;
  }
  _flushCodePointsConsumedAsCharacterReference() {
    if (this._isCharacterReferenceInAttribute())
      for (let t = 0; t < this.tempBuff.length; t++)
        this.currentAttr.value += Ge(this.tempBuff[t]);
    else
      this._emitSeveralCodePoints(this.tempBuff);
    this.tempBuff = [];
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  [be](t) {
    this.preprocessor.dropParsedChunk(), t === I.LESS_THAN_SIGN ? this.state = Yd : t === I.AMPERSAND ? (this.returnState = be, this.state = Zo) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this._emitCodePoint(t)) : t === I.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  //  RCDATA state
  //------------------------------------------------------------------
  [Qo](t) {
    this.preprocessor.dropParsedChunk(), t === I.AMPERSAND ? (this.returnState = Qo, this.state = Zo) : t === I.LESS_THAN_SIGN ? this.state = Qd : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this._emitChars(Se.REPLACEMENT_CHARACTER)) : t === I.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  [oi](t) {
    this.preprocessor.dropParsedChunk(), t === I.LESS_THAN_SIGN ? this.state = tc : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this._emitChars(Se.REPLACEMENT_CHARACTER)) : t === I.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // Script data state
  //------------------------------------------------------------------
  [Cn](t) {
    this.preprocessor.dropParsedChunk(), t === I.LESS_THAN_SIGN ? this.state = rc : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this._emitChars(Se.REPLACEMENT_CHARACTER)) : t === I.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  [$m](t) {
    this.preprocessor.dropParsedChunk(), t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this._emitChars(Se.REPLACEMENT_CHARACTER)) : t === I.EOF ? this._emitEOFToken() : this._emitCodePoint(t);
  }
  // Tag open state
  //------------------------------------------------------------------
  [Yd](t) {
    t === I.EXCLAMATION_MARK ? this.state = gc : t === I.SOLIDUS ? this.state = Xd : Vn(t) ? (this._createStartTagToken(), this._reconsumeInState(nl)) : t === I.QUESTION_MARK ? (this._err(Q.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(), this._reconsumeInState(Vr)) : t === I.EOF ? (this._err(Q.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken()) : (this._err(Q.invalidFirstCharacterOfTagName), this._emitChars("<"), this._reconsumeInState(be));
  }
  // End tag open state
  //------------------------------------------------------------------
  [Xd](t) {
    Vn(t) ? (this._createEndTagToken(), this._reconsumeInState(nl)) : t === I.GREATER_THAN_SIGN ? (this._err(Q.missingEndTagName), this.state = be) : t === I.EOF ? (this._err(Q.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken()) : (this._err(Q.invalidFirstCharacterOfTagName), this._createCommentToken(), this._reconsumeInState(Vr));
  }
  // Tag name state
  //------------------------------------------------------------------
  [nl](t) {
    Pe(t) ? this.state = on : t === I.SOLIDUS ? this.state = Pn : t === I.GREATER_THAN_SIGN ? (this.state = be, this._emitCurrentToken()) : Wt(t) ? this.currentToken.tagName += Fn(t) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentToken.tagName += Se.REPLACEMENT_CHARACTER) : t === I.EOF ? (this._err(Q.eofInTag), this._emitEOFToken()) : this.currentToken.tagName += Ge(t);
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  [Qd](t) {
    t === I.SOLIDUS ? (this.tempBuff = [], this.state = Jd) : (this._emitChars("<"), this._reconsumeInState(Qo));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  [Jd](t) {
    Vn(t) ? (this._createEndTagToken(), this._reconsumeInState(ec)) : (this._emitChars("</"), this._reconsumeInState(Qo));
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  [ec](t) {
    if (Wt(t))
      this.currentToken.tagName += Fn(t), this.tempBuff.push(t);
    else if (fo(t))
      this.currentToken.tagName += Ge(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Pe(t)) {
          this.state = on;
          return;
        }
        if (t === I.SOLIDUS) {
          this.state = Pn;
          return;
        }
        if (t === I.GREATER_THAN_SIGN) {
          this.state = be, this._emitCurrentToken();
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Qo);
    }
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  [tc](t) {
    t === I.SOLIDUS ? (this.tempBuff = [], this.state = nc) : (this._emitChars("<"), this._reconsumeInState(oi));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  [nc](t) {
    Vn(t) ? (this._createEndTagToken(), this._reconsumeInState(oc)) : (this._emitChars("</"), this._reconsumeInState(oi));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  [oc](t) {
    if (Wt(t))
      this.currentToken.tagName += Fn(t), this.tempBuff.push(t);
    else if (fo(t))
      this.currentToken.tagName += Ge(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Pe(t)) {
          this.state = on;
          return;
        }
        if (t === I.SOLIDUS) {
          this.state = Pn;
          return;
        }
        if (t === I.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = be;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(oi);
    }
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  [rc](t) {
    t === I.SOLIDUS ? (this.tempBuff = [], this.state = ic) : t === I.EXCLAMATION_MARK ? (this.state = ac, this._emitChars("<!")) : (this._emitChars("<"), this._reconsumeInState(Cn));
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  [ic](t) {
    Vn(t) ? (this._createEndTagToken(), this._reconsumeInState(sc)) : (this._emitChars("</"), this._reconsumeInState(Cn));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  [sc](t) {
    if (Wt(t))
      this.currentToken.tagName += Fn(t), this.tempBuff.push(t);
    else if (fo(t))
      this.currentToken.tagName += Ge(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Pe(t)) {
          this.state = on;
          return;
        } else if (t === I.SOLIDUS) {
          this.state = Pn;
          return;
        } else if (t === I.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = be;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Cn);
    }
  }
  // Script data escape start state
  //------------------------------------------------------------------
  [ac](t) {
    t === I.HYPHEN_MINUS ? (this.state = lc, this._emitChars("-")) : this._reconsumeInState(Cn);
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  [lc](t) {
    t === I.HYPHEN_MINUS ? (this.state = ol, this._emitChars("-")) : this._reconsumeInState(Cn);
  }
  // Script data escaped state
  //------------------------------------------------------------------
  [Zt](t) {
    t === I.HYPHEN_MINUS ? (this.state = uc, this._emitChars("-")) : t === I.LESS_THAN_SIGN ? this.state = zi : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this._emitChars(Se.REPLACEMENT_CHARACTER)) : t === I.EOF ? (this._err(Q.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  [uc](t) {
    t === I.HYPHEN_MINUS ? (this.state = ol, this._emitChars("-")) : t === I.LESS_THAN_SIGN ? this.state = zi : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.state = Zt, this._emitChars(Se.REPLACEMENT_CHARACTER)) : t === I.EOF ? (this._err(Q.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = Zt, this._emitCodePoint(t));
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  [ol](t) {
    t === I.HYPHEN_MINUS ? this._emitChars("-") : t === I.LESS_THAN_SIGN ? this.state = zi : t === I.GREATER_THAN_SIGN ? (this.state = Cn, this._emitChars(">")) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.state = Zt, this._emitChars(Se.REPLACEMENT_CHARACTER)) : t === I.EOF ? (this._err(Q.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = Zt, this._emitCodePoint(t));
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  [zi](t) {
    t === I.SOLIDUS ? (this.tempBuff = [], this.state = dc) : Vn(t) ? (this.tempBuff = [], this._emitChars("<"), this._reconsumeInState(hc)) : (this._emitChars("<"), this._reconsumeInState(Zt));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  [dc](t) {
    Vn(t) ? (this._createEndTagToken(), this._reconsumeInState(cc)) : (this._emitChars("</"), this._reconsumeInState(Zt));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  [cc](t) {
    if (Wt(t))
      this.currentToken.tagName += Fn(t), this.tempBuff.push(t);
    else if (fo(t))
      this.currentToken.tagName += Ge(t), this.tempBuff.push(t);
    else {
      if (this.lastStartTagName === this.currentToken.tagName) {
        if (Pe(t)) {
          this.state = on;
          return;
        }
        if (t === I.SOLIDUS) {
          this.state = Pn;
          return;
        }
        if (t === I.GREATER_THAN_SIGN) {
          this._emitCurrentToken(), this.state = be;
          return;
        }
      }
      this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(Zt);
    }
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  [hc](t) {
    Pe(t) || t === I.SOLIDUS || t === I.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? gn : Zt, this._emitCodePoint(t)) : Wt(t) ? (this.tempBuff.push(hs(t)), this._emitCodePoint(t)) : fo(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(Zt);
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  [gn](t) {
    t === I.HYPHEN_MINUS ? (this.state = mc, this._emitChars("-")) : t === I.LESS_THAN_SIGN ? (this.state = Ki, this._emitChars("<")) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this._emitChars(Se.REPLACEMENT_CHARACTER)) : t === I.EOF ? (this._err(Q.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  [mc](t) {
    t === I.HYPHEN_MINUS ? (this.state = pc, this._emitChars("-")) : t === I.LESS_THAN_SIGN ? (this.state = Ki, this._emitChars("<")) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.state = gn, this._emitChars(Se.REPLACEMENT_CHARACTER)) : t === I.EOF ? (this._err(Q.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = gn, this._emitCodePoint(t));
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  [pc](t) {
    t === I.HYPHEN_MINUS ? this._emitChars("-") : t === I.LESS_THAN_SIGN ? (this.state = Ki, this._emitChars("<")) : t === I.GREATER_THAN_SIGN ? (this.state = Cn, this._emitChars(">")) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.state = gn, this._emitChars(Se.REPLACEMENT_CHARACTER)) : t === I.EOF ? (this._err(Q.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = gn, this._emitCodePoint(t));
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  [Ki](t) {
    t === I.SOLIDUS ? (this.tempBuff = [], this.state = fc, this._emitChars("/")) : this._reconsumeInState(gn);
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  [fc](t) {
    Pe(t) || t === I.SOLIDUS || t === I.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? Zt : gn, this._emitCodePoint(t)) : Wt(t) ? (this.tempBuff.push(hs(t)), this._emitCodePoint(t)) : fo(t) ? (this.tempBuff.push(t), this._emitCodePoint(t)) : this._reconsumeInState(gn);
  }
  // Before attribute name state
  //------------------------------------------------------------------
  [on](t) {
    Pe(t) || (t === I.SOLIDUS || t === I.GREATER_THAN_SIGN || t === I.EOF ? this._reconsumeInState(rl) : t === I.EQUALS_SIGN ? (this._err(Q.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = Zi) : (this._createAttr(""), this._reconsumeInState(Zi)));
  }
  // Attribute name state
  //------------------------------------------------------------------
  [Zi](t) {
    Pe(t) || t === I.SOLIDUS || t === I.GREATER_THAN_SIGN || t === I.EOF ? (this._leaveAttrName(rl), this._unconsume()) : t === I.EQUALS_SIGN ? this._leaveAttrName(il) : Wt(t) ? this.currentAttr.name += Fn(t) : t === I.QUOTATION_MARK || t === I.APOSTROPHE || t === I.LESS_THAN_SIGN ? (this._err(Q.unexpectedCharacterInAttributeName), this.currentAttr.name += Ge(t)) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentAttr.name += Se.REPLACEMENT_CHARACTER) : this.currentAttr.name += Ge(t);
  }
  // After attribute name state
  //------------------------------------------------------------------
  [rl](t) {
    Pe(t) || (t === I.SOLIDUS ? this.state = Pn : t === I.EQUALS_SIGN ? this.state = il : t === I.GREATER_THAN_SIGN ? (this.state = be, this._emitCurrentToken()) : t === I.EOF ? (this._err(Q.eofInTag), this._emitEOFToken()) : (this._createAttr(""), this._reconsumeInState(Zi)));
  }
  // Before attribute value state
  //------------------------------------------------------------------
  [il](t) {
    Pe(t) || (t === I.QUOTATION_MARK ? this.state = xi : t === I.APOSTROPHE ? this.state = Wi : t === I.GREATER_THAN_SIGN ? (this._err(Q.missingAttributeValue), this.state = be, this._emitCurrentToken()) : this._reconsumeInState(qi));
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  [xi](t) {
    t === I.QUOTATION_MARK ? this.state = sl : t === I.AMPERSAND ? (this.returnState = xi, this.state = Zo) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentAttr.value += Se.REPLACEMENT_CHARACTER) : t === I.EOF ? (this._err(Q.eofInTag), this._emitEOFToken()) : this.currentAttr.value += Ge(t);
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  [Wi](t) {
    t === I.APOSTROPHE ? this.state = sl : t === I.AMPERSAND ? (this.returnState = Wi, this.state = Zo) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentAttr.value += Se.REPLACEMENT_CHARACTER) : t === I.EOF ? (this._err(Q.eofInTag), this._emitEOFToken()) : this.currentAttr.value += Ge(t);
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  [qi](t) {
    Pe(t) ? this._leaveAttrValue(on) : t === I.AMPERSAND ? (this.returnState = qi, this.state = Zo) : t === I.GREATER_THAN_SIGN ? (this._leaveAttrValue(be), this._emitCurrentToken()) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentAttr.value += Se.REPLACEMENT_CHARACTER) : t === I.QUOTATION_MARK || t === I.APOSTROPHE || t === I.LESS_THAN_SIGN || t === I.EQUALS_SIGN || t === I.GRAVE_ACCENT ? (this._err(Q.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += Ge(t)) : t === I.EOF ? (this._err(Q.eofInTag), this._emitEOFToken()) : this.currentAttr.value += Ge(t);
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  [sl](t) {
    Pe(t) ? this._leaveAttrValue(on) : t === I.SOLIDUS ? this._leaveAttrValue(Pn) : t === I.GREATER_THAN_SIGN ? (this._leaveAttrValue(be), this._emitCurrentToken()) : t === I.EOF ? (this._err(Q.eofInTag), this._emitEOFToken()) : (this._err(Q.missingWhitespaceBetweenAttributes), this._reconsumeInState(on));
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  [Pn](t) {
    t === I.GREATER_THAN_SIGN ? (this.currentToken.selfClosing = !0, this.state = be, this._emitCurrentToken()) : t === I.EOF ? (this._err(Q.eofInTag), this._emitEOFToken()) : (this._err(Q.unexpectedSolidusInTag), this._reconsumeInState(on));
  }
  // Bogus comment state
  //------------------------------------------------------------------
  [Vr](t) {
    t === I.GREATER_THAN_SIGN ? (this.state = be, this._emitCurrentToken()) : t === I.EOF ? (this._emitCurrentToken(), this._emitEOFToken()) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentToken.data += Se.REPLACEMENT_CHARACTER) : this.currentToken.data += Ge(t);
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  [gc](t) {
    this._consumeSequenceIfMatch(uo.DASH_DASH_STRING, t, !0) ? (this._createCommentToken(), this.state = vc) : this._consumeSequenceIfMatch(uo.DOCTYPE_STRING, t, !1) ? this.state = kc : this._consumeSequenceIfMatch(uo.CDATA_START_STRING, t, !0) ? this.allowCDATA ? this.state = es : (this._err(Q.cdataInHtmlContent), this._createCommentToken(), this.currentToken.data = "[CDATA[", this.state = Vr) : this._ensureHibernation() || (this._err(Q.incorrectlyOpenedComment), this._createCommentToken(), this._reconsumeInState(Vr));
  }
  // Comment start state
  //------------------------------------------------------------------
  [vc](t) {
    t === I.HYPHEN_MINUS ? this.state = bc : t === I.GREATER_THAN_SIGN ? (this._err(Q.abruptClosingOfEmptyComment), this.state = be, this._emitCurrentToken()) : this._reconsumeInState(Hn);
  }
  // Comment start dash state
  //------------------------------------------------------------------
  [bc](t) {
    t === I.HYPHEN_MINUS ? this.state = Xi : t === I.GREATER_THAN_SIGN ? (this._err(Q.abruptClosingOfEmptyComment), this.state = be, this._emitCurrentToken()) : t === I.EOF ? (this._err(Q.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Hn));
  }
  // Comment state
  //------------------------------------------------------------------
  [Hn](t) {
    t === I.HYPHEN_MINUS ? this.state = Yi : t === I.LESS_THAN_SIGN ? (this.currentToken.data += "<", this.state = yc) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentToken.data += Se.REPLACEMENT_CHARACTER) : t === I.EOF ? (this._err(Q.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.data += Ge(t);
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  [yc](t) {
    t === I.EXCLAMATION_MARK ? (this.currentToken.data += "!", this.state = _c) : t === I.LESS_THAN_SIGN ? this.currentToken.data += "!" : this._reconsumeInState(Hn);
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  [_c](t) {
    t === I.HYPHEN_MINUS ? this.state = Cc : this._reconsumeInState(Hn);
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  [Cc](t) {
    t === I.HYPHEN_MINUS ? this.state = wc : this._reconsumeInState(Yi);
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  [wc](t) {
    t !== I.GREATER_THAN_SIGN && t !== I.EOF && this._err(Q.nestedComment), this._reconsumeInState(Xi);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  [Yi](t) {
    t === I.HYPHEN_MINUS ? this.state = Xi : t === I.EOF ? (this._err(Q.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Hn));
  }
  // Comment end state
  //------------------------------------------------------------------
  [Xi](t) {
    t === I.GREATER_THAN_SIGN ? (this.state = be, this._emitCurrentToken()) : t === I.EXCLAMATION_MARK ? this.state = Tc : t === I.HYPHEN_MINUS ? this.currentToken.data += "-" : t === I.EOF ? (this._err(Q.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--", this._reconsumeInState(Hn));
  }
  // Comment end bang state
  //------------------------------------------------------------------
  [Tc](t) {
    t === I.HYPHEN_MINUS ? (this.currentToken.data += "--!", this.state = Yi) : t === I.GREATER_THAN_SIGN ? (this._err(Q.incorrectlyClosedComment), this.state = be, this._emitCurrentToken()) : t === I.EOF ? (this._err(Q.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--!", this._reconsumeInState(Hn));
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  [kc](t) {
    Pe(t) ? this.state = Qi : t === I.GREATER_THAN_SIGN ? this._reconsumeInState(Qi) : t === I.EOF ? (this._err(Q.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Q.missingWhitespaceBeforeDoctypeName), this._reconsumeInState(Qi));
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  [Qi](t) {
    Pe(t) || (Wt(t) ? (this._createDoctypeToken(Fn(t)), this.state = Ji) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this._createDoctypeToken(Se.REPLACEMENT_CHARACTER), this.state = Ji) : t === I.GREATER_THAN_SIGN ? (this._err(Q.missingDoctypeName), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = be) : t === I.EOF ? (this._err(Q.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._createDoctypeToken(Ge(t)), this.state = Ji));
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  [Ji](t) {
    Pe(t) ? this.state = Ec : t === I.GREATER_THAN_SIGN ? (this.state = be, this._emitCurrentToken()) : Wt(t) ? this.currentToken.name += Fn(t) : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentToken.name += Se.REPLACEMENT_CHARACTER) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.name += Ge(t);
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  [Ec](t) {
    Pe(t) || (t === I.GREATER_THAN_SIGN ? (this.state = be, this._emitCurrentToken()) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this._consumeSequenceIfMatch(uo.PUBLIC_STRING, t, !1) ? this.state = Sc : this._consumeSequenceIfMatch(uo.SYSTEM_STRING, t, !1) ? this.state = $c : this._ensureHibernation() || (this._err(Q.invalidCharacterSequenceAfterDoctypeName), this.currentToken.forceQuirks = !0, this._reconsumeInState(vn)));
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  [Sc](t) {
    Pe(t) ? this.state = Mc : t === I.QUOTATION_MARK ? (this._err(Q.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = al) : t === I.APOSTROPHE ? (this._err(Q.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = ll) : t === I.GREATER_THAN_SIGN ? (this._err(Q.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = be, this._emitCurrentToken()) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Q.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(vn));
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  [Mc](t) {
    Pe(t) || (t === I.QUOTATION_MARK ? (this.currentToken.publicId = "", this.state = al) : t === I.APOSTROPHE ? (this.currentToken.publicId = "", this.state = ll) : t === I.GREATER_THAN_SIGN ? (this._err(Q.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = be, this._emitCurrentToken()) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Q.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(vn)));
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  [al](t) {
    t === I.QUOTATION_MARK ? this.state = ul : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentToken.publicId += Se.REPLACEMENT_CHARACTER) : t === I.GREATER_THAN_SIGN ? (this._err(Q.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = be) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += Ge(t);
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  [ll](t) {
    t === I.APOSTROPHE ? this.state = ul : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentToken.publicId += Se.REPLACEMENT_CHARACTER) : t === I.GREATER_THAN_SIGN ? (this._err(Q.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = be) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += Ge(t);
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  [ul](t) {
    Pe(t) ? this.state = Ac : t === I.GREATER_THAN_SIGN ? (this.state = be, this._emitCurrentToken()) : t === I.QUOTATION_MARK ? (this._err(Q.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = jr) : t === I.APOSTROPHE ? (this._err(Q.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = Ur) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Q.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(vn));
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  [Ac](t) {
    Pe(t) || (t === I.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = be) : t === I.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = jr) : t === I.APOSTROPHE ? (this.currentToken.systemId = "", this.state = Ur) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Q.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(vn)));
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  [$c](t) {
    Pe(t) ? this.state = Ic : t === I.QUOTATION_MARK ? (this._err(Q.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = jr) : t === I.APOSTROPHE ? (this._err(Q.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = Ur) : t === I.GREATER_THAN_SIGN ? (this._err(Q.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = be, this._emitCurrentToken()) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Q.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(vn));
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  [Ic](t) {
    Pe(t) || (t === I.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = jr) : t === I.APOSTROPHE ? (this.currentToken.systemId = "", this.state = Ur) : t === I.GREATER_THAN_SIGN ? (this._err(Q.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = be, this._emitCurrentToken()) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Q.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(vn)));
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  [jr](t) {
    t === I.QUOTATION_MARK ? this.state = dl : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentToken.systemId += Se.REPLACEMENT_CHARACTER) : t === I.GREATER_THAN_SIGN ? (this._err(Q.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = be) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += Ge(t);
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  [Ur](t) {
    t === I.APOSTROPHE ? this.state = dl : t === I.NULL ? (this._err(Q.unexpectedNullCharacter), this.currentToken.systemId += Se.REPLACEMENT_CHARACTER) : t === I.GREATER_THAN_SIGN ? (this._err(Q.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = be) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += Ge(t);
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  [dl](t) {
    Pe(t) || (t === I.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = be) : t === I.EOF ? (this._err(Q.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(Q.unexpectedCharacterAfterDoctypeSystemIdentifier), this._reconsumeInState(vn)));
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  [vn](t) {
    t === I.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = be) : t === I.NULL ? this._err(Q.unexpectedNullCharacter) : t === I.EOF && (this._emitCurrentToken(), this._emitEOFToken());
  }
  // CDATA section state
  //------------------------------------------------------------------
  [es](t) {
    t === I.RIGHT_SQUARE_BRACKET ? this.state = Dc : t === I.EOF ? (this._err(Q.eofInCdata), this._emitEOFToken()) : this._emitCodePoint(t);
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  [Dc](t) {
    t === I.RIGHT_SQUARE_BRACKET ? this.state = Lc : (this._emitChars("]"), this._reconsumeInState(es));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  [Lc](t) {
    t === I.GREATER_THAN_SIGN ? this.state = be : t === I.RIGHT_SQUARE_BRACKET ? this._emitChars("]") : (this._emitChars("]]"), this._reconsumeInState(es));
  }
  // Character reference state
  //------------------------------------------------------------------
  [Zo](t) {
    this.tempBuff = [I.AMPERSAND], t === I.NUMBER_SIGN ? (this.tempBuff.push(t), this.state = Pc) : cl(t) ? this._reconsumeInState(Oc) : (this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Named character reference state
  //------------------------------------------------------------------
  [Oc](t) {
    const n = this._matchNamedCharacterReference(t);
    if (this._ensureHibernation())
      this.tempBuff = [I.AMPERSAND];
    else if (n) {
      const o = this.tempBuff[this.tempBuff.length - 1] === I.SEMICOLON;
      this._isCharacterReferenceAttributeQuirk(o) || (o || this._errOnNextCodePoint(Q.missingSemicolonAfterCharacterReference), this.tempBuff = n), this._flushCodePointsConsumedAsCharacterReference(), this.state = this.returnState;
    } else
      this._flushCodePointsConsumedAsCharacterReference(), this.state = Nc;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  [Nc](t) {
    cl(t) ? this._isCharacterReferenceInAttribute() ? this.currentAttr.value += Ge(t) : this._emitCodePoint(t) : (t === I.SEMICOLON && this._err(Q.unknownNamedCharacterReference), this._reconsumeInState(this.returnState));
  }
  // Numeric character reference state
  //------------------------------------------------------------------
  [Pc](t) {
    this.charRefCode = 0, t === I.LATIN_SMALL_X || t === I.LATIN_CAPITAL_X ? (this.tempBuff.push(t), this.state = Hc) : this._reconsumeInState(Fc);
  }
  // Hexademical character reference start state
  //------------------------------------------------------------------
  [Hc](t) {
    XL(t) ? this._reconsumeInState(Rc) : (this._err(Q.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Decimal character reference start state
  //------------------------------------------------------------------
  [Fc](t) {
    li(t) ? this._reconsumeInState(Bc) : (this._err(Q.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
  }
  // Hexademical character reference state
  //------------------------------------------------------------------
  [Rc](t) {
    Im(t) ? this.charRefCode = this.charRefCode * 16 + t - 55 : Dm(t) ? this.charRefCode = this.charRefCode * 16 + t - 87 : li(t) ? this.charRefCode = this.charRefCode * 16 + t - 48 : t === I.SEMICOLON ? this.state = Gr : (this._err(Q.missingSemicolonAfterCharacterReference), this._reconsumeInState(Gr));
  }
  // Decimal character reference state
  //------------------------------------------------------------------
  [Bc](t) {
    li(t) ? this.charRefCode = this.charRefCode * 10 + t - 48 : t === I.SEMICOLON ? this.state = Gr : (this._err(Q.missingSemicolonAfterCharacterReference), this._reconsumeInState(Gr));
  }
  // Numeric character reference end state
  //------------------------------------------------------------------
  [Gr]() {
    if (this.charRefCode === I.NULL)
      this._err(Q.nullCharacterReference), this.charRefCode = I.REPLACEMENT_CHARACTER;
    else if (this.charRefCode > 1114111)
      this._err(Q.characterReferenceOutsideUnicodeRange), this.charRefCode = I.REPLACEMENT_CHARACTER;
    else if (Se.isSurrogate(this.charRefCode))
      this._err(Q.surrogateCharacterReference), this.charRefCode = I.REPLACEMENT_CHARACTER;
    else if (Se.isUndefinedCodePoint(this.charRefCode))
      this._err(Q.noncharacterCharacterReference);
    else if (Se.isControlCodePoint(this.charRefCode) || this.charRefCode === I.CARRIAGE_RETURN) {
      this._err(Q.controlCharacterReference);
      const t = qL[this.charRefCode];
      t && (this.charRefCode = t);
    }
    this.tempBuff = [this.charRefCode], this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState);
  }
};
zt.CHARACTER_TOKEN = "CHARACTER_TOKEN";
zt.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN";
zt.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN";
zt.START_TAG_TOKEN = "START_TAG_TOKEN";
zt.END_TAG_TOKEN = "END_TAG_TOKEN";
zt.COMMENT_TOKEN = "COMMENT_TOKEN";
zt.DOCTYPE_TOKEN = "DOCTYPE_TOKEN";
zt.EOF_TOKEN = "EOF_TOKEN";
zt.HIBERNATION_TOKEN = "HIBERNATION_TOKEN";
zt.MODE = {
  DATA: be,
  RCDATA: Qo,
  RAWTEXT: oi,
  SCRIPT_DATA: Cn,
  PLAINTEXT: $m
};
zt.getTokenAttr = function(e, t) {
  for (let n = e.attrs.length - 1; n >= 0; n--)
    if (e.attrs[n].name === t)
      return e.attrs[n].value;
  return null;
};
var ca = zt, tn = {};
const hl = tn.NAMESPACES = {
  HTML: "http://www.w3.org/1999/xhtml",
  MATHML: "http://www.w3.org/1998/Math/MathML",
  SVG: "http://www.w3.org/2000/svg",
  XLINK: "http://www.w3.org/1999/xlink",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
};
tn.ATTRS = {
  TYPE: "type",
  ACTION: "action",
  ENCODING: "encoding",
  PROMPT: "prompt",
  NAME: "name",
  COLOR: "color",
  FACE: "face",
  SIZE: "size"
};
tn.DOCUMENT_MODE = {
  NO_QUIRKS: "no-quirks",
  QUIRKS: "quirks",
  LIMITED_QUIRKS: "limited-quirks"
};
const ne = tn.TAG_NAMES = {
  A: "a",
  ADDRESS: "address",
  ANNOTATION_XML: "annotation-xml",
  APPLET: "applet",
  AREA: "area",
  ARTICLE: "article",
  ASIDE: "aside",
  B: "b",
  BASE: "base",
  BASEFONT: "basefont",
  BGSOUND: "bgsound",
  BIG: "big",
  BLOCKQUOTE: "blockquote",
  BODY: "body",
  BR: "br",
  BUTTON: "button",
  CAPTION: "caption",
  CENTER: "center",
  CODE: "code",
  COL: "col",
  COLGROUP: "colgroup",
  DD: "dd",
  DESC: "desc",
  DETAILS: "details",
  DIALOG: "dialog",
  DIR: "dir",
  DIV: "div",
  DL: "dl",
  DT: "dt",
  EM: "em",
  EMBED: "embed",
  FIELDSET: "fieldset",
  FIGCAPTION: "figcaption",
  FIGURE: "figure",
  FONT: "font",
  FOOTER: "footer",
  FOREIGN_OBJECT: "foreignObject",
  FORM: "form",
  FRAME: "frame",
  FRAMESET: "frameset",
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6",
  HEAD: "head",
  HEADER: "header",
  HGROUP: "hgroup",
  HR: "hr",
  HTML: "html",
  I: "i",
  IMG: "img",
  IMAGE: "image",
  INPUT: "input",
  IFRAME: "iframe",
  KEYGEN: "keygen",
  LABEL: "label",
  LI: "li",
  LINK: "link",
  LISTING: "listing",
  MAIN: "main",
  MALIGNMARK: "malignmark",
  MARQUEE: "marquee",
  MATH: "math",
  MENU: "menu",
  META: "meta",
  MGLYPH: "mglyph",
  MI: "mi",
  MO: "mo",
  MN: "mn",
  MS: "ms",
  MTEXT: "mtext",
  NAV: "nav",
  NOBR: "nobr",
  NOFRAMES: "noframes",
  NOEMBED: "noembed",
  NOSCRIPT: "noscript",
  OBJECT: "object",
  OL: "ol",
  OPTGROUP: "optgroup",
  OPTION: "option",
  P: "p",
  PARAM: "param",
  PLAINTEXT: "plaintext",
  PRE: "pre",
  RB: "rb",
  RP: "rp",
  RT: "rt",
  RTC: "rtc",
  RUBY: "ruby",
  S: "s",
  SCRIPT: "script",
  SECTION: "section",
  SELECT: "select",
  SOURCE: "source",
  SMALL: "small",
  SPAN: "span",
  STRIKE: "strike",
  STRONG: "strong",
  STYLE: "style",
  SUB: "sub",
  SUMMARY: "summary",
  SUP: "sup",
  TABLE: "table",
  TBODY: "tbody",
  TEMPLATE: "template",
  TEXTAREA: "textarea",
  TFOOT: "tfoot",
  TD: "td",
  TH: "th",
  THEAD: "thead",
  TITLE: "title",
  TR: "tr",
  TRACK: "track",
  TT: "tt",
  U: "u",
  UL: "ul",
  SVG: "svg",
  VAR: "var",
  WBR: "wbr",
  XMP: "xmp"
};
tn.SPECIAL_ELEMENTS = {
  [hl.HTML]: {
    [ne.ADDRESS]: !0,
    [ne.APPLET]: !0,
    [ne.AREA]: !0,
    [ne.ARTICLE]: !0,
    [ne.ASIDE]: !0,
    [ne.BASE]: !0,
    [ne.BASEFONT]: !0,
    [ne.BGSOUND]: !0,
    [ne.BLOCKQUOTE]: !0,
    [ne.BODY]: !0,
    [ne.BR]: !0,
    [ne.BUTTON]: !0,
    [ne.CAPTION]: !0,
    [ne.CENTER]: !0,
    [ne.COL]: !0,
    [ne.COLGROUP]: !0,
    [ne.DD]: !0,
    [ne.DETAILS]: !0,
    [ne.DIR]: !0,
    [ne.DIV]: !0,
    [ne.DL]: !0,
    [ne.DT]: !0,
    [ne.EMBED]: !0,
    [ne.FIELDSET]: !0,
    [ne.FIGCAPTION]: !0,
    [ne.FIGURE]: !0,
    [ne.FOOTER]: !0,
    [ne.FORM]: !0,
    [ne.FRAME]: !0,
    [ne.FRAMESET]: !0,
    [ne.H1]: !0,
    [ne.H2]: !0,
    [ne.H3]: !0,
    [ne.H4]: !0,
    [ne.H5]: !0,
    [ne.H6]: !0,
    [ne.HEAD]: !0,
    [ne.HEADER]: !0,
    [ne.HGROUP]: !0,
    [ne.HR]: !0,
    [ne.HTML]: !0,
    [ne.IFRAME]: !0,
    [ne.IMG]: !0,
    [ne.INPUT]: !0,
    [ne.LI]: !0,
    [ne.LINK]: !0,
    [ne.LISTING]: !0,
    [ne.MAIN]: !0,
    [ne.MARQUEE]: !0,
    [ne.MENU]: !0,
    [ne.META]: !0,
    [ne.NAV]: !0,
    [ne.NOEMBED]: !0,
    [ne.NOFRAMES]: !0,
    [ne.NOSCRIPT]: !0,
    [ne.OBJECT]: !0,
    [ne.OL]: !0,
    [ne.P]: !0,
    [ne.PARAM]: !0,
    [ne.PLAINTEXT]: !0,
    [ne.PRE]: !0,
    [ne.SCRIPT]: !0,
    [ne.SECTION]: !0,
    [ne.SELECT]: !0,
    [ne.SOURCE]: !0,
    [ne.STYLE]: !0,
    [ne.SUMMARY]: !0,
    [ne.TABLE]: !0,
    [ne.TBODY]: !0,
    [ne.TD]: !0,
    [ne.TEMPLATE]: !0,
    [ne.TEXTAREA]: !0,
    [ne.TFOOT]: !0,
    [ne.TH]: !0,
    [ne.THEAD]: !0,
    [ne.TITLE]: !0,
    [ne.TR]: !0,
    [ne.TRACK]: !0,
    [ne.UL]: !0,
    [ne.WBR]: !0,
    [ne.XMP]: !0
  },
  [hl.MATHML]: {
    [ne.MI]: !0,
    [ne.MO]: !0,
    [ne.MN]: !0,
    [ne.MS]: !0,
    [ne.MTEXT]: !0,
    [ne.ANNOTATION_XML]: !0
  },
  [hl.SVG]: {
    [ne.TITLE]: !0,
    [ne.FOREIGN_OBJECT]: !0,
    [ne.DESC]: !0
  }
};
const Lm = tn, oe = Lm.TAG_NAMES, Me = Lm.NAMESPACES;
function jc(e) {
  switch (e.length) {
    case 1:
      return e === oe.P;
    case 2:
      return e === oe.RB || e === oe.RP || e === oe.RT || e === oe.DD || e === oe.DT || e === oe.LI;
    case 3:
      return e === oe.RTC;
    case 6:
      return e === oe.OPTION;
    case 8:
      return e === oe.OPTGROUP;
  }
  return !1;
}
function QL(e) {
  switch (e.length) {
    case 1:
      return e === oe.P;
    case 2:
      return e === oe.RB || e === oe.RP || e === oe.RT || e === oe.DD || e === oe.DT || e === oe.LI || e === oe.TD || e === oe.TH || e === oe.TR;
    case 3:
      return e === oe.RTC;
    case 5:
      return e === oe.TBODY || e === oe.TFOOT || e === oe.THEAD;
    case 6:
      return e === oe.OPTION;
    case 7:
      return e === oe.CAPTION;
    case 8:
      return e === oe.OPTGROUP || e === oe.COLGROUP;
  }
  return !1;
}
function ts(e, t) {
  switch (e.length) {
    case 2:
      if (e === oe.TD || e === oe.TH)
        return t === Me.HTML;
      if (e === oe.MI || e === oe.MO || e === oe.MN || e === oe.MS)
        return t === Me.MATHML;
      break;
    case 4:
      if (e === oe.HTML)
        return t === Me.HTML;
      if (e === oe.DESC)
        return t === Me.SVG;
      break;
    case 5:
      if (e === oe.TABLE)
        return t === Me.HTML;
      if (e === oe.MTEXT)
        return t === Me.MATHML;
      if (e === oe.TITLE)
        return t === Me.SVG;
      break;
    case 6:
      return (e === oe.APPLET || e === oe.OBJECT) && t === Me.HTML;
    case 7:
      return (e === oe.CAPTION || e === oe.MARQUEE) && t === Me.HTML;
    case 8:
      return e === oe.TEMPLATE && t === Me.HTML;
    case 13:
      return e === oe.FOREIGN_OBJECT && t === Me.SVG;
    case 14:
      return e === oe.ANNOTATION_XML && t === Me.MATHML;
  }
  return !1;
}
let JL = class {
  constructor(e, t) {
    this.stackTop = -1, this.items = [], this.current = e, this.currentTagName = null, this.currentTmplContent = null, this.tmplCount = 0, this.treeAdapter = t;
  }
  //Index of element
  _indexOf(e) {
    let t = -1;
    for (let n = this.stackTop; n >= 0; n--)
      if (this.items[n] === e) {
        t = n;
        break;
      }
    return t;
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagName === oe.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === Me.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagName = this.current && this.treeAdapter.getTagName(this.current), this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
  }
  //Mutations
  push(e) {
    this.items[++this.stackTop] = e, this._updateCurrentElement(), this._isInTemplate() && this.tmplCount++;
  }
  pop() {
    this.stackTop--, this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this._updateCurrentElement();
  }
  replace(e, t) {
    const n = this._indexOf(e);
    this.items[n] = t, n === this.stackTop && this._updateCurrentElement();
  }
  insertAfter(e, t) {
    const n = this._indexOf(e) + 1;
    this.items.splice(n, 0, t), n === ++this.stackTop && this._updateCurrentElement();
  }
  popUntilTagNamePopped(e) {
    for (; this.stackTop > -1; ) {
      const t = this.currentTagName, n = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), t === e && n === Me.HTML)
        break;
    }
  }
  popUntilElementPopped(e) {
    for (; this.stackTop > -1; ) {
      const t = this.current;
      if (this.pop(), t === e)
        break;
    }
  }
  popUntilNumberedHeaderPopped() {
    for (; this.stackTop > -1; ) {
      const e = this.currentTagName, t = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), e === oe.H1 || e === oe.H2 || e === oe.H3 || e === oe.H4 || e === oe.H5 || e === oe.H6 && t === Me.HTML)
        break;
    }
  }
  popUntilTableCellPopped() {
    for (; this.stackTop > -1; ) {
      const e = this.currentTagName, t = this.treeAdapter.getNamespaceURI(this.current);
      if (this.pop(), e === oe.TD || e === oe.TH && t === Me.HTML)
        break;
    }
  }
  popAllUpToHtmlElement() {
    this.stackTop = 0, this._updateCurrentElement();
  }
  clearBackToTableContext() {
    for (; this.currentTagName !== oe.TABLE && this.currentTagName !== oe.TEMPLATE && this.currentTagName !== oe.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Me.HTML; )
      this.pop();
  }
  clearBackToTableBodyContext() {
    for (; this.currentTagName !== oe.TBODY && this.currentTagName !== oe.TFOOT && this.currentTagName !== oe.THEAD && this.currentTagName !== oe.TEMPLATE && this.currentTagName !== oe.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Me.HTML; )
      this.pop();
  }
  clearBackToTableRowContext() {
    for (; this.currentTagName !== oe.TR && this.currentTagName !== oe.TEMPLATE && this.currentTagName !== oe.HTML || this.treeAdapter.getNamespaceURI(this.current) !== Me.HTML; )
      this.pop();
  }
  remove(e) {
    for (let t = this.stackTop; t >= 0; t--)
      if (this.items[t] === e) {
        this.items.splice(t, 1), this.stackTop--, this._updateCurrentElement();
        break;
      }
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    const e = this.items[1];
    return e && this.treeAdapter.getTagName(e) === oe.BODY ? e : null;
  }
  contains(e) {
    return this._indexOf(e) > -1;
  }
  getCommonAncestor(e) {
    let t = this._indexOf(e);
    return --t >= 0 ? this.items[t] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.currentTagName === oe.HTML;
  }
  //Element in scope
  hasInScope(e) {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]), o = this.treeAdapter.getNamespaceURI(this.items[t]);
      if (n === e && o === Me.HTML)
        return !0;
      if (ts(n, o))
        return !1;
    }
    return !0;
  }
  hasNumberedHeaderInScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      const t = this.treeAdapter.getTagName(this.items[e]), n = this.treeAdapter.getNamespaceURI(this.items[e]);
      if ((t === oe.H1 || t === oe.H2 || t === oe.H3 || t === oe.H4 || t === oe.H5 || t === oe.H6) && n === Me.HTML)
        return !0;
      if (ts(t, n))
        return !1;
    }
    return !0;
  }
  hasInListItemScope(e) {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]), o = this.treeAdapter.getNamespaceURI(this.items[t]);
      if (n === e && o === Me.HTML)
        return !0;
      if ((n === oe.UL || n === oe.OL) && o === Me.HTML || ts(n, o))
        return !1;
    }
    return !0;
  }
  hasInButtonScope(e) {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]), o = this.treeAdapter.getNamespaceURI(this.items[t]);
      if (n === e && o === Me.HTML)
        return !0;
      if (n === oe.BUTTON && o === Me.HTML || ts(n, o))
        return !1;
    }
    return !0;
  }
  hasInTableScope(e) {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]);
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === Me.HTML) {
        if (n === e)
          return !0;
        if (n === oe.TABLE || n === oe.TEMPLATE || n === oe.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let e = this.stackTop; e >= 0; e--) {
      const t = this.treeAdapter.getTagName(this.items[e]);
      if (this.treeAdapter.getNamespaceURI(this.items[e]) === Me.HTML) {
        if (t === oe.TBODY || t === oe.THEAD || t === oe.TFOOT)
          return !0;
        if (t === oe.TABLE || t === oe.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasInSelectScope(e) {
    for (let t = this.stackTop; t >= 0; t--) {
      const n = this.treeAdapter.getTagName(this.items[t]);
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === Me.HTML) {
        if (n === e)
          return !0;
        if (n !== oe.OPTION && n !== oe.OPTGROUP)
          return !1;
      }
    }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; jc(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; QL(this.currentTagName); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(e) {
    for (; jc(this.currentTagName) && this.currentTagName !== e; )
      this.pop();
  }
};
var eO = JL;
const ns = 3;
let W1 = class jn {
  constructor(t) {
    this.length = 0, this.entries = [], this.treeAdapter = t, this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t) {
    const n = [];
    if (this.length >= ns) {
      const o = this.treeAdapter.getAttrList(t).length, i = this.treeAdapter.getTagName(t), r = this.treeAdapter.getNamespaceURI(t);
      for (let a = this.length - 1; a >= 0; a--) {
        const s = this.entries[a];
        if (s.type === jn.MARKER_ENTRY)
          break;
        const l = s.element, u = this.treeAdapter.getAttrList(l);
        this.treeAdapter.getTagName(l) === i && this.treeAdapter.getNamespaceURI(l) === r && u.length === o && n.push({ idx: a, attrs: u });
      }
    }
    return n.length < ns ? [] : n;
  }
  _ensureNoahArkCondition(t) {
    const n = this._getNoahArkConditionCandidates(t);
    let o = n.length;
    if (o) {
      const i = this.treeAdapter.getAttrList(t), r = i.length, a = /* @__PURE__ */ Object.create(null);
      for (let s = 0; s < r; s++) {
        const l = i[s];
        a[l.name] = l.value;
      }
      for (let s = 0; s < r; s++)
        for (let l = 0; l < o; l++) {
          const u = n[l].attrs[s];
          if (a[u.name] !== u.value && (n.splice(l, 1), o--), n.length < ns)
            return;
        }
      for (let s = o - 1; s >= ns - 1; s--)
        this.entries.splice(n[s].idx, 1), this.length--;
    }
  }
  //Mutations
  insertMarker() {
    this.entries.push({ type: jn.MARKER_ENTRY }), this.length++;
  }
  pushElement(t, n) {
    this._ensureNoahArkCondition(t), this.entries.push({
      type: jn.ELEMENT_ENTRY,
      element: t,
      token: n
    }), this.length++;
  }
  insertElementAfterBookmark(t, n) {
    let o = this.length - 1;
    for (; o >= 0 && this.entries[o] !== this.bookmark; o--)
      ;
    this.entries.splice(o + 1, 0, {
      type: jn.ELEMENT_ENTRY,
      element: t,
      token: n
    }), this.length++;
  }
  removeEntry(t) {
    for (let n = this.length - 1; n >= 0; n--)
      if (this.entries[n] === t) {
        this.entries.splice(n, 1), this.length--;
        break;
      }
  }
  clearToLastMarker() {
    for (; this.length; ) {
      const t = this.entries.pop();
      if (this.length--, t.type === jn.MARKER_ENTRY)
        break;
    }
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    for (let n = this.length - 1; n >= 0; n--) {
      const o = this.entries[n];
      if (o.type === jn.MARKER_ENTRY)
        return null;
      if (this.treeAdapter.getTagName(o.element) === t)
        return o;
    }
    return null;
  }
  getElementEntry(t) {
    for (let n = this.length - 1; n >= 0; n--) {
      const o = this.entries[n];
      if (o.type === jn.ELEMENT_ENTRY && o.element === t)
        return o;
    }
    return null;
  }
};
W1.MARKER_ENTRY = "MARKER_ENTRY";
W1.ELEMENT_ENTRY = "ELEMENT_ENTRY";
var tO = W1;
let Om = class {
  constructor(e) {
    const t = {}, n = this._getOverriddenMethods(this, t);
    for (const o of Object.keys(n))
      typeof n[o] == "function" && (t[o] = e[o], e[o] = n[o]);
  }
  _getOverriddenMethods() {
    throw new Error("Not implemented");
  }
};
Om.install = function(e, t, n) {
  e.__mixins || (e.__mixins = []);
  for (let i = 0; i < e.__mixins.length; i++)
    if (e.__mixins[i].constructor === t)
      return e.__mixins[i];
  const o = new t(e, n);
  return e.__mixins.push(o), o;
};
var Nn = Om;
const nO = Nn;
let oO = class extends nO {
  constructor(e) {
    super(e), this.preprocessor = e, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.offset = 0, this.col = 0, this.line = 1;
  }
  _getOverriddenMethods(e, t) {
    return {
      advance() {
        const n = this.pos + 1, o = this.html[n];
        return e.isEol && (e.isEol = !1, e.line++, e.lineStartPos = n), (o === `
` || o === "\r" && this.html[n + 1] !== `
`) && (e.isEol = !0), e.col = n - e.lineStartPos + 1, e.offset = e.droppedBufferSize + n, t.advance.call(this);
      },
      retreat() {
        t.retreat.call(this), e.isEol = !1, e.col = this.pos - e.lineStartPos + 1;
      },
      dropParsedChunk() {
        const n = this.pos;
        t.dropParsedChunk.call(this);
        const o = n - this.pos;
        e.lineStartPos -= o, e.droppedBufferSize += o, e.offset = e.droppedBufferSize + this.pos;
      }
    };
  }
};
var Nm = oO;
const Uc = Nn, ml = ca, rO = Nm;
let iO = class extends Uc {
  constructor(e) {
    super(e), this.tokenizer = e, this.posTracker = Uc.install(e.preprocessor, rO), this.currentAttrLocation = null, this.ctLoc = null;
  }
  _getCurrentLocation() {
    return {
      startLine: this.posTracker.line,
      startCol: this.posTracker.col,
      startOffset: this.posTracker.offset,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
  }
  _attachCurrentAttrLocationInfo() {
    this.currentAttrLocation.endLine = this.posTracker.line, this.currentAttrLocation.endCol = this.posTracker.col, this.currentAttrLocation.endOffset = this.posTracker.offset;
    const e = this.tokenizer.currentToken, t = this.tokenizer.currentAttr;
    e.location.attrs || (e.location.attrs = /* @__PURE__ */ Object.create(null)), e.location.attrs[t.name] = this.currentAttrLocation;
  }
  _getOverriddenMethods(e, t) {
    const n = {
      _createStartTagToken() {
        t._createStartTagToken.call(this), this.currentToken.location = e.ctLoc;
      },
      _createEndTagToken() {
        t._createEndTagToken.call(this), this.currentToken.location = e.ctLoc;
      },
      _createCommentToken() {
        t._createCommentToken.call(this), this.currentToken.location = e.ctLoc;
      },
      _createDoctypeToken(o) {
        t._createDoctypeToken.call(this, o), this.currentToken.location = e.ctLoc;
      },
      _createCharacterToken(o, i) {
        t._createCharacterToken.call(this, o, i), this.currentCharacterToken.location = e.ctLoc;
      },
      _createEOFToken() {
        t._createEOFToken.call(this), this.currentToken.location = e._getCurrentLocation();
      },
      _createAttr(o) {
        t._createAttr.call(this, o), e.currentAttrLocation = e._getCurrentLocation();
      },
      _leaveAttrName(o) {
        t._leaveAttrName.call(this, o), e._attachCurrentAttrLocationInfo();
      },
      _leaveAttrValue(o) {
        t._leaveAttrValue.call(this, o), e._attachCurrentAttrLocationInfo();
      },
      _emitCurrentToken() {
        const o = this.currentToken.location;
        this.currentCharacterToken && (this.currentCharacterToken.location.endLine = o.startLine, this.currentCharacterToken.location.endCol = o.startCol, this.currentCharacterToken.location.endOffset = o.startOffset), this.currentToken.type === ml.EOF_TOKEN ? (o.endLine = o.startLine, o.endCol = o.startCol, o.endOffset = o.startOffset) : (o.endLine = e.posTracker.line, o.endCol = e.posTracker.col + 1, o.endOffset = e.posTracker.offset + 1), t._emitCurrentToken.call(this);
      },
      _emitCurrentCharacterToken() {
        const o = this.currentCharacterToken && this.currentCharacterToken.location;
        o && o.endOffset === -1 && (o.endLine = e.posTracker.line, o.endCol = e.posTracker.col, o.endOffset = e.posTracker.offset), t._emitCurrentCharacterToken.call(this);
      }
    };
    return Object.keys(ml.MODE).forEach((o) => {
      const i = ml.MODE[o];
      n[i] = function(r) {
        e.ctLoc = e._getCurrentLocation(), t[i].call(this, r);
      };
    }), n;
  }
};
var Pm = iO;
const sO = Nn;
let aO = class extends sO {
  constructor(e, t) {
    super(e), this.onItemPop = t.onItemPop;
  }
  _getOverriddenMethods(e, t) {
    return {
      pop() {
        e.onItemPop(this.current), t.pop.call(this);
      },
      popAllUpToHtmlElement() {
        for (let n = this.stackTop; n > 0; n--)
          e.onItemPop(this.items[n]);
        t.popAllUpToHtmlElement.call(this);
      },
      remove(n) {
        e.onItemPop(this.current), t.remove.call(this, n);
      }
    };
  }
};
var lO = aO;
const pl = Nn, Gc = ca, uO = Pm, dO = lO, cO = tn, fl = cO.TAG_NAMES;
let hO = class extends pl {
  constructor(e) {
    super(e), this.parser = e, this.treeAdapter = this.parser.treeAdapter, this.posTracker = null, this.lastStartTagToken = null, this.lastFosterParentingLocation = null, this.currentToken = null;
  }
  _setStartLocation(e) {
    let t = null;
    this.lastStartTagToken && (t = Object.assign({}, this.lastStartTagToken.location), t.startTag = this.lastStartTagToken.location), this.treeAdapter.setNodeSourceCodeLocation(e, t);
  }
  _setEndLocation(e, t) {
    if (this.treeAdapter.getNodeSourceCodeLocation(e) && t.location) {
      const n = t.location, o = this.treeAdapter.getTagName(e), i = t.type === Gc.END_TAG_TOKEN && o === t.tagName, r = {};
      i ? (r.endTag = Object.assign({}, n), r.endLine = n.endLine, r.endCol = n.endCol, r.endOffset = n.endOffset) : (r.endLine = n.startLine, r.endCol = n.startCol, r.endOffset = n.startOffset), this.treeAdapter.updateNodeSourceCodeLocation(e, r);
    }
  }
  _getOverriddenMethods(e, t) {
    return {
      _bootstrap(n, o) {
        t._bootstrap.call(this, n, o), e.lastStartTagToken = null, e.lastFosterParentingLocation = null, e.currentToken = null;
        const i = pl.install(this.tokenizer, uO);
        e.posTracker = i.posTracker, pl.install(this.openElements, dO, {
          onItemPop: function(r) {
            e._setEndLocation(r, e.currentToken);
          }
        });
      },
      _runParsingLoop(n) {
        t._runParsingLoop.call(this, n);
        for (let o = this.openElements.stackTop; o >= 0; o--)
          e._setEndLocation(this.openElements.items[o], e.currentToken);
      },
      //Token processing
      _processTokenInForeignContent(n) {
        e.currentToken = n, t._processTokenInForeignContent.call(this, n);
      },
      _processToken(n) {
        if (e.currentToken = n, t._processToken.call(this, n), n.type === Gc.END_TAG_TOKEN && (n.tagName === fl.HTML || n.tagName === fl.BODY && this.openElements.hasInScope(fl.BODY)))
          for (let o = this.openElements.stackTop; o >= 0; o--) {
            const i = this.openElements.items[o];
            if (this.treeAdapter.getTagName(i) === n.tagName) {
              e._setEndLocation(i, n);
              break;
            }
          }
      },
      //Doctype
      _setDocumentType(n) {
        t._setDocumentType.call(this, n);
        const o = this.treeAdapter.getChildNodes(this.document), i = o.length;
        for (let r = 0; r < i; r++) {
          const a = o[r];
          if (this.treeAdapter.isDocumentTypeNode(a)) {
            this.treeAdapter.setNodeSourceCodeLocation(a, n.location);
            break;
          }
        }
      },
      //Elements
      _attachElementToTree(n) {
        e._setStartLocation(n), e.lastStartTagToken = null, t._attachElementToTree.call(this, n);
      },
      _appendElement(n, o) {
        e.lastStartTagToken = n, t._appendElement.call(this, n, o);
      },
      _insertElement(n, o) {
        e.lastStartTagToken = n, t._insertElement.call(this, n, o);
      },
      _insertTemplate(n) {
        e.lastStartTagToken = n, t._insertTemplate.call(this, n);
        const o = this.treeAdapter.getTemplateContent(this.openElements.current);
        this.treeAdapter.setNodeSourceCodeLocation(o, null);
      },
      _insertFakeRootElement() {
        t._insertFakeRootElement.call(this), this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
      },
      //Comments
      _appendCommentNode(n, o) {
        t._appendCommentNode.call(this, n, o);
        const i = this.treeAdapter.getChildNodes(o), r = i[i.length - 1];
        this.treeAdapter.setNodeSourceCodeLocation(r, n.location);
      },
      //Text
      _findFosterParentingLocation() {
        return e.lastFosterParentingLocation = t._findFosterParentingLocation.call(this), e.lastFosterParentingLocation;
      },
      _insertCharacters(n) {
        t._insertCharacters.call(this, n);
        const o = this._shouldFosterParentOnInsertion(), i = o && e.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current, r = this.treeAdapter.getChildNodes(i), a = o && e.lastFosterParentingLocation.beforeElement ? r.indexOf(e.lastFosterParentingLocation.beforeElement) - 1 : r.length - 1, s = r[a];
        if (this.treeAdapter.getNodeSourceCodeLocation(s)) {
          const { endLine: l, endCol: u, endOffset: m } = n.location;
          this.treeAdapter.updateNodeSourceCodeLocation(s, { endLine: l, endCol: u, endOffset: m });
        } else
          this.treeAdapter.setNodeSourceCodeLocation(s, n.location);
      }
    };
  }
};
var mO = hO;
const pO = Nn;
let fO = class extends pO {
  constructor(e, t) {
    super(e), this.posTracker = null, this.onParseError = t.onParseError;
  }
  _setErrorLocation(e) {
    e.startLine = e.endLine = this.posTracker.line, e.startCol = e.endCol = this.posTracker.col, e.startOffset = e.endOffset = this.posTracker.offset;
  }
  _reportError(e) {
    const t = {
      code: e,
      startLine: -1,
      startCol: -1,
      startOffset: -1,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    };
    this._setErrorLocation(t), this.onParseError(t);
  }
  _getOverriddenMethods(e) {
    return {
      _err(t) {
        e._reportError(t);
      }
    };
  }
};
var q1 = fO;
const gO = q1, vO = Nm, bO = Nn;
let yO = class extends gO {
  constructor(e, t) {
    super(e, t), this.posTracker = bO.install(e, vO), this.lastErrOffset = -1;
  }
  _reportError(e) {
    this.lastErrOffset !== this.posTracker.offset && (this.lastErrOffset = this.posTracker.offset, super._reportError(e));
  }
};
var _O = yO;
const CO = q1, wO = _O, TO = Nn;
let kO = class extends CO {
  constructor(e, t) {
    super(e, t);
    const n = TO.install(e.preprocessor, wO, t);
    this.posTracker = n.posTracker;
  }
};
var EO = kO;
const SO = q1, MO = EO, AO = Pm, zc = Nn;
let $O = class extends SO {
  constructor(e, t) {
    super(e, t), this.opts = t, this.ctLoc = null, this.locBeforeToken = !1;
  }
  _setErrorLocation(e) {
    this.ctLoc && (e.startLine = this.ctLoc.startLine, e.startCol = this.ctLoc.startCol, e.startOffset = this.ctLoc.startOffset, e.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine, e.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol, e.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset);
  }
  _getOverriddenMethods(e, t) {
    return {
      _bootstrap(n, o) {
        t._bootstrap.call(this, n, o), zc.install(this.tokenizer, MO, e.opts), zc.install(this.tokenizer, AO);
      },
      _processInputToken(n) {
        e.ctLoc = n.location, t._processInputToken.call(this, n);
      },
      _err(n, o) {
        e.locBeforeToken = o && o.beforeToken, e._reportError(n);
      }
    };
  }
};
var IO = $O, Ce = {};
const { DOCUMENT_MODE: DO } = tn;
Ce.createDocument = function() {
  return {
    nodeName: "#document",
    mode: DO.NO_QUIRKS,
    childNodes: []
  };
};
Ce.createDocumentFragment = function() {
  return {
    nodeName: "#document-fragment",
    childNodes: []
  };
};
Ce.createElement = function(e, t, n) {
  return {
    nodeName: e,
    tagName: e,
    attrs: n,
    namespaceURI: t,
    childNodes: [],
    parentNode: null
  };
};
Ce.createCommentNode = function(e) {
  return {
    nodeName: "#comment",
    data: e,
    parentNode: null
  };
};
const Hm = function(e) {
  return {
    nodeName: "#text",
    value: e,
    parentNode: null
  };
}, Fm = Ce.appendChild = function(e, t) {
  e.childNodes.push(t), t.parentNode = e;
}, LO = Ce.insertBefore = function(e, t, n) {
  const o = e.childNodes.indexOf(n);
  e.childNodes.splice(o, 0, t), t.parentNode = e;
};
Ce.setTemplateContent = function(e, t) {
  e.content = t;
};
Ce.getTemplateContent = function(e) {
  return e.content;
};
Ce.setDocumentType = function(e, t, n, o) {
  let i = null;
  for (let r = 0; r < e.childNodes.length; r++)
    if (e.childNodes[r].nodeName === "#documentType") {
      i = e.childNodes[r];
      break;
    }
  i ? (i.name = t, i.publicId = n, i.systemId = o) : Fm(e, {
    nodeName: "#documentType",
    name: t,
    publicId: n,
    systemId: o
  });
};
Ce.setDocumentMode = function(e, t) {
  e.mode = t;
};
Ce.getDocumentMode = function(e) {
  return e.mode;
};
Ce.detachNode = function(e) {
  if (e.parentNode) {
    const t = e.parentNode.childNodes.indexOf(e);
    e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
  }
};
Ce.insertText = function(e, t) {
  if (e.childNodes.length) {
    const n = e.childNodes[e.childNodes.length - 1];
    if (n.nodeName === "#text") {
      n.value += t;
      return;
    }
  }
  Fm(e, Hm(t));
};
Ce.insertTextBefore = function(e, t, n) {
  const o = e.childNodes[e.childNodes.indexOf(n) - 1];
  o && o.nodeName === "#text" ? o.value += t : LO(e, Hm(t), n);
};
Ce.adoptAttributes = function(e, t) {
  const n = [];
  for (let o = 0; o < e.attrs.length; o++)
    n.push(e.attrs[o].name);
  for (let o = 0; o < t.length; o++)
    n.indexOf(t[o].name) === -1 && e.attrs.push(t[o]);
};
Ce.getFirstChild = function(e) {
  return e.childNodes[0];
};
Ce.getChildNodes = function(e) {
  return e.childNodes;
};
Ce.getParentNode = function(e) {
  return e.parentNode;
};
Ce.getAttrList = function(e) {
  return e.attrs;
};
Ce.getTagName = function(e) {
  return e.tagName;
};
Ce.getNamespaceURI = function(e) {
  return e.namespaceURI;
};
Ce.getTextNodeContent = function(e) {
  return e.value;
};
Ce.getCommentNodeContent = function(e) {
  return e.data;
};
Ce.getDocumentTypeNodeName = function(e) {
  return e.name;
};
Ce.getDocumentTypeNodePublicId = function(e) {
  return e.publicId;
};
Ce.getDocumentTypeNodeSystemId = function(e) {
  return e.systemId;
};
Ce.isTextNode = function(e) {
  return e.nodeName === "#text";
};
Ce.isCommentNode = function(e) {
  return e.nodeName === "#comment";
};
Ce.isDocumentTypeNode = function(e) {
  return e.nodeName === "#documentType";
};
Ce.isElementNode = function(e) {
  return !!e.tagName;
};
Ce.setNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = t;
};
Ce.getNodeSourceCodeLocation = function(e) {
  return e.sourceCodeLocation;
};
Ce.updateNodeSourceCodeLocation = function(e, t) {
  e.sourceCodeLocation = Object.assign(e.sourceCodeLocation, t);
};
var OO = function(e, t) {
  return t = t || /* @__PURE__ */ Object.create(null), [e, t].reduce((n, o) => (Object.keys(o).forEach((i) => {
    n[i] = o[i];
  }), n), /* @__PURE__ */ Object.create(null));
}, ha = {};
const { DOCUMENT_MODE: xo } = tn, Rm = "html", NO = "about:legacy-compat", PO = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", Bm = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], HO = Bm.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]), FO = ["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"], Vm = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], RO = Vm.concat([
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
]);
function Kc(e) {
  const t = e.indexOf('"') !== -1 ? "'" : '"';
  return t + e + t;
}
function Zc(e, t) {
  for (let n = 0; n < t.length; n++)
    if (e.indexOf(t[n]) === 0)
      return !0;
  return !1;
}
ha.isConforming = function(e) {
  return e.name === Rm && e.publicId === null && (e.systemId === null || e.systemId === NO);
};
ha.getDocumentMode = function(e) {
  if (e.name !== Rm)
    return xo.QUIRKS;
  const t = e.systemId;
  if (t && t.toLowerCase() === PO)
    return xo.QUIRKS;
  let n = e.publicId;
  if (n !== null) {
    if (n = n.toLowerCase(), FO.indexOf(n) > -1)
      return xo.QUIRKS;
    let o = t === null ? HO : Bm;
    if (Zc(n, o))
      return xo.QUIRKS;
    if (o = t === null ? Vm : RO, Zc(n, o))
      return xo.LIMITED_QUIRKS;
  }
  return xo.NO_QUIRKS;
};
ha.serializeContent = function(e, t, n) {
  let o = "!DOCTYPE ";
  return e && (o += e), t ? o += " PUBLIC " + Kc(t) : n && (o += " SYSTEM"), n !== null && (o += " " + Kc(n)), o;
};
var ro = {};
const gl = ca, Y1 = tn, ce = Y1.TAG_NAMES, tt = Y1.NAMESPACES, ms = Y1.ATTRS, xc = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, BO = "definitionurl", VO = "definitionURL", jO = {
  attributename: "attributeName",
  attributetype: "attributeType",
  basefrequency: "baseFrequency",
  baseprofile: "baseProfile",
  calcmode: "calcMode",
  clippathunits: "clipPathUnits",
  diffuseconstant: "diffuseConstant",
  edgemode: "edgeMode",
  filterunits: "filterUnits",
  glyphref: "glyphRef",
  gradienttransform: "gradientTransform",
  gradientunits: "gradientUnits",
  kernelmatrix: "kernelMatrix",
  kernelunitlength: "kernelUnitLength",
  keypoints: "keyPoints",
  keysplines: "keySplines",
  keytimes: "keyTimes",
  lengthadjust: "lengthAdjust",
  limitingconeangle: "limitingConeAngle",
  markerheight: "markerHeight",
  markerunits: "markerUnits",
  markerwidth: "markerWidth",
  maskcontentunits: "maskContentUnits",
  maskunits: "maskUnits",
  numoctaves: "numOctaves",
  pathlength: "pathLength",
  patterncontentunits: "patternContentUnits",
  patterntransform: "patternTransform",
  patternunits: "patternUnits",
  pointsatx: "pointsAtX",
  pointsaty: "pointsAtY",
  pointsatz: "pointsAtZ",
  preservealpha: "preserveAlpha",
  preserveaspectratio: "preserveAspectRatio",
  primitiveunits: "primitiveUnits",
  refx: "refX",
  refy: "refY",
  repeatcount: "repeatCount",
  repeatdur: "repeatDur",
  requiredextensions: "requiredExtensions",
  requiredfeatures: "requiredFeatures",
  specularconstant: "specularConstant",
  specularexponent: "specularExponent",
  spreadmethod: "spreadMethod",
  startoffset: "startOffset",
  stddeviation: "stdDeviation",
  stitchtiles: "stitchTiles",
  surfacescale: "surfaceScale",
  systemlanguage: "systemLanguage",
  tablevalues: "tableValues",
  targetx: "targetX",
  targety: "targetY",
  textlength: "textLength",
  viewbox: "viewBox",
  viewtarget: "viewTarget",
  xchannelselector: "xChannelSelector",
  ychannelselector: "yChannelSelector",
  zoomandpan: "zoomAndPan"
}, UO = {
  "xlink:actuate": { prefix: "xlink", name: "actuate", namespace: tt.XLINK },
  "xlink:arcrole": { prefix: "xlink", name: "arcrole", namespace: tt.XLINK },
  "xlink:href": { prefix: "xlink", name: "href", namespace: tt.XLINK },
  "xlink:role": { prefix: "xlink", name: "role", namespace: tt.XLINK },
  "xlink:show": { prefix: "xlink", name: "show", namespace: tt.XLINK },
  "xlink:title": { prefix: "xlink", name: "title", namespace: tt.XLINK },
  "xlink:type": { prefix: "xlink", name: "type", namespace: tt.XLINK },
  "xml:base": { prefix: "xml", name: "base", namespace: tt.XML },
  "xml:lang": { prefix: "xml", name: "lang", namespace: tt.XML },
  "xml:space": { prefix: "xml", name: "space", namespace: tt.XML },
  xmlns: { prefix: "", name: "xmlns", namespace: tt.XMLNS },
  "xmlns:xlink": { prefix: "xmlns", name: "xlink", namespace: tt.XMLNS }
}, GO = ro.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
  altglyph: "altGlyph",
  altglyphdef: "altGlyphDef",
  altglyphitem: "altGlyphItem",
  animatecolor: "animateColor",
  animatemotion: "animateMotion",
  animatetransform: "animateTransform",
  clippath: "clipPath",
  feblend: "feBlend",
  fecolormatrix: "feColorMatrix",
  fecomponenttransfer: "feComponentTransfer",
  fecomposite: "feComposite",
  feconvolvematrix: "feConvolveMatrix",
  fediffuselighting: "feDiffuseLighting",
  fedisplacementmap: "feDisplacementMap",
  fedistantlight: "feDistantLight",
  feflood: "feFlood",
  fefunca: "feFuncA",
  fefuncb: "feFuncB",
  fefuncg: "feFuncG",
  fefuncr: "feFuncR",
  fegaussianblur: "feGaussianBlur",
  feimage: "feImage",
  femerge: "feMerge",
  femergenode: "feMergeNode",
  femorphology: "feMorphology",
  feoffset: "feOffset",
  fepointlight: "fePointLight",
  fespecularlighting: "feSpecularLighting",
  fespotlight: "feSpotLight",
  fetile: "feTile",
  feturbulence: "feTurbulence",
  foreignobject: "foreignObject",
  glyphref: "glyphRef",
  lineargradient: "linearGradient",
  radialgradient: "radialGradient",
  textpath: "textPath"
}, zO = {
  [ce.B]: !0,
  [ce.BIG]: !0,
  [ce.BLOCKQUOTE]: !0,
  [ce.BODY]: !0,
  [ce.BR]: !0,
  [ce.CENTER]: !0,
  [ce.CODE]: !0,
  [ce.DD]: !0,
  [ce.DIV]: !0,
  [ce.DL]: !0,
  [ce.DT]: !0,
  [ce.EM]: !0,
  [ce.EMBED]: !0,
  [ce.H1]: !0,
  [ce.H2]: !0,
  [ce.H3]: !0,
  [ce.H4]: !0,
  [ce.H5]: !0,
  [ce.H6]: !0,
  [ce.HEAD]: !0,
  [ce.HR]: !0,
  [ce.I]: !0,
  [ce.IMG]: !0,
  [ce.LI]: !0,
  [ce.LISTING]: !0,
  [ce.MENU]: !0,
  [ce.META]: !0,
  [ce.NOBR]: !0,
  [ce.OL]: !0,
  [ce.P]: !0,
  [ce.PRE]: !0,
  [ce.RUBY]: !0,
  [ce.S]: !0,
  [ce.SMALL]: !0,
  [ce.SPAN]: !0,
  [ce.STRONG]: !0,
  [ce.STRIKE]: !0,
  [ce.SUB]: !0,
  [ce.SUP]: !0,
  [ce.TABLE]: !0,
  [ce.TT]: !0,
  [ce.U]: !0,
  [ce.UL]: !0,
  [ce.VAR]: !0
};
ro.causesExit = function(e) {
  const t = e.tagName;
  return t === ce.FONT && (gl.getTokenAttr(e, ms.COLOR) !== null || gl.getTokenAttr(e, ms.SIZE) !== null || gl.getTokenAttr(e, ms.FACE) !== null) ? !0 : zO[t];
};
ro.adjustTokenMathMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === BO) {
      e.attrs[t].name = VO;
      break;
    }
};
ro.adjustTokenSVGAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = jO[e.attrs[t].name];
    n && (e.attrs[t].name = n);
  }
};
ro.adjustTokenXMLAttrs = function(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const n = UO[e.attrs[t].name];
    n && (e.attrs[t].prefix = n.prefix, e.attrs[t].name = n.name, e.attrs[t].namespace = n.namespace);
  }
};
ro.adjustTokenSVGTagName = function(e) {
  const t = GO[e.tagName];
  t && (e.tagName = t);
};
function KO(e, t) {
  return t === tt.MATHML && (e === ce.MI || e === ce.MO || e === ce.MN || e === ce.MS || e === ce.MTEXT);
}
function ZO(e, t, n) {
  if (t === tt.MATHML && e === ce.ANNOTATION_XML) {
    for (let o = 0; o < n.length; o++)
      if (n[o].name === ms.ENCODING) {
        const i = n[o].value.toLowerCase();
        return i === xc.TEXT_HTML || i === xc.APPLICATION_XML;
      }
  }
  return t === tt.SVG && (e === ce.FOREIGN_OBJECT || e === ce.DESC || e === ce.TITLE);
}
ro.isIntegrationPoint = function(e, t, n, o) {
  return !!((!o || o === tt.HTML) && ZO(e, t, n) || (!o || o === tt.MATHML) && KO(e, t));
};
const R = ca, xO = eO, Wc = tO, WO = mO, qO = IO, qc = Nn, YO = Ce, XO = OO, Yc = ha, dn = ro, lt = x1, QO = en, Ro = tn, f = Ro.TAG_NAMES, le = Ro.NAMESPACES, jm = Ro.ATTRS, JO = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  onParseError: null,
  treeAdapter: YO
}, Um = "hidden", eN = 8, tN = 3, Gm = "INITIAL_MODE", X1 = "BEFORE_HTML_MODE", ma = "BEFORE_HEAD_MODE", Sr = "IN_HEAD_MODE", zm = "IN_HEAD_NO_SCRIPT_MODE", pa = "AFTER_HEAD_MODE", hn = "IN_BODY_MODE", Rs = "TEXT_MODE", it = "IN_TABLE_MODE", Km = "IN_TABLE_TEXT_MODE", fa = "IN_CAPTION_MODE", Di = "IN_COLUMN_GROUP_MODE", Ut = "IN_TABLE_BODY_MODE", Dn = "IN_ROW_MODE", ga = "IN_CELL_MODE", Q1 = "IN_SELECT_MODE", J1 = "IN_SELECT_IN_TABLE_MODE", Bs = "IN_TEMPLATE_MODE", eu = "AFTER_BODY_MODE", va = "IN_FRAMESET_MODE", Zm = "AFTER_FRAMESET_MODE", xm = "AFTER_AFTER_BODY_MODE", Wm = "AFTER_AFTER_FRAMESET_MODE", nN = {
  [f.TR]: Dn,
  [f.TBODY]: Ut,
  [f.THEAD]: Ut,
  [f.TFOOT]: Ut,
  [f.CAPTION]: fa,
  [f.COLGROUP]: Di,
  [f.TABLE]: it,
  [f.BODY]: hn,
  [f.FRAMESET]: va
}, oN = {
  [f.CAPTION]: it,
  [f.COLGROUP]: it,
  [f.TBODY]: it,
  [f.TFOOT]: it,
  [f.THEAD]: it,
  [f.COL]: Di,
  [f.TR]: Ut,
  [f.TD]: Dn,
  [f.TH]: Dn
}, Xc = {
  [Gm]: {
    [R.CHARACTER_TOKEN]: Kr,
    [R.NULL_CHARACTER_TOKEN]: Kr,
    [R.WHITESPACE_CHARACTER_TOKEN]: ye,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: mN,
    [R.START_TAG_TOKEN]: Kr,
    [R.END_TAG_TOKEN]: Kr,
    [R.EOF_TOKEN]: Kr
  },
  [X1]: {
    [R.CHARACTER_TOKEN]: ui,
    [R.NULL_CHARACTER_TOKEN]: ui,
    [R.WHITESPACE_CHARACTER_TOKEN]: ye,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: pN,
    [R.END_TAG_TOKEN]: fN,
    [R.EOF_TOKEN]: ui
  },
  [ma]: {
    [R.CHARACTER_TOKEN]: di,
    [R.NULL_CHARACTER_TOKEN]: di,
    [R.WHITESPACE_CHARACTER_TOKEN]: ye,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: os,
    [R.START_TAG_TOKEN]: gN,
    [R.END_TAG_TOKEN]: vN,
    [R.EOF_TOKEN]: di
  },
  [Sr]: {
    [R.CHARACTER_TOKEN]: ci,
    [R.NULL_CHARACTER_TOKEN]: ci,
    [R.WHITESPACE_CHARACTER_TOKEN]: ft,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: os,
    [R.START_TAG_TOKEN]: Qe,
    [R.END_TAG_TOKEN]: Bo,
    [R.EOF_TOKEN]: ci
  },
  [zm]: {
    [R.CHARACTER_TOKEN]: hi,
    [R.NULL_CHARACTER_TOKEN]: hi,
    [R.WHITESPACE_CHARACTER_TOKEN]: ft,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: os,
    [R.START_TAG_TOKEN]: bN,
    [R.END_TAG_TOKEN]: yN,
    [R.EOF_TOKEN]: hi
  },
  [pa]: {
    [R.CHARACTER_TOKEN]: mi,
    [R.NULL_CHARACTER_TOKEN]: mi,
    [R.WHITESPACE_CHARACTER_TOKEN]: ft,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: os,
    [R.START_TAG_TOKEN]: _N,
    [R.END_TAG_TOKEN]: CN,
    [R.EOF_TOKEN]: mi
  },
  [hn]: {
    [R.CHARACTER_TOKEN]: rs,
    [R.NULL_CHARACTER_TOKEN]: ye,
    [R.WHITESPACE_CHARACTER_TOKEN]: co,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: kt,
    [R.END_TAG_TOKEN]: tu,
    [R.EOF_TOKEN]: yn
  },
  [Rs]: {
    [R.CHARACTER_TOKEN]: ft,
    [R.NULL_CHARACTER_TOKEN]: ft,
    [R.WHITESPACE_CHARACTER_TOKEN]: ft,
    [R.COMMENT_TOKEN]: ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: ye,
    [R.END_TAG_TOKEN]: QN,
    [R.EOF_TOKEN]: JN
  },
  [it]: {
    [R.CHARACTER_TOKEN]: _n,
    [R.NULL_CHARACTER_TOKEN]: _n,
    [R.WHITESPACE_CHARACTER_TOKEN]: _n,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: nu,
    [R.END_TAG_TOKEN]: ou,
    [R.EOF_TOKEN]: yn
  },
  [Km]: {
    [R.CHARACTER_TOKEN]: uP,
    [R.NULL_CHARACTER_TOKEN]: ye,
    [R.WHITESPACE_CHARACTER_TOKEN]: lP,
    [R.COMMENT_TOKEN]: Zr,
    [R.DOCTYPE_TOKEN]: Zr,
    [R.START_TAG_TOKEN]: Zr,
    [R.END_TAG_TOKEN]: Zr,
    [R.EOF_TOKEN]: Zr
  },
  [fa]: {
    [R.CHARACTER_TOKEN]: rs,
    [R.NULL_CHARACTER_TOKEN]: ye,
    [R.WHITESPACE_CHARACTER_TOKEN]: co,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: dP,
    [R.END_TAG_TOKEN]: cP,
    [R.EOF_TOKEN]: yn
  },
  [Di]: {
    [R.CHARACTER_TOKEN]: Vs,
    [R.NULL_CHARACTER_TOKEN]: Vs,
    [R.WHITESPACE_CHARACTER_TOKEN]: ft,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: hP,
    [R.END_TAG_TOKEN]: mP,
    [R.EOF_TOKEN]: yn
  },
  [Ut]: {
    [R.CHARACTER_TOKEN]: _n,
    [R.NULL_CHARACTER_TOKEN]: _n,
    [R.WHITESPACE_CHARACTER_TOKEN]: _n,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: pP,
    [R.END_TAG_TOKEN]: fP,
    [R.EOF_TOKEN]: yn
  },
  [Dn]: {
    [R.CHARACTER_TOKEN]: _n,
    [R.NULL_CHARACTER_TOKEN]: _n,
    [R.WHITESPACE_CHARACTER_TOKEN]: _n,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: gP,
    [R.END_TAG_TOKEN]: vP,
    [R.EOF_TOKEN]: yn
  },
  [ga]: {
    [R.CHARACTER_TOKEN]: rs,
    [R.NULL_CHARACTER_TOKEN]: ye,
    [R.WHITESPACE_CHARACTER_TOKEN]: co,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: bP,
    [R.END_TAG_TOKEN]: yP,
    [R.EOF_TOKEN]: yn
  },
  [Q1]: {
    [R.CHARACTER_TOKEN]: ft,
    [R.NULL_CHARACTER_TOKEN]: ye,
    [R.WHITESPACE_CHARACTER_TOKEN]: ft,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: qm,
    [R.END_TAG_TOKEN]: Ym,
    [R.EOF_TOKEN]: yn
  },
  [J1]: {
    [R.CHARACTER_TOKEN]: ft,
    [R.NULL_CHARACTER_TOKEN]: ye,
    [R.WHITESPACE_CHARACTER_TOKEN]: ft,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: _P,
    [R.END_TAG_TOKEN]: CP,
    [R.EOF_TOKEN]: yn
  },
  [Bs]: {
    [R.CHARACTER_TOKEN]: rs,
    [R.NULL_CHARACTER_TOKEN]: ye,
    [R.WHITESPACE_CHARACTER_TOKEN]: co,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: wP,
    [R.END_TAG_TOKEN]: TP,
    [R.EOF_TOKEN]: Xm
  },
  [eu]: {
    [R.CHARACTER_TOKEN]: js,
    [R.NULL_CHARACTER_TOKEN]: js,
    [R.WHITESPACE_CHARACTER_TOKEN]: co,
    [R.COMMENT_TOKEN]: hN,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: kP,
    [R.END_TAG_TOKEN]: EP,
    [R.EOF_TOKEN]: zr
  },
  [va]: {
    [R.CHARACTER_TOKEN]: ye,
    [R.NULL_CHARACTER_TOKEN]: ye,
    [R.WHITESPACE_CHARACTER_TOKEN]: ft,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: SP,
    [R.END_TAG_TOKEN]: MP,
    [R.EOF_TOKEN]: zr
  },
  [Zm]: {
    [R.CHARACTER_TOKEN]: ye,
    [R.NULL_CHARACTER_TOKEN]: ye,
    [R.WHITESPACE_CHARACTER_TOKEN]: ft,
    [R.COMMENT_TOKEN]: Ye,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: AP,
    [R.END_TAG_TOKEN]: $P,
    [R.EOF_TOKEN]: zr
  },
  [xm]: {
    [R.CHARACTER_TOKEN]: ps,
    [R.NULL_CHARACTER_TOKEN]: ps,
    [R.WHITESPACE_CHARACTER_TOKEN]: co,
    [R.COMMENT_TOKEN]: Qc,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: IP,
    [R.END_TAG_TOKEN]: ps,
    [R.EOF_TOKEN]: zr
  },
  [Wm]: {
    [R.CHARACTER_TOKEN]: ye,
    [R.NULL_CHARACTER_TOKEN]: ye,
    [R.WHITESPACE_CHARACTER_TOKEN]: co,
    [R.COMMENT_TOKEN]: Qc,
    [R.DOCTYPE_TOKEN]: ye,
    [R.START_TAG_TOKEN]: DP,
    [R.END_TAG_TOKEN]: ye,
    [R.EOF_TOKEN]: zr
  }
};
class rN {
  constructor(t) {
    this.options = XO(JO, t), this.treeAdapter = this.options.treeAdapter, this.pendingScript = null, this.options.sourceCodeLocationInfo && qc.install(this, WO), this.options.onParseError && qc.install(this, qO, { onParseError: this.options.onParseError });
  }
  // API
  parse(t) {
    const n = this.treeAdapter.createDocument();
    return this._bootstrap(n, null), this.tokenizer.write(t, !0), this._runParsingLoop(null), n;
  }
  parseFragment(t, n) {
    n || (n = this.treeAdapter.createElement(f.TEMPLATE, le.HTML, []));
    const o = this.treeAdapter.createElement("documentmock", le.HTML, []);
    this._bootstrap(o, n), this.treeAdapter.getTagName(n) === f.TEMPLATE && this._pushTmplInsertionMode(Bs), this._initTokenizerForFragmentParsing(), this._insertFakeRootElement(), this._resetInsertionMode(), this._findFormInFragmentContext(), this.tokenizer.write(t, !0), this._runParsingLoop(null);
    const i = this.treeAdapter.getFirstChild(o), r = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(i, r), r;
  }
  //Bootstrap parser
  _bootstrap(t, n) {
    this.tokenizer = new R(this.options), this.stopped = !1, this.insertionMode = Gm, this.originalInsertionMode = "", this.document = t, this.fragmentContext = n, this.headElement = null, this.formElement = null, this.openElements = new xO(this.document, this.treeAdapter), this.activeFormattingElements = new Wc(this.treeAdapter), this.tmplInsertionModeStack = [], this.tmplInsertionModeStackTop = -1, this.currentTmplInsertionMode = null, this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1;
  }
  //Errors
  _err() {
  }
  //Parsing loop
  _runParsingLoop(t) {
    for (; !this.stopped; ) {
      this._setupTokenizerCDATAMode();
      const n = this.tokenizer.getNextToken();
      if (n.type === R.HIBERNATION_TOKEN)
        break;
      if (this.skipNextNewLine && (this.skipNextNewLine = !1, n.type === R.WHITESPACE_CHARACTER_TOKEN && n.chars[0] === `
`)) {
        if (n.chars.length === 1)
          continue;
        n.chars = n.chars.substr(1);
      }
      if (this._processInputToken(n), t && this.pendingScript)
        break;
    }
  }
  runParsingLoopForCurrentChunk(t, n) {
    if (this._runParsingLoop(n), n && this.pendingScript) {
      const o = this.pendingScript;
      this.pendingScript = null, n(o);
      return;
    }
    t && t();
  }
  //Text parsing
  _setupTokenizerCDATAMode() {
    const t = this._getAdjustedCurrentElement();
    this.tokenizer.allowCDATA = t && t !== this.document && this.treeAdapter.getNamespaceURI(t) !== le.HTML && !this._isIntegrationPoint(t);
  }
  _switchToTextParsing(t, n) {
    this._insertElement(t, le.HTML), this.tokenizer.state = n, this.originalInsertionMode = this.insertionMode, this.insertionMode = Rs;
  }
  switchToPlaintextParsing() {
    this.insertionMode = Rs, this.originalInsertionMode = hn, this.tokenizer.state = R.MODE.PLAINTEXT;
  }
  //Fragment parsing
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    do {
      if (this.treeAdapter.getTagName(t) === f.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    } while (t);
  }
  _initTokenizerForFragmentParsing() {
    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === le.HTML) {
      const t = this.treeAdapter.getTagName(this.fragmentContext);
      t === f.TITLE || t === f.TEXTAREA ? this.tokenizer.state = R.MODE.RCDATA : t === f.STYLE || t === f.XMP || t === f.IFRAME || t === f.NOEMBED || t === f.NOFRAMES || t === f.NOSCRIPT ? this.tokenizer.state = R.MODE.RAWTEXT : t === f.SCRIPT ? this.tokenizer.state = R.MODE.SCRIPT_DATA : t === f.PLAINTEXT && (this.tokenizer.state = R.MODE.PLAINTEXT);
    }
  }
  //Tree mutation
  _setDocumentType(t) {
    const n = t.name || "", o = t.publicId || "", i = t.systemId || "";
    this.treeAdapter.setDocumentType(this.document, n, o, i);
  }
  _attachElementToTree(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.appendChild(n, t);
    }
  }
  _appendElement(t, n) {
    const o = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(o);
  }
  _insertElement(t, n) {
    const o = this.treeAdapter.createElement(t.tagName, n, t.attrs);
    this._attachElementToTree(o), this.openElements.push(o);
  }
  _insertFakeElement(t) {
    const n = this.treeAdapter.createElement(t, le.HTML, []);
    this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertTemplate(t) {
    const n = this.treeAdapter.createElement(t.tagName, le.HTML, t.attrs), o = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(n, o), this._attachElementToTree(n), this.openElements.push(n);
  }
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(f.HTML, le.HTML, []);
    this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t);
  }
  _appendCommentNode(t, n) {
    const o = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(n, o);
  }
  _insertCharacters(t) {
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentText(t.chars);
    else {
      const n = this.openElements.currentTmplContent || this.openElements.current;
      this.treeAdapter.insertText(n, t.chars);
    }
  }
  _adoptNodes(t, n) {
    for (let o = this.treeAdapter.getFirstChild(t); o; o = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(o), this.treeAdapter.appendChild(n, o);
  }
  //Token processing
  _shouldProcessTokenInForeignContent(t) {
    const n = this._getAdjustedCurrentElement();
    if (!n || n === this.document)
      return !1;
    const o = this.treeAdapter.getNamespaceURI(n);
    if (o === le.HTML || this.treeAdapter.getTagName(n) === f.ANNOTATION_XML && o === le.MATHML && t.type === R.START_TAG_TOKEN && t.tagName === f.SVG)
      return !1;
    const i = t.type === R.CHARACTER_TOKEN || t.type === R.NULL_CHARACTER_TOKEN || t.type === R.WHITESPACE_CHARACTER_TOKEN;
    return (t.type === R.START_TAG_TOKEN && t.tagName !== f.MGLYPH && t.tagName !== f.MALIGNMARK || i) && this._isIntegrationPoint(n, le.MATHML) || (t.type === R.START_TAG_TOKEN || i) && this._isIntegrationPoint(n, le.HTML) ? !1 : t.type !== R.EOF_TOKEN;
  }
  _processToken(t) {
    Xc[this.insertionMode][t.type](this, t);
  }
  _processTokenInBodyMode(t) {
    Xc[hn][t.type](this, t);
  }
  _processTokenInForeignContent(t) {
    t.type === R.CHARACTER_TOKEN ? OP(this, t) : t.type === R.NULL_CHARACTER_TOKEN ? LP(this, t) : t.type === R.WHITESPACE_CHARACTER_TOKEN ? ft(this, t) : t.type === R.COMMENT_TOKEN ? Ye(this, t) : t.type === R.START_TAG_TOKEN ? NP(this, t) : t.type === R.END_TAG_TOKEN && PP(this, t);
  }
  _processInputToken(t) {
    this._shouldProcessTokenInForeignContent(t) ? this._processTokenInForeignContent(t) : this._processToken(t), t.type === R.START_TAG_TOKEN && t.selfClosing && !t.ackSelfClosing && this._err(lt.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  //Integration points
  _isIntegrationPoint(t, n) {
    const o = this.treeAdapter.getTagName(t), i = this.treeAdapter.getNamespaceURI(t), r = this.treeAdapter.getAttrList(t);
    return dn.isIntegrationPoint(o, i, r, n);
  }
  //Active formatting elements reconstruction
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.length;
    if (t) {
      let n = t, o = null;
      do
        if (n--, o = this.activeFormattingElements.entries[n], o.type === Wc.MARKER_ENTRY || this.openElements.contains(o.element)) {
          n++;
          break;
        }
      while (n > 0);
      for (let i = n; i < t; i++)
        o = this.activeFormattingElements.entries[i], this._insertElement(o.token, this.treeAdapter.getNamespaceURI(o.element)), o.element = this.openElements.current;
    }
  }
  //Close elements
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = Dn;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(f.P), this.openElements.popUntilTagNamePopped(f.P);
  }
  //Insertion modes
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop, n = !1; t >= 0; t--) {
      let o = this.openElements.items[t];
      t === 0 && (n = !0, this.fragmentContext && (o = this.fragmentContext));
      const i = this.treeAdapter.getTagName(o), r = nN[i];
      if (r) {
        this.insertionMode = r;
        break;
      } else if (!n && (i === f.TD || i === f.TH)) {
        this.insertionMode = ga;
        break;
      } else if (!n && i === f.HEAD) {
        this.insertionMode = Sr;
        break;
      } else if (i === f.SELECT) {
        this._resetInsertionModeForSelect(t);
        break;
      } else if (i === f.TEMPLATE) {
        this.insertionMode = this.currentTmplInsertionMode;
        break;
      } else if (i === f.HTML) {
        this.insertionMode = this.headElement ? pa : ma;
        break;
      } else if (n) {
        this.insertionMode = hn;
        break;
      }
    }
  }
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let n = t - 1; n > 0; n--) {
        const o = this.openElements.items[n], i = this.treeAdapter.getTagName(o);
        if (i === f.TEMPLATE)
          break;
        if (i === f.TABLE) {
          this.insertionMode = J1;
          return;
        }
      }
    this.insertionMode = Q1;
  }
  _pushTmplInsertionMode(t) {
    this.tmplInsertionModeStack.push(t), this.tmplInsertionModeStackTop++, this.currentTmplInsertionMode = t;
  }
  _popTmplInsertionMode() {
    this.tmplInsertionModeStack.pop(), this.tmplInsertionModeStackTop--, this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
  }
  //Foster parenting
  _isElementCausesFosterParenting(t) {
    const n = this.treeAdapter.getTagName(t);
    return n === f.TABLE || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR;
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
  }
  _findFosterParentingLocation() {
    const t = {
      parent: null,
      beforeElement: null
    };
    for (let n = this.openElements.stackTop; n >= 0; n--) {
      const o = this.openElements.items[n], i = this.treeAdapter.getTagName(o), r = this.treeAdapter.getNamespaceURI(o);
      if (i === f.TEMPLATE && r === le.HTML) {
        t.parent = this.treeAdapter.getTemplateContent(o);
        break;
      } else if (i === f.TABLE) {
        t.parent = this.treeAdapter.getParentNode(o), t.parent ? t.beforeElement = o : t.parent = this.openElements.items[n - 1];
        break;
      }
    }
    return t.parent || (t.parent = this.openElements.items[0]), t;
  }
  _fosterParentElement(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertBefore(n.parent, t, n.beforeElement) : this.treeAdapter.appendChild(n.parent, t);
  }
  _fosterParentText(t) {
    const n = this._findFosterParentingLocation();
    n.beforeElement ? this.treeAdapter.insertTextBefore(n.parent, t, n.beforeElement) : this.treeAdapter.insertText(n.parent, t);
  }
  //Special elements
  _isSpecialElement(t) {
    const n = this.treeAdapter.getTagName(t), o = this.treeAdapter.getNamespaceURI(t);
    return Ro.SPECIAL_ELEMENTS[o][n];
  }
}
var iN = rN;
function sN(e, t) {
  let n = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return n ? e.openElements.contains(n.element) ? e.openElements.hasInScope(t.tagName) || (n = null) : (e.activeFormattingElements.removeEntry(n), n = null) : qt(e, t), n;
}
function aN(e, t) {
  let n = null;
  for (let o = e.openElements.stackTop; o >= 0; o--) {
    const i = e.openElements.items[o];
    if (i === t.element)
      break;
    e._isSpecialElement(i) && (n = i);
  }
  return n || (e.openElements.popUntilElementPopped(t.element), e.activeFormattingElements.removeEntry(t)), n;
}
function lN(e, t, n) {
  let o = t, i = e.openElements.getCommonAncestor(t);
  for (let r = 0, a = i; a !== n; r++, a = i) {
    i = e.openElements.getCommonAncestor(a);
    const s = e.activeFormattingElements.getElementEntry(a), l = s && r >= tN;
    !s || l ? (l && e.activeFormattingElements.removeEntry(s), e.openElements.remove(a)) : (a = uN(e, s), o === t && (e.activeFormattingElements.bookmark = s), e.treeAdapter.detachNode(o), e.treeAdapter.appendChild(a, o), o = a);
  }
  return o;
}
function uN(e, t) {
  const n = e.treeAdapter.getNamespaceURI(t.element), o = e.treeAdapter.createElement(t.token.tagName, n, t.token.attrs);
  return e.openElements.replace(t.element, o), t.element = o, o;
}
function dN(e, t, n) {
  if (e._isElementCausesFosterParenting(t))
    e._fosterParentElement(n);
  else {
    const o = e.treeAdapter.getTagName(t), i = e.treeAdapter.getNamespaceURI(t);
    o === f.TEMPLATE && i === le.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, n);
  }
}
function cN(e, t, n) {
  const o = e.treeAdapter.getNamespaceURI(n.element), i = n.token, r = e.treeAdapter.createElement(i.tagName, o, i.attrs);
  e._adoptNodes(t, r), e.treeAdapter.appendChild(t, r), e.activeFormattingElements.insertElementAfterBookmark(r, n.token), e.activeFormattingElements.removeEntry(n), e.openElements.remove(n.element), e.openElements.insertAfter(t, r);
}
function Un(e, t) {
  let n;
  for (let o = 0; o < eN && (n = sN(e, t), !!n); o++) {
    const i = aN(e, n);
    if (!i)
      break;
    e.activeFormattingElements.bookmark = n;
    const r = lN(e, i, n.element), a = e.openElements.getCommonAncestor(n.element);
    e.treeAdapter.detachNode(r), dN(e, a, r), cN(e, i, n);
  }
}
function ye() {
}
function os(e) {
  e._err(lt.misplacedDoctype);
}
function Ye(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContent || e.openElements.current);
}
function hN(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function Qc(e, t) {
  e._appendCommentNode(t, e.document);
}
function ft(e, t) {
  e._insertCharacters(t);
}
function zr(e) {
  e.stopped = !0;
}
function mN(e, t) {
  e._setDocumentType(t);
  const n = t.forceQuirks ? Ro.DOCUMENT_MODE.QUIRKS : Yc.getDocumentMode(t);
  Yc.isConforming(t) || e._err(lt.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, n), e.insertionMode = X1;
}
function Kr(e, t) {
  e._err(lt.missingDoctype, { beforeToken: !0 }), e.treeAdapter.setDocumentMode(e.document, Ro.DOCUMENT_MODE.QUIRKS), e.insertionMode = X1, e._processToken(t);
}
function pN(e, t) {
  t.tagName === f.HTML ? (e._insertElement(t, le.HTML), e.insertionMode = ma) : ui(e, t);
}
function fN(e, t) {
  const n = t.tagName;
  (n === f.HTML || n === f.HEAD || n === f.BODY || n === f.BR) && ui(e, t);
}
function ui(e, t) {
  e._insertFakeRootElement(), e.insertionMode = ma, e._processToken(t);
}
function gN(e, t) {
  const n = t.tagName;
  n === f.HTML ? kt(e, t) : n === f.HEAD ? (e._insertElement(t, le.HTML), e.headElement = e.openElements.current, e.insertionMode = Sr) : di(e, t);
}
function vN(e, t) {
  const n = t.tagName;
  n === f.HEAD || n === f.BODY || n === f.HTML || n === f.BR ? di(e, t) : e._err(lt.endTagWithoutMatchingOpenElement);
}
function di(e, t) {
  e._insertFakeElement(f.HEAD), e.headElement = e.openElements.current, e.insertionMode = Sr, e._processToken(t);
}
function Qe(e, t) {
  const n = t.tagName;
  n === f.HTML ? kt(e, t) : n === f.BASE || n === f.BASEFONT || n === f.BGSOUND || n === f.LINK || n === f.META ? (e._appendElement(t, le.HTML), t.ackSelfClosing = !0) : n === f.TITLE ? e._switchToTextParsing(t, R.MODE.RCDATA) : n === f.NOSCRIPT ? e.options.scriptingEnabled ? e._switchToTextParsing(t, R.MODE.RAWTEXT) : (e._insertElement(t, le.HTML), e.insertionMode = zm) : n === f.NOFRAMES || n === f.STYLE ? e._switchToTextParsing(t, R.MODE.RAWTEXT) : n === f.SCRIPT ? e._switchToTextParsing(t, R.MODE.SCRIPT_DATA) : n === f.TEMPLATE ? (e._insertTemplate(t, le.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = Bs, e._pushTmplInsertionMode(Bs)) : n === f.HEAD ? e._err(lt.misplacedStartTagForHeadElement) : ci(e, t);
}
function Bo(e, t) {
  const n = t.tagName;
  n === f.HEAD ? (e.openElements.pop(), e.insertionMode = pa) : n === f.BODY || n === f.BR || n === f.HTML ? ci(e, t) : n === f.TEMPLATE && e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagName !== f.TEMPLATE && e._err(lt.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(f.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode()) : e._err(lt.endTagWithoutMatchingOpenElement);
}
function ci(e, t) {
  e.openElements.pop(), e.insertionMode = pa, e._processToken(t);
}
function bN(e, t) {
  const n = t.tagName;
  n === f.HTML ? kt(e, t) : n === f.BASEFONT || n === f.BGSOUND || n === f.HEAD || n === f.LINK || n === f.META || n === f.NOFRAMES || n === f.STYLE ? Qe(e, t) : n === f.NOSCRIPT ? e._err(lt.nestedNoscriptInHead) : hi(e, t);
}
function yN(e, t) {
  const n = t.tagName;
  n === f.NOSCRIPT ? (e.openElements.pop(), e.insertionMode = Sr) : n === f.BR ? hi(e, t) : e._err(lt.endTagWithoutMatchingOpenElement);
}
function hi(e, t) {
  const n = t.type === R.EOF_TOKEN ? lt.openElementsLeftAfterEof : lt.disallowedContentInNoscriptInHead;
  e._err(n), e.openElements.pop(), e.insertionMode = Sr, e._processToken(t);
}
function _N(e, t) {
  const n = t.tagName;
  n === f.HTML ? kt(e, t) : n === f.BODY ? (e._insertElement(t, le.HTML), e.framesetOk = !1, e.insertionMode = hn) : n === f.FRAMESET ? (e._insertElement(t, le.HTML), e.insertionMode = va) : n === f.BASE || n === f.BASEFONT || n === f.BGSOUND || n === f.LINK || n === f.META || n === f.NOFRAMES || n === f.SCRIPT || n === f.STYLE || n === f.TEMPLATE || n === f.TITLE ? (e._err(lt.abandonedHeadElementChild), e.openElements.push(e.headElement), Qe(e, t), e.openElements.remove(e.headElement)) : n === f.HEAD ? e._err(lt.misplacedStartTagForHeadElement) : mi(e, t);
}
function CN(e, t) {
  const n = t.tagName;
  n === f.BODY || n === f.HTML || n === f.BR ? mi(e, t) : n === f.TEMPLATE ? Bo(e, t) : e._err(lt.endTagWithoutMatchingOpenElement);
}
function mi(e, t) {
  e._insertFakeElement(f.BODY), e.insertionMode = hn, e._processToken(t);
}
function co(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function rs(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function wN(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function TN(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  n && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(n, t.attrs));
}
function kN(e, t) {
  const n = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && n && (e.treeAdapter.detachNode(n), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, le.HTML), e.insertionMode = va);
}
function bn(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, le.HTML);
}
function EN(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement();
  const n = e.openElements.currentTagName;
  (n === f.H1 || n === f.H2 || n === f.H3 || n === f.H4 || n === f.H5 || n === f.H6) && e.openElements.pop(), e._insertElement(t, le.HTML);
}
function Jc(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, le.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function SN(e, t) {
  const n = e.openElements.tmplCount > 0;
  (!e.formElement || n) && (e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, le.HTML), n || (e.formElement = e.openElements.current));
}
function MN(e, t) {
  e.framesetOk = !1;
  const n = t.tagName;
  for (let o = e.openElements.stackTop; o >= 0; o--) {
    const i = e.openElements.items[o], r = e.treeAdapter.getTagName(i);
    let a = null;
    if (n === f.LI && r === f.LI ? a = f.LI : (n === f.DD || n === f.DT) && (r === f.DD || r === f.DT) && (a = r), a) {
      e.openElements.generateImpliedEndTagsWithExclusion(a), e.openElements.popUntilTagNamePopped(a);
      break;
    }
    if (r !== f.ADDRESS && r !== f.DIV && r !== f.P && e._isSpecialElement(i))
      break;
  }
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, le.HTML);
}
function AN(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, le.HTML), e.tokenizer.state = R.MODE.PLAINTEXT;
}
function $N(e, t) {
  e.openElements.hasInScope(f.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, le.HTML), e.framesetOk = !1;
}
function IN(e, t) {
  const n = e.activeFormattingElements.getElementEntryInScopeWithTagName(f.A);
  n && (Un(e, t), e.openElements.remove(n.element), e.activeFormattingElements.removeEntry(n)), e._reconstructActiveFormattingElements(), e._insertElement(t, le.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function Wo(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, le.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function DN(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(f.NOBR) && (Un(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, le.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function eh(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, le.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function LN(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== Ro.DOCUMENT_MODE.QUIRKS && e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, le.HTML), e.framesetOk = !1, e.insertionMode = it;
}
function Jo(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, le.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function ON(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, le.HTML);
  const n = R.getTokenAttr(t, jm.TYPE);
  (!n || n.toLowerCase() !== Um) && (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function th(e, t) {
  e._appendElement(t, le.HTML), t.ackSelfClosing = !0;
}
function NN(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._appendElement(t, le.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function PN(e, t) {
  t.tagName = f.IMG, Jo(e, t);
}
function HN(e, t) {
  e._insertElement(t, le.HTML), e.skipNextNewLine = !0, e.tokenizer.state = R.MODE.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = Rs;
}
function FN(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, R.MODE.RAWTEXT);
}
function RN(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, R.MODE.RAWTEXT);
}
function nh(e, t) {
  e._switchToTextParsing(t, R.MODE.RAWTEXT);
}
function BN(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, le.HTML), e.framesetOk = !1, e.insertionMode === it || e.insertionMode === fa || e.insertionMode === Ut || e.insertionMode === Dn || e.insertionMode === ga ? e.insertionMode = J1 : e.insertionMode = Q1;
}
function oh(e, t) {
  e.openElements.currentTagName === f.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, le.HTML);
}
function rh(e, t) {
  e.openElements.hasInScope(f.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, le.HTML);
}
function VN(e, t) {
  e.openElements.hasInScope(f.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(f.RTC), e._insertElement(t, le.HTML);
}
function jN(e, t) {
  e.openElements.hasInButtonScope(f.P) && e._closePElement(), e._insertElement(t, le.HTML);
}
function UN(e, t) {
  e._reconstructActiveFormattingElements(), dn.adjustTokenMathMLAttrs(t), dn.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, le.MATHML) : e._insertElement(t, le.MATHML), t.ackSelfClosing = !0;
}
function GN(e, t) {
  e._reconstructActiveFormattingElements(), dn.adjustTokenSVGAttrs(t), dn.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, le.SVG) : e._insertElement(t, le.SVG), t.ackSelfClosing = !0;
}
function Pt(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, le.HTML);
}
function kt(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 1:
      n === f.I || n === f.S || n === f.B || n === f.U ? Wo(e, t) : n === f.P ? bn(e, t) : n === f.A ? IN(e, t) : Pt(e, t);
      break;
    case 2:
      n === f.DL || n === f.OL || n === f.UL ? bn(e, t) : n === f.H1 || n === f.H2 || n === f.H3 || n === f.H4 || n === f.H5 || n === f.H6 ? EN(e, t) : n === f.LI || n === f.DD || n === f.DT ? MN(e, t) : n === f.EM || n === f.TT ? Wo(e, t) : n === f.BR ? Jo(e, t) : n === f.HR ? NN(e, t) : n === f.RB ? rh(e, t) : n === f.RT || n === f.RP ? VN(e, t) : n !== f.TH && n !== f.TD && n !== f.TR && Pt(e, t);
      break;
    case 3:
      n === f.DIV || n === f.DIR || n === f.NAV ? bn(e, t) : n === f.PRE ? Jc(e, t) : n === f.BIG ? Wo(e, t) : n === f.IMG || n === f.WBR ? Jo(e, t) : n === f.XMP ? FN(e, t) : n === f.SVG ? GN(e, t) : n === f.RTC ? rh(e, t) : n !== f.COL && Pt(e, t);
      break;
    case 4:
      n === f.HTML ? wN(e, t) : n === f.BASE || n === f.LINK || n === f.META ? Qe(e, t) : n === f.BODY ? TN(e, t) : n === f.MAIN || n === f.MENU ? bn(e, t) : n === f.FORM ? SN(e, t) : n === f.CODE || n === f.FONT ? Wo(e, t) : n === f.NOBR ? DN(e, t) : n === f.AREA ? Jo(e, t) : n === f.MATH ? UN(e, t) : n === f.MENU ? jN(e, t) : n !== f.HEAD && Pt(e, t);
      break;
    case 5:
      n === f.STYLE || n === f.TITLE ? Qe(e, t) : n === f.ASIDE ? bn(e, t) : n === f.SMALL ? Wo(e, t) : n === f.TABLE ? LN(e, t) : n === f.EMBED ? Jo(e, t) : n === f.INPUT ? ON(e, t) : n === f.PARAM || n === f.TRACK ? th(e, t) : n === f.IMAGE ? PN(e, t) : n !== f.FRAME && n !== f.TBODY && n !== f.TFOOT && n !== f.THEAD && Pt(e, t);
      break;
    case 6:
      n === f.SCRIPT ? Qe(e, t) : n === f.CENTER || n === f.FIGURE || n === f.FOOTER || n === f.HEADER || n === f.HGROUP || n === f.DIALOG ? bn(e, t) : n === f.BUTTON ? $N(e, t) : n === f.STRIKE || n === f.STRONG ? Wo(e, t) : n === f.APPLET || n === f.OBJECT ? eh(e, t) : n === f.KEYGEN ? Jo(e, t) : n === f.SOURCE ? th(e, t) : n === f.IFRAME ? RN(e, t) : n === f.SELECT ? BN(e, t) : n === f.OPTION ? oh(e, t) : Pt(e, t);
      break;
    case 7:
      n === f.BGSOUND ? Qe(e, t) : n === f.DETAILS || n === f.ADDRESS || n === f.ARTICLE || n === f.SECTION || n === f.SUMMARY ? bn(e, t) : n === f.LISTING ? Jc(e, t) : n === f.MARQUEE ? eh(e, t) : n === f.NOEMBED ? nh(e, t) : n !== f.CAPTION && Pt(e, t);
      break;
    case 8:
      n === f.BASEFONT ? Qe(e, t) : n === f.FRAMESET ? kN(e, t) : n === f.FIELDSET ? bn(e, t) : n === f.TEXTAREA ? HN(e, t) : n === f.TEMPLATE ? Qe(e, t) : n === f.NOSCRIPT ? e.options.scriptingEnabled ? nh(e, t) : Pt(e, t) : n === f.OPTGROUP ? oh(e, t) : n !== f.COLGROUP && Pt(e, t);
      break;
    case 9:
      n === f.PLAINTEXT ? AN(e, t) : Pt(e, t);
      break;
    case 10:
      n === f.BLOCKQUOTE || n === f.FIGCAPTION ? bn(e, t) : Pt(e, t);
      break;
    default:
      Pt(e, t);
  }
}
function zN(e) {
  e.openElements.hasInScope(f.BODY) && (e.insertionMode = eu);
}
function KN(e, t) {
  e.openElements.hasInScope(f.BODY) && (e.insertionMode = eu, e._processToken(t));
}
function Rn(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n));
}
function ZN(e) {
  const t = e.openElements.tmplCount > 0, n = e.formElement;
  t || (e.formElement = null), (n || t) && e.openElements.hasInScope(f.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(f.FORM) : e.openElements.remove(n));
}
function xN(e) {
  e.openElements.hasInButtonScope(f.P) || e._insertFakeElement(f.P), e._closePElement();
}
function WN(e) {
  e.openElements.hasInListItemScope(f.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(f.LI), e.openElements.popUntilTagNamePopped(f.LI));
}
function qN(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n));
}
function YN(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function ih(e, t) {
  const n = t.tagName;
  e.openElements.hasInScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker());
}
function XN(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(f.BR), e.openElements.pop(), e.framesetOk = !1;
}
function qt(e, t) {
  const n = t.tagName;
  for (let o = e.openElements.stackTop; o > 0; o--) {
    const i = e.openElements.items[o];
    if (e.treeAdapter.getTagName(i) === n) {
      e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilElementPopped(i);
      break;
    }
    if (e._isSpecialElement(i))
      break;
  }
}
function tu(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 1:
      n === f.A || n === f.B || n === f.I || n === f.S || n === f.U ? Un(e, t) : n === f.P ? xN(e) : qt(e, t);
      break;
    case 2:
      n === f.DL || n === f.UL || n === f.OL ? Rn(e, t) : n === f.LI ? WN(e) : n === f.DD || n === f.DT ? qN(e, t) : n === f.H1 || n === f.H2 || n === f.H3 || n === f.H4 || n === f.H5 || n === f.H6 ? YN(e) : n === f.BR ? XN(e) : n === f.EM || n === f.TT ? Un(e, t) : qt(e, t);
      break;
    case 3:
      n === f.BIG ? Un(e, t) : n === f.DIR || n === f.DIV || n === f.NAV || n === f.PRE ? Rn(e, t) : qt(e, t);
      break;
    case 4:
      n === f.BODY ? zN(e) : n === f.HTML ? KN(e, t) : n === f.FORM ? ZN(e) : n === f.CODE || n === f.FONT || n === f.NOBR ? Un(e, t) : n === f.MAIN || n === f.MENU ? Rn(e, t) : qt(e, t);
      break;
    case 5:
      n === f.ASIDE ? Rn(e, t) : n === f.SMALL ? Un(e, t) : qt(e, t);
      break;
    case 6:
      n === f.CENTER || n === f.FIGURE || n === f.FOOTER || n === f.HEADER || n === f.HGROUP || n === f.DIALOG ? Rn(e, t) : n === f.APPLET || n === f.OBJECT ? ih(e, t) : n === f.STRIKE || n === f.STRONG ? Un(e, t) : qt(e, t);
      break;
    case 7:
      n === f.ADDRESS || n === f.ARTICLE || n === f.DETAILS || n === f.SECTION || n === f.SUMMARY || n === f.LISTING ? Rn(e, t) : n === f.MARQUEE ? ih(e, t) : qt(e, t);
      break;
    case 8:
      n === f.FIELDSET ? Rn(e, t) : n === f.TEMPLATE ? Bo(e, t) : qt(e, t);
      break;
    case 10:
      n === f.BLOCKQUOTE || n === f.FIGCAPTION ? Rn(e, t) : qt(e, t);
      break;
    default:
      qt(e, t);
  }
}
function yn(e, t) {
  e.tmplInsertionModeStackTop > -1 ? Xm(e, t) : e.stopped = !0;
}
function QN(e, t) {
  t.tagName === f.SCRIPT && (e.pendingScript = e.openElements.current), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function JN(e, t) {
  e._err(lt.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function _n(e, t) {
  const n = e.openElements.currentTagName;
  n === f.TABLE || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR ? (e.pendingCharacterTokens = [], e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = Km, e._processToken(t)) : Rt(e, t);
}
function eP(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, le.HTML), e.insertionMode = fa;
}
function tP(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, le.HTML), e.insertionMode = Di;
}
function nP(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(f.COLGROUP), e.insertionMode = Di, e._processToken(t);
}
function oP(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, le.HTML), e.insertionMode = Ut;
}
function rP(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(f.TBODY), e.insertionMode = Ut, e._processToken(t);
}
function iP(e, t) {
  e.openElements.hasInTableScope(f.TABLE) && (e.openElements.popUntilTagNamePopped(f.TABLE), e._resetInsertionMode(), e._processToken(t));
}
function sP(e, t) {
  const n = R.getTokenAttr(t, jm.TYPE);
  n && n.toLowerCase() === Um ? e._appendElement(t, le.HTML) : Rt(e, t), t.ackSelfClosing = !0;
}
function aP(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, le.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function nu(e, t) {
  const n = t.tagName;
  switch (n.length) {
    case 2:
      n === f.TD || n === f.TH || n === f.TR ? rP(e, t) : Rt(e, t);
      break;
    case 3:
      n === f.COL ? nP(e, t) : Rt(e, t);
      break;
    case 4:
      n === f.FORM ? aP(e, t) : Rt(e, t);
      break;
    case 5:
      n === f.TABLE ? iP(e, t) : n === f.STYLE ? Qe(e, t) : n === f.TBODY || n === f.TFOOT || n === f.THEAD ? oP(e, t) : n === f.INPUT ? sP(e, t) : Rt(e, t);
      break;
    case 6:
      n === f.SCRIPT ? Qe(e, t) : Rt(e, t);
      break;
    case 7:
      n === f.CAPTION ? eP(e, t) : Rt(e, t);
      break;
    case 8:
      n === f.COLGROUP ? tP(e, t) : n === f.TEMPLATE ? Qe(e, t) : Rt(e, t);
      break;
    default:
      Rt(e, t);
  }
}
function ou(e, t) {
  const n = t.tagName;
  n === f.TABLE ? e.openElements.hasInTableScope(f.TABLE) && (e.openElements.popUntilTagNamePopped(f.TABLE), e._resetInsertionMode()) : n === f.TEMPLATE ? Bo(e, t) : n !== f.BODY && n !== f.CAPTION && n !== f.COL && n !== f.COLGROUP && n !== f.HTML && n !== f.TBODY && n !== f.TD && n !== f.TFOOT && n !== f.TH && n !== f.THEAD && n !== f.TR && Rt(e, t);
}
function Rt(e, t) {
  const n = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, e._processTokenInBodyMode(t), e.fosterParentingEnabled = n;
}
function lP(e, t) {
  e.pendingCharacterTokens.push(t);
}
function uP(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function Zr(e, t) {
  let n = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; n < e.pendingCharacterTokens.length; n++)
      Rt(e, e.pendingCharacterTokens[n]);
  else
    for (; n < e.pendingCharacterTokens.length; n++)
      e._insertCharacters(e.pendingCharacterTokens[n]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
function dP(e, t) {
  const n = t.tagName;
  n === f.CAPTION || n === f.COL || n === f.COLGROUP || n === f.TBODY || n === f.TD || n === f.TFOOT || n === f.TH || n === f.THEAD || n === f.TR ? e.openElements.hasInTableScope(f.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = it, e._processToken(t)) : kt(e, t);
}
function cP(e, t) {
  const n = t.tagName;
  n === f.CAPTION || n === f.TABLE ? e.openElements.hasInTableScope(f.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(f.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = it, n === f.TABLE && e._processToken(t)) : n !== f.BODY && n !== f.COL && n !== f.COLGROUP && n !== f.HTML && n !== f.TBODY && n !== f.TD && n !== f.TFOOT && n !== f.TH && n !== f.THEAD && n !== f.TR && tu(e, t);
}
function hP(e, t) {
  const n = t.tagName;
  n === f.HTML ? kt(e, t) : n === f.COL ? (e._appendElement(t, le.HTML), t.ackSelfClosing = !0) : n === f.TEMPLATE ? Qe(e, t) : Vs(e, t);
}
function mP(e, t) {
  const n = t.tagName;
  n === f.COLGROUP ? e.openElements.currentTagName === f.COLGROUP && (e.openElements.pop(), e.insertionMode = it) : n === f.TEMPLATE ? Bo(e, t) : n !== f.COL && Vs(e, t);
}
function Vs(e, t) {
  e.openElements.currentTagName === f.COLGROUP && (e.openElements.pop(), e.insertionMode = it, e._processToken(t));
}
function pP(e, t) {
  const n = t.tagName;
  n === f.TR ? (e.openElements.clearBackToTableBodyContext(), e._insertElement(t, le.HTML), e.insertionMode = Dn) : n === f.TH || n === f.TD ? (e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(f.TR), e.insertionMode = Dn, e._processToken(t)) : n === f.CAPTION || n === f.COL || n === f.COLGROUP || n === f.TBODY || n === f.TFOOT || n === f.THEAD ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = it, e._processToken(t)) : nu(e, t);
}
function fP(e, t) {
  const n = t.tagName;
  n === f.TBODY || n === f.TFOOT || n === f.THEAD ? e.openElements.hasInTableScope(n) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = it) : n === f.TABLE ? e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = it, e._processToken(t)) : (n !== f.BODY && n !== f.CAPTION && n !== f.COL && n !== f.COLGROUP || n !== f.HTML && n !== f.TD && n !== f.TH && n !== f.TR) && ou(e, t);
}
function gP(e, t) {
  const n = t.tagName;
  n === f.TH || n === f.TD ? (e.openElements.clearBackToTableRowContext(), e._insertElement(t, le.HTML), e.insertionMode = ga, e.activeFormattingElements.insertMarker()) : n === f.CAPTION || n === f.COL || n === f.COLGROUP || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR ? e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Ut, e._processToken(t)) : nu(e, t);
}
function vP(e, t) {
  const n = t.tagName;
  n === f.TR ? e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Ut) : n === f.TABLE ? e.openElements.hasInTableScope(f.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Ut, e._processToken(t)) : n === f.TBODY || n === f.TFOOT || n === f.THEAD ? (e.openElements.hasInTableScope(n) || e.openElements.hasInTableScope(f.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = Ut, e._processToken(t)) : (n !== f.BODY && n !== f.CAPTION && n !== f.COL && n !== f.COLGROUP || n !== f.HTML && n !== f.TD && n !== f.TH) && ou(e, t);
}
function bP(e, t) {
  const n = t.tagName;
  n === f.CAPTION || n === f.COL || n === f.COLGROUP || n === f.TBODY || n === f.TD || n === f.TFOOT || n === f.TH || n === f.THEAD || n === f.TR ? (e.openElements.hasInTableScope(f.TD) || e.openElements.hasInTableScope(f.TH)) && (e._closeTableCell(), e._processToken(t)) : kt(e, t);
}
function yP(e, t) {
  const n = t.tagName;
  n === f.TD || n === f.TH ? e.openElements.hasInTableScope(n) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(n), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = Dn) : n === f.TABLE || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR ? e.openElements.hasInTableScope(n) && (e._closeTableCell(), e._processToken(t)) : n !== f.BODY && n !== f.CAPTION && n !== f.COL && n !== f.COLGROUP && n !== f.HTML && tu(e, t);
}
function qm(e, t) {
  const n = t.tagName;
  n === f.HTML ? kt(e, t) : n === f.OPTION ? (e.openElements.currentTagName === f.OPTION && e.openElements.pop(), e._insertElement(t, le.HTML)) : n === f.OPTGROUP ? (e.openElements.currentTagName === f.OPTION && e.openElements.pop(), e.openElements.currentTagName === f.OPTGROUP && e.openElements.pop(), e._insertElement(t, le.HTML)) : n === f.INPUT || n === f.KEYGEN || n === f.TEXTAREA || n === f.SELECT ? e.openElements.hasInSelectScope(f.SELECT) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), n !== f.SELECT && e._processToken(t)) : (n === f.SCRIPT || n === f.TEMPLATE) && Qe(e, t);
}
function Ym(e, t) {
  const n = t.tagName;
  if (n === f.OPTGROUP) {
    const o = e.openElements.items[e.openElements.stackTop - 1], i = o && e.treeAdapter.getTagName(o);
    e.openElements.currentTagName === f.OPTION && i === f.OPTGROUP && e.openElements.pop(), e.openElements.currentTagName === f.OPTGROUP && e.openElements.pop();
  } else n === f.OPTION ? e.openElements.currentTagName === f.OPTION && e.openElements.pop() : n === f.SELECT && e.openElements.hasInSelectScope(f.SELECT) ? (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode()) : n === f.TEMPLATE && Bo(e, t);
}
function _P(e, t) {
  const n = t.tagName;
  n === f.CAPTION || n === f.TABLE || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR || n === f.TD || n === f.TH ? (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), e._processToken(t)) : qm(e, t);
}
function CP(e, t) {
  const n = t.tagName;
  n === f.CAPTION || n === f.TABLE || n === f.TBODY || n === f.TFOOT || n === f.THEAD || n === f.TR || n === f.TD || n === f.TH ? e.openElements.hasInTableScope(n) && (e.openElements.popUntilTagNamePopped(f.SELECT), e._resetInsertionMode(), e._processToken(t)) : Ym(e, t);
}
function wP(e, t) {
  const n = t.tagName;
  if (n === f.BASE || n === f.BASEFONT || n === f.BGSOUND || n === f.LINK || n === f.META || n === f.NOFRAMES || n === f.SCRIPT || n === f.STYLE || n === f.TEMPLATE || n === f.TITLE)
    Qe(e, t);
  else {
    const o = oN[n] || hn;
    e._popTmplInsertionMode(), e._pushTmplInsertionMode(o), e.insertionMode = o, e._processToken(t);
  }
}
function TP(e, t) {
  t.tagName === f.TEMPLATE && Bo(e, t);
}
function Xm(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(f.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e._popTmplInsertionMode(), e._resetInsertionMode(), e._processToken(t)) : e.stopped = !0;
}
function kP(e, t) {
  t.tagName === f.HTML ? kt(e, t) : js(e, t);
}
function EP(e, t) {
  t.tagName === f.HTML ? e.fragmentContext || (e.insertionMode = xm) : js(e, t);
}
function js(e, t) {
  e.insertionMode = hn, e._processToken(t);
}
function SP(e, t) {
  const n = t.tagName;
  n === f.HTML ? kt(e, t) : n === f.FRAMESET ? e._insertElement(t, le.HTML) : n === f.FRAME ? (e._appendElement(t, le.HTML), t.ackSelfClosing = !0) : n === f.NOFRAMES && Qe(e, t);
}
function MP(e, t) {
  t.tagName === f.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagName !== f.FRAMESET && (e.insertionMode = Zm));
}
function AP(e, t) {
  const n = t.tagName;
  n === f.HTML ? kt(e, t) : n === f.NOFRAMES && Qe(e, t);
}
function $P(e, t) {
  t.tagName === f.HTML && (e.insertionMode = Wm);
}
function IP(e, t) {
  t.tagName === f.HTML ? kt(e, t) : ps(e, t);
}
function ps(e, t) {
  e.insertionMode = hn, e._processToken(t);
}
function DP(e, t) {
  const n = t.tagName;
  n === f.HTML ? kt(e, t) : n === f.NOFRAMES && Qe(e, t);
}
function LP(e, t) {
  t.chars = QO.REPLACEMENT_CHARACTER, e._insertCharacters(t);
}
function OP(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function NP(e, t) {
  if (dn.causesExit(t) && !e.fragmentContext) {
    for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== le.HTML && !e._isIntegrationPoint(e.openElements.current); )
      e.openElements.pop();
    e._processToken(t);
  } else {
    const n = e._getAdjustedCurrentElement(), o = e.treeAdapter.getNamespaceURI(n);
    o === le.MATHML ? dn.adjustTokenMathMLAttrs(t) : o === le.SVG && (dn.adjustTokenSVGTagName(t), dn.adjustTokenSVGAttrs(t)), dn.adjustTokenXMLAttrs(t), t.selfClosing ? e._appendElement(t, o) : e._insertElement(t, o), t.ackSelfClosing = !0;
  }
}
function PP(e, t) {
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const o = e.openElements.items[n];
    if (e.treeAdapter.getNamespaceURI(o) === le.HTML) {
      e._processToken(t);
      break;
    }
    if (e.treeAdapter.getTagName(o).toLowerCase() === t.tagName) {
      e.openElements.popUntilElementPopped(o);
      break;
    }
  }
}
const HP = /* @__PURE__ */ Er(iN);
class Li {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, o) {
    this.property = t, this.normal = n, o && (this.space = o);
  }
}
Li.prototype.property = {};
Li.prototype.normal = {};
Li.prototype.space = null;
function Qm(e, t) {
  const n = {}, o = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(o, e[i].normal);
  return new Li(n, o, t);
}
function wi(e) {
  return e.toLowerCase();
}
class Kt {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
Kt.prototype.space = null;
Kt.prototype.boolean = !1;
Kt.prototype.booleanish = !1;
Kt.prototype.overloadedBoolean = !1;
Kt.prototype.number = !1;
Kt.prototype.commaSeparated = !1;
Kt.prototype.spaceSeparated = !1;
Kt.prototype.commaOrSpaceSeparated = !1;
Kt.prototype.mustUseProperty = !1;
Kt.prototype.defined = !1;
let FP = 0;
const fe = Vo(), Ze = Vo(), Jm = Vo(), te = Vo(), Oe = Vo(), ar = Vo(), Mt = Vo();
function Vo() {
  return 2 ** ++FP;
}
const t1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: fe,
  booleanish: Ze,
  commaOrSpaceSeparated: Mt,
  commaSeparated: ar,
  number: te,
  overloadedBoolean: Jm,
  spaceSeparated: Oe
}, Symbol.toStringTag, { value: "Module" })), vl = Object.keys(t1);
class ru extends Kt {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, o, i) {
    let r = -1;
    if (super(t, n), sh(this, "space", i), typeof o == "number")
      for (; ++r < vl.length; ) {
        const a = vl[r];
        sh(this, vl[r], (o & t1[a]) === t1[a]);
      }
  }
}
ru.prototype.defined = !0;
function sh(e, t, n) {
  n && (e[t] = n);
}
const RP = {}.hasOwnProperty;
function Mr(e) {
  const t = {}, n = {};
  let o;
  for (o in e.properties)
    if (RP.call(e.properties, o)) {
      const i = e.properties[o], r = new ru(
        o,
        e.transform(e.attributes || {}, o),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(o) && (r.mustUseProperty = !0), t[o] = r, n[wi(o)] = o, n[wi(r.attribute)] = o;
    }
  return new Li(t, n, e.space);
}
const ep = Mr({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), tp = Mr({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function np(e, t) {
  return t in e ? e[t] : t;
}
function op(e, t) {
  return np(e, t.toLowerCase());
}
const rp = Mr({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: op,
  properties: { xmlns: null, xmlnsXLink: null }
}), ip = Mr({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Ze,
    ariaAutoComplete: null,
    ariaBusy: Ze,
    ariaChecked: Ze,
    ariaColCount: te,
    ariaColIndex: te,
    ariaColSpan: te,
    ariaControls: Oe,
    ariaCurrent: null,
    ariaDescribedBy: Oe,
    ariaDetails: null,
    ariaDisabled: Ze,
    ariaDropEffect: Oe,
    ariaErrorMessage: null,
    ariaExpanded: Ze,
    ariaFlowTo: Oe,
    ariaGrabbed: Ze,
    ariaHasPopup: null,
    ariaHidden: Ze,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Oe,
    ariaLevel: te,
    ariaLive: null,
    ariaModal: Ze,
    ariaMultiLine: Ze,
    ariaMultiSelectable: Ze,
    ariaOrientation: null,
    ariaOwns: Oe,
    ariaPlaceholder: null,
    ariaPosInSet: te,
    ariaPressed: Ze,
    ariaReadOnly: Ze,
    ariaRelevant: null,
    ariaRequired: Ze,
    ariaRoleDescription: Oe,
    ariaRowCount: te,
    ariaRowIndex: te,
    ariaRowSpan: te,
    ariaSelected: Ze,
    ariaSetSize: te,
    ariaSort: null,
    ariaValueMax: te,
    ariaValueMin: te,
    ariaValueNow: te,
    ariaValueText: null,
    role: null
  }
}), BP = Mr({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: op,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ar,
    acceptCharset: Oe,
    accessKey: Oe,
    action: null,
    allow: null,
    allowFullScreen: fe,
    allowPaymentRequest: fe,
    allowUserMedia: fe,
    alt: null,
    as: null,
    async: fe,
    autoCapitalize: null,
    autoComplete: Oe,
    autoFocus: fe,
    autoPlay: fe,
    blocking: Oe,
    capture: null,
    charSet: null,
    checked: fe,
    cite: null,
    className: Oe,
    cols: te,
    colSpan: null,
    content: null,
    contentEditable: Ze,
    controls: fe,
    controlsList: Oe,
    coords: te | ar,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: fe,
    defer: fe,
    dir: null,
    dirName: null,
    disabled: fe,
    download: Jm,
    draggable: Ze,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: fe,
    formTarget: null,
    headers: Oe,
    height: te,
    hidden: fe,
    high: te,
    href: null,
    hrefLang: null,
    htmlFor: Oe,
    httpEquiv: Oe,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: fe,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: fe,
    itemId: null,
    itemProp: Oe,
    itemRef: Oe,
    itemScope: fe,
    itemType: Oe,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: fe,
    low: te,
    manifest: null,
    max: null,
    maxLength: te,
    media: null,
    method: null,
    min: null,
    minLength: te,
    multiple: fe,
    muted: fe,
    name: null,
    nonce: null,
    noModule: fe,
    noValidate: fe,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: fe,
    optimum: te,
    pattern: null,
    ping: Oe,
    placeholder: null,
    playsInline: fe,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: fe,
    referrerPolicy: null,
    rel: Oe,
    required: fe,
    reversed: fe,
    rows: te,
    rowSpan: te,
    sandbox: Oe,
    scope: null,
    scoped: fe,
    seamless: fe,
    selected: fe,
    shadowRootClonable: fe,
    shadowRootDelegatesFocus: fe,
    shadowRootMode: null,
    shape: null,
    size: te,
    sizes: null,
    slot: null,
    span: te,
    spellCheck: Ze,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: te,
    step: null,
    style: null,
    tabIndex: te,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: fe,
    useMap: null,
    value: Ze,
    width: te,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Oe,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: te,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: te,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: fe,
    // Lists. Use CSS to reduce space between items instead
    declare: fe,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: te,
    // `<img>` and `<object>`
    leftMargin: te,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: te,
    // `<body>`
    marginWidth: te,
    // `<body>`
    noResize: fe,
    // `<frame>`
    noHref: fe,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: fe,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: fe,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: te,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Ze,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: te,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: te,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: fe,
    disableRemotePlayback: fe,
    prefix: null,
    property: null,
    results: te,
    security: null,
    unselectable: null
  }
}), VP = Mr({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: np,
  properties: {
    about: Mt,
    accentHeight: te,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: te,
    amplitude: te,
    arabicForm: null,
    ascent: te,
    attributeName: null,
    attributeType: null,
    azimuth: te,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: te,
    by: null,
    calcMode: null,
    capHeight: te,
    className: Oe,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: te,
    diffuseConstant: te,
    direction: null,
    display: null,
    dur: null,
    divisor: te,
    dominantBaseline: null,
    download: fe,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: te,
    enableBackground: null,
    end: null,
    event: null,
    exponent: te,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: te,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ar,
    g2: ar,
    glyphName: ar,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: te,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: te,
    horizOriginX: te,
    horizOriginY: te,
    id: null,
    ideographic: te,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: te,
    k: te,
    k1: te,
    k2: te,
    k3: te,
    k4: te,
    kernelMatrix: Mt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: te,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: te,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: te,
    overlineThickness: te,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: te,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Oe,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: te,
    pointsAtY: te,
    pointsAtZ: te,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Mt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Mt,
    rev: Mt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Mt,
    requiredFeatures: Mt,
    requiredFonts: Mt,
    requiredFormats: Mt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: te,
    specularExponent: te,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: te,
    strikethroughThickness: te,
    string: null,
    stroke: null,
    strokeDashArray: Mt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: te,
    strokeOpacity: te,
    strokeWidth: null,
    style: null,
    surfaceScale: te,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Mt,
    tabIndex: te,
    tableValues: null,
    target: null,
    targetX: te,
    targetY: te,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Mt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: te,
    underlineThickness: te,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: te,
    values: null,
    vAlphabetic: te,
    vMathematical: te,
    vectorEffect: null,
    vHanging: te,
    vIdeographic: te,
    version: null,
    vertAdvY: te,
    vertOriginX: te,
    vertOriginY: te,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: te,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), jP = /^data[-\w.:]+$/i, ah = /-[a-z]/g, UP = /[A-Z]/g;
function iu(e, t) {
  const n = wi(t);
  let o = t, i = Kt;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && jP.test(t)) {
    if (t.charAt(4) === "-") {
      const r = t.slice(5).replace(ah, zP);
      o = "data" + r.charAt(0).toUpperCase() + r.slice(1);
    } else {
      const r = t.slice(4);
      if (!ah.test(r)) {
        let a = r.replace(UP, GP);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    i = ru;
  }
  return new i(o, t);
}
function GP(e) {
  return "-" + e.toLowerCase();
}
function zP(e) {
  return e.charAt(1).toUpperCase();
}
const ba = Qm([tp, ep, rp, ip, BP], "html"), Oi = Qm([tp, ep, rp, ip, VP], "svg"), lh = /[#.]/g;
function KP(e, t) {
  const n = e || "", o = {};
  let i = 0, r, a;
  for (; i < n.length; ) {
    lh.lastIndex = i;
    const s = lh.exec(n), l = n.slice(i, s ? s.index : n.length);
    l && (r ? r === "#" ? o.id = l : Array.isArray(o.className) ? o.className.push(l) : o.className = [l] : a = l, i += l.length), s && (r = s[0], i++);
  }
  return {
    type: "element",
    // @ts-expect-error: fine.
    tagName: a || t || "div",
    properties: o,
    children: []
  };
}
function uh(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function ZP(e) {
  return e.join(" ").trim();
}
function dh(e) {
  const t = [], n = String(e || "");
  let o = n.indexOf(","), i = 0, r = !1;
  for (; !r; ) {
    o === -1 && (o = n.length, r = !0);
    const a = n.slice(i, o).trim();
    (a || !r) && t.push(a), i = o + 1, o = n.indexOf(",", i);
  }
  return t;
}
function xP(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const WP = /* @__PURE__ */ new Set(["menu", "submit", "reset", "button"]), n1 = {}.hasOwnProperty;
function sp(e, t, n) {
  const o = n && QP(n);
  return (
    /**
     * @type {{
     *   (): Root
     *   (selector: null | undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */
    /**
     * Hyperscript compatible DSL for creating virtual hast trees.
     *
     * @param {string | null} [selector]
     * @param {HProperties | HChild} [properties]
     * @param {Array<HChild>} children
     * @returns {HResult}
     */
    function(i, r, ...a) {
      let s = -1, l;
      if (i == null)
        l = { type: "root", children: [] }, a.unshift(r);
      else if (l = KP(i, t), l.tagName = l.tagName.toLowerCase(), o && n1.call(o, l.tagName) && (l.tagName = o[l.tagName]), qP(r, l.tagName)) {
        let u;
        for (u in r)
          n1.call(r, u) && YP(e, l.properties, u, r[u]);
      } else
        a.unshift(r);
      for (; ++s < a.length; )
        o1(l.children, a[s]);
      return l.type === "element" && l.tagName === "template" && (l.content = { type: "root", children: l.children }, l.children = []), l;
    }
  );
}
function qP(e, t) {
  return e == null || typeof e != "object" || Array.isArray(e) ? !1 : t === "input" || !e.type || typeof e.type != "string" ? !0 : "children" in e && Array.isArray(e.children) ? !1 : t === "button" ? WP.has(e.type.toLowerCase()) : !("value" in e);
}
function YP(e, t, n, o) {
  const i = iu(e, n);
  let r = -1, a;
  if (o != null) {
    if (typeof o == "number") {
      if (Number.isNaN(o)) return;
      a = o;
    } else typeof o == "boolean" ? a = o : typeof o == "string" ? i.spaceSeparated ? a = uh(o) : i.commaSeparated ? a = dh(o) : i.commaOrSpaceSeparated ? a = uh(dh(o).join(" ")) : a = ch(i, i.property, o) : Array.isArray(o) ? a = o.concat() : a = i.property === "style" ? XP(o) : String(o);
    if (Array.isArray(a)) {
      const s = [];
      for (; ++r < a.length; )
        s[r] = ch(i, i.property, a[r]);
      a = s;
    }
    i.property === "className" && Array.isArray(t.className) && (a = t.className.concat(a)), t[i.property] = a;
  }
}
function o1(e, t) {
  let n = -1;
  if (t != null) if (typeof t == "string" || typeof t == "number")
    e.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (; ++n < t.length; )
      o1(e, t[n]);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? o1(e, t.children) : e.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function ch(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || wi(n) === wi(t)))
      return !0;
  }
  return n;
}
function XP(e) {
  const t = [];
  let n;
  for (n in e)
    n1.call(e, n) && t.push([n, e[n]].join(": "));
  return t.join("; ");
}
function QP(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    t[e[n].toLowerCase()] = e[n];
  return t;
}
const Ne = sp(ba, "div"), JP = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], eH = sp(Oi, "g", JP);
function tH(e) {
  const t = String(e), n = [], o = /\r?\n|\r/g;
  for (; o.test(t); )
    n.push(o.lastIndex);
  return n.push(t.length + 1), { toPoint: i, toOffset: r };
  function i(a) {
    let s = -1;
    if (typeof a == "number" && a > -1 && a < n[n.length - 1]) {
      for (; ++s < n.length; )
        if (n[s] > a)
          return {
            line: s + 1,
            column: a - (s > 0 ? n[s - 1] : 0) + 1,
            offset: a
          };
    }
    return { line: void 0, column: void 0, offset: void 0 };
  }
  function r(a) {
    const s = a && a.line, l = a && a.column;
    if (typeof s == "number" && typeof l == "number" && !Number.isNaN(s) && !Number.isNaN(l) && s - 1 in n) {
      const u = (n[s - 2] || 0) + l - 1 || 0;
      if (u > -1 && u < n[n.length - 1])
        return u;
    }
    return -1;
  }
}
const nH = {
  svg: "http://www.w3.org/2000/svg"
}, ap = {}.hasOwnProperty, oH = Object.prototype;
function rH(e, t) {
  const n = t || {};
  let o, i;
  return aH(n) ? (i = n, o = {}) : (i = n.file || void 0, o = n), su(
    {
      schema: o.space === "svg" ? Oi : ba,
      file: i,
      verbose: o.verbose,
      location: !1
    },
    e
  );
}
function su(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const o = (
        /** @type {P5Comment} */
        t
      );
      return n = { type: "comment", value: o.data }, fs(e, o, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const o = (
        /** @type {P5Document | P5DocumentFragment} */
        t
      ), i = "mode" in o ? o.mode === "quirks" || o.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: lp(e, t.childNodes),
        data: { quirksMode: i }
      }, e.file && e.location) {
        const r = String(e.file), a = tH(r), s = a.toPoint(0), l = a.toPoint(r.length);
        n.position = { start: s, end: l };
      }
      return n;
    }
    case "#documentType": {
      const o = (
        /** @type {P5DocumentType} */
        t
      );
      return n = { type: "doctype" }, fs(e, o, n), n;
    }
    case "#text": {
      const o = (
        /** @type {P5Text} */
        t
      );
      return n = { type: "text", value: o.value }, fs(e, o, n), n;
    }
    default:
      return n = iH(
        e,
        /** @type {P5Element} */
        t
      ), n;
  }
}
function lp(e, t) {
  let n = -1;
  const o = [];
  for (; ++n < t.length; )
    o[n] = su(e, t[n]);
  return o;
}
function iH(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === nH.svg ? Oi : ba;
  let o = -1;
  const i = {};
  for (; ++o < t.attrs.length; ) {
    const a = t.attrs[o], s = (a.prefix ? a.prefix + ":" : "") + a.name;
    ap.call(oH, s) || (i[s] = a.value);
  }
  const r = (e.schema.space === "svg" ? eH : Ne)(t.tagName, i, lp(e, t.childNodes));
  if (fs(e, t, r), r.tagName === "template") {
    const a = (
      /** @type {P5Template} */
      t
    ), s = a.sourceCodeLocation, l = s && s.startTag && or(s.startTag), u = s && s.endTag && or(s.endTag), m = su(e, a.content);
    l && u && e.file && (m.position = { start: l.end, end: u.start }), r.content = m;
  }
  return e.schema = n, r;
}
function fs(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const o = sH(e, n, t.sourceCodeLocation);
    o && (e.location = !0, n.position = o);
  }
}
function sH(e, t, n) {
  const o = or(n);
  if (t.type === "element") {
    const i = t.children[t.children.length - 1];
    if (o && !n.endTag && i && i.position && i.position.end && (o.end = Object.assign({}, i.position.end)), e.verbose) {
      const r = {};
      let a;
      if (n.attrs)
        for (a in n.attrs)
          ap.call(n.attrs, a) && (r[iu(e.schema, a).property] = or(
            n.attrs[a]
          ));
      t.data = {
        position: {
          // @ts-expect-error: assume not `undefined`.
          opening: or(n.startTag),
          closing: n.endTag ? or(n.endTag) : null,
          properties: r
        }
      };
    }
  }
  return o;
}
function or(e) {
  const t = hh({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = hh({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function hh(e) {
  return e.line && e.column ? e : void 0;
}
function aH(e) {
  return "messages" in e;
}
const lH = {
  abandonedHeadElementChild: {
    reason: "Unexpected metadata element after head",
    description: "Unexpected element after head. Expected the element before `</head>`",
    url: !1
  },
  abruptClosingOfEmptyComment: {
    reason: "Unexpected abruptly closed empty comment",
    description: "Unexpected `>` or `->`. Expected `-->` to close comments"
  },
  abruptDoctypePublicIdentifier: {
    reason: "Unexpected abruptly closed public identifier",
    description: "Unexpected `>`. Expected a closing `\"` or `'` after the public identifier"
  },
  abruptDoctypeSystemIdentifier: {
    reason: "Unexpected abruptly closed system identifier",
    description: "Unexpected `>`. Expected a closing `\"` or `'` after the identifier identifier"
  },
  absenceOfDigitsInNumericCharacterReference: {
    reason: "Unexpected non-digit at start of numeric character reference",
    description: "Unexpected `%c`. Expected `[0-9]` for decimal references or `[0-9a-fA-F]` for hexadecimal references"
  },
  cdataInHtmlContent: {
    reason: "Unexpected CDATA section in HTML",
    description: "Unexpected `<![CDATA[` in HTML. Remove it, use a comment, or encode special characters instead"
  },
  characterReferenceOutsideUnicodeRange: {
    reason: "Unexpected too big numeric character reference",
    description: "Unexpectedly high character reference. Expected character references to be at most hexadecimal 10ffff (or decimal 1114111)"
  },
  closingOfElementWithOpenChildElements: {
    reason: "Unexpected closing tag with open child elements",
    description: "Unexpectedly closing tag. Expected other tags to be closed first",
    url: !1
  },
  controlCharacterInInputStream: {
    reason: "Unexpected control character",
    description: "Unexpected control character `%x`. Expected a non-control code point, 0x00, or ASCII whitespace"
  },
  controlCharacterReference: {
    reason: "Unexpected control character reference",
    description: "Unexpectedly control character in reference. Expected a non-control code point, 0x00, or ASCII whitespace"
  },
  disallowedContentInNoscriptInHead: {
    reason: "Disallowed content inside `<noscript>` in `<head>`",
    description: "Unexpected text character `%c`. Only use text in `<noscript>`s in `<body>`",
    url: !1
  },
  duplicateAttribute: {
    reason: "Unexpected duplicate attribute",
    description: "Unexpectedly double attribute. Expected attributes to occur only once"
  },
  endTagWithAttributes: {
    reason: "Unexpected attribute on closing tag",
    description: "Unexpected attribute. Expected `>` instead"
  },
  endTagWithTrailingSolidus: {
    reason: "Unexpected slash at end of closing tag",
    description: "Unexpected `%c-1`. Expected `>` instead"
  },
  endTagWithoutMatchingOpenElement: {
    reason: "Unexpected unopened end tag",
    description: "Unexpected end tag. Expected no end tag or another end tag",
    url: !1
  },
  eofBeforeTagName: {
    reason: "Unexpected end of file",
    description: "Unexpected end of file. Expected tag name instead"
  },
  eofInCdata: {
    reason: "Unexpected end of file in CDATA",
    description: "Unexpected end of file. Expected `]]>` to close the CDATA"
  },
  eofInComment: {
    reason: "Unexpected end of file in comment",
    description: "Unexpected end of file. Expected `-->` to close the comment"
  },
  eofInDoctype: {
    reason: "Unexpected end of file in doctype",
    description: "Unexpected end of file. Expected a valid doctype (such as `<!doctype html>`)"
  },
  eofInElementThatCanContainOnlyText: {
    reason: "Unexpected end of file in element that can only contain text",
    description: "Unexpected end of file. Expected text or a closing tag",
    url: !1
  },
  eofInScriptHtmlCommentLikeText: {
    reason: "Unexpected end of file in comment inside script",
    description: "Unexpected end of file. Expected `-->` to close the comment"
  },
  eofInTag: {
    reason: "Unexpected end of file in tag",
    description: "Unexpected end of file. Expected `>` to close the tag"
  },
  incorrectlyClosedComment: {
    reason: "Incorrectly closed comment",
    description: "Unexpected `%c-1`. Expected `-->` to close the comment"
  },
  incorrectlyOpenedComment: {
    reason: "Incorrectly opened comment",
    description: "Unexpected `%c`. Expected `<!--` to open the comment"
  },
  invalidCharacterSequenceAfterDoctypeName: {
    reason: "Invalid sequence after doctype name",
    description: "Unexpected sequence at `%c`. Expected `public` or `system`"
  },
  invalidFirstCharacterOfTagName: {
    reason: "Invalid first character in tag name",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  misplacedDoctype: {
    reason: "Misplaced doctype",
    description: "Unexpected doctype. Expected doctype before head",
    url: !1
  },
  misplacedStartTagForHeadElement: {
    reason: "Misplaced `<head>` start tag",
    description: "Unexpected start tag `<head>`. Expected `<head>` directly after doctype",
    url: !1
  },
  missingAttributeValue: {
    reason: "Missing attribute value",
    description: "Unexpected `%c-1`. Expected an attribute value or no `%c-1` instead"
  },
  missingDoctype: {
    reason: "Missing doctype before other content",
    description: "Expected a `<!doctype html>` before anything else",
    url: !1
  },
  missingDoctypeName: {
    reason: "Missing doctype name",
    description: "Unexpected doctype end at `%c`. Expected `html` instead"
  },
  missingDoctypePublicIdentifier: {
    reason: "Missing public identifier in doctype",
    description: "Unexpected `%c`. Expected identifier for `public` instead"
  },
  missingDoctypeSystemIdentifier: {
    reason: "Missing system identifier in doctype",
    description: 'Unexpected `%c`. Expected identifier for `system` instead (suggested: `"about:legacy-compat"`)'
  },
  missingEndTagName: {
    reason: "Missing name in end tag",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  missingQuoteBeforeDoctypePublicIdentifier: {
    reason: "Missing quote before public identifier in doctype",
    description: "Unexpected `%c`. Expected `\"` or `'` instead"
  },
  missingQuoteBeforeDoctypeSystemIdentifier: {
    reason: "Missing quote before system identifier in doctype",
    description: "Unexpected `%c`. Expected `\"` or `'` instead"
  },
  missingSemicolonAfterCharacterReference: {
    reason: "Missing semicolon after character reference",
    description: "Unexpected `%c`. Expected `;` instead"
  },
  missingWhitespaceAfterDoctypePublicKeyword: {
    reason: "Missing whitespace after public identifier in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceAfterDoctypeSystemKeyword: {
    reason: "Missing whitespace after system identifier in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBeforeDoctypeName: {
    reason: "Missing whitespace before doctype name",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBetweenAttributes: {
    reason: "Missing whitespace between attributes",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: {
    reason: "Missing whitespace between public and system identifiers in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  nestedComment: {
    reason: "Unexpected nested comment",
    description: "Unexpected `<!--`. Expected `-->`"
  },
  nestedNoscriptInHead: {
    reason: "Unexpected nested `<noscript>` in `<head>`",
    description: "Unexpected `<noscript>`. Expected a closing tag or a meta element",
    url: !1
  },
  nonConformingDoctype: {
    reason: "Unexpected non-conforming doctype declaration",
    description: 'Expected `<!doctype html>` or `<!doctype html system "about:legacy-compat">`',
    url: !1
  },
  nonVoidHtmlElementStartTagWithTrailingSolidus: {
    reason: "Unexpected trailing slash on start tag of non-void element",
    description: "Unexpected `/`. Expected `>` instead"
  },
  noncharacterCharacterReference: {
    reason: "Unexpected noncharacter code point referenced by character reference",
    description: "Unexpected code point. Do not use noncharacters in HTML"
  },
  noncharacterInInputStream: {
    reason: "Unexpected noncharacter character",
    description: "Unexpected code point `%x`. Do not use noncharacters in HTML"
  },
  nullCharacterReference: {
    reason: "Unexpected NULL character referenced by character reference",
    description: "Unexpected code point. Do not use NULL characters in HTML"
  },
  openElementsLeftAfterEof: {
    reason: "Unexpected end of file",
    description: "Unexpected end of file. Expected closing tag instead",
    url: !1
  },
  surrogateCharacterReference: {
    reason: "Unexpected surrogate character referenced by character reference",
    description: "Unexpected code point. Do not use lone surrogate characters in HTML"
  },
  surrogateInInputStream: {
    reason: "Unexpected surrogate character",
    description: "Unexpected code point `%x`. Do not use lone surrogate characters in HTML"
  },
  unexpectedCharacterAfterDoctypeSystemIdentifier: {
    reason: "Invalid character after system identifier in doctype",
    description: "Unexpected character at `%c`. Expected `>`"
  },
  unexpectedCharacterInAttributeName: {
    reason: "Unexpected character in attribute name",
    description: "Unexpected `%c`. Expected whitespace, `/`, `>`, `=`, or probably an ASCII letter"
  },
  unexpectedCharacterInUnquotedAttributeValue: {
    reason: "Unexpected character in unquoted attribute value",
    description: "Unexpected `%c`. Quote the attribute value to include it"
  },
  unexpectedEqualsSignBeforeAttributeName: {
    reason: "Unexpected equals sign before attribute name",
    description: "Unexpected `%c`. Add an attribute name before it"
  },
  unexpectedNullCharacter: {
    reason: "Unexpected NULL character",
    description: "Unexpected code point `%x`. Do not use NULL characters in HTML"
  },
  unexpectedQuestionMarkInsteadOfTagName: {
    reason: "Unexpected question mark instead of tag name",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  unexpectedSolidusInTag: {
    reason: "Unexpected slash in tag",
    description: "Unexpected `%c-1`. Expected it followed by `>` or in a quoted attribute value"
  },
  unknownNamedCharacterReference: {
    reason: "Unexpected unknown named character reference",
    description: "Unexpected character reference. Expected known named character references"
  }
}, uH = "https://html.spec.whatwg.org/multipage/parsing.html#parse-error-", dH = { 2: !0, 1: !1, 0: null };
function up(e) {
  const t = (
    /** @type {Options} */
    this.data("settings")
  ), n = Object.assign({}, t, e);
  Object.assign(this, { Parser: o });
  function o(i, r) {
    const a = n.fragment ? "parseFragment" : "parse", s = n.emitParseErrors ? u : null, l = new HP({
      sourceCodeLocationInfo: !0,
      onParseError: s,
      scriptingEnabled: !1
    });
    return rH(l[a](i), {
      space: n.space,
      file: r,
      verbose: n.verbose
    });
    function u(m) {
      const g = m.code, p = cH(g), T = n[p], M = T == null ? !0 : T, C = typeof M == "number" ? M : M ? 1 : 0, E = {
        line: m.startLine,
        column: m.startCol,
        offset: m.startOffset
      }, P = {
        line: m.endLine,
        column: m.endCol,
        offset: m.endOffset
      };
      if (C) {
        const D = lH[p] || { reason: "", description: "", url: "" }, H = r.message(F(D.reason), { start: E, end: P });
        H.source = "parse-error", H.ruleId = g, H.fatal = dH[C], H.note = F(D.description), H.url = "url" in D && D.url === !1 ? null : uH + g;
      }
      function F(D) {
        return D.replace(/%c(?:-(\d+))?/g, (H, B) => {
          const U = B ? -Number.parseInt(B, 10) : 0, x = i.charAt(m.startOffset + U);
          return x === "`" ? "` ` `" : x;
        }).replace(
          /%x/g,
          () => "0x" + i.charCodeAt(m.startOffset).toString(16).toUpperCase()
        );
      }
    }
  }
}
function cH(e) {
  return e.replace(/-[a-z]/g, (t) => t.charAt(1).toUpperCase());
}
const dp = {
  strip: ["script"],
  clobberPrefix: "user-content-",
  clobber: ["name", "id"],
  ancestors: {
    tbody: ["table"],
    tfoot: ["table"],
    thead: ["table"],
    td: ["table"],
    th: ["table"],
    tr: ["table"]
  },
  protocols: {
    href: ["http", "https", "mailto", "xmpp", "irc", "ircs"],
    cite: ["http", "https"],
    src: ["http", "https"],
    longDesc: ["http", "https"]
  },
  tagNames: [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "br",
    "b",
    "i",
    "strong",
    "em",
    "a",
    "pre",
    "code",
    "img",
    "tt",
    "div",
    "ins",
    "del",
    "sup",
    "sub",
    "p",
    "ol",
    "ul",
    "table",
    "thead",
    "tbody",
    "tfoot",
    "blockquote",
    "dl",
    "dt",
    "dd",
    "kbd",
    "q",
    "samp",
    "var",
    "hr",
    "ruby",
    "rt",
    "rp",
    "li",
    "tr",
    "td",
    "th",
    "s",
    "strike",
    "summary",
    "details",
    "caption",
    "figure",
    "figcaption",
    "abbr",
    "bdo",
    "cite",
    "dfn",
    "mark",
    "small",
    "span",
    "time",
    "wbr",
    "input"
  ],
  attributes: {
    a: ["href"],
    img: ["src", "longDesc"],
    input: [
      ["type", "checkbox"],
      ["disabled", !0]
    ],
    li: [["className", "task-list-item"]],
    div: ["itemScope", "itemType"],
    blockquote: ["cite"],
    del: ["cite"],
    ins: ["cite"],
    q: ["cite"],
    "*": [
      "abbr",
      "accept",
      "acceptCharset",
      "accessKey",
      "action",
      "align",
      "alt",
      "ariaDescribedBy",
      "ariaHidden",
      "ariaLabel",
      "ariaLabelledBy",
      "axis",
      "border",
      "cellPadding",
      "cellSpacing",
      "char",
      "charOff",
      "charSet",
      "checked",
      "clear",
      "cols",
      "colSpan",
      "color",
      "compact",
      "coords",
      "dateTime",
      "dir",
      "disabled",
      "encType",
      "htmlFor",
      "frame",
      "headers",
      "height",
      "hrefLang",
      "hSpace",
      "isMap",
      "id",
      "label",
      "lang",
      "maxLength",
      "media",
      "method",
      "multiple",
      "name",
      "noHref",
      "noShade",
      "noWrap",
      "open",
      "prompt",
      "readOnly",
      "rel",
      "rev",
      "rows",
      "rowSpan",
      "rules",
      "scope",
      "selected",
      "shape",
      "size",
      "span",
      "start",
      "summary",
      "tabIndex",
      "target",
      "title",
      "type",
      "useMap",
      "vAlign",
      "value",
      "vSpace",
      "width",
      "itemProp"
    ]
  },
  required: {
    input: {
      type: "checkbox",
      disabled: !0
    }
  }
}, ln = {}.hasOwnProperty, bl = {
  root: { children: mh },
  doctype: mH,
  comment: pH,
  element: {
    tagName: hp,
    properties: fH,
    children: mh
  },
  text: { value: bH },
  "*": { data: ph, position: ph }
};
function hH(e, t) {
  let n = { type: "root", children: [] };
  if (e && typeof e == "object" && e.type) {
    const o = cp(
      Object.assign({}, dp, t || {}),
      e,
      []
    );
    o && (Array.isArray(o) ? o.length === 1 ? n = o[0] : n.children = o : n = o);
  }
  return n;
}
function cp(e, t, n) {
  const o = t && t.type, i = { type: t.type };
  let r;
  if (ln.call(bl, o)) {
    let a = bl[o];
    if (typeof a == "function" && (a = a(e, t)), a) {
      const s = Object.assign({}, a, bl["*"]);
      let l;
      r = !0;
      for (l in s)
        if (ln.call(s, l)) {
          const u = s[l](e, t[l], t, n);
          u === !1 ? (r = void 0, i[l] = t[l]) : u != null && (i[l] = u);
        }
    }
  }
  return r ? i : i.type === "element" && e.strip && !e.strip.includes(i.tagName) ? i.children : void 0;
}
function mh(e, t, n, o) {
  const i = [];
  if (Array.isArray(t)) {
    let r = -1;
    for (n.type === "element" && o.push(n.tagName); ++r < t.length; ) {
      const a = cp(e, t[r], o);
      a && (Array.isArray(a) ? i.push(...a) : i.push(a));
    }
    n.type === "element" && o.pop();
  }
  return i;
}
function mH(e) {
  return e.allowDoctypes ? { name: gH } : void 0;
}
function pH(e) {
  return e.allowComments ? { value: vH } : void 0;
}
function fH(e, t, n, o) {
  const i = hp(e, n.tagName, n, o), r = e.attributes || {}, a = e.required || {}, s = t || {}, l = Object.assign(
    {},
    fh(r["*"]),
    fh(i && ln.call(r, i) ? r[i] : [])
  ), u = {};
  let m;
  for (m in s)
    if (ln.call(s, m)) {
      let g = s[m], p;
      if (ln.call(l, m))
        p = l[m];
      else if (CH(m) && ln.call(l, "data*"))
        p = l["data*"];
      else
        continue;
      g = Array.isArray(g) ? yH(e, g, m, p) : mp(e, g, m, p), g != null && (u[m] = g);
    }
  if (i && ln.call(a, i))
    for (m in a[i])
      ln.call(u, m) || (u[m] = a[i][m]);
  return u;
}
function gH() {
  return "html";
}
function hp(e, t, n, o) {
  const i = typeof t == "string" ? t : "";
  let r = -1;
  if (!i || i === "*" || e.tagNames && !e.tagNames.includes(i))
    return !1;
  if (e.ancestors && ln.call(e.ancestors, i)) {
    for (; ++r < e.ancestors[i].length; )
      if (o.includes(e.ancestors[i][r]))
        return i;
    return !1;
  }
  return i;
}
function vH(e, t) {
  const n = typeof t == "string" ? t : "", o = n.indexOf("-->");
  return o < 0 ? n : n.slice(0, o);
}
function bH(e, t) {
  return typeof t == "string" ? t : "";
}
function ph(e, t) {
  return t;
}
function yH(e, t, n, o) {
  let i = -1;
  const r = [];
  for (; ++i < t.length; ) {
    const a = mp(e, t[i], n, o);
    a != null && r.push(a);
  }
  return r;
}
function mp(e, t, n, o) {
  if ((typeof t == "boolean" || typeof t == "number" || typeof t == "string") && _H(e, t, n) && (o.length === 0 || o.some(
    (i) => i && typeof i == "object" && "flags" in i ? i.test(String(t)) : i === t
  )))
    return e.clobberPrefix && e.clobber && e.clobber.includes(n) ? e.clobberPrefix + t : t;
}
function _H(e, t, n) {
  const o = String(t), i = o.indexOf(":"), r = o.indexOf("?"), a = o.indexOf("#"), s = o.indexOf("/"), l = e.protocols && ln.call(e.protocols, n) ? e.protocols[n].concat() : [];
  let u = -1;
  if (l.length === 0 || i < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
  s > -1 && i > s || r > -1 && i > r || a > -1 && i > a)
    return !0;
  for (; ++u < l.length; )
    if (i === l[u].length && o.slice(0, l[u].length) === l[u])
      return !0;
  return !1;
}
function fh(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; ) {
    const o = e[n];
    Array.isArray(o) ? t[o[0]] = o.slice(1) : t[o] = [];
  }
  return t;
}
function CH(e) {
  return e.length > 4 && e.slice(0, 4).toLowerCase() === "data";
}
function pp(e = dp) {
  return (t) => hH(t, e);
}
const wH = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "menuitem",
  "meta",
  "nextid",
  "param",
  "source",
  "track",
  "wbr"
], gh = {}.hasOwnProperty;
function TH(e, t) {
  const n = t || {};
  function o(i, ...r) {
    let a = o.invalid;
    const s = o.handlers;
    if (i && gh.call(i, e)) {
      const l = String(i[e]);
      a = gh.call(s, l) ? s[l] : o.unknown;
    }
    if (a)
      return a.call(this, i, ...r);
  }
  return o.handlers = n.handlers || {}, o.invalid = n.invalid, o.unknown = n.unknown, o;
}
const kH = /["&'<>`]/g, EH = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, SH = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), MH = /[|\\{}()[\]^$+*?.]/g, vh = /* @__PURE__ */ new WeakMap();
function AH(e, t) {
  if (e = e.replace(
    t.subset ? $H(t.subset) : kH,
    o
  ), t.subset || t.escapeOnly)
    return e;
  return e.replace(EH, n).replace(SH, o);
  function n(i, r, a) {
    return t.format(
      (i.charCodeAt(0) - 55296) * 1024 + i.charCodeAt(1) - 56320 + 65536,
      a.charCodeAt(r + 2),
      t
    );
  }
  function o(i, r, a) {
    return t.format(
      i.charCodeAt(0),
      a.charCodeAt(r + 1),
      t
    );
  }
}
function $H(e) {
  let t = vh.get(e);
  return t || (t = IH(e), vh.set(e, t)), t;
}
function IH(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t.push(e[n].replace(MH, "\\$&"));
  return new RegExp("(?:" + t.join("|") + ")", "g");
}
const DH = /[\dA-Fa-f]/;
function LH(e, t, n) {
  const o = "&#x" + e.toString(16).toUpperCase();
  return n && t && !DH.test(String.fromCharCode(t)) ? o : o + ";";
}
const OH = /\d/;
function NH(e, t, n) {
  const o = "&#" + String(e);
  return n && t && !OH.test(String.fromCharCode(t)) ? o : o + ";";
}
const PH = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], yl = {
  nbsp: " ",
  iexcl: "¡",
  cent: "¢",
  pound: "£",
  curren: "¤",
  yen: "¥",
  brvbar: "¦",
  sect: "§",
  uml: "¨",
  copy: "©",
  ordf: "ª",
  laquo: "«",
  not: "¬",
  shy: "­",
  reg: "®",
  macr: "¯",
  deg: "°",
  plusmn: "±",
  sup2: "²",
  sup3: "³",
  acute: "´",
  micro: "µ",
  para: "¶",
  middot: "·",
  cedil: "¸",
  sup1: "¹",
  ordm: "º",
  raquo: "»",
  frac14: "¼",
  frac12: "½",
  frac34: "¾",
  iquest: "¿",
  Agrave: "À",
  Aacute: "Á",
  Acirc: "Â",
  Atilde: "Ã",
  Auml: "Ä",
  Aring: "Å",
  AElig: "Æ",
  Ccedil: "Ç",
  Egrave: "È",
  Eacute: "É",
  Ecirc: "Ê",
  Euml: "Ë",
  Igrave: "Ì",
  Iacute: "Í",
  Icirc: "Î",
  Iuml: "Ï",
  ETH: "Ð",
  Ntilde: "Ñ",
  Ograve: "Ò",
  Oacute: "Ó",
  Ocirc: "Ô",
  Otilde: "Õ",
  Ouml: "Ö",
  times: "×",
  Oslash: "Ø",
  Ugrave: "Ù",
  Uacute: "Ú",
  Ucirc: "Û",
  Uuml: "Ü",
  Yacute: "Ý",
  THORN: "Þ",
  szlig: "ß",
  agrave: "à",
  aacute: "á",
  acirc: "â",
  atilde: "ã",
  auml: "ä",
  aring: "å",
  aelig: "æ",
  ccedil: "ç",
  egrave: "è",
  eacute: "é",
  ecirc: "ê",
  euml: "ë",
  igrave: "ì",
  iacute: "í",
  icirc: "î",
  iuml: "ï",
  eth: "ð",
  ntilde: "ñ",
  ograve: "ò",
  oacute: "ó",
  ocirc: "ô",
  otilde: "õ",
  ouml: "ö",
  divide: "÷",
  oslash: "ø",
  ugrave: "ù",
  uacute: "ú",
  ucirc: "û",
  uuml: "ü",
  yacute: "ý",
  thorn: "þ",
  yuml: "ÿ",
  fnof: "ƒ",
  Alpha: "Α",
  Beta: "Β",
  Gamma: "Γ",
  Delta: "Δ",
  Epsilon: "Ε",
  Zeta: "Ζ",
  Eta: "Η",
  Theta: "Θ",
  Iota: "Ι",
  Kappa: "Κ",
  Lambda: "Λ",
  Mu: "Μ",
  Nu: "Ν",
  Xi: "Ξ",
  Omicron: "Ο",
  Pi: "Π",
  Rho: "Ρ",
  Sigma: "Σ",
  Tau: "Τ",
  Upsilon: "Υ",
  Phi: "Φ",
  Chi: "Χ",
  Psi: "Ψ",
  Omega: "Ω",
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ε",
  zeta: "ζ",
  eta: "η",
  theta: "θ",
  iota: "ι",
  kappa: "κ",
  lambda: "λ",
  mu: "μ",
  nu: "ν",
  xi: "ξ",
  omicron: "ο",
  pi: "π",
  rho: "ρ",
  sigmaf: "ς",
  sigma: "σ",
  tau: "τ",
  upsilon: "υ",
  phi: "φ",
  chi: "χ",
  psi: "ψ",
  omega: "ω",
  thetasym: "ϑ",
  upsih: "ϒ",
  piv: "ϖ",
  bull: "•",
  hellip: "…",
  prime: "′",
  Prime: "″",
  oline: "‾",
  frasl: "⁄",
  weierp: "℘",
  image: "ℑ",
  real: "ℜ",
  trade: "™",
  alefsym: "ℵ",
  larr: "←",
  uarr: "↑",
  rarr: "→",
  darr: "↓",
  harr: "↔",
  crarr: "↵",
  lArr: "⇐",
  uArr: "⇑",
  rArr: "⇒",
  dArr: "⇓",
  hArr: "⇔",
  forall: "∀",
  part: "∂",
  exist: "∃",
  empty: "∅",
  nabla: "∇",
  isin: "∈",
  notin: "∉",
  ni: "∋",
  prod: "∏",
  sum: "∑",
  minus: "−",
  lowast: "∗",
  radic: "√",
  prop: "∝",
  infin: "∞",
  ang: "∠",
  and: "∧",
  or: "∨",
  cap: "∩",
  cup: "∪",
  int: "∫",
  there4: "∴",
  sim: "∼",
  cong: "≅",
  asymp: "≈",
  ne: "≠",
  equiv: "≡",
  le: "≤",
  ge: "≥",
  sub: "⊂",
  sup: "⊃",
  nsub: "⊄",
  sube: "⊆",
  supe: "⊇",
  oplus: "⊕",
  otimes: "⊗",
  perp: "⊥",
  sdot: "⋅",
  lceil: "⌈",
  rceil: "⌉",
  lfloor: "⌊",
  rfloor: "⌋",
  lang: "〈",
  rang: "〉",
  loz: "◊",
  spades: "♠",
  clubs: "♣",
  hearts: "♥",
  diams: "♦",
  quot: '"',
  amp: "&",
  lt: "<",
  gt: ">",
  OElig: "Œ",
  oelig: "œ",
  Scaron: "Š",
  scaron: "š",
  Yuml: "Ÿ",
  circ: "ˆ",
  tilde: "˜",
  ensp: " ",
  emsp: " ",
  thinsp: " ",
  zwnj: "‌",
  zwj: "‍",
  lrm: "‎",
  rlm: "‏",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  sbquo: "‚",
  ldquo: "“",
  rdquo: "”",
  bdquo: "„",
  dagger: "†",
  Dagger: "‡",
  permil: "‰",
  lsaquo: "‹",
  rsaquo: "›",
  euro: "€"
}, HH = [
  "cent",
  "copy",
  "divide",
  "gt",
  "lt",
  "not",
  "para",
  "times"
], fp = {}.hasOwnProperty, r1 = {};
let is;
for (is in yl)
  fp.call(yl, is) && (r1[yl[is]] = is);
const FH = /[^\dA-Za-z]/;
function RH(e, t, n, o) {
  const i = String.fromCharCode(e);
  if (fp.call(r1, i)) {
    const r = r1[i], a = "&" + r;
    return n && PH.includes(r) && !HH.includes(r) && (!o || t && t !== 61 && FH.test(String.fromCharCode(t))) ? a : a + ";";
  }
  return "";
}
function BH(e, t, n) {
  let o = LH(e, t, n.omitOptionalSemicolons), i;
  if ((n.useNamedReferences || n.useShortestReferences) && (i = RH(
    e,
    t,
    n.omitOptionalSemicolons,
    n.attribute
  )), (n.useShortestReferences || !i) && n.useShortestReferences) {
    const r = NH(e, t, n.omitOptionalSemicolons);
    r.length < o.length && (o = r);
  }
  return i && (!n.useShortestReferences || i.length < o.length) ? i : o;
}
function lr(e, t) {
  return AH(e, Object.assign({ format: BH }, t));
}
function VH(e, t, n, o) {
  return o.settings.bogusComments ? "<?" + lr(
    e.value,
    Object.assign({}, o.settings.characterReferences, { subset: [">"] })
  ) + ">" : "<!--" + e.value.replace(/^>|^->|<!--|-->|--!>|<!-$/g, i) + "-->";
  function i(r) {
    return lr(
      r,
      Object.assign({}, o.settings.characterReferences, {
        subset: ["<", ">"]
      })
    );
  }
}
function jH(e, t, n, o) {
  return "<!" + (o.settings.upperDoctype ? "DOCTYPE" : "doctype") + (o.settings.tightDoctype ? "" : " ") + "html>";
}
function bh(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let o = 0, i = n.indexOf(t);
  for (; i !== -1; )
    o++, i = n.indexOf(t, i + t.length);
  return o;
}
function au(e) {
  const t = (
    // @ts-expect-error looks like a node.
    e && typeof e == "object" && e.type === "text" ? (
      // @ts-expect-error looks like a text.
      e.value || ""
    ) : e
  );
  return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
const qe = vp(1), gp = vp(-1);
function vp(e) {
  return t;
  function t(n, o, i) {
    const r = n ? n.children : [];
    let a = (o || 0) + e, s = r && r[a];
    if (!i)
      for (; s && au(s); )
        a += e, s = r[a];
    return s;
  }
}
const UH = {}.hasOwnProperty;
function bp(e) {
  return t;
  function t(n, o, i) {
    return UH.call(e, n.tagName) && e[n.tagName](n, o, i);
  }
}
const lu = bp({
  html: GH,
  head: _l,
  body: zH,
  p: KH,
  li: ZH,
  dt: xH,
  dd: WH,
  rt: yh,
  rp: yh,
  optgroup: qH,
  option: YH,
  menuitem: XH,
  colgroup: _l,
  caption: _l,
  thead: QH,
  tbody: JH,
  tfoot: eF,
  tr: tF,
  td: _h,
  th: _h
});
function _l(e, t, n) {
  const o = qe(n, t, !0);
  return !o || o.type !== "comment" && !(o.type === "text" && au(o.value.charAt(0)));
}
function GH(e, t, n) {
  const o = qe(n, t);
  return !o || o.type !== "comment";
}
function zH(e, t, n) {
  const o = qe(n, t);
  return !o || o.type !== "comment";
}
function KH(e, t, n) {
  const o = qe(n, t);
  return o ? o.type === "element" && (o.tagName === "address" || o.tagName === "article" || o.tagName === "aside" || o.tagName === "blockquote" || o.tagName === "details" || o.tagName === "div" || o.tagName === "dl" || o.tagName === "fieldset" || o.tagName === "figcaption" || o.tagName === "figure" || o.tagName === "footer" || o.tagName === "form" || o.tagName === "h1" || o.tagName === "h2" || o.tagName === "h3" || o.tagName === "h4" || o.tagName === "h5" || o.tagName === "h6" || o.tagName === "header" || o.tagName === "hgroup" || o.tagName === "hr" || o.tagName === "main" || o.tagName === "menu" || o.tagName === "nav" || o.tagName === "ol" || o.tagName === "p" || o.tagName === "pre" || o.tagName === "section" || o.tagName === "table" || o.tagName === "ul") : !n || // Confusing parent.
  !(n.type === "element" && (n.tagName === "a" || n.tagName === "audio" || n.tagName === "del" || n.tagName === "ins" || n.tagName === "map" || n.tagName === "noscript" || n.tagName === "video"));
}
function ZH(e, t, n) {
  const o = qe(n, t);
  return !o || o.type === "element" && o.tagName === "li";
}
function xH(e, t, n) {
  const o = qe(n, t);
  return o && o.type === "element" && (o.tagName === "dt" || o.tagName === "dd");
}
function WH(e, t, n) {
  const o = qe(n, t);
  return !o || o.type === "element" && (o.tagName === "dt" || o.tagName === "dd");
}
function yh(e, t, n) {
  const o = qe(n, t);
  return !o || o.type === "element" && (o.tagName === "rp" || o.tagName === "rt");
}
function qH(e, t, n) {
  const o = qe(n, t);
  return !o || o.type === "element" && o.tagName === "optgroup";
}
function YH(e, t, n) {
  const o = qe(n, t);
  return !o || o.type === "element" && (o.tagName === "option" || o.tagName === "optgroup");
}
function XH(e, t, n) {
  const o = qe(n, t);
  return !o || o.type === "element" && (o.tagName === "menuitem" || o.tagName === "hr" || o.tagName === "menu");
}
function QH(e, t, n) {
  const o = qe(n, t);
  return o && o.type === "element" && (o.tagName === "tbody" || o.tagName === "tfoot");
}
function JH(e, t, n) {
  const o = qe(n, t);
  return !o || o.type === "element" && (o.tagName === "tbody" || o.tagName === "tfoot");
}
function eF(e, t, n) {
  return !qe(n, t);
}
function tF(e, t, n) {
  const o = qe(n, t);
  return !o || o.type === "element" && o.tagName === "tr";
}
function _h(e, t, n) {
  const o = qe(n, t);
  return !o || o.type === "element" && (o.tagName === "td" || o.tagName === "th");
}
const nF = bp({
  html: oF,
  head: rF,
  body: iF,
  colgroup: sF,
  tbody: aF
});
function oF(e) {
  const t = qe(e, -1);
  return !t || t.type !== "comment";
}
function rF(e) {
  const t = e.children, n = [];
  let o = -1;
  for (; ++o < t.length; ) {
    const i = t[o];
    if (i.type === "element" && (i.tagName === "title" || i.tagName === "base")) {
      if (n.includes(i.tagName)) return !1;
      n.push(i.tagName);
    }
  }
  return t.length > 0;
}
function iF(e) {
  const t = qe(e, -1, !0);
  return !t || t.type !== "comment" && !(t.type === "text" && au(t.value.charAt(0))) && !(t.type === "element" && (t.tagName === "meta" || t.tagName === "link" || t.tagName === "script" || t.tagName === "style" || t.tagName === "template"));
}
function sF(e, t, n) {
  const o = gp(n, t), i = qe(e, -1, !0);
  return n && o && o.type === "element" && o.tagName === "colgroup" && lu(o, n.children.indexOf(o), n) ? !1 : i && i.type === "element" && i.tagName === "col";
}
function aF(e, t, n) {
  const o = gp(n, t), i = qe(e, -1);
  return n && o && o.type === "element" && (o.tagName === "thead" || o.tagName === "tbody") && lu(o, n.children.indexOf(o), n) ? !1 : i && i.type === "element" && i.tagName === "tr";
}
const ss = {
  // See: <https://html.spec.whatwg.org/#attribute-name-state>.
  name: [
    [`	
\f\r &/=>`.split(""), `	
\f\r "&'/=>\``.split("")],
    [`\0	
\f\r "&'/<=>`.split(""), `\0	
\f\r "&'/<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
  unquoted: [
    [`	
\f\r &>`.split(""), `\0	
\f\r "&'<=>\``.split("")],
    [`\0	
\f\r "&'<=>\``.split(""), `\0	
\f\r "&'<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
  single: [
    ["&'".split(""), "\"&'`".split("")],
    ["\0&'".split(""), "\0\"&'`".split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
  double: [
    ['"&'.split(""), "\"&'`".split("")],
    ['\0"&'.split(""), "\0\"&'`".split("")]
  ]
};
function lF(e, t, n, o) {
  const i = o.schema, r = i.space === "svg" ? !1 : o.settings.omitOptionalTags;
  let a = i.space === "svg" ? o.settings.closeEmptyElements : o.settings.voids.includes(e.tagName.toLowerCase());
  const s = [];
  let l;
  i.space === "html" && e.tagName === "svg" && (o.schema = Oi);
  const u = uF(o, e.properties), m = o.all(
    i.space === "html" && e.tagName === "template" ? e.content : e
  );
  return o.schema = i, m && (a = !1), (u || !r || !nF(e, t, n)) && (s.push("<", e.tagName, u ? " " + u : ""), a && (i.space === "svg" || o.settings.closeSelfClosing) && (l = u.charAt(u.length - 1), (!o.settings.tightSelfClosing || l === "/" || l && l !== '"' && l !== "'") && s.push(" "), s.push("/")), s.push(">")), s.push(m), !a && (!r || !lu(e, t, n)) && s.push("</" + e.tagName + ">"), s.join("");
}
function uF(e, t) {
  const n = [];
  let o = -1, i;
  if (t) {
    for (i in t)
      if (t[i] !== void 0 && t[i] !== null) {
        const r = dF(e, i, t[i]);
        r && n.push(r);
      }
  }
  for (; ++o < n.length; ) {
    const r = e.settings.tightAttributes ? n[o].charAt(n[o].length - 1) : null;
    o !== n.length - 1 && r !== '"' && r !== "'" && (n[o] += " ");
  }
  return n.join("");
}
function dF(e, t, n) {
  const o = iu(e.schema, t), i = e.settings.allowParseErrors && e.schema.space === "html" ? 0 : 1, r = e.settings.allowDangerousCharacters ? 0 : 1;
  let a = e.quote, s;
  if (o.overloadedBoolean && (n === o.attribute || n === "") ? n = !0 : (o.boolean || o.overloadedBoolean && typeof n != "string") && (n = !!n), n == null || n === !1 || typeof n == "number" && Number.isNaN(n))
    return "";
  const l = lr(
    o.attribute,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: ss.name[i][r]
    })
  );
  return n === !0 || (n = Array.isArray(n) ? (o.commaSeparated ? xP : ZP)(n, {
    padLeft: !e.settings.tightCommaSeparatedLists
  }) : String(n), e.settings.collapseEmptyAttributes && !n) ? l : (e.settings.preferUnquoted && (s = lr(
    n,
    Object.assign({}, e.settings.characterReferences, {
      subset: ss.unquoted[i][r],
      attribute: !0
    })
  )), s !== n && (e.settings.quoteSmart && bh(n, a) > bh(n, e.alternative) && (a = e.alternative), s = a + lr(
    n,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: (a === "'" ? ss.single : ss.double)[i][r],
      attribute: !0
    })
  ) + a), l + (s && "=" + s));
}
function yp(e, t, n, o) {
  return n && n.type === "element" && (n.tagName === "script" || n.tagName === "style") ? e.value : lr(
    e.value,
    Object.assign({}, o.settings.characterReferences, {
      subset: ["<", "&"]
    })
  );
}
function cF(e, t, n, o) {
  return o.settings.allowDangerousHtml ? e.value : yp(e, t, n, o);
}
function hF(e, t, n, o) {
  return o.all(e);
}
const mF = TH("type", {
  invalid: pF,
  unknown: fF,
  handlers: { comment: VH, doctype: jH, element: lF, raw: cF, root: hF, text: yp }
});
function pF(e) {
  throw new Error("Expected node, not `" + e + "`");
}
function fF(e) {
  throw new Error("Cannot compile unknown node `" + e.type + "`");
}
function gF(e, t) {
  const n = t || {}, o = n.quote || '"', i = o === '"' ? "'" : '"';
  if (o !== '"' && o !== "'")
    throw new Error("Invalid quote `" + o + "`, expected `'` or `\"`");
  return {
    one: vF,
    all: bF,
    settings: {
      omitOptionalTags: n.omitOptionalTags || !1,
      allowParseErrors: n.allowParseErrors || !1,
      allowDangerousCharacters: n.allowDangerousCharacters || !1,
      quoteSmart: n.quoteSmart || !1,
      preferUnquoted: n.preferUnquoted || !1,
      tightAttributes: n.tightAttributes || !1,
      upperDoctype: n.upperDoctype || !1,
      tightDoctype: n.tightDoctype || !1,
      bogusComments: n.bogusComments || !1,
      tightCommaSeparatedLists: n.tightCommaSeparatedLists || !1,
      tightSelfClosing: n.tightSelfClosing || !1,
      collapseEmptyAttributes: n.collapseEmptyAttributes || !1,
      allowDangerousHtml: n.allowDangerousHtml || !1,
      voids: n.voids || wH,
      characterReferences: n.characterReferences || n.entities || {},
      closeSelfClosing: n.closeSelfClosing || !1,
      closeEmptyElements: n.closeEmptyElements || !1
    },
    schema: n.space === "svg" ? Oi : ba,
    quote: o,
    alternative: i
  }.one(
    Array.isArray(e) ? { type: "root", children: e } : e,
    void 0,
    void 0
  );
}
function vF(e, t, n) {
  return mF(e, t, n, this);
}
function bF(e) {
  const t = [], n = e && e.children || [];
  let o = -1;
  for (; ++o < n.length; )
    t[o] = this.one(n[o], o, e);
  return t.join("");
}
function yF(e) {
  const t = (
    /** @type {Options} */
    this.data("settings")
  ), n = Object.assign({}, t, e);
  Object.assign(this, { Compiler: o });
  function o(i) {
    return gF(i, n);
  }
}
var _F = Object.prototype;
function CF(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || _F;
  return e === n;
}
var ya = CF;
function wF(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var _p = wF, TF = _p, kF = TF(Object.keys, Object), EF = kF, SF = ya, MF = EF, AF = Object.prototype, $F = AF.hasOwnProperty;
function IF(e) {
  if (!SF(e))
    return MF(e);
  var t = [];
  for (var n in Object(e))
    $F.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var Cp = IF, DF = typeof Gi == "object" && Gi && Gi.Object === Object && Gi, wp = DF, LF = wp, OF = typeof self == "object" && self && self.Object === Object && self, NF = LF || OF || Function("return this")(), pn = NF, PF = pn, HF = PF.Symbol, _a = HF, Ch = _a, Tp = Object.prototype, FF = Tp.hasOwnProperty, RF = Tp.toString, xr = Ch ? Ch.toStringTag : void 0;
function BF(e) {
  var t = FF.call(e, xr), n = e[xr];
  try {
    e[xr] = void 0;
    var o = !0;
  } catch (r) {
  }
  var i = RF.call(e);
  return o && (t ? e[xr] = n : delete e[xr]), i;
}
var VF = BF, jF = Object.prototype, UF = jF.toString;
function GF(e) {
  return UF.call(e);
}
var zF = GF, wh = _a, KF = VF, ZF = zF, xF = "[object Null]", WF = "[object Undefined]", Th = wh ? wh.toStringTag : void 0;
function qF(e) {
  return e == null ? e === void 0 ? WF : xF : Th && Th in Object(e) ? KF(e) : ZF(e);
}
var Ni = qF;
function YF(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Pi = YF, XF = Ni, QF = Pi, JF = "[object AsyncFunction]", eR = "[object Function]", tR = "[object GeneratorFunction]", nR = "[object Proxy]";
function oR(e) {
  if (!QF(e))
    return !1;
  var t = XF(e);
  return t == eR || t == tR || t == JF || t == nR;
}
var kp = oR, rR = pn, iR = rR["__core-js_shared__"], sR = iR, Cl = sR, kh = function() {
  var e = /[^.]+$/.exec(Cl && Cl.keys && Cl.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function aR(e) {
  return !!kh && kh in e;
}
var lR = aR, uR = Function.prototype, dR = uR.toString;
function cR(e) {
  if (e != null) {
    try {
      return dR.call(e);
    } catch (t) {
    }
    try {
      return e + "";
    } catch (t) {
    }
  }
  return "";
}
var Ep = cR, hR = kp, mR = lR, pR = Pi, fR = Ep, gR = /[\\^$.*+?()[\]{}|]/g, vR = /^\[object .+?Constructor\]$/, bR = Function.prototype, yR = Object.prototype, _R = bR.toString, CR = yR.hasOwnProperty, wR = RegExp(
  "^" + _R.call(CR).replace(gR, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function TR(e) {
  if (!pR(e) || mR(e))
    return !1;
  var t = hR(e) ? wR : vR;
  return t.test(fR(e));
}
var kR = TR;
function ER(e, t) {
  return e == null ? void 0 : e[t];
}
var SR = ER, MR = kR, AR = SR;
function $R(e, t) {
  var n = AR(e, t);
  return MR(n) ? n : void 0;
}
var jo = $R, IR = jo, DR = pn, LR = IR(DR, "DataView"), OR = LR, NR = jo, PR = pn, HR = NR(PR, "Map"), uu = HR, FR = jo, RR = pn, BR = FR(RR, "Promise"), VR = BR, jR = jo, UR = pn, GR = jR(UR, "Set"), zR = GR, KR = jo, ZR = pn, xR = KR(ZR, "WeakMap"), WR = xR, i1 = OR, s1 = uu, a1 = VR, l1 = zR, u1 = WR, Sp = Ni, Ar = Ep, Eh = "[object Map]", qR = "[object Object]", Sh = "[object Promise]", Mh = "[object Set]", Ah = "[object WeakMap]", $h = "[object DataView]", YR = Ar(i1), XR = Ar(s1), QR = Ar(a1), JR = Ar(l1), eB = Ar(u1), go = Sp;
(i1 && go(new i1(new ArrayBuffer(1))) != $h || s1 && go(new s1()) != Eh || a1 && go(a1.resolve()) != Sh || l1 && go(new l1()) != Mh || u1 && go(new u1()) != Ah) && (go = function(e) {
  var t = Sp(e), n = t == qR ? e.constructor : void 0, o = n ? Ar(n) : "";
  if (o)
    switch (o) {
      case YR:
        return $h;
      case XR:
        return Eh;
      case QR:
        return Sh;
      case JR:
        return Mh;
      case eB:
        return Ah;
    }
  return t;
});
var Ca = go;
function tB(e) {
  return e != null && typeof e == "object";
}
var $r = tB, nB = Ni, oB = $r, rB = "[object Arguments]";
function iB(e) {
  return oB(e) && nB(e) == rB;
}
var sB = iB, Ih = sB, aB = $r, Mp = Object.prototype, lB = Mp.hasOwnProperty, uB = Mp.propertyIsEnumerable, dB = Ih(/* @__PURE__ */ function() {
  return arguments;
}()) ? Ih : function(e) {
  return aB(e) && lB.call(e, "callee") && !uB.call(e, "callee");
}, Ap = dB, cB = Array.isArray, Uo = cB, hB = 9007199254740991;
function mB(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= hB;
}
var $p = mB, pB = kp, fB = $p;
function gB(e) {
  return e != null && fB(e.length) && !pB(e);
}
var du = gB, Us = { exports: {} };
function vB() {
  return !1;
}
var bB = vB;
Us.exports;
(function(e, t) {
  var n = pn, o = bB, i = t && !t.nodeType && t, r = i && !0 && e && !e.nodeType && e, a = r && r.exports === i, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || o;
  e.exports = u;
})(Us, Us.exports);
var cu = Us.exports, yB = Ni, _B = $p, CB = $r, wB = "[object Arguments]", TB = "[object Array]", kB = "[object Boolean]", EB = "[object Date]", SB = "[object Error]", MB = "[object Function]", AB = "[object Map]", $B = "[object Number]", IB = "[object Object]", DB = "[object RegExp]", LB = "[object Set]", OB = "[object String]", NB = "[object WeakMap]", PB = "[object ArrayBuffer]", HB = "[object DataView]", FB = "[object Float32Array]", RB = "[object Float64Array]", BB = "[object Int8Array]", VB = "[object Int16Array]", jB = "[object Int32Array]", UB = "[object Uint8Array]", GB = "[object Uint8ClampedArray]", zB = "[object Uint16Array]", KB = "[object Uint32Array]", Fe = {};
Fe[FB] = Fe[RB] = Fe[BB] = Fe[VB] = Fe[jB] = Fe[UB] = Fe[GB] = Fe[zB] = Fe[KB] = !0;
Fe[wB] = Fe[TB] = Fe[PB] = Fe[kB] = Fe[HB] = Fe[EB] = Fe[SB] = Fe[MB] = Fe[AB] = Fe[$B] = Fe[IB] = Fe[DB] = Fe[LB] = Fe[OB] = Fe[NB] = !1;
function ZB(e) {
  return CB(e) && _B(e.length) && !!Fe[yB(e)];
}
var xB = ZB;
function WB(e) {
  return function(t) {
    return e(t);
  };
}
var hu = WB, Gs = { exports: {} };
Gs.exports;
(function(e, t) {
  var n = wp, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, r = i && i.exports === o, a = r && n.process, s = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || a && a.binding && a.binding("util");
    } catch (u) {
    }
  }();
  e.exports = s;
})(Gs, Gs.exports);
var mu = Gs.exports, qB = xB, YB = hu, Dh = mu, Lh = Dh && Dh.isTypedArray, XB = Lh ? YB(Lh) : qB, Ip = XB, QB = Cp, JB = Ca, eV = Ap, tV = Uo, nV = du, oV = cu, rV = ya, iV = Ip, sV = "[object Map]", aV = "[object Set]", lV = Object.prototype, uV = lV.hasOwnProperty;
function dV(e) {
  if (e == null)
    return !0;
  if (nV(e) && (tV(e) || typeof e == "string" || typeof e.splice == "function" || oV(e) || iV(e) || eV(e)))
    return !e.length;
  var t = JB(e);
  if (t == sV || t == aV)
    return !e.size;
  if (rV(e))
    return !QB(e).length;
  for (var n in e)
    if (uV.call(e, n))
      return !1;
  return !0;
}
var cV = dV;
const hV = /* @__PURE__ */ Er(cV);
function mV() {
  this.__data__ = [], this.size = 0;
}
var pV = mV;
function fV(e, t) {
  return e === t || e !== e && t !== t;
}
var Dp = fV, gV = Dp;
function vV(e, t) {
  for (var n = e.length; n--; )
    if (gV(e[n][0], t))
      return n;
  return -1;
}
var wa = vV, bV = wa, yV = Array.prototype, _V = yV.splice;
function CV(e) {
  var t = this.__data__, n = bV(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : _V.call(t, n, 1), --this.size, !0;
}
var wV = CV, TV = wa;
function kV(e) {
  var t = this.__data__, n = TV(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var EV = kV, SV = wa;
function MV(e) {
  return SV(this.__data__, e) > -1;
}
var AV = MV, $V = wa;
function IV(e, t) {
  var n = this.__data__, o = $V(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
var DV = IV, LV = pV, OV = wV, NV = EV, PV = AV, HV = DV;
function Ir(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Ir.prototype.clear = LV;
Ir.prototype.delete = OV;
Ir.prototype.get = NV;
Ir.prototype.has = PV;
Ir.prototype.set = HV;
var Ta = Ir, FV = Ta;
function RV() {
  this.__data__ = new FV(), this.size = 0;
}
var BV = RV;
function VV(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var jV = VV;
function UV(e) {
  return this.__data__.get(e);
}
var GV = UV;
function zV(e) {
  return this.__data__.has(e);
}
var KV = zV, ZV = jo, xV = ZV(Object, "create"), ka = xV, Oh = ka;
function WV() {
  this.__data__ = Oh ? Oh(null) : {}, this.size = 0;
}
var qV = WV;
function YV(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var XV = YV, QV = ka, JV = "__lodash_hash_undefined__", ej = Object.prototype, tj = ej.hasOwnProperty;
function nj(e) {
  var t = this.__data__;
  if (QV) {
    var n = t[e];
    return n === JV ? void 0 : n;
  }
  return tj.call(t, e) ? t[e] : void 0;
}
var oj = nj, rj = ka, ij = Object.prototype, sj = ij.hasOwnProperty;
function aj(e) {
  var t = this.__data__;
  return rj ? t[e] !== void 0 : sj.call(t, e);
}
var lj = aj, uj = ka, dj = "__lodash_hash_undefined__";
function cj(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = uj && t === void 0 ? dj : t, this;
}
var hj = cj, mj = qV, pj = XV, fj = oj, gj = lj, vj = hj;
function Dr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Dr.prototype.clear = mj;
Dr.prototype.delete = pj;
Dr.prototype.get = fj;
Dr.prototype.has = gj;
Dr.prototype.set = vj;
var bj = Dr, Nh = bj, yj = Ta, _j = uu;
function Cj() {
  this.size = 0, this.__data__ = {
    hash: new Nh(),
    map: new (_j || yj)(),
    string: new Nh()
  };
}
var wj = Cj;
function Tj(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var kj = Tj, Ej = kj;
function Sj(e, t) {
  var n = e.__data__;
  return Ej(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Ea = Sj, Mj = Ea;
function Aj(e) {
  var t = Mj(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var $j = Aj, Ij = Ea;
function Dj(e) {
  return Ij(this, e).get(e);
}
var Lj = Dj, Oj = Ea;
function Nj(e) {
  return Oj(this, e).has(e);
}
var Pj = Nj, Hj = Ea;
function Fj(e, t) {
  var n = Hj(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
var Rj = Fj, Bj = wj, Vj = $j, jj = Lj, Uj = Pj, Gj = Rj;
function Lr(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Lr.prototype.clear = Bj;
Lr.prototype.delete = Vj;
Lr.prototype.get = jj;
Lr.prototype.has = Uj;
Lr.prototype.set = Gj;
var Lp = Lr, zj = Ta, Kj = uu, Zj = Lp, xj = 200;
function Wj(e, t) {
  var n = this.__data__;
  if (n instanceof zj) {
    var o = n.__data__;
    if (!Kj || o.length < xj - 1)
      return o.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Zj(o);
  }
  return n.set(e, t), this.size = n.size, this;
}
var qj = Wj, Yj = Ta, Xj = BV, Qj = jV, Jj = GV, eU = KV, tU = qj;
function Or(e) {
  var t = this.__data__ = new Yj(e);
  this.size = t.size;
}
Or.prototype.clear = Xj;
Or.prototype.delete = Qj;
Or.prototype.get = Jj;
Or.prototype.has = eU;
Or.prototype.set = tU;
var nU = Or;
function oU(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var rU = oU, iU = jo, sU = function() {
  try {
    var e = iU(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (t) {
  }
}(), aU = sU, Ph = aU;
function lU(e, t, n) {
  t == "__proto__" && Ph ? Ph(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var Op = lU, uU = Op, dU = Dp, cU = Object.prototype, hU = cU.hasOwnProperty;
function mU(e, t, n) {
  var o = e[t];
  (!(hU.call(e, t) && dU(o, n)) || n === void 0 && !(t in e)) && uU(e, t, n);
}
var Np = mU, pU = Np, fU = Op;
function gU(e, t, n, o) {
  var i = !n;
  n || (n = {});
  for (var r = -1, a = t.length; ++r < a; ) {
    var s = t[r], l = o ? o(n[s], e[s], s, n, e) : void 0;
    l === void 0 && (l = e[s]), i ? fU(n, s, l) : pU(n, s, l);
  }
  return n;
}
var Sa = gU;
function vU(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var bU = vU, yU = 9007199254740991, _U = /^(?:0|[1-9]\d*)$/;
function CU(e, t) {
  var n = typeof e;
  return t = t == null ? yU : t, !!t && (n == "number" || n != "symbol" && _U.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var wU = CU, TU = bU, kU = Ap, EU = Uo, SU = cu, MU = wU, AU = Ip, $U = Object.prototype, IU = $U.hasOwnProperty;
function DU(e, t) {
  var n = EU(e), o = !n && kU(e), i = !n && !o && SU(e), r = !n && !o && !i && AU(e), a = n || o || i || r, s = a ? TU(e.length, String) : [], l = s.length;
  for (var u in e)
    (t || IU.call(e, u)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    MU(u, l))) && s.push(u);
  return s;
}
var Pp = DU, LU = Pp, OU = Cp, NU = du;
function PU(e) {
  return NU(e) ? LU(e) : OU(e);
}
var pu = PU, HU = Sa, FU = pu;
function RU(e, t) {
  return e && HU(t, FU(t), e);
}
var BU = RU;
function VU(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var jU = VU, UU = Pi, GU = ya, zU = jU, KU = Object.prototype, ZU = KU.hasOwnProperty;
function xU(e) {
  if (!UU(e))
    return zU(e);
  var t = GU(e), n = [];
  for (var o in e)
    o == "constructor" && (t || !ZU.call(e, o)) || n.push(o);
  return n;
}
var WU = xU, qU = Pp, YU = WU, XU = du;
function QU(e) {
  return XU(e) ? qU(e, !0) : YU(e);
}
var fu = QU, JU = Sa, eG = fu;
function tG(e, t) {
  return e && JU(t, eG(t), e);
}
var nG = tG, zs = { exports: {} };
zs.exports;
(function(e, t) {
  var n = pn, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, r = i && i.exports === o, a = r ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function l(u, m) {
    if (m)
      return u.slice();
    var g = u.length, p = s ? s(g) : new u.constructor(g);
    return u.copy(p), p;
  }
  e.exports = l;
})(zs, zs.exports);
var oG = zs.exports;
function rG(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var iG = rG;
function sG(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, i = 0, r = []; ++n < o; ) {
    var a = e[n];
    t(a, n, e) && (r[i++] = a);
  }
  return r;
}
var aG = sG;
function lG() {
  return [];
}
var Hp = lG, uG = aG, dG = Hp, cG = Object.prototype, hG = cG.propertyIsEnumerable, Hh = Object.getOwnPropertySymbols, mG = Hh ? function(e) {
  return e == null ? [] : (e = Object(e), uG(Hh(e), function(t) {
    return hG.call(e, t);
  }));
} : dG, gu = mG, pG = Sa, fG = gu;
function gG(e, t) {
  return pG(e, fG(e), t);
}
var vG = gG;
function bG(e, t) {
  for (var n = -1, o = t.length, i = e.length; ++n < o; )
    e[i + n] = t[n];
  return e;
}
var Fp = bG, yG = _p, _G = yG(Object.getPrototypeOf, Object), Rp = _G, CG = Fp, wG = Rp, TG = gu, kG = Hp, EG = Object.getOwnPropertySymbols, SG = EG ? function(e) {
  for (var t = []; e; )
    CG(t, TG(e)), e = wG(e);
  return t;
} : kG, Bp = SG, MG = Sa, AG = Bp;
function $G(e, t) {
  return MG(e, AG(e), t);
}
var IG = $G, DG = Fp, LG = Uo;
function OG(e, t, n) {
  var o = t(e);
  return LG(e) ? o : DG(o, n(e));
}
var Vp = OG, NG = Vp, PG = gu, HG = pu;
function FG(e) {
  return NG(e, HG, PG);
}
var RG = FG, BG = Vp, VG = Bp, jG = fu;
function UG(e) {
  return BG(e, jG, VG);
}
var GG = UG, zG = Object.prototype, KG = zG.hasOwnProperty;
function ZG(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && KG.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var xG = ZG, WG = pn, qG = WG.Uint8Array, YG = qG, Fh = YG;
function XG(e) {
  var t = new e.constructor(e.byteLength);
  return new Fh(t).set(new Fh(e)), t;
}
var vu = XG, QG = vu;
function JG(e, t) {
  var n = t ? QG(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var ez = JG, tz = /\w*$/;
function nz(e) {
  var t = new e.constructor(e.source, tz.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var oz = nz, Rh = _a, Bh = Rh ? Rh.prototype : void 0, Vh = Bh ? Bh.valueOf : void 0;
function rz(e) {
  return Vh ? Object(Vh.call(e)) : {};
}
var iz = rz, sz = vu;
function az(e, t) {
  var n = t ? sz(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var lz = az, uz = vu, dz = ez, cz = oz, hz = iz, mz = lz, pz = "[object Boolean]", fz = "[object Date]", gz = "[object Map]", vz = "[object Number]", bz = "[object RegExp]", yz = "[object Set]", _z = "[object String]", Cz = "[object Symbol]", wz = "[object ArrayBuffer]", Tz = "[object DataView]", kz = "[object Float32Array]", Ez = "[object Float64Array]", Sz = "[object Int8Array]", Mz = "[object Int16Array]", Az = "[object Int32Array]", $z = "[object Uint8Array]", Iz = "[object Uint8ClampedArray]", Dz = "[object Uint16Array]", Lz = "[object Uint32Array]";
function Oz(e, t, n) {
  var o = e.constructor;
  switch (t) {
    case wz:
      return uz(e);
    case pz:
    case fz:
      return new o(+e);
    case Tz:
      return dz(e, n);
    case kz:
    case Ez:
    case Sz:
    case Mz:
    case Az:
    case $z:
    case Iz:
    case Dz:
    case Lz:
      return mz(e, n);
    case gz:
      return new o();
    case vz:
    case _z:
      return new o(e);
    case bz:
      return cz(e);
    case yz:
      return new o();
    case Cz:
      return hz(e);
  }
}
var Nz = Oz, Pz = Pi, jh = Object.create, Hz = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Pz(t))
      return {};
    if (jh)
      return jh(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), Fz = Hz, Rz = Fz, Bz = Rp, Vz = ya;
function jz(e) {
  return typeof e.constructor == "function" && !Vz(e) ? Rz(Bz(e)) : {};
}
var Uz = jz, Gz = Ca, zz = $r, Kz = "[object Map]";
function Zz(e) {
  return zz(e) && Gz(e) == Kz;
}
var xz = Zz, Wz = xz, qz = hu, Uh = mu, Gh = Uh && Uh.isMap, Yz = Gh ? qz(Gh) : Wz, Xz = Yz, Qz = Ca, Jz = $r, eK = "[object Set]";
function tK(e) {
  return Jz(e) && Qz(e) == eK;
}
var nK = tK, oK = nK, rK = hu, zh = mu, Kh = zh && zh.isSet, iK = Kh ? rK(Kh) : oK, sK = iK, aK = nU, lK = rU, uK = Np, dK = BU, cK = nG, hK = oG, mK = iG, pK = vG, fK = IG, gK = RG, vK = GG, bK = Ca, yK = xG, _K = Nz, CK = Uz, wK = Uo, TK = cu, kK = Xz, EK = Pi, SK = sK, MK = pu, AK = fu, $K = 1, IK = 2, DK = 4, jp = "[object Arguments]", LK = "[object Array]", OK = "[object Boolean]", NK = "[object Date]", PK = "[object Error]", Up = "[object Function]", HK = "[object GeneratorFunction]", FK = "[object Map]", RK = "[object Number]", Gp = "[object Object]", BK = "[object RegExp]", VK = "[object Set]", jK = "[object String]", UK = "[object Symbol]", GK = "[object WeakMap]", zK = "[object ArrayBuffer]", KK = "[object DataView]", ZK = "[object Float32Array]", xK = "[object Float64Array]", WK = "[object Int8Array]", qK = "[object Int16Array]", YK = "[object Int32Array]", XK = "[object Uint8Array]", QK = "[object Uint8ClampedArray]", JK = "[object Uint16Array]", eZ = "[object Uint32Array]", De = {};
De[jp] = De[LK] = De[zK] = De[KK] = De[OK] = De[NK] = De[ZK] = De[xK] = De[WK] = De[qK] = De[YK] = De[FK] = De[RK] = De[Gp] = De[BK] = De[VK] = De[jK] = De[UK] = De[XK] = De[QK] = De[JK] = De[eZ] = !0;
De[PK] = De[Up] = De[GK] = !1;
function gs(e, t, n, o, i, r) {
  var a, s = t & $K, l = t & IK, u = t & DK;
  if (n && (a = i ? n(e, o, i, r) : n(e)), a !== void 0)
    return a;
  if (!EK(e))
    return e;
  var m = wK(e);
  if (m) {
    if (a = yK(e), !s)
      return mK(e, a);
  } else {
    var g = bK(e), p = g == Up || g == HK;
    if (TK(e))
      return hK(e, s);
    if (g == Gp || g == jp || p && !i) {
      if (a = l || p ? {} : CK(e), !s)
        return l ? fK(e, cK(a, e)) : pK(e, dK(a, e));
    } else {
      if (!De[g])
        return i ? e : {};
      a = _K(e, g, s);
    }
  }
  r || (r = new aK());
  var T = r.get(e);
  if (T)
    return T;
  r.set(e, a), SK(e) ? e.forEach(function(E) {
    a.add(gs(E, t, n, E, e, r));
  }) : kK(e) && e.forEach(function(E, P) {
    a.set(P, gs(E, t, n, P, e, r));
  });
  var M = u ? l ? vK : gK : l ? AK : MK, C = m ? void 0 : M(e);
  return lK(C || e, function(E, P) {
    C && (P = E, E = e[P]), uK(a, P, gs(E, t, n, P, e, r));
  }), a;
}
var tZ = gs, nZ = tZ, oZ = 1, rZ = 4;
function iZ(e) {
  return nZ(e, oZ | rZ);
}
var sZ = iZ;
const zp = /* @__PURE__ */ Er(sZ), aZ = {
  news: {
    cover_image: [
      {
        url: "cover_image",
        alt_text: "image_description",
        image_focal_point_x: "image_focal_point_x",
        image_focal_point_y: "image_focal_point_y"
      }
    ],
    title: "title",
    snippet: "snippet",
    author: "author",
    time_ago: "time_ago",
    date: ["published_at"],
    time: ["published_at"]
  },
  events: {
    title: "title",
    description: "description",
    venue: "venue",
    date: ["formatted_start", "formatted_end", "all_day"],
    time: ["formatted_start", "formatted_end", "all_day"]
  },
  all_events: {
    title: "title",
    description: "description",
    venue: "venue",
    date: ["formatted_start", "formatted_end", "all_day"],
    time: ["formatted_start", "formatted_end", "all_day"]
  },
  live_feed: {
    status: "status",
    author: "author",
    avatar: "avatar",
    time_ago: "time_ago",
    date: ["time"],
    live_feed_images: "live_feed_images",
    time: ["time"]
  },
  athletics: {
    title: "title",
    home_team: "home_team",
    home_score: "home_score",
    away_team: "away_team",
    away_score: "away_score",
    date: ["formatted_date"],
    time: ["formatted_date"],
    address: "address",
    versus: "versus",
    filter_name: "filter_name"
  },
  dining: {
    breakfast: "breakfast",
    lunch: "lunch"
  }
}, d1 = (e, t, n) => {
  const o = Object.entries(t).reduce((i, [r, a]) => (a instanceof Array ? i[r] = Object.values(d1(e, a)) : a instanceof Object ? i[r] = d1(e, a) : a in e && (i[r] = e[a]), i), {});
  return n && ["events", "all_events", "news", "live_feed"].includes(n.DATA_TYPE) ? Z1(Tn({}, o), { entry_url: uZ(e, n) }) : o;
}, lZ = (e, t) => {
  if (!e) throw new Error("No data source found.");
  const n = aZ[[t.DATA_TYPE]];
  return e.map((o) => d1(o, n, t));
}, uZ = (e, t) => {
  const n = {
    all_events: "events",
    news: "article",
    live_feed: "live-feed"
  }[t.DATA_TYPE] || t.DATA_TYPE, o = `${t.PATH_PREFIX}/${n}`;
  switch (n) {
    case "events":
      return `${o}?id=${e.id}`;
    case "article":
      return `${o}/${e.id}`;
    case "live-feed":
      return `${o}#${e.id}`;
    default:
      return o;
  }
}, dZ = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, cZ = (e, t, n) => {
  let o;
  const i = dZ[e];
  return typeof i == "string" ? o = i : t === 1 ? o = i.one : o = i.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function wl(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const hZ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, mZ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, pZ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, fZ = {
  date: wl({
    formats: hZ,
    defaultWidth: "full"
  }),
  time: wl({
    formats: mZ,
    defaultWidth: "full"
  }),
  dateTime: wl({
    formats: pZ,
    defaultWidth: "full"
  })
}, gZ = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, vZ = (e, t, n, o) => gZ[e];
function Wr(e) {
  return (t, n) => {
    const o = n != null && n.context ? String(n.context) : "standalone";
    let i;
    if (o === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      i = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[s] || e.values[a];
    }
    const r = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[r];
  };
}
const bZ = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, yZ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, _Z = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, CZ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, wZ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, TZ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, kZ = (e, t) => {
  const n = Number(e), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, EZ = {
  ordinalNumber: kZ,
  era: Wr({
    values: bZ,
    defaultWidth: "wide"
  }),
  quarter: Wr({
    values: yZ,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Wr({
    values: _Z,
    defaultWidth: "wide"
  }),
  day: Wr({
    values: CZ,
    defaultWidth: "wide"
  }),
  dayPeriod: Wr({
    values: wZ,
    defaultWidth: "wide",
    formattingValues: TZ,
    defaultFormattingWidth: "wide"
  })
};
function qr(e) {
  return (t, n = {}) => {
    const o = n.width, i = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], r = t.match(i);
    if (!r)
      return null;
    const a = r[0], s = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? MZ(s, (g) => g.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      SZ(s, (g) => g.test(a))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(u)
    ) : u;
    const m = t.slice(a.length);
    return { value: u, rest: m };
  };
}
function SZ(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function MZ(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function AZ(e) {
  return (t, n = {}) => {
    const o = t.match(e.matchPattern);
    if (!o) return null;
    const i = o[0], r = t.match(e.parsePattern);
    if (!r) return null;
    let a = e.valueCallback ? e.valueCallback(r[0]) : r[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(i.length);
    return { value: a, rest: s };
  };
}
const $Z = /^(\d+)(th|st|nd|rd)?/i, IZ = /\d+/i, DZ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, LZ = {
  any: [/^b/i, /^(a|c)/i]
}, OZ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, NZ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, PZ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, HZ = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, FZ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, RZ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, BZ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, VZ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, jZ = {
  ordinalNumber: AZ({
    matchPattern: $Z,
    parsePattern: IZ,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: qr({
    matchPatterns: DZ,
    defaultMatchWidth: "wide",
    parsePatterns: LZ,
    defaultParseWidth: "any"
  }),
  quarter: qr({
    matchPatterns: OZ,
    defaultMatchWidth: "wide",
    parsePatterns: NZ,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: qr({
    matchPatterns: PZ,
    defaultMatchWidth: "wide",
    parsePatterns: HZ,
    defaultParseWidth: "any"
  }),
  day: qr({
    matchPatterns: FZ,
    defaultMatchWidth: "wide",
    parsePatterns: RZ,
    defaultParseWidth: "any"
  }),
  dayPeriod: qr({
    matchPatterns: BZ,
    defaultMatchWidth: "any",
    parsePatterns: VZ,
    defaultParseWidth: "any"
  })
}, UZ = {
  code: "en-US",
  formatDistance: cZ,
  formatLong: fZ,
  formatRelative: vZ,
  localize: EZ,
  match: jZ,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let GZ = {};
function Ma() {
  return GZ;
}
const Kp = 6048e5, zZ = 864e5, Zp = 6e4, xp = 36e5;
function nn(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Zh(e) {
  const t = nn(e);
  return t.setHours(0, 0, 0, 0), t;
}
function xh(e) {
  const t = nn(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function KZ(e, t) {
  const n = Zh(e), o = Zh(t), i = +n - xh(n), r = +o - xh(o);
  return Math.round((i - r) / zZ);
}
function $o(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function ZZ(e) {
  const t = nn(e), n = $o(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function xZ(e) {
  const t = nn(e);
  return KZ(t, ZZ(t)) + 1;
}
function Ti(e, t) {
  var n, o, i, r, a, s, l, u;
  const m = Ma(), g = (u = (l = (r = (i = t == null ? void 0 : t.weekStartsOn) != null ? i : (o = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : o.weekStartsOn) != null ? r : m.weekStartsOn) != null ? l : (s = (a = m.locale) == null ? void 0 : a.options) == null ? void 0 : s.weekStartsOn) != null ? u : 0, p = nn(e), T = p.getDay(), M = (T < g ? 7 : 0) + T - g;
  return p.setDate(p.getDate() - M), p.setHours(0, 0, 0, 0), p;
}
function Ks(e) {
  return Ti(e, { weekStartsOn: 1 });
}
function Wp(e) {
  const t = nn(e), n = t.getFullYear(), o = $o(e, 0);
  o.setFullYear(n + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const i = Ks(o), r = $o(e, 0);
  r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0);
  const a = Ks(r);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function WZ(e) {
  const t = Wp(e), n = $o(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), Ks(n);
}
function qZ(e) {
  const t = nn(e), n = +Ks(t) - +WZ(t);
  return Math.round(n / Kp) + 1;
}
function qp(e, t) {
  var n, o, i, r, a, s, l, u;
  const m = nn(e), g = m.getFullYear(), p = Ma(), T = (u = (l = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) != null ? i : (o = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : o.firstWeekContainsDate) != null ? r : p.firstWeekContainsDate) != null ? l : (s = (a = p.locale) == null ? void 0 : a.options) == null ? void 0 : s.firstWeekContainsDate) != null ? u : 1, M = $o(e, 0);
  M.setFullYear(g + 1, 0, T), M.setHours(0, 0, 0, 0);
  const C = Ti(M, t), E = $o(e, 0);
  E.setFullYear(g, 0, T), E.setHours(0, 0, 0, 0);
  const P = Ti(E, t);
  return m.getTime() >= C.getTime() ? g + 1 : m.getTime() >= P.getTime() ? g : g - 1;
}
function YZ(e, t) {
  var n, o, i, r, a, s, l, u;
  const m = Ma(), g = (u = (l = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) != null ? i : (o = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : o.firstWeekContainsDate) != null ? r : m.firstWeekContainsDate) != null ? l : (s = (a = m.locale) == null ? void 0 : a.options) == null ? void 0 : s.firstWeekContainsDate) != null ? u : 1, p = qp(e, t), T = $o(e, 0);
  return T.setFullYear(p, 0, g), T.setHours(0, 0, 0, 0), Ti(T, t);
}
function XZ(e, t) {
  const n = nn(e), o = +Ti(n, t) - +YZ(n, t);
  return Math.round(o / Kp) + 1;
}
function ke(e, t) {
  const n = e < 0 ? "-" : "", o = Math.abs(e).toString().padStart(t, "0");
  return n + o;
}
const Bn = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
    return ke(t === "yy" ? o % 100 : o, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : ke(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return ke(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return ke(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return ke(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return ke(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return ke(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, o = e.getMilliseconds(), i = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return ke(i, t.length);
  }
}, qo = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Wh = {
  // Era
  G: function(e, t, n) {
    const o = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const o = e.getFullYear(), i = o > 0 ? o : 1 - o;
      return n.ordinalNumber(i, { unit: "year" });
    }
    return Bn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, o) {
    const i = qp(e, o), r = i > 0 ? i : 1 - i;
    if (t === "YY") {
      const a = r % 100;
      return ke(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(r, { unit: "year" }) : ke(r, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Wp(e);
    return ke(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return ke(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(o);
      case "QQ":
        return ke(o, 2);
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(o);
      case "qq":
        return ke(o, 2);
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Bn.M(e, t);
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const o = e.getMonth();
    switch (t) {
      case "L":
        return String(o + 1);
      case "LL":
        return ke(o + 1, 2);
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, o) {
    const i = XZ(e, o);
    return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : ke(i, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const o = qZ(e);
    return t === "Io" ? n.ordinalNumber(o, { unit: "week" }) : ke(o, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Bn.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const o = xZ(e);
    return t === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : ke(o, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const o = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, o) {
    const i = e.getDay(), r = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(r);
      case "ee":
        return ke(r, 2);
      case "eo":
        return n.ordinalNumber(r, { unit: "day" });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, o) {
    const i = e.getDay(), r = (i - o.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(r);
      case "cc":
        return ke(r, t.length);
      case "co":
        return n.ordinalNumber(r, { unit: "day" });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const o = e.getDay(), i = o === 0 ? 7 : o;
    switch (t) {
      case "i":
        return String(i);
      case "ii":
        return ke(i, t.length);
      case "io":
        return n.ordinalNumber(i, { unit: "day" });
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const o = e.getHours();
    let i;
    switch (o === 12 ? i = qo.noon : o === 0 ? i = qo.midnight : i = o / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const o = e.getHours();
    let i;
    switch (o >= 17 ? i = qo.evening : o >= 12 ? i = qo.afternoon : o >= 4 ? i = qo.morning : i = qo.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let o = e.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return Bn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Bn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const o = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : ke(o, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let o = e.getHours();
    return o === 0 && (o = 24), t === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : ke(o, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Bn.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Bn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Bn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const o = e.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (t) {
      case "X":
        return Yh(o);
      case "XXXX":
      case "XX":
        return vo(o);
      case "XXXXX":
      case "XXX":
      default:
        return vo(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Yh(o);
      case "xxxx":
      case "xx":
        return vo(o);
      case "xxxxx":
      case "xxx":
      default:
        return vo(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + qh(o, ":");
      case "OOOO":
      default:
        return "GMT" + vo(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const o = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + qh(o, ":");
      case "zzzz":
      default:
        return "GMT" + vo(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const o = Math.trunc(e.getTime() / 1e3);
    return ke(o, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const o = e.getTime();
    return ke(o, t.length);
  }
};
function qh(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), i = Math.trunc(o / 60), r = o % 60;
  return r === 0 ? n + String(i) : n + String(i) + t + ke(r, 2);
}
function Yh(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + ke(Math.abs(e) / 60, 2) : vo(e, t);
}
function vo(e, t = "") {
  const n = e > 0 ? "-" : "+", o = Math.abs(e), i = ke(Math.trunc(o / 60), 2), r = ke(o % 60, 2);
  return n + i + t + r;
}
const Xh = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Yp = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, QZ = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], o = n[1], i = n[2];
  if (!i)
    return Xh(e, t);
  let r;
  switch (o) {
    case "P":
      r = t.dateTime({ width: "short" });
      break;
    case "PP":
      r = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      r = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      r = t.dateTime({ width: "full" });
      break;
  }
  return r.replace("{{date}}", Xh(o, t)).replace("{{time}}", Yp(i, t));
}, JZ = {
  p: Yp,
  P: QZ
}, ex = /^D+$/, tx = /^Y+$/, nx = ["D", "DD", "YY", "YYYY"];
function ox(e) {
  return ex.test(e);
}
function rx(e) {
  return tx.test(e);
}
function ix(e, t, n) {
  const o = sx(e, t, n);
  if (console.warn(o), nx.includes(e)) throw new RangeError(o);
}
function sx(e, t, n) {
  const o = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function ax(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function lx(e) {
  if (!ax(e) && typeof e != "number")
    return !1;
  const t = nn(e);
  return !isNaN(Number(t));
}
const ux = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, dx = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, cx = /^'([^]*?)'?$/, hx = /''/g, mx = /[a-zA-Z]/;
function px(e, t, n) {
  var o, i, r, a, s, l, u, m, g;
  const p = Ma(), T = (o = p.locale) != null ? o : UZ, M = (s = (a = p.firstWeekContainsDate) != null ? a : (r = (i = p.locale) == null ? void 0 : i.options) == null ? void 0 : r.firstWeekContainsDate) != null ? s : 1, C = (g = (m = p.weekStartsOn) != null ? m : (u = (l = p.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) != null ? g : 0, E = nn(e);
  if (!lx(E))
    throw new RangeError("Invalid time value");
  let P = t.match(dx).map((D) => {
    const H = D[0];
    if (H === "p" || H === "P") {
      const B = JZ[H];
      return B(D, T.formatLong);
    }
    return D;
  }).join("").match(ux).map((D) => {
    if (D === "''")
      return { isToken: !1, value: "'" };
    const H = D[0];
    if (H === "'")
      return { isToken: !1, value: fx(D) };
    if (Wh[H])
      return { isToken: !0, value: D };
    if (H.match(mx))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + H + "`"
      );
    return { isToken: !1, value: D };
  });
  T.localize.preprocessor && (P = T.localize.preprocessor(E, P));
  const F = {
    firstWeekContainsDate: M,
    weekStartsOn: C,
    locale: T
  };
  return P.map((D) => {
    if (!D.isToken) return D.value;
    const H = D.value;
    (rx(H) || ox(H)) && ix(H, t, String(e));
    const B = Wh[H[0]];
    return B(E, H, T.localize, F);
  }).join("");
}
function fx(e) {
  const t = e.match(cx);
  return t ? t[1].replace(hx, "'") : e;
}
function gx(e, t) {
  const n = _x(e);
  let o;
  if (n.date) {
    const s = Cx(n.date, 2);
    o = wx(s.restDateString, s.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const i = o.getTime();
  let r = 0, a;
  if (n.time && (r = Tx(n.time), isNaN(r)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (a = kx(n.timezone), isNaN(a))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const s = new Date(i + r), l = /* @__PURE__ */ new Date(0);
    return l.setFullYear(
      s.getUTCFullYear(),
      s.getUTCMonth(),
      s.getUTCDate()
    ), l.setHours(
      s.getUTCHours(),
      s.getUTCMinutes(),
      s.getUTCSeconds(),
      s.getUTCMilliseconds()
    ), l;
  }
  return new Date(i + r + a);
}
const as = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, vx = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, bx = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, yx = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function _x(e) {
  const t = {}, n = e.split(as.dateTimeDelimiter);
  let o;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? o = n[0] : (t.date = n[0], o = n[1], as.timeZoneDelimiter.test(t.date) && (t.date = e.split(as.timeZoneDelimiter)[0], o = e.substr(
    t.date.length,
    e.length
  ))), o) {
    const i = as.timezone.exec(o);
    i ? (t.time = o.replace(i[1], ""), t.timezone = i[1]) : t.time = o;
  }
  return t;
}
function Cx(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), o = e.match(n);
  if (!o) return { year: NaN, restDateString: "" };
  const i = o[1] ? parseInt(o[1]) : null, r = o[2] ? parseInt(o[2]) : null;
  return {
    year: r === null ? i : r * 100,
    restDateString: e.slice((o[1] || o[2]).length)
  };
}
function wx(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const n = e.match(vx);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const o = !!n[4], i = Yr(n[1]), r = Yr(n[2]) - 1, a = Yr(n[3]), s = Yr(n[4]), l = Yr(n[5]) - 1;
  if (o)
    return $x(t, s, l) ? Ex(t, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const u = /* @__PURE__ */ new Date(0);
    return !Mx(t, r, a) || !Ax(t, i) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(t, r, Math.max(i, a)), u);
  }
}
function Yr(e) {
  return e ? parseInt(e) : 1;
}
function Tx(e) {
  const t = e.match(bx);
  if (!t) return NaN;
  const n = Tl(t[1]), o = Tl(t[2]), i = Tl(t[3]);
  return Ix(n, o, i) ? n * xp + o * Zp + i * 1e3 : NaN;
}
function Tl(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function kx(e) {
  if (e === "Z") return 0;
  const t = e.match(yx);
  if (!t) return 0;
  const n = t[1] === "+" ? -1 : 1, o = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return Dx(o, i) ? n * (o * xp + i * Zp) : NaN;
}
function Ex(e, t, n) {
  const o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(e, 0, 4);
  const i = o.getUTCDay() || 7, r = (t - 1) * 7 + n + 1 - i;
  return o.setUTCDate(o.getUTCDate() + r), o;
}
const Sx = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Xp(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Mx(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (Sx[t] || (Xp(e) ? 29 : 28));
}
function Ax(e, t) {
  return t >= 1 && t <= (Xp(e) ? 366 : 365);
}
function $x(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function Ix(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function Dx(e, t) {
  return t >= 0 && t <= 59;
}
function Yt(e, t) {
  const n = e.includes("T") ? e.substring(0, e.lastIndexOf(".")) : e, o = gx(n);
  return px(o, t);
}
function Lx(e, t) {
  return t ? Yt(e, "MMM/dd/yyyy") === Yt(t, "MMM/dd/yyyy") : !0;
}
var Ox = Ni, Nx = $r, Px = "[object Symbol]";
function Hx(e) {
  return typeof e == "symbol" || Nx(e) && Ox(e) == Px;
}
var bu = Hx, Fx = Uo, Rx = bu, Bx = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Vx = /^\w*$/;
function jx(e, t) {
  if (Fx(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || Rx(e) ? !0 : Vx.test(e) || !Bx.test(e) || t != null && e in Object(t);
}
var Ux = jx, Qp = Lp, Gx = "Expected a function";
function yu(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Gx);
  var n = function() {
    var o = arguments, i = t ? t.apply(this, o) : o[0], r = n.cache;
    if (r.has(i))
      return r.get(i);
    var a = e.apply(this, o);
    return n.cache = r.set(i, a) || r, a;
  };
  return n.cache = new (yu.Cache || Qp)(), n;
}
yu.Cache = Qp;
var zx = yu, Kx = zx, Zx = 500;
function xx(e) {
  var t = Kx(e, function(o) {
    return n.size === Zx && n.clear(), o;
  }), n = t.cache;
  return t;
}
var Wx = xx, qx = Wx, Yx = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Xx = /\\(\\)?/g, Qx = qx(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Yx, function(n, o, i, r) {
    t.push(i ? r.replace(Xx, "$1") : o || n);
  }), t;
}), Jx = Qx;
function eW(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, i = Array(o); ++n < o; )
    i[n] = t(e[n], n, e);
  return i;
}
var tW = eW, Qh = _a, nW = tW, oW = Uo, rW = bu, Jh = Qh ? Qh.prototype : void 0, e0 = Jh ? Jh.toString : void 0;
function Jp(e) {
  if (typeof e == "string")
    return e;
  if (oW(e))
    return nW(e, Jp) + "";
  if (rW(e))
    return e0 ? e0.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var iW = Jp, sW = iW;
function aW(e) {
  return e == null ? "" : sW(e);
}
var lW = aW, uW = Uo, dW = Ux, cW = Jx, hW = lW;
function mW(e, t) {
  return uW(e) ? e : dW(e, t) ? [e] : cW(hW(e));
}
var pW = mW, fW = bu;
function gW(e) {
  if (typeof e == "string" || fW(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var vW = gW, bW = pW, yW = vW;
function _W(e, t) {
  t = bW(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[yW(t[n++])];
  return n && n == o ? e : void 0;
}
var CW = _W, wW = CW;
function TW(e, t, n) {
  var o = e == null ? void 0 : wW(e, t);
  return o === void 0 ? n : o;
}
var kW = TW;
const c1 = /* @__PURE__ */ Er(kW), EW = (e, t, n = "date") => {
  if (!(n in e.entries[t]))
    return { type: "text", value: "Error: Value date not found" };
  const [o, i] = e.entries[t][n], r = Lx(o, i) ? "" : Yt(i, "MMM/dd/yyyy"), a = Yt(o, "MMM"), s = Yt(o, "dd"), l = Yt(o, "iiii"), u = Ne("span.date", [
    Ne("span.start-month", a),
    Ne("span.start-date", s),
    Ne("span.start-weekday", l)
  ]);
  if (r) {
    const m = Yt(i, "MMM"), g = Yt(i, "dd"), p = Yt(i, "iiii");
    u.children = u.children.concat(
      Ne("span.date-separator", "-"),
      Ne("span.end-month", m),
      Ne("span.end-date", g),
      Ne("span.end-weekday", p)
    );
  }
  return u;
}, SW = (e, t, n = "date") => {
  if (!(n in e.entries[t]))
    return { type: "text", value: "Error: Value time not found" };
  const [o, i, r] = e.entries[t][n];
  let a;
  const s = Yt(o, "h:mmaaa");
  if (r)
    return Ne("span.time", Ne("span.start-time", "All day"));
  const l = Ne("span.time", [Ne("span.start-time", s)]);
  return i && (a = Yt(i, "h:mmaaa"), l.children = l.children.concat(Ne("span.time-separator", "-"), Ne("span.end-time", a))), l;
}, t0 = (e, t, n) => {
  let o = e.entries[t][n];
  return (o.length === 0 || !o[0].url) && (o = [{ url: c1(e, "fallback_image.url", "") }]), Ne(
    `div.${n.replace(/_/g, "-")}`,
    o.map(
      (i, r) => Ne(`img.entry-${t}-img-${r}`, {
        src: i.url,
        alt: i.alt_text || "",
        style: i.image_focal_point_x && i.image_focal_point_y ? { "object-position": `${i.image_focal_point_x || 50}% ${i.image_focal_point_y || 50}%` } : void 0
      })
    )
  );
}, MW = (e, t, n) => {
  const o = e.split("|");
  for (let i = 0; i < o.length; i++) {
    const r = o[i], a = c1(t.entries[n], r, c1(t, r, void 0));
    if (a !== void 0) return a;
  }
};
function AW(e) {
  const t = {
    type: "element",
    tagName: "a",
    properties: {
      href: e.link_url,
      target: e.opens_in_new_tab,
      class: "automatic-schools-menu-image-a"
    }
  }, n = {
    type: "element",
    tagName: "img",
    properties: {
      src: e.url,
      class: "automatic-schools-menu-image-img",
      alt: e.alt_text,
      width: `${e.width}`,
      height: `${e.height}`
    }
  };
  return e.action_on_click === "no_action" ? n : (t.children = [n], t);
}
const h1 = "default", ef = "children", _u = (e, t, n, o = {}, i) => e ? e.tagName === ef ? DW(e, t, n, o, i) : IW(e, t, n, o, i) : null, $W = (e) => {
  const t = {
    [h1]: Ne(null, [new Ne("div", ["{{name|url}}", new Ne(ef)])])
  }, n = { templates: t, children: [] };
  return (e.children || []).forEach((o) => {
    var i, r;
    if (o.tagName === "template") {
      const a = Ne(null, [...((i = o.content) == null ? void 0 : i.children) || []]), s = ((r = o.properties) == null ? void 0 : r.type) || h1;
      t[s] = a;
    } else
      n.children.push(o);
  }), n;
}, IW = (e, t, n, o, i) => (e.tagName && (e.properties.className = [
  ...Array.isArray(e.properties.className) ? e.properties.className : [],
  `${e.tagName}-${t.class || ""}`
]), Array.isArray(e.children) && (e.children = e.children.map((r) => _u(r, t, n, o, i)).filter(Boolean)), e), DW = (e, t, n, o, i) => {
  if (!n || n.length === 0)
    return null;
  const { startRange: r, endRange: a } = OW(e.properties, n.length), { templates: s, children: l } = $W(e), u = Tn(Tn({}, o), s);
  e.children = l;
  const m = new Ne(null, []);
  for (let g = r; g < a; g++) {
    const p = Tn(Tn({}, t), n[g]), T = zp(u[p.type] || u[h1]);
    if (!T) continue;
    LW(p, t.class), _u(T, Z1(Tn({}, t), { class: p.class }), p.children, u, i);
    const M = i(T, Tn(Tn({}, t), p));
    M && m.children.push(M);
  }
  return m;
}, LW = (e, t) => {
  if (Array.isArray(e.children)) {
    const n = `${t}-${(e.name || "").replace(/\W/g, "").toLowerCase()}`;
    e.children.forEach((o) => {
      o.class = n;
    });
  }
}, OW = (e, t) => {
  let n = 0, o = t;
  if (e != null && e.idx)
    n = Number(e.idx), o = n + 1;
  else if (e != null && e.loop) {
    const [i, r] = (e.loop.match(/\d+/g) || []).map(Number);
    n = i || 0, o = r || t;
  }
  return { startRange: n, endRange: o };
}, n0 = "loop", kl = (e) => parseInt(e, 10), tf = (e) => e.substr(2, e.length - 4).trim(), NW = (e) => kl(e) ? [0, kl(e)] : e.replace(/[()]/g, "").split(", ").map(kl), o0 = {
  "cms-header-menu": (e, t) => {
    const n = t.menus[e.properties.entity].entries;
    return t.class = e.properties.entity, _u(e, t, n, {}, vr), vr(e, t);
  },
  "cms-sign-in-button": (e, t) => {
    const { signInButtonText: n, showSignInButton: o, signInUrl: i } = t, r = o ? Ne(
      "a",
      {
        href: i,
        className: ["sign-in"],
        target: "_blank",
        "aria-label": `${n} (opens ${i} in a new tab)`
      },
      n
    ) : Ne(null);
    return Ne(null, [r]);
  }
}, Gn = {
  DATA_TYPE: "",
  PATH_PREFIX: "",
  reservedTagParser: () => {
  },
  mappingFn: () => {
  }
}, PW = ["cms-media", "cms-header-menu", "cms-sign-in-button"], HW = (e) => {
  const t = {
    "&#x26;lt;": "<",
    "&#x3C;": "<",
    "&#x26;gt;": ">"
  }, n = new RegExp(Object.keys(t).join("|"), "gi");
  return e.replace(n, (o) => t[o]);
}, nf = (e, t, n) => {
  const o = "{{", i = "}}", r = /{{([^{][\s\S]+?[^}])}}/g, a = e.toString().match(r);
  if (!a)
    return e;
  const s = a.map((l) => {
    const u = l.indexOf(o), m = l.lastIndexOf(i);
    if (u !== 0 && !u || !m || m < u)
      throw new Error(`Syntax error at ${l}`);
    const g = tf(l), p = Gn.mappingFn(g, t, n);
    if (p == null)
      throw new Error(`Value ${g} not found`);
    return p;
  });
  return a.reduce((l, u, m) => l.replace(u, s[m]), e);
}, vr = (e, t, n = -1) => {
  let o = zp(e);
  const i = (s) => s.type === "text", r = (s) => s.type === "element", a = (s) => s.children && s.children.length > 0;
  if (!a(e) && i(e)) {
    const s = r0(e, t, n);
    s.length === 1 ? r(s[0]) ? o = s[0] : o.value = s[0].value : s.length > 1 && (o = Ne("span", s));
  }
  if (a(e)) {
    const s = (l) => l.tagName && PW.includes(l.tagName) && l.children;
    o.children = e.children.reduce((l, u) => {
      if (i(u))
        return [...l, ...r0(u, t, n)];
      if (s(u)) {
        if (typeof o0[u.tagName] == "function") {
          const m = o0[u.tagName](u, t);
          return [...l, ...m.children];
        }
        return Gn.reservedTagParser(l, u, n, t);
      }
      return [...l, vr(u, t, n)];
    }, []);
  }
  return ((s) => !hV(s.properties))(e) && (o.properties = Object.fromEntries(
    Object.entries(e.properties).map(([s, l]) => [s, nf(l, t, n)])
  )), o;
}, FW = (e, t, n, o) => {
  let i = n;
  if (t.properties.idx) {
    i = t.properties.idx;
    const r = t.children.map((a) => vr(a, o, i));
    return [...e, ...r];
  }
  if (t.properties[n0]) {
    const [r, a] = NW(t.properties[n0]);
    let s = 0;
    a > 0 ? s = a > o.entries.length ? o.entries.length : a + r : s = o.entries.length;
    let l = [];
    for (let u = r; u < s; u++)
      l = l.concat(t.children.map((m) => vr(m, o, u)));
    return [...e, ...l];
  }
}, of = (e, t, n) => {
  if (!t)
    throw new Error("Data type must be specified, eg. news, live_feed, athletics, events, or dining");
  if (!n)
    throw new Error("Data source is missing.");
  Gn.DATA_TYPE = t, Gn.PATH_PREFIX = n.path_prefix, Gn.reservedTagParser = FW, Gn.mappingFn = MW;
  const o = lZ(n.entries, Gn), i = (l) => l == "all_events" ? "events" : l.replace(/_/g, "-"), r = `${Gn.PATH_PREFIX}/${i(t)}`, a = e1().use(up, { fragment: !0, emitParseErrors: !0, duplicateAttribute: !1 }).use(pp).parse(e), s = vr(a, Z1(Tn({}, n), { section_page_url: r, entries: o }));
  return HW(e1().use(yF).stringify(s));
};
function r0(e, t, n) {
  const o = /({{[^{][\s\S]+?[^}]}})/g, i = e.value.trim().split(o).filter((a) => a != ""), r = {
    date: EW,
    time: SW,
    cover_image: t0,
    live_feed_images: t0,
    schoolMenuImage: AW,
    default: function(a, s, l) {
      return { type: "text", value: nf(`{{${l}}}`, a, s) };
    }
  };
  return i.map((a) => {
    if (a.match(o)) {
      const s = tf(a);
      return r[s] ? r[s](t, n, s) : r.default(t, n, s);
    } else
      return { type: "text", value: a };
  });
}
const RW = (e) => e1().use(up, { fragment: !0, emitParseErrors: !0 }).use(pp).parse(e), BW = {
  name: "CustomHtml",
  props: {
    theme: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      componentKey: 0
    };
  },
  computed: {
    cssCode() {
      return this.theme.css_code;
    },
    jsCode() {
      return this.theme.js_code;
    },
    htmlCode() {
      return this.theme.html_code;
    }
  },
  watch: {
    cssCode(e, t) {
      this.hasNewValue(e, t) && this.mountCss(e);
    },
    jsCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(e);
    },
    htmlCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(this.jsCode);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mountCss(this.cssCode), this.mountJs(this.jsCode);
    });
  },
  methods: {
    hasNewValue(e, t) {
      return e && e.localeCompare && e.localeCompare(t) !== 0;
    },
    mountCss(e) {
      if (!e)
        return;
      this.removeElementIfExists("style");
      const t = document.createElement("style");
      t.type = "text/css", t.appendChild(document.createTextNode(e)), this.$refs.container.appendChild(t);
    },
    mountJs(e) {
      this.componentKey += 1, this.$nextTick(() => {
        if (!e || !this.$refs.container)
          return;
        this.removeElementIfExists("script");
        const t = document.createElement("script");
        t.type = "text/javascript", t.appendChild(document.createTextNode(e)), this.$refs.container.appendChild(t);
      });
    },
    removeElementIfExists(e) {
      const t = document.querySelector(`#${this.id} ${e}`);
      t && t.remove();
    }
  }
}, VW = ["id"], jW = ["innerHTML"];
function UW(e, t, n, o, i, r) {
  return d(), h("div", {
    id: n.theme.container_id,
    ref: "container",
    class: "custom-html"
  }, [
    (d(), h("div", {
      ref: "html_code",
      key: i.componentKey,
      innerHTML: r.htmlCode
    }, null, 8, jW))
  ], 8, VW);
}
const Aa = /* @__PURE__ */ O(BW, [["render", UW], ["__scopeId", "data-v-20687f05"]]), GW = {
  name: "Custom",
  components: {
    CustomHtml: Aa
  },
  mixins: [et],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    processedTheme() {
      var t, n, o, i;
      let e = "";
      try {
        const r = [], a = {
          schoolName: this.content.globals.info.school_name,
          schoolLogo: this.content.globals.logo.url || "",
          schoolTagline: this.content.globals.info.school_tag_line || "",
          schoolPath: this.content.pathPrefix || "/",
          langCode: this.content.langCode,
          langText: "",
          signInButtonText: this.signInText,
          showSignInButton: this.showSignInButton,
          signInUrl: this.signInUrl
        };
        this.content.languages.forEach((m) => {
          m.code === this.content.langCode && (a.langText = m.language), r.push(he(ie({}, m), { name: m.language }));
        });
        const s = this.formatItems(this.content.sitemapMenuItems), l = ((i = (o = (n = (t = this.content.globals) == null ? void 0 : t.homepage) == null ? void 0 : n.schools_menu) == null ? void 0 : o.menu) == null ? void 0 : i.flat()) || rm.menu.flat(), u = {
          siteMenu: {
            dataType: "siteMenu",
            entries: s
          },
          schoolsCustomMenu: {
            dataType: "schoolsCustomMenu",
            entries: this.formatItems(l)
          },
          schoolsMenu: {
            dataType: "schoolsMenu",
            entries: this.formatItems(this.content.organizations, "schoolsMenu")
          },
          languages: {
            dataType: "languages",
            entries: r
          }
        };
        e = of(this.theme.customData.htmlCode, "header", he(ie({}, a), { entries: [], menus: u }));
      } catch (r) {
        e = r;
      }
      return he(ie({}, this.theme), {
        html_code: e,
        css_code: this.theme.customData.cssCode,
        js_code: this.theme.customData.jsCode
      });
    }
  },
  methods: {
    formatItems(e, t) {
      const n = this.formatItems;
      return e.map((o) => {
        let i = ie({}, o);
        const r = {
          SchoolsMenuLink: (s) => (s.opens_in_new_tab = s.opens_in_new_tab ? "_blank" : "_self", s.url = s.link || "", s.url = s.url.toLowerCase().replace(/\s/g, "-"), s),
          SchoolsMenuImage: (s) => (s.opens_in_new_tab = s.open_in_new_tab ? "_blank" : "_self", s.url = s.url.toLowerCase().replace(/\s/g, "-"), s.height = s.preferred_height || "auto", s.width = s.preferred_width || "auto", s.alignment = s.image_alignment, s),
          link: (s) => (s.opens_in_new_tab = s.opens_in_new_tab ? "_blank" : "_self", s.url = s.mailto ? `mailto:${s.email_address}` : s.url, s.url = s.url.toLowerCase().replace(/\s/g, "-"), s.ipAddress = s.ipAddress || "", s.email_address = s.email_address || "", s),
          SchoolsMenuOrg: (s) => (s.alias = s.alias || "", s.link = s.link || "", s.link = s.link.toLowerCase().replace(/\s/g, "-"), s),
          schoolsMenu: (s) => (s.path_prefix = s.path_prefix ? s.path_prefix : "/", s),
          page: (s) => (s.link_path = `${this.content.pathPrefix}/page/${s.slug}`, s)
        }, a = i.type || t;
        return r[a] && (i = r[a](i)), Array.isArray(i.children) && (i.children = n(i.children, t)), i;
      });
    }
  }
}, zW = { class: "header-custom-code" };
function KW(e, t, n, o, i, r) {
  const a = $("CustomHtml");
  return d(), h("div", zW, [
    L(a, { theme: r.processedTheme }, null, 8, ["theme"])
  ]);
}
const ZW = /* @__PURE__ */ O(GW, [["render", KW]]), xW = {
  name: "BarNavItemWrapper",
  components: { MenuElementType: bm, DropdownArrowIcon: kr, HamburgerIcon: j1, PlusIcon: U1 },
  props: {
    item: {
      type: Object,
      default: void 0
    },
    theme: {
      type: Object,
      default: () => {
      }
    },
    content: {
      type: Object,
      default: () => {
      }
    },
    colors: {
      type: Object,
      required: !0
    },
    forceShow: Boolean,
    moreMenuItem: Boolean,
    additionalMenuItem: Boolean,
    moreMenuVisible: Boolean,
    isMoreMenuItem: Boolean,
    activeId: {
      type: [String, Number],
      default: null
    },
    firstItemId: {
      type: Number,
      default: 0
    },
    lastItemId: {
      type: Number,
      default: 0
    }
  },
  emits: [
    "handle-item",
    "handle-enter-event",
    "toggle-drawer",
    "navigate",
    "handle-close",
    "next-tab",
    "focus-sub-menu"
  ],
  computed: {
    isActive() {
      var e;
      return this.moreMenuItem ? this.moreMenuVisible : ((e = this.item) == null ? void 0 : e.id) === this.activeId;
    },
    iconClass() {
      return this.isActive ? "open" : void 0;
    },
    iconColor() {
      return this.isMoreMenuItem ? this.colors["--more-text-color"] : this.colors["--text-color"];
    },
    itemId() {
      return this.moreMenuItem ? "more-menu-item" : this.item ? this.item.id : "";
    },
    hasChildren() {
      var e, t;
      return !!((t = (e = this.item) == null ? void 0 : e.children) != null && t.length);
    },
    buttonTitle() {
      var e, t;
      return ((e = this.item) == null ? void 0 : e.name) || ((t = this.item) == null ? void 0 : t.translatedTitle);
    },
    hasFocusableChildren() {
      var t, n, o;
      const e = (i) => {
        var r;
        return [i, ...((r = i.children) == null ? void 0 : r.map((a) => e(a))) || []].flat();
      };
      return (o = (n = (t = this.item.children) == null ? void 0 : t.map((i) => e(i))) == null ? void 0 : n.flat()) == null ? void 0 : o.filter((i) => i.type !== "header").length;
    },
    isHeader() {
      var e;
      return ((e = this.item) == null ? void 0 : e.type) === "header";
    },
    hasSlug() {
      var e;
      return (e = this.item) == null ? void 0 : e.slug;
    },
    ariaId() {
      return this.moreMenuItem ? "menu-button-more" : `menu-button-${this.item ? this.item.id : ""}`;
    },
    ariaHasPopup() {
      return this.moreMenuItem ? "true" : this.hasChildren ? "dialog" : "false";
    },
    ariaControls() {
      return this.moreMenuItem ? "more-menu-dropdown" : this.hasChildren ? `drawer-${this.item ? this.item.id : ""}` : void 0;
    },
    ariaExpanded() {
      if (this.moreMenuItem)
        return this.moreMenuVisible ? "true" : "false";
      if (this.hasChildren)
        return this.isActive ? "true" : "false";
    }
  },
  methods: {
    handleEnterEvent(e) {
      if (this.moreMenuItem || !this.item) {
        this.$emit("handle-enter-event");
        return;
      }
      if (this.isHeader || this.additionalMenuItem || e) {
        this.$emit("toggle-drawer", this.item);
        return;
      }
      this.$emit("navigate", this.item);
    },
    handleNextTab(e, t) {
      var s, l;
      const n = e.shiftKey, o = this.isActive, i = this.activeId && o, r = ((s = this.item) == null ? void 0 : s.id) === this.firstItemId, a = ((l = this.item) == null ? void 0 : l.id) === this.lastItemId;
      if (n) {
        if (this.isMoreMenuItem && r && !t) {
          this.$emit("handle-close");
          return;
        }
        if (!this.isMoreMenuItem && o) {
          this.$emit("handle-close");
          return;
        }
        if (a && t && this.hasChildren && i) {
          this.$emit("handle-close");
          return;
        }
      } else {
        if (this.moreMenuItem) return;
        if (i && (t && this.hasFocusableChildren || this.isHeader)) {
          this.$emit("focus-sub-menu", this.item);
          return;
        }
        this.hasFocusableChildren === 0 && !this.isMoreMenuItem && o && this.$emit("handle-close"), a && (!this.hasChildren || t && this.hasChildren && !i) && this.$emit("handle-close");
      }
    }
  }
}, WW = ["id"], qW = ["aria-expanded", "aria-haspopup", "aria-controls"], YW = {
  class: "menu-item-focusable",
  tabindex: "-1"
}, XW = { class: "sr-only" }, QW = ["aria-expanded", "aria-haspopup", "aria-controls"], JW = { class: "sr-only" };
function eq(e, t, n, o, i, r) {
  const a = $("MenuElementType"), s = $("DropdownArrowIcon");
  return n.forceShow || n.moreMenuItem || n.additionalMenuItem || n.item ? (d(), h("div", {
    key: 0,
    id: r.itemId,
    ref: r.itemId,
    class: v(["bar-menu-item", {
      "menu-dropdown-item": n.isMoreMenuItem,
      "menu-item-active": !n.isMoreMenuItem && r.isActive
    }]),
    "data-testid": "menu-item",
    onMouseover: t[8] || (t[8] = z((l) => e.$emit("handle-item", n.item), ["stop", "prevent"])),
    onTouchstart: t[9] || (t[9] = z((...l) => r.handleEnterEvent && r.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
  }, [
    L(a, {
      id: r.ariaId,
      class: v(["menu-item-text", {
        "menu-dropdown-item-active": r.isActive,
        [n.theme.style]: !!n.theme.style
      }]),
      "path-prefix": n.content.pathPrefix,
      "more-menu-title": n.theme.translations.more_dropdown_title,
      "more-menu-visible": n.moreMenuVisible,
      "fill-color": n.colors["--dropdown-text-color"],
      item: n.item,
      "aria-expanded": r.ariaExpanded,
      "aria-has-popup": r.ariaHasPopup,
      "aria-controls": r.ariaControls,
      onKeydown: [
        V(r.handleEnterEvent, ["enter"]),
        t[0] || (t[0] = V((l) => r.handleNextTab(l, !1), ["tab"]))
      ],
      onTouchstart: z(r.handleEnterEvent, ["exact", "stop", "prevent"])
    }, null, 8, ["id", "class", "path-prefix", "more-menu-title", "more-menu-visible", "fill-color", "item", "aria-expanded", "aria-has-popup", "aria-controls", "onKeydown", "onTouchstart"]),
    !r.isHeader && r.hasChildren && r.itemId !== "explore-button" && r.itemId !== "schoolsbutton" ? (d(), h("button", {
      key: 0,
      class: "menu-item-icon",
      "aria-expanded": r.ariaExpanded,
      "aria-haspopup": r.ariaHasPopup,
      "aria-controls": r.ariaControls,
      onKeydown: t[1] || (t[1] = V((l) => r.handleNextTab(l, !0), ["tab"])),
      onTouchstart: t[2] || (t[2] = z((l) => r.handleEnterEvent(!0), ["exact", "stop", "prevent"])),
      onClick: t[3] || (t[3] = z((l) => r.handleEnterEvent(!0), ["stop", "prevent"]))
    }, [
      c("span", YW, [
        L(s, {
          "dropdown-class": r.iconClass,
          "fill-color": r.iconColor
        }, null, 8, ["dropdown-class", "fill-color"]),
        c("span", XW, " Show submenu for " + y(r.buttonTitle) + " button", 1)
      ])
    ], 40, qW)) : b("", !0),
    r.isHeader || n.moreMenuItem || n.additionalMenuItem ? (d(), h(Y, { key: 1 }, [
      n.moreMenuItem || n.additionalMenuItem || r.hasChildren ? (d(), h("button", {
        key: 0,
        class: v(["menu-item-icon", n.item.id]),
        "aria-expanded": r.ariaExpanded,
        "aria-haspopup": r.ariaHasPopup,
        "aria-controls": r.ariaControls,
        onMouseover: t[4] || (t[4] = z(() => {
        }, ["stop", "prevent"])),
        onTouchstart: t[5] || (t[5] = z((...l) => r.handleEnterEvent && r.handleEnterEvent(...l), ["exact", "stop", "prevent"])),
        onKeydown: t[6] || (t[6] = V((l) => r.handleNextTab(l, !0), ["tab"])),
        onClick: t[7] || (t[7] = z((...l) => r.handleEnterEvent && r.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
      }, [
        n.item.id === "explore-button" ? (d(), k(K(n.item.icon), {
          key: 0,
          "fill-color": n.item.colors["--bg-color"],
          "fill-path-color": r.iconColor
        }, null, 8, ["fill-color", "fill-path-color"])) : (d(), k(s, {
          key: 1,
          "dropdown-class": r.iconClass,
          "fill-color": r.iconColor
        }, null, 8, ["dropdown-class", "fill-color"])),
        c("span", JW, " Show submenu for " + y(n.item.name || n.item.translatedTitle), 1)
      ], 42, QW)) : b("", !0)
    ], 64)) : b("", !0)
  ], 42, WW)) : b("", !0);
}
const rf = /* @__PURE__ */ O(xW, [["render", eq], ["__scopeId", "data-v-f89846d5"]]), tq = {
  name: "BarNavDrawer",
  components: { BarNavDrawerItem: ym },
  mixins: [et],
  props: {
    activeItem: {
      type: Object,
      default: void 0
    },
    currentDomain: {
      type: String,
      default: null
    },
    isMoreMenuActive: Boolean,
    isOpen: Boolean,
    isTemporarilyHideMenu: Boolean,
    isUnderlapped: Boolean
  },
  emits: ["hide-drawer", "handle-close", "prevent-close", "handle-toggle-parent", "next-tab", "navigate"],
  data() {
    return {
      activeParent: null,
      scrollWidth: !1
    };
  },
  computed: {
    orgsWithIds() {
      return this.content.organizations.map((t, n) => he(ie({}, t), { id: n + 1 }));
    },
    itemId() {
      return `drawer-${this.activeItem.id}`;
    },
    drawerWidth() {
      return {
        "--drawer-width": this.isUnderlapped ? "100%" : "auto",
        "--left-alignment": this.isUnderlapped ? "46px" : ""
      };
    }
  },
  watch: {
    isOpen(e) {
      if (e) {
        const { scrollWidth: t, clientWidth: n } = this.$refs["drawer-wrapper"];
        t > n && (this.scrollWidth = !0);
      }
    }
  },
  methods: {
    orgLink(e) {
      return Ho(e, {
        isPreview: this.content.isPreview,
        currentDomain: this.currentDomain
      });
    },
    hideDrawer() {
      this.$emit("hide-drawer");
    },
    handleNextTab({ itemId: e, isIconButton: t, isBackwardsTab: n }) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null, this.$emit("handle-toggle-parent", { itemId: e.id });
        return;
      }
      this.activeParent = e.id, this.$emit("handle-toggle-parent", { itemId: e.id });
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    }
  }
}, nq = ["id", "aria-labelledby"], oq = {
  key: 0,
  class: "menu-item-active-line"
}, rq = { key: 0 }, iq = { class: "explore-link" }, sq = ["innerHTML"], aq = ["href", "target", "onKeydown"], lq = { key: 1 }, uq = {
  key: 0,
  class: "basic-schools-dropdown"
}, dq = ["href", "target", "onKeydown"], cq = { key: 2 };
function hq(e, t, n, o, i, r) {
  const a = $("BarNavDrawerItem");
  return d(), h("div", {
    id: r.itemId,
    ref: r.itemId,
    "aria-labelledby": `menu-button-${n.activeItem.id}`,
    "aria-modal": "true",
    class: v(["bar-nav-menu--drawer", [n.activeItem.id]]),
    style: j([r.drawerWidth, { flexDirection: i.scrollWidth ? "column" : "row" }]),
    onMouseleave: t[3] || (t[3] = z((s) => e.$emit("hide-drawer"), ["exact", "stop", "prevent"])),
    onMouseenter: t[4] || (t[4] = (s) => e.$emit("prevent-close"))
  }, [
    c("div", {
      ref: "drawer-wrapper",
      class: v(["bar-nav-menu--drawer-content-wrapper", { scrollWidth: i.scrollWidth }])
    }, [
      L(Ee, { name: "slide-fade-up" }, {
        default: _(() => [
          n.isOpen ? (d(), h("div", oq)) : b("", !0)
        ]),
        _: 1
      }),
      n.activeItem.id === "explore-button" ? (d(), h("div", rq, [
        (d(!0), h(Y, null, ee(e.content.customMenuItems, (s) => (d(), h("div", {
          key: s.id,
          class: "dropdown-with-icons"
        }, [
          c("div", iq, [
            c("span", {
              innerHTML: s.icon || s.icon_cms
            }, null, 8, sq),
            c("a", {
              href: r.getLink(s.url),
              style: j({ color: e.theme.explore_menu_text_color }),
              target: r.targetWindow(s),
              onKeydown: V((l) => r.handleNextTab({ itemId: s.id, isIconButton: !1, isBackwardsTab: l.shiftKey }), ["tab"])
            }, y(s.name), 45, aq)
          ])
        ]))), 128))
      ])) : b("", !0),
      n.activeItem.id === "schoolsbutton" ? (d(), h("div", lq, [
        e.content.hasCustomSchoolsMenu ? b("", !0) : (d(), h("ul", uq, [
          (d(!0), h(Y, null, ee(r.orgsWithIds, (s) => (d(), h("li", {
            key: s.id
          }, [
            c("a", {
              href: r.orgLink(s),
              class: "school-link",
              target: r.targetWindow(s),
              onKeydown: V((l) => r.handleNextTab({ itemId: s.id, isIconButton: !0, isBackwardsTab: l.shiftKey }), ["tab"])
            }, y(s.name), 41, dq)
          ]))), 128))
        ]))
      ])) : b("", !0),
      n.activeItem.id !== "schoolsbutton" && n.activeItem.id !== "explore-button" ? (d(), h("div", cq, [
        (d(!0), h(Y, null, ee(n.activeItem.children, (s) => (d(), k(a, {
          key: s.id,
          "elem-data": s,
          "theme-style": e.theme.style,
          colors: e.colors,
          "active-parent": i.activeParent,
          "path-prefix": e.content.pathPrefix,
          onToggleParent: r.handleToggleParent,
          onHandleClose: t[0] || (t[0] = (l) => e.$emit("handle-close")),
          onNextTab: t[1] || (t[1] = (l) => e.$emit("next-tab", l)),
          onNavigate: t[2] || (t[2] = (l) => e.$emit("navigate", l))
        }, null, 8, ["elem-data", "theme-style", "colors", "active-parent", "path-prefix", "onToggleParent"]))), 128))
      ])) : b("", !0)
    ], 2)
  ], 46, nq);
}
const mq = /* @__PURE__ */ O(tq, [["render", hq], ["__scopeId", "data-v-ab83e199"]]), pq = {
  name: "BarNavMenuDropdown",
  components: { BarNavItemWrapper: rf },
  props: {
    activeId: {
      type: [String, Number],
      default: null
    },
    isVisible: Boolean,
    moreItems: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Object,
      default: null
    },
    theme: {
      type: Object,
      default: null
    },
    content: {
      type: Object,
      default: null
    }
  },
  emits: [
    "prevent-close",
    "handle-enter-event",
    "toggle-drawer",
    "navigate",
    "open-dropdown",
    "handle-close",
    "temporarily-hide-menu",
    "focus-sub-menu"
  ],
  computed: {
    ariaId() {
      return "more-menu-dropdown";
    },
    ariaLabelledBy() {
      return "menu-button-more";
    },
    ariaExpanded() {
      return this.isVisible ? "true" : "false";
    },
    lastItemId() {
      const e = (n) => {
        var o;
        return n.type !== "header" || ((o = n.children) == null ? void 0 : o.length) > 0;
      }, t = this.moreItems.findLastIndex(e);
      return this.moreItems[t].id;
    },
    firstItemId() {
      const e = (n) => {
        var o;
        return n.type !== "header" || ((o = n.children) == null ? void 0 : o.length) > 0;
      }, t = this.moreItems.findIndex(e);
      return this.moreItems[t].id;
    }
  }
}, fq = ["id", "aria-labelledby", "aria-expanded"];
function gq(e, t, n, o, i, r) {
  const a = $("BarNavItemWrapper");
  return d(), h("div", {
    id: r.ariaId,
    "aria-labelledby": r.ariaLabelledBy,
    "aria-expanded": r.ariaExpanded,
    class: "bar-nav-menu--dropdown-item-wrapper",
    onMouseleave: t[3] || (t[3] = (s) => e.$emit("prevent-close"))
  }, [
    (d(!0), h(Y, null, ee(n.moreItems, (s) => (d(), h(Y, null, [
      s ? (d(), k(a, {
        ref_for: !0,
        ref: `more-${s.id}`,
        key: s.id,
        item: s,
        "force-show": !0,
        "is-more-menu-item": !0,
        "first-item-id": r.firstItemId,
        "last-item-id": r.lastItemId,
        "active-id": n.activeId,
        theme: n.theme,
        content: n.content,
        colors: n.colors,
        onNavigate: (l) => e.$emit("navigate", s),
        onHandleEnterEvent: (l) => e.$emit("handle-enter-event", s),
        onHandleItem: (l) => e.$emit("open-dropdown", s),
        onToggleDrawer: t[0] || (t[0] = (l) => e.$emit("toggle-drawer", l)),
        onHandleClose: t[1] || (t[1] = (l) => e.$emit("handle-close")),
        onFocusSubMenu: t[2] || (t[2] = (l) => e.$emit("focus-sub-menu", l))
      }, null, 8, ["item", "first-item-id", "last-item-id", "active-id", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleItem"])) : b("", !0)
    ], 64))), 256))
  ], 40, fq);
}
const vq = /* @__PURE__ */ O(pq, [["render", gq], ["__scopeId", "data-v-33993d03"]]), bq = {
  name: "M5",
  components: {
    BarNavItemWrapper: rf,
    BarNavDrawer: mq,
    BarNavMoreDropdown: vq,
    CMSSchoolsMenu: no,
    MenuItem: Nt
  },
  mixins: [hm, et],
  emits: ["toggle-search"],
  computed: {
    moreBtnWidth() {
      var e, t;
      return ((t = (e = this.$refs) == null ? void 0 : e["more-wrapper"]) == null ? void 0 : t.clientWidth) || 10;
    },
    exploreButton() {
      var e, t, n, o;
      return {
        id: "explore-button",
        ref: "explore-button",
        class: ["explore", "button-action", "menu", this.theme.style],
        dataTestId: "explore-button",
        ariaExpanded: this.exploreMenuVisible,
        ariaControls: this.exploreMenuVisible ? "explore-menu" : null,
        children: this.content.customMenuItems,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.menu_dropdown_title) || ((n = (t = this.theme.translations) == null ? void 0 : t.header) == null ? void 0 : n.explore_dropdown_title) || "Explore",
        icon: this.theme.menu_icon === "plus" ? "PlusIcon" : "HamburgerIcon",
        colors: {
          "--fill-color": ((o = this.theme.navigation_color) == null ? void 0 : o.hex) || "#000000",
          "--fill-path-color": this.theme.navigation_icon_color.hex,
          "--bg-color": this.theme.bg_color.hex,
          "--dropdown-class": this.exploreMenuVisible ? "open" : "close",
          "--nav-color": this.theme.navigation_color.hex
        }
      };
    },
    schoolsButton() {
      var e;
      return {
        id: "schoolsbutton",
        ref: "schoolsbutton",
        class: ["schools", "button-action", "menu", this.theme.style],
        dataTestId: "schools-button",
        ariaExpanded: this.isSchoolDropdownVisible || this.customSchoolsMenuVisible,
        ariaControls: this.isSchoolDropdownVisible || this.customSchoolsMenuVisible ? "schools-menu-sm1" : null,
        icon: "FilledDropdownArrow",
        translatedTitle: this.content.orgDropdownTitle || "Schools",
        children: this.orgsWithIds,
        colors: {
          "--fill-color": ((e = this.theme.navigation_color) == null ? void 0 : e.hex) || "#000000",
          "--fill-path-color": this.theme.navigation_icon_color.hex,
          "--bg-color": this.theme.bg_color.hex,
          "--dropdown-class": this.isSchoolDropdownVisible || this.customSchoolsMenuVisible ? "open" : "close",
          "--nav-color": this.theme.navigation_color.hex
        }
      };
    },
    orgsWithIds() {
      return this.content.organizations.map((t, n) => he(ie({}, t), { id: n + 1 }));
    }
  },
  methods: {
    isUnderlapped(e) {
      return e === null ? void 0 : !!this.underLappedItems.find((n) => n.id === e);
    },
    closeCustomSchoolsMenu() {
      this.customSchoolsMenuVisible = !1, this.handleClose();
    }
  }
}, yq = { class: "bar-nav-menu--align-right" }, _q = {
  ref: "bar-nav-item-wrapper",
  class: "bar-nav-item-wrapper"
}, Cq = {
  class: "options-wrapper",
  "data-testid": "options-wrapper"
}, wq = {
  class: "options-wrapper",
  "data-testid": "options-wrapper"
}, Tq = {
  ref: "more-wrapper",
  class: "bar-dropdown-more-wrapper"
}, kq = {
  ref: "bar-end-options",
  class: "bar-end-options"
}, Eq = ["href"];
function Sq(e, t, n, o, i, r) {
  const a = $("BarNavItemWrapper"), s = $("BarNavDrawer"), l = $("CMSSchoolsMenu"), u = $("BarNavMoreDropdown"), m = $("MenuItem"), g = Ve("click-away");
  return d(), h("div", {
    id: "m5",
    style: j(e.colors),
    class: v(["bar-nav-menu", { "is-i-frame": e.content.isIFrame }])
  }, [
    c("div", {
      ref: "bar-nav-menu-bar",
      class: "bar-nav-menu-bar",
      onMouseleave: t[21] || (t[21] = (p) => e.mouseLeaveMenu()),
      onMouseenter: t[22] || (t[22] = (p) => e.mouseEnterMenu())
    }, [
      c("div", yq, [
        ge((d(), h("div", _q, [
          c("div", Cq, [
            L(a, {
              item: r.exploreButton,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              "additional-menu-item": "",
              onNavigate: e.navigate,
              onHandleItem: t[0] || (t[0] = (p) => e.showItem(r.exploreButton)),
              onToggleDrawer: t[1] || (t[1] = (p) => e.handleDrawerToggle(r.exploreButton)),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
            L(Ee, { name: "slide-fade-up" }, {
              default: _(() => [
                e.activeItem && e.activeItem.id === r.exploreButton.id ? (d(), k(s, {
                  key: 0,
                  ref: `drawer-${r.exploreButton.id}`,
                  "active-item": r.exploreButton,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === r.exploreButton.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: t[2] || (t[2] = (p) => e.navigate(p)),
                  onHideDrawer: t[3] || (t[3] = (p) => e.hideDrawer("mouseleave")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[4] || (t[4] = (p) => e.preventClose(e.activeItem)),
                  onNextTab: t[5] || (t[5] = (p) => e.nextTabAction(p, "exploreButton"))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "onHandleToggleParent", "onHandleClose"])) : b("", !0)
              ]),
              _: 1
            })
          ]),
          c("div", wq, [
            L(a, {
              item: r.schoolsButton,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              "additional-menu-item": "",
              onNavigate: e.navigate,
              onHandleItem: t[6] || (t[6] = (p) => e.showItem(r.schoolsButton)),
              onToggleDrawer: t[7] || (t[7] = (p) => e.handleDrawerToggle(r.schoolsButton)),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
            L(Ee, { name: "slide-fade-up" }, {
              default: _(() => [
                e.activeItem && e.activeItem.id === r.schoolsButton.id & !e.content.hasCustomSchoolsMenu ? (d(), k(s, {
                  key: 0,
                  ref: "drawer-schoolsbutton",
                  "active-item": r.schoolsButton,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === r.schoolsButton.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: e.navigate,
                  onHideDrawer: t[8] || (t[8] = (p) => e.hideDrawer("mouseleave")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[9] || (t[9] = (p) => e.preventClose(e.activeItem)),
                  onNextTab: t[10] || (t[10] = (p) => e.nextTabAction(p, "schoolsButton"))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "onHandleToggleParent", "onNavigate", "onHandleClose"])) : b("", !0)
              ]),
              _: 1
            }),
            L(Ee, { name: "slide" }, {
              default: _(() => [
                e.content.hasCustomSchoolsMenu ? (d(), k(l, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  role: "menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: r.closeCustomSchoolsMenu,
                  onMouseleave: r.closeCustomSchoolsMenu
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview", "onFocusLost", "onMouseleave"])) : b("", !0)
              ]),
              _: 1
            })
          ]),
          (d(!0), h(Y, null, ee(e.content.sitemapMenuItems, (p) => (d(), h("div", {
            key: p.id,
            class: "options-wrapper",
            "data-testid": "options-wrapper"
          }, [
            ge(L(a, {
              item: p,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              onNavigate: e.navigate,
              onHandleEnterEvent: e.handleClose,
              onHandleItem: (T) => e.showItem(p),
              onToggleDrawer: (T) => e.handleDrawerToggle(p),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleItem", "onToggleDrawer", "onHandleClose"]), [
              [Sn, e.visibleItems.find(({ id: T }) => T === p.id)]
            ]),
            L(Ee, { name: "slide-fade-up" }, {
              default: _(() => [
                ge(L(s, {
                  ref_for: !0,
                  ref: `drawer-${p.id}`,
                  "active-item": p,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === p.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  "is-underlapped": r.isUnderlapped(e.activeItem && e.activeItem.id),
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: e.navigate,
                  onHideDrawer: t[11] || (t[11] = (T) => e.hideDrawer("hide-drawer")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[12] || (t[12] = (T) => e.preventClose(e.activeItem)),
                  onNextTab: t[13] || (t[13] = (T) => e.nextTabAction(T))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "is-underlapped", "onHandleToggleParent", "onNavigate", "onHandleClose"]), [
                  [Sn, e.activeItem && e.activeItem.id === p.id && p.children.length > 0]
                ])
              ]),
              _: 2
            }, 1024)
          ]))), 128))
        ])), [
          [g, e.hideDrawer]
        ]),
        ge(c("div", Tq, [
          L(a, {
            class: "bar-dropdown-button",
            "more-menu-item": "",
            "more-menu-visible": e.isMoreDropdownVisible,
            "force-show": "",
            theme: e.theme,
            item: { name: "more", children: [], id: "more" },
            content: e.content,
            colors: e.colors,
            onNavigate: e.navigate,
            onHandleEnterEvent: t[14] || (t[14] = (p) => e.isMoreDropdownVisible = !e.isMoreDropdownVisible),
            onHandleClose: e.hideMoreMenu,
            onHandleItem: t[15] || (t[15] = (p) => {
              e.handleMoreMenuToggle(e.isMoreDropdownVisible), e.hideDrawer();
            })
          }, null, 8, ["more-menu-visible", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
          L(Ee, { name: "slide-fade-up" }, {
            default: _(() => [
              e.underLappedItems && e.isMoreDropdownVisible ? ge((d(), k(u, {
                key: 0,
                ref: "moreDropdown",
                "active-id": e.activeItem ? e.activeItem.id : null,
                "is-visible": e.isMoreDropdownVisible,
                "more-items": e.underLappedItems,
                theme: e.theme,
                content: e.content,
                colors: e.colors,
                onNavigate: e.navigate,
                onHandleEnterEvent: e.handleClose,
                onOpenDropdown: t[16] || (t[16] = (p) => e.handleDropdownMenuOpen(p)),
                onToggleDrawer: t[17] || (t[17] = (p) => e.handleDrawerToggle(p)),
                onPreventClose: t[18] || (t[18] = (p) => e.preventClose(e.activeItem)),
                onHandleClose: e.handleClose,
                onFocusSubMenu: t[19] || (t[19] = (p) => e.focusSubMenu(p)),
                onTemporarilyHideMenu: e.temporalHide
              }, null, 8, ["active-id", "is-visible", "more-items", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleClose", "onTemporarilyHideMenu"])), [
                [g, e.hideMoreMenu]
              ]) : b("", !0)
            ]),
            _: 1
          })
        ], 512), [
          [Sn, e.displayMoreButton]
        ])
      ]),
      c("div", kq, [
        !e.isMobile || !e.content.newMobileHeader ? (d(), k(m, {
          key: 0,
          item: "searchbutton",
          theme: e.theme,
          content: e.content,
          onToggleSearch: t[20] || (t[20] = (p) => e.$emit("toggle-search"))
        }, null, 8, ["theme", "content"])) : b("", !0),
        e.showSignInButton ? (d(), h("a", {
          key: 1,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank"
        }, y(e.signInText), 9, Eq)) : b("", !0)
      ], 512)
    ], 544)
  ], 6);
}
const Mq = /* @__PURE__ */ O(bq, [["render", Sq], ["__scopeId", "data-v-ed244f98"]]), Aq = {
  name: "CmsHeader",
  components: {
    /* eslint-disable vue/no-reserved-component-names */
    H1: y$,
    H2: B$,
    H3: U$,
    H4: FI,
    H5: lD,
    H6: FD,
    H7: JD,
    H8: vL,
    /* eslint-enable vue/no-reserved-component-names */
    Custom: ZW,
    M4: K1,
    M5: Mq
  },
  mixins: [Tt],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      validator(e) {
        const t = Object.keys(e);
        return [
          "customMenuItems",
          "globals",
          "hasCustomSchoolsMenu",
          "hasGalleryImages",
          "isIFrame",
          "isEditing",
          "isPreview",
          "isSearchOpen",
          "langCode",
          "langText",
          "languages",
          "menuOptions",
          "newMobileHeader",
          "orgDropdownTitle",
          "orgMenuContent",
          "organizations",
          "pathPrefix",
          "showMenu",
          "sitemapMenuItems",
          "iconLinks",
          "translations",
          "utilities"
        ].every((o) => t.includes(o));
      },
      type: Object,
      required: !0
    },
    isHomepage: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    currentDomain: {
      type: String,
      default: null
    },
    mediaSubdomain: {
      type: String,
      default: ""
    }
  },
  emits: [
    "toggle-mobile-menu",
    "toggle-menu",
    "toggle-search",
    "language-change",
    "close-menu",
    "update:utilities",
    "update:icon-links"
  ],
  data() {
    return {
      headerShouldShrink: !1,
      headerOffsetHeight: 0,
      headerClientHeight: 218,
      ticking: !1,
      debouncedToggleStickyHeaderAdj: () => {
      },
      debouncedCalculateHeaderHeight: () => {
      }
    };
  },
  computed: {
    customSchoolsMenu() {
      return this.content.hasCustomSchoolsMenu || this.theme.custom_schools_dropdown;
    },
    cmsHeaderStickyStyles() {
      const e = this.content.isPreview || !this.headerShouldBeSticky ? 0 : this.headerOffsetHeight, t = this.theme.version === "H3" && !this.isMobile && this.isHomepage && this.content.hasGalleryImages, n = this.theme.version === "H4" && !this.isMobile && this.isHomepage && this.content.hasGalleryImages;
      return {
        paddingBottom: `${e}px`,
        "--header-position": t || n ? "absolute" : "relative",
        "--header-width": t || n ? "100%" : "auto"
      };
    },
    headerShouldBeSticky() {
      var e;
      return ((e = this.theme) == null ? void 0 : e.sticky_header) && this.headerShouldShrink && !this.content.isIFrame;
    },
    // Used only to toggle settings in cms-v2-components example
    themeSettingsToWatch() {
      var e;
      return `${this.theme.version}${(e = this.theme) == null ? void 0 : e.sticky_header}`;
    },
    isBarNavEnabled() {
      var e, t;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4" || ((t = this.content.menuOptions) == null ? void 0 : t.version) === "M5";
    },
    menuOptions() {
      return he(ie(ie({}, this.theme), this.content.menuOptions), {
        translations: this.theme.translations || this.content.menuOptions.translations,
        headerHeight: this.headerClientHeight
      });
    },
    showMenuV4() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4" && !this.isMobile && !["Custom", "H5"].includes(this.theme.version);
    },
    showMenuV5() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M5" && !this.isMobile && !["Custom", "H5"].includes(this.theme.version);
    },
    isMobile() {
      var t;
      if (!this.screenSize)
        return !1;
      let e = this.isBarNavEnabled ? 1023 : 960;
      return ((t = this.content.menuOptions) == null ? void 0 : t.version) === "M6" ? this.screenSize <= 600 : (["H5", "H6"].includes(this.theme.version) && (e = 600), this.screenSize <= e);
    },
    showSignInButton() {
      return !!(this.theme.show_sign_in_button && (this.mediaSubdomain || this.content.isPreview));
    },
    signInUrl() {
      return `https://${this.mediaSubdomain}.id.thrillshare.com`;
    },
    H3gradient() {
      var e;
      return {
        "--bg-color": this.theme.version === "H3" ? this.theme.bg_color.hex : "",
        "--background-opacity": `${(e = this.theme.background_opacity) != null ? e : "80"}%`
      };
    }
  },
  watch: {
    themeSettingsToWatch() {
      this.calculateHeaderHeight();
    }
  },
  mounted() {
    this.$nextTick(() => this.calculateHeaderHeight()), this.debouncedToggleStickyHeaderAdj = pi(this.toggleStickyHeaderAdjustments, 10), this.debouncedCalculateHeaderHeight = pi(this.calculateHeaderHeight, 100), window.addEventListener("scroll", this.debouncedToggleStickyHeaderAdj), window.addEventListener("resize", this.debouncedCalculateHeaderHeight);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.debouncedToggleStickyHeaderAdj), window.removeEventListener("resize", this.debouncedCalculateHeaderHeight);
  },
  methods: {
    toggleStickyHeaderAdjustments() {
      !this.theme.sticky_header || this.content.isIFrame || this.ticking || (this.ticking = !0, window.requestAnimationFrame(() => {
        const e = window.scrollY > this.$refs.headerWrapper.offsetHeight;
        e !== this.headerShouldShrink && (this.headerShouldShrink = e), this.ticking = !1;
      }));
    },
    async calculateHeaderHeight() {
      if (await this.$nextTick(), this.$refs.headerWrapper) {
        const e = this.$refs.headerWrapper, t = e.clientHeight, n = e.offsetHeight, o = this.isBarNavEnabled && this.screenSize > 1024 ? 54 : 0;
        this.headerOffsetHeight = n + o, t > 0 && t !== this.headerClientHeight && (this.headerClientHeight = t);
      }
    }
  }
};
function $q(e, t, n, o, i, r) {
  const a = $("M4"), s = $("M5");
  return d(), h("div", {
    id: "cms-header",
    ref: "cmsHeader",
    class: "cms-header",
    style: j(r.cmsHeaderStickyStyles)
  }, [
    c("div", {
      ref: "headerWrapper",
      class: v(["header-bar-wrapper", [r.headerShouldBeSticky ? "sticky" : ""]]),
      style: j(r.H3gradient)
    }, [
      (d(), k(K(n.theme.version), {
        ref: "header",
        theme: n.theme,
        content: n.content,
        "should-shrink": i.headerShouldShrink,
        "should-be-sticky": r.headerShouldBeSticky,
        "is-mobile": r.isMobile,
        "is-homepage": n.isHomepage,
        "wrapper-component": n.wrapperComponent,
        "wrapper-props": n.wrapperProps,
        "show-sign-in-button": r.showSignInButton,
        "sign-in-url": r.signInUrl,
        onToggleMenu: t[0] || (t[0] = (l) => e.$emit("toggle-menu", l)),
        onToggleMobileMenu: t[1] || (t[1] = (l) => e.$emit("toggle-mobile-menu", l)),
        onCloseMenu: t[2] || (t[2] = (l) => e.$emit("close-menu")),
        onLanguageChange: t[3] || (t[3] = (l) => e.$emit("language-change", l)),
        onToggleSearch: t[4] || (t[4] = (l) => e.$emit("toggle-search")),
        "onUpdate:utilities": t[5] || (t[5] = (l) => e.$emit("update:utilities", l)),
        "onUpdate:iconLinks": t[6] || (t[6] = (l) => e.$emit("update:icon-links", l))
      }, {
        utility: _(({ idx: l }) => [
          w(e.$slots, "utility", { idx: l }, void 0, !0)
        ]),
        iconLink: _(({ idx: l }) => [
          w(e.$slots, "iconLink", { idx: l }, void 0, !0)
        ]),
        _: 3
      }, 40, ["theme", "content", "should-shrink", "should-be-sticky", "is-mobile", "is-homepage", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url"])),
      r.showMenuV4 ? (d(), k(a, {
        key: 0,
        theme: r.menuOptions,
        content: n.content,
        "is-mobile": r.isMobile,
        "is-preview": n.content.isPreview,
        onCloseMenu: t[7] || (t[7] = (l) => e.$emit("close-menu"))
      }, null, 8, ["theme", "content", "is-mobile", "is-preview"])) : b("", !0),
      r.showMenuV5 ? (d(), k(s, {
        key: 1,
        theme: r.menuOptions,
        content: n.content,
        "current-domain": n.currentDomain,
        "show-sign-in-button": r.showSignInButton,
        "sign-in-url": r.signInUrl,
        onCloseMenu: t[8] || (t[8] = (l) => e.$emit("toggle-menu", !1)),
        onToggleSearch: t[9] || (t[9] = (l) => e.$emit("toggle-search"))
      }, null, 8, ["theme", "content", "current-domain", "show-sign-in-button", "sign-in-url"])) : b("", !0)
    ], 6)
  ], 4);
}
const Iq = /* @__PURE__ */ O(Aq, [["render", $q], ["__scopeId", "data-v-34cc8f5d"]]), sf = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
function af(e) {
  return e.replace(sf, (t, n, o, i) => "#" + n + n + o + o + i + i).substring(1).match(/.{2}/g).map((t) => parseInt(t, 16));
}
function i0(e, t = 1) {
  return [...e.replace(sf, (o, i, r, a) => "#" + i + i + r + r + a + a).substring(1).match(/.{2}/g).map((o) => parseInt(o, 16)), t].join(",");
}
const Dq = {
  name: "M1",
  mixins: [da],
  props: {
    isActive: Boolean
  },
  data() {
    return {
      parentList: null,
      childList: null,
      grandchildList: null
    };
  },
  computed: {
    columns() {
      if (!this.content.sitemapMenuItems || this.content.sitemapMenuItems.length < 1) return [];
      const e = 3, t = new Array(e).fill(null).map(() => []);
      let n = 0;
      return this.content.sitemapMenuItems.forEach((o) => {
        n > e - 1 && (n = 0), t[n].push(o), n += 1;
      }), t;
    },
    mainMenuRGBColor() {
      const [e, t, n] = af(this.theme.bg_color.hex);
      return `rgba(${e}, ${t}, ${n}, .96)`;
    }
  },
  methods: {
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    },
    isSubMenuExpanded(e) {
      return this.activeIds.includes(e.id);
    },
    closeDropdownOnChildReverse(e, t, n) {
      e.id === n[0].id && this.toggleOpen(t.id, !1);
    },
    closeDropdownOnParentReverse(e, t) {
      e && this.toggleOpen(t.id, !1);
    },
    checkForExpandedMenu(e, t, n, o) {
      if (!e) {
        const i = o.length - 1;
        t.id === o[i].id && this.toggleOpen(n.id, !0);
      }
    },
    closeDropdownOnLastGrandchild(e, t, n) {
      const o = n.length - 1, i = t.length - 1, r = n[o].children[i].id;
      e.id === r && this.toggleOpen(e.id, !0);
    },
    closeDropdownOnLastChild(e, t) {
      const n = t.length - 1;
      e.id === t[n].id && e.children.length === 0 && this.toggleOpen(e.id, !0);
    }
  }
}, Lq = {
  id: "m1",
  "data-testid": "m1"
}, Oq = { "data-testid": "heading" }, Nq = { class: "content" }, Pq = { class: "static-links" }, Hq = ["onKeydown"], Fq = ["id", "target", "href"], Rq = ["innerHTML"], Bq = {
  key: 0,
  class: "generated-links"
}, Vq = ["onMouseover"], jq = ["onKeydown"], Uq = ["id", "aria-expanded", "aria-controls", "aria-describedby", "onKeydown", "onClick"], Gq = ["onKeydown", "onClick"], zq = ["id", "aria-expanded", "aria-controls", "aria-describedby"], Kq = ["id", "aria-labelledby"], Zq = ["onMouseover"], xq = ["onKeydown"], Wq = ["onKeydown", "onClick"], qq = ["id", "aria-expanded", "aria-controls", "aria-describedby"], Yq = ["id", "aria-labelledby"], Xq = ["onMouseover", "onKeydown"], Qq = ["onKeydown"], Jq = {
  class: "button-action-content",
  tabindex: "-1"
}, eY = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, tY = ["fill"], nY = ["fill"];
function oY(e, t, n, o, i, r) {
  const a = $("MenuElement");
  return d(), h("div", Lq, [
    c("div", {
      id: "mainmenu",
      ref: "mainmenu",
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      tabindex: "0",
      style: j(`background: ${r.mainMenuRGBColor}`),
      onKeydown: [
        t[8] || (t[8] = V(z((s) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"])),
        t[9] || (t[9] = V(z(() => {
        }, ["exact", "prevent"]), ["space"])),
        t[10] || (t[10] = V(z(() => {
        }, ["exact", "prevent"]), ["up"])),
        t[11] || (t[11] = V(z(() => {
        }, ["exact", "prevent"]), ["down"]))
      ]
    }, [
      c("div", {
        style: j(`color: ${e.theme.l1_text_color.hex || "#dddddd"};`),
        class: "heading",
        "data-testid": "heading-color"
      }, [
        c("h2", Oq, y(e.translations.title), 1)
      ], 4),
      c("div", Nq, [
        c("div", Pq, [
          c("ul", null, [
            (d(!0), h(Y, null, ee(e.content.customMenuItems, (s) => (d(), h("li", {
              key: s.id,
              "data-testid": "static-link",
              onKeydown: V(z((l) => e.clickStaticLink(e.getLink(s.url)), ["exact", "prevent"]), ["space"])
            }, [
              c("a", {
                id: s.id,
                style: j(`color: ${e.theme.icon_text_color.hex};`),
                target: s.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(s.url),
                onClick: t[0] || (t[0] = (l) => e.$emit("close-menu"))
              }, [
                c("div", null, [
                  c("div", {
                    class: v(["link-image", { "global-icon": s.cms_icon_id }]),
                    style: j(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    c("div", {
                      class: "menu-item-icon",
                      "data-testid": "m1-icon-color",
                      style: j(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: s.cms_icon_id ? s.icon_cms : s.icon
                    }, null, 12, Rq)
                  ], 6),
                  c("span", {
                    "data-testid": "m1-icon-text",
                    style: j(`color: ${e.theme.icon_text_color.hex};`)
                  }, y(s.name), 5)
                ])
              ], 12, Fq)
            ], 40, Hq))), 128))
          ])
        ]),
        r.columns.length ? (d(), h("div", Bq, [
          c("ul", null, [
            (d(!0), h(Y, null, ee(e.content.sitemapMenuItems, (s, l) => (d(), h("li", {
              key: `parent-${l}`,
              "data-testid": "generated-link",
              class: v({
                "has-child": s.children.length,
                open: e.activeIds.includes(s.id)
              }),
              style: j(
                i.parentList === l ? { color: e.theme.l1_text_hover_color.hex } : { color: e.theme.l1_text_color.hex }
              ),
              onMouseover: (u) => r.setHoverColor("parentList", l),
              onMouseleave: t[6] || (t[6] = (u) => r.removeHoverColor("parentList"))
            }, [
              c("span", {
                class: "parent-menu-element-wrapper",
                onKeydown: [
                  V(z((u) => e.clickGeneratedLink(s, !0), ["exact", "prevent"]), ["enter"]),
                  V(z((u) => e.clickGeneratedLink(s, !0), ["exact", "prevent"]), ["space"])
                ]
              }, [
                L(a, {
                  id: `${s.slug || s.id}-${s.type}`,
                  element: s,
                  "toggle-fn": e.toggleOpen,
                  "path-prefix": e.content.pathPrefix,
                  "is-parent": "",
                  "cursor-pointer": "",
                  onRouterLinkClick: t[1] || (t[1] = (u) => e.$emit("close-menu"))
                }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
              ], 40, jq),
              s.children.length ? (d(), h("span", {
                key: 0,
                id: `${s.slug || s.id}-${s.type}-parent-button`,
                role: "button",
                tabindex: "-1",
                "aria-expanded": !!e.activeIds.includes(s.id),
                "aria-haspopup": "true",
                "aria-controls": `${s.slug || s.id}-${s.type}-child-list`,
                "aria-label": "Toggle Submenu",
                "aria-describedby": `${s.slug || s.id}-${s.type}`,
                onKeydown: [
                  V(z((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["enter"]),
                  V(z((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["space"])
                ],
                onClick: (u) => e.toggleOpen(s.id, !0)
              }, null, 40, Uq)) : b("", !0),
              s.children.length ? (d(), h("span", {
                key: 1,
                class: "arrow-box",
                tabindex: "0",
                onKeydown: [
                  V(z((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["enter"]),
                  V(z((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["space"]),
                  V(z((u) => r.closeDropdownOnParentReverse(e.activeIds.includes(s.id), s), ["shift", "exact"]), ["tab"])
                ],
                onClick: (u) => e.toggleOpen(s.id, !0)
              }, [
                c("span", {
                  id: `${s.slug || s.id}-${s.type}-parent-button`,
                  role: "button",
                  class: "parent-arrow",
                  tabindex: "-1",
                  "aria-expanded": !!e.activeIds.includes(s.id),
                  "aria-haspopup": "true",
                  "aria-controls": `${s.slug || s.id}-${s.type}-child-list`,
                  "aria-label": "Toggle Submenu",
                  "aria-describedby": `${s.slug || s.id}-${s.type}`
                }, null, 8, zq)
              ], 40, Gq)) : b("", !0),
              c("div", {
                class: "dropdown",
                style: j(`background: ${e.theme.l2_bg_color.hex || "#000000"};`)
              }, [
                s.children.length ? (d(), h("ul", {
                  key: 0,
                  id: `${s.slug || s.id}-${l}-child-list`,
                  "aria-labelledby": `${s.slug || s.id}-${s.type}-parent-button`
                }, [
                  (d(!0), h(Y, null, ee(s.children, (u, m) => (d(), h("li", {
                    key: `child-${m}`,
                    style: j(
                      i.childList === m ? { color: e.theme.l2_text_hover_color.hex } : { color: e.theme.l2_text_color.hex }
                    ),
                    class: v({
                      "has-child": u.children.length,
                      open: e.activeIds.includes(u.id)
                    }),
                    onMouseover: (g) => r.setHoverColor("childList", m),
                    onMouseleave: t[5] || (t[5] = (g) => r.removeHoverColor("childList"))
                  }, [
                    c("span", {
                      class: "child-menu-element-wrapper",
                      onKeydown: [
                        V(z((g) => e.clickGeneratedLink(u, !1), ["exact", "prevent"]), ["enter"]),
                        V(z((g) => e.clickGeneratedLink(u, !1), ["exact", "prevent"]), ["space"]),
                        V(z((g) => r.closeDropdownOnChildReverse(u, s, s.children), ["shift", "exact"]), ["tab"]),
                        V(z((g) => r.closeDropdownOnLastChild(u, s.children), ["exact"]), ["tab"])
                      ]
                    }, [
                      L(a, {
                        id: `${u.slug || u.id}-${u.type}`,
                        element: u,
                        "toggle-fn": e.toggleOpen,
                        "path-prefix": e.content.pathPrefix,
                        "is-sub-parent": "",
                        onRouterLinkClick: t[2] || (t[2] = (g) => e.$emit("close-menu"))
                      }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
                    ], 40, xq),
                    u.children.length ? (d(), h("span", {
                      key: 0,
                      class: "arrow-box",
                      tabindex: "0",
                      onKeydown: [
                        V(z((g) => e.toggleOpen(u.id, !1), ["exact", "prevent"]), ["enter"]),
                        V(z((g) => e.toggleOpen(u.id, !1), ["exact", "prevent"]), ["space"]),
                        V(z((g) => r.checkForExpandedMenu(r.isSubMenuExpanded(u), u, s, s.children), ["exact"]), ["tab"])
                      ],
                      onClick: (g) => e.toggleOpen(u.id, !1)
                    }, [
                      c("span", {
                        id: `${u.slug || u.id}-${u.type}-child-button`,
                        class: "child-arrow",
                        role: "button",
                        tabindex: "-1",
                        "aria-expanded": !!e.activeIds.includes(u.id),
                        "aria-haspopup": "true",
                        "aria-controls": `${u.slug || u.id}-${m}-grandchild-list`,
                        "aria-label": "Toggle Submenu",
                        "aria-describedby": `${u.slug || u.id}-${u.type}`
                      }, null, 8, qq)
                    ], 40, Wq)) : b("", !0),
                    u.children.length ? (d(), h("ul", {
                      key: 1,
                      id: `${u.slug || u.id}-${m}-grandchild-list`,
                      "aria-labelledby": `${u.slug || u.id}-${u.type}-child-button`,
                      style: j(`border-left: 1px solid ${e.theme.l2_text_color.hex}`)
                    }, [
                      (d(!0), h(Y, null, ee(u.children, (g, p) => (d(), h("li", {
                        key: `grandchild-${p}`,
                        style: j(
                          i.grandchildList === p ? { color: e.theme.l2_text_hover_color.hex } : { color: e.theme.l2_text_color.hex }
                        ),
                        onMouseover: (T) => r.setHoverColor("grandchildList", p),
                        onMouseleave: t[4] || (t[4] = (T) => r.removeHoverColor("grandchildList")),
                        onKeydown: V(z((T) => r.closeDropdownOnLastGrandchild(g, u.children, s.children), ["exact"]), ["tab"])
                      }, [
                        c("span", {
                          class: "grandchild-menu-element-wrapper",
                          onKeydown: [
                            V(z((T) => e.clickGeneratedLink(g, !1), ["exact", "prevent"]), ["enter"]),
                            V(z((T) => e.clickGeneratedLink(g, !1), ["exact", "prevent"]), ["space"])
                          ]
                        }, [
                          L(a, {
                            id: `${g.slug || g.id}-${g.type}`,
                            element: g,
                            "path-prefix": e.content.pathPrefix,
                            onRouterLinkClick: t[3] || (t[3] = (T) => e.$emit("close-menu"))
                          }, null, 8, ["id", "element", "path-prefix"])
                        ], 40, Qq)
                      ], 44, Xq))), 128))
                    ], 12, Yq)) : b("", !0)
                  ], 46, Zq))), 128))
                ], 8, Kq)) : b("", !0)
              ], 4)
            ], 46, Vq))), 128))
          ])
        ])) : b("", !0)
      ]),
      c("button", {
        ref: "close-menu-button'",
        "data-testid": "close-menu-button",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[7] || (t[7] = (s) => e.$emit("close-menu"))
      }, [
        c("div", Jq, [
          (d(), h("svg", eY, [
            c("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.l1_text_color.hex,
              "fill-rule": "evenodd"
            }, [
              c("g", {
                id: "close_modal_icon",
                fill: e.theme.l1_text_color.hex
              }, t[12] || (t[12] = [
                c("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, nY)
            ], 8, tY)
          ]))
        ])
      ], 512)
    ], 36)
  ]);
}
const rY = /* @__PURE__ */ O(Dq, [["render", oY], ["__scopeId", "data-v-4b5a0977"]]), iY = {
  name: "M2",
  mixins: [da],
  data() {
    return {
      sectionList: null,
      parentList: null,
      childList: null
    };
  },
  computed: {
    mainMenuRGBColor() {
      const [e, t, n] = af(this.theme.bg_color.hex);
      return `rgba(${e}, ${t}, ${n}, .96)`;
    }
  },
  methods: {
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    }
  }
}, sY = { id: "m2" }, aY = { class: "content" }, lY = { class: "static-links" }, uY = ["onKeydown"], dY = ["id", "target", "href"], cY = ["innerHTML"], hY = { class: "generated-links" }, mY = ["onKeydown", "onMouseover"], pY = ["id", "aria-labelledby"], fY = ["onMouseover"], gY = ["id", "aria-expanded", "aria-controls", "tabindex", "onKeydown", "onMousedown"], vY = ["fill"], bY = ["fill", "stroke"], yY = ["fill", "stroke"], _Y = ["tabindex", "aria-controls", "aria-expanded", "aria-label", "onKeydown", "onClick"], CY = ["id", "aria-labelledby"], wY = ["onMouseover"], TY = ["onKeydown"], kY = {
  class: "button-action-content",
  tabindex: "-1"
}, EY = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, SY = ["fill"], MY = ["fill"];
function AY(e, t, n, o, i, r) {
  const a = $("MenuElement");
  return d(), h("div", sY, [
    c("div", {
      id: "mainmenu",
      style: j(`background: ${r.mainMenuRGBColor}`),
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      onKeydown: [
        t[6] || (t[6] = V(z((s) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"])),
        t[7] || (t[7] = V(z(() => {
        }, ["exact", "prevent"]), ["space"])),
        t[8] || (t[8] = V(z(() => {
        }, ["exact", "prevent"]), ["up"])),
        t[9] || (t[9] = V(z(() => {
        }, ["exact", "prevent"]), ["down"]))
      ]
    }, [
      c("div", aY, [
        c("div", lY, [
          c("ul", null, [
            (d(!0), h(Y, null, ee(e.content.customMenuItems, (s) => (d(), h("li", {
              key: s.id,
              onKeydown: V(z((l) => e.clickStaticLink(e.getLink(s.url)), ["exact", "prevent"]), ["space"])
            }, [
              c("a", {
                id: s.id,
                style: j(`color: ${e.theme.icon_text_color.hex};`),
                target: s.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(s.url)
              }, [
                c("div", null, [
                  c("div", {
                    class: v(["link-image", { "global-icon": s.cms_icon_id }]),
                    style: j(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    c("div", {
                      class: "menu-item-icon",
                      style: j(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: s.cms_icon_id ? s.icon_cms : s.icon
                    }, null, 12, cY)
                  ], 6),
                  c("span", {
                    style: j(`color: ${e.theme.icon_text_color.hex};`)
                  }, y(s.name), 5)
                ])
              ], 12, dY)
            ], 40, uY))), 128))
          ])
        ]),
        c("div", hY, [
          (d(!0), h(Y, null, ee(e.content.sitemapMenuItems, (s, l) => (d(), h("div", {
            key: `section-${l}`,
            style: j(`border-right-color: ${e.theme.text_color.hex}`),
            class: "col"
          }, [
            c("h2", {
              style: j(
                i.sectionList === s.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
              ),
              onKeydown: [
                V(z((u) => e.clickGeneratedLink(s, !1), ["exact", "prevent"]), ["enter"]),
                V(z((u) => e.clickGeneratedLink(s, !1), ["exact", "prevent"]), ["space"])
              ],
              onMouseover: (u) => r.setHoverColor("sectionList", s.id),
              onMouseleave: t[1] || (t[1] = (u) => r.removeHoverColor("sectionList"))
            }, [
              L(a, {
                id: `${s.slug || s.id}-${s.type}`,
                element: s,
                class: v({ "has-child": s.children.length }),
                "path-prefix": e.content.pathPrefix,
                "is-parent": "",
                onRouterLinkClick: t[0] || (t[0] = (u) => e.$emit("close-menu"))
              }, null, 8, ["id", "element", "class", "path-prefix"])
            ], 44, mY),
            s.children.length ? (d(), h("ul", {
              key: 0,
              id: `${s.slug || s.id}-${l}-parent-list`,
              "aria-labelledby": `${s.slug || s.id}-${s.type}`
            }, [
              (d(!0), h(Y, null, ee(s.children, (u, m) => (d(), h("li", {
                key: `parent-${m}`,
                style: j(
                  i.parentList === u.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                ),
                class: v({
                  "has-child": u.children.length,
                  open: e.activeIds.includes(u.id)
                }),
                onMouseover: (g) => r.setHoverColor("parentList", u.id),
                onMouseleave: t[4] || (t[4] = (g) => r.removeHoverColor("parentList"))
              }, [
                u.children.length ? (d(), h("svg", {
                  key: 0,
                  id: `${u.slug || u.id}-${u.type}-parent-button`,
                  role: "button",
                  "aria-expanded": u.type !== "header" ? !!e.activeIds.includes(u.id) : "",
                  "aria-haspopup": "true",
                  "aria-controls": u.type !== "header" ? `${u.slug || u.id}-${m}-child-list` : "",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "15",
                  height: "15",
                  viewBox: "0 0 16 16",
                  class: "icon-box",
                  tabindex: u.children.length && u.type !== "header" ? "0" : "-1",
                  onKeydown: [
                    V(z((g) => e.toggleOpen(u.id, !0), ["exact", "prevent"]), ["enter"]),
                    V(z((g) => e.toggleOpen(u.id, !0), ["exact", "prevent"]), ["space"])
                  ],
                  onMousedown: z((g) => e.toggleOpen(u.id, !0), ["prevent"])
                }, [
                  c("title", null, y(`Toggle Submenu for ${u.name}`), 1),
                  c("circle", {
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.bg_color.hex,
                    cx: "10",
                    cy: "10",
                    r: "20"
                  }, null, 8, vY),
                  e.activeIds.includes(u.id) ? (d(), h("path", {
                    key: 0,
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.text_color.hex,
                    stroke: e.theme.bg_color.hex,
                    d: "M549,659a8,8,0,1,1,8-8A8,8,0,0,1,549,659Zm4-9h-8v2h8v-2Z",
                    transform: "translate(-541 -643)"
                  }, null, 8, bY)) : (d(), h("path", {
                    key: 1,
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.text_color.hex,
                    stroke: e.theme.bg_color.hex,
                    d: "M549,638a8,8,0,1,1,8-8A8,8,0,0,1,549,638Zm4-9h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2Z",
                    transform: "translate(-541 -622)"
                  }, null, 8, yY))
                ], 40, gY)) : b("", !0),
                c("span", {
                  class: "parent-menu-element-wrapper",
                  tabindex: u.children.length && u.type === "header" ? "0" : "-1",
                  "aria-controls": u.type === "header" ? `${u.slug || u.id}-${m}-child-list` : "",
                  "aria-expanded": u.type === "header" ? !!e.activeIds.includes(u.id) : "",
                  "aria-label": u.type === "header" ? `Toggle Submenu for ${u.name}` : "",
                  onKeydown: [
                    V(z((g) => e.clickGeneratedLink(u, !0), ["exact", "prevent"]), ["enter"]),
                    V(z((g) => e.clickGeneratedLink(u, !0), ["exact", "prevent"]), ["space"])
                  ],
                  onClick: z((g) => e.clickGeneratedLink(u, !0), ["stop"])
                }, [
                  L(a, {
                    id: `${u.slug || u.id}-${u.type}`,
                    element: u,
                    "path-prefix": e.content.pathPrefix,
                    "is-sub-parent": ""
                  }, null, 8, ["id", "element", "path-prefix"])
                ], 40, _Y),
                u.children.length ? (d(), h("ul", {
                  key: 1,
                  id: `${u.slug || u.id}-${m}-child-list`,
                  "aria-labelledby": `${u.slug || u.id}-${u.type}-parent-button`
                }, [
                  (d(!0), h(Y, null, ee(u.children, (g, p) => (d(), h("li", {
                    key: `child-${p}`,
                    style: j(
                      i.childList === g.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                    ),
                    onMouseover: (T) => r.setHoverColor("childList", g.id),
                    onMouseleave: t[3] || (t[3] = (T) => r.removeHoverColor("childList"))
                  }, [
                    c("span", {
                      class: "child-menu-element-wrapper",
                      onKeydown: [
                        V(z((T) => e.clickGeneratedLink(g, !1), ["exact", "prevent"]), ["enter"]),
                        V(z((T) => e.clickGeneratedLink(g, !1), ["exact", "prevent"]), ["space"])
                      ]
                    }, [
                      L(a, {
                        id: `${g.slug || g.id}-${g.type}`,
                        element: g,
                        "path-prefix": e.content.pathPrefix,
                        onRouterLinkClick: t[2] || (t[2] = (T) => e.$emit("close-menu"))
                      }, null, 8, ["id", "element", "path-prefix"])
                    ], 40, TY)
                  ], 44, wY))), 128))
                ], 8, CY)) : b("", !0)
              ], 46, fY))), 128))
            ], 8, pY)) : b("", !0)
          ], 4))), 128))
        ])
      ]),
      c("button", {
        ref: "closeButton",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[5] || (t[5] = (s) => e.$emit("close-menu"))
      }, [
        c("div", kY, [
          (d(), h("svg", EY, [
            c("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.l1_text_color.hex,
              "fill-rule": "evenodd"
            }, [
              c("g", {
                id: "close_modal_icon",
                fill: e.theme.text_color.hex
              }, t[10] || (t[10] = [
                c("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, MY)
            ], 8, SY)
          ]))
        ])
      ], 512)
    ], 36)
  ]);
}
const $Y = /* @__PURE__ */ O(iY, [["render", AY], ["__scopeId", "data-v-5e351852"]]), IY = {
  name: "M3",
  mixins: [da, ht],
  data() {
    return {
      sectionList: null,
      parentList: null,
      childList: null
    };
  },
  methods: {
    closeMenuIfOpen() {
      this.content.showMenu && !this.isPreview && this.$emit("close-menu");
    },
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    }
  }
}, DY = { id: "m3" }, LY = { class: "content" }, OY = { class: "static-links" }, NY = ["onKeydown"], PY = ["id", "target", "href"], HY = ["innerHTML"], FY = { class: "generated-links" }, RY = ["onKeydown", "onMouseover"], BY = ["id", "aria-labelledby"], VY = ["onMouseover"], jY = ["onKeydown"], UY = ["tabindex", "onKeydown"], GY = ["id", "aria-expanded", "aria-controls", "aria-label", "onClick"], zY = ["id", "aria-labelledby"], KY = ["onMouseover"], ZY = ["onKeydown"], xY = {
  class: "button-action-content",
  tabindex: "-1"
}, WY = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, qY = ["fill"], YY = ["fill"];
function XY(e, t, n, o, i, r) {
  const a = $("MenuElement"), s = Ve("click-away");
  return d(), h("div", DY, [
    ge((d(), h("div", {
      style: j(`background: ${e.theme.bg_color.hex}; opacity: 0.96`),
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      onKeydown: t[8] || (t[8] = V(z((l) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"]))
    }, [
      c("div", {
        style: j(`color: ${e.theme.text_color.hex || "#dddddd"};`),
        class: "heading"
      }, [
        c("h2", null, y(e.translations.title), 1)
      ], 4),
      c("div", LY, [
        c("div", OY, [
          c("ul", null, [
            (d(!0), h(Y, null, ee(e.content.customMenuItems, (l) => (d(), h("li", {
              key: l.id,
              onKeydown: V(z((u) => e.clickStaticLink(e.getLink(l.url)), ["exact", "prevent"]), ["space"])
            }, [
              c("a", {
                id: l.id,
                style: j(`color: ${e.theme.icon_text_color.hex};`),
                target: l.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(l.url),
                onClick: t[0] || (t[0] = (u) => e.$emit("close-menu"))
              }, [
                c("div", null, [
                  c("div", {
                    class: v(["link-image", { "global-icon": l.cms_icon_id }]),
                    style: j(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    c("div", {
                      class: "menu-item-icon",
                      style: j(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: l.cms_icon_id ? l.icon_cms : l.icon
                    }, null, 12, HY)
                  ], 6),
                  c("span", {
                    style: j(`color: ${e.theme.icon_text_color.hex};`)
                  }, y(l.name), 5)
                ])
              ], 12, PY)
            ], 40, NY))), 128))
          ])
        ]),
        c("div", FY, [
          c("ul", null, [
            (d(!0), h(Y, null, ee(e.content.sitemapMenuItems, (l, u) => (d(), h("li", {
              key: `section-${u}`
            }, [
              c("h2", {
                style: j(
                  i.sectionList === l.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                ),
                class: v({ "has-child": l.children.length }),
                onKeydown: [
                  V(z((m) => e.clickGeneratedLink(l, !1), ["exact", "prevent"]), ["enter"]),
                  V(z((m) => e.clickGeneratedLink(l, !1), ["exact", "prevent"]), ["space"])
                ],
                onMouseover: (m) => r.setHoverColor("sectionList", l.id),
                onMouseleave: t[2] || (t[2] = (m) => r.removeHoverColor("sectionList"))
              }, [
                L(a, {
                  id: `${l.slug || l.id}-${l.type}`,
                  element: l,
                  "path-prefix": e.content.pathPrefix,
                  "is-parent": "",
                  onRouterLinkClick: t[1] || (t[1] = (m) => e.$emit("close-menu"))
                }, null, 8, ["id", "element", "path-prefix"])
              ], 46, RY),
              l.children.length ? (d(), h("ul", {
                key: 0,
                id: `${l.slug || l.id}-${u}-parent-list`,
                "aria-labelledby": `${l.slug || l.id}-${l.type}`
              }, [
                (d(!0), h(Y, null, ee(l.children, (m, g) => (d(), h("li", {
                  key: `parent-${g}`,
                  style: j(
                    i.parentList === m.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                  ),
                  class: v({
                    "has-child": m.children.length,
                    open: e.activeIds.includes(m.id)
                  }),
                  onMouseover: (p) => r.setHoverColor("parentList", m.id),
                  onMouseleave: t[6] || (t[6] = (p) => r.removeHoverColor("parentList"))
                }, [
                  c("span", {
                    class: "parent-menu-element-wrapper",
                    onKeydown: [
                      V(z((p) => e.clickGeneratedLink(m, !0), ["exact", "prevent"]), ["enter"]),
                      V(z((p) => e.clickGeneratedLink(m, !0), ["exact", "prevent"]), ["space"])
                    ]
                  }, [
                    L(a, {
                      id: `${m.slug || m.id}-${m.type}`,
                      element: m,
                      "toggle-fn": e.toggleOpen,
                      "path-prefix": e.content.pathPrefix,
                      "is-sub-parent": "",
                      onRouterLinkClick: t[3] || (t[3] = (p) => e.$emit("close-menu"))
                    }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
                  ], 40, jY),
                  c("span", {
                    class: "arrow-box",
                    tabindex: m.children.length ? "0" : "-1",
                    onKeydown: [
                      V(z((p) => e.toggleOpen(m.id, !0), ["exact", "prevent"]), ["enter"]),
                      V(z((p) => e.toggleOpen(m.id, !0), ["exact", "prevent"]), ["space"])
                    ]
                  }, [
                    m.children.length ? (d(), h("span", {
                      key: 0,
                      id: `${m.slug || m.id}-${m.type}-parent-button`,
                      class: "parent-arrow",
                      role: "button",
                      tabindex: "-1",
                      "aria-expanded": !!e.activeIds.includes(m.id),
                      "aria-haspopup": !0,
                      "aria-controls": `${m.slug || m.id}-${g}-child-list`,
                      "aria-label": `Toggle Submenu for ${m.name}`,
                      onClick: (p) => e.toggleOpen(m.id, !0)
                    }, null, 8, GY)) : b("", !0)
                  ], 40, UY),
                  m.children.length ? (d(), h("ul", {
                    key: 0,
                    id: `${m.slug || m.id}-${g}-child-list`,
                    "aria-labelledby": `${m.slug || m.id}-${m.type}-parent-button`
                  }, [
                    (d(!0), h(Y, null, ee(m.children, (p, T) => (d(), h("li", {
                      key: `child-${T}`,
                      style: j(
                        i.childList === p.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                      ),
                      onMouseover: (M) => r.setHoverColor("childList", p.id),
                      onMouseleave: t[5] || (t[5] = (M) => r.removeHoverColor("childList"))
                    }, [
                      c("span", {
                        class: "child-menu-element-wrapper",
                        onKeydown: [
                          V(z((M) => e.clickGeneratedLink(p, !1), ["exact", "prevent"]), ["enter"]),
                          V(z((M) => e.clickGeneratedLink(p, !1), ["exact", "prevent"]), ["space"])
                        ]
                      }, [
                        L(a, {
                          id: `${p.slug || p.id}-${p.type}`,
                          element: p,
                          "path-prefix": e.content.pathPrefix,
                          onRouterLinkClick: t[4] || (t[4] = (M) => e.$emit("close-menu"))
                        }, null, 8, ["id", "element", "path-prefix"])
                      ], 40, ZY)
                    ], 44, KY))), 128))
                  ], 8, zY)) : b("", !0)
                ], 46, VY))), 128))
              ], 8, BY)) : b("", !0)
            ]))), 128))
          ])
        ])
      ]),
      c("button", {
        ref: "close-menu-button",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[7] || (t[7] = (l) => e.$emit("close-menu"))
      }, [
        c("div", xY, [
          (d(), h("svg", WY, [
            c("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.text_color.hex,
              "fill-rule": "evenodd"
            }, [
              c("g", {
                id: "close_modal_icon",
                fill: e.theme.text_color.hex
              }, t[9] || (t[9] = [
                c("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, YY)
            ], 8, qY)
          ]))
        ])
      ], 512)
    ], 36)), [
      [s, r.closeMenuIfOpen]
    ])
  ]);
}
const QY = /* @__PURE__ */ O(IY, [["render", XY], ["__scopeId", "data-v-4f6d0b70"]]), JY = {
  name: "CMSMenu",
  components: {
    M1: rY,
    M2: $Y,
    M3: QY
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close-menu"],
  setup() {
    const e = Yn(), { hasFocus: t, activate: n, deactivate: o } = z1(e);
    return {
      activate: n,
      deactivate: o,
      hasFocus: t,
      cmsmenu: e
    };
  },
  computed: {
    hasMenu() {
      return ["M1", "M2", "M3"].includes(this.theme.version);
    }
  },
  watch: {
    "content.showMenu": {
      async handler() {
        this.content.showMenu && !this.isPreview ? (await En(), this.activate()) : (await En(), this.deactivate());
      }
    }
  }
}, eX = { id: "view-menu" };
function tX(e, t, n, o, i, r) {
  return r.hasMenu ? (d(), k(K(n.content.showMenu ? "nav" : "div"), { key: 0 }, {
    default: _(() => [
      c("div", eX, [
        L(Ee, {
          name: `${n.theme.version}-fade`
        }, {
          default: _(() => [
            n.content.showMenu ? (d(), k(K(n.theme.version), {
              key: 0,
              ref: "cmsmenu",
              theme: n.theme,
              content: n.content,
              "is-preview": n.isPreview,
              onCloseMenu: t[0] || (t[0] = (a) => e.$emit("close-menu"))
            }, null, 40, ["theme", "content", "is-preview"])) : b("", !0)
          ]),
          _: 1
        }, 8, ["name"])
      ])
    ]),
    _: 1
  })) : b("", !0);
}
const nX = /* @__PURE__ */ O(JY, [["render", tX], ["__scopeId", "data-v-794058fb"]]), oX = {
  name: "FooterHeader",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    theme: {
      type: Object,
      required: !0
    }
  }
};
function rX(e, t, n, o, i, r) {
  return d(), h("h2", {
    style: j(`color: ${n.theme.heading_color.hex || "#cccccc"};`),
    class: v(n.theme.style === "light" ? "" : "bold")
  }, y(n.item.content), 7);
}
const iX = /* @__PURE__ */ O(oX, [["render", rX]]), sX = {
  name: "FooterLink",
  props: {
    item: {
      type: Object,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    }
  },
  computed: {
    getReference() {
      return this.item.mailto ? `mailto:${this.item.email_address}` : this.item.url;
    },
    linkTarget() {
      return this.item.opens_in_new_tab ? "_blank" : "_self";
    }
  }
}, aX = ["href", "target"];
function lX(e, t, n, o, i, r) {
  return d(), h("a", {
    href: r.getReference,
    target: r.linkTarget,
    style: j({ color: n.theme.text_link_color.hex, textDecoration: "none" })
  }, y(n.item.content), 13, aX);
}
const uX = /* @__PURE__ */ O(sX, [["render", lX]]), dX = {
  name: "FooterTextField",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    theme: {
      type: Object,
      required: !0
    }
  }
};
function cX(e, t, n, o, i, r) {
  return d(), h("p", {
    style: j(`color: ${n.theme.text_link_color.hex || "#cccccc"};`),
    class: "textfield"
  }, y(n.item.content), 5);
}
const hX = /* @__PURE__ */ O(dX, [["render", cX]]), mX = {
  name: "FooterImage",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    hasLink() {
      return this.item.action_on_click === "link";
    },
    opensInNewTab() {
      return this.item.open_in_new_tab ? "_blank" : "_self";
    },
    width() {
      return this.item.display === "percentage" ? `${this.item.set_ratio * 100}%` : `${this.item.preferred_width}px`;
    },
    height() {
      let e = `max-height: ${this.item.preferred_height}px`;
      return this.item.display === "percentage" && (e = "auto"), e;
    }
  }
}, pX = ["src", "alt"];
function fX(e, t, n, o, i, r) {
  return d(), h("div", {
    class: v([n.item.image_alignment, "image-container"])
  }, [
    (d(), k(K(r.hasLink ? "a" : "div"), {
      style: j({ width: r.width, height: r.height }),
      href: r.hasLink && n.item.link_url,
      target: r.hasLink && r.opensInNewTab,
      class: "image-wrapper"
    }, {
      default: _(() => [
        c("img", {
          src: n.item.url,
          alt: n.item.alt_text
        }, null, 8, pX)
      ]),
      _: 1
    }, 8, ["style", "href", "target"]))
  ], 2);
}
const gX = /* @__PURE__ */ O(mX, [["render", fX], ["__scopeId", "data-v-37437fa5"]]), vX = /(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/g, bX = (e) => {
  if (typeof e != "string")
    throw new Error("Expected a string argument");
  return e.replace(vX, (n) => `<a href="tel:${n}" class="tel-link">${n}</a>`);
}, lf = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    organizations: {
      type: Array,
      required: !0
    },
    iosLink: {
      type: String,
      default: ""
    },
    androidLink: {
      type: String,
      default: ""
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isIFrame: {
      type: Boolean,
      default: !1
    },
    currentDomain: {
      type: String,
      default: null
    },
    logo: {
      type: String,
      default: ""
    }
  },
  methods: {
    addTelLinksToPhoneNumbers: bX
  },
  computed: {
    logoImage() {
      return this.isPreview ? this.logo : this.content.logo.url;
    },
    logoWidth() {
      return this.content.logo.display === "percentage" ? `${this.content.logo.set_ratio * 100}%` : `${this.content.logo.preferred_width || 150}px`;
    },
    logoHeight() {
      return this.content.logo.display === "percentage" || !this.content.logo.preferred_height ? "100%" : `${this.content.logo.preferred_height}px`;
    },
    logoAlignment() {
      return S(this.content, "logo.image_alignment", "center");
    },
    firstColumnHeader() {
      return this.content.columns[0].hasHeader || this.isPreview ? this.content.columns[0].header : !1;
    },
    info() {
      return this.content.organization_info;
    },
    currentYear() {
      return (/* @__PURE__ */ new Date()).getFullYear();
    },
    primaryOrg() {
      return this.organizations.filter((e) => e.primary);
    },
    copyrightOrg() {
      return this.organizations.length > 0 && !this.isIFrame ? this.primaryOrg[0].name : "School District";
    },
    translations() {
      return this.theme.translations;
    },
    cssVars() {
      return {
        "--bg-color": S(this.theme, "bg_color.hex", "#ffffff"),
        "--heading-color": S(this.theme, "heading_color.hex", "#cccccc"),
        "--link-color": S(this.theme, "text_link_color.hex", "#000000"),
        "--text-link-color": S(this.theme, "text_link_color.hex", "#000000"),
        "--logo-width": this.logoWidth,
        "--logo-height": this.logoHeight,
        "--logo-alignment": this.logoAlignment
      };
    }
  }
}, uf = "data:image/svg+xml,%3csvg%20width='135'%20height='40'%20viewBox='0%200%20135%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%205C0%202.23858%202.23858%200%205%200H130C132.761%200%20135%202.23858%20135%205V35C135%2037.7614%20132.761%2040%20130%2040H5C2.23857%2040%200%2037.7614%200%2035V5Z'%20fill='black'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M130%201H5C2.79086%201%201%202.79086%201%205V35C1%2037.2091%202.79086%2039%205%2039H130C132.209%2039%20134%2037.2091%20134%2035V5C134%202.79086%20132.209%201%20130%201ZM5%200C2.23858%200%200%202.23858%200%205V35C0%2037.7614%202.23857%2040%205%2040H130C132.761%2040%20135%2037.7614%20135%2035V5C135%202.23858%20132.761%200%20130%200H5Z'%20fill='%23A6A6A6'/%3e%3cpath%20d='M81.5259%2019.2009V21.4919H80.0898V22.9944H81.5259V28.0994C81.5259%2029.8425%2082.3144%2030.5398%2084.2983%2030.5398C84.647%2030.5398%2084.979%2030.4983%2085.2695%2030.4485V28.9626C85.0205%2028.9875%2084.8628%2029.0041%2084.5889%2029.0041C83.7007%2029.0041%2083.3105%2028.5891%2083.3105%2027.6428V22.9944H85.2695V21.4919H83.3105V19.2009H81.5259Z'%20fill='white'/%3e%3cpath%20d='M90.3234%2030.6643C92.963%2030.6643%2094.5817%2028.8962%2094.5817%2025.9661C94.5817%2023.0525%2092.9547%2021.2761%2090.3234%2021.2761C87.6837%2021.2761%2086.0568%2023.0525%2086.0568%2025.9661C86.0568%2028.8962%2087.6754%2030.6643%2090.3234%2030.6643ZM90.3234%2029.0789C88.7711%2029.0789%2087.8995%2027.9416%2087.8995%2025.9661C87.8995%2024.0071%2088.7711%2022.8616%2090.3234%2022.8616C91.8673%2022.8616%2092.7472%2024.0071%2092.7472%2025.9661C92.7472%2027.9333%2091.8673%2029.0789%2090.3234%2029.0789Z'%20fill='white'/%3e%3cpath%20d='M95.9666%2030.49H97.7512V25.1526C97.7512%2023.8826%2098.7058%2023.0276%20100.059%2023.0276C100.374%2023.0276%20100.906%2023.0857%20101.055%2023.1355V21.3757C100.864%2021.3259%20100.524%2021.301%20100.258%2021.301C99.0794%2021.301%2098.075%2021.9485%2097.8176%2022.8367H97.6848V21.4504H95.9666V30.49Z'%20fill='white'/%3e%3cpath%20d='M105.486%2022.7952C106.806%2022.7952%20107.669%2023.7165%20107.711%2025.136H103.145C103.245%2023.7248%20104.166%2022.7952%20105.486%2022.7952ZM107.703%2028.0496C107.371%2028.7551%20106.632%2029.1453%20105.553%2029.1453C104.125%2029.1453%20103.204%2028.1409%20103.145%2026.5554V26.4558H109.529V25.8332C109.529%2022.9944%20108.01%2021.2761%20105.495%2021.2761C102.946%2021.2761%20101.328%2023.1106%20101.328%2025.9993C101.328%2028.8879%20102.913%2030.6643%20105.503%2030.6643C107.57%2030.6643%20109.014%2029.6682%20109.421%2028.0496H107.703Z'%20fill='white'/%3e%3cpath%20d='M69.8223%2027.1518C69.9599%2029.3715%2071.8097%2030.7911%2074.5628%2030.7911C77.5052%2030.7911%2079.3464%2029.3027%2079.3464%2026.9281C79.3464%2025.0612%2078.2967%2024.0287%2075.7501%2023.4351L74.3821%2023.0996C72.7647%2022.721%2072.1108%2022.2134%2072.1108%2021.3272C72.1108%2020.2088%2073.126%2019.4775%2074.6489%2019.4775C76.0942%2019.4775%2077.0923%2020.1916%2077.2729%2021.3358H79.1485C79.0366%2019.2452%2077.1955%2017.774%2074.6747%2017.774C71.9646%2017.774%2070.1578%2019.2452%2070.1578%2021.4563C70.1578%2023.2802%2071.1816%2024.3643%2073.4272%2024.8891L75.0274%2025.2763C76.6707%2025.6634%2077.3934%2026.2312%2077.3934%2027.1776C77.3934%2028.2789%2076.2577%2029.079%2074.7091%2029.079C73.0486%2029.079%2071.8957%2028.3305%2071.7323%2027.1518H69.8223Z'%20fill='white'/%3e%3cpath%20d='M51.3349%2021.301C50.1064%2021.301%2049.0439%2021.9153%2048.4961%2022.9446H48.3633V21.4504H46.645V33.4949H48.4297V29.1204H48.5708C49.0439%2030.0749%2050.0649%2030.6394%2051.3516%2030.6394C53.6343%2030.6394%2055.0869%2028.8381%2055.0869%2025.9661C55.0869%2023.094%2053.6343%2021.301%2051.3349%2021.301ZM50.8286%2029.0373C49.3345%2029.0373%2048.3965%2027.8586%2048.3965%2025.9744C48.3965%2024.0818%2049.3345%2022.9031%2050.8369%2022.9031C52.3476%2022.9031%2053.2524%2024.0569%2053.2524%2025.9661C53.2524%2027.8835%2052.3476%2029.0373%2050.8286%2029.0373Z'%20fill='white'/%3e%3cpath%20d='M61.3317%2021.301C60.1032%2021.301%2059.0407%2021.9153%2058.4929%2022.9446H58.3601V21.4504H56.6418V33.4949H58.4265V29.1204H58.5676C59.0407%2030.0749%2060.0617%2030.6394%2061.3483%2030.6394C63.6311%2030.6394%2065.0837%2028.8381%2065.0837%2025.9661C65.0837%2023.094%2063.6311%2021.301%2061.3317%2021.301ZM60.8254%2029.0373C59.3313%2029.0373%2058.3933%2027.8586%2058.3933%2025.9744C58.3933%2024.0818%2059.3313%2022.9031%2060.8337%2022.9031C62.3444%2022.9031%2063.2492%2024.0569%2063.2492%2025.9661C63.2492%2027.8835%2062.3444%2029.0373%2060.8254%2029.0373Z'%20fill='white'/%3e%3cpath%20d='M43.443%2030.49H45.4906L41.0082%2018.0751H38.9348L34.4523%2030.49H36.4311L37.5754%2027.1948H42.3073L43.443%2030.49ZM39.8725%2020.3292H40.0188L41.8169%2025.5774H38.0658L39.8725%2020.3292Z'%20fill='white'/%3e%3cpath%20d='M35.6511%208.71094V14.7H37.8135C39.5981%2014.7%2040.6316%2013.6001%2040.6316%2011.6868C40.6316%209.80249%2039.5898%208.71094%2037.8135%208.71094H35.6511ZM36.5808%209.55762H37.7097C38.9507%209.55762%2039.6853%2010.3462%2039.6853%2011.6992C39.6853%2013.073%2038.9631%2013.8533%2037.7097%2013.8533H36.5808V9.55762Z'%20fill='white'/%3e%3cpath%20d='M43.7967%2014.7871C45.1165%2014.7871%2045.9258%2013.9031%2045.9258%2012.438C45.9258%2010.9812%2045.1124%2010.093%2043.7967%2010.093C42.4769%2010.093%2041.6634%2010.9812%2041.6634%2012.438C41.6634%2013.9031%2042.4727%2014.7871%2043.7967%2014.7871ZM43.7967%2013.9944C43.0206%2013.9944%2042.5848%2013.4258%2042.5848%2012.438C42.5848%2011.4585%2043.0206%2010.8857%2043.7967%2010.8857C44.5687%2010.8857%2045.0086%2011.4585%2045.0086%2012.438C45.0086%2013.4216%2044.5687%2013.9944%2043.7967%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M52.818%2010.1802H51.9256L51.1205%2013.6292H51.0499L50.1202%2010.1802H49.2652L48.3355%2013.6292H48.2691L47.4598%2010.1802H46.555L47.8001%2014.7H48.7174L49.6471%2011.3713H49.7176L50.6515%2014.7H51.577L52.818%2010.1802Z'%20fill='white'/%3e%3cpath%20d='M53.8456%2014.7H54.7379V12.0562C54.7379%2011.3506%2055.1571%2010.9106%2055.817%2010.9106C56.477%2010.9106%2056.7924%2011.2717%2056.7924%2011.998V14.7H57.6847V11.7739C57.6847%2010.699%2057.1286%2010.093%2056.12%2010.093C55.4394%2010.093%2054.9911%2010.396%2054.7711%2010.8982H54.7047V10.1802H53.8456V14.7Z'%20fill='white'/%3e%3cpath%20d='M59.09%2014.7H59.9824V8.41626H59.09V14.7Z'%20fill='white'/%3e%3cpath%20d='M63.3384%2014.7871C64.6582%2014.7871%2065.4675%2013.9031%2065.4675%2012.438C65.4675%2010.9812%2064.6541%2010.093%2063.3384%2010.093C62.0186%2010.093%2061.2051%2010.9812%2061.2051%2012.438C61.2051%2013.9031%2062.0144%2014.7871%2063.3384%2014.7871ZM63.3384%2013.9944C62.5623%2013.9944%2062.1265%2013.4258%2062.1265%2012.438C62.1265%2011.4585%2062.5623%2010.8857%2063.3384%2010.8857C64.1104%2010.8857%2064.5503%2011.4585%2064.5503%2012.438C64.5503%2013.4216%2064.1104%2013.9944%2063.3384%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M68.1263%2014.0234C67.6407%2014.0234%2067.2879%2013.7869%2067.2879%2013.3801C67.2879%2012.9817%2067.5701%2012.77%2068.1927%2012.7285L69.2967%2012.658V13.0356C69.2967%2013.5959%2068.7986%2014.0234%2068.1263%2014.0234ZM67.898%2014.7747C68.4915%2014.7747%2068.9854%2014.5173%2069.2552%2014.0649H69.3257V14.7H70.1849V11.6121C70.1849%2010.6575%2069.5457%2010.093%2068.4126%2010.093C67.3875%2010.093%2066.657%2010.5911%2066.5657%2011.3672H67.429C67.5286%2011.0476%2067.8731%2010.865%2068.3711%2010.865C68.9812%2010.865%2069.2967%2011.1348%2069.2967%2011.6121V12.0022L68.0723%2012.0728C66.9974%2012.1392%2066.3914%2012.6082%2066.3914%2013.4216C66.3914%2014.2476%2067.0264%2014.7747%2067.898%2014.7747Z'%20fill='white'/%3e%3cpath%20d='M73.213%2014.7747C73.8355%2014.7747%2074.3626%2014.48%2074.6324%2013.9861H74.703V14.7H75.558V8.41626H74.6656V10.8982H74.5992C74.3543%2010.4001%2073.8314%2010.1055%2073.213%2010.1055C72.0716%2010.1055%2071.337%2011.0103%2071.337%2012.438C71.337%2013.8699%2072.0633%2014.7747%2073.213%2014.7747ZM73.4662%2010.9065C74.2132%2010.9065%2074.6822%2011.5%2074.6822%2012.4421C74.6822%2013.3884%2074.2174%2013.9736%2073.4662%2013.9736C72.7108%2013.9736%2072.2584%2013.3967%2072.2584%2012.438C72.2584%2011.4875%2072.7149%2010.9065%2073.4662%2010.9065Z'%20fill='white'/%3e%3cpath%20d='M81.3444%2014.7871C82.6643%2014.7871%2083.4736%2013.9031%2083.4736%2012.438C83.4736%2010.9812%2082.6601%2010.093%2081.3444%2010.093C80.0246%2010.093%2079.2111%2010.9812%2079.2111%2012.438C79.2111%2013.9031%2080.0205%2014.7871%2081.3444%2014.7871ZM81.3444%2013.9944C80.5683%2013.9944%2080.1325%2013.4258%2080.1325%2012.438C80.1325%2011.4585%2080.5683%2010.8857%2081.3444%2010.8857C82.1164%2010.8857%2082.5563%2011.4585%2082.5563%2012.438C82.5563%2013.4216%2082.1164%2013.9944%2081.3444%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M84.6548%2014.7H85.5471V12.0562C85.5471%2011.3506%2085.9663%2010.9106%2086.6262%2010.9106C87.2861%2010.9106%2087.6016%2011.2717%2087.6016%2011.998V14.7H88.4939V11.7739C88.4939%2010.699%2087.9377%2010.093%2086.9292%2010.093C86.2485%2010.093%2085.8003%2010.396%2085.5803%2010.8982H85.5139V10.1802H84.6548V14.7Z'%20fill='white'/%3e%3cpath%20d='M92.6036%209.05542V10.2009H91.8856V10.9521H92.6036V13.5046C92.6036%2014.3762%2092.9979%2014.7249%2093.9898%2014.7249C94.1642%2014.7249%2094.3302%2014.7041%2094.4754%2014.6792V13.9363C94.3509%2013.9487%2094.2721%2013.957%2094.1351%2013.957C93.691%2013.957%2093.4959%2013.7495%2093.4959%2013.2764V10.9521H94.4754V10.2009H93.4959V9.05542H92.6036Z'%20fill='white'/%3e%3cpath%20d='M95.6732%2014.7H96.5656V12.0603C96.5656%2011.3755%2096.9723%2010.9148%2097.7028%2010.9148C98.3336%2010.9148%2098.6698%2011.28%2098.6698%2012.0022V14.7H99.5622V11.7822C99.5622%2010.7073%2098.9687%2010.0972%2098.0058%2010.0972C97.3251%2010.0972%2096.8478%2010.4001%2096.6278%2010.9065H96.5573V8.41626H95.6732V14.7Z'%20fill='white'/%3e%3cpath%20d='M102.781%2010.8525C103.441%2010.8525%20103.873%2011.3132%20103.894%2012.0229H101.611C101.661%2011.3174%20102.121%2010.8525%20102.781%2010.8525ZM103.889%2013.4797C103.723%2013.8325%20103.354%2014.0276%20102.814%2014.0276C102.101%2014.0276%20101.64%2013.5254%20101.611%2012.7327V12.6829H104.802V12.3716C104.802%2010.9521%20104.043%2010.093%20102.785%2010.093C101.511%2010.093%20100.702%2011.0103%20100.702%2012.4546C100.702%2013.8989%20101.495%2014.7871%20102.789%2014.7871C103.823%2014.7871%20104.545%2014.2891%20104.748%2013.4797H103.889Z'%20fill='white'/%3e%3cpath%20d='M24.769%2020.3008C24.7907%2018.6198%2025.6934%2017.0292%2027.1256%2016.1488C26.2221%2014.8584%2024.7088%2014.0403%2023.1344%2013.9911C21.4552%2013.8148%2019.8272%2014.9959%2018.9715%2014.9959C18.0992%2014.9959%2016.7817%2014.0086%2015.363%2014.0378C13.5137%2014.0975%2011.7898%2015.1489%2010.8901%2016.7656C8.95607%2020.1141%2010.3987%2025.0351%2012.2513%2027.7417C13.1782%2029.0671%2014.2615%2030.5475%2015.6789%2030.495C17.066%2030.4375%2017.584%2029.6105%2019.2583%2029.6105C20.9171%2029.6105%2021.4031%2030.495%2022.8493%2030.4616C24.3377%2030.4375%2025.2754%2029.1304%2026.1698%2027.7925C26.8358%2026.8481%2027.3483%2025.8044%2027.6882%2024.7C25.9391%2023.9602%2024.771%2022.2%2024.769%2020.3008Z'%20fill='white'/%3e%3cpath%20d='M22.0373%2012.2111C22.8489%2011.2369%2023.2487%209.98469%2023.1518%208.72046C21.912%208.85068%2020.7668%209.44324%2019.9443%2010.3801C19.14%2011.2954%2018.7214%2012.5255%2018.8006%2013.7415C20.0408%2013.7542%2021.2601%2013.1777%2022.0373%2012.2111Z'%20fill='white'/%3e%3c/svg%3e", df = "data:image/svg+xml,%3csvg%20width='135'%20height='40'%20viewBox='0%200%20135%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%205C0%202.23858%202.23858%200%205%200H130C132.761%200%20135%202.23858%20135%205V35C135%2037.7614%20132.761%2040%20130%2040H5C2.23857%2040%200%2037.7614%200%2035V5Z'%20fill='black'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M130%201H5C2.79086%201%201%202.79086%201%205V35C1%2037.2091%202.79086%2039%205%2039H130C132.209%2039%20134%2037.2091%20134%2035V5C134%202.79086%20132.209%201%20130%201ZM5%200C2.23858%200%200%202.23858%200%205V35C0%2037.7614%202.23857%2040%205%2040H130C132.761%2040%20135%2037.7614%20135%2035V5C135%202.23858%20132.761%200%20130%200H5Z'%20fill='%23A6A6A6'/%3e%3cpath%20d='M68.136%2020.8861C65.784%2020.8861%2063.867%2022.6751%2063.867%2025.1391C63.867%2027.5881%2065.784%2029.3921%2068.136%2029.3921C70.489%2029.3921%2072.406%2027.5881%2072.406%2025.1391C72.405%2022.6751%2070.488%2020.8861%2068.136%2020.8861ZM68.136%2027.7181C66.847%2027.7181%2065.736%2026.6551%2065.736%2025.1401C65.736%2023.6091%2066.848%2022.5621%2068.136%2022.5621C69.425%2022.5621%2070.536%2023.6091%2070.536%2025.1401C70.536%2026.6541%2069.425%2027.7181%2068.136%2027.7181ZM58.822%2020.8861C56.47%2020.8861%2054.553%2022.6751%2054.553%2025.1391C54.553%2027.5881%2056.47%2029.3921%2058.822%2029.3921C61.175%2029.3921%2063.092%2027.5881%2063.092%2025.1391C63.092%2022.6751%2061.175%2020.8861%2058.822%2020.8861ZM58.822%2027.7181C57.533%2027.7181%2056.422%2026.6551%2056.422%2025.1401C56.422%2023.6091%2057.534%2022.5621%2058.822%2022.5621C60.111%2022.5621%2061.222%2023.6091%2061.222%2025.1401C61.223%2026.6541%2060.111%2027.7181%2058.822%2027.7181ZM47.744%2022.1921V23.9961H52.062C51.933%2025.0111%2051.595%2025.7521%2051.079%2026.2671C50.451%2026.8951%2049.468%2027.5881%2047.744%2027.5881C45.086%2027.5881%2043.008%2025.4451%2043.008%2022.7871C43.008%2020.1291%2045.086%2017.9861%2047.744%2017.9861C49.178%2017.9861%2050.225%2018.5501%2050.998%2019.2751L52.271%2018.0021C51.191%2016.9711%2049.758%2016.1821%2047.744%2016.1821C44.103%2016.1821%2041.042%2019.1461%2041.042%2022.7871C41.042%2026.4281%2044.103%2029.3921%2047.744%2029.3921C49.709%2029.3921%2051.192%2028.7471%2052.351%2027.5391C53.543%2026.3471%2053.914%2024.6711%2053.914%2023.3181C53.914%2022.9001%2053.882%2022.5131%2053.817%2022.1911H47.744V22.1921ZM93.052%2023.5931C92.698%2022.6431%2091.618%2020.8861%2089.411%2020.8861C87.22%2020.8861%2085.399%2022.6101%2085.399%2025.1391C85.399%2027.5231%2087.204%2029.3921%2089.62%2029.3921C91.569%2029.3921%2092.697%2028.2001%2093.165%2027.5071L91.715%2026.5401C91.232%2027.2491%2090.571%2027.7161%2089.62%2027.7161C88.67%2027.7161%2087.993%2027.2811%2087.558%2026.4271L93.245%2024.0751L93.052%2023.5931ZM87.252%2025.0111C87.204%2023.3671%2088.525%2022.5301%2089.476%2022.5301C90.217%2022.5301%2090.845%2022.9011%2091.055%2023.4321L87.252%2025.0111ZM82.629%2029.1351H84.497V16.6341H82.629V29.1351ZM79.567%2021.8371H79.503C79.084%2021.3371%2078.278%2020.8861%2077.264%2020.8861C75.137%2020.8861%2073.188%2022.7551%2073.188%2025.1561C73.188%2027.5401%2075.137%2029.3931%2077.264%2029.3931C78.279%2029.3931%2079.084%2028.9421%2079.503%2028.4271H79.567V29.0391C79.567%2030.6661%2078.697%2031.5361%2077.296%2031.5361C76.152%2031.5361%2075.443%2030.7151%2075.153%2030.0221L73.526%2030.6991C73.993%2031.8261%2075.233%2033.2121%2077.296%2033.2121C79.487%2033.2121%2081.34%2031.9231%2081.34%2028.7811V21.1451H79.568V21.8371H79.567ZM77.425%2027.7181C76.136%2027.7181%2075.057%2026.6381%2075.057%2025.1561C75.057%2023.6571%2076.136%2022.5621%2077.425%2022.5621C78.697%2022.5621%2079.696%2023.6571%2079.696%2025.1561C79.696%2026.6381%2078.697%2027.7181%2077.425%2027.7181ZM101.806%2016.6341H97.335V29.1351H99.2V24.3991H101.805C103.873%2024.3991%20105.907%2022.9021%20105.907%2020.5171C105.907%2018.1321%20103.874%2016.6341%20101.806%2016.6341ZM101.854%2022.6591H99.2V18.3741H101.854C103.249%2018.3741%20104.041%2019.5291%20104.041%2020.5171C104.041%2021.4851%20103.249%2022.6591%20101.854%2022.6591ZM113.386%2020.8641C112.035%2020.8641%20110.636%2021.4591%20110.057%2022.7781L111.713%2023.4691C112.067%2022.7781%20112.727%2022.5521%20113.418%2022.5521C114.383%2022.5521%20115.364%2023.1311%20115.38%2024.1601V24.2891C115.042%2024.0961%20114.318%2023.8071%20113.434%2023.8071C111.649%2023.8071%20109.831%2024.7881%20109.831%2026.6211C109.831%2028.2941%20111.295%2029.3711%20112.935%2029.3711C114.189%2029.3711%20114.881%2028.8081%20115.315%2028.1481H115.379V29.1131H117.181V24.3201C117.182%2022.1021%20115.524%2020.8641%20113.386%2020.8641ZM113.16%2027.7151C112.55%2027.7151%20111.697%2027.4091%20111.697%2026.6531C111.697%2025.6881%20112.759%2025.3181%20113.676%2025.3181C114.495%2025.3181%20114.882%2025.4951%20115.38%2025.7361C115.235%2026.8951%20114.238%2027.7151%20113.16%2027.7151ZM123.743%2021.1371L121.604%2026.5571H121.54L119.32%2021.1371H117.31L120.639%2028.7121L118.741%2032.9261H120.687L125.818%2021.1371H123.743ZM106.937%2029.1351H108.802V16.6341H106.937V29.1351Z'%20fill='white'/%3e%3cpath%20d='M47.418%209.37795C47.418%2010.216%2047.17%2010.883%2046.673%2011.381C46.109%2011.973%2045.3731%2012.269%2044.4691%2012.269C43.6031%2012.269%2042.8661%2011.969%2042.2611%2011.369C41.6551%2010.768%2041.3521%2010.024%2041.3521%209.13595C41.3521%208.24695%2041.6551%207.50295%2042.2611%206.90295C42.8661%206.30195%2043.6031%206.00195%2044.4691%206.00195C44.8991%206.00195%2045.3101%206.08595%2045.7001%206.25295C46.0911%206.42095%2046.4041%206.64395%2046.6381%206.92295L46.111%207.45095C45.714%206.97595%2045.167%206.73895%2044.468%206.73895C43.836%206.73895%2043.29%206.96095%2042.829%207.40495C42.368%207.84895%2042.1381%208.42595%2042.1381%209.13495C42.1381%209.84395%2042.368%2010.421%2042.829%2010.865C43.29%2011.309%2043.836%2011.531%2044.468%2011.531C45.138%2011.531%2045.6971%2011.308%2046.1441%2010.861C46.4341%2010.57%2046.602%2010.165%2046.647%209.64595H44.468V8.92495H47.375C47.405%209.08195%2047.418%209.23295%2047.418%209.37795Z'%20fill='white'/%3e%3cpath%20d='M52.0281%206.87201H49.2961V8.77401H51.7601V9.49501H49.2961V11.397H52.0281V12.135H48.5251V6.13501H52.0281V6.87201Z'%20fill='white'/%3e%3cpath%20d='M55.279%2012.135H54.508V6.87201H52.832V6.13501H56.955V6.87201H55.279V12.135Z'%20fill='white'/%3e%3cpath%20d='M59.938%2012.135V6.13501H60.709V12.135H59.938Z'%20fill='white'/%3e%3cpath%20d='M64.1281%2012.135H63.3572V6.87201H61.6812V6.13501H65.8042V6.87201H64.1281V12.135Z'%20fill='white'/%3e%3cpath%20d='M73.6089%2011.36C73.0189%2011.966%2072.2859%2012.269%2071.4089%2012.269C70.5319%2012.269%2069.7989%2011.966%2069.2099%2011.36C68.6199%2010.754%2068.3259%2010.012%2068.3259%209.135C68.3259%208.258%2068.6199%207.516%2069.2099%206.91C69.7989%206.304%2070.5319%206%2071.4089%206C72.2809%206%2073.0129%206.305%2073.6049%206.914C74.1969%207.523%2074.4929%208.263%2074.4929%209.135C74.4929%2010.012%2074.1979%2010.754%2073.6089%2011.36ZM69.7789%2010.857C70.2229%2011.307%2070.7659%2011.531%2071.4089%2011.531C72.0519%2011.531%2072.5959%2011.306%2073.0389%2010.857C73.4829%2010.407%2073.7059%209.833%2073.7059%209.135C73.7059%208.437%2073.4829%207.863%2073.0389%207.413C72.5959%206.963%2072.0519%206.739%2071.4089%206.739C70.7659%206.739%2070.2229%206.964%2069.7789%207.413C69.3359%207.863%2069.1129%208.437%2069.1129%209.135C69.1129%209.833%2069.3359%2010.407%2069.7789%2010.857Z'%20fill='white'/%3e%3cpath%20d='M75.5749%2012.135V6.13501H76.513L79.429%2010.802H79.4619L79.429%209.64601V6.13501H80.1999V12.135H79.3949L76.344%207.24101H76.3109L76.344%208.39701V12.135H75.5749Z'%20fill='white'/%3e%3cpath%20d='M47.418%209.37795C47.418%2010.216%2047.17%2010.883%2046.673%2011.381C46.109%2011.973%2045.3731%2012.269%2044.4691%2012.269C43.6031%2012.269%2042.8661%2011.969%2042.2611%2011.369C41.6551%2010.768%2041.3521%2010.024%2041.3521%209.13595C41.3521%208.24695%2041.6551%207.50295%2042.2611%206.90295C42.8661%206.30195%2043.6031%206.00195%2044.4691%206.00195C44.8991%206.00195%2045.3101%206.08595%2045.7001%206.25295C46.0911%206.42095%2046.4041%206.64395%2046.6381%206.92295L46.111%207.45095C45.714%206.97595%2045.167%206.73895%2044.468%206.73895C43.836%206.73895%2043.29%206.96095%2042.829%207.40495C42.368%207.84895%2042.1381%208.42595%2042.1381%209.13495C42.1381%209.84395%2042.368%2010.421%2042.829%2010.865C43.29%2011.309%2043.836%2011.531%2044.468%2011.531C45.138%2011.531%2045.6971%2011.308%2046.1441%2010.861C46.4341%2010.57%2046.602%2010.165%2046.647%209.64595H44.468V8.92495H47.375C47.405%209.08195%2047.418%209.23295%2047.418%209.37795Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M52.0281%206.87201H49.2961V8.77401H51.7601V9.49501H49.2961V11.397H52.0281V12.135H48.5251V6.13501H52.0281V6.87201Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M55.279%2012.135H54.508V6.87201H52.832V6.13501H56.955V6.87201H55.279V12.135Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M59.938%2012.135V6.13501H60.709V12.135H59.938Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M64.1281%2012.135H63.3572V6.87201H61.6812V6.13501H65.8042V6.87201H64.1281V12.135Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M73.6089%2011.36C73.0189%2011.966%2072.2859%2012.269%2071.4089%2012.269C70.5319%2012.269%2069.7989%2011.966%2069.2099%2011.36C68.6199%2010.754%2068.3259%2010.012%2068.3259%209.135C68.3259%208.258%2068.6199%207.516%2069.2099%206.91C69.7989%206.304%2070.5319%206%2071.4089%206C72.2809%206%2073.0129%206.305%2073.6049%206.914C74.1969%207.523%2074.4929%208.263%2074.4929%209.135C74.4929%2010.012%2074.1979%2010.754%2073.6089%2011.36ZM69.7789%2010.857C70.2229%2011.307%2070.7659%2011.531%2071.4089%2011.531C72.0519%2011.531%2072.5959%2011.306%2073.0389%2010.857C73.4829%2010.407%2073.7059%209.833%2073.7059%209.135C73.7059%208.437%2073.4829%207.863%2073.0389%207.413C72.5959%206.963%2072.0519%206.739%2071.4089%206.739C70.7659%206.739%2070.2229%206.964%2069.7789%207.413C69.3359%207.863%2069.1129%208.437%2069.1129%209.135C69.1129%209.833%2069.3359%2010.407%2069.7789%2010.857Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M75.5749%2012.135V6.13501H76.513L79.429%2010.802H79.4619L79.429%209.64601V6.13501H80.1999V12.135H79.3949L76.344%207.24101H76.3109L76.344%208.39701V12.135H75.5749Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cg%20filter='url(%23filter0_ii)'%3e%3cpath%20d='M10.436%206.67302C10.145%206.98102%209.97302%207.45902%209.97302%208.07802V30.194C9.97302%2030.814%2010.145%2031.291%2010.436%2031.599L10.51%2031.671L22.899%2019.282V19.136V18.99L10.51%206.60002L10.436%206.67302Z'%20fill='url(%23paint0_linear)'/%3e%3cpath%20d='M27.028%2023.413L22.899%2019.282V19.136V18.99L27.029%2014.86L27.122%2014.913L32.015%2017.693C33.412%2018.487%2033.412%2019.786%2032.015%2020.581L27.122%2023.361L27.028%2023.413Z'%20fill='url(%23paint1_linear)'/%3e%3cg%20filter='url(%23filter1_i)'%3e%3cpath%20d='M27.122%2023.36L22.898%2019.136L10.436%2031.599C10.896%2032.087%2011.657%2032.147%2012.514%2031.661L27.122%2023.36Z'%20fill='url(%23paint2_linear)'/%3e%3c/g%3e%3cpath%20d='M27.122%2014.912L12.514%206.61202C11.657%206.12502%2010.896%206.18602%2010.436%206.67402L22.899%2019.137L27.122%2014.912Z'%20fill='url(%23paint3_linear)'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_ii'%20x='9.97302'%20y='6.27594'%20width='23.0898'%20height='25.7208'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='-0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.12%200'/%3e%3cfeBlend%20mode='normal'%20in2='shape'%20result='effect1_innerShadow'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%201%200%200%200%200%201%200%200%200%200%201%200%200%200%200.25%200'/%3e%3cfeBlend%20mode='normal'%20in2='effect1_innerShadow'%20result='effect2_innerShadow'/%3e%3c/filter%3e%3cfilter%20id='filter1_i'%20x='10.436'%20y='19.136'%20width='16.686'%20height='12.8607'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='-0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.08%200'/%3e%3cfeBlend%20mode='normal'%20in2='shape'%20result='effect1_innerShadow'/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear'%20x1='21.8008'%20y1='7.84402'%20x2='5.01882'%20y2='24.626'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%2300A0FF'/%3e%3cstop%20offset='0.0066'%20stop-color='%2300A1FF'/%3e%3cstop%20offset='0.2601'%20stop-color='%2300BEFF'/%3e%3cstop%20offset='0.5122'%20stop-color='%2300D2FF'/%3e%3cstop%20offset='0.7604'%20stop-color='%2300DFFF'/%3e%3cstop%20offset='1'%20stop-color='%2300E3FF'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear'%20x1='33.8335'%20y1='19.136'%20x2='9.63765'%20y2='19.136'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FFE000'/%3e%3cstop%20offset='0.4087'%20stop-color='%23FFBD00'/%3e%3cstop%20offset='0.7754'%20stop-color='%23FFA500'/%3e%3cstop%20offset='1'%20stop-color='%23FF9C00'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear'%20x1='24.8281'%20y1='21.4299'%20x2='2.06964'%20y2='44.1884'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FF3A44'/%3e%3cstop%20offset='1'%20stop-color='%23C31162'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear'%20x1='7.29743'%20y1='-0.688184'%20x2='17.4597'%20y2='9.47412'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%2332A071'/%3e%3cstop%20offset='0.0685'%20stop-color='%232DA771'/%3e%3cstop%20offset='0.4762'%20stop-color='%2315CF74'/%3e%3cstop%20offset='0.8009'%20stop-color='%2306E775'/%3e%3cstop%20offset='1'%20stop-color='%2300F076'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", cf = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%233B5998'/%3e%3cpath%20d='M24.625%206.625H7.375C6.96016%206.625%206.625%206.96016%206.625%207.375V24.625C6.625%2025.0398%206.96016%2025.375%207.375%2025.375H24.625C25.0398%2025.375%2025.375%2025.0398%2025.375%2024.625V7.375C25.375%206.96016%2025.0398%206.625%2024.625%206.625ZM22.4594%2012.0977H20.9617C19.7875%2012.0977%2019.5602%2012.6555%2019.5602%2013.4758V15.2828H22.3633L21.9977%2018.1117H19.5602V25.375H16.6375V18.1141H14.193V15.2828H16.6375V13.1969C16.6375%2010.7758%2018.1164%209.45625%2020.2773%209.45625C21.3133%209.45625%2022.2016%209.53359%2022.4617%209.56875V12.0977H22.4594Z'%20fill='white'/%3e%3c/svg%3e", hf = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2028.0.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2032%2032'%20style='enable-background:new%200%200%2032%2032;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%23231F20;}%20.st1{fill:%23FFFFFF;}%20%3c/style%3e%3cpath%20class='st0'%20d='M2,0h28c1.1,0,2,0.9,2,2v28c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z'/%3e%3cpath%20class='st1'%20d='M17.6,14.7L24,7.2h-1.5L17,13.7l-4.4-6.5H7.4l6.7,9.8l-6.7,7.8h1.5l5.9-6.8l4.7,6.8h5.1L17.6,14.7L17.6,14.7z%20M15.6,17.1l-0.7-1L9.5,8.3h2.3l4.4,6.3l0.7,1l5.7,8.1h-2.3L15.6,17.1L15.6,17.1z'/%3e%3c/svg%3e", mf = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%23FF0000'/%3e%3cpath%20d='M26.0617%2010.9398C25.9422%2010.4946%2025.7078%2010.0886%2025.382%209.76243C25.0563%209.43625%2024.6505%209.20136%2024.2055%209.08125C22.5672%208.64063%2016%208.64062%2016%208.64062C16%208.64062%209.43281%208.64062%207.79453%209.07891C7.34927%209.19862%206.94334%209.43339%206.61751%209.75962C6.29169%2010.0859%206.05744%2010.4921%205.93828%2010.9375C5.5%2012.5781%205.5%2016%205.5%2016C5.5%2016%205.5%2019.4219%205.93828%2021.0602C6.17969%2021.9648%206.89219%2022.6773%207.79453%2022.9188C9.43281%2023.3594%2016%2023.3594%2016%2023.3594C16%2023.3594%2022.5672%2023.3594%2024.2055%2022.9188C25.1102%2022.6773%2025.8203%2021.9648%2026.0617%2021.0602C26.5%2019.4219%2026.5%2016%2026.5%2016C26.5%2016%2026.5%2012.5781%2026.0617%2010.9398ZM13.9141%2019.1406V12.8594L19.3516%2015.9766L13.9141%2019.1406Z'%20fill='white'/%3e%3c/svg%3e", pf = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%23E5017B'/%3e%3cpath%20d='M16%2011.193C13.3398%2011.193%2011.193%2013.3398%2011.193%2016C11.193%2018.6602%2013.3398%2020.807%2016%2020.807C18.6601%2020.807%2020.807%2018.6602%2020.807%2016C20.807%2013.3398%2018.6601%2011.193%2016%2011.193ZM16%2019.1242C14.2797%2019.1242%2012.8758%2017.7203%2012.8758%2016C12.8758%2014.2797%2014.2797%2012.8758%2016%2012.8758C17.7203%2012.8758%2019.1242%2014.2797%2019.1242%2016C19.1242%2017.7203%2017.7203%2019.1242%2016%2019.1242ZM21.0039%209.87578C20.3828%209.87578%2019.8812%2010.3773%2019.8812%2010.9984C19.8812%2011.6195%2020.3828%2012.1211%2021.0039%2012.1211C21.625%2012.1211%2022.1266%2011.6219%2022.1266%2010.9984C22.1267%2010.851%2022.0978%2010.7049%2022.0415%2010.5686C21.9851%2010.4323%2021.9024%2010.3085%2021.7981%2010.2042C21.6939%2010.0999%2021.57%2010.0172%2021.4337%209.96086C21.2974%209.90451%2021.1514%209.87559%2021.0039%209.87578ZM25.3703%2016C25.3703%2014.7062%2025.382%2013.4242%2025.3094%2012.1328C25.2367%2010.6328%2024.8945%209.30156%2023.7976%208.20469C22.6984%207.10547%2021.3695%206.76562%2019.8695%206.69297C18.5758%206.62031%2017.2937%206.63203%2016.0023%206.63203C14.7086%206.63203%2013.4266%206.62031%2012.1351%206.69297C10.6351%206.76562%209.3039%207.10781%208.20702%208.20469C7.1078%209.3039%206.76796%2010.6328%206.6953%2012.1328C6.62265%2013.4266%206.63436%2014.7086%206.63436%2016C6.63436%2017.2914%206.62265%2018.5758%206.6953%2019.8672C6.76796%2021.3672%207.11015%2022.6984%208.20702%2023.7953C9.30624%2024.8945%2010.6351%2025.2344%2012.1351%2025.307C13.4289%2025.3797%2014.7109%2025.368%2016.0023%2025.368C17.2961%2025.368%2018.5781%2025.3797%2019.8695%2025.307C21.3695%2025.2344%2022.7008%2024.8922%2023.7976%2023.7953C24.8969%2022.6961%2025.2367%2021.3672%2025.3094%2019.8672C25.3844%2018.5758%2025.3703%2017.2937%2025.3703%2016ZM23.3078%2021.5266C23.1367%2021.9531%2022.9305%2022.2719%2022.6%2022.6C22.2695%2022.9305%2021.9531%2023.1367%2021.5266%2023.3078C20.2937%2023.7977%2017.3664%2023.6875%2016%2023.6875C14.6336%2023.6875%2011.7039%2023.7977%2010.4711%2023.3102C10.0445%2023.1391%209.72577%2022.9328%209.39765%2022.6023C9.06718%2022.2719%208.86093%2021.9555%208.68983%2021.5289C8.20233%2020.2937%208.31249%2017.3664%208.31249%2016C8.31249%2014.6336%208.20233%2011.7039%208.68983%2010.4711C8.86093%2010.0445%209.06718%209.72578%209.39765%209.39765C9.72811%209.06953%2010.0445%208.86094%2010.4711%208.68984C11.7039%208.20234%2014.6336%208.3125%2016%208.3125C17.3664%208.3125%2020.2961%208.20234%2021.5289%208.68984C21.9555%208.86094%2022.2742%209.06719%2022.6023%209.39765C22.9328%209.72812%2023.1391%2010.0445%2023.3101%2010.4711C23.7976%2011.7039%2023.6875%2014.6336%2023.6875%2016C23.6875%2017.3664%2023.7976%2020.2937%2023.3078%2021.5266Z'%20fill='white'/%3e%3c/svg%3e", yX = {
  name: "F1",
  components: {
    FooterHeader: iX,
    FooterLink: uX,
    FooterImage: gX,
    FooterTextField: hX
  },
  mixins: [lf],
  methods: {
    orgLink(e) {
      return Ho(e, {
        isPreview: this.isPreview,
        currentDomain: this.currentDomain
      });
    }
  }
}, _X = { class: "row" }, CX = {
  class: "footer-column-main",
  "data-testid": "footer-column"
}, wX = { class: "logo-wrapper" }, TX = ["src"], kX = { key: 0 }, EX = { key: 1 }, SX = { key: 2 }, MX = ["innerHTML"], AX = ["innerHTML"], $X = { key: 5 }, IX = ["innerHTML"], DX = ["href"], LX = {
  class: "footer-column-last",
  "data-testid": "footer-column"
}, OX = ["href"], NX = ["href"], PX = {
  key: 0,
  "data-social-media": "facebook",
  "data-testid": "social-icon"
}, HX = ["href"], FX = {
  key: 1,
  "data-social-media": "twitter",
  "data-testid": "social-icon"
}, RX = ["href"], BX = {
  key: 2,
  "data-social-media": "youtube",
  "data-testid": "social-icon"
}, VX = ["href"], jX = {
  key: 3,
  "data-social-media": "instagram",
  "data-testid": "social-icon"
}, UX = ["href"], GX = ["innerHTML"];
function zX(e, t, n, o, i, r) {
  return d(), h("footer", {
    id: "footer-f1",
    style: j(e.cssVars)
  }, [
    c("div", _X, [
      c("div", CX, [
        c("div", wX, [
          e.content.hasLogo || e.isPreview ? (d(), h("img", {
            key: 0,
            src: e.logoImage,
            alt: "",
            class: "footer-logo"
          }, null, 8, TX)) : b("", !0)
        ]),
        e.firstColumnHeader ? (d(), h("h2", {
          key: 0,
          class: v(e.theme.style)
        }, y(e.firstColumnHeader), 3)) : b("", !0),
        c("p", null, [
          e.info.name ? (d(), h("span", kX, y(e.info.name), 1)) : b("", !0),
          e.info.address ? (d(), h("span", EX, y(e.info.address), 1)) : b("", !0),
          e.info.city ? (d(), h("span", SX, y(e.info.city) + ", " + y(e.info.state) + " " + y(e.info.zip), 1)) : b("", !0),
          e.info.phone_number ? (d(), h("span", {
            key: 3,
            innerHTML: e.addTelLinksToPhoneNumbers(e.info.phone_number)
          }, null, 8, MX)) : b("", !0),
          e.info.fax_number ? (d(), h("span", {
            key: 4,
            innerHTML: e.addTelLinksToPhoneNumbers(e.info.fax_number)
          }, null, 8, AX)) : b("", !0),
          e.info.email ? (d(), h("span", $X, y(e.info.email), 1)) : b("", !0)
        ]),
        c("ul", null, [
          (d(!0), h(Y, null, ee(e.content.columns[0].items, (a, s) => (d(), h("li", { key: s }, [
            (d(), k(K(a.type), {
              item: a,
              theme: e.theme,
              class: v(e.theme.style)
            }, null, 8, ["item", "theme", "class"]))
          ]))), 128))
        ]),
        e.content.hasAdditionalText && e.content.additionalTextAlignment === "left" ? (d(), h("div", {
          key: 1,
          class: "additional-text",
          innerHTML: e.content.additionalText
        }, null, 8, IX)) : b("", !0)
      ]),
      (d(!0), h(Y, null, ee(e.theme.num_columns - 2, (a, s) => (d(), h("div", {
        key: s,
        class: "footer-columns",
        "data-testid": "footer-column"
      }, [
        e.content.columns[s + 1].hasHeader ? (d(), h("h2", {
          key: 0,
          class: v(e.theme.style)
        }, y(e.content.columns[s + 1].header), 3)) : b("", !0),
        s === 0 && e.content.columns[s + 1].showSchools ? (d(), h("ul", {
          key: 1,
          class: v({ "normal-window": !e.isIFrame })
        }, [
          (d(!0), h(Y, null, ee(e.organizations, (l, u) => (d(), h("li", { key: u }, [
            c("a", {
              href: r.orgLink(l)
            }, y(l.name), 9, DX)
          ]))), 128))
        ], 2)) : b("", !0),
        c("ul", {
          class: v({ "normal-window": !e.isIFrame })
        }, [
          (d(!0), h(Y, null, ee(e.content.columns[s + 1].items, (l, u) => (d(), h("li", { key: u }, [
            (d(), k(K(l.type), {
              item: l,
              theme: e.theme,
              class: v(e.theme.style)
            }, null, 8, ["item", "theme", "class"]))
          ]))), 128))
        ], 2)
      ]))), 128)),
      c("div", LX, [
        c("h2", {
          class: v(e.theme.style)
        }, y(e.translations.stay_connected), 3),
        e.iosLink || e.isPreview ? (d(), h("a", {
          key: 0,
          href: e.iosLink,
          target: "_blank",
          "data-mobile-app": "ios"
        }, t[0] || (t[0] = [
          c("img", {
            class: "app-link",
            src: uf,
            alt: "Download our iOS App",
            "data-testid": "app-icon"
          }, null, -1)
        ]), 8, OX)) : b("", !0),
        e.androidLink || e.isPreview ? (d(), h("a", {
          key: 1,
          href: e.androidLink,
          target: "_blank",
          "data-mobile-app": "android"
        }, t[1] || (t[1] = [
          c("img", {
            class: "app-link",
            src: df,
            alt: "Download our Android App",
            "data-testid": "app-icon"
          }, null, -1)
        ]), 8, NX)) : b("", !0),
        c("ul", {
          class: v(["footer-social-links", { "normal-window": !e.isIFrame }])
        }, [
          e.content.facebook || e.isPreview ? (d(), h("li", PX, [
            c("a", {
              href: e.content.facebook,
              target: "_blank"
            }, t[2] || (t[2] = [
              c("img", {
                src: cf,
                alt: "Visit us on Facebook"
              }, null, -1)
            ]), 8, HX)
          ])) : b("", !0),
          e.content.twitter || e.isPreview ? (d(), h("li", FX, [
            c("a", {
              href: e.content.twitter,
              target: "_blank"
            }, t[3] || (t[3] = [
              c("img", {
                src: hf,
                alt: "Visit us on X, formerly Twitter"
              }, null, -1)
            ]), 8, RX)
          ])) : b("", !0),
          e.content.youtube || e.isPreview ? (d(), h("li", BX, [
            c("a", {
              href: e.content.youtube,
              target: "_blank"
            }, t[4] || (t[4] = [
              c("img", {
                src: mf,
                alt: "Visit us on Youtube"
              }, null, -1)
            ]), 8, VX)
          ])) : b("", !0),
          e.content.instagram || e.isPreview ? (d(), h("li", jX, [
            c("a", {
              href: e.content.instagram,
              target: "_blank"
            }, t[5] || (t[5] = [
              c("img", {
                src: pf,
                alt: "Visit us on Instagram"
              }, null, -1)
            ]), 8, UX)
          ])) : b("", !0)
        ], 2)
      ])
    ]),
    e.content.hasAdditionalText && e.content.additionalTextAlignment === "center" ? (d(), h("div", {
      key: 0,
      class: "additional-text additional-text-bottom",
      innerHTML: e.content.additionalText
    }, null, 8, GX)) : b("", !0),
    c("div", {
      class: v(`apptegy-copyright ${e.theme.version && e.theme.version.toLowerCase()}`)
    }, [
      c("span", null, y(e.translations.copyright) + " © " + y(e.currentYear) + " " + y(e.copyrightOrg) + ". " + y(e.translations.all_rights_reserved), 1),
      c("span", null, [
        A(y(e.translations.powered_by) + " ", 1),
        t[6] || (t[6] = c("a", {
          href: "https://www.apptegy.com",
          target: "_blank",
          class: "notranslate"
        }, [
          A("Apptegy "),
          c("span", { class: "sr-only" }, "Visit us to learn more")
        ], -1))
      ])
    ], 2)
  ], 4);
}
const KX = /* @__PURE__ */ O(yX, [["render", zX], ["__scopeId", "data-v-e45d0272"]]), ZX = {
  name: "F2",
  mixins: [lf],
  computed: {
    showDownloadApps() {
      return this.content.hasApps || this.content.columns[2].showApps || this.isPreview;
    },
    showSocialMedia() {
      return this.content.hasSocial || this.content.columns[0].hasSocial || this.isPreview;
    },
    thirdColumnHeader() {
      return this.isPreview ? this.translations.stay_connected : this.content.columns[2].hasHeader ? this.content.columns[2].header : !1;
    }
  }
}, xX = { class: "footer-wrapper" }, WX = { class: "logo" }, qX = ["src"], YX = {
  class: "download-links",
  "data-testid": "download-links"
}, XX = {
  key: 1,
  class: "links-wrapper"
}, QX = ["href"], JX = ["href"], eQ = { class: "contact-data" }, tQ = {
  key: 0,
  class: "social-media"
}, nQ = {
  key: 0,
  "data-social-media": "facebook",
  "data-testid": "social-icon"
}, oQ = ["href"], rQ = {
  key: 1,
  "data-social-media": "twitter",
  "data-testid": "social-icon"
}, iQ = ["href"], sQ = {
  key: 2,
  "data-social-media": "youtube",
  "data-testid": "social-icon"
}, aQ = ["href"], lQ = {
  key: 3,
  "data-social-media": "instagram",
  "data-testid": "social-icon"
}, uQ = ["href"], dQ = { key: 0 }, cQ = { key: 1 }, hQ = { key: 2 }, mQ = { key: 3 }, pQ = ["innerHTML"], fQ = { key: 4 }, gQ = ["innerHTML"], vQ = { key: 5 }, bQ = ["innerHTML"];
function yQ(e, t, n, o, i, r) {
  return d(), h("footer", {
    id: "footer-f2",
    style: j(e.cssVars)
  }, [
    c("div", xX, [
      c("div", WX, [
        e.content.hasLogo || e.isPreview ? (d(), h("img", {
          key: 0,
          src: e.logoImage,
          alt: "",
          class: "footer-logo"
        }, null, 8, qX)) : b("", !0)
      ]),
      c("div", YX, [
        r.thirdColumnHeader ? (d(), h("h2", {
          key: 0,
          class: v(`header ${e.theme.style}`)
        }, y(r.thirdColumnHeader), 3)) : b("", !0),
        r.showDownloadApps ? (d(), h("div", XX, [
          e.iosLink || e.isPreview ? (d(), h("a", {
            key: 0,
            href: e.iosLink,
            target: "_blank",
            "data-mobile-app": "ios"
          }, t[0] || (t[0] = [
            c("img", {
              class: "app-icon",
              src: uf,
              alt: "Download our iOS App",
              "data-testid": "app-icon"
            }, null, -1)
          ]), 8, QX)) : b("", !0),
          e.androidLink || e.isPreview ? (d(), h("a", {
            key: 1,
            href: e.androidLink,
            target: "_blank",
            "data-mobile-app": "android"
          }, t[1] || (t[1] = [
            c("img", {
              class: "app-icon",
              src: df,
              alt: "Download our Android App",
              "data-testid": "app-icon"
            }, null, -1)
          ]), 8, JX)) : b("", !0)
        ])) : b("", !0)
      ]),
      c("div", eQ, [
        r.showSocialMedia ? (d(), h("ul", tQ, [
          e.content.facebook || e.isPreview ? (d(), h("li", nQ, [
            c("a", {
              href: e.content.facebook,
              target: "_blank"
            }, t[2] || (t[2] = [
              c("img", {
                src: cf,
                alt: "Visit us on Facebook",
                class: "icon-img"
              }, null, -1)
            ]), 8, oQ)
          ])) : b("", !0),
          e.content.twitter || e.isPreview ? (d(), h("li", rQ, [
            c("a", {
              href: e.content.twitter,
              target: "_blank"
            }, t[3] || (t[3] = [
              c("img", {
                src: hf,
                alt: "Visit us on X, formerly Twitter",
                class: "icon-img"
              }, null, -1)
            ]), 8, iQ)
          ])) : b("", !0),
          e.content.youtube || e.isPreview ? (d(), h("li", sQ, [
            c("a", {
              href: e.content.youtube,
              target: "_blank"
            }, t[4] || (t[4] = [
              c("img", {
                src: mf,
                alt: "Visit us on Youtube",
                class: "icon-img"
              }, null, -1)
            ]), 8, aQ)
          ])) : b("", !0),
          e.content.instagram || e.isPreview ? (d(), h("li", lQ, [
            c("a", {
              href: e.content.instagram,
              target: "_blank"
            }, t[5] || (t[5] = [
              c("img", {
                src: pf,
                alt: "Visit us on Instagram",
                class: "icon-img"
              }, null, -1)
            ]), 8, uQ)
          ])) : b("", !0)
        ])) : b("", !0),
        e.firstColumnHeader ? (d(), h("h2", {
          key: 1,
          class: v(`header ${e.theme.style}`)
        }, y(e.firstColumnHeader), 3)) : b("", !0),
        c("div", {
          class: v(`info ${e.theme.style}`)
        }, [
          e.info.name ? (d(), h("span", dQ, y(e.info.name), 1)) : b("", !0),
          t[6] || (t[6] = A("  ")),
          e.info.address ? (d(), h("span", cQ, y(e.info.address), 1)) : b("", !0),
          t[7] || (t[7] = A("  ")),
          e.info.city ? (d(), h("span", hQ, y(e.info.city) + ", " + y(e.info.state) + " " + y(e.info.zip), 1)) : b("", !0),
          t[8] || (t[8] = c("br", null, null, -1)),
          e.info.phone_number ? (d(), h("span", mQ, [
            A(y(e.translations.phone_number) + ": ", 1),
            c("span", {
              innerHTML: e.addTelLinksToPhoneNumbers(e.info.phone_number)
            }, null, 8, pQ)
          ])) : b("", !0),
          t[9] || (t[9] = A("  ")),
          e.info.fax_number ? (d(), h("span", fQ, [
            A(y(e.translations.fax_number) + ": ", 1),
            c("span", {
              innerHTML: e.addTelLinksToPhoneNumbers(e.info.fax_number)
            }, null, 8, gQ)
          ])) : b("", !0),
          t[10] || (t[10] = A("  ")),
          e.info.email ? (d(), h("span", vQ, y(e.translations.email) + ": " + y(e.info.email), 1)) : b("", !0)
        ], 2)
      ])
    ]),
    e.content.hasAdditionalText && !e.isPreview ? (d(), h("div", {
      key: 0,
      class: "additional-text",
      innerHTML: e.content.additionalText
    }, null, 8, bQ)) : b("", !0),
    c("div", {
      class: v(`apptegy-copyright ${e.theme.version && e.theme.version.toLowerCase()}`)
    }, [
      c("span", null, y(e.translations.copyright) + " © " + y(e.currentYear) + " " + y(e.copyrightOrg) + ". " + y(e.translations.all_rights_reserved), 1),
      c("span", null, [
        A(y(e.translations.powered_by) + " ", 1),
        t[11] || (t[11] = c("a", {
          href: "https://www.apptegy.com",
          target: "_blank",
          class: "notranslate"
        }, [
          A("Apptegy "),
          c("span", { class: "sr-only" }, "Visit us to learn more")
        ], -1))
      ])
    ], 2)
  ], 4);
}
const _Q = /* @__PURE__ */ O(ZX, [["render", yQ], ["__scopeId", "data-v-b16e74b5"]]), CQ = {
  name: "CmsFooter",
  components: {
    F1: KX,
    F2: _Q,
    CustomHtml: Aa
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    organizations: {
      type: Array,
      default: () => []
    },
    iosLink: {
      type: String,
      default: ""
    },
    androidLink: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    currentDomain: {
      type: String,
      default: null
    },
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    themeVersion() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.version) == null ? void 0 : t.toLowerCase()) || "";
    },
    translations() {
      return this.theme.translations;
    },
    cssVars() {
      return {
        "--bg-color": S(this.theme, "bg_color.hex", "#ffffff"),
        "--separator-color": S(this.theme, "separator_color.hex", "#ffffff"),
        "--text-color": S(this.theme, "text_link_color.hex", "#000000"),
        "--apptegy-link-color": S(this.theme, "apptegy_link_color.hex", "#000000")
      };
    }
  }
};
function wQ(e, t, n, o, i, r) {
  const a = $("custom-html");
  return d(), h("div", null, [
    n.theme.version !== "CustomFooter" ? (d(), h("div", {
      key: 0,
      id: "cms-footer",
      style: j(r.cssVars)
    }, [
      (d(), k(K(n.theme.version), {
        theme: n.theme,
        content: n.content,
        organizations: n.organizations,
        "ios-link": n.iosLink,
        "android-link": n.androidLink,
        "is-preview": n.isPreview,
        "is-i-frame": n.isIFrame,
        "current-domain": n.currentDomain,
        logo: n.logo
      }, null, 8, ["theme", "content", "organizations", "ios-link", "android-link", "is-preview", "is-i-frame", "current-domain", "logo"]))
    ], 4)) : (d(), k(a, {
      key: 1,
      theme: n.theme
    }, null, 8, ["theme"]))
  ]);
}
const TQ = /* @__PURE__ */ O(CQ, [["render", wQ], ["__scopeId", "data-v-97861574"]]);
var kQ = ea;
function EQ() {
  this.__data__ = new kQ(), this.size = 0;
}
var SQ = EQ;
function MQ(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var AQ = MQ;
function $Q(e) {
  return this.__data__.get(e);
}
var IQ = $Q;
function DQ(e) {
  return this.__data__.has(e);
}
var LQ = DQ, OQ = ea, NQ = v1, PQ = j0, HQ = 200;
function FQ(e, t) {
  var n = this.__data__;
  if (n instanceof OQ) {
    var o = n.__data__;
    if (!NQ || o.length < HQ - 1)
      return o.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new PQ(o);
  }
  return n.set(e, t), this.size = n.size, this;
}
var RQ = FQ, BQ = ea, VQ = SQ, jQ = AQ, UQ = IQ, GQ = LQ, zQ = RQ;
function Nr(e) {
  var t = this.__data__ = new BQ(e);
  this.size = t.size;
}
Nr.prototype.clear = VQ;
Nr.prototype.delete = jQ;
Nr.prototype.get = UQ;
Nr.prototype.has = GQ;
Nr.prototype.set = zQ;
var KQ = Nr;
function ZQ(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var xQ = ZQ, WQ = Lo, qQ = function() {
  try {
    var e = WQ(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (t) {
  }
}(), YQ = qQ, s0 = YQ;
function XQ(e, t, n) {
  t == "__proto__" && s0 ? s0(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var ff = XQ, QQ = ff, JQ = g1, eJ = Object.prototype, tJ = eJ.hasOwnProperty;
function nJ(e, t, n) {
  var o = e[t];
  (!(tJ.call(e, t) && JQ(o, n)) || n === void 0 && !(t in e)) && QQ(e, t, n);
}
var gf = nJ, oJ = gf, rJ = ff;
function iJ(e, t, n, o) {
  var i = !n;
  n || (n = {});
  for (var r = -1, a = t.length; ++r < a; ) {
    var s = t[r], l = o ? o(n[s], e[s], s, n, e) : void 0;
    l === void 0 && (l = e[s]), i ? rJ(n, s, l) : oJ(n, s, l);
  }
  return n;
}
var $a = iJ;
function sJ(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var aJ = sJ, lJ = 9007199254740991, uJ = /^(?:0|[1-9]\d*)$/;
function dJ(e, t) {
  var n = typeof e;
  return t = t == null ? lJ : t, !!t && (n == "number" || n != "symbol" && uJ.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var vf = dJ, cJ = aJ, hJ = Q0, mJ = Do, pJ = _1, fJ = vf, gJ = e2, vJ = Object.prototype, bJ = vJ.hasOwnProperty;
function yJ(e, t) {
  var n = mJ(e), o = !n && hJ(e), i = !n && !o && pJ(e), r = !n && !o && !i && gJ(e), a = n || o || i || r, s = a ? cJ(e.length, String) : [], l = s.length;
  for (var u in e)
    (t || bJ.call(e, u)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    r && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    fJ(u, l))) && s.push(u);
  return s;
}
var bf = yJ, _J = bf, CJ = q0, wJ = ia;
function TJ(e) {
  return wJ(e) ? _J(e) : CJ(e);
}
var Cu = TJ, kJ = $a, EJ = Cu;
function SJ(e, t) {
  return e && kJ(t, EJ(t), e);
}
var MJ = SJ;
function AJ(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var $J = AJ, IJ = Jn, DJ = oa, LJ = $J, OJ = Object.prototype, NJ = OJ.hasOwnProperty;
function PJ(e) {
  if (!IJ(e))
    return LJ(e);
  var t = DJ(e), n = [];
  for (var o in e)
    o == "constructor" && (t || !NJ.call(e, o)) || n.push(o);
  return n;
}
var HJ = PJ, FJ = bf, RJ = HJ, BJ = ia;
function VJ(e) {
  return BJ(e) ? FJ(e, !0) : RJ(e);
}
var wu = VJ, jJ = $a, UJ = wu;
function GJ(e, t) {
  return e && jJ(t, UJ(t), e);
}
var zJ = GJ, Zs = { exports: {} };
Zs.exports;
(function(e, t) {
  var n = Qt, o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, r = i && i.exports === o, a = r ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function l(u, m) {
    if (m)
      return u.slice();
    var g = u.length, p = s ? s(g) : new u.constructor(g);
    return u.copy(p), p;
  }
  e.exports = l;
})(Zs, Zs.exports);
var KJ = Zs.exports;
function ZJ(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var xJ = ZJ;
function WJ(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, i = 0, r = []; ++n < o; ) {
    var a = e[n];
    t(a, n, e) && (r[i++] = a);
  }
  return r;
}
var qJ = WJ;
function YJ() {
  return [];
}
var yf = YJ, XJ = qJ, QJ = yf, JJ = Object.prototype, eee = JJ.propertyIsEnumerable, a0 = Object.getOwnPropertySymbols, tee = a0 ? function(e) {
  return e == null ? [] : (e = Object(e), XJ(a0(e), function(t) {
    return eee.call(e, t);
  }));
} : QJ, Tu = tee, nee = $a, oee = Tu;
function ree(e, t) {
  return nee(e, oee(e), t);
}
var iee = ree;
function see(e, t) {
  for (var n = -1, o = t.length, i = e.length; ++n < o; )
    e[i + n] = t[n];
  return e;
}
var _f = see, aee = W0, lee = aee(Object.getPrototypeOf, Object), Cf = lee, uee = _f, dee = Cf, cee = Tu, hee = yf, mee = Object.getOwnPropertySymbols, pee = mee ? function(e) {
  for (var t = []; e; )
    uee(t, cee(e)), e = dee(e);
  return t;
} : hee, wf = pee, fee = $a, gee = wf;
function vee(e, t) {
  return fee(e, gee(e), t);
}
var bee = vee, yee = _f, _ee = Do;
function Cee(e, t, n) {
  var o = t(e);
  return _ee(e) ? o : yee(o, n(e));
}
var Tf = Cee, wee = Tf, Tee = Tu, kee = Cu;
function Eee(e) {
  return wee(e, kee, Tee);
}
var See = Eee, Mee = Tf, Aee = wf, $ee = wu;
function Iee(e) {
  return Mee(e, $ee, Aee);
}
var Dee = Iee, Lee = Object.prototype, Oee = Lee.hasOwnProperty;
function Nee(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && Oee.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var Pee = Nee, Hee = Qt, Fee = Hee.Uint8Array, Ree = Fee, l0 = Ree;
function Bee(e) {
  var t = new e.constructor(e.byteLength);
  return new l0(t).set(new l0(e)), t;
}
var ku = Bee, Vee = ku;
function jee(e, t) {
  var n = t ? Vee(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var Uee = jee, Gee = /\w*$/;
function zee(e) {
  var t = new e.constructor(e.source, Gee.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Kee = zee, u0 = Ys, d0 = u0 ? u0.prototype : void 0, c0 = d0 ? d0.valueOf : void 0;
function Zee(e) {
  return c0 ? Object(c0.call(e)) : {};
}
var xee = Zee, Wee = ku;
function qee(e, t) {
  var n = t ? Wee(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Yee = qee, Xee = ku, Qee = Uee, Jee = Kee, ete = xee, tte = Yee, nte = "[object Boolean]", ote = "[object Date]", rte = "[object Map]", ite = "[object Number]", ste = "[object RegExp]", ate = "[object Set]", lte = "[object String]", ute = "[object Symbol]", dte = "[object ArrayBuffer]", cte = "[object DataView]", hte = "[object Float32Array]", mte = "[object Float64Array]", pte = "[object Int8Array]", fte = "[object Int16Array]", gte = "[object Int32Array]", vte = "[object Uint8Array]", bte = "[object Uint8ClampedArray]", yte = "[object Uint16Array]", _te = "[object Uint32Array]";
function Cte(e, t, n) {
  var o = e.constructor;
  switch (t) {
    case dte:
      return Xee(e);
    case nte:
    case ote:
      return new o(+e);
    case cte:
      return Qee(e, n);
    case hte:
    case mte:
    case pte:
    case fte:
    case gte:
    case vte:
    case bte:
    case yte:
    case _te:
      return tte(e, n);
    case rte:
      return new o();
    case ite:
    case lte:
      return new o(e);
    case ste:
      return Jee(e);
    case ate:
      return new o();
    case ute:
      return ete(e);
  }
}
var wte = Cte, Tte = Jn, h0 = Object.create, kte = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Tte(t))
      return {};
    if (h0)
      return h0(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), Ete = kte, Ste = Ete, Mte = Cf, Ate = oa;
function $te(e) {
  return typeof e.constructor == "function" && !Ate(e) ? Ste(Mte(e)) : {};
}
var Ite = $te, Dte = ra, Lte = yr, Ote = "[object Map]";
function Nte(e) {
  return Lte(e) && Dte(e) == Ote;
}
var Pte = Nte, Hte = Pte, Fte = C1, m0 = w1, p0 = m0 && m0.isMap, Rte = p0 ? Fte(p0) : Hte, Bte = Rte, Vte = ra, jte = yr, Ute = "[object Set]";
function Gte(e) {
  return jte(e) && Vte(e) == Ute;
}
var zte = Gte, Kte = zte, Zte = C1, f0 = w1, g0 = f0 && f0.isSet, xte = g0 ? Zte(g0) : Kte, Wte = xte, qte = KQ, Yte = xQ, Xte = gf, Qte = MJ, Jte = zJ, ene = KJ, tne = xJ, nne = iee, one = bee, rne = See, ine = Dee, sne = ra, ane = Pee, lne = wte, une = Ite, dne = Do, cne = _1, hne = Bte, mne = Jn, pne = Wte, fne = Cu, gne = wu, vne = 1, bne = 2, yne = 4, kf = "[object Arguments]", _ne = "[object Array]", Cne = "[object Boolean]", wne = "[object Date]", Tne = "[object Error]", Ef = "[object Function]", kne = "[object GeneratorFunction]", Ene = "[object Map]", Sne = "[object Number]", Sf = "[object Object]", Mne = "[object RegExp]", Ane = "[object Set]", $ne = "[object String]", Ine = "[object Symbol]", Dne = "[object WeakMap]", Lne = "[object ArrayBuffer]", One = "[object DataView]", Nne = "[object Float32Array]", Pne = "[object Float64Array]", Hne = "[object Int8Array]", Fne = "[object Int16Array]", Rne = "[object Int32Array]", Bne = "[object Uint8Array]", Vne = "[object Uint8ClampedArray]", jne = "[object Uint16Array]", Une = "[object Uint32Array]", Le = {};
Le[kf] = Le[_ne] = Le[Lne] = Le[One] = Le[Cne] = Le[wne] = Le[Nne] = Le[Pne] = Le[Hne] = Le[Fne] = Le[Rne] = Le[Ene] = Le[Sne] = Le[Sf] = Le[Mne] = Le[Ane] = Le[$ne] = Le[Ine] = Le[Bne] = Le[Vne] = Le[jne] = Le[Une] = !0;
Le[Tne] = Le[Ef] = Le[Dne] = !1;
function vs(e, t, n, o, i, r) {
  var a, s = t & vne, l = t & bne, u = t & yne;
  if (n && (a = i ? n(e, o, i, r) : n(e)), a !== void 0)
    return a;
  if (!mne(e))
    return e;
  var m = dne(e);
  if (m) {
    if (a = ane(e), !s)
      return tne(e, a);
  } else {
    var g = sne(e), p = g == Ef || g == kne;
    if (cne(e))
      return ene(e, s);
    if (g == Sf || g == kf || p && !i) {
      if (a = l || p ? {} : une(e), !s)
        return l ? one(e, Jte(a, e)) : nne(e, Qte(a, e));
    } else {
      if (!Le[g])
        return i ? e : {};
      a = lne(e, g, s);
    }
  }
  r || (r = new qte());
  var T = r.get(e);
  if (T)
    return T;
  r.set(e, a), pne(e) ? e.forEach(function(E) {
    a.add(vs(E, t, n, E, e, r));
  }) : hne(e) && e.forEach(function(E, P) {
    a.set(P, vs(E, t, n, P, e, r));
  });
  var M = u ? l ? ine : rne : l ? gne : fne, C = m ? void 0 : M(e);
  return Yte(C || e, function(E, P) {
    C && (P = E, E = e[P]), Xte(a, P, vs(E, t, n, P, e, r));
  }), a;
}
var Gne = vs, zne = Gne, Kne = 1, Zne = 4;
function xne(e) {
  return zne(e, Kne | Zne);
}
var Wne = xne;
const qne = /* @__PURE__ */ br(Wne), Hi = {
  mixins: [mt],
  components: { DraggableWrapper: at },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    programs: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    colors() {
      const e = this.sharedThemeColors(), t = S(this.theme, "box_bg_color.hex", "none"), n = `${t}cc`;
      return he(ie({}, e), {
        "--accent-color": S(this.theme, "accent_color.hex", "#fff"),
        "--text-color": S(this.theme, "text_color.hex", "#fff"),
        "--hover-text-color": S(this.theme, "hover_text_color.hex", "initial"),
        "--box-bg-color": t,
        "--box-bg-color-opacity": n,
        "--hover-bg-color": S(this.theme, "hover_bg_color.hex", "initial"),
        "--hover-line-color": S(this.theme, "hover_line_color.hex", "initial"),
        "--title-color": S(this.theme, "title_color.hex", "--heading-color", "initial"),
        "--arrow-icon-color": S(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-icon-hover-color": S(this.theme, "arrow_icon_hover_color.hex", "initial"),
        "--arrow-background-color": S(this.theme, "arrow_background_color.hex", "initial"),
        "--program-image-border-color": S(
          this.theme,
          "program_image_border_color.hex",
          S(this.theme, "globalThemeSettings.secondaryColor")
        ),
        "--link-color": S(this.theme, "link_color.hex", "#0070E0"),
        "--link-hover-color": S(this.theme, "link_hover_color.hex", "#0070E0")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.programs.component_header_top || this.isEditing);
    }
  }
}, Yne = {
  name: "P1",
  mixins: [Hi],
  data() {
    return {
      hoverIndex: -1,
      editIdx: -1,
      descriptionTabIndex: -1
    };
  },
  computed: {
    getLinkFormData() {
      const e = qne(this.programs.content[this.editIdx].link);
      return this.programs.read_more_link || (e.name = this.programs.content[this.editIdx].title), e;
    }
  },
  methods: {
    showLinkButton(e) {
      return this.hoverIndex === e && this.programs.read_more_link;
    },
    setHoverIndex(e) {
      this.hoverIndex = e;
    },
    async toggleVisibility(e, t) {
      this.isEditing || (t.preventDefault(), this.programs.details_on_hover && (this.hoverIndex = this.hoverIndex === e ? -1 : e, this.descriptionTabIndex = -1, await this.$nextTick(), this.$refs.programDescription[0] && this.$refs.programDescription[0].scrollHeight > this.$refs.programDescription[0].clientHeight && (this.descriptionTabIndex = 0, this.$refs.programDescription[0].focus({ showFocus: !0 }))));
    },
    closeOnBlur(e) {
      e.currentTarget.contains(e.relatedTarget) || (this.hoverIndex = -1);
    }
  }
}, Xne = ["data-testid"], Qne = ["data-testid"], Jne = ["tabindex", "aria-haspopup", "aria-labelledby", "aria-describedby", "role", "onKeydown", "onFocus", "onMouseover"], eoe = ["src", "alt"], toe = {
  key: 1,
  class: "program-image"
}, noe = {
  key: 0,
  class: "hover-content"
}, ooe = {
  class: "middle",
  role: "document"
}, roe = ["id"], ioe = ["id", "tabindex"], soe = {
  key: 0,
  class: "program-link"
}, aoe = {
  key: 1,
  maxlength: "26"
};
function loe(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    id: "programs-p1",
    class: v(e.theme.style),
    style: j(e.colors)
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`
        }, [
          e.displayHeaderTop ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.programs.component_header_top), 1)
            ], !0)
          ], 8, Qne)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.programs.component_header), 1)
          ], !0)
        ], 8, Xne)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
      modelValue: e.programs.content,
      "onUpdate:modelValue": t[7] || (t[7] = (s) => e.programs.content = s),
      "item-key": "index",
      class: "programs-wrapper"
    }), {
      item: _(({ element: s, index: l }) => [
        c("div", {
          class: v([e.programs.num_columns === 3 ? "three-column" : "four-column", "program"])
        }, [
          w(e.$slots, "controls", { idx: l }, void 0, !0),
          c("div", {
            class: "image-wrapper image-border-accent",
            tabindex: e.programs.details_on_hover ? 0 : "",
            "aria-haspopup": !!e.programs.details_on_hover,
            "aria-labelledby": e.programs.details_on_hover && `dialog${l}Title`,
            "aria-describedby": e.programs.details_on_hover && `dialog${l}Desc`,
            role: e.programs.details_on_hover && "dialog",
            "data-testid": "program-content",
            onKeydown: [
              V(z((u) => r.toggleVisibility(l, u), ["exact"]), ["enter"]),
              V(z((u) => r.toggleVisibility(l, u), ["exact"]), ["space"])
            ],
            onFocus: (u) => r.toggleVisibility(l, u),
            onBlur: t[5] || (t[5] = (...u) => r.closeOnBlur && r.closeOnBlur(...u)),
            onMouseover: (u) => i.hoverIndex = l,
            onMouseleave: t[6] || (t[6] = (u) => i.hoverIndex = -1)
          }, [
            s.image.url ? (d(), h("img", {
              key: 0,
              src: s.image.url,
              alt: s.image.alt_text,
              loading: "lazy",
              class: "program-image"
            }, null, 8, eoe)) : (d(), h("div", toe)),
            c("div", {
              class: v([[
                e.theme.style,
                e.theme.text_background,
                {
                  "hover-enter": e.programs.details_on_hover && i.hoverIndex === l
                }
              ], "content-box"])
            }, [
              e.programs.details_on_hover && i.hoverIndex === l ? (d(), h("div", noe, [
                t[8] || (t[8] = c("div", { class: "top-bar" }, null, -1)),
                c("div", ooe, [
                  c("div", {
                    class: v([e.theme.style, "title"])
                  }, [
                    s.link.url && !e.programs.read_more_link ? (d(), k(K(e.isEditing ? "div" : "a"), {
                      key: 0,
                      id: `dialog${l}Title`,
                      href: s.link.url,
                      target: s.link.opens_in_new_tab ? "_blank" : "",
                      onKeydown: [
                        t[0] || (t[0] = V((u) => r.setHoverIndex(-1), ["tab"])),
                        t[1] || (t[1] = V(z(() => {
                        }, ["exact", "stop"]), ["enter"]))
                      ]
                    }, {
                      default: _(() => [
                        w(e.$slots, "title", { idx: l }, () => [
                          A(y(s.title), 1)
                        ], !0)
                      ]),
                      _: 2
                    }, 1064, ["id", "href", "target"])) : (d(), h("p", {
                      key: 1,
                      id: `dialog${l}Title`,
                      maxlength: "26"
                    }, [
                      w(e.$slots, "title", { idx: l }, () => [
                        A(y(s.title), 1)
                      ], !0)
                    ], 8, roe))
                  ], 2),
                  c("p", {
                    id: `dialog${l}Desc`,
                    ref: "programDescription",
                    class: v([[{ editing: e.isEditing }, e.theme.style], "program-description"]),
                    tabindex: i.descriptionTabIndex,
                    "aria-label": "program-description"
                  }, [
                    w(e.$slots, "description", { idx: l }, () => [
                      A(y(s.description), 1)
                    ], !0)
                  ], 10, ioe),
                  r.showLinkButton(l) ? (d(), h("div", soe, [
                    (d(), k(K(e.isEditing ? "div" : "a"), {
                      "aria-label": s.link.name,
                      href: s.link.url,
                      target: s.link.opens_in_new_tab ? "_blank" : "",
                      onKeydown: [
                        t[2] || (t[2] = V((u) => r.setHoverIndex(-1), ["tab"])),
                        t[3] || (t[3] = V(z(() => {
                        }, ["exact", "stop"]), ["enter"]))
                      ]
                    }, {
                      default: _(() => [
                        w(e.$slots, "link", { idx: l }, () => [
                          A(y(s.link.name), 1)
                        ], !0)
                      ]),
                      _: 2
                    }, 1064, ["aria-label", "href", "target"]))
                  ])) : b("", !0)
                ])
              ])) : (d(), h("div", {
                key: 1,
                class: v(["normal-content title", e.theme.style])
              }, [
                !e.programs.details_on_hover && s.link.url ? (d(), k(K(e.isEditing ? "div" : "a"), {
                  key: 0,
                  href: s.link.url,
                  target: s.link.opens_in_new_tab ? "_blank" : "",
                  onKeydown: t[4] || (t[4] = V(z(() => {
                  }, ["exact", "stop"]), ["enter"]))
                }, {
                  default: _(() => [
                    w(e.$slots, "title", { idx: l }, () => [
                      A(y(s.title), 1)
                    ], !0)
                  ]),
                  _: 2
                }, 1064, ["href", "target"])) : (d(), h("p", aoe, [
                  w(e.$slots, "title", { idx: l }, () => [
                    A(y(s.title), 1)
                  ], !0)
                ]))
              ], 2))
            ], 2)
          ], 40, Jne)
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const uoe = /* @__PURE__ */ O(Yne, [["render", loe], ["__scopeId", "data-v-78a9e7ae"]]), doe = {
  name: "P2",
  mixins: [Hi],
  data() {
    return {
      direction: "forward",
      content: []
    };
  },
  computed: {
    seeAllURL() {
      return S(this.programs, "see_all_link.url", !1);
    },
    seeAll() {
      return this.programs.see_all && (!!this.seeAllURL || this.isEditing);
    },
    programRows() {
      let e = [[]];
      return this.programs.content.length > 0 && (e = this.content.slice(1).reduce(
        (t, n, o) => (this.isEditing || o % 4 !== 0 || o === 0 ? t[t.length - 1].push(n) : t.push([n]), t),
        [[]]
      )), this.programs.slider ? [e[0]] : e;
    },
    opensInNewTab() {
      return this.programs.see_all_link.opens_in_new_tab ? "_blank" : "";
    }
  },
  watch: {
    programs: {
      handler(e) {
        this.content = e.content.map((t, n) => he(ie({}, t), {
          idx: n
        }));
      },
      deep: !0,
      immediate: !0
    }
  },
  methods: {
    previous() {
      this.direction = "backward", this.$nextTick(() => {
        this.content.splice(0, 0, this.content.pop());
      });
    },
    next() {
      this.direction = "forward", this.$nextTick(() => {
        this.content.push(this.content.shift());
      });
    }
  }
}, coe = ["data-testid"], hoe = ["data-testid"], moe = ["target", "href", "data-testid"], poe = { class: "main-program" }, foe = {
  key: 0,
  "data-testid": "component-header-top"
}, goe = ["data-testid"], voe = ["target", "href", "data-testid"], boe = { class: "main-program-text" }, yoe = {
  key: 0,
  class: "purple arrows"
}, _oe = {
  class: "left-arrow-button",
  role: "button"
}, Coe = {
  class: "right-arrow-button",
  role: "button"
}, woe = {
  key: 0,
  class: "light-bold arrows"
}, Toe = {
  class: "left-arrow-button",
  role: "button"
}, koe = {
  class: "right-arrow-button",
  role: "button"
}, Eoe = ["src", "alt"], Soe = { class: "stacked-programs" }, Moe = { class: "small-first-program" }, Aoe = { class: "aspect-ratio-box" }, $oe = ["src", "alt"], Ioe = { class: "aspect-ratio-box" }, Doe = ["src", "alt"], Loe = { class: "aspect-ratio-box" }, Ooe = ["src", "alt"], Noe = ["target", "href", "data-testid"];
function Poe(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return e.programs.content.length > 0 ? (d(), h("div", {
    key: 0,
    id: "programs-v2",
    style: j(e.colors),
    class: v(e.theme.style),
    "data-testid": "p2"
  }, [
    e.screenSize <= 960 || e.theme.style === "purple" ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-above"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          class: v({ "no-border": !r.seeAll }),
          "data-testid": `header-${e.theme.style}-above`
        }, [
          e.displayHeaderTop ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.programs.component_header_top), 1)
            ], !0)
          ], 8, hoe)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.programs.component_header), 1)
          ], !0)
        ], 10, coe)
      ]),
      default: _(() => [
        r.seeAll && e.screenSize > 600 && e.theme.style !== "purple" ? (d(), h("a", {
          key: 0,
          target: r.opensInNewTab,
          href: `${e.pathPrefix}${r.seeAllURL}`,
          "data-testid": `see-all-${e.theme.style}-above`,
          onClick: t[0] || (t[0] = (s) => e.$emit("edit-see-all-link", s))
        }, [
          A(y(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
          w(e.$slots, "link", {}, void 0, !0)
        ], 8, moe)) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : b("", !0),
    c("div", poe, [
      c("div", {
        class: v(["main-program-left", e.theme.style])
      }, [
        e.screenSize > 960 && e.theme.style !== "purple" ? (d(), k(a, {
          key: 0,
          class: v([e.theme.style, "see-all-top"]),
          "theme-options": e.theme
        }, {
          header: _(() => [
            e.theme.style === "monterrey" && (e.programs.component_header_top || e.isEditing) ? (d(), h("h3", foe, [
              w(e.$slots, "header-top", {}, () => [
                A(y(e.programs.component_header_top), 1)
              ], !0)
            ])) : b("", !0),
            c("h2", {
              class: v({ "no-border": !r.seeAll }),
              "data-testid": `header-${e.theme.style}-top`
            }, [
              w(e.$slots, "header", {}, () => [
                A(y(e.programs.component_header), 1)
              ], !0)
            ], 10, goe)
          ]),
          default: _(() => [
            r.seeAll ? (d(), h("a", {
              key: 0,
              class: "hide-on-xs",
              target: r.opensInNewTab,
              href: `${e.pathPrefix}${r.seeAllURL}`,
              "data-testid": `see-all-${e.theme.style}-top`,
              onClick: t[1] || (t[1] = (s) => e.$emit("edit-see-all-link", s))
            }, [
              A(y(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
              w(e.$slots, "link", {}, void 0, !0)
            ], 8, voe)) : b("", !0)
          ]),
          _: 3
        }, 8, ["class", "theme-options"])) : b("", !0),
        c("div", boe, [
          e.theme.style === "purple" && e.programs.slider ? (d(), h("div", yoe, [
            c("div", _oe, [
              (d(), h("svg", {
                class: "purple-left-arrow",
                width: "31",
                height: "71",
                viewBox: "0 0 31 71",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[2] || (t[2] = (...s) => r.previous && r.previous(...s))
              }, t[7] || (t[7] = [
                c("path", {
                  class: "arrow-stroke",
                  d: "M28 68.2969L3 35.6597L28 3.02245",
                  stroke: "#4C4C4C",
                  "stroke-width": "5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]))),
              t[8] || (t[8] = c("span", { class: "sr-only" }, "Reverse Slider", -1))
            ]),
            c("div", Coe, [
              (d(), h("svg", {
                class: "purple-right-arrow",
                width: "31",
                height: "71",
                viewBox: "0 0 31 71",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[3] || (t[3] = (...s) => r.next && r.next(...s))
              }, t[9] || (t[9] = [
                c("path", {
                  class: "arrow-stroke",
                  d: "M3 3.01953L28 35.6567L3 68.294",
                  stroke: "#4C4C4C",
                  "stroke-width": "5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]))),
              t[10] || (t[10] = c("span", { class: "sr-only" }, "Advance Slider", -1))
            ])
          ])) : b("", !0),
          L(Ee, {
            appear: "",
            mode: "out-in",
            name: "fade-vertical"
          }, {
            default: _(() => [
              (d(), h("h3", {
                key: i.content[0].idx,
                class: v([[e.theme.style, i.direction], "main program-title"])
              }, [
                i.content[0].link && i.content[0].link.url ? (d(), k(K(e.isEditing ? "div" : "a"), {
                  key: 0,
                  href: i.content[0].link.url,
                  target: i.content[0].link.opens_in_new_tab ? "_blank" : ""
                }, {
                  default: _(() => [
                    w(e.$slots, "title", {
                      idx: i.content[0].idx
                    }, () => [
                      A(y(i.content[0].title), 1)
                    ], !0)
                  ]),
                  _: 3
                }, 8, ["href", "target"])) : w(e.$slots, "title", {
                  key: 1,
                  idx: i.content[0].idx
                }, () => [
                  A(y(i.content[0].title), 1)
                ], !0)
              ], 2))
            ]),
            _: 3
          }),
          L(Ee, {
            appear: "",
            mode: "out-in",
            name: "fade-vertical"
          }, {
            default: _(() => [
              (d(), h("p", {
                key: i.content[0].idx,
                class: v([[e.theme.style, i.direction], "main program-description"])
              }, [
                w(e.$slots, "description", {
                  idx: i.content[0].idx
                }, () => [
                  A(y(i.content[0].description), 1)
                ], !0)
              ], 2))
            ]),
            _: 3
          })
        ])
      ], 2),
      c("div", {
        class: v(["main-program-image", { editing: e.isEditing }])
      }, [
        w(e.$slots, "controls", {
          idx: i.content[0].idx
        }, void 0, !0),
        ["light", "bold", "monterrey", "sydney"].includes(e.theme.style) && e.programs.slider ? (d(), h("div", woe, [
          w(e.$slots, "main-controls", {}, () => [
            c("div", Toe, [
              (d(), h("svg", {
                class: "left-arrow",
                width: "64",
                height: "64",
                viewBox: "0 0 64 64",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[4] || (t[4] = (...s) => r.previous && r.previous(...s))
              }, t[11] || (t[11] = [
                c("path", {
                  class: "arrow-bg",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M-6.10352e-05 0L63.9999 0L63.9999 64L-6.10352e-05 64L-6.10352e-05 0Z",
                  fill: "#014990"
                }, null, -1),
                c("path", {
                  class: "arrow-stroke",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M26 32L38 19.5L36.5 18L22.9999 32.0428L36.5 46L38 44.5L26 32Z",
                  fill: "white"
                }, null, -1)
              ]))),
              t[12] || (t[12] = c("span", { class: "sr-only" }, "Reverse Slider", -1))
            ]),
            c("div", koe, [
              (d(), h("svg", {
                class: "right-arrow",
                width: "64",
                height: "64",
                viewBox: "0 0 64 64",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[5] || (t[5] = (...s) => r.next && r.next(...s))
              }, t[13] || (t[13] = [
                c("path", {
                  class: "arrow-bg",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M64.0001 64L5.34058e-05 64L5.90008e-05 -1.78036e-06L64.0001 3.8147e-06L64.0001 64Z",
                  fill: "#014990"
                }, null, -1),
                c("path", {
                  class: "arrow-stroke",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M38 32L26 44.5L27.5 46L41.0001 31.9572L27.5 18L26 19.5L38 32Z",
                  fill: "white"
                }, null, -1)
              ]))),
              t[14] || (t[14] = c("span", { class: "sr-only" }, "Advance Slider", -1))
            ])
          ], !0)
        ])) : b("", !0),
        L(Ee, {
          appear: "",
          mode: "out-in",
          name: "fade-vertical"
        }, {
          default: _(() => [
            (d(), h("div", {
              key: i.content[0].idx,
              class: v([i.direction, "aspect-ratio-box main"])
            }, [
              c("img", {
                class: "image-border-accent",
                src: i.content[0].image.url,
                alt: i.content[0].image.alt_text,
                loading: "lazy"
              }, null, 8, Eoe)
            ], 2))
          ]),
          _: 1
        })
      ], 2)
    ]),
    c("ul", Soe, [
      c("li", Moe, [
        c("div", Aoe, [
          c("img", {
            class: "image-border-accent",
            src: i.content[0].image.url,
            alt: i.content[0].image.alt_text,
            loading: "lazy"
          }, null, 8, $oe)
        ]),
        c("h3", {
          class: v([e.theme.style, "program-title"])
        }, [
          i.content[0].link && i.content[0].link.url ? (d(), k(K(e.isEditing ? "div" : "a"), {
            key: 0,
            href: i.content[0].link.url,
            target: i.content[0].link.opens_in_new_tab ? "_blank" : ""
          }, {
            default: _(() => [
              w(e.$slots, "title", {
                idx: i.content[0].idx
              }, () => [
                A(y(i.content[0].title), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["href", "target"])) : w(e.$slots, "title", {
            key: 1,
            idx: i.content[0].idx
          }, () => [
            A(y(i.content[0].title), 1)
          ], !0)
        ], 2),
        c("p", {
          class: v([e.theme.style, "program-description"])
        }, [
          w(e.$slots, "description", {
            idx: i.content[0].idx
          }, () => [
            A(y(i.content[0].description), 1)
          ], !0)
        ], 2)
      ]),
      (d(!0), h(Y, null, ee(i.content.slice(1), (s) => (d(), h("li", {
        key: s.idx,
        "data-testid": "programs-content"
      }, [
        c("div", Ioe, [
          w(e.$slots, "small-controls", {
            idx: s.idx
          }, void 0, !0),
          c("img", {
            src: s.image.url,
            alt: s.image.alt_text,
            class: "program-image image-border-accent",
            loading: "lazy"
          }, null, 8, Doe)
        ]),
        c("h3", {
          class: v([e.theme.style, "program-title"])
        }, [
          s.link && s.link.url ? (d(), k(K(e.isEditing ? "div" : "a"), {
            key: 0,
            href: s.link.url,
            target: s.link.opens_in_new_tab ? "_blank" : ""
          }, {
            default: _(() => [
              w(e.$slots, "title", {
                idx: i.content[0].idx
              }, () => [
                A(y(s.title), 1)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target"])) : w(e.$slots, "title", {
            key: 1,
            idx: i.content[0].idx
          }, () => [
            A(y(s.title), 1)
          ], !0)
        ], 2),
        c("p", {
          class: v([e.theme.style, "program-description"])
        }, [
          w(e.$slots, "description", {
            idx: i.content[0].idx
          }, () => [
            A(y(s.description), 1)
          ], !0)
        ], 2)
      ]))), 128))
    ]),
    c("div", null, [
      (d(!0), h(Y, null, ee(r.programRows, (s, l) => (d(), k(Ln, {
        key: l + 1,
        tag: "ul",
        name: "program-row",
        class: v(["program-row", { "less-than-4": s.length < 4 }])
      }, {
        default: _(() => [
          (d(!0), h(Y, null, ee(s, (u) => (d(), h("li", {
            key: u.idx,
            class: v([i.direction, ["row-of-" + s.length]])
          }, [
            w(e.$slots, "controls", {
              idx: u.idx
            }, void 0, !0),
            c("div", Loe, [
              c("img", {
                src: u.image.url,
                alt: u.image.alt_text,
                class: "program-image image-border-accent",
                loading: "lazy"
              }, null, 8, Ooe)
            ]),
            c("h3", {
              class: v([e.theme.style, "program-title"])
            }, [
              u.link && u.link.url ? (d(), k(K(e.isEditing ? "div" : "a"), {
                key: 0,
                href: u.link.url,
                target: u.link.opens_in_new_tab ? "_blank" : ""
              }, {
                default: _(() => [
                  w(e.$slots, "title", {
                    idx: u.idx
                  }, () => [
                    A(y(u.title), 1)
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "target"])) : w(e.$slots, "title", {
                key: 1,
                idx: u.idx
              }, () => [
                A(y(u.title), 1)
              ], !0)
            ], 2),
            c("p", {
              class: v([e.theme.style, "program-description"])
            }, [
              w(e.$slots, "description", {
                idx: u.idx
              }, () => [
                A(y(u.description), 1)
              ], !0)
            ], 2)
          ], 2))), 128))
        ]),
        _: 2
      }, 1032, ["class"]))), 128))
    ]),
    e.programs.see_all ? (d(), k(a, {
      key: 1,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: _(() => [
        r.seeAll && (e.screenSize < 600 || e.theme.style === "purple") ? (d(), h("a", {
          key: 0,
          target: r.opensInNewTab,
          href: `${e.pathPrefix}${r.seeAllURL}`,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[6] || (t[6] = (s) => e.$emit("edit-see-all-link", s))
        }, [
          A(y(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
          w(e.$slots, "link", {}, void 0, !0)
        ], 8, Noe)) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : b("", !0)
  ], 6)) : b("", !0);
}
const Hoe = /* @__PURE__ */ O(doe, [["render", Poe], ["__scopeId", "data-v-bfc47d2c"]]), Foe = {
  name: "P3",
  components: {
    CardSlider: Jt
  },
  mixins: [Hi, ut],
  computed: {
    content() {
      return this.programs.content;
    },
    sliderCenterSize() {
      return 600;
    },
    p3Colors() {
      return he(ie({}, this.colors), {
        "--heading-description-color": S(this.theme, "heading_description_color.hex", "#000000"),
        "--top-heading-color": S(this.theme, "top_heading_color.hex", "#000000"),
        "--card-1-bg-color": S(this.theme, "programs_card_1_bg_color.hex", "#4e0188"),
        "--card-1-heading-color": S(this.theme, "programs_card_1_heading_color.hex", "#ffffff"),
        "--card-1-text-color": S(this.theme, "programs_card_1_text_color.hex", "#ffffff"),
        "--card-1-box-color": S(this.theme, "programs_card_1_box_color.hex", "#ffffff"),
        "--card-2-bg-color": S(this.theme, "programs_card_2_bg_color.hex", "#86259C"),
        "--card-2-heading-color": S(this.theme, "programs_card_2_heading_color.hex", "#ffffff"),
        "--card-2-text-color": S(this.theme, "programs_card_2_text_color.hex", "#ffffff"),
        "--card-2-box-color": S(this.theme, "programs_card_2_box_color.hex", "#ffffff"),
        "--card-3-bg-color": S(this.theme, "programs_card_3_bg_color.hex", "#fcD40b"),
        "--card-3-heading-color": S(this.theme, "programs_card_3_heading_color.hex", "#131313"),
        "--card-3-text-color": S(this.theme, "programs_card_3_text_color.hex", "#131313"),
        "--card-3-box-color": S(this.theme, "programs_card_3_box_color.hex", "#ffffff"),
        "--card-4-bg-color": S(this.theme, "programs_card_4_bg_color.hex", "#b22785"),
        "--card-4-heading-color": S(this.theme, "programs_card_4_heading_color.hex", "#ffffff"),
        "--card-4-text-color": S(this.theme, "programs_card_4_text_color.hex", "#ffffff"),
        "--card-4-box-color": S(this.theme, "programs_card_4_box_color.hex", "#ffffff"),
        "--card-5-bg-color": S(this.theme, "programs_card_5_bg_color.hex", "#5e49ec"),
        "--card-5-heading-color": S(this.theme, "programs_card_5_heading_color.hex", "#ffffff"),
        "--card-5-text-color": S(this.theme, "programs_card_5_text_color.hex", "#000000"),
        "--card-5-box-color": S(this.theme, "programs_card_5_box_color.hex", "#ffffff")
      });
    }
  }
}, Roe = { class: "header-wrapper" }, Boe = {
  key: 0,
  "data-testid": "component-header-top",
  class: "header-top"
}, Voe = {
  key: 0,
  class: "header-description",
  "data-testid": "header-description"
}, joe = ["data-testid", "aria-label"], Uoe = { class: "program-card-wrapper" }, Goe = { class: "program-bottom-card" }, zoe = { class: "program-description" }, Koe = ["innerHTML"];
function Zoe(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("CardSlider");
  return d(), h("div", {
    id: "programs-v3",
    "data-testid": "P3",
    style: j(r.p3Colors),
    class: v([e.theme.style, { editing: e.isEditing }])
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("div", Roe, [
          c("div", null, [
            c("h2", null, [
              e.displayHeaderTop ? (d(), h("span", Boe, [
                w(e.$slots, "header-top", {}, () => [
                  A(y(e.programs.component_header_top), 1)
                ], !0)
              ])) : b("", !0),
              w(e.$slots, "header", {}, () => [
                A(y(e.programs.component_header), 1)
              ], !0)
            ])
          ]),
          e.programs.component_header_description || e.isEditing ? (d(), h("div", Voe, [
            w(e.$slots, "header-description", {}, () => [
              A(y(e.programs.component_header_description), 1)
            ], !0)
          ])) : b("", !0)
        ])
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    L(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": r.content.length,
      "theme-styles": e.theme,
      "section-header": e.programs.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: _(() => [
        (d(), k(K(e.wrapperComponent), we({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.programs.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.programs.content = l),
          class: [{ "all-cards-visible": e.allCardsVisible }, "programs-wrapper"],
          "item-key": "index"
        }), {
          item: _(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              class: v(["program", `card-${u + 1}`, `card-style-${u % 5 + 1}`]),
              "data-testid": `programCard${u + 1}`,
              "aria-label": `${u + 1} of ${r.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              "data-attr": "program-content"
            }, [
              w(e.$slots, "controls", { idx: u }, void 0, !0),
              w(e.$slots, "image", { idx: u }, () => [
                (d(), k(K(l.image ? "img" : "div"), {
                  src: l.image.url,
                  alt: l.image.alt_text,
                  loading: "lazy",
                  class: "program-image"
                }, null, 8, ["src", "alt"]))
              ], !0),
              c("div", Uoe, [
                c("div", Goe, [
                  (d(), k(K(l.link && l.link.url && !e.isEditing ? "a" : "span"), {
                    href: l.link.url,
                    target: l.link.opens_in_new_tab ? "_blank" : null,
                    class: v(["program-title", { "is-editing": e.isEditing }])
                  }, {
                    default: _(() => [
                      w(e.$slots, "title", {
                        title: l.title,
                        idx: u
                      }, () => [
                        A(y(l.title), 1)
                      ], !0)
                    ]),
                    _: 2
                  }, 1032, ["href", "target", "class"])),
                  c("span", zoe, [
                    w(e.$slots, "description", {
                      title: l.description,
                      idx: u
                    }, () => [
                      c("span", {
                        class: "description-link",
                        innerHTML: l.description
                      }, null, 8, Koe)
                    ], !0)
                  ])
                ])
              ])
            ], 10, joe)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const xoe = /* @__PURE__ */ O(Foe, [["render", Zoe], ["__scopeId", "data-v-f678074c"]]), Woe = {
  name: "P4",
  mixins: [Hi],
  data() {
    return {
      activeItem: 0
    };
  },
  computed: {
    programsContent: {
      get() {
        return this.programs.content.slice(0, 5);
      },
      set(e) {
        this.programs.content = e;
      }
    },
    programsLength() {
      return this.programs.content.length;
    },
    cssVars() {
      return he(ie({}, this.colors), {
        "--active-headline-color": S(this.theme, "active_headline_color.hex", "#000000"),
        "--active-line-color": S(this.theme, "active_line_color.hex", "#000000"),
        "--headline-color": S(this.theme, "headline_color.hex", "#000000"),
        "--card-bg-color": S(this.theme, "card_bg_color.hex", "#FFFFFF"),
        "--card-border-color": S(this.theme, "card_border_color.hex", "#000000")
      });
    }
  },
  methods: {
    activateTab(e) {
      this.activeItem = e;
    },
    onKeyDown(e) {
      if (this.isEditing) return;
      const n = {
        ArrowLeft: this.focusPreviousTab,
        ArrowRight: this.focusNextTab,
        Home: this.focusFirstTab,
        End: this.focusLastTab
      }[e.key];
      n && n.call(this);
    },
    focusActiveTab() {
      this.$refs["tab-" + this.activeItem][0].focus();
    },
    focusPreviousTab() {
      this.activeItem > 0 ? this.activeItem -= 1 : this.activeItem = this.programsLength - 1, this.focusActiveTab();
    },
    focusNextTab() {
      this.activeItem < this.programsLength - 1 ? this.activeItem += 1 : this.activeItem = 0, this.focusActiveTab();
    },
    focusFirstTab() {
      this.activeItem = 0, this.focusActiveTab();
    },
    focusLastTab() {
      this.activeItem = this.programsLength - 1, this.focusActiveTab();
    }
  }
}, qoe = { class: "columns-wrapper" }, Yoe = ["data-testid"], Xoe = { class: "column-1" }, Qoe = ["data-testid"], Joe = ["data-testid"], ere = ["id", "tabindex", "aria-selected", "aria-controls", "onClick"], tre = { class: "column-2" }, nre = ["id", "aria-labelledby"], ore = { class: "program-card" }, rre = { class: "card-title" }, ire = {
  key: 0,
  class: "card-description"
}, sre = ["innerHTML"];
function are(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    class: v(["programs-v4", e.theme.style]),
    style: j(r.cssVars)
  }, [
    c("div", qoe, [
      e.programs.has_header && e.isPurpleStyle ? (d(), k(a, {
        key: 0,
        class: v(["see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: _(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            w(e.$slots, "header", {}, () => [
              A(y(e.programs.component_header), 1)
            ])
          ], 8, Yoe)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])) : b("", !0),
      c("div", Xoe, [
        e.programs.has_header && !e.isPurpleStyle ? (d(), k(a, {
          key: 0,
          class: v(["see-all-top", e.theme.style]),
          "theme-options": e.theme
        }, {
          header: _(() => [
            c("h2", {
              "data-testid": `header-${e.theme.style}-top`
            }, [
              e.isMonterreyStyle ? (d(), h("span", {
                key: 0,
                "data-testid": `header-${e.theme.style}-top`,
                class: "header-top"
              }, [
                w(e.$slots, "header-top", {}, () => [
                  A(y(e.programs.component_header_top), 1)
                ])
              ], 8, Joe)) : b("", !0),
              w(e.$slots, "header", {}, () => [
                A(y(e.programs.component_header), 1)
              ])
            ], 8, Qoe)
          ]),
          _: 3
        }, 8, ["class", "theme-options"])) : b("", !0),
        (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
          modelValue: r.programsContent,
          "onUpdate:modelValue": t[1] || (t[1] = (s) => r.programsContent = s),
          class: ["programs-tabs", e.theme.style],
          role: "tablist",
          "item-key": "index",
          "aria-label": "programs-tabs"
        }), {
          item: _(({ element: s, index: l }) => [
            c("button", {
              id: `tab-${l}`,
              ref: `tab-${l}`,
              role: "tab",
              tabindex: String(i.activeItem === l ? 0 : -1),
              "aria-selected": String(i.activeItem === l),
              "aria-controls": `tabpanel-${l}`,
              class: v(["tab-button", { active: l === i.activeItem, [e.theme.style]: !0 }]),
              "data-testid": "tab-button",
              onClick: (u) => r.activateTab(l),
              onKeydown: t[0] || (t[0] = (u) => r.onKeyDown(u))
            }, [
              w(e.$slots, "drag"),
              w(e.$slots, "headline", { idx: l }, () => [
                A(y(s.headline), 1)
              ])
            ], 42, ere)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      c("div", tre, [
        (d(!0), h(Y, null, ee(r.programsContent, (s, l) => (d(), h("div", {
          id: ["tabpanel-" + l],
          key: l,
          "aria-labelledby": l,
          role: "tabpanel",
          class: v([{ active: l === i.activeItem }, "program-slide"]),
          "data-testid": "program-slide"
        }, [
          w(e.$slots, "controls", { idx: l }),
          w(e.$slots, "image", { idx: l }, () => [
            (d(), k(K(s.image.url ? "img" : "div"), {
              src: s.image.url,
              alt: s.image.alt_text,
              class: "program-image"
            }, null, 8, ["src", "alt"]))
          ]),
          c("div", ore, [
            c("h2", rre, [
              w(e.$slots, "title", { idx: l }, () => [
                A(y(s.title), 1)
              ])
            ]),
            e.programs.has_snippet ? (d(), h("div", ire, [
              w(e.$slots, "description", {
                description: s.description,
                idx: l
              }, () => [
                c("span", {
                  innerHTML: s.description
                }, null, 8, sre)
              ])
            ])) : b("", !0),
            e.programs.read_more_link ? (d(), k(K(e.isEditing ? "div" : "a"), {
              key: 1,
              class: "card-link",
              href: s.link.url,
              target: s.link.opens_in_new_tab ? "_blank" : ""
            }, {
              default: _(() => [
                w(e.$slots, "link", { idx: l }, () => [
                  A(y(s.link.name), 1)
                ])
              ]),
              _: 2
            }, 1032, ["href", "target"])) : b("", !0)
          ])
        ], 10, nre))), 128))
      ])
    ])
  ], 6);
}
const lre = /* @__PURE__ */ O(Woe, [["render", are], ["__scopeId", "data-v-815d8972"]]), Mf = {
  props: {
    // Index of the item considered active in the carrousel view
    activeIndex: {
      type: Number,
      default: 3
    },
    // Minimum pixel distance to trigger a swipe action
    swipeThreshold: {
      type: Number,
      default: 50
    },
    // Interval time in ms for auto-scrolling
    autoScrollIntervalTime: {
      type: Number,
      default: 6e3
    },
    // Duration in ms for the slide animation
    animationDuration: {
      type: Number,
      default: 500
    },
    // Number of positions to shift the array for the carrousel effect
    carrouselShift: {
      type: Number,
      default: 3
    },
    // Minimum number of items before mirroring is applied
    itemsMirrorLimit: {
      type: Number,
      default: 7
    }
  },
  data() {
    return {
      carrouselItems: [],
      isOnAnimation: !1,
      // provide each item with a unique id in format xxx-{index}
      carrouselActiveIdx: this.activeIndex,
      isAutoScroll: !1,
      autoScrollInterval: null,
      onFocus: !1,
      swipeStartX: 0,
      isSwiping: !1
    };
  },
  computed: {
    isMirrorArray() {
      return this.isEditing ? !1 : this.carrouselItems.length < this.itemsMirrorLimit;
    },
    content() {
      let e = [...this.carrouselItems];
      return this.isEditing || e.length < 3 ? e : (this.isMirrorArray && (e = [...e, ...e]), this.shiftArray(e, this.carrouselShift));
    }
  },
  methods: {
    shiftArray(e, t) {
      const n = e.length - t;
      return [...e.slice(n), ...e.slice(0, n)];
    },
    onAnimation() {
      return new Promise((e) => {
        this.isOnAnimation = !0, setTimeout(() => {
          this.isOnAnimation = !1, e();
        }, this.animationDuration);
      });
    },
    async moveItem({ direction: e = "next", autofocus: t = !1 } = {}) {
      if (this.isOnAnimation) return;
      const n = this.$refs.carrousel;
      if (!n) return;
      const o = n.children;
      this.reorderItems(n, o, e), this.updateTabIndexes(o), t && this.focusActiveItem(o), this.isAutoScroll && this.resetAutoScroll(), await this.onAnimation();
    },
    async setActiveItem(e, t = !1) {
      if (this.isOnAnimation) return;
      const n = this.$refs.carrousel;
      if (!n || n.children.length === 0 || n.children.length < 3 || e < 0 || e >= n.children.length)
        return;
      if (e === this.activeIndex) {
        t && this.focusActiveItem(n.children);
        return;
      }
      const o = e - this.activeIndex, i = o > 0 ? "next" : "prev", r = Math.abs(o);
      for (let a = 0; a < r; a++) {
        const s = a === r - 1 && t;
        await this.moveItem({ direction: i, autofocus: s });
      }
    },
    reorderItems(e, t, n) {
      var o, i;
      n === "next" ? e.appendChild(t[0]) : n === "prev" && e.prepend(t[t.length - 1]), this.carrouselActiveIdx = +((i = (o = t[this.activeIndex]) == null ? void 0 : o.id) == null ? void 0 : i.split("-").at(-1));
    },
    updateTabIndexes(e) {
      Array.from(e).forEach((t) => t.setAttribute("tabindex", "-1")), e[this.activeIndex] && e[this.activeIndex].setAttribute("tabindex", "0");
    },
    focusActiveItem(e) {
      var t;
      (t = e[this.activeIndex]) == null || t.focus();
    },
    getItemNumber(e) {
      let t;
      const n = this.content.length, o = 3;
      if (this.isMirrorArray) {
        const i = n / 2;
        t = (e % i + i - o) % i + 1;
      } else
        t = e - o + 1, t < 1 && (t += n);
      return t;
    },
    handleSwipeStart(e) {
      this.isSwiping = !0, this.swipeStartX = e.touches ? e.touches[0].clientX : e.clientX;
    },
    handleSwipeEnd(e) {
      if (!this.isSwiping) return;
      this.isSwiping = !1;
      const n = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - this.swipeStartX;
      n > this.swipeThreshold ? this.moveItem({ direction: "prev" }) : n < -this.swipeThreshold && this.moveItem({ direction: "next" });
    },
    toggleAutoScroll() {
      this.isAutoScroll ? this.stopAutoScroll() : this.startAutoScroll();
    },
    handleFocus() {
      this.onFocus = !0;
    },
    handleBlur() {
      this.onFocus = !1;
    },
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        this.moveItem({ direction: "next", autofocus: this.onFocus });
      }, this.autoScrollIntervalTime), this.isAutoScroll = !0;
    },
    stopAutoScroll() {
      clearInterval(this.autoScrollInterval), this.isAutoScroll = !1;
    },
    resetAutoScroll() {
      this.stopAutoScroll(), this.startAutoScroll();
    }
  },
  beforeDestroy() {
    this.stopAutoScroll();
  }
}, ure = {
  name: "P5",
  mixins: [Hi, Mf],
  props: {
    animationDuration: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      carrouselItems: this.programs.content || []
    };
  },
  computed: {
    p5Colors() {
      return he(ie({}, this.colors), {
        "--heading-description-color": S(this.theme, "heading_description_color.hex", "#000"),
        "--icon-bg-color": S(this.theme, "icon_bg_color.hex", "#FFD6D6"),
        "--icon-color": S(this.theme, "icon_color.hex", "#741819")
      });
    },
    nextSlideText() {
      return S(this.theme, "translations.next_slide", "Next slide");
    },
    previousSlideText() {
      return S(this.theme, "translations.previous_slide", "Previous slide");
    }
  },
  methods: {
    handleProgramClick(e) {
      const t = e.currentTarget, n = this.$refs.carrousel, o = Array.from(n.children).indexOf(t);
      this.setActiveItem(o, !0);
    },
    getProgramAriaLabel(e, t) {
      return `${this.getItemNumber(e)} of ${this.content.length}, ${t.title}`;
    }
  }
}, dre = { class: "programs-wrapper" }, cre = { class: "header-wrapper" }, hre = {
  key: 0,
  class: "header"
}, mre = {
  key: 1,
  class: "header-description",
  "data-testid": "header-description"
}, pre = {
  key: 0,
  class: "carrousel-container",
  role: "region",
  "aria-roledescription": "carousel"
}, fre = ["id", "data-testid", "aria-label", "tabindex", "onClick"], gre = {
  key: 0,
  class: "icon-wrapper"
}, vre = ["innerHTML"], bre = { class: "program-content" }, yre = { class: "program-title" }, _re = ["innerHTML"], Cre = { class: "program" }, wre = { class: "icon-wrapper" }, Tre = ["innerHTML"], kre = { class: "program-content" }, Ere = { class: "program-title" }, Sre = { class: "program-title" }, Mre = { class: "program-description" }, Are = ["innerHTML"], $re = {
  key: 0,
  class: "card-link"
}, Ire = {
  key: 2,
  role: "group",
  "aria-label": "slide controls",
  class: "carrousel-controls"
}, Dre = { class: "nav" }, Lre = ["aria-label"], Ore = ["aria-label"];
function Nre(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    class: v(["programs-v5", [e.theme.style, { editing: e.isEditing }]]),
    "data-testid": "P5",
    style: j(r.p5Colors)
  }, [
    c("div", dre, [
      L(a, {
        class: v([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: _(() => [
          c("div", cre, [
            e.programs.has_header ? (d(), h("div", hre, [
              c("h2", null, [
                w(e.$slots, "header", {}, () => [
                  A(y(e.programs.component_header), 1)
                ], !0)
              ])
            ])) : b("", !0),
            e.programs.has_header_description ? (d(), h("div", mre, [
              w(e.$slots, "header-description", {}, () => [
                A(y(e.programs.component_header_description), 1)
              ], !0)
            ])) : b("", !0)
          ])
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      e.isEditing ? (d(), k(K(e.wrapperComponent), we({ key: 1 }, e.wrapperProps, {
        modelValue: e.programs.content,
        "onUpdate:modelValue": t[8] || (t[8] = (s) => e.programs.content = s),
        "item-key": "id",
        class: "draggable-carrousel"
      }), {
        item: _(({ element: s, index: l }) => [
          c("div", Cre, [
            w(e.$slots, "controls", { idx: l }, void 0, !0),
            e.programs.has_visuals ? (d(), h("div", {
              key: 0,
              class: v(["program-header", { "icon-only": e.theme.enable_icons }])
            }, [
              e.theme.enable_icons ? w(e.$slots, "icon", {
                key: 0,
                idx: l
              }, () => [
                c("div", wre, [
                  s.icon ? (d(), h("span", {
                    key: 0,
                    class: "raw-svg",
                    "data-testid": "program-icon",
                    innerHTML: s.icon
                  }, null, 8, Tre)) : b("", !0)
                ])
              ], !0) : w(e.$slots, "image", {
                key: 1,
                idx: l
              }, () => [
                (d(), k(K(s.image && s.image.url ? "img" : "div"), {
                  src: s.image && s.image.url,
                  alt: s.image && s.image.alt_text,
                  loading: "lazy",
                  class: "program-image"
                }, null, 8, ["src", "alt"]))
              ], !0)
            ], 2)) : b("", !0),
            c("div", kre, [
              c("span", Ere, [
                w(e.$slots, "title", {
                  title: s.title,
                  idx: l
                }, () => [
                  c("span", Sre, y(s.title), 1)
                ], !0)
              ]),
              c("span", Mre, [
                w(e.$slots, "description", {
                  description: s.description,
                  idx: l
                }, () => [
                  c("span", {
                    class: "description-link",
                    innerHTML: s.description
                  }, null, 8, Are)
                ], !0)
              ]),
              e.programs.read_more_link ? (d(), h("div", $re, [
                w(e.$slots, "link", { idx: l }, () => [
                  A(y(s.link.name), 1)
                ], !0)
              ])) : b("", !0)
            ])
          ])
        ]),
        _: 3
      }, 16, ["modelValue"])) : (d(), h("div", pre, [
        c("div", {
          ref: "carrousel",
          class: v([
            "carrousel-wrapper",
            {
              swiping: e.isSwiping,
              single: e.content.length === 1,
              small: e.content.length < 5
            }
          ]),
          onTouchstart: t[4] || (t[4] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onTouchend: t[5] || (t[5] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s)),
          onMousedown: t[6] || (t[6] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onMouseup: t[7] || (t[7] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s))
        }, [
          (d(!0), h(Y, null, ee(e.content, (s, l) => (d(), h("div", {
            id: `carrousel-item-${l}`,
            key: l,
            class: "program",
            "data-testid": `programCard${l}`,
            "aria-label": r.getProgramAriaLabel(l, s),
            role: "group",
            "aria-roledescription": "slide",
            "data-attr": "program-content",
            tabindex: l === 3 ? 0 : -1,
            onKeyup: [
              t[0] || (t[0] = V((u) => e.moveItem({ direction: "prev", autofocus: !0 }), ["left"])),
              t[1] || (t[1] = V((u) => e.moveItem({ direction: "next", autofocus: !0 }), ["right"]))
            ],
            onFocus: t[2] || (t[2] = (...u) => e.handleFocus && e.handleFocus(...u)),
            onBlur: t[3] || (t[3] = (...u) => e.handleBlur && e.handleBlur(...u)),
            onClick: (u) => r.handleProgramClick(u, l)
          }, [
            e.programs.has_visuals ? (d(), h("div", {
              key: 0,
              class: v(["program-header", { "icon-only": e.theme.enable_icons }])
            }, [
              e.theme.enable_icons ? (d(), h("div", gre, [
                s.icon ? (d(), h("span", {
                  key: 0,
                  class: "raw-svg",
                  "data-testid": "program-icon",
                  innerHTML: s.icon
                }, null, 8, vre)) : b("", !0)
              ])) : (d(), k(K(s.image && s.image.url ? "img" : "div"), {
                key: 1,
                src: s.image && s.image.url,
                alt: s.image && s.image.alt_text,
                loading: "lazy",
                class: "program-image"
              }, null, 8, ["src", "alt"]))
            ], 2)) : b("", !0),
            c("div", bre, [
              c("span", yre, y(s.title), 1),
              c("span", {
                class: v([
                  "program-description",
                  {
                    full: !e.programs.has_visuals,
                    "with-icons": e.programs.has_visuals && e.theme.enable_icons
                  }
                ])
              }, [
                c("span", {
                  class: "description-link",
                  innerHTML: s.description
                }, null, 8, _re)
              ], 2),
              e.programs.read_more_link && s.link ? (d(), k(K(e.isPreview ? "div" : "a"), {
                key: 0,
                class: "card-link",
                href: s.link.url,
                target: s.link.opens_in_new_tab ? "_blank" : "",
                tabindex: e.carrouselActiveIdx === l ? 0 : -1
              }, {
                default: _(() => [
                  A(y(s.link.name), 1)
                ]),
                _: 2
              }, 1032, ["href", "target", "tabindex"])) : b("", !0)
            ])
          ], 40, fre))), 128))
        ], 34)
      ])),
      e.programs.slider ? (d(), h("div", Ire, [
        c("div", Dre, [
          c("button", {
            class: "carrousel-nav prev",
            "aria-label": r.previousSlideText,
            onClick: t[9] || (t[9] = (s) => e.moveItem({ direction: "prev" }))
          }, t[11] || (t[11] = [
            c("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "26",
              height: "14",
              viewBox: "0 0 26 14",
              fill: "none",
              "aria-hidden": "true"
            }, [
              c("path", {
                d: "M1 7L7 13M1 7L7 1M1 7L25 7",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]), 8, Lre),
          c("button", {
            class: "carrousel-nav next",
            "aria-label": r.nextSlideText,
            onClick: t[10] || (t[10] = (s) => e.moveItem({ direction: "next" }))
          }, t[12] || (t[12] = [
            c("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "26",
              height: "14",
              viewBox: "0 0 26 14",
              fill: "none",
              "aria-hidden": "true"
            }, [
              c("path", {
                d: "M25 7L19 1M25 7L19 13M25 7H1",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]), 8, Ore)
        ]),
        t[13] || (t[13] = c("div", { class: "accent-bar" }, null, -1))
      ])) : b("", !0)
    ])
  ], 6);
}
const Pre = /* @__PURE__ */ O(ure, [["render", Nre], ["__scopeId", "data-v-f3967577"]]), Hre = {
  name: "Programs",
  components: {
    P1: uoe,
    P2: Hoe,
    P3: xoe,
    P4: lre,
    P5: Pre
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  }
};
function Fre(e, t, n, o, i, r) {
  return d(), k(K(n.theme.version), {
    theme: n.theme,
    programs: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    "is-preview": n.isPreview,
    onEditSeeAllLink: t[0] || (t[0] = (a) => {
      e.$emit("edit-see-all-link", a);
    })
  }, {
    "header-top": _(() => [
      w(e.$slots, "header-top")
    ]),
    header: _(() => [
      w(e.$slots, "header")
    ]),
    "header-description": _(() => [
      w(e.$slots, "header-description")
    ]),
    controls: _(({ idx: a }) => [
      w(e.$slots, "controls", { idx: a })
    ]),
    "main-controls": _(() => [
      w(e.$slots, "main-controls")
    ]),
    "small-controls": _(({ idx: a }) => [
      w(e.$slots, "small-controls", { idx: a })
    ]),
    image: _(({ idx: a }) => [
      w(e.$slots, "image", { idx: a })
    ]),
    icon: _(({ idx: a }) => [
      w(e.$slots, "icon", { idx: a })
    ]),
    link: _(({ idx: a }) => [
      w(e.$slots, "link", { idx: a })
    ]),
    title: _(({ title: a, idx: s }) => [
      w(e.$slots, "title", {
        title: a,
        idx: s
      })
    ]),
    description: _(({ description: a, idx: s }) => [
      w(e.$slots, "description", {
        description: a,
        idx: s
      })
    ]),
    headline: _(({ idx: a }) => [
      w(e.$slots, "headline", { idx: a })
    ]),
    drag: _(() => [
      w(e.$slots, "drag")
    ]),
    _: 3
  }, 40, ["theme", "programs", "wrapper-component", "wrapper-props", "is-editing", "is-preview"]);
}
const Rre = /* @__PURE__ */ O(Hre, [["render", Fre]]), Bre = ["regular", "pill"], Vre = (e) => (t) => e.includes(t), jre = {
  name: "EventTag",
  props: {
    displayText: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: "regular",
      validator: Vre(Bre)
    },
    bgColor: {
      type: String,
      default: "#F3F3F3"
    },
    fontColor: {
      type: String,
      default: "#000"
    }
  },
  computed: {
    text() {
      return this.variant === "pill" ? this.displayText : `| ${this.displayText}`;
    },
    cssVars() {
      return {
        "--bg-color": this.bgColor,
        "--font-color": `${this.fontColor}CC`
      };
    }
  }
}, Ure = { class: "tag-tooltip tag-tooltip-bottom" }, Gre = { class: "tag-tooltip-text" };
function zre(e, t, n, o, i, r) {
  return d(), h("div", Ure, [
    n.displayText ? (d(), h("div", {
      key: 0,
      style: j(r.cssVars),
      class: v([n.variant, "event-tag"])
    }, y(r.text), 7)) : b("", !0),
    c("div", Gre, y(n.displayText), 1)
  ]);
}
const Kre = /* @__PURE__ */ O(jre, [["render", zre], ["__scopeId", "data-v-c536c1f9"]]), Go = {
  components: { EventTag: Kre },
  mixins: [mt],
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    events: {
      type: Array,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    eventsConfig: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    componentId: {
      type: String,
      required: !0
    }
  },
  computed: {
    theme() {
      return this.options;
    },
    colors() {
      var t, n;
      const e = this.sharedThemeColors();
      return he(ie({}, e), {
        "--date-color": S(this.theme, "date_color.hex", "initial"),
        "--date-bg-color": S(this.theme, "date_bg_color.hex", "initial"),
        "--time-color": S(this.theme, "time_color.hex", "initial"),
        "--location-color": S(this.theme, "location_color.hex", "initial"),
        "--bg-color": S(this.theme, "bg_color.hex", "#fff"),
        "--event-bg-color": S(this.theme, "event_bg_color.hex", "none"),
        "--event-title-color": S(this.theme, "event_title_color.hex", "initial"),
        "--event-separator-color": S(this.theme, "event_separator_color.hex", "#000"),
        "--event-border-color": S(this.theme, "event_border_color.hex", "#000"),
        event_section_tag_color: S(this.theme, "event_section_tag_color.hex", "#F3F3F3"),
        event_section_tag_text_color: S(this.theme, "event_section_tag_text_color.hex", "#fff"),
        "--arrow-background-color": S(this.theme, "arrow_background_color.hex", "#fff"),
        "--event-arrow-color": S(this.theme, "event_arrow_color.hex", "#fff"),
        "--pager-color": S(this.theme, "pager_color.hex", "#fff"),
        "--event-bg-color-1": S(this.theme, "event_bg_color_1.hex", "#fff"),
        "--event-date-border-color": S(this.theme, "event_date_border_color.hex", "#fff"),
        "--event-bg-color-3": S(this.theme, "event_bg_color_3.hex", "#fff"),
        "--event-text-color-1": S(this.theme, "event_text_color_1.hex", "#fff"),
        "--event-text-color-3": S(this.theme, "event_text_color_3.hex", "#000"),
        "--percentage-date-opacity": `${(t = this.theme.percentage_date_opacity) != null ? t : 0}%`,
        "--percentage-button-opacity": `${(n = this.theme.percentage_button_opacity) != null ? n : 0}%`
      });
    },
    timeColor() {
      return S(this.theme, "time_color.hex", "initial");
    },
    translations() {
      return this.options.translations || {};
    },
    isPurpleStyle() {
      return this.options.style === "purple";
    },
    isMonterreyStyle() {
      return this.options.style === "monterrey";
    },
    seeAllLinkHref() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.href) || this.link("events");
    },
    seeAllLinkName() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.eventsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    },
    visibleItems() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.num_rows) || 4;
    }
  },
  methods: {
    startDateMonth(e) {
      return e.split("from")[0].trim().split(" to ")[0].split(" ")[0];
    },
    startDateDay(e) {
      return e.split("from")[0].trim().split(" to ")[0].split(" ")[1];
    },
    endDateMonth(e) {
      const n = e.split("from")[0].trim().split(" to ");
      let o = "";
      const i = n[1] || "";
      return An(i) || (o = i.split(" ")), o[0];
    },
    endDateDay(e) {
      const n = e.split("from")[0].trim().split(" to ");
      let o = "";
      const i = n[1] || "";
      return An(i) || (o = i.split(" ")), o[1];
    },
    formatDateAndTime(e, t) {
      const n = e.split("from");
      return t === "date" ? n[0].replace("to", "—") : n[1].replace("to", "—").toUpperCase() !== "" ? n[1].replace("to", "—").toUpperCase() : this.translations.all_day;
    },
    displayEventTags(e) {
      return this.eventsConfig.display_tags && this.eventSectionName(e);
    },
    eventSectionName(e) {
      return e.sectionDisplayName || e.custom_section_name;
    }
  }
}, Zre = {
  name: "E1",
  mixins: [Go],
  computed: {
    eventsOnHomepage() {
      return this.events.slice(0, 4);
    },
    lessThanFourEvents() {
      return this.eventsOnHomepage.length <= 3;
    }
  }
}, xre = ["data-testid"], Wre = { class: "events-title-wrapper" }, qre = ["href"], Yre = { class: "sr-only" }, Xre = {
  key: 0,
  class: "event-tag-wrapper"
};
function Qre(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("event-tag");
  return d(), h("div", {
    id: "events-e1",
    style: j(e.colors),
    class: v([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e1"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, xre)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: _(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["hide-on-xs hide-on-lg-three-cols see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: v(["events-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), h(Y, null, ee(r.eventsOnHomepage, (l, u) => (d(), h("div", {
        key: `${u}-${l.title}`,
        class: v(["events-card grow events-accent-border", { "less-than-four-events": r.lessThanFourEvents }]),
        "data-testid": "events-content"
      }, [
        c("p", {
          class: v(["events-date", e.theme.style])
        }, y(e.formatDateAndTime(l.cms_formatted_date, "date")), 3),
        c("p", {
          class: v(["events-time", e.theme.style])
        }, y(e.formatDateAndTime(l.cms_formatted_date, "time")), 3),
        c("div", Wre, [
          c("a", {
            href: e.link(`events?id=${l.id}`),
            "data-testid": "events-title",
            class: "events-title"
          }, [
            A(y(l.title) + " ", 1),
            c("span", Yre, y(e.formatDateAndTime(l.cms_formatted_date, "date")), 1)
          ], 8, qre)
        ]),
        e.displayEventTags(l) ? (d(), h("div", Xre, [
          L(s, {
            variant: "pill",
            "display-text": e.eventSectionName(l),
            "bg-color": e.colors.event_section_tag_color,
            "font-color": e.colors.event_section_tag_text_color
          }, null, 8, ["display-text", "bg-color", "font-color"])
        ])) : b("", !0)
      ], 2))), 128))
    ], 2),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : b("", !0)
  ], 6);
}
const Jre = /* @__PURE__ */ O(Zre, [["render", Qre], ["__scopeId", "data-v-cb66b5e5"]]), eie = {
  name: "E2",
  mixins: [Go]
}, tie = ["data-testid"], nie = { class: "events-date-and-time" }, oie = { class: "events-title" }, rie = ["href"], iie = { class: "sr-only" }, sie = {
  key: 0,
  class: "event-tag-wrapper"
};
function aie(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("event-tag");
  return d(), h("div", {
    id: "events-e2",
    class: v([e.theme.style, { "is-editing": e.isEditing }]),
    style: j(e.colors),
    "data-testid": "e2"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, tie)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: _(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: v(["events-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), h(Y, null, ee(e.events.slice(0, 8), (l, u) => (d(), h("div", {
        key: `${u}-${l.title}`,
        class: "events-card",
        "data-testid": "events-content"
      }, [
        c("p", nie, [
          c("span", {
            class: v(["events-date", e.theme.style])
          }, y(e.formatDateAndTime(l.cms_formatted_date, "date")), 3),
          c("span", {
            class: v(["events-time", e.theme.style])
          }, y(e.formatDateAndTime(l.cms_formatted_date, "time")), 3)
        ]),
        c("h3", oie, [
          c("a", {
            href: e.isPreview ? void 0 : `${e.pathPrefix}/events?id=${l.id}`
          }, [
            A(y(l.title) + " ", 1),
            c("span", iie, y(e.formatDateAndTime(l.cms_formatted_date, "date")), 1)
          ], 8, rie)
        ]),
        e.displayEventTags(l) ? (d(), h("div", sie, [
          L(s, {
            variant: "pill",
            "display-text": e.eventSectionName(l),
            "bg-color": e.colors.event_section_tag_color,
            "font-color": e.colors.event_section_tag_text_color
          }, null, 8, ["display-text", "bg-color", "font-color"])
        ])) : b("", !0)
      ]))), 128))
    ], 2),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : b("", !0)
  ], 6);
}
const lie = /* @__PURE__ */ O(eie, [["render", aie], ["__scopeId", "data-v-6b81d5a6"]]), uie = {
  name: "E3",
  mixins: [Go],
  computed: {
    backgroundStyle() {
      return this.options.show_background_image ? {
        backgroundImage: `linear-gradient(${this.options.bg_color.hex}e6, ${this.options.bg_color.hex}e6), url(${S(
          this.eventsConfig,
          "background_image.url"
        )})`,
        backgroundSize: "cover"
      } : !1;
    }
  }
}, die = ["data-testid"], cie = { class: "events-v3__events" }, hie = ["href"], mie = { class: "sr-only" }, pie = { class: "events-v3__events__event__time" }, fie = { class: "events-v3__footer" };
function gie(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("event-tag");
  return d(), h("div", {
    id: "events-v3",
    class: v([e.options.style, { "is-editing": e.isEditing }]),
    style: j([r.backgroundStyle, e.colors]),
    "data-testid": "e3"
  }, [
    c("div", {
      class: v(["events-v3__header__button", e.options.style])
    }, [
      L(a, {
        class: v([e.options.style, "see-all-top"]),
        "theme-options": e.theme,
        "data-testid": "see-all-top"
      }, {
        header: _(() => [
          e.isMonterreyStyle ? (d(), h("h3", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, die)) : b("", !0),
          (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
            "data-testid": `header-${e.theme.style}-top`
          }, {
            default: _(() => [
              w(e.$slots, "header", {}, () => [
                A(y(e.sectionHeader), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["data-testid"]))
        ]),
        default: _(() => [
          e.options.style !== "purple" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
            key: 0,
            class: v(["hide-on-xs see-all-button", e.options.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.options.style}-top`,
            onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
          }, {
            default: _(() => [
              A(y(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])
    ], 2),
    c("div", cie, [
      (d(!0), h(Y, null, ee(e.events.slice(0, 4), (l, u) => (d(), h("div", {
        key: u,
        class: v(["events-v3__events__event grow", [e.options.style, { "is-editing": e.isEditing }]]),
        "data-testid": "events-content"
      }, [
        c("div", {
          class: v(["events-v3__events__event__date events-date", e.options.style])
        }, y(e.formatDateAndTime(l.cms_formatted_date, "date")), 3),
        c("a", {
          href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${l.id}`,
          class: "events-v3__events__event__title"
        }, [
          A(y(l.title) + " ", 1),
          c("span", mie, y(e.formatDateAndTime(l.cms_formatted_date, "date")), 1)
        ], 8, hie),
        c("div", pie, [
          A(y(e.formatDateAndTime(l.cms_formatted_date, "time")) + " ", 1),
          e.displayEventTags(l) ? (d(), k(s, {
            key: 0,
            "display-text": e.eventSectionName(l),
            "bg-color": e.timeColor
          }, null, 8, ["display-text", "bg-color"])) : b("", !0)
        ])
      ], 2))), 128))
    ]),
    c("div", fie, [
      e.options.style === "purple" || e.screenSize < 600 ? (d(), k(a, {
        key: 0,
        class: v([e.options.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.options.style}-bottom`
      }, {
        default: _(() => [
          (d(), k(K(e.isEditing ? "button" : "a"), {
            class: v(["see-all-button", e.options.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
          }, {
            default: _(() => [
              A(y(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : b("", !0)
    ])
  ], 6);
}
const vie = /* @__PURE__ */ O(uie, [["render", gie], ["__scopeId", "data-v-a850dc5f"]]), bie = {
  name: "OriginalSliderButton",
  props: {
    iconColor: {
      type: String,
      default: "#000000"
    },
    translatedAria: {
      type: String,
      default: ""
    },
    direction: {
      type: String,
      default: "left"
    }
  }
}, yie = { class: "btn_content" }, _ie = {
  class: "normal",
  viewBox: "0 0 30 69",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cie = ["fill"], wie = ["fill"], Tie = {
  class: "hover",
  viewBox: "0 0 33 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, kie = ["fill"], Eie = ["fill"], Sie = { class: "sr-only" };
function Mie(e, t, n, o, i, r) {
  return d(), h("button", {
    class: v(["cards-slider-arrow", n.direction]),
    onClick: t[0] || (t[0] = (a) => e.$emit(`go-${n.direction}`))
  }, [
    c("span", yie, [
      (d(), h("svg", _ie, [
        n.direction === "left" ? (d(), h("path", {
          key: 0,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M29.0391 68.4702C27.9511 69.3202 26.38 69.1273 25.5299 68.0392L0.529939 36.0392C-0.176646 35.1348 -0.176646 33.8654 0.529939 32.961L25.5299 0.961001C26.38 -0.127035 27.9511 -0.319974 29.0391 0.530047C30.1271 1.38008 30.3201 2.95119 29.4701 4.03923L5.67249 34.5001L29.4701 64.961C30.3201 66.049 30.1271 67.6201 29.0391 68.4702Z"
        }, null, 8, Cie)) : (d(), h("path", {
          key: 1,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M1.46088 0.53005C2.54891 -0.319977 4.12002 -0.127034 4.97005 0.961001L29.97 32.961C30.6766 33.8654 30.6766 35.1348 29.97 36.0392L4.97005 68.0392C4.12002 69.1273 2.54891 69.3202 1.46088 68.4702C0.372844 67.6201 0.179901 66.049 1.02993 64.961L24.8275 34.5001L1.02993 4.03922C0.179901 2.95119 0.372844 1.38008 1.46088 0.53005Z"
        }, null, 8, wie))
      ])),
      (d(), h("svg", Tie, [
        n.direction === "left" ? (d(), h("path", {
          key: 0,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M31.4626 71.1523C29.7217 72.5123 27.208 72.2036 25.8479 70.4628L0.847911 38.4628C-0.282628 37.0157 -0.282628 34.9847 0.847911 33.5376L25.8479 1.53761C27.208 -0.20324 29.7217 -0.511948 31.4626 0.848091C33.2034 2.20814 33.5122 4.72191 32.1521 6.46277L9.07599 36.0002L32.1521 65.5376C33.5121 67.2785 33.2034 69.7922 31.4626 71.1523Z"
        }, null, 8, kie)) : (d(), h("path", {
          key: 1,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M1.5376 0.84808C3.27846 -0.511963 5.79223 -0.203254 7.15228 1.5376L32.1523 33.5376C33.2828 34.9847 33.2828 37.0157 32.1523 38.4628L7.15228 70.4628C5.79223 72.2036 3.27846 72.5123 1.5376 71.1523C-0.203254 69.7922 -0.511963 67.2785 0.84808 65.5376L23.9242 36.0002L0.84808 6.46275C-0.511963 4.7219 -0.203254 2.20812 1.5376 0.84808Z"
        }, null, 8, Eie))
      ])),
      c("span", Sie, y(n.translatedAria), 1)
    ])
  ], 2);
}
const Aie = /* @__PURE__ */ O(bie, [["render", Mie], ["__scopeId", "data-v-34444ce7"]]), $ie = {
  name: "Slider",
  components: { OriginalSliderButton: Aie },
  props: {
    totalCards: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    currentCard: {
      type: Number,
      default: 0
    },
    allCardsVisible: {
      type: Boolean
    },
    sectionHeader: {
      type: String,
      required: !0
    },
    hideXSmall: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    buttonStyles() {
      var e, t;
      return {
        "--background-color": ((t = (e = this.themeStyles) == null ? void 0 : e.arrow_background_color) == null ? void 0 : t.hex) || "#fff"
      };
    },
    arrowIconColor() {
      return S(this.themeStyles, "arrow_icon_color.hex", "#000");
    },
    nextSlideText() {
      return S(this.themeStyles, "translations.next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return S(this.themeStyles, "translations.previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    }
  }
}, Iie = ["aria-label"];
function Die(e, t, n, o, i, r) {
  const a = $("OriginalSliderButton");
  return d(), h("div", {
    "aria-label": n.sectionHeader,
    style: j(r.buttonStyles),
    class: v([{ "hide-x-small": n.hideXSmall }, "cards-slider"]),
    role: "region",
    "aria-roledescription": "carousel"
  }, [
    w(e.$slots, "button-left", {}, () => [
      L(a, {
        direction: "left",
        "icon-color": r.arrowIconColor,
        "translated-aria": r.previousSlideText,
        onGoLeft: t[0] || (t[0] = (s) => e.$emit("scroll-left"))
      }, null, 8, ["icon-color", "translated-aria"])
    ]),
    w(e.$slots, "default"),
    w(e.$slots, "button-right", {}, () => [
      L(a, {
        direction: "right",
        "icon-color": r.arrowIconColor,
        "translated-aria": r.nextSlideText,
        onGoRight: t[1] || (t[1] = (s) => e.$emit("scroll-right"))
      }, null, 8, ["icon-color", "translated-aria"])
    ])
  ], 14, Iie);
}
const Eu = /* @__PURE__ */ O($ie, [["render", Die], ["__scopeId", "data-v-af515ce7"]]), Lie = {
  name: "E4",
  components: { Slider: Eu },
  mixins: [Go, ut],
  computed: {
    content() {
      return this.events;
    },
    eventsContent() {
      return this.isSliderShown ? this.content : this.content.slice(0, 4);
    },
    isSliderShown() {
      return this.screenSize > 960;
    },
    themeStyles() {
      var e, t;
      return he(ie({}, this.theme), {
        arrow_icon_color: { hex: ((t = (e = this.theme) == null ? void 0 : e.event_arrow_color) == null ? void 0 : t.hex) || "#000" }
      });
    }
  },
  methods: {
    isInRange(e, t) {
      return e >= t - 3 && e <= t + 3;
    },
    isTheLastOneInRange(e, t) {
      return e === t + 3;
    },
    isTheFirstOneInRange(e, t) {
      return e === t;
    },
    cardClassObj(e, t) {
      return {
        "events-card-hidden": !this.isInRange(e, t) && this.isSliderShown,
        "events-card-no-border": this.isTheLastOneInRange(e, t),
        "events-card-first": this.isTheFirstOneInRange(e, t)
      };
    }
  }
}, Oie = ["data-testid"], Nie = ["data-testid"], Pie = { class: "cards-slider-content" }, Hie = ["aria-label"], Fie = ["href"], Rie = { class: "sr-only" };
function Bie(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("event-tag"), l = $("Slider"), u = Ve("touch");
  return d(), h("div", {
    id: "events-e4",
    style: j(e.colors),
    class: v([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e4"
  }, [
    e.screenSize >= 600 && e.theme.style === "purple" ? (d(), k(a, {
      key: 0,
      "theme-options": e.theme,
      class: v(["see-all-above hide-on-xs", e.theme.style]),
      "data-testid": `header-${e.theme.style}-above`
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-above`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Oie)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-above`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      _: 3
    }, 8, ["theme-options", "class", "data-testid"])) : b("", !0),
    c("div", {
      class: v(["events-info", e.theme.style])
    }, [
      e.theme.style !== "purple" || e.screenSize < 600 ? (d(), k(a, {
        key: 0,
        class: v([e.theme.style, "see-all-top"]),
        "theme-options": e.theme,
        "data-testid": `header-${e.theme.style}-top`
      }, {
        header: _(() => [
          e.isMonterreyStyle ? (d(), h("h3", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, Nie)) : b("", !0),
          (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
            "data-testid": `header-${e.theme.style}-top`
          }, {
            default: _(() => [
              w(e.$slots, "header", {}, () => [
                A(y(e.sectionHeader), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["data-testid"]))
        ]),
        default: _(() => [
          e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
            key: 0,
            class: v(["hide-on-xs see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (m) => e.$emit("open-modal"))
          }, {
            default: _(() => [
              A(y(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options", "data-testid"])) : b("", !0),
      L(l, {
        "total-cards": r.content.length,
        "current-card": e.currentCard,
        "all-cards-visible": e.allCardsVisible,
        "section-header": e.sectionHeader,
        "theme-styles": r.themeStyles,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        default: _(() => [
          c("div", Pie, [
            c("div", {
              ref: "scrollWrapper",
              class: v([{ "all-cards-visible": e.allCardsVisible }, "cards-slider-container"])
            }, [
              (d(!0), h(Y, null, ee(r.eventsContent, (m, g) => ge((d(), h("div", {
                ref_for: !0,
                ref: `sliderCard-${g}`,
                key: g,
                class: v(["events-card", [e.theme.style, r.cardClassObj(g, e.currentCard), { "is-editing": e.isEditing }]]),
                "aria-label": `${g + 1} of ${r.content.length}`,
                role: "group",
                "aria-roledescription": "slide",
                "data-attr": "event-content",
                "data-testid": "events-content"
              }, [
                c("p", {
                  class: v(["events-date", e.theme.style])
                }, y(e.formatDateAndTime(m.cms_formatted_date, "date")), 3),
                c("a", {
                  class: v(["events-title", e.theme.style]),
                  href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${m.id}`
                }, [
                  A(y(m.title) + " ", 1),
                  c("span", Rie, y(e.formatDateAndTime(m.cms_formatted_date, "date")), 1)
                ], 10, Fie),
                c("p", {
                  class: v(["events-time", e.theme.style])
                }, [
                  A(y(e.formatDateAndTime(m.cms_formatted_date, "time")) + " ", 1),
                  e.displayEventTags(m) ? (d(), k(s, {
                    key: 0,
                    "display-text": e.eventSectionName(m),
                    "bg-color": e.timeColor
                  }, null, 8, ["display-text", "bg-color"])) : b("", !0)
                ], 2),
                t[2] || (t[2] = c("div", { class: "events-card-mobile-border-top" }, null, -1)),
                t[3] || (t[3] = c("div", { class: "events-card-mobile-border-right" }, null, -1))
              ], 10, Hie)), [
                [
                  u,
                  e.scrollRight,
                  "swipe",
                  { left: !0 }
                ],
                [
                  u,
                  e.scrollLeft,
                  "swipe",
                  { right: !0 }
                ]
              ])), 128))
            ], 2)
          ])
        ]),
        _: 1
      }, 8, ["total-cards", "current-card", "all-cards-visible", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"]),
      e.theme.style === "purple" || e.screenSize < 600 ? (d(), k(a, {
        key: 1,
        class: v([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.theme.style}-bottom`
      }, {
        default: _(() => [
          (d(), k(K(e.isEditing ? "button" : "a"), {
            class: v(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[1] || (t[1] = (m) => e.$emit("open-modal"))
          }, {
            default: _(() => [
              A(y(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : b("", !0)
    ], 2)
  ], 6);
}
const Vie = /* @__PURE__ */ O(Lie, [["render", Bie], ["__scopeId", "data-v-05ce2c28"]]), jie = {
  name: "E5",
  components: { CardSlider: Jt },
  mixins: [Go, ut],
  computed: {
    content() {
      return this.events.slice(0, 12);
    },
    sliderCenterSize() {
      return 599;
    },
    seeAllStyles() {
      return this.theme.style === "purple" ? "see-all-above" : "see-all-top";
    },
    cssVars() {
      return he(ie({}, this.colors), {
        "--event-bg-color-2": S(this.theme, "event_bg_color_2.hex", "#fff"),
        "--event-text-color-2": S(this.theme, "event_text_color_2.hex", "#000"),
        "--event-bg-color-4": S(this.theme, "event_bg_color_4.hex", "#fff"),
        "--event-text-color-4": S(this.theme, "event_text_color_4.hex", "#000")
      });
    }
  },
  methods: {
    iconAndTagColor(e) {
      return e + 1 > 4 ? this.cssVars[`--event-text-color-${(e + 1) % 4}`] : this.cssVars[`--event-text-color-${e + 1}`];
    }
  }
}, Uie = ["data-testid"], Gie = ["data-testid"], zie = ["aria-label"], Kie = { class: "start-date" }, Zie = {
  class: "date-month",
  "data-testid": "start-month"
}, xie = {
  class: "date-day",
  "data-testid": "start-day"
}, Wie = { key: 0 }, qie = {
  key: 1,
  class: "end-date"
}, Yie = {
  class: "date-month",
  "data-testid": "end-month"
}, Xie = {
  class: "date-day",
  "data-testid": "end-day"
}, Qie = ["href"], Jie = { class: "time-section details" }, ese = { class: "icon-wrapper" }, tse = {
  class: "icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nse = ["stroke"], ose = {
  key: 0,
  class: "location-section details"
}, rse = { class: "icon-wrapper" }, ise = {
  class: "icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sse = ["fill"], ase = ["stroke"], lse = {
  key: 1,
  class: "section-tag"
};
function use(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("CardSlider");
  return d(), h("div", {
    id: "events-e5",
    style: j(r.cssVars),
    class: v([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e5"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-above"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, Gie)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.sectionHeader), 1)
          ], !0)
        ], 8, Uie)
      ]),
      default: _(() => [
        !e.isPurpleStyle && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    L(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      class: v({ "is-editing": e.isEditing }),
      "pager-section-count": e.pagerSectionCount,
      "total-cards": r.content.length,
      "theme-styles": e.theme,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: _(() => [
        c("div", {
          ref: "scrollWrapper",
          class: v(["events-wrapper", { "all-cards-visible": e.allCardsVisible }])
        }, [
          (d(!0), h(Y, null, ee(r.content, (l, u) => (d(), h("div", {
            key: u,
            ref_for: !0,
            ref: `sliderCard-${u}`,
            class: v(["card-content", `card-${u}`]),
            "aria-label": `${u + 1} of ${r.content.length}`,
            "data-testid": "events-content",
            role: "group",
            "aria-roledescription": "slide"
          }, [
            (d(), h("div", {
              key: `${u}-${l.title}`,
              class: v(["card events-card card-color", [e.theme.style, `card-color-${u % 4 + 1}`]]),
              "data-testid": "events-content-item"
            }, [
              c("div", {
                class: v(["events-date", e.theme.style])
              }, [
                c("div", Kie, [
                  c("div", Zie, y(e.startDateMonth(l.cms_formatted_date)), 1),
                  c("div", xie, y(e.startDateDay(l.cms_formatted_date)), 1)
                ]),
                e.endDateMonth(l.cms_formatted_date) ? (d(), h("div", Wie, "-")) : b("", !0),
                e.endDateMonth(l.cms_formatted_date) ? (d(), h("div", qie, [
                  c("div", Yie, y(e.endDateMonth(l.cms_formatted_date)), 1),
                  c("div", Xie, y(e.endDateDay(l.cms_formatted_date)), 1)
                ])) : b("", !0)
              ], 2),
              c("a", {
                class: v(["events-title", e.theme.style]),
                href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${l.id}`
              }, y(l.title), 11, Qie),
              c("div", Jie, [
                c("div", ese, [
                  (d(), h("svg", tse, [
                    c("path", {
                      d: "M11.5 12.381C11.5 12.5269 11.5638 12.6656 11.6746 12.7606L14.3413 15.0463C14.5509 15.226 14.8666 15.2017 15.0463 14.9921C15.226 14.7824 15.2017 14.4668 14.9921 14.287L12.5 12.151V8.66667C12.5 8.39052 12.2761 8.16667 12 8.16667C11.7239 8.16667 11.5 8.39052 11.5 8.66667V12.381ZM19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12Z",
                      stroke: r.iconAndTagColor(u),
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 8, nse)
                  ]))
                ]),
                c("p", {
                  class: v(["events-time", e.theme.style])
                }, y(e.formatDateAndTime(l.cms_formatted_date, "time")), 3)
              ]),
              l.venue ? (d(), h("div", ose, [
                c("div", rse, [
                  (d(), h("svg", ise, [
                    c("rect", {
                      x: "12",
                      y: "11.125",
                      width: "1",
                      height: "9",
                      fill: r.iconAndTagColor(u)
                    }, null, 8, sse),
                    c("circle", {
                      cx: "12.5",
                      cy: "6.625",
                      r: "5",
                      stroke: r.iconAndTagColor(u)
                    }, null, 8, ase)
                  ]))
                ]),
                c("p", {
                  class: v(["events-location", e.theme.style])
                }, y(l.venue), 3)
              ])) : b("", !0),
              e.displayEventTags(l) ? (d(), h("div", lse, y(e.eventSectionName(l)), 1)) : b("", !0),
              t[2] || (t[2] = c("div", { class: "events-card-mobile-border-top" }, null, -1)),
              t[3] || (t[3] = c("div", { class: "events-card-mobile-border-right" }, null, -1))
            ], 2))
          ], 10, zie))), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "class", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button see-all-events", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : b("", !0)
  ], 6);
}
const dse = /* @__PURE__ */ O(jie, [["render", use], ["__scopeId", "data-v-45b5b2db"]]), cse = {
  name: "E6",
  mixins: [Go],
  props: {
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    content() {
      return this.events.slice(0, 6);
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    logoStyles() {
      return {
        "--logo-url": `url(${this.logo})`
      };
    }
  },
  methods: {
    getFormattedDate(e) {
      const t = this.startDateMonth(e) || "", n = this.endDateMonth(e) || "", o = this.startDateDay(e) || "", i = this.endDateDay(e) || "", r = this.formatDateAndTime(e, "time") || "";
      return t === n && o === i ? r : `${t} ${o} - ${n} ${i} ${r}`;
    }
  }
}, hse = ["data-testid"], mse = ["data-testid"], pse = {
  key: 0,
  class: "logo"
}, fse = { class: "start-date" }, gse = { class: "month" }, vse = { class: "date-number" }, bse = { class: "details" }, yse = { class: "event-title" }, _se = ["href"], Cse = { class: "event-dates" }, wse = { class: "event-location" };
function Tse(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    class: v(["events-e6", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: j(e.colors),
    "data-testid": "e6"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          r.isMonterreyStyle ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, mse)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.sectionHeader), 1)
          ], !0)
        ], 8, hse)
      ]),
      default: _(() => [
        !r.isPurpleStyle && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: "events-container",
      style: j(r.logoStyles)
    }, [
      n.logo ? (d(), h("div", pse)) : b("", !0),
      c("div", {
        class: v(["events-wrapper", { "is-editing": e.isEditing }])
      }, [
        (d(!0), h(Y, null, ee(r.content, (s, l) => (d(), h("div", {
          key: `${l}-${s.title}`,
          class: "event-card",
          "data-testid": "events-content"
        }, [
          c("div", fse, [
            c("div", gse, y(e.startDateMonth(s.cms_formatted_date)), 1),
            c("div", vse, y(e.startDateDay(s.cms_formatted_date)), 1)
          ]),
          c("div", bse, [
            c("div", yse, [
              c("a", {
                class: v(["events-title", e.theme.style]),
                href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${s.id}`
              }, y(s.title), 11, _se)
            ]),
            c("div", Cse, [
              t[2] || (t[2] = c("br", null, null, -1)),
              A(" " + y(r.getFormattedDate(s.cms_formatted_date)), 1)
            ]),
            c("div", wse, y(s.venue), 1)
          ])
        ]))), 128))
      ], 2)
    ], 4),
    r.isPurpleStyle || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : b("", !0)
  ], 6);
}
const kse = /* @__PURE__ */ O(cse, [["render", Tse], ["__scopeId", "data-v-056d70ff"]]), Ese = {
  name: "E7",
  mixins: [Go],
  emits: ["open-modal"],
  methods: {
    getFormattedDate(e) {
      const t = this.startDateMonth(e) || "", n = this.endDateMonth(e) || "", o = this.startDateDay(e) || "", i = this.endDateDay(e) || "", r = this.formatDateAndTime(e, "time") || "";
      return t === n && o === i ? r : `${t} ${o} - ${n} ${i} | ${r}`;
    }
  }
}, Sse = ["data-testid"], Mse = ["data-testid"], Ase = { class: "button-text" }, $se = { class: "month" }, Ise = { class: "date-number" }, Dse = { class: "event-title" }, Lse = ["href"], Ose = {
  key: 1,
  class: "event-tag"
}, Nse = { class: "button-text" };
function Pse(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("EventTag");
  return d(), h("div", {
    class: v(["events-e7", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: j(e.colors),
    "data-testid": "e7"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, Mse)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.sectionHeader), 1)
          ], !0)
        ], 8, Sse)
      ]),
      default: _(() => [
        !e.isMonterreyStyle && !e.isPurpleStyle && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            c("div", Ase, y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: v(["events-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), h(Y, null, ee(e.events.slice(0, e.visibleItems), (l) => (d(), h("div", {
        key: l.id,
        class: "events-card",
        "data-testid": "events-content"
      }, [
        c("div", {
          class: v(["events-date", e.theme.style])
        }, [
          c("div", $se, y(e.startDateMonth(l.cms_formatted_date)), 1),
          c("div", Ise, y(e.startDateDay(l.cms_formatted_date)), 1)
        ], 2),
        c("div", {
          class: v(["events-description", e.theme.style])
        }, [
          c("div", Dse, [
            c("a", {
              class: v(["events-title", e.theme.style]),
              href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${l.id}`
            }, y(l.title), 11, Lse)
          ]),
          c("div", {
            class: v(["events-time", e.theme.style])
          }, y(r.getFormattedDate(l.cms_formatted_date)), 3),
          l.venue ? (d(), h("div", {
            key: 0,
            class: v(["events-location", e.theme.style])
          }, y(l.venue), 3)) : b("", !0),
          e.displayEventTags(l) ? (d(), h("div", Ose, [
            L(s, {
              variant: "pill",
              "display-text": e.eventSectionName(l),
              "bg-color": e.colors.event_section_tag_color,
              "font-color": e.colors.event_section_tag_text_color
            }, null, 8, ["display-text", "bg-color", "font-color"])
          ])) : b("", !0)
        ], 2)
      ]))), 128))
    ], 2),
    e.isMonterreyStyle || e.isPurpleStyle || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            c("div", Nse, y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : b("", !0)
  ], 6);
}
const Hse = /* @__PURE__ */ O(Ese, [["render", Pse], ["__scopeId", "data-v-40029719"]]), Fse = {
  name: "CmsEvents",
  components: {
    E1: Jre,
    E2: lie,
    E3: vie,
    E4: Vie,
    E5: dse,
    E6: kse,
    E7: Hse
  },
  props: {
    options: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    isPreview: Boolean,
    eventsConfig: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isEditing: Boolean,
    componentId: {
      type: String,
      required: !0
    },
    logo: {
      type: String,
      default: ""
    }
  }
}, Rse = {
  id: "view-events",
  class: "view-events events-versions"
};
function Bse(e, t, n, o, i, r) {
  return d(), h("div", Rse, [
    (d(), k(K(n.options.version), {
      options: n.options,
      events: n.content,
      "is-preview": n.isPreview,
      "events-config": n.eventsConfig,
      "component-id": n.componentId,
      "path-prefix": n.pathPrefix,
      logo: n.logo,
      "is-editing": n.isEditing,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": _(() => [
        w(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: _(() => [
        w(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["options", "events", "is-preview", "events-config", "component-id", "path-prefix", "logo", "is-editing"]))
  ]);
}
const Vse = /* @__PURE__ */ O(Fse, [["render", Bse], ["__scopeId", "data-v-23ed585b"]]), io = {
  mixins: [mt],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    posts: {
      type: Array,
      required: !0
    },
    fallbackImage: {
      type: Object,
      default: () => ({})
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    livefeedConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    isEditing: Boolean
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      let t = S(this.theme, "link_card_bg_color.hex", "#fff");
      return t.startsWith("#") || (t = `#${t}`), he(ie({}, e), {
        "--top-heading-color": S(this.theme, "top_heading_color.hex", "#fff"),
        "--bottom-heading-color": S(this.theme, "bottom_heading_color.hex", "#fff"),
        "--header-accent-color": S(this.theme, "header_accent_color.hex", "#333"),
        "--button-border-color": S(this.theme, "button_border_color.hex", "#fff"),
        "--link-color": S(this.theme, "post_link_color.hex", "#0000ee"),
        "--time-and-author-color": S(this.theme, "time_and_author_text_color.hex", e["--heading-color"]),
        "--post-bg-color": S(this.theme, "post_bg_color.hex", "#dfdfdf"),
        "--post-text-color": S(this.theme, "post_text_color.hex", "#333"),
        "--panel-bg-color": S(this.theme, "panel_bg_color.hex", "#fff"),
        "--image-border-color": S(
          this.theme,
          "image_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--link-card-bg-color": t,
        "--arrow-border-color": S(this.theme, "arrow_border_color.hex", "#fff"),
        "--arrow-background-color": S(this.theme, "arrow_background_color.hex", "#ffffff"),
        "--arrow-icon-color": S(this.theme, "arrow_icon_color.hex", "#ffffff"),
        "--pager-color": S(this.theme, "pager_color.hex", "#000"),
        "--time-color": S(this.theme, "time_color.hex", "#000"),
        "--author-color": S(this.theme, "author_text_color.hex", "#000")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("live-feed");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    }
  },
  methods: {
    openLightbox(e) {
      this.isIFrame || this.$emit("openLightbox", e);
    },
    saveFocusElement(e) {
      this.isIFrame || this.$emit("saveFocusElement", e.target);
    },
    onClickImage(e, t, n) {
      this.saveFocusElement(e), this.openLightbox({ images: t, idx: n });
    },
    clickSeeAllButton() {
      this.isIFrame || this.$router.push({ path: `${this.pathPrefix}/live-feed` });
    },
    viewImageText(e) {
      return e.live_feed_images.length > 1 ? this.translations.view_images : this.translations.view_image;
    },
    // Preferably we shouldn't render user-provided HTML
    // https://vuejs.org/v2/guide/syntax.html#Raw-HTML
    getPostContent(e, t) {
      const n = x0(e.status, t), o = `
        <a aria-labelledby="LF-${e.id}" href="${this.pathPrefix}/live-feed#${e.id}">
          Read More
        </a>
      `;
      return n.endsWith("...") ? U8(n).concat(o) : n;
    }
  }
}, jse = {
  name: "LF1",
  mixins: [io],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  },
  methods: {
    thumbnailImages(e) {
      return e.length > 4 ? e.slice(0, 3) : e;
    }
  }
}, Use = ["data-testid"], Gse = { class: "live-feed-post-header" }, zse = ["src"], Kse = { class: "live-feed-author" }, Zse = ["aria-labelledby", "aria-posinset", "aria-setsize"], xse = ["id", "innerHTML"], Wse = ["onKeydown", "onClick"], qse = {
  class: "button-action-content",
  tabindex: "-1"
}, Yse = {
  key: 1,
  class: "thumbnails"
}, Xse = ["src", "alt", "onKeydown", "onClick"], Qse = ["onKeydown", "onClick"];
function Jse(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    id: "LF1",
    class: v(e.theme.style),
    style: j(e.colors),
    "data-testid": "lf1",
    role: "feed"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Use)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: _(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(!0), h(Y, null, ee(r.filteredPosts, (s, l) => (d(), h("div", {
      key: `${l}-${s.author}-LF`,
      class: v(["live-feed-post", [e.theme.style, { "is-editing": e.isEditing }]]),
      "data-testid": "live-feed-content"
    }, [
      c("div", Gse, [
        c("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          role: "presentation",
          loading: "lazy"
        }, null, 8, zse),
        c("span", Kse, y(s.author), 1),
        c("span", {
          class: v(["live-feed-time", e.theme.style])
        }, y(s.time_ago), 3)
      ]),
      c("div", {
        class: v(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": l + 1,
        "aria-setsize": r.filteredPosts.length
      }, [
        c("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, xse),
        !e.theme.show_thumbnails && s.live_feed_images.length > 0 ? (d(), h("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            V(z((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            V(z((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (u) => e.onClickImage(u, s.live_feed_images)
        }, [
          c("div", qse, y(e.viewImageText(s)), 1)
        ], 40, Wse)) : b("", !0),
        e.theme.show_thumbnails && s.live_feed_images.length > 0 ? (d(), h("div", Yse, [
          (d(!0), h(Y, null, ee(r.thumbnailImages(s.live_feed_images), (u, m) => (d(), h("img", {
            key: `${u.id}`,
            tabindex: "0",
            class: "thumbnail",
            loading: "lazy",
            src: u.url,
            alt: u.alt_text,
            onKeydown: [
              V(z((g) => e.onClickImage(g, s.live_feed_images, m), ["exact", "prevent"]), ["enter"]),
              V(z((g) => e.onClickImage(g, s.live_feed_images, m), ["exact", "prevent"]), ["space"])
            ],
            onClick: (g) => e.onClickImage(g, s.live_feed_images, m)
          }, null, 40, Xse))), 128)),
          s.live_feed_images.length > 4 ? (d(), h("div", {
            key: 0,
            style: j({ "--lf-more-bg-image": `url(${s.live_feed_images[3].url})` }),
            tabindex: "0",
            class: "thumbnail more-images",
            onKeydown: [
              V(z((u) => e.onClickImage(u, s.live_feed_images, 3), ["exact", "prevent"]), ["enter"]),
              V(z((u) => e.onClickImage(u, s.live_feed_images, 3), ["exact", "prevent"]), ["space"])
            ],
            onClick: (u) => e.onClickImage(u, s.live_feed_images, 3)
          }, [
            c("span", null, "+ " + y(s.live_feed_images.length - 3), 1)
          ], 44, Qse)) : b("", !0)
        ])) : b("", !0)
      ], 10, Zse)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : b("", !0)
  ], 6);
}
const eae = /* @__PURE__ */ O(jse, [["render", Jse], ["__scopeId", "data-v-b6b428e4"]]), tae = {
  name: "LF2",
  mixins: [io],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  }
}, nae = ["data-testid"], oae = { class: "live-feed-post-header" }, rae = ["src"], iae = { class: "live-feed-time-and-author" }, sae = ["aria-labelledby", "aria-posinset", "aria-setsize"], aae = ["id", "innerHTML"], lae = ["onKeydown", "onClick"], uae = {
  class: "button-action-content",
  tabindex: "-1"
};
function dae(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    id: "LF2",
    style: j(e.colors),
    class: v(e.theme.style),
    role: "feed"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, nae)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: _(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(!0), h(Y, null, ee(r.filteredPosts, (s, l) => (d(), h("div", {
      key: `${l}-${s.author}-LF`,
      class: v(["live-feed-post", { "is-editing": e.isEditing }]),
      "data-testid": "live-feed-content"
    }, [
      c("div", oae, [
        c("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          role: "presentation",
          loading: "lazy"
        }, null, 8, rae),
        c("span", iae, y(s.time_ago) + ", " + y(s.author), 1)
      ]),
      c("div", {
        class: v(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": l + 1,
        "aria-setsize": r.filteredPosts.length
      }, [
        c("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, aae),
        e.isPreview || s.live_feed_images.length > 0 ? (d(), h("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            V(z((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            V(z((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (u) => e.onClickImage(u, s.live_feed_images)
        }, [
          c("div", uae, y(e.viewImageText(s)), 1)
        ], 40, lae)) : b("", !0)
      ], 10, sae)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : b("", !0)
  ], 6);
}
const cae = /* @__PURE__ */ O(tae, [["render", dae], ["__scopeId", "data-v-a7eaf91b"]]), hae = {
  name: "LF3",
  mixins: [io],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  }
}, mae = ["data-testid"], pae = { class: "live-feed-post-header" }, fae = ["src"], gae = { class: "live-feed-time-and-author" }, vae = ["aria-labelledby", "aria-posinset", "aria-setsize"], bae = ["id", "innerHTML"], yae = ["onKeydown", "onClick"], _ae = {
  class: "button-action-content",
  tabindex: "-1"
};
function Cae(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    id: "LF3",
    style: j(e.colors),
    class: v(e.theme.style),
    role: "feed"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, mae)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: _(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(!0), h(Y, null, ee(r.filteredPosts, (s, l) => (d(), h("div", {
      key: `${l}-${s.author}-LF`,
      class: v(["live-feed-post", { "is-editing": e.isEditing }]),
      "data-testid": "live-feed-content"
    }, [
      c("div", pae, [
        c("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          role: "presentation",
          loading: "lazy"
        }, null, 8, fae),
        c("span", gae, y(s.time_ago) + ", " + y(s.author), 1)
      ]),
      c("div", {
        class: v(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": l + 1,
        "aria-setsize": r.filteredPosts.length
      }, [
        c("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, bae),
        e.isPreview || s.live_feed_images.length > 0 ? (d(), h("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            V(z((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            V(z((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (u) => e.onClickImage(u, s.live_feed_images)
        }, [
          c("div", _ae, y(e.viewImageText(s)), 1)
        ], 40, yae)) : b("", !0)
      ], 10, vae)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : b("", !0)
  ], 6);
}
const wae = /* @__PURE__ */ O(hae, [["render", Cae], ["__scopeId", "data-v-f35e219d"]]), Tae = {
  name: "LF4",
  mixins: [io],
  data() {
    return {
      displayImage: "",
      displayImageAlt: ""
    };
  },
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  },
  mounted() {
    this.setDisplayImage();
  },
  methods: {
    setImage(e) {
      if (e.live_feed_images.length >= 1) {
        this.displayImage = e.live_feed_images[0].url, this.displayImageAlt = e.live_feed_images[0].alt_text;
        return;
      }
      this.setDisplayImage();
    },
    setDisplayImage() {
      var e, t, n, o, i, r;
      this.displayImage = ((n = (t = (e = this.filteredPosts[0]) == null ? void 0 : e.live_feed_images) == null ? void 0 : t[0]) == null ? void 0 : n.url) || this.fallbackImage.url, this.displayImageAlt = ((r = (i = (o = this.filteredPosts[0]) == null ? void 0 : o.live_feed_images) == null ? void 0 : i[0]) == null ? void 0 : r.alt_text) || "";
    }
  }
}, kae = { class: "LF4__container" }, Eae = ["data-testid"], Sae = { class: "LF4__posts__container-images" }, Mae = ["src", "alt"], Aae = ["onMouseover"], $ae = { class: "LF4__posts__container__post__avatar" }, Iae = ["src"], Dae = { class: "LF4__posts__container__post__info" }, Lae = { class: "live-feed-time" }, Oae = ["aria-labelledby", "aria-posinset", "aria-setsize"], Nae = ["id", "innerHTML"], Pae = ["onKeydown", "onClick"], Hae = {
  class: "button-action-content",
  tabindex: "-1"
}, Fae = { class: "LF4__posts__image" }, Rae = ["src", "alt"];
function Bae(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    id: "LF4",
    style: j(e.colors),
    class: v(e.theme.style),
    role: "feed"
  }, [
    c("div", kae, [
      c("div", {
        class: v([e.theme.style, "LF4__posts"])
      }, [
        c("div", {
          class: v(["LF4__posts__container", e.theme.style])
        }, [
          L(a, {
            class: v([e.theme.style, "see-all-top"]),
            "theme-options": e.theme
          }, {
            header: _(() => [
              e.isMonterreyStyle ? (d(), h("h3", {
                key: 0,
                "data-testid": `header-${e.theme.style}-top`
              }, [
                w(e.$slots, "header-top", {}, () => [
                  A(y(e.sectionHeaderTop), 1)
                ], !0)
              ], 8, Eae)) : b("", !0),
              (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
                "data-testid": `header-${e.theme.style}-top`
              }, {
                default: _(() => [
                  w(e.$slots, "header", {}, () => [
                    A(y(e.sectionHeader), 1)
                  ], !0)
                ]),
                _: 3
              }, 8, ["data-testid"]))
            ]),
            default: _(() => [
              e.theme.style === "bold" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
                key: 0,
                class: v(["see-all-button", e.theme.style]),
                href: e.seeAllLinkHref,
                target: e.seeAllLinkTarget,
                "data-testid": `see-all-${e.theme.style}-top`,
                onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
              }, {
                default: _(() => [
                  A(y(e.seeAllLinkName), 1)
                ]),
                _: 1
              }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
            ]),
            _: 3
          }, 8, ["class", "theme-options"]),
          c("div", Sae, [
            c("img", {
              class: "LF4__posts__container-images__image",
              src: i.displayImage,
              alt: i.displayImageAlt,
              loading: "lazy"
            }, null, 8, Mae)
          ]),
          (d(!0), h(Y, null, ee(r.filteredPosts, (s, l) => (d(), h("div", {
            key: `${l}-${s.author}-LF`,
            class: v([[e.theme.style, { "is-editing": e.isEditing }], "LF4__posts__container__post"]),
            "data-testid": "live-feed-content",
            onMouseover: (u) => r.setImage(s)
          }, [
            c("div", $ae, [
              c("img", {
                src: s.avatar,
                alt: "",
                role: "presentation"
              }, null, 8, Iae)
            ]),
            c("div", Dae, [
              c("div", {
                class: v([e.theme.style, "LF4__posts__container__post__info__time-author"])
              }, [
                A(y(s.author) + ", ", 1),
                c("span", Lae, y(s.time_ago), 1)
              ], 2),
              c("div", {
                class: v([e.theme.style, "live-feed-details"]),
                role: "article",
                tabindex: "0",
                "aria-labelledby": `LF-${s.id}`,
                "aria-posinset": l + 1,
                "aria-setsize": r.filteredPosts.length
              }, [
                c("div", {
                  id: `LF-${s.id}`,
                  class: v(["LF4__posts__container__post__info__text", e.theme.style]),
                  innerHTML: e.getPostContent(s)
                }, null, 10, Nae),
                e.isPreview || s.live_feed_images.length > 0 ? (d(), h("button", {
                  key: 0,
                  class: "view-images button-action",
                  "data-testid": "live-feed-images-button",
                  "aria-haspopup": "true",
                  onKeydown: [
                    V(z((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
                    V(z((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
                  ],
                  onClick: (u) => e.onClickImage(u, s.live_feed_images)
                }, [
                  c("div", Hae, y(e.viewImageText(s)), 1)
                ], 40, Pae)) : b("", !0)
              ], 10, Oae)
            ])
          ], 42, Aae))), 128)),
          (e.isEditing || e.posts.length > 4) && (e.theme.style !== "bold" || e.screenSize < 600) ? (d(), k(a, {
            key: 0,
            class: v([e.theme.style, "see-all-bottom"]),
            "theme-options": e.theme,
            "data-testid": "see-all-bottom"
          }, {
            default: _(() => [
              (d(), k(K(e.isEditing ? "button" : "a"), {
                class: v(["see-all-button", e.theme.style]),
                href: e.seeAllLinkHref,
                target: e.seeAllLinkTarget,
                "data-testid": `see-all-${e.theme.style}-bottom`,
                onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
              }, {
                default: _(() => [
                  A(y(e.seeAllLinkName), 1)
                ]),
                _: 1
              }, 8, ["class", "href", "target", "data-testid"]))
            ]),
            _: 1
          }, 8, ["class", "theme-options"])) : b("", !0)
        ], 2),
        c("div", Fae, [
          c("img", {
            class: "LF4__posts__image__img",
            src: i.displayImage,
            alt: i.displayImageAlt
          }, null, 8, Rae)
        ])
      ], 2)
    ])
  ], 6);
}
const Vae = /* @__PURE__ */ O(Tae, [["render", Bae], ["__scopeId", "data-v-13ae5631"]]), jae = {
  name: "LF5",
  mixins: [io],
  data() {
    return {
      active: null,
      collapsedSibling: null
    };
  },
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 3);
    }
  },
  methods: {
    setActiveCard(e) {
      this.active = e;
      const t = Math.min(window.innerWidth, document.documentElement.clientWidth);
      if (t > 600 && t < 1281 || this.isPreview && t > 1080 && t < 1441) {
        this.collapsedSibling = e === 0 ? 1 : 0;
        return;
      }
      e < 2 ? this.collapsedSibling = e + 1 : e === 2 && (this.collapsedSibling = 1);
    }
  }
}, Uae = ["data-testid"], Gae = { class: "live-feed--post-container" }, zae = ["onMouseenter"], Kae = { class: "live-feed--card-description" }, Zae = { class: "live-feed--card-description--icon" }, xae = ["src"], Wae = { class: "live-feed-time" }, qae = ["aria-labelledby", "aria-posinset", "aria-setsize"], Yae = ["id", "innerHTML"], Xae = ["onKeydown", "onClick"], Qae = {
  class: "button-action-content",
  tabindex: "-1"
}, Jae = { class: "live-feed--card-image" }, ele = ["src", "alt"];
function tle(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    id: "live-feed-lf5",
    class: v(e.theme.style),
    style: j(e.colors),
    role: "feed"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Uae)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: _(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["hide-on-xs hide-on-lg-three-cols see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Gae, [
      (d(!0), h(Y, null, ee(r.filteredPosts, (s, l) => (d(), h("div", {
        key: `${l}-${s.author}-LF`,
        class: v(["live-feed--card", [{ collapsed: l === i.collapsedSibling }, { "is-editing": e.isEditing }]]),
        "data-testid": "live-feed-content",
        onMouseenter: (u) => r.setActiveCard(l),
        onMouseleave: t[1] || (t[1] = (u) => {
          i.active = null, i.collapsedSibling = null;
        })
      }, [
        c("div", Kae, [
          c("div", Zae, [
            c("img", {
              src: s.avatar,
              alt: "",
              role: "presentation",
              loading: "lazy"
            }, null, 8, xae)
          ]),
          c("div", {
            class: v(["live-feed--card-description--header", e.theme.style])
          }, [
            c("span", null, [
              A(y(s.author) + " - ", 1),
              c("span", Wae, y(s.time_ago), 1)
            ])
          ], 2),
          c("div", {
            class: v([e.theme.style, "live-feed-details"]),
            role: "article",
            tabindex: "0",
            "aria-labelledby": `LF-${s.id}`,
            "aria-posinset": l + 1,
            "aria-setsize": r.filteredPosts.length
          }, [
            c("div", {
              id: `LF-${s.id}`,
              class: v(["live-feed--card-description--content", e.theme.style]),
              innerHTML: e.getPostContent(s, 120)
            }, null, 10, Yae),
            e.isPreview || s.live_feed_images.length > 0 ? (d(), h("button", {
              key: 0,
              class: "view-images button-action",
              "aria-haspopup": "true",
              onKeydown: [
                V(z((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
                V(z((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
              ],
              onClick: (u) => e.onClickImage(u, s.live_feed_images)
            }, [
              c("div", Qae, y(e.viewImageText(s)), 1)
            ], 40, Xae)) : b("", !0)
          ], 10, qae)
        ]),
        c("div", Jae, [
          c("img", {
            src: s.live_feed_images.length > 0 ? s.live_feed_images[0].url : e.fallbackImage.url,
            alt: s.live_feed_images.length > 0 ? s.live_feed_images[0].alt_text : "",
            loading: "lazy"
          }, null, 8, ele)
        ])
      ], 42, zae))), 128))
    ]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[2] || (t[2] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : b("", !0)
  ], 6);
}
const nle = /* @__PURE__ */ O(jae, [["render", tle], ["__scopeId", "data-v-2034cbed"]]), ole = {
  name: "LF6Buttons",
  props: {
    arrowColor: {
      type: String,
      default: "#fff"
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    borderColor: {
      type: String,
      default: "#fff"
    },
    previousSlideText: {
      type: String,
      default: ""
    },
    nextSlideText: {
      type: String,
      default: ""
    }
  }
}, rle = {
  class: "buttons",
  role: "group",
  "aria-label": "slide controls"
}, ile = ["aria-label"], sle = {
  width: "15",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ale = ["stroke"], lle = ["aria-label"], ule = {
  width: "15",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dle = ["stroke"];
function cle(e, t, n, o, i, r) {
  return d(), h("div", rle, [
    c("button", {
      class: "button",
      style: j({
        "background-color": n.backgroundColor,
        "border-color": n.borderColor
      }),
      "aria-label": n.previousSlideText,
      onClick: t[0] || (t[0] = (a) => e.$emit("scroll-left")),
      onKeyup: t[1] || (t[1] = V((a) => e.$emit("scroll-left"), ["left"]))
    }, [
      (d(), h("svg", sle, [
        c("path", {
          d: "M1 6h13M1 6l4.79 5M1 6l4.79-5",
          stroke: n.arrowColor,
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, ale)
      ]))
    ], 44, ile),
    c("button", {
      class: "button mirror",
      style: j({
        "background-color": n.backgroundColor,
        "border-color": n.borderColor
      }),
      "aria-label": n.nextSlideText,
      onClick: t[2] || (t[2] = (a) => e.$emit("scroll-right")),
      onKeyup: t[3] || (t[3] = V((a) => e.$emit("scroll-right"), ["right"]))
    }, [
      (d(), h("svg", ule, [
        c("path", {
          d: "M1 6h13M1 6l4.79 5M1 6l4.79-5",
          stroke: n.arrowColor,
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, dle)
      ]))
    ], 44, lle)
  ]);
}
const hle = /* @__PURE__ */ O(ole, [["render", cle], ["__scopeId", "data-v-0ee870d6"]]);
function mle(e, t, n) {
  var o = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var r = Array(i); ++o < i; )
    r[o] = e[o + t];
  return r;
}
var ple = mle, fle = g1, gle = ia, vle = vf, ble = Jn;
function yle(e, t, n) {
  if (!ble(n))
    return !1;
  var o = typeof t;
  return (o == "number" ? gle(n) && vle(t, n.length) : o == "string" && t in n) ? fle(n[t], e) : !1;
}
var _le = yle, Cle = Z0, v0 = 1 / 0, wle = 17976931348623157e292;
function Tle(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = Cle(e), e === v0 || e === -v0) {
    var t = e < 0 ? -1 : 1;
    return t * wle;
  }
  return e === e ? e : 0;
}
var kle = Tle, Ele = kle;
function Sle(e) {
  var t = Ele(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
var Mle = Sle, Ale = ple, $le = _le, Ile = Mle, Dle = Math.ceil, Lle = Math.max;
function Ole(e, t, n) {
  (n ? $le(e, t, n) : t === void 0) ? t = 1 : t = Lle(Ile(t), 0);
  var o = e == null ? 0 : e.length;
  if (!o || t < 1)
    return [];
  for (var i = 0, r = 0, a = Array(Dle(o / t)); i < o; )
    a[r++] = Ale(e, i, i += t);
  return a;
}
var Nle = Ole;
const Ple = /* @__PURE__ */ br(Nle), Hle = {
  name: "LF6",
  components: {
    Pager: y1,
    LFButtons: hle
  },
  mixins: [io, ut],
  props: {
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    sliderCenterSize() {
      return this.screenSize;
    },
    logoStyles() {
      return {
        "--logo-url": `url(${this.logo})`
      };
    },
    nextSlideText() {
      var e;
      return ((e = this.theme.translations) == null ? void 0 : e.next_slide) || "Next slide";
    },
    previousSlideText() {
      var e;
      return ((e = this.theme.translations) == null ? void 0 : e.previous_slide) || "Previous slide";
    },
    content() {
      return Ple(this.posts, 3);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    getGalleryType(e) {
      const t = e.live_feed_images.length;
      return t > 4 ? "cols-4 overflow" : `cols-${t}`;
    },
    goToCard(e) {
      this.currentCard = e - 1, this.calculateScroll();
    },
    handleFocusChange(e) {
      e !== this.currentCard && (this.currentCard = e, this.calculateScroll());
    },
    setCardHeight() {
      if (this.isEditing)
        return;
      this.$refs.scrollWrapper.style.minHeight = "auto";
      const e = Math.max(
        ...Array.from(this.content.length).map((n, o) => this.$refs[`sliderCard-${o}`].offsetHeight)
      ), t = this.content.length <= 2 ? 48 : 0;
      this.$refs.scrollWrapper.style.minHeight = `${e + t}px`;
    }
  }
}, Fle = ["data-testid"], Rle = ["data-testid"], Ble = { class: "controls" }, Vle = ["aria-label"], jle = ["id", "aria-label", "onFocusin"], Ule = ["id"], Gle = { class: "header" }, zle = ["src"], Kle = { class: "time-author" }, Zle = ["aria-labelledby", "aria-posinset", "aria-setsize"], xle = ["id", "innerHTML"], Wle = ["data-see-more", "aria-label", "onClick"], qle = ["src"];
function Yle(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("LFButtons"), l = $("Pager");
  return d(), h("div", {
    id: "LF6",
    class: v([e.theme.style, { "is-editing": e.isEditing }]),
    style: j(e.colors),
    "data-testid": "lf6",
    role: "feed"
  }, [
    L(a, {
      class: v(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, Rle)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.sectionHeader), 1)
          ], !0)
        ], 8, Fle)
      ]),
      default: _(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": "see-all-bold-top",
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: "slider-container",
      style: j(r.logoStyles)
    }, [
      c("div", Ble, [
        L(a, {
          class: v(e.theme.style),
          "theme-options": e.theme,
          "data-testid": "lf-link"
        }, {
          default: _(() => [
            e.theme.style !== "bold" || e.screenSize <= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
              key: 0,
              class: v([e.theme.style, "see-all-button"]),
              href: e.seeAllLinkHref,
              target: e.seeAllLinkTarget,
              "data-testid": `see-all-${e.theme.style}-button`,
              onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
            }, {
              default: _(() => [
                A(y(e.seeAllLinkName), 1)
              ]),
              _: 1
            }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
          ]),
          _: 1
        }, 8, ["class", "theme-options"]),
        c("div", {
          "aria-label": e.sectionHeader,
          role: "region",
          "aria-roledescription": "carousel",
          class: "control-actions-wrapper"
        }, [
          L(s, {
            "arrow-color": e.theme.arrow_icon_color.hex,
            "background-color": e.theme.arrow_background_color.hex,
            "border-color": e.theme.arrow_border_color.hex,
            "previous-slide-text": r.previousSlideText,
            "next-slide-text": r.nextSlideText,
            onScrollLeft: e.scrollLeft,
            onScrollRight: e.scrollRight
          }, null, 8, ["arrow-color", "background-color", "border-color", "previous-slide-text", "next-slide-text", "onScrollLeft", "onScrollRight"]),
          L(l, {
            "total-cards": r.content.length,
            "pager-color": e.theme.pager_color.hex,
            "theme-styles": e.theme,
            "current-card": e.currentCard,
            "pager-section-count": r.content.length,
            class: "pager",
            onGoToSection: r.goToCard
          }, null, 8, ["total-cards", "pager-color", "theme-styles", "current-card", "pager-section-count", "onGoToSection"])
        ], 8, Vle)
      ]),
      c("div", {
        ref: "scrollWrapper",
        class: v(["slider", { "is-editing": e.isEditing }])
      }, [
        (d(!0), h(Y, null, ee(r.content, (u, m) => (d(), h("div", {
          id: `slide-${m}`,
          key: m,
          ref_for: !0,
          ref: `sliderCard-${m}`,
          class: v(`slide slide-${m} ${m === e.currentCard && "active"}`),
          "aria-label": `${m + 1} of ${r.content.length}`,
          "data-testid": "live-feed-content",
          role: "group",
          "aria-roledescription": "slide",
          onFocusin: (g) => r.handleFocusChange(m)
        }, [
          (d(!0), h(Y, null, ee(u, (g, p) => (d(), h("div", {
            id: p,
            key: p,
            class: "post"
          }, [
            c("div", Gle, [
              c("img", {
                src: g.avatar,
                class: "avatar",
                alt: "",
                role: "presentation",
                loading: "lazy"
              }, null, 8, zle),
              c("span", Kle, y(g.author) + " | " + y(g.time_ago), 1)
            ]),
            c("div", {
              class: "details",
              role: "article",
              tabindex: "0",
              "aria-labelledby": `LF-${g.id}`,
              "aria-posinset": p + 1,
              "aria-setsize": u.length
            }, [
              c("div", {
                id: `LF-${g.id}`,
                class: "post-content",
                innerHTML: e.getPostContent(g, 200)
              }, null, 8, xle),
              g.live_feed_images.length ? (d(), h("div", {
                key: 0,
                class: v(["gallery", r.getGalleryType(g)])
              }, [
                (d(!0), h(Y, null, ee(g.live_feed_images, (T, M) => (d(), h("button", {
                  key: `gallery-item-${M}`,
                  "data-see-more": g.live_feed_images.length > 4 && `+ ${g.live_feed_images.length - 4}`,
                  "aria-label": e.translations.open_image_in_modal,
                  class: "gallery-item",
                  onClick: (C) => e.onClickImage(C, g.live_feed_images)
                }, [
                  c("img", {
                    class: "gallery-image",
                    src: T.url,
                    alt: "",
                    loading: "lazy"
                  }, null, 8, qle)
                ], 8, Wle))), 128))
              ], 2)) : b("", !0)
            ], 8, Zle)
          ], 8, Ule))), 128))
        ], 42, jle))), 128))
      ], 2)
    ], 4)
  ], 6);
}
const Xle = /* @__PURE__ */ O(Hle, [["render", Yle], ["__scopeId", "data-v-0723837b"]]), Qle = {
  name: "LF7",
  components: { CardSlider: Jt },
  mixins: [io, ut],
  computed: {
    content() {
      return this.posts.slice(0, 12);
    },
    sliderCenterSize() {
      return 599;
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    }
  },
  methods: {
    extraImagesContent(e) {
      return e.live_feed_images.length > 4 ? `+ ${e.live_feed_images.length - 3}` : "";
    },
    backgroundImage(e, t) {
      return {
        backgroundImage: `url("${e.live_feed_images[t].url}")`
      };
    }
  }
}, Jle = ["data-testid"], e1e = ["data-testid"], t1e = ["aria-label"], n1e = { class: "post live-feed-details" }, o1e = { class: "post-info" }, r1e = ["src"], i1e = { class: "author" }, s1e = { class: "time-ago" }, a1e = ["id", "innerHTML"], l1e = { class: "thumbnails-wrapper" }, u1e = ["aria-label", "data-before", "data-testid", "onClick"];
function d1e(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("CardSlider");
  return d(), h("div", {
    class: v(["live-feed-lf7", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: j(e.colors),
    "data-testid": "lf7"
  }, [
    L(a, {
      class: v(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          r.isMonterreyStyle ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, e1e)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.sectionHeader), 1)
          ], !0)
        ], 8, Jle)
      ]),
      default: _(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    L(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      class: v({ "is-editing": e.isEditing }),
      "pager-section-count": e.pagerSectionCount,
      "total-cards": r.content.length,
      "theme-styles": e.theme,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: _(() => [
        c("div", {
          ref: "scrollWrapper",
          class: v(["posts-wrapper", { "all-cards-visible": e.allCardsVisible }])
        }, [
          (d(!0), h(Y, null, ee(r.content, (l, u) => (d(), h("div", {
            key: `${l}-${u}`,
            ref_for: !0,
            ref: `sliderCard-${u}`,
            class: v(["card-content", `card-${u}`]),
            "data-testid": "live-feed-content",
            "aria-label": `${u + 1} of ${r.content.length}`,
            role: "group",
            "aria-roledescription": "slide"
          }, [
            c("div", n1e, [
              c("div", o1e, [
                c("img", {
                  src: l.avatar,
                  role: "presentation",
                  loading: "lazy"
                }, null, 8, r1e),
                c("div", i1e, y(l.author), 1),
                t[2] || (t[2] = c("span", null, "|", -1)),
                c("div", s1e, y(l.time_ago), 1)
              ]),
              c("div", {
                id: `LF-${l.id}`,
                class: "post-status",
                innerHTML: e.getPostContent(l)
              }, null, 8, a1e),
              c("div", l1e, [
                (d(!0), h(Y, null, ee(l.live_feed_images.slice(0, 4), (m, g) => (d(), h("button", {
                  key: m.id + g,
                  class: "live-feed-image-thumbnail",
                  "aria-label": e.translations.open_image_in_modal,
                  "data-before": r.extraImagesContent(l),
                  style: j(r.backgroundImage(l, g)),
                  "data-testid": `live-feed-images-button-${g}`,
                  onClick: (p) => e.$emit("openLightbox", { images: l.live_feed_images, idx: g })
                }, null, 12, u1e))), 128))
              ])
            ])
          ], 10, t1e))), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "class", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : b("", !0)
  ], 6);
}
const c1e = /* @__PURE__ */ O(Qle, [["render", d1e], ["__scopeId", "data-v-7551fe7e"]]), h1e = {
  name: "ImageGallery",
  props: {
    images: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      activeItem: 0
    };
  },
  methods: {
    activateItem(e) {
      this.activeItem = e;
    },
    activateNext() {
      let e = this.activeItem + 1;
      e >= this.images.length && (e = 0), this.activeItem = e;
    },
    activatePrev() {
      let e = this.activeItem - 1;
      e < 0 && (e = this.images.length - 1), this.activeItem = e;
    },
    handleImageClick(e) {
      this.$emit("image-click", { e });
    }
  }
}, m1e = {
  class: "image-gallery",
  "data-testid": "image-gallery"
}, p1e = {
  key: 0,
  class: "gallery-image"
}, f1e = ["src", "alt"], g1e = {
  key: 0,
  class: "gallery-controls"
}, v1e = { class: "indicators" }, b1e = {
  class: "buttons",
  role: "group",
  "aria-label": "slide controls"
};
function y1e(e, t, n, o, i, r) {
  return d(), h("div", m1e, [
    c("div", {
      class: "gallery-track",
      onClick: t[0] || (t[0] = (a) => r.handleImageClick(a))
    }, [
      t[3] || (t[3] = c("div", {
        class: "gallery-overlay",
        "data-testid": "gallery-overlay"
      }, null, -1)),
      (d(!0), h(Y, null, ee(n.images, (a, s) => (d(), h("div", {
        key: a.id + s,
        class: v(["gallery-slide", i.activeItem === s && "is-active"]),
        "data-testid": "gallery-slide"
      }, [
        a.url ? (d(), h("div", p1e, [
          c("img", {
            src: a.url,
            alt: a.alt_text
          }, null, 8, f1e)
        ])) : b("", !0)
      ], 2))), 128))
    ]),
    n.images.length > 1 ? (d(), h("div", g1e, [
      c("div", v1e, y(i.activeItem + 1) + " / " + y(n.images.length), 1),
      c("div", b1e, [
        c("button", {
          class: "button left",
          "aria-label": "button prev",
          onClick: t[1] || (t[1] = (...a) => r.activatePrev && r.activatePrev(...a))
        }, t[4] || (t[4] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ])),
        c("button", {
          class: "button right",
          "aria-label": "button next",
          onClick: t[2] || (t[2] = (...a) => r.activateNext && r.activateNext(...a))
        }, t[5] || (t[5] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]))
      ])
    ])) : b("", !0)
  ]);
}
const _1e = /* @__PURE__ */ O(h1e, [["render", y1e], ["__scopeId", "data-v-49126e1d"]]), C1e = {
  name: "LF8",
  components: { Slider: Eu, ImageGallery: _1e },
  mixins: [io, ut],
  computed: {
    content() {
      return this.posts;
    },
    sliderCenterSize() {
      return 599;
    },
    cssVars() {
      var e, t;
      return he(ie({}, this.colors), {
        "--percentage-button-opacity": `${(e = this.theme.percentage_button_opacity) != null ? e : 0}%`,
        "--image-gradient-color": S(this.theme, "image_gradient_color.hex", "#000000"),
        "--image-gradient-opacity": `${(t = this.theme.image_gradient_opacity) != null ? t : 80}%`,
        "--indicators-color": S(this.theme, "indicators_color.hex", "#FFFFFF"),
        "--arrow-color": S(this.theme, "arrow_color.hex", "#FFFFFF"),
        "--button-border-color": S(this.theme, "button_border_color.hex", "#FFFFFF")
      });
    }
  }
}, w1e = { class: "wrapper" }, T1e = ["data-testid"], k1e = ["data-testid"], E1e = { class: "button-text" }, S1e = {
  ref: "scrollWrapper",
  class: "cards-wrapper"
}, M1e = ["aria-label"], A1e = ["aria-labelledby", "aria-posinset", "aria-setsize"], $1e = { class: "card-header" }, I1e = ["src"], D1e = { class: "author" }, L1e = { class: "time-ago" }, O1e = ["id", "innerHTML"], N1e = {
  key: 0,
  class: "card-gallery"
}, P1e = {
  class: "buttons-container",
  role: "group",
  "aria-label": "slide controls"
}, H1e = { class: "button-text" };
function F1e(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("ImageGallery"), l = $("Slider");
  return d(), h("div", {
    class: v(["live-feed-lf8", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: j(r.cssVars),
    "data-testid": "lf8",
    role: "feed"
  }, [
    c("div", w1e, [
      L(a, {
        class: v(["see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: _(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (d(), h("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              w(e.$slots, "header-top", {}, () => [
                A(y(e.sectionHeaderTop), 1)
              ], !0)
            ], 8, k1e)) : b("", !0),
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ], 8, T1e)
        ]),
        default: _(() => [
          e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
            key: 0,
            class: v(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
          }, {
            default: _(() => [
              c("div", E1e, y(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      L(l, {
        "current-card": e.currentCard,
        class: v(["slider", { "is-editing": e.isEditing }]),
        "total-cards": r.content.length,
        "theme-styles": e.theme,
        "section-header": e.sectionHeader,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        "button-left": _(() => [
          c("button", {
            class: "slider-button left",
            "aria-label": "button prev",
            onKeyup: t[1] || (t[1] = V((...u) => e.scrollLeft && e.scrollLeft(...u), ["left"])),
            onClick: t[2] || (t[2] = (...u) => e.scrollLeft && e.scrollLeft(...u))
          }, t[10] || (t[10] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 32)
        ]),
        "button-right": _(() => [
          c("button", {
            class: "slider-button right",
            "aria-label": "button next",
            onKeyup: t[3] || (t[3] = V((...u) => e.scrollRight && e.scrollRight(...u), ["right"])),
            onClick: t[4] || (t[4] = (...u) => e.scrollRight && e.scrollRight(...u))
          }, t[11] || (t[11] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 32)
        ]),
        default: _(() => [
          c("div", S1e, [
            (d(!0), h(Y, null, ee(r.content, (u, m) => (d(), h("div", {
              key: `${u}-${m}`,
              ref_for: !0,
              ref: `sliderCard-${m}`,
              class: v(["card", `card-${m}`]),
              "data-testid": "live-feed-content",
              "aria-label": `${m + 1} of ${r.content.length}`,
              role: "group",
              "aria-roledescription": "slide"
            }, [
              c("div", {
                class: "card-content",
                role: "article",
                tabindex: "0",
                "aria-labelledby": `LF-${u.id}`,
                "aria-posinset": m + 1,
                "aria-setsize": r.content.length
              }, [
                c("div", $1e, [
                  c("img", {
                    src: u.avatar,
                    role: "presentation",
                    loading: "lazy"
                  }, null, 8, I1e),
                  c("div", D1e, y(u.author), 1),
                  c("div", L1e, y(u.time_ago), 1)
                ]),
                c("div", {
                  id: `LF-${u.id}`,
                  class: "card-description",
                  innerHTML: e.getPostContent(u)
                }, null, 8, O1e)
              ], 8, A1e),
              u.live_feed_images.length >= 1 && e.screenSize > 600 ? (d(), h("div", N1e, [
                L(s, {
                  images: u.live_feed_images,
                  onImageClick: (g) => e.onClickImage(g, u.live_feed_images)
                }, null, 8, ["images", "onImageClick"])
              ])) : b("", !0)
            ], 10, M1e))), 128))
          ], 512)
        ]),
        _: 1
      }, 8, ["current-card", "class", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft"]),
      c("div", P1e, [
        c("button", {
          class: "slider-button left",
          "aria-label": "button prev",
          onKeyup: t[5] || (t[5] = V((...u) => e.scrollLeft && e.scrollLeft(...u), ["left"])),
          onClick: t[6] || (t[6] = (...u) => e.scrollLeft && e.scrollLeft(...u))
        }, t[12] || (t[12] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]), 32),
        c("button", {
          class: "slider-button right",
          "aria-label": "button next",
          onKeyup: t[7] || (t[7] = V((...u) => e.scrollRight && e.scrollRight(...u), ["right"])),
          onClick: t[8] || (t[8] = (...u) => e.scrollRight && e.scrollRight(...u))
        }, t[13] || (t[13] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]), 32)
      ]),
      e.theme.style === "purple" || e.screenSize < 600 ? (d(), k(a, {
        key: 0,
        class: v([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.theme.style}-bottom`
      }, {
        default: _(() => [
          (d(), k(K(e.isEditing ? "button" : "a"), {
            class: v(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[9] || (t[9] = (u) => e.$emit("open-modal"))
          }, {
            default: _(() => [
              c("div", H1e, y(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : b("", !0)
    ])
  ], 6);
}
const R1e = /* @__PURE__ */ O(C1e, [["render", F1e], ["__scopeId", "data-v-45fd8393"]]), B1e = {
  name: "LiveFeed",
  components: {
    LF1: eae,
    LF2: cae,
    LF3: wae,
    LF4: Vae,
    LF5: nle,
    LF6: Xle,
    LF7: c1e,
    LF8: R1e
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    fallbackImage: {
      type: Object,
      default: () => {
      }
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    livefeedConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: Boolean,
    logo: {
      type: String,
      default: ""
    }
  },
  methods: {
    openLightbox(e) {
      this.$emit("toggleLightbox", e);
    },
    saveFocusElement(e) {
      this.$emit("savePrevFocusedElem", e);
    }
  }
}, V1e = { id: "cms-live-feed" };
function j1e(e, t, n, o, i, r) {
  return d(), h("div", V1e, [
    (d(), k(K(n.theme.version), {
      theme: n.theme,
      posts: n.content,
      "livefeed-config": n.livefeedConfig,
      "component-id": n.componentId,
      "fallback-image": n.fallbackImage,
      "path-prefix": n.pathPrefix,
      "is-preview": n.isPreview,
      "is-i-frame": n.isIFrame,
      "is-editing": n.isEditing,
      logo: n.logo,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal")),
      onSaveFocusElement: t[1] || (t[1] = (a) => r.saveFocusElement(a)),
      onOpenLightbox: t[2] || (t[2] = (a) => r.openLightbox(a))
    }, {
      "header-top": _(() => [
        w(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: _(() => [
        w(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "posts", "livefeed-config", "component-id", "fallback-image", "path-prefix", "is-preview", "is-i-frame", "is-editing", "logo"]))
  ]);
}
const U1e = /* @__PURE__ */ O(B1e, [["render", j1e], ["__scopeId", "data-v-cf483d17"]]), Fi = {
  mixins: [mt],
  components: { DraggableWrapper: at },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    stats: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    isPreview: Boolean
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors(), t = e["--heading-color"];
      return he(ie({}, e), {
        "--accent-color": S(this.theme, "accent_color.hex", "#FFF"),
        "--arrow-color": S(this.theme, "arrow_icon_color.hex", "#FFF"),
        "--card-bg-color": S(this.theme, "card_bg_color.hex", t),
        "--card-2-bg-color": S(this.theme, "card_2_bg_color.hex", "#FCD40B"),
        "--card-3-bg-color": S(this.theme, "card_3_bg_color.hex", "#131313"),
        "--card-border-color": S(this.theme, "card_border_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--card-top-border": S(this.theme, "card_top_border.hex", t),
        "--color": S(this.theme, "color.hex", t),
        "--color-2": S(this.theme, "color_2.hex", t),
        "--color-3": S(this.theme, "color_3.hex", t),
        "--description-color": S(this.theme, "description_color.hex", t),
        "--headline-color": S(this.theme, "headline_color.hex", "#FFF"),
        "--icon-bg-color": S(this.theme, "icon_bg_color.hex", t),
        "--icon-color": S(this.theme, "icon_color.hex", t),
        "--link-color": S(this.theme, "link_color.hex", "#FFF"),
        "--link-hover-color": S(this.theme, "link_hover_color.hex", "#FFF"),
        "--snippet-color": S(this.theme, "snippet_color.hex", "#333"),
        "--stats-header-color": S(this.theme, "stats_header_color.hex", "#FFF"),
        "--stats-slider-header-width": this.stats.headline && this.stats.slider ? "calc(100%/3 - 16px)" : "calc(25% - 18px)"
      });
    },
    translations() {
      return this.theme.translations;
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.stats.component_header_top || this.isEditing);
    },
    backgroundStyle() {
      var t, n;
      if (!((t = this.stats.bg_image) != null && t.url) || !this.theme.show_background_image) return null;
      const e = `${this.theme.bg_color.hex}e6`;
      return {
        backgroundImage: `linear-gradient(${e}, ${e}), url(${((n = this.stats.bg_image) == null ? void 0 : n.url) || ""})`,
        backgroundSize: "cover",
        backgroundPosition: "center center"
      };
    }
  }
}, G1e = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, z1e = {
  width: "22",
  height: "32",
  viewBox: "0 0 22 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, K1e = ["fill"];
function Z1e(e, t, n, o, i, r) {
  return d(), h("svg", z1e, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17 20.2059V30.9971C17 31.3818 16.779 31.7315 16.434 31.8988C16.296 31.9639 16.148 31.997 16 31.997C15.777 31.997 15.556 31.9219 15.375 31.7776L11 28.278L6.625 31.7776C6.324 32.018 5.915 32.0631 5.566 31.8988C5.221 31.7315 5 31.3818 5 30.9971V20.2059C1.994 18.2402 0 14.8498 0 10.9986C0 4.93325 4.935 0 11 0C17.065 0 22 4.93325 22 10.9986C22 14.8498 20.006 18.2402 17 20.2059ZM7 28.9162L10.375 26.2172C10.74 25.9246 11.26 25.9246 11.625 26.2172L15 28.9162V21.2338C13.758 21.7207 12.412 21.9982 11 21.9982C9.588 21.9982 8.242 21.7207 7 21.2338V28.9162ZM11 1.99875C6.037 1.99875 2 6.03632 2 10.9986C2 15.9599 6.037 19.9975 11 19.9975C15.963 19.9975 20 15.9599 20 10.9986C20 6.03632 15.963 1.99875 11 1.99875ZM13 15.998H9C8.447 15.998 8 15.5502 8 14.9981C8 14.4461 8.447 13.9982 9 13.9982H10V9.41265L8.707 10.7051C8.512 10.9014 8.256 10.9986 8 10.9986C7.744 10.9986 7.488 10.9014 7.293 10.7051C6.902 10.3153 6.902 9.68215 7.293 9.29142L10.292 6.2928C10.385 6.19962 10.495 6.12649 10.618 6.07539C10.733 6.0283 10.855 6.00626 10.977 6.00326C10.985 6.00326 10.992 5.99825 11 5.99825C11.007 5.99825 11.012 6.00225 11.019 6.00225C11.143 6.00526 11.266 6.0283 11.382 6.07539C11.627 6.17758 11.822 6.37195 11.923 6.61741C11.973 6.73863 12 6.86788 12 6.99712C12 6.99812 12 6.99812 12 6.99912V13.9982H13C13.553 13.9982 14 14.4461 14 14.9981C14 15.5502 13.553 15.998 13 15.998Z",
      fill: n.color
    }, null, 8, K1e)
  ]);
}
const x1e = /* @__PURE__ */ O(G1e, [["render", Z1e]]), W1e = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, q1e = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Y1e = ["fill"];
function X1e(e, t, n, o, i, r) {
  return d(), h("svg", q1e, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 32C7.178 32 0 24.823 0 16C0 7.178 7.178 0 16 0C24.822 0 32 7.178 32 16C32 24.823 24.822 32 16 32ZM4.948 24.542C6.752 22.358 7.753 19.708 7.951 17H2.048C2.25 19.832 3.307 22.425 4.948 24.542ZM7.95 15C7.753 12.293 6.751 9.643 4.946 7.46C3.306 9.577 2.25 12.169 2.048 15H7.95ZM15 2.051C11.622 2.291 8.579 3.739 6.286 5.957C8.517 8.548 9.737 11.741 9.944 15H15V2.051ZM15 17H9.945C9.738 20.259 8.518 23.453 6.288 26.045C8.581 28.262 11.623 29.709 15 29.949V17ZM29.952 17H24.049C24.247 19.708 25.249 22.358 27.053 24.541C28.693 22.424 29.75 19.832 29.952 17ZM17 29.949C20.378 29.709 23.42 28.261 25.713 26.044C23.483 23.452 22.262 20.259 22.055 17H17V29.949ZM17 2.051V15H22.055C22.262 11.741 23.483 8.548 25.713 5.956C23.42 3.739 20.378 2.291 17 2.051ZM27.053 7.458C25.249 9.643 24.247 12.293 24.049 15H29.952C29.75 12.168 28.693 9.576 27.053 7.458Z",
      fill: n.color
    }, null, 8, Y1e)
  ]);
}
const Q1e = /* @__PURE__ */ O(W1e, [["render", X1e]]), J1e = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, eue = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tue = ["fill"];
function nue(e, t, n, o, i, r) {
  return d(), h("svg", eue, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30 26H26.85L29.8 30.45C30.1 30.9 30 31.55 29.5 31.85C29.4 31.95 29.2 32 29 32C28.7 32 28.35 31.85 28.15 31.55L24.45 26H17V30C17 30.55 16.55 31 16 31C15.45 31 15 30.55 15 30V26H7.55L3.85 31.55C3.65 31.85 3.3 32 3 32C2.8 32 2.6 31.95 2.45 31.85C2 31.55 1.85 30.9 2.15 30.45L5.1 26H2C0.9 26 0 25.1 0 24V6C0 4.9 0.9 4 2 4H15V1C15 0.45 15.45 0 16 0C16.55 0 17 0.45 17 1V4H30C31.1 4 32 4.9 32 6V24C32 25.1 31.1 26 30 26ZM30 24V10H2V24H30ZM2 6V8H30V6H2Z",
      fill: n.color
    }, null, 8, tue)
  ]);
}
const oue = /* @__PURE__ */ O(J1e, [["render", nue]]), rue = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, iue = {
  width: "28",
  height: "32",
  viewBox: "0 0 28 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sue = ["fill"];
function aue(e, t, n, o, i, r) {
  return d(), h("svg", iue, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M27 29V31C27 31.552 26.553 32 26 32H20C19.447 32 19 31.552 19 31V29H9V31C9 31.552 8.553 32 8 32H2C1.447 32 1 31.552 1 31V29C0.447 29 0 28.552 0 28V3C0 1.346 1.346 0 3 0H25C26.654 0 28 1.346 28 3V28C28 28.552 27.553 29 27 29ZM21 30H25V29H21V30ZM3 30H7V29H3V30ZM26 3C26 2.449 25.552 2 25 2H3C2.448 2 2 2.449 2 3V7H26V3ZM26 9H2V17H26V9ZM26 19H2V27H26V19ZM6 21C7.102 21 8 21.897 8 23C8 24.103 7.102 25 6 25C4.897 25 4 24.103 4 23C4 21.897 4.897 21 6 21ZM22 21C23.102 21 24 21.897 24 23C24 24.103 23.102 25 22 25C20.897 25 20 24.103 20 23C20 21.897 20.897 21 22 21Z",
      fill: n.color
    }, null, 8, sue)
  ]);
}
const lue = /* @__PURE__ */ O(rue, [["render", aue]]), uue = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, due = {
  width: "26",
  height: "32",
  viewBox: "0 0 26 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cue = ["fill"];
function hue(e, t, n, o, i, r) {
  return d(), h("svg", due, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25.4203 27C26.0792 28.25 26.1806 29.5 25.623 30.45C25.0149 31.45 23.8492 32 22.3794 32H3.62695C2.15716 32 0.940789 31.45 0.383285 30.45C-0.17422 29.5 -0.123538 28.25 0.535331 27L7.98562 13.8V2C7.42812 2 6.97198 1.55 6.97198 1C6.97198 0.45 7.42812 0 7.98562 0H17.97C18.5275 0 18.9837 0.45 18.9837 1C18.9837 1.5 18.5782 1.9 18.1221 2V14L25.4203 27ZM13.0032 7H10.0129V9H13.0032C13.5607 9 14.0168 9.45 14.0168 10C14.0168 10.55 13.5607 11 13.0032 11H10.0129V14.05V14.1C10.0129 14.15 10.0129 14.25 9.96223 14.3C9.96223 14.35 9.91155 14.45 9.91155 14.5V14.55L2.30921 27.95C2.00512 28.55 1.90375 29.05 2.10648 29.4C2.30921 29.75 2.86672 30 3.62695 30H22.3794C23.1396 30 23.6971 29.8 23.8999 29.4C24.1026 29.05 24.0519 28.55 23.6971 27.95L16.0948 14.5C15.9427 14.2 15.9427 13.9 16.0441 13.6V2H9.96223V5H12.9525C13.51 5 13.9661 5.45 13.9661 6C13.9661 6.55 13.5607 7 13.0032 7Z",
      fill: n.color
    }, null, 8, cue)
  ]);
}
const mue = /* @__PURE__ */ O(uue, [["render", hue]]), pue = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, fue = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gue = ["fill"];
function vue(e, t, n, o, i, r) {
  return d(), h("svg", fue, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.7909 3.612L21.9725 16.317L28.6932 23.037C28.6932 23.037 28.6932 23.038 28.6942 23.038L28.6992 23.043C28.7464 23.091 28.7705 23.151 28.8066 23.205C28.8428 23.259 28.89 23.304 28.9151 23.367L28.9181 23.373C28.9181 23.373 28.9181 23.374 28.9191 23.374L31.9235 30.617C32.0791 30.991 31.9927 31.421 31.7066 31.707C31.5148 31.898 31.2597 32 30.9997 32C30.8711 32 30.7396 31.975 30.6171 31.924L23.3753 28.919C23.3743 28.919 23.3733 28.918 23.3712 28.918L23.3672 28.916C23.314 28.894 23.2769 28.853 23.2307 28.824C23.1664 28.784 23.0981 28.755 23.0429 28.699L23.0379 28.695C23.0369 28.694 23.0369 28.694 23.0369 28.693L17.0412 22.698L14.9907 25.352C15.0731 26.699 14.6272 28.048 13.6452 29.203C12.154 30.957 9.70396 32 7.08116 32C7.05706 32 7.03397 32 7.00987 32C4.68529 31.983 2.29847 30.807 0.291199 28.688C0.0100414 28.391 -0.0622564 27.953 0.109451 27.582C0.27915 27.211 0.648671 26.981 1.0674 27.001C3.7394 27.136 4.02256 26.17 4.49652 24.571C4.7114 23.846 4.95541 23.024 5.47354 22.316C6.48972 20.928 8.0622 20.064 9.57041 20L11.8779 17.572L1.29132 6.95C1.26923 6.927 1.26119 6.898 1.24111 6.873C1.21902 6.855 1.19291 6.848 1.17283 6.828C0.416716 6.074 0.00100414 5.069 0 4.001C0 2.933 0.415712 1.928 1.17183 1.171C1.92693 0.416 2.93107 0 3.99947 0C5.06787 0 6.07301 0.416 6.82812 1.171C6.84921 1.193 6.85724 1.222 6.87632 1.245C6.89941 1.264 6.92753 1.272 6.94861 1.293L17.4077 11.751L28.2754 0.311C28.4632 0.112 28.7253 0 28.9994 0C30.5418 0 31.9998 1.458 31.9998 3C31.9998 3.221 31.9265 3.436 31.7909 3.612ZM29.149 29.15L27.6408 25.515L25.5141 27.642L29.149 29.15ZM23.7498 26.578L26.5774 23.75L20.7404 17.912L18.2743 21.103L23.7498 26.578ZM7.08718 23.497C6.7749 23.925 6.59917 24.516 6.41341 25.141C6.02481 26.452 5.52475 28.132 3.42611 28.761C4.60095 29.561 5.83503 29.991 7.02392 30C7.043 30 7.06309 30 7.08216 30C9.12558 30 11.0053 29.22 12.1219 27.908C12.7756 27.139 13.0708 26.265 13.0035 25.418L9.60556 22.02C8.6938 22.064 7.74088 22.604 7.08718 23.497ZM5.53479 2.707C5.5127 2.685 5.50567 2.657 5.48559 2.633C5.4635 2.614 5.43538 2.607 5.41329 2.585C4.65818 1.83 3.34176 1.83 2.58565 2.586C2.20809 2.964 1.99923 3.466 1.99923 4.001C1.99923 4.534 2.20809 5.036 2.58464 5.413C2.60774 5.436 2.61577 5.466 2.63686 5.491C2.65895 5.509 2.68707 5.517 2.70715 5.538L3.99746 6.832L6.82812 4L5.53479 2.707ZM8.24194 5.414L5.40928 8.248L13.2556 16.121L16.03 13.201L8.24194 5.414ZM29.3428 2.092L11.3959 20.982L13.9033 23.489L29.9423 2.733C29.8369 2.474 29.5979 2.222 29.3428 2.092Z",
      fill: n.color
    }, null, 8, gue)
  ]);
}
const bue = /* @__PURE__ */ O(pue, [["render", vue]]), yue = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, _ue = {
  width: "32",
  height: "26",
  viewBox: "0 0 32 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cue = ["fill"];
function wue(e, t, n, o, i, r) {
  return d(), h("svg", _ue, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31 21.9873H29C28.447 21.9873 28 21.5398 28 20.9872C28 20.4366 28.447 19.989 29 19.989H30V2.00429H2V20.0531H15C15.553 20.0531 16 20.4366 16 20.9872C16 21.5398 15.553 21.9873 15 21.9873H1C0.447 21.9873 0 21.5398 0 20.9872V1.00513C0 0.453498 0.447 0.00598145 1 0.00598145H31C31.553 0.00598145 32 0.453498 32 1.00513V20.9872C32 21.5398 31.553 21.9873 31 21.9873ZM22 10.9957C24.757 10.9957 27 13.2372 27 15.9924C27 17.1097 26.618 18.1319 25.995 18.9649C25.995 18.9739 26 18.9809 26 18.9899V24.9848C26 25.3522 25.797 25.6916 25.472 25.8658C25.324 25.9449 25.162 25.984 25 25.984C24.806 25.984 24.612 25.9279 24.445 25.8158L22 24.1869L19.555 25.8158C19.249 26.02 18.853 26.04 18.528 25.8658C18.203 25.6916 18 25.3522 18 24.9848V18.9899C18 18.9809 18.005 18.9739 18.005 18.9649C17.382 18.1319 17 17.1097 17 15.9924C17 13.2372 19.243 10.9957 22 10.9957ZM22 12.995C20.346 12.995 19 14.3395 19 15.9924C19 17.6453 20.346 18.9899 22 18.9899C23.654 18.9899 25 17.6453 25 15.9924C25 14.3395 23.654 12.995 22 12.995ZM21.445 22.1545C21.781 21.9313 22.219 21.9313 22.555 22.1545L24 23.1176V20.5647C23.386 20.833 22.712 20.9872 22 20.9872C21.288 20.9872 20.613 20.833 20 20.5647V23.1176L21.445 22.1545ZM15 10.0416C15.553 10.0416 16 10.445 16 10.9957C16 11.5483 15.553 11.9958 15 11.9958H9C8.447 11.9958 8 11.5483 8 10.9957C8 10.445 8.447 10.0416 9 10.0416H15ZM5 7.9992C4.447 7.9992 4 7.55169 4 7.00005C4 6.44841 4.447 6.03694 5 6.03694H27C27.553 6.03694 28 6.44841 28 7.00005C28 7.55169 27.553 7.9992 27 7.9992H5Z",
      fill: n.color
    }, null, 8, Cue)
  ]);
}
const Tue = /* @__PURE__ */ O(yue, [["render", wue]]), kue = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Eue = {
  width: "25",
  height: "33",
  viewBox: "0 0 25 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sue = ["fill"];
function Mue(e, t, n, o, i, r) {
  return d(), h("svg", Eue, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.55567 0C4.69663 0 3.998 0.699099 3.998 1.55839V26.8914C3.998 27.7516 4.69685 28.4492 5.55567 28.4492H22.8797C23.7392 28.4492 24.4373 27.7515 24.4373 26.8914L24.4507 9.09668C24.4507 9.07071 24.4543 9.04756 24.4507 9.02997V9.01535C24.4581 8.98566 24.4507 8.94257 24.4507 8.8917C24.4507 8.59877 24.3093 8.33899 24.0918 8.17674L16.1802 0.260977C15.9739 0.0561669 15.7006 0.00255148 15.4538 0.0325386C15.4031 0.0178254 15.331 0 15.2543 0H5.55567ZM5.7807 26.6664L5.78397 1.74266H14.6593V8.8917C14.6593 9.40065 15.0835 9.75501 15.559 9.75501H22.6547V26.6664H5.7807ZM16.442 8.00033V3.04523L21.3947 8.00033H16.442ZM1.549 4.00017C0.693308 4.00017 0 4.70059 0 5.55789V30.8916C0 31.7509 0.698628 32.45 1.55767 32.45H18.8823C19.2991 32.45 19.6921 32.2858 19.9851 31.9879C20.2784 31.6909 20.4361 31.2951 20.4306 30.8789L20.4206 30.2112C20.4132 29.7031 19.9833 29.3573 19.5315 29.3335L19.5239 29.3331L19.5164 29.3332C19.0237 29.3404 18.6318 29.7454 18.638 30.2374L18.6506 30.6666H1.78259L1.77408 5.78289H2.20567C2.69715 5.78289 3.09667 5.38447 3.09667 4.89153C3.09667 4.3994 2.6973 4.00017 2.20567 4.00017H1.549Z",
      fill: n.color
    }, null, 8, Sue)
  ]);
}
const Aue = /* @__PURE__ */ O(kue, [["render", Mue]]), $ue = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Iue = {
  width: "26",
  height: "33",
  viewBox: "0 0 26 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Due = ["fill"];
function Lue(e, t, n, o, i, r) {
  return d(), h("svg", Iue, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 27.9811V30.091H15C15.55 30.091 16 30.4929 16 31.0455C16 31.5981 15.55 32.0502 15 32.0502H7C6.45 32.0502 6 31.5981 6 31.0455C6 30.4929 6.45 30.091 7 30.091H10V27.9811C7.8 27.8304 5.6 27.1271 3.5 25.9215C3 25.6201 2.85 25.0172 3.15 24.5651C3.45 24.0628 4.05 23.9121 4.5 24.2135C6.65 25.4694 8.8 26.0722 11 26.0722C18.15 26.0722 24 20.2449 24 13.0612C24 8.43953 21.6 4.26999 17.5 1.90892C17 1.60751 16.85 1.00468 17.15 0.552564C17.45 0.0502093 18.05 -0.100497 18.5 0.200916C23.2 2.91363 26 7.73624 26 13.0612C26 20.9482 19.8 27.4285 12 27.9811ZM22 13.011C22 19.0895 17.05 24.0125 11 24.0125C4.95 24.0125 0 19.0895 0 13.011C0 6.93247 4.95 2.00939 11 2.00939C17.05 2.00939 22 6.93247 22 13.011ZM11 4.01881C6.05 4.01881 2 8.03765 2 13.011C2 17.9843 6.05 22.0031 11 22.0031C15.95 22.0031 20 17.9843 20 13.011C20 8.03765 15.95 4.01881 11 4.01881Z",
      fill: n.color
    }, null, 8, Due)
  ]);
}
const Oue = /* @__PURE__ */ O($ue, [["render", Lue]]), Nue = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Pue = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Hue = ["fill"];
function Fue(e, t, n, o, i, r) {
  return d(), h("svg", Pue, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M32 17C32 20.86 28.8599 24 25.0005 24C21.1411 24 18 20.86 18 17C18 16.517 18.0492 16.046 18.1426 15.591C17.8543 15.39 17.1452 15 16 15C14.8639 15 14.1557 15.386 13.8584 15.592C13.9508 16.047 14 16.518 14 17C14 20.86 10.8599 24 7.0005 24C3.14114 24 0 20.86 0 17C0 16.75 0.0150678 16.504 0.0401808 16.26C0.00401809 16.125 -0.0100452 15.983 0.0140633 15.836L2.01406 3.836C2.17579 2.535 3.43446 0 7.0005 0C7.55299 0 8 0.448 8 1C8 1.552 7.55299 2 7.0005 2C4.2893 2 4.00301 4.037 3.99297 4.124L2.77549 11.432C3.95078 10.538 5.41236 10 7.0005 10C9.66047 10 11.9779 11.492 13.1622 13.683C13.78 13.346 14.7172 13 16 13C17.2838 13 18.22 13.346 18.8388 13.682C20.0231 11.492 22.3405 10 25.0005 10C26.5876 10 28.0492 10.537 29.2245 11.432L28.0141 4.164C27.9769 3.916 27.6183 2 25.0005 2C24.447 2 24 1.552 24 1C24 0.448 24.447 0 25.0005 0C28.5655 0 29.8242 2.535 29.992 3.876L31.9859 15.836C32.0111 15.983 31.997 16.125 31.9598 16.261C31.9859 16.504 32 16.75 32 17ZM7.0005 12C4.24309 12 2 14.243 2 17C2 19.757 4.24309 22 7.0005 22C9.75691 22 12 19.757 12 17C12 14.243 9.75691 12 7.0005 12ZM25.0005 12C22.2431 12 20 14.243 20 17C20 19.757 22.2431 22 25.0005 22C27.7569 22 30 19.757 30 17C30 14.243 27.7569 12 25.0005 12Z",
      fill: n.color
    }, null, 8, Hue)
  ]);
}
const Rue = /* @__PURE__ */ O(Nue, [["render", Fue]]), Bue = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Vue = {
  width: "30",
  height: "33",
  viewBox: "0 0 30 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jue = ["fill"];
function Uue(e, t, n, o, i, r) {
  return d(), h("svg", Vue, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M28.9995 7.00245H24.9995V11.0037C24.9995 11.5559 24.5517 12.0048 23.9995 12.0048C23.4473 12.0048 22.9995 11.5559 22.9995 11.0037V7.00245H18.9995C18.4473 7.00245 17.9995 6.55463 17.9995 6.00239C17.9995 5.45014 18.4091 5.06759 18.9624 5.06759H22.9995V1.00107C22.9995 0.448823 23.4473 0 23.9995 0C24.5517 0 24.9995 0.448823 24.9995 1.00107V5.06759H29.0025C29.5557 5.06759 29.9995 5.45014 29.9995 6.00239C29.9995 6.55463 29.5517 7.00245 28.9995 7.00245ZM23.3439 31.9488C23.2304 31.991 23.114 32.01 22.9995 32.01C22.5919 32.01 22.2093 31.759 22.0608 31.3544L17.9463 20.1288H6.05272L1.93826 31.3544C1.7475 31.8735 1.17722 32.1386 0.655127 31.9488C0.137055 31.758 -0.12901 31.1837 0.0617534 30.6656L11.0608 0.656668C11.2043 0.262065 11.5798 0 11.9995 0C12.4192 0 12.7947 0.262065 12.9383 0.656668L23.9383 30.6656C24.128 31.1837 23.862 31.758 23.3439 31.9488ZM11.9995 3.90587L6.78967 18.1206H17.2104L11.9995 3.90587Z",
      fill: n.color
    }, null, 8, jue)
  ]);
}
const Gue = /* @__PURE__ */ O(Bue, [["render", Uue]]), zue = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Kue = {
  width: "32",
  height: "28",
  viewBox: "0 0 32 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Zue = ["fill"];
function xue(e, t, n, o, i, r) {
  return d(), h("svg", Kue, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M29.9355 23.8376C28.7979 23.8376 27.871 22.904 27.871 21.759C27.871 20.9929 28.289 20.3299 28.9032 19.9687V12.1175L24.7546 14.5042C24.7577 14.5385 24.7742 14.5687 24.7742 14.6031V24.8764C24.7742 24.916 24.7556 24.9503 24.7515 24.9899C24.7432 25.0606 24.7319 25.1273 24.7102 25.1959C24.6895 25.2594 24.6627 25.3167 24.6307 25.375C24.5987 25.4322 24.5646 25.4843 24.5223 25.5363C24.4759 25.5915 24.4253 25.6362 24.3685 25.681C24.3386 25.7049 24.32 25.7382 24.2859 25.7591C24.1404 25.8507 20.6483 27.9938 15.4839 27.9938C10.3195 27.9938 6.82735 25.8507 6.68181 25.7591C6.64774 25.7382 6.62916 25.7049 6.59923 25.681C6.54245 25.6362 6.49187 25.5915 6.44542 25.5353C6.4031 25.4843 6.36903 25.4322 6.33703 25.375C6.30503 25.3167 6.27819 25.2594 6.25755 25.1959C6.23587 25.1273 6.22452 25.0606 6.21626 24.9899C6.21213 24.9513 6.19355 24.917 6.19355 24.8764V14.6031C6.19355 14.5687 6.21006 14.5385 6.21316 14.5042L0.520258 11.2286C0.198194 11.0444 0 10.6998 0 10.3272C0 9.95355 0.198194 9.60902 0.520258 9.42479L14.9719 1.11037C15.2877 0.928217 15.679 0.928217 15.9959 1.11037L30.4475 9.42479C30.7695 9.60902 30.9677 9.95355 30.9677 10.3272C30.9677 10.3449 30.9554 10.3595 30.9543 10.3782C30.9554 10.4022 30.9677 10.423 30.9677 10.4469V19.9687C31.5819 20.3299 32 20.9929 32 21.759C32 22.904 31.0741 23.8376 29.9355 23.8376ZM22.7097 24.2571V15.6804L15.9959 19.543C15.8379 19.6346 15.6604 19.6804 15.4839 19.6804C15.3074 19.6804 15.1298 19.6346 14.9719 19.543L8.25806 15.6804V24.254C9.29445 24.7765 11.9515 25.9162 15.4839 25.9162C19.0369 25.9162 21.6785 24.7796 22.7097 24.2571ZM15.4839 3.20979L3.11329 10.3272L15.4839 17.4436L27.8545 10.3272L15.4839 3.20979Z",
      fill: n.color
    }, null, 8, Zue)
  ]);
}
const Wue = /* @__PURE__ */ O(zue, [["render", xue]]), que = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Yue = {
  width: "33",
  height: "29",
  viewBox: "0 0 33 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Xue = ["fill"];
function Que(e, t, n, o, i, r) {
  return d(), h("svg", Yue, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.0462 2.957H13.8656L8.9928 28.1971C8.89233 28.5986 8.59091 28.8997 8.23926 29C8.18903 29 8.08856 29 8.03832 29C7.73691 29 7.38526 28.8495 7.23455 28.5484L0.201588 18.5627C-0.0998244 18.1111 0.000646586 17.509 0.452766 17.1577C0.904885 16.8566 1.50771 16.957 1.85936 17.4086L7.48573 25.4875L12.0572 1.80288C12.0572 1.7527 12.0572 1.7527 12.0572 1.70252C12.0572 1.65234 12.1074 1.55198 12.1576 1.5018C12.2079 1.45162 12.2079 1.40144 12.2581 1.35126C12.3083 1.30108 12.3586 1.2509 12.4088 1.20073C12.459 1.15055 12.5093 1.15055 12.5595 1.10037C12.6098 1.05019 12.66 1.05019 12.7605 1.00001C12.8107 1.00001 12.8609 0.949829 12.9614 0.949829C13.0116 0.949829 13.0116 0.949829 13.0619 0.949829H31.0964C31.649 0.949829 32.1011 1.40144 32.1011 1.95341C32.1011 2.50538 31.5988 2.957 31.0462 2.957ZM16.4779 7.17205C16.93 6.87098 17.5831 7.02151 17.8342 7.47313L22.0038 14.147L26.1733 7.47313C26.4747 7.02151 27.0776 6.87098 27.5297 7.17205C27.9818 7.47313 28.1325 8.07528 27.8311 8.57707L23.1592 16.0538L27.8311 23.5305C28.1325 23.9821 27.9818 24.6344 27.5297 24.9355C27.379 25.0359 27.178 25.086 26.9771 25.086C26.6254 25.086 26.324 24.9355 26.1231 24.6344L21.9535 18.0108L17.784 24.6344C17.5831 24.9355 17.2816 25.086 16.93 25.086C16.7291 25.086 16.5784 25.0359 16.3774 24.9355C15.9253 24.6344 15.7746 24.0323 16.076 23.5305L20.7479 16.0538L16.1765 8.52689C15.8751 8.07528 16.0258 7.47313 16.4779 7.17205Z",
      fill: n.color
    }, null, 8, Xue)
  ]);
}
const Jue = /* @__PURE__ */ O(que, [["render", Que]]), ede = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, tde = {
  width: "32",
  height: "38",
  viewBox: "0 0 32 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nde = ["fill"];
function ode(e, t, n, o, i, r) {
  return d(), h("svg", tde, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.9702 8.89879C31.9829 8.9717 31.9898 9.0423 31.9875 9.11521C31.9863 9.18696 31.9759 9.25525 31.9609 9.327C31.9437 9.4057 31.9217 9.47861 31.8883 9.55268C31.8745 9.58509 31.8745 9.62097 31.8572 9.65337L24.8414 22.3181C25.7754 23.9233 26.2909 25.7218 26.2909 27.5897C26.2909 33.3278 21.6794 37.9977 16.0105 37.9977C10.3416 37.9977 5.73017 33.3278 5.73017 27.5897C5.73017 25.7207 6.24679 23.921 7.17969 22.3181L0.165057 9.65337C0.146607 9.62097 0.146607 9.58509 0.132769 9.55268C0.10048 9.47861 0.0774174 9.4057 0.0612732 9.327C0.0451291 9.25525 0.0347507 9.18696 0.0335976 9.11521C0.0312913 9.0423 0.0393633 8.9717 0.0508949 8.89879C0.0635796 8.82009 0.0831832 8.74718 0.112012 8.67311C0.124697 8.63955 0.12239 8.60367 0.138535 8.57011L3.56571 1.63188C3.57839 1.60526 3.60722 1.59369 3.62221 1.56823C3.69832 1.43977 3.79518 1.33098 3.91396 1.2407C3.95547 1.2083 3.99353 1.17936 4.03965 1.1539C4.17342 1.07868 4.31871 1.03123 4.47785 1.01502C4.50322 1.01271 4.52282 0.994191 4.54819 0.993034C4.55857 0.991877 4.56664 0.995349 4.57702 0.995349C4.58048 0.995349 4.58394 0.993034 4.5874 0.993034H26.8629C26.9793 0.993034 27.0866 1.0266 27.1927 1.06016C27.2872 1.03933 27.3726 0.989562 27.4729 0.993034C27.8915 1.00808 28.2686 1.25343 28.4554 1.63188L31.8825 8.57011C31.8987 8.60367 31.8964 8.63955 31.9102 8.67311C31.939 8.74718 31.9575 8.82009 31.9702 8.89879ZM16.0105 35.6853C20.419 35.6853 24.0065 32.0536 24.0065 27.5897C24.0065 25.9405 23.5164 24.3481 22.587 22.9836C21.4269 21.2834 19.6833 20.1053 17.6757 19.6655C17.1337 19.5532 16.5698 19.4953 16.0105 19.4953C15.4513 19.4953 14.8874 19.5532 14.3315 19.6689C12.34 20.1053 10.5953 21.2834 9.4341 22.9847C8.50581 24.3469 8.01457 25.9405 8.01457 27.5897C8.01457 32.0536 11.602 35.6853 16.0105 35.6853ZM17.309 17.301L21.4073 10.2436H10.6138L14.6971 17.2756C15.5723 17.1645 16.4441 17.1957 17.309 17.301ZM2.45291 9.05619L8.68686 20.3101C9.73392 19.2396 10.9943 18.4109 12.3942 17.8751L4.66927 4.57036L2.45291 9.05619ZM9.27035 7.93126H22.7507L25.4364 3.30539H6.58466L9.27035 7.93126ZM27.3518 4.57036L19.6395 17.8531C21.0394 18.3936 22.2941 19.2315 23.3365 20.3078L29.5682 9.05619L27.3518 4.57036Z",
      fill: n.color
    }, null, 8, nde)
  ]);
}
const rde = /* @__PURE__ */ O(ede, [["render", ode]]), ide = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, sde = {
  width: "32",
  height: "29",
  viewBox: "0 0 32 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ade = ["fill"];
function lde(e, t, n, o, i, r) {
  return d(), h("svg", sde, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M29.452 24H20.22L20.82 27H22.047C22.599 27 23.047 27.447 23.047 28C23.047 28.553 22.599 29 22.047 29H10.047C9.495 29 9.047 28.553 9.047 28C9.047 27.447 9.495 27 10.047 27H11.18L11.78 24H2.548C1.143 24 0 22.857 0 21.452V2.548C0 1.143 1.143 0 2.548 0H29.452C30.857 0 32 1.143 32 2.548V21.452C32 22.857 30.857 24 29.452 24ZM18.78 27L18.18 24H13.82L13.22 27H18.78ZM2.548 22H29.452C29.754 22 30 21.754 30 21.452V20H2V21.452C2 21.754 2.246 22 2.548 22ZM29.452 2H2.548C2.246 2 2 2.246 2 2.548V18H30V2.548C30 2.246 29.754 2 29.452 2Z",
      fill: n.color
    }, null, 8, ade)
  ]);
}
const ude = /* @__PURE__ */ O(ide, [["render", lde]]), dde = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, cde = {
  width: "32",
  height: "30",
  viewBox: "0 0 32 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hde = ["fill"];
function mde(e, t, n, o, i, r) {
  return d(), h("svg", cde, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30 30H2C0.898 30 0 29.103 0 28V7C0 5.897 0.898 5 2 5H10V3C10 1.346 11.346 0 13 0H19C20.654 0 22 1.346 22 3V5H30C31.102 5 32 5.897 32 7V28C32 29.103 31.102 30 30 30ZM17 28H29.996L29.998 16H26V17.285C26 18.782 24.654 20 23 20C22.234 20 21.503 19.735 20.94 19.254C20.343 18.742 20 18.024 20 17.285V16H17V28ZM22 17.285C22 17.497 22.151 17.658 22.241 17.735C22.438 17.903 22.715 18 23 18C23.532 18 24 17.666 24 17.285V14H22V17.285ZM2 28H15V16H12V17.285C12 18.782 10.654 20 9 20C8.234 20 7.503 19.735 6.94 19.254C6.343 18.742 6 18.024 6 17.285V16H2V28ZM10 17.285V14H8V17.285C8 17.497 8.151 17.658 8.241 17.735C8.438 17.903 8.715 18 9 18C9.532 18 10 17.666 10 17.285ZM20 3C20 2.448 19.552 2 19 2H13C12.448 2 12 2.448 12 3V5H20V3ZM2 7V14H6V13C6 12.448 6.447 12 7 12H11C11.553 12 12 12.448 12 13V14H20V13C20 12.448 20.447 12 21 12H25C25.553 12 26 12.448 26 13V14H29.999L30 7H2Z",
      fill: n.color
    }, null, 8, hde)
  ]);
}
const pde = /* @__PURE__ */ O(dde, [["render", mde]]), fde = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, gde = {
  width: "32",
  height: "28",
  viewBox: "0 0 32 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vde = ["fill"];
function bde(e, t, n, o, i, r) {
  return d(), h("svg", gde, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.0006 11.9999C30.9956 11.9999 30.9875 11.9999 30.9805 11.9999H26.9838V22.0007H28.9826C29.535 22.0007 29.9811 22.4485 29.9811 23.0006C29.9811 23.5526 29.535 24.0005 28.9826 24.0005H2.99831C2.44596 24.0005 1.99887 23.5526 1.99887 23.0006C1.99887 22.4485 2.44596 22.0007 2.99831 22.0007H4.99718V11.9999H0.999436C0.559363 11.9999 0.171418 11.7113 0.0431051 11.2895C-0.0842053 10.8687 0.079193 10.4129 0.445085 10.1674L15.4356 0.167566C15.7714 -0.0558552 16.2095 -0.0558552 16.5443 0.167566L31.4246 10.0933C31.7644 10.2536 32 10.5992 32 11C32 11.552 31.5529 11.9999 31.0006 11.9999ZM21.9866 22.0007H24.9849V11.9999H21.9866V22.0007ZM16.9894 22.0007H19.9877V11.9999H16.9894V22.0007ZM14.9905 22.0007V11.9999H11.9501V22.0007H14.9905ZM6.93791 22.0007H9.99436V11.9999H6.93791V22.0007ZM15.99 2.2014L4.30048 10.0001H27.6805L15.99 2.2014ZM0.999436 26.0002H30.9805C31.5329 26.0002 31.98 26.4481 31.98 27.0001C31.98 27.5532 31.5329 28 30.9805 28H0.999436C0.44709 28 0 27.5532 0 27.0001C0 26.4481 0.44709 26.0002 0.999436 26.0002Z",
      fill: n.color
    }, null, 8, vde)
  ]);
}
const yde = /* @__PURE__ */ O(fde, [["render", bde]]), _de = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Cde = {
  width: "28",
  height: "33",
  viewBox: "0 0 28 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wde = ["fill"];
function Tde(e, t, n, o, i, r) {
  return d(), h("svg", Cde, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.219 17.4369C23.242 18.8659 28 24.1269 28 30.0179V31.0169C28 31.5669 27.552 32.0139 27 32.0139H1C0.448 32.0139 0 31.5669 0 31.0169V30.0179C0 24.1269 4.758 18.8659 10.78 17.4369C7.406 16.1399 5 12.8779 5 9.05893C5 4.10593 9.038 0.0759277 14 0.0759277C18.962 0.0759277 23 4.10593 23 9.05893C23 12.8779 20.594 16.1399 17.219 17.4369ZM2 30.0179H26C26 24.1699 20.393 19.0399 14 19.0399C7.607 19.0399 2 24.1699 2 30.0179ZM14 2.07293C10.14 2.07293 7 5.20693 7 9.05893C7 12.9109 10.14 16.0449 14 16.0449C17.86 16.0449 21 12.9109 21 9.05893C21 5.20693 17.86 2.07293 14 2.07293Z",
      fill: n.color
    }, null, 8, wde)
  ]);
}
const kde = /* @__PURE__ */ O(_de, [["render", Tde]]), Ede = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Sde = {
  width: "30",
  height: "32",
  viewBox: "0 0 30 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Mde = ["fill"];
function Ade(e, t, n, o, i, r) {
  return d(), h("svg", Sde, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M27 20.794V27C27 28.005 26.269 28.962 25.299 29.227L15.263 31.964C15.175 31.988 15.087 32 14.999 32C14.76 32 14.537 31.908 14.359 31.757C14.331 31.759 14.306 31.77 14.278 31.77C14.111 31.77 13.941 31.747 13.772 31.701L4.702 29.227C3.731 28.962 3 28.005 3 27V20.794C1.567 20.288 0 18.835 0 17C0 15.164 1.567 13.711 3 13.206V11C3 10.423 3.247 9.904 3.677 9.576C4.105 9.247 4.669 9.146 5.229 9.299L14.298 11.772C14.483 11.822 14.648 11.918 14.812 12.015L24.772 9.298C25.327 9.147 25.894 9.247 26.323 9.576C26.753 9.904 27 10.423 27 11V13.206C28.433 13.711 30 15.164 30 17C30 18.835 28.433 20.288 27 20.794ZM2 17C2 18.033 3.375 19 4 19C4.408 19 5 18.22 5 17C5 15.779 4.408 15 4 15C3.375 15 2 15.966 2 17ZM14 14C14 13.901 13.867 13.727 13.772 13.701L5 11.309V13.237C6.173 13.777 7 15.229 7 17C7 18.771 6.173 20.223 5 20.763V27C5 27.099 5.133 27.272 5.229 27.298L14 29.69V14ZM25 11.309L15.96 13.774C15.969 13.851 16 13.923 16 14V29.69L24.772 27.298C24.867 27.272 25 27.099 25 27V20.763C23.827 20.223 23 18.771 23 17C23 15.229 23.827 13.777 25 13.237V11.309ZM26 15C25.592 15 25 15.779 25 17C25 18.22 25.592 19 26 19C26.625 19 28 18.033 28 17C28 15.966 26.625 15 26 15ZM15 10C12.243 10 10 7.757 10 5C10 2.243 12.243 0 15 0C17.757 0 20 2.243 20 5C20 7.757 17.757 10 15 10ZM15 2C13.346 2 12 3.346 12 5C12 6.654 13.346 8 15 8C16.654 8 18 6.654 18 5C18 3.346 16.654 2 15 2Z",
      fill: n.color
    }, null, 8, Mde)
  ]);
}
const $de = /* @__PURE__ */ O(Ede, [["render", Ade]]), Ide = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Dde = {
  width: "33",
  height: "33",
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Lde = ["fill"];
function Ode(e, t, n, o, i, r) {
  return d(), h("svg", Dde, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.9511 15.2675C31.8112 15.6861 31.4205 15.9511 31.0026 15.9511C30.8969 15.9511 30.7912 15.934 30.6854 15.8989L26.0083 14.335L25.7032 15.2625C25.6196 15.5155 25.4394 15.7253 25.2017 15.8447C25.0618 15.915 24.9067 15.9511 24.7526 15.9511C24.6459 15.9511 24.5402 15.934 24.4375 15.8999L17.0044 13.4256V15.133C18.7242 15.5807 20.004 17.1335 20.004 18.9935C20.004 20.0274 19.5992 20.9629 18.9528 21.6736L22.9321 31.6269C23.1375 32.1408 22.8878 32.722 22.3753 32.9278C22.2535 32.977 22.1276 33 22.0037 33C21.607 33 21.2314 32.7611 21.0754 32.3707L17.241 22.7797C16.8493 22.9082 16.4385 22.9955 16.0045 22.9955C15.5695 22.9955 15.1597 22.9082 14.768 22.7797L10.9326 32.3707C10.7766 32.7611 10.401 33 10.0042 33C9.88039 33 9.75453 32.977 9.63269 32.9278C9.12016 32.722 8.87045 32.1408 9.07586 31.6269L13.0552 21.6746C12.4088 20.9629 12.004 20.0274 12.004 18.9935C12.004 17.1335 13.2838 15.5807 15.0036 15.133V12.991C15.0036 12.9137 15.0308 12.8465 15.0479 12.7752L9.09902 10.7948L8.9651 11.2645C8.83923 11.7042 8.43848 11.9903 8.00449 11.9903C7.91286 11.9903 7.82023 11.9782 7.7286 11.9511L0.729478 9.9506C0.197823 9.79904 -0.110296 9.24496 0.0417497 8.71397L2.0415 1.7107C2.19354 1.17871 2.75138 0.873565 3.278 1.02413L10.2771 3.02463C10.8088 3.1772 11.1169 3.73028 10.9648 4.26127L10.7484 5.01911L26.3184 10.2005C26.842 10.3742 27.1249 10.9393 26.9528 11.4623L26.6336 12.4339L31.3198 14.0018C31.8434 14.1765 32.1253 14.7436 31.9511 15.2675ZM3.68983 3.22237L2.23986 8.30142L7.31677 9.75286L7.41645 9.40255C7.42451 9.33128 7.41947 9.26102 7.44263 9.19075C7.45773 9.14458 7.49096 9.11146 7.51211 9.0703L8.76673 4.67382L3.68983 3.22237ZM14.0037 18.9935C14.0037 20.0967 14.9019 20.994 16.0045 20.994C17.1061 20.994 18.0042 20.0967 18.0042 18.9935C18.0042 17.8894 17.1061 16.992 16.0045 16.992C14.9019 16.992 14.0037 17.8894 14.0037 18.9935ZM10.1986 6.94433L9.6488 8.87055L24.1163 13.6846L24.7406 11.7845L10.1986 6.94433Z",
      fill: n.color
    }, null, 8, Lde)
  ]);
}
const Nde = /* @__PURE__ */ O(Ide, [["render", Ode]]), Pde = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, Hde = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Fde = ["fill"];
function Rde(e, t, n, o, i, r) {
  return d(), h("svg", Hde, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M26 10.9V14C26 19.176 22.046 23.446 17 23.95V30H23C23.553 30 24 30.448 24 31C24 31.552 23.553 32 23 32H9C8.447 32 8 31.552 8 31C8 30.448 8.447 30 9 30H15V23.95C9.954 23.446 6 19.176 6 14V10.9C2.507 10.272 0 6.454 0 3C0 2.448 0.447 2 1 2H6V1C6 0.448 6.447 0 7 0H25C25.553 0 26 0.448 26 1V2H31C31.553 2 32 2.448 32 3C32 6.454 29.493 10.272 26 10.9ZM6 4H2.094C2.481 6.114 4.029 8.274 6 8.845V4ZM24 2H8V14C8 18.411 11.589 22 16 22C20.411 22 24 18.411 24 14V2ZM26 4V8.845C27.971 8.274 29.519 6.114 29.906 4H26ZM18 17H14C13.447 17 13 16.552 13 16C13 15.448 13.447 15 14 15H15V9.414L13.707 10.707C13.316 11.097 12.684 11.097 12.293 10.707C11.902 10.316 11.902 9.683 12.293 9.293L15.293 6.293C15.579 6.006 16.009 5.922 16.383 6.076C16.757 6.231 17 6.596 17 7V15H18C18.553 15 19 15.448 19 16C19 16.552 18.553 17 18 17Z",
      fill: n.color
    }, null, 8, Fde)
  ]);
}
const Bde = /* @__PURE__ */ O(Pde, [["render", Rde]]), Vde = {
  name: "S1",
  components: {
    CmsBadge: x1e,
    CmsBasketball: Q1e,
    CmsBlackboard: oue,
    CmsBus: lue,
    CmsChemistry: mue,
    CmsDesign: bue,
    CmsDiploma: Tue,
    CmsDocuments: Aue,
    CmsGeography: Oue,
    CmsGlasses: Rue,
    CmsGrade: Gue,
    CmsGraduationCap: Wue,
    CmsMath: Jue,
    CmsMedal: rde,
    CmsMonitor: ude,
    CmsSchoolBag: pde,
    CmsSchoolBuilding: yde,
    CmsStaff: kde,
    CmsStudent: $de,
    CmsTelescope: Nde,
    CmsTrophy: Bde
  },
  mixins: [Fi]
}, jde = {
  key: 0,
  "data-testid": "component-header-top"
}, Ude = ["data-testid"], Gde = { class: "stats-info" }, zde = { class: "stats-card-border" }, Kde = {
  class: "stats-card stats-accent-border",
  "data-testid": "stats-accent-border"
}, Zde = { class: "svg-wrapper" }, xde = ["innerHTML"];
function Wde(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    id: "stats-s1",
    class: v(e.theme.style),
    style: j(e.colors),
    "data-testid": "S1"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.displayHeaderTop ? (d(), h("h3", jde, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.stats.component_header_top), 1)
          ], !0)
        ])) : b("", !0),
        c("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header", {}, () => [
            A(y(e.stats.component_header), 1)
          ], !0)
        ], 8, Ude)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
      modelValue: e.stats.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.stats.content = s),
      "item-key": "index",
      class: "stats-wrapper"
    }), {
      item: _(({ element: s, index: l }) => [
        c("div", Gde, [
          w(e.$slots, "controls", { idx: l }, void 0, !0),
          c("div", zde, [
            c("div", Kde, [
              c("div", Zde, [
                w(e.$slots, "icon", { idx: l }, () => [
                  s.icon ? (d(), h("span", {
                    key: 0,
                    class: "raw-svg",
                    "data-testid": "stats-icon",
                    innerHTML: s.icon
                  }, null, 8, xde)) : s.name ? (d(), k(K(`cms-${s.name.replace(/\s/g, "-")}`), {
                    key: 1,
                    "data-testid": "stats-icon",
                    color: `${e.theme.icon_color.hex}`
                  }, null, 8, ["color"])) : b("", !0)
                ], !0)
              ])
            ])
          ]),
          e.stats.headline ? (d(), h("h3", {
            key: 0,
            class: v(["stats-headline", e.theme.style]),
            "data-testid": "stats-headline"
          }, [
            w(e.$slots, "headline", { idx: l }, () => [
              A(y(s.headline), 1)
            ], !0)
          ], 2)) : b("", !0),
          e.stats.snippet ? (d(), h("p", {
            key: 1,
            class: v(["stats-snippet", e.theme.style]),
            "data-testid": "stats-snippet"
          }, [
            w(e.$slots, "snippet", { idx: l }, () => [
              A(y(s.snippet), 1)
            ], !0)
          ], 2)) : b("", !0)
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const qde = /* @__PURE__ */ O(Vde, [["render", Wde], ["__scopeId", "data-v-201e6dff"]]), Yde = {
  methods: {
    isShortList(e) {
      var n;
      return (e || ((n = this.items) == null ? void 0 : n.length)) <= this.sliderCapacity;
    },
    goRight(e) {
      this.isShortList(e) || (this.currentCard + this.sliderCapacity === this.cardsLength ? this.currentCard = 0 : this.currentCard += 1, this.move());
    },
    goLeft(e) {
      this.isShortList(e) || (this.currentCard === 0 ? this.currentCard = this.cardsLength - this.sliderCapacity : this.currentCard -= 1, this.move());
    },
    move() {
      const t = (this.$refs[`slider-card-${this.currentCard}`] ? this : this.getSlot()).$refs[`slider-card-${this.currentCard}`], { slider: n } = this.$refs, { left: o } = this.getRelativePos(t);
      n.$el.style.transform = `translateX(-${o}px)`;
    },
    getSlot() {
      const e = Object.keys(this.$slots)[this.currentCard], [t] = this.$slots[e]();
      return t.context;
    },
    getRelativePos(e) {
      const t = e.parentNode.getBoundingClientRect(), n = e.getBoundingClientRect(), o = {};
      return o.top = n.top - t.top + e.parentNode.scrollTop, o.right = n.right - t.right, o.bottom = n.bottom - t.bottom, o.left = n.left - t.left + e.parentNode.scrollLeft, o;
    }
  }
}, Xde = {
  name: "S2",
  mixins: [Fi, Tt, Yde],
  data() {
    return {
      currentCard: 0,
      cardsLength: 0
    };
  },
  computed: {
    component_header() {
      return this.stats.stats_header;
    },
    stats_header() {
      return this.stats.component_header;
    },
    sliderCapacity() {
      return this.screenSize < 600 ? 1 : this.screenSize >= 1600 && !this.hasHeader ? 4 : this.screenSize >= 960 && this.hasHeader && this.hasSlider ? 3 : 4;
    },
    lowSliderCount() {
      var t;
      const e = ((t = this.stats.content) == null ? void 0 : t.length) || 0;
      return this.hasSlider && e < this.sliderCapacity;
    },
    hasHeader() {
      return this.stats.headline;
    },
    hasSlider() {
      return this.stats.slider && !this.isEditing;
    },
    hasTwoRows() {
      return this.screenSize >= 600 && this.screenSize < 960;
    },
    showArrows() {
      return this.screenSize >= 600 && this.hasSlider && this.stats.content.length > this.sliderCapacity;
    },
    backgroundImage() {
      return this.stats.bg_image && this.stats.bg_image.url ? {
        backgroundImage: `linear-gradient(${this.theme.bg_color.hex}e6, ${this.theme.bg_color.hex}e6), ${`url(${this.stats.bg_image.url})`}`
      } : !1;
    },
    hasDots() {
      return !!(this.hasSlider && this.stats.content.length > this.sliderCapacity);
    },
    dotCount() {
      const e = this.sliderCapacity, t = this.stats.content.length;
      return Math.ceil(t / e);
    },
    activeStatIdx() {
      return Math.ceil(this.currentCard / this.sliderCapacity + 1) === this.dotCount ? this.dotCount : Math.floor(this.currentCard / this.sliderCapacity + 1);
    }
  },
  mounted() {
    this.cardsLength = this.stats.content.length;
  },
  methods: {
    sliderCardOptions(e) {
      return {
        "stats-card-hidden": !this.isInRange(e, this.currentCard) && this.hasSlider,
        "stats-card-no-border": this.isTheLastOneInRange(e, this.currentCard),
        "stats-card-no-header": !this.hasHeader,
        "stats-card-no-slider": !this.hasSlider
      };
    },
    setScreenSize() {
      this.hasSlider && (this.screenSize = document.documentElement.clientWidth, this.lowSliderCount || this.move());
    },
    moveForward() {
      this.isEditing || (this.hasTwoRows ? (this.currentCard + this.sliderCapacity >= this.cardsLength ? this.currentCard = 0 : this.currentCard += 2, this.move()) : this.goRight(this.cardsLength));
    },
    moveBack() {
      this.isEditing || (this.hasTwoRows ? (this.currentCard <= 1 ? this.cardsLength % 2 !== 0 ? this.currentCard = this.cardsLength - this.sliderCapacity + 1 : this.currentCard = this.cardsLength - this.sliderCapacity : this.currentCard -= 2, this.move()) : this.goLeft(this.cardsLength));
    },
    isInRange(e, t) {
      return e >= t && e <= t + this.sliderCapacity - 1;
    },
    isTheLastOneInRange(e, t) {
      return e === t + this.sliderCapacity - 1 && this.hasSlider;
    },
    dotMove(e) {
      const t = this.sliderCapacity, n = this.stats.content.length, o = (e - 1) * t;
      if (e === this.dotCount && n < this.dotCount * t) {
        const i = n - t, r = n % 2 === 0;
        this.currentCard = this.hasTwoRows && !r ? i + 1 : i;
      } else
        this.currentCard = o;
      this.move();
    }
  }
}, Qde = { key: 0 }, Jde = ["data-testid"], ece = { class: "stat-content" }, tce = { class: "slider-nav" }, nce = ["onClick"], oce = {
  class: "button-action-content",
  tabindex: "-1",
  role: "button"
}, rce = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ice = ["fill"], sce = ["fill"], ace = {
  class: "button-action-content",
  tabindex: "-1",
  role: "button"
}, lce = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uce = ["fill"], dce = ["fill"];
function cce(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = Ve("touch");
  return d(), h("div", {
    id: "stats-s2",
    class: v([[{ "no-slider": !r.hasSlider }, e.theme.style], "stats-s2"]),
    style: j([r.backgroundImage, e.colors])
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.displayHeaderTop ? (d(), h("h3", Qde, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.stats.component_header_top), 1)
          ], !0)
        ])) : b("", !0),
        c("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header", {}, () => [
            A(y(r.component_header), 1)
          ], !0)
        ], 8, Jde)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: v(["stats-info", { "stats-info-w-header": r.hasHeader }])
    }, [
      r.hasHeader && r.hasSlider ? (d(), h("div", {
        key: 0,
        class: v([e.theme.style, "stats-header"])
      }, [
        w(e.$slots, "stats-header", {}, () => [
          A(y(r.stats_header), 1)
        ], !0)
      ], 2)) : b("", !0),
      c("div", {
        class: v(["cards-slider", { "cards-slider-no-slider": !r.hasSlider, "cards-slider-w-header": r.hasHeader }])
      }, [
        ge((d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
          ref: "slider",
          modelValue: e.stats.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.stats.content = l),
          "item-key": "index",
          class: [{ "cards-slider-container-wrap": !r.hasSlider, "cards-slider-container-center": r.lowSliderCount }, "cards-slider-container"]
        }), {
          header: _(() => [
            r.hasHeader && !r.hasSlider ? (d(), h("div", {
              key: 0,
              class: v([e.theme.style, "stats-card stats-card-no-slider stats-header-card"])
            }, [
              w(e.$slots, "stats-header", {}, () => [
                A(y(r.stats_header), 1)
              ], !0)
            ], 2)) : b("", !0)
          ]),
          item: _(({ element: l, index: u }) => [
            c("div", {
              ref: `slider-card-${u}`,
              class: v(["stats-card", r.sliderCardOptions(u)]),
              "data-testid": "stats-content"
            }, [
              w(e.$slots, "controls", { idx: u }, void 0, !0),
              c("div", ece, [
                c("p", {
                  class: v(["stat-headline", [{ "no-slider": !r.hasSlider }, e.theme.style]])
                }, [
                  w(e.$slots, "headline", { idx: u }, () => [
                    A(y(l.headline), 1)
                  ], !0)
                ], 2),
                c("p", {
                  class: v(["stat-description", e.theme.style])
                }, [
                  w(e.$slots, "snippet", { idx: u }, () => [
                    A(y(l.snippet), 1)
                  ], !0)
                ], 2)
              ])
            ], 2)
          ]),
          _: 3
        }, 16, ["modelValue", "class"])), [
          [
            s,
            r.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            s,
            r.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        r.hasDots ? (d(), h("div", {
          key: 0,
          class: v([{ "slider-dots-w-header": r.hasHeader }, "slider-dots"])
        }, [
          c("ul", tce, [
            (d(!0), h(Y, null, ee(r.dotCount, (l) => (d(), h("li", {
              key: l,
              class: v({ activeStatIdx: l === r.activeStatIdx, unactiveStat: l !== r.activeStatIdx }),
              onClick: (u) => r.dotMove(l)
            }, t[5] || (t[5] = [
              c("span", { class: "circle" }, null, -1)
            ]), 10, nce))), 128))
          ])
        ], 2)) : b("", !0)
      ], 2)
    ], 2),
    r.showArrows ? (d(), h("div", {
      key: 0,
      class: v(["navigation", { "navigation-w-header": r.hasHeader }])
    }, [
      c("div", {
        class: v(["arrows", { "arrows-w-header": r.hasHeader }])
      }, [
        c("button", {
          class: v(["left-arrow button-action", { "left-arrow-w-header": r.hasHeader }]),
          onClick: t[1] || (t[1] = (...l) => r.moveBack && r.moveBack(...l)),
          onKeydown: t[2] || (t[2] = V(z((...l) => r.moveBack && r.moveBack(...l), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", oce, [
            (d(), h("svg", rce, [
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M-0.00012207 0H63.9999V62.9999H-0.00012207V0Z",
                "fill-opacity": "0.9",
                fill: e.theme.icon_bg_color.hex
              }, null, 8, ice),
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M24.7803 31.209L37.1333 43.8414L35.7324 45.265L21.9999 31.2222L35.9117 17L37.2991 18.4104L24.7803 31.209Z",
                fill: e.theme.icon_color.hex
              }, null, 8, sce)
            ])),
            t[6] || (t[6] = c("span", { class: "sr-only" }, "Reverse Slider", -1))
          ])
        ], 34),
        c("button", {
          class: v(["right-arrow button-action", { "right-arrow-w-header": r.hasHeader }]),
          onClick: t[3] || (t[3] = (l) => r.moveForward()),
          onKeydown: t[4] || (t[4] = V((l) => r.moveForward(), ["enter"]))
        }, [
          c("div", ace, [
            (d(), h("svg", lce, [
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 0H63.9999V62.9999H0V0Z",
                "fill-opacity": "0.9",
                fill: e.theme.icon_bg_color.hex
              }, null, 8, uce),
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M38.5191 31.209L26.1659 43.8414L27.5668 45.265L41.2995 31.2222L27.3874 17L26 18.4104L38.5191 31.209Z",
                fill: e.theme.icon_color.hex
              }, null, 8, dce)
            ])),
            t[7] || (t[7] = c("span", { class: "sr-only" }, "Advance Slider", -1))
          ])
        ], 34)
      ], 2)
    ], 2)) : b("", !0)
  ], 6);
}
const hce = /* @__PURE__ */ O(Xde, [["render", cce], ["__scopeId", "data-v-e1d0f8bd"]]), mce = {
  name: "S3",
  mixins: [Fi]
}, pce = ["data-testid"], fce = {
  key: 0,
  class: "header-top"
}, gce = {
  key: 0,
  class: "stats-card-img"
}, vce = ["src", "alt"], bce = {
  key: 1,
  class: "stats-content-body"
}, yce = ["innerHTML"], _ce = { class: "stats-card-body" }, Cce = { class: "stats-card-body-snippet-text" };
function wce(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    class: v(["stats-s3", e.theme.style]),
    "data-testid": "S3",
    style: j(e.colors)
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`,
          class: "no-border"
        }, [
          e.displayHeaderTop ? (d(), h("span", fce, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.stats.component_header_top), 1)
            ], !0)
          ])) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.stats.component_header), 1)
          ], !0)
        ], 8, pce)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
      modelValue: e.stats.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.stats.content = s),
      "item-key": "index",
      class: "stats-container stats-wrapper"
    }), {
      item: _(({ element: s, index: l }) => [
        c("div", {
          class: "stats-card",
          style: j({ backgroundColor: s.bg_color }),
          "data-testid": "stats-content"
        }, [
          w(e.$slots, "controls", { idx: l }, void 0, !0),
          s.bg_image ? (d(), h("div", gce, [
            w(e.$slots, "image", { idx: l }, () => [
              s.bg_image.url ? (d(), h("img", {
                key: 0,
                class: "stat-card-img",
                src: s.bg_image.url,
                alt: s.bg_image.alt_text
              }, null, 8, vce)) : b("", !0)
            ], !0)
          ])) : (d(), h("div", bce, [
            e.stats.icon ? (d(), h("div", {
              key: 0,
              class: "svg-wrapper",
              style: j({ fill: s.color })
            }, [
              w(e.$slots, "icon", { idx: l }, () => [
                c("span", {
                  class: "raw-svg",
                  "data-testid": "stats-icon",
                  innerHTML: s.icon
                }, null, 8, yce)
              ], !0)
            ], 4)) : b("", !0),
            c("div", _ce, [
              e.stats.headline ? (d(), h("div", {
                key: 0,
                class: "stats-card-body-headline",
                style: j({ color: s.color })
              }, [
                w(e.$slots, "headline", { idx: l }, () => [
                  c("h3", null, y(s.headline), 1)
                ], !0)
              ], 4)) : b("", !0),
              e.stats.snippet ? (d(), h("div", {
                key: 1,
                class: "stats-card-body-snippet",
                style: j({ color: s.color })
              }, [
                w(e.$slots, "snippet", { idx: l }, () => [
                  c("p", Cce, y(s.snippet), 1)
                ], !0)
              ], 4)) : b("", !0)
            ])
          ]))
        ], 4)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Tce = /* @__PURE__ */ O(mce, [["render", wce], ["__scopeId", "data-v-bf23411e"]]), kce = {
  name: "S4",
  components: {
    Pager: y1
  },
  mixins: [Fi, ut],
  props: {
    startIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentStatCardIndex: 0,
      statsImageCards: [],
      scrollInterval: () => {
      },
      sliderOverlayIndex: 0,
      pauseScroll: !1
    };
  },
  computed: {
    statsV4Colors() {
      var e, t, n, o, i, r, a, s;
      return he(ie({}, this.colors), {
        "--control-border-color": ((t = (e = this.theme) == null ? void 0 : e.button_border_color) == null ? void 0 : t.hex) || "#000",
        "--control-bg-color": ((o = (n = this.theme) == null ? void 0 : n.button_bg_color) == null ? void 0 : o.hex) || "#fff",
        "--pager-color": ((r = (i = this.theme) == null ? void 0 : i.pager_color) == null ? void 0 : r.hex) || "#fff",
        "--overlay-color": ((s = (a = this.theme) == null ? void 0 : a.overlay_color) == null ? void 0 : s.hex) || "#fff",
        "--overlay-opacity": `${this.theme.percentage_opacity || "80"}%`
      });
    },
    content() {
      return this.statsImageCards;
    },
    sliderCenterSize() {
      return this.mobileScreenSize ? 600 : 1e6;
    },
    mobileScreenSize() {
      return this.screenSize < 1023;
    },
    activeStat() {
      return this.mappedStats[this.currentStatCardIndex] || {
        top_stats: { headline: "", snippet: "" },
        bottom_stats: { headline: "", snippet: "" }
      };
    },
    mappedStats() {
      const e = this.startIndex ? this.stats.nested_content.slice(this.startIndex).concat(this.stats.nested_content.slice(0, this.startIndex)) : this.stats.nested_content;
      return (e == null ? void 0 : e.map((t, n) => he(ie({}, t), {
        left_image: he(ie({}, t.left_image), {
          internalIdx: n
        }),
        right_image: he(ie({}, t.right_image), {
          internalIdx: n
        })
      }))) || [];
    }
  },
  created() {
    this.statsImageCards = this.getStatsImageCards(), this.currentStatCardIndex = this.startIndex;
  },
  async mounted() {
    this.currentCard = Math.floor(this.statsImageCards.length / 2), await this.$nextTick(), this.mobileScreenSize && (this.currentCard -= 1), this.startScroll(), this.calculateScroll(!0);
  },
  beforeUnmount() {
    this.clearScroll();
  },
  methods: {
    startScroll() {
      this.isEditing || !this.mappedStats.length || (this.scrollInterval = setInterval(this.handleScroll, 4e3));
    },
    clearScroll() {
      clearInterval(this.scrollInterval);
    },
    getStatsImageCards() {
      var n, o, i, r;
      if (!this.mappedStats.length)
        return [];
      const e = [
        ...this.mappedStats.slice(1, this.mappedStats.length).map((a) => (a == null ? void 0 : a.left_image) || {}),
        he(ie({}, ((o = (n = this.mappedStats) == null ? void 0 : n[0]) == null ? void 0 : o.left_image) || {}), {
          position: "left_image"
        })
      ], t = [
        he(ie({}, ((r = (i = this.mappedStats) == null ? void 0 : i[0]) == null ? void 0 : r.right_image) || {}), {
          position: "right_image"
        }),
        ...this.mappedStats.slice(1, this.mappedStats.length).map((a) => (a == null ? void 0 : a.right_image) || {})
      ];
      return [...e, {}, ...t];
    },
    togglePlayPause() {
      if (this.pauseScroll = !this.pauseScroll, this.pauseScroll) {
        this.clearScroll();
        return;
      }
      this.startScroll();
    },
    async handleScroll(e) {
      if (this.isEditing || this.pauseScroll || this.mappedStats.length <= 1)
        return;
      this.currentStatCardIndex = e || (this.currentStatCardIndex + 1) % this.mappedStats.length, this.sliderOverlayIndex = this.currentStatCardIndex, await new Promise((o) => setTimeout(o, 1e3));
      const t = this.mappedStats[this.currentStatCardIndex].left_image;
      this.statsImageCards[this.currentCard] = ie({}, t);
      const n = this.mappedStats.at(this.currentStatCardIndex - 1).right_image;
      this.statsImageCards.push(ie({}, n)), this.statsImageCards.splice(0, 1), this.currentCard -= 1, this.mobileScreenSize && (this.currentCard -= 1), this.$refs.scrollWrapper.style["scroll-behavior"] = "auto", this.calculateScroll(), this.$refs.scrollWrapper.style["scroll-behavior"] = "smooth", await this.$nextTick(), this.scrollRight(), this.mobileScreenSize && (this.currentCard += 1);
    }
  }
}, Ece = ["data-testid"], Sce = ["data-testid"], Mce = {
  ref: "scrollWrapper",
  class: "card-wrapper"
}, Ace = { class: "stat-image-wrapper" }, $ce = ["src", "alt"], Ice = { class: "stats-pager" }, Dce = { class: "stat-text-wrapper" }, Lce = { class: "stats-action-button-container" }, Oce = {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Nce = {
  key: 0,
  d: "M38 27.9984L23 36.3123L23 19.6846L38 27.9984Z",
  fill: "#333333"
};
function Pce(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("Pager");
  return d(), h("div", {
    class: v(["stats-v4", { "is-editing": e.isEditing }, e.theme.style]),
    "data-testid": "S4",
    style: j(r.statsV4Colors)
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`
        }, [
          e.displayHeaderTop ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.stats.component_header_top), 1)
            ], !0)
          ], 8, Sce)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.stats.component_header), 1)
          ], !0)
        ], 8, Ece)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Mce, [
      (d(!0), h(Y, null, ee(i.statsImageCards, (l, u) => (d(), h("div", {
        key: u,
        ref_for: !0,
        ref: `sliderCard-${u}`,
        class: v(["stat-card", e.isEditing && "is-editing"])
      }, [
        c("div", Ace, [
          w(e.$slots, l.position ? "image" : "image-alt", {
            idx: u,
            position: l.position
          }, () => [
            c("img", {
              src: l.url ? l.url : "",
              alt: l.alt_text ? l.alt_text : "",
              class: "stat-image",
              loading: "lazy"
            }, null, 8, $ce)
          ], !0),
          c("div", {
            class: v(["stat-image-overlay", { "overlay-visible": i.sliderOverlayIndex === l.internalIdx }])
          }, null, 2)
        ])
      ], 2))), 128)),
      c("div", {
        class: v(["stats-main-card stat-card", { "is-editing": e.isEditing }])
      }, [
        c("div", Ice, [
          L(s, {
            "total-cards": r.mappedStats.length,
            "theme-styles": e.theme,
            "pager-color": e.theme.pager_color ? e.theme.pager_color.hex : "#fff",
            "current-card": i.currentStatCardIndex,
            "pager-section-count": r.mappedStats.length
          }, null, 8, ["total-cards", "theme-styles", "pager-color", "current-card", "pager-section-count"])
        ]),
        c("div", Dce, [
          (d(), k(K(e.isEditing ? "div" : "transition-group"), {
            duration: 1e3,
            tag: "div",
            name: "stats-fade",
            class: v(["stats-text-transition stat-top-text", { "no-snippet": !e.stats.snippet, "no-headline": !e.stats.headline }])
          }, {
            default: _(() => [
              e.stats.headline ? (d(), h("div", {
                key: `${i.currentStatCardIndex}-top`,
                class: "stats-top-text"
              }, [
                w(e.$slots, "headline", {}, () => [
                  A(y(r.activeStat.top_stats.headline), 1)
                ], !0)
              ])) : b("", !0),
              e.stats.snippet ? (d(), h("div", {
                key: `${i.currentStatCardIndex}-bottom`,
                class: "stats-bottom-text"
              }, [
                w(e.$slots, "snippet", {}, () => [
                  A(y(r.activeStat.top_stats.snippet), 1)
                ], !0)
              ])) : b("", !0)
            ]),
            _: 3
          }, 8, ["class"])),
          t[1] || (t[1] = c("div", { class: "stats-divider" }, null, -1)),
          (d(), k(K(e.isEditing ? "div" : "transition-group"), {
            duration: 1e3,
            tag: "div",
            name: "stats-fade",
            class: v(["stats-text-transition stat-bottom-text", { "no-snippet": !e.stats.snippet, "no-headline": !e.stats.headline }])
          }, {
            default: _(() => [
              e.stats.headline ? (d(), h("div", {
                key: `${i.currentStatCardIndex}-top`,
                class: "stats-top-text"
              }, [
                w(e.$slots, "bottom-headline", {}, () => [
                  A(y(r.activeStat.bottom_stats.headline), 1)
                ], !0)
              ])) : b("", !0),
              e.stats.snippet ? (d(), h("div", {
                key: `${i.currentStatCardIndex}-bottom`,
                class: "stats-bottom-text"
              }, [
                w(e.$slots, "bottom-snippet", {}, () => [
                  A(y(r.activeStat.bottom_stats.snippet), 1)
                ], !0)
              ])) : b("", !0)
            ]),
            _: 3
          }, 8, ["class"]))
        ])
      ], 2)
    ], 512),
    c("div", Lce, [
      c("button", {
        class: "stats-action-button",
        onClick: t[0] || (t[0] = (...l) => r.togglePlayPause && r.togglePlayPause(...l))
      }, [
        (d(), h("svg", Oce, [
          c("g", null, [
            t[4] || (t[4] = c("rect", {
              x: "-0.5",
              y: "0.5",
              width: "55",
              height: "55",
              transform: "matrix(-1 0 0 1 55 0)",
              stroke: "#333333"
            }, null, -1)),
            i.pauseScroll ? (d(), h("path", Nce)) : (d(), h(Y, { key: 1 }, [
              t[2] || (t[2] = c("path", {
                d: "M24 21.5V33.5",
                stroke: "black",
                "stroke-width": "3",
                "stroke-linecap": "round"
              }, null, -1)),
              t[3] || (t[3] = c("path", {
                d: "M32 21.5V33.5",
                stroke: "black",
                "stroke-width": "3",
                "stroke-linecap": "round"
              }, null, -1))
            ], 64))
          ])
        ]))
      ])
    ])
  ], 6);
}
const Hce = /* @__PURE__ */ O(kce, [["render", Pce], ["__scopeId", "data-v-eea51a61"]]);
/*!
 * strings: 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Fce = /(?:^\s+|\s+$)/g, Rce = /([\uD800-\uDBFF][\uDC00-\uDFFF](?:[\u200D\uFE0F][\uD800-\uDBFF][\uDC00-\uDFFF]){2,}|\uD83D\uDC69(?:\u200D(?:(?:\uD83D\uDC69\u200D)?\uD83D\uDC67|(?:\uD83D\uDC69\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2642\u2640]\uFE0F|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDD27\uDCBC\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC6F\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3C-\uDD3E\uDDD6-\uDDDF])\u200D[\u2640\u2642]\uFE0F|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|(?:\u26F9|\uD83C[\uDFCC\uDFCB]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])\uFE0F|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC69\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708]))\uFE0F|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83D\uDC69\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\u200D(?:(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F)/;
function Su(e) {
  var t = e.nodeType, n = "";
  if (t === 1 || t === 9 || t === 11) {
    if (typeof e.textContent == "string")
      return e.textContent;
    for (e = e.firstChild; e; e = e.nextSibling)
      n += Su(e);
  } else if (t === 3 || t === 4)
    return e.nodeValue;
  return n;
}
function sn(e, t, n, o, i) {
  if (e += "", n && (e = e.trim ? e.trim() : e.replace(Fce, "")), t && t !== "")
    return e.replace(/>/g, "&gt;").replace(/</g, "&lt;").split(t);
  for (var r = [], a = e.length, s = 0, l, u; s < a; s++)
    u = e.charAt(s), (u.charCodeAt(0) >= 55296 && u.charCodeAt(0) <= 56319 || e.charCodeAt(s + 1) >= 65024 && e.charCodeAt(s + 1) <= 65039) && (l = ((e.substr(s, 12).split(Rce) || [])[1] || "").length || 2, u = e.substr(s, l), r.emoji = 1, s += l - 1), r.push(i ? u : u === ">" ? "&gt;" : u === "<" ? "&lt;" : o && u === " " && (e.charAt(s - 1) === " " || e.charAt(s + 1) === " ") ? "&nbsp;" : u);
  return r;
}
/*!
 * ScrambleTextPlugin 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var bs = /* @__PURE__ */ function() {
  function e(n) {
    this.chars = sn(n), this.sets = [], this.length = 50;
    for (var o = 0; o < 20; o++)
      this.sets[o] = y0(80, this.chars);
  }
  var t = e.prototype;
  return t.grow = function(o) {
    for (var i = 0; i < 20; i++)
      this.sets[i] += y0(o - this.length, this.chars);
    this.length = o;
  }, e;
}(), wo, Af, $f = function() {
  return wo || typeof window != "undefined" && (wo = window.gsap) && wo.registerPlugin && wo;
}, Bce = 1, b0 = /\s+/g, y0 = function(t, n) {
  for (var o = n.length, i = ""; --t > -1; )
    i += n[~~(Math.random() * o)];
  return i;
}, m1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", _0 = m1.toLowerCase(), Vce = {
  upperCase: new bs(m1),
  lowerCase: new bs(_0),
  upperAndLowerCase: new bs(m1 + _0)
}, C0 = function() {
  Af = wo = $f();
}, Ia = {
  version: "3.13.0",
  name: "scrambleText",
  register: function(t, n, o) {
    wo = t, C0();
  },
  init: function(t, n, o, i, r) {
    if (Af || C0(), this.prop = "innerHTML" in t ? "innerHTML" : "textContent" in t ? "textContent" : 0, !!this.prop) {
      this.target = t, typeof n != "object" && (n = {
        text: n
      });
      var a = n.text || n.value || "", s = n.trim !== !1, l = this, u, m, g, p;
      return l.delimiter = u = n.delimiter || "", l.original = sn(Su(t).replace(b0, " ").split("&nbsp;").join(""), u, s), (a === "{original}" || a === !0 || a == null) && (a = l.original.join(u)), l.text = sn((a || "").replace(b0, " "), u, s), l.hasClass = !!(n.newClass || n.oldClass), l.newClass = n.newClass, l.oldClass = n.oldClass, p = u === "", l.textHasEmoji = p && !!l.text.emoji, l.charsHaveEmoji = !!n.chars && !!sn(n.chars).emoji, l.length = p ? l.original.length : l.original.join(u).length, l.lengthDif = (p ? l.text.length : l.text.join(u).length) - l.length, l.fillChar = n.fillChar || n.chars && ~n.chars.indexOf(" ") ? "&nbsp;" : "", l.charSet = g = Vce[n.chars || "upperCase"] || new bs(n.chars), l.speed = 0.05 / (n.speed || 1), l.prevScrambleTime = 0, l.setIndex = Math.random() * 20 | 0, m = l.length + Math.max(l.lengthDif, 0), m > g.length && g.grow(m), l.chars = g.sets[l.setIndex], l.revealDelay = n.revealDelay || 0, l.tweenLength = n.tweenLength !== !1, l.tween = o, l.rightToLeft = !!n.rightToLeft, l._props.push("scrambleText", "text"), Bce;
    }
  },
  render: function(t, n) {
    var o = n.target, i = n.prop, r = n.text, a = n.delimiter, s = n.tween, l = n.prevScrambleTime, u = n.revealDelay, m = n.setIndex, g = n.chars, p = n.charSet, T = n.length, M = n.textHasEmoji, C = n.charsHaveEmoji, E = n.lengthDif, P = n.tweenLength, F = n.oldClass, D = n.newClass, H = n.rightToLeft, B = n.fillChar, U = n.speed, x = n.original, Z = n.hasClass, q = r.length, ue = s._time, me = ue - l, W, N, G, X, J, re, se, de, pe, ve, Te;
    u && (s._from && (ue = s._dur - ue), t = ue === 0 ? 0 : ue < u ? 1e-6 : ue === s._dur ? 1 : s._ease((ue - u) / (s._dur - u))), t < 0 ? t = 0 : t > 1 && (t = 1), H && (t = 1 - t), W = ~~(t * q + 0.5), t ? ((me > U || me < -U) && (n.setIndex = m = (m + (Math.random() * 19 | 0)) % 20, n.chars = p.sets[m], n.prevScrambleTime += me), X = g) : X = x.join(a), Te = s._from ? t : 1 - t, ve = T + (P ? s._from ? Te * Te * Te : 1 - Te * Te * Te : 1) * E, H ? t === 1 && (s._from || s.data === "isFromStart") ? (G = "", X = x.join(a)) : (se = r.slice(W).join(a), C ? G = sn(X).slice(0, ve - (M ? sn(se) : se).length + 0.5 | 0).join("") : G = X.substr(0, ve - (M ? sn(se) : se).length + 0.5 | 0), X = se) : (G = r.slice(0, W).join(a), N = (M ? sn(G) : G).length, C ? X = sn(X).slice(N, ve + 0.5 | 0).join("") : X = X.substr(N, ve - N + 0.5 | 0)), Z ? (de = H ? F : D, pe = H ? D : F, J = de && W !== 0, re = pe && W !== q, se = (J ? "<span class='" + de + "'>" : "") + G + (J ? "</span>" : "") + (re ? "<span class='" + pe + "'>" : "") + a + X + (re ? "</span>" : "")) : se = G + a + X, o[i] = B === "&nbsp;" && ~se.indexOf("  ") ? se.split("  ").join("&nbsp;&nbsp;") : se;
  }
};
Ia.emojiSafeSplit = sn;
Ia.getText = Su;
$f() && wo.registerPlugin(Ia);
const jce = {
  name: "S5",
  components: {
    CardSlider: Jt
  },
  mixins: [Fi, ut],
  data() {
    return {
      usersReducedMotionPreference: !1
    };
  },
  computed: {
    s5Styles() {
      var e;
      return {
        "--content-alignment": ((e = this.stats.alignment) == null ? void 0 : e.value) || "Left"
      };
    },
    content() {
      return this.stats.content;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight(), this.usersReducedMotionPreference = window.matchMedia("(prefers-reduced-motion: reduce)").matches, !this.usersReducedMotionPreference && !this.isEditing && this.updateCounter();
    }), window.addEventListener("resize", this.setCardHeight), zn.registerPlugin(Ia);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    setCardHeight() {
      if (this.isEditing)
        return;
      this.content.forEach((t, n) => {
        this.$refs[`statsCard-${n}`].style.minHeight = "unset";
      });
      const e = Math.max(...this.content.map((t, n) => this.$refs[`statsCard-${n}`].clientHeight));
      this.content.forEach((t, n) => {
        this.$refs[`statsCard-${n}`].style.minHeight = e ? `${e - 64}px` : "unset";
      });
    },
    updateCounter() {
      const e = document.querySelectorAll(".stats-counter"), t = new Intl.NumberFormat("en-US", {
        style: "decimal",
        notation: "compact",
        compactDisplay: "short",
        maximumFractionDigits: 1
      });
      e.forEach((n, o) => {
        zn.timeline(n, {
          defaults: { ease: "none" },
          scrambleText: {
            text: String(this.stats.content[o].counter_start),
            chars: "0123456789"
          },
          duration: 2
        }).to(n, {
          scrambleText: {
            text: t.format(this.stats.content[o].counter_end),
            chars: "0123456789"
          },
          duration: 2
        });
      });
    }
  }
}, Uce = ["data-testid"], Gce = ["data-testid"], zce = ["aria-label"], Kce = {
  key: 0,
  class: "svg-wrapper"
}, Zce = ["innerHTML"], xce = ["src"], Wce = { class: "snippet-link-container" };
function qce(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("CardSlider");
  return d(), h("div", {
    id: "stats-s5",
    class: v(e.theme.style),
    style: j([e.backgroundStyle, e.colors, r.s5Styles]),
    "data-testid": "S5"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.stats.headline ? (d(), h("h2", {
          key: 0,
          "data-testid": `header-${e.theme.style}`,
          class: v([e.theme.style, "stat-header"])
        }, [
          w(e.$slots, "header", {}, () => [
            A(y(e.stats.component_header), 1)
          ], !0)
        ], 10, Uce)) : b("", !0)
      ]),
      default: _(() => [
        e.stats.show_description ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-description`,
          class: v([e.theme.style, "stat-description"])
        }, [
          w(e.$slots, "description", {}, () => [
            A(y(e.stats.component_description), 1)
          ], !0)
        ], 10, Gce)) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    L(s, {
      "nav-orientation": "wide",
      "has-pager": !1,
      "has-accent": "",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "screen-size": e.screenSize,
      "total-cards": r.content.length,
      "theme-styles": e.theme,
      "section-header": e.stats.component_header,
      class: "card-slider",
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: _(() => [
        (d(), k(K(e.wrapperComponent), we({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.stats.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.stats.content = l),
          "item-key": "index",
          class: ["stats-wrapper", { "all-cards-visible": e.allCardsVisible, "is-editing": e.isEditing }]
        }), {
          item: _(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              class: v(["stats-info", { "is-editing": e.isEditing }]),
              "aria-label": `${u + 1} of ${r.content.length}`,
              role: "group",
              "aria-roledescription": "slide"
            }, [
              c("div", {
                ref: `statsCard-${u}`,
                "data-testid": "stats-card",
                class: v(["stats-card", e.isEditing])
              }, [
                w(e.$slots, "controls", { idx: u }, void 0, !0),
                e.theme.icons_or_images && e.stats.show_icons_or_images ? (d(), h("div", Kce, [
                  w(e.$slots, "icon", { idx: u }, () => {
                    var m;
                    return [
                      l.icon && e.theme.icons_or_images === "icons" ? (d(), h("span", {
                        key: 0,
                        class: "raw-svg",
                        "data-testid": "stats-icon",
                        innerHTML: l.icon
                      }, null, 8, Zce)) : (d(), h("img", {
                        key: 1,
                        class: "stats-image",
                        "data-testid": "stats-image",
                        src: ((m = l.image) == null ? void 0 : m.url) || "",
                        alt: ""
                      }, null, 8, xce))
                    ];
                  }, !0)
                ])) : b("", !0),
                c("h3", {
                  class: v(["stats-counter", [e.theme.style, `stats-counter-${u}`]]),
                  "data-testid": "stats-counter"
                }, [
                  w(e.$slots, "headline", { idx: u }, () => [
                    A(y(i.usersReducedMotionPreference ? l.counter_end : l.counter_start), 1)
                  ], !0)
                ], 2),
                c("div", Wce, [
                  e.stats.snippet ? (d(), h("p", {
                    key: 0,
                    class: v(["stats-snippet", e.theme.style]),
                    "data-testid": "stats-snippet"
                  }, [
                    w(e.$slots, "snippet", { idx: u }, () => [
                      A(y(l.snippet), 1)
                    ], !0)
                  ], 2)) : b("", !0),
                  w(e.$slots, "link", { idx: u }, () => {
                    var m, g;
                    return [
                      e.stats.show_links ? (d(), k(K(e.isPreview || e.isEditing ? "div" : "a"), {
                        key: 0,
                        href: ((m = l.link) == null ? void 0 : m.href) || "#",
                        class: v(["stat-link", e.theme.style]),
                        target: ((g = l.link) == null ? void 0 : g.target) || "_blank",
                        "data-testid": "stat-link"
                      }, {
                        default: _(() => {
                          var p;
                          return [
                            A(y(((p = l.link) == null ? void 0 : p.name) || ""), 1)
                          ];
                        }),
                        _: 2
                      }, 1032, ["href", "class", "target"])) : b("", !0)
                    ];
                  }, !0)
                ])
              ], 2)
            ], 10, zce)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "screen-size", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const Yce = /* @__PURE__ */ O(jce, [["render", qce], ["__scopeId", "data-v-0a8d4d6d"]]), Xce = {
  name: "Stats",
  components: {
    S1: qde,
    S2: hce,
    S3: Tce,
    S4: Hce,
    S5: Yce
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    startIndex: {
      type: Number,
      default: 0
    },
    isEditing: Boolean,
    isPreview: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function Qce(e, t, n, o, i, r) {
  return d(), k(K(n.theme.version), {
    theme: n.theme,
    stats: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    "is-preview": n.isPreview,
    "start-index": n.startIndex
  }, {
    "header-top": _(() => [
      w(e.$slots, "header-top")
    ]),
    header: _(() => [
      w(e.$slots, "header")
    ]),
    description: _(() => [
      w(e.$slots, "description")
    ]),
    "stats-header": _(() => [
      w(e.$slots, "stats-header")
    ]),
    controls: _(({ idx: a }) => [
      w(e.$slots, "controls", { idx: a })
    ]),
    icon: _(({ idx: a }) => [
      w(e.$slots, "icon", { idx: a })
    ]),
    image: _(({ idx: a, position: s }) => [
      w(e.$slots, "image", {
        idx: a,
        position: s
      })
    ]),
    headline: _(({ idx: a }) => [
      w(e.$slots, "headline", { idx: a })
    ]),
    snippet: _(({ idx: a }) => [
      w(e.$slots, "snippet", { idx: a })
    ]),
    link: _(({ idx: a }) => [
      w(e.$slots, "link", { idx: a })
    ]),
    "bottom-headline": _(({ idx: a }) => [
      w(e.$slots, "bottom-headline", { idx: a })
    ]),
    "bottom-snippet": _(({ idx: a }) => [
      w(e.$slots, "bottom-snippet", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "stats", "wrapper-component", "wrapper-props", "is-editing", "is-preview", "start-index"]);
}
const Jce = /* @__PURE__ */ O(Xce, [["render", Qce]]), Mu = {
  mixins: [Tt, mt],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    isPlaceholder: Boolean,
    videoSlotsItems: {
      type: Array,
      default: () => []
    },
    currentVideoThrillshare: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeItem: 0,
      isPlaying: !1,
      readMoreOpen: !1
    };
  },
  methods: {
    playPause(e, t, n) {
      const o = document.getElementById(e);
      if (!o) return;
      const i = n || (this.isPlaying ? "pause" : "play");
      if (t === "youtube")
        o.contentWindow.postMessage(`{"event":"command","func":"${i}Video","args":""}`, "*");
      else if (t === "vimeo") {
        const r = o.querySelector("iframe");
        r && r.contentWindow.postMessage(`{"method":"${i}"}`, "*");
      }
    },
    setIsPlaying({ isPlaying: e }) {
      this.isPlaying = e;
    },
    parseVideo(e) {
      let t = null;
      return e.match(
        /(http:\/\/|https:\/\/|)(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/
      ), RegExp.$3.indexOf("youtu") > -1 ? t = "youtube" : RegExp.$3.indexOf("vimeo") > -1 && (t = "vimeo"), {
        type: t,
        id: RegExp.$6
      };
    },
    getThumbnail(e) {
      return `https://vumbnail.com/${e}_large.jpg`;
    }
  },
  watch: {
    currentVideoThrillshare(e, t) {
      t !== e && (this.activeItem = e);
    },
    content() {
      this.activeItem = this.currentVideoThrillshare;
    }
  },
  computed: {
    videoItems() {
      return this.content.videos.map((e) => {
        const { type: t, id: n } = this.parseVideo(e.url), o = this.getThumbnail(n, t);
        return he(ie({}, e), {
          type: t,
          thumbnail: o,
          videoId: n
        });
      });
    },
    currentItem() {
      return this.videoItems.length === 0 ? {} : this.videoItems[this.activeItem];
    },
    isDesktop() {
      return this.screenSize >= 960;
    },
    colors() {
      const e = this.sharedThemeColors();
      return he(ie({}, e), {
        "--heading-color": S(this.theme, "heading_color.hex", "#333"),
        "--header-accent-color": S(this.theme, "header_accent_color.hex", "#333"),
        "--video-title-color": S(this.theme, "video_title_color.hex", "#333"),
        "--video-text-color": S(this.theme, "video_text_color.hex", "#333"),
        "--arrow-background-color": S(this.theme, "arrow_background_color.hex", "#333"),
        "--arrow-text-color": S(this.theme, "arrow_text_color.hex", "#fff"),
        "--pager-color": S(this.theme, "pager_color.hex", "#333")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayTopHeader() {
      return this.theme.style === "monterrey" && (this.content.component_header_top || this.isEditing);
    }
  }
};
var Au = { exports: {} }, ur = typeof Reflect == "object" ? Reflect : null, w0 = ur && typeof ur.apply == "function" ? ur.apply : function(t, n, o) {
  return Function.prototype.apply.call(t, n, o);
}, ys;
ur && typeof ur.ownKeys == "function" ? ys = ur.ownKeys : Object.getOwnPropertySymbols ? ys = function(t) {
  return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
} : ys = function(t) {
  return Object.getOwnPropertyNames(t);
};
function ehe(e) {
  console && console.warn && console.warn(e);
}
var If = Number.isNaN || function(t) {
  return t !== t;
};
function Ae() {
  Ae.init.call(this);
}
Au.exports = Ae;
Au.exports.once = rhe;
Ae.EventEmitter = Ae;
Ae.prototype._events = void 0;
Ae.prototype._eventsCount = 0;
Ae.prototype._maxListeners = void 0;
var T0 = 10;
function Da(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(Ae, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return T0;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || If(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    T0 = e;
  }
});
Ae.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
Ae.prototype.setMaxListeners = function(t) {
  if (typeof t != "number" || t < 0 || If(t))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
  return this._maxListeners = t, this;
};
function Df(e) {
  return e._maxListeners === void 0 ? Ae.defaultMaxListeners : e._maxListeners;
}
Ae.prototype.getMaxListeners = function() {
  return Df(this);
};
Ae.prototype.emit = function(t) {
  for (var n = [], o = 1; o < arguments.length; o++) n.push(arguments[o]);
  var i = t === "error", r = this._events;
  if (r !== void 0)
    i = i && r.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var a;
    if (n.length > 0 && (a = n[0]), a instanceof Error)
      throw a;
    var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
    throw s.context = a, s;
  }
  var l = r[t];
  if (l === void 0)
    return !1;
  if (typeof l == "function")
    w0(l, this, n);
  else
    for (var u = l.length, m = Hf(l, u), o = 0; o < u; ++o)
      w0(m[o], this, n);
  return !0;
};
function Lf(e, t, n, o) {
  var i, r, a;
  if (Da(n), r = e._events, r === void 0 ? (r = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (r.newListener !== void 0 && (e.emit(
    "newListener",
    t,
    n.listener ? n.listener : n
  ), r = e._events), a = r[t]), a === void 0)
    a = r[t] = n, ++e._eventsCount;
  else if (typeof a == "function" ? a = r[t] = o ? [n, a] : [a, n] : o ? a.unshift(n) : a.push(n), i = Df(e), i > 0 && a.length > i && !a.warned) {
    a.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = a.length, ehe(s);
  }
  return e;
}
Ae.prototype.addListener = function(t, n) {
  return Lf(this, t, n, !1);
};
Ae.prototype.on = Ae.prototype.addListener;
Ae.prototype.prependListener = function(t, n) {
  return Lf(this, t, n, !0);
};
function the() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function Of(e, t, n) {
  var o = { fired: !1, wrapFn: void 0, target: e, type: t, listener: n }, i = the.bind(o);
  return i.listener = n, o.wrapFn = i, i;
}
Ae.prototype.once = function(t, n) {
  return Da(n), this.on(t, Of(this, t, n)), this;
};
Ae.prototype.prependOnceListener = function(t, n) {
  return Da(n), this.prependListener(t, Of(this, t, n)), this;
};
Ae.prototype.removeListener = function(t, n) {
  var o, i, r, a, s;
  if (Da(n), i = this._events, i === void 0)
    return this;
  if (o = i[t], o === void 0)
    return this;
  if (o === n || o.listener === n)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[t], i.removeListener && this.emit("removeListener", t, o.listener || n));
  else if (typeof o != "function") {
    for (r = -1, a = o.length - 1; a >= 0; a--)
      if (o[a] === n || o[a].listener === n) {
        s = o[a].listener, r = a;
        break;
      }
    if (r < 0)
      return this;
    r === 0 ? o.shift() : nhe(o, r), o.length === 1 && (i[t] = o[0]), i.removeListener !== void 0 && this.emit("removeListener", t, s || n);
  }
  return this;
};
Ae.prototype.off = Ae.prototype.removeListener;
Ae.prototype.removeAllListeners = function(t) {
  var n, o, i;
  if (o = this._events, o === void 0)
    return this;
  if (o.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : o[t] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete o[t]), this;
  if (arguments.length === 0) {
    var r = Object.keys(o), a;
    for (i = 0; i < r.length; ++i)
      a = r[i], a !== "removeListener" && this.removeAllListeners(a);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (n = o[t], typeof n == "function")
    this.removeListener(t, n);
  else if (n !== void 0)
    for (i = n.length - 1; i >= 0; i--)
      this.removeListener(t, n[i]);
  return this;
};
function Nf(e, t, n) {
  var o = e._events;
  if (o === void 0)
    return [];
  var i = o[t];
  return i === void 0 ? [] : typeof i == "function" ? n ? [i.listener || i] : [i] : n ? ohe(i) : Hf(i, i.length);
}
Ae.prototype.listeners = function(t) {
  return Nf(this, t, !0);
};
Ae.prototype.rawListeners = function(t) {
  return Nf(this, t, !1);
};
Ae.listenerCount = function(e, t) {
  return typeof e.listenerCount == "function" ? e.listenerCount(t) : Pf.call(e, t);
};
Ae.prototype.listenerCount = Pf;
function Pf(e) {
  var t = this._events;
  if (t !== void 0) {
    var n = t[e];
    if (typeof n == "function")
      return 1;
    if (n !== void 0)
      return n.length;
  }
  return 0;
}
Ae.prototype.eventNames = function() {
  return this._eventsCount > 0 ? ys(this._events) : [];
};
function Hf(e, t) {
  for (var n = new Array(t), o = 0; o < t; ++o)
    n[o] = e[o];
  return n;
}
function nhe(e, t) {
  for (; t + 1 < e.length; t++)
    e[t] = e[t + 1];
  e.pop();
}
function ohe(e) {
  for (var t = new Array(e.length), n = 0; n < t.length; ++n)
    t[n] = e[n].listener || e[n];
  return t;
}
function rhe(e, t) {
  return new Promise(function(n, o) {
    function i(a) {
      e.removeListener(t, r), o(a);
    }
    function r() {
      typeof e.removeListener == "function" && e.removeListener("error", i), n([].slice.call(arguments));
    }
    Ff(e, t, r, { once: !0 }), t !== "error" && ihe(e, i, { once: !0 });
  });
}
function ihe(e, t, n) {
  typeof e.on == "function" && Ff(e, "error", t, n);
}
function Ff(e, t, n, o) {
  if (typeof e.on == "function")
    o.once ? e.once(t, n) : e.on(t, n);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(t, function i(r) {
      o.once && e.removeEventListener(t, i), n(r);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var she = Au.exports;
/*! load-script2. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var ahe = function(t, n, o) {
  return new Promise((i, r) => {
    const a = document.createElement("script");
    a.async = !0, a.src = t;
    for (const [l, u] of Object.entries(n || {}))
      a.setAttribute(l, u);
    a.onload = () => {
      a.onerror = a.onload = null, i(a);
    }, a.onerror = () => {
      a.onerror = a.onload = null, r(new Error(`Failed to load ${t}`));
    }, (o || document.head || document.getElementsByTagName("head")[0]).appendChild(a);
  });
};
/*! yt-player. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
const lhe = she.EventEmitter, uhe = ahe, k0 = "https://www.youtube.com/iframe_api", E0 = {
  "-1": "unstarted",
  0: "ended",
  1: "playing",
  2: "paused",
  3: "buffering",
  5: "cued"
}, Xr = {
  // The request contains an invalid parameter value. For example, this error
  // occurs if you specify a videoId that does not have 11 characters, or if the
  // videoId contains invalid characters, such as exclamation points or asterisks.
  INVALID_PARAM: 2,
  // The requested content cannot be played in an HTML5 player or another error
  // related to the HTML5 player has occurred.
  HTML5_ERROR: 5,
  // The video requested was not found. This error occurs when a video has been
  // removed (for any reason) or has been marked as private.
  NOT_FOUND: 100,
  // The owner of the requested video does not allow it to be played in embedded
  // players.
  UNPLAYABLE_1: 101,
  // This error is the same as 101. It's just a 101 error in disguise!
  UNPLAYABLE_2: 150
}, Qr = [];
class dhe extends lhe {
  constructor(t, n) {
    super();
    const o = typeof t == "string" ? document.querySelector(t) : t;
    o.id ? this._id = o.id : this._id = o.id = "ytplayer-" + Math.random().toString(16).slice(2, 8), this._opts = Object.assign({
      width: 640,
      height: 360,
      autoplay: !1,
      captions: void 0,
      controls: !0,
      keyboard: !0,
      fullscreen: !0,
      annotations: !0,
      modestBranding: !1,
      related: !0,
      timeupdateFrequency: 1e3,
      playsInline: !0,
      start: 0
    }, n), this.videoId = null, this.destroyed = !1, this._api = null, this._autoplay = !1, this._player = null, this._ready = !1, this._queue = [], this._interval = null, this._startInterval = this._startInterval.bind(this), this._stopInterval = this._stopInterval.bind(this), this.on("playing", this._startInterval), this.on("unstarted", this._stopInterval), this.on("ended", this._stopInterval), this.on("paused", this._stopInterval), this.on("buffering", this._stopInterval), this._loadIframeAPI((i, r) => {
      if (i) return this._destroy(new Error("YouTube Iframe API failed to load"));
      this._api = r, this.videoId && this.load(this.videoId, this._autoplay, this._start);
    });
  }
  load(t, n = !1, o = 0) {
    if (!this.destroyed && (this.videoId = t, this._autoplay = n, this._start = o, !!this._api)) {
      if (!this._player) {
        this._createPlayer(t);
        return;
      }
      this._ready && (n ? this._player.loadVideoById(t, o) : this._player.cueVideoById(t, o));
    }
  }
  play() {
    this._ready ? this._player.playVideo() : this._queueCommand("play");
  }
  pause() {
    this._ready ? this._player.pauseVideo() : this._queueCommand("pause");
  }
  stop() {
    this._ready ? this._player.stopVideo() : this._queueCommand("stop");
  }
  seek(t) {
    this._ready ? this._player.seekTo(t, !0) : this._queueCommand("seek", t);
  }
  setVolume(t) {
    this._ready ? this._player.setVolume(t) : this._queueCommand("setVolume", t);
  }
  getVolume() {
    return this._ready && this._player.getVolume() || 0;
  }
  mute() {
    this._ready ? this._player.mute() : this._queueCommand("mute");
  }
  unMute() {
    this._ready ? this._player.unMute() : this._queueCommand("unMute");
  }
  isMuted() {
    return this._ready && this._player.isMuted() || !1;
  }
  setSize(t, n) {
    this._ready ? this._player.setSize(t, n) : this._queueCommand("setSize", t, n);
  }
  setPlaybackRate(t) {
    this._ready ? this._player.setPlaybackRate(t) : this._queueCommand("setPlaybackRate", t);
  }
  setPlaybackQuality(t) {
    this._ready ? this._player.setPlaybackQuality(t) : this._queueCommand("setPlaybackQuality", t);
  }
  getPlaybackRate() {
    return this._ready && this._player.getPlaybackRate() || 1;
  }
  getAvailablePlaybackRates() {
    return this._ready && this._player.getAvailablePlaybackRates() || [1];
  }
  getDuration() {
    return this._ready && this._player.getDuration() || 0;
  }
  getProgress() {
    return this._ready && this._player.getVideoLoadedFraction() || 0;
  }
  getState() {
    return this._ready && E0[this._player.getPlayerState()] || "unstarted";
  }
  getCurrentTime() {
    return this._ready && this._player.getCurrentTime() || 0;
  }
  destroy() {
    this._destroy();
  }
  _destroy(t) {
    this.destroyed || (this.destroyed = !0, this._player && (this._player.stopVideo && this._player.stopVideo(), this._player.destroy()), this.videoId = null, this._id = null, this._opts = null, this._api = null, this._player = null, this._ready = !1, this._queue = null, this._stopInterval(), this.removeListener("playing", this._startInterval), this.removeListener("paused", this._stopInterval), this.removeListener("buffering", this._stopInterval), this.removeListener("unstarted", this._stopInterval), this.removeListener("ended", this._stopInterval), t && this.emit("error", t));
  }
  _queueCommand(t, ...n) {
    this.destroyed || this._queue.push([t, n]);
  }
  _flushQueue() {
    for (; this._queue.length; ) {
      const t = this._queue.shift();
      this[t[0]].apply(this, t[1]);
    }
  }
  _loadIframeAPI(t) {
    if (window.YT && typeof window.YT.Player == "function")
      return t(null, window.YT);
    Qr.push(t), Array.from(document.getElementsByTagName("script")).some((r) => r.src === k0) || uhe(k0).catch((r) => {
      for (; Qr.length; )
        Qr.shift()(r);
    });
    const i = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      for (typeof i == "function" && i(); Qr.length; )
        Qr.shift()(null, window.YT);
    };
  }
  _createPlayer(t) {
    if (this.destroyed) return;
    const n = this._opts;
    this._player = new this._api.Player(this._id, {
      width: n.width,
      height: n.height,
      videoId: t,
      // (Not part of documented API) This parameter controls the hostname that
      // videos are loaded from. Set to `'https://www.youtube-nocookie.com'`
      // for enhanced privacy.
      host: n.host,
      playerVars: {
        // This parameter specifies whether the initial video will automatically
        // start to play when the player loads. Supported values are 0 or 1. The
        // default value is 0.
        autoplay: n.autoplay ? 1 : 0,
        // Setting the parameter's value to 1 causes closed captions to be shown
        // by default, even if the user has turned captions off. The default
        // behavior is based on user preference.
        cc_load_policy: n.captions != null ? n.captions !== !1 ? 1 : 0 : void 0,
        // default to not setting this option
        // Sets the player's interface language. The parameter value is an ISO
        // 639-1 two-letter language code or a fully specified locale. For
        // example, fr and fr-ca are both valid values. Other language input
        // codes, such as IETF language tags (BCP 47) might also be handled
        // properly.
        hl: n.captions != null && n.captions !== !1 ? n.captions : void 0,
        // default to not setting this option
        // This parameter specifies the default language that the player will
        // use to display captions. Set the parameter's value to an ISO 639-1
        // two-letter language code.
        cc_lang_pref: n.captions != null && n.captions !== !1 ? n.captions : void 0,
        // default to not setting this option
        // This parameter indicates whether the video player controls are
        // displayed. For IFrame embeds that load a Flash player, it also defines
        // when the controls display in the player as well as when the player
        // will load. Supported values are:
        //   - controls=0 – Player controls do not display in the player. For
        //                  IFrame embeds, the Flash player loads immediately.
        //   - controls=1 – (default) Player controls display in the player. For
        //                  IFrame embeds, the controls display immediately and
        //                  the Flash player also loads immediately.
        //   - controls=2 – Player controls display in the player. For IFrame
        //                  embeds, the controls display and the Flash player
        //                  loads after the user initiates the video playback.
        controls: n.controls ? 2 : 0,
        // Setting the parameter's value to 1 causes the player to not respond to
        // keyboard controls. The default value is 0, which means that keyboard
        // controls are enabled.
        disablekb: n.keyboard ? 0 : 1,
        // Setting the parameter's value to 1 enables the player to be
        // controlled via IFrame or JavaScript Player API calls. The default
        // value is 0, which means that the player cannot be controlled using
        // those APIs.
        enablejsapi: 1,
        // Setting this parameter to 0 prevents the fullscreen button from
        // displaying in the player. The default value is 1, which causes the
        // fullscreen button to display.
        fs: n.fullscreen ? 1 : 0,
        // Setting the parameter's value to 1 causes video annotations to be
        // shown by default, whereas setting to 3 causes video annotations to not
        // be shown by default. The default value is 1.
        iv_load_policy: n.annotations ? 1 : 3,
        // This parameter lets you use a YouTube player that does not show a
        // YouTube logo. Set the parameter value to 1 to prevent the YouTube logo
        // from displaying in the control bar. Note that a small YouTube text
        // label will still display in the upper-right corner of a paused video
        // when the user's mouse pointer hovers over the player.
        modestbranding: n.modestBranding ? 1 : 0,
        // This parameter provides an extra security measure for the IFrame API
        // and is only supported for IFrame embeds. If you are using the IFrame
        // API, which means you are setting the enablejsapi parameter value to 1,
        // you should always specify your domain as the origin parameter value.
        origin: window.location.origin,
        // This parameter controls whether videos play inline or fullscreen in an
        // HTML5 player on iOS. Valid values are:
        //   - 0: This value causes fullscreen playback. This is currently the
        //        default value, though the default is subject to change.
        //   - 1: This value causes inline playback for UIWebViews created with
        //        the allowsInlineMediaPlayback property set to TRUE.
        playsinline: n.playsInline ? 1 : 0,
        // This parameter indicates whether the player should show related
        // videos from the same channel (0) or from any channel (1) when
        // playback of the video ends. The default value is 1.
        rel: n.related ? 1 : 0,
        // (Not part of documented API) Allow html elements with higher z-index
        // to be shown on top of the YouTube player.
        wmode: "opaque",
        // This parameter causes the player to begin playing the video at the given number
        // of seconds from the start of the video. The parameter value is a positive integer.
        // Note that similar to the seek function, the player will look for the closest
        // keyframe to the time you specify. This means that sometimes the play head may seek
        // to just before the requested time, usually no more than around two seconds.
        start: n.start
      },
      events: {
        onReady: () => this._onReady(t),
        onStateChange: (o) => this._onStateChange(o),
        onPlaybackQualityChange: (o) => this._onPlaybackQualityChange(o),
        onPlaybackRateChange: (o) => this._onPlaybackRateChange(o),
        onError: (o) => this._onError(o)
      }
    });
  }
  /**
   * This event fires when the player has finished loading and is ready to begin
   * receiving API calls.
   */
  _onReady(t) {
    this.destroyed || (this._ready = !0, this.load(this.videoId, this._autoplay, this._start), this._flushQueue());
  }
  /**
   * Called when the player's state changes. We emit friendly events so the user
   * doesn't need to use YouTube's YT.PlayerState.* event constants.
   */
  _onStateChange(t) {
    if (this.destroyed) return;
    const n = E0[t.data];
    if (n)
      ["paused", "buffering", "ended"].includes(n) && this._onTimeupdate(), this.emit(n), ["unstarted", "playing", "cued"].includes(n) && this._onTimeupdate();
    else
      throw new Error("Unrecognized state change: " + t);
  }
  /**
   * This event fires whenever the video playback quality changes. Possible
   * values are: 'small', 'medium', 'large', 'hd720', 'hd1080', 'highres'.
   */
  _onPlaybackQualityChange(t) {
    this.destroyed || this.emit("playbackQualityChange", t.data);
  }
  /**
   * This event fires whenever the video playback rate changes.
   */
  _onPlaybackRateChange(t) {
    this.destroyed || this.emit("playbackRateChange", t.data);
  }
  /**
   * This event fires if an error occurs in the player.
   */
  _onError(t) {
    if (this.destroyed) return;
    const n = Number(t.data);
    if (n !== Xr.HTML5_ERROR) {
      if (n === Xr.UNPLAYABLE_1 || n === Xr.UNPLAYABLE_2 || n === Xr.NOT_FOUND || n === Xr.INVALID_PARAM)
        return this.emit("unplayable", this.videoId);
      this._destroy(new Error("YouTube Player Error. Unknown error code: " + n));
    }
  }
  /**
   * This event fires when the time indicated by the `getCurrentTime()` method
   * has been updated.
   */
  _onTimeupdate() {
    this.emit("timeupdate", this.getCurrentTime());
  }
  _startInterval() {
    this._interval = setInterval(() => this._onTimeupdate(), this._opts.timeupdateFrequency);
  }
  _stopInterval() {
    clearInterval(this._interval), this._interval = null;
  }
}
var che = dhe;
const hhe = /* @__PURE__ */ br(che);
/*! @vimeo/player v2.25.1 | (c) 2025 Vimeo | MIT License | https://github.com/vimeo/player.js */
function S0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function M0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S0(Object(n), !0).forEach(function(o) {
      _s(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : S0(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function dt() {
  dt = function() {
    return e;
  };
  var e = {}, t = Object.prototype, n = t.hasOwnProperty, o = Object.defineProperty || function(W, N, G) {
    W[N] = G.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, r = i.iterator || "@@iterator", a = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
  function l(W, N, G) {
    return Object.defineProperty(W, N, {
      value: G,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), W[N];
  }
  try {
    l({}, "");
  } catch (W) {
    l = function(N, G, X) {
      return N[G] = X;
    };
  }
  function u(W, N, G, X) {
    var J = N && N.prototype instanceof p ? N : p, re = Object.create(J.prototype), se = new q(X || []);
    return o(re, "_invoke", {
      value: B(W, G, se)
    }), re;
  }
  function m(W, N, G) {
    try {
      return {
        type: "normal",
        arg: W.call(N, G)
      };
    } catch (X) {
      return {
        type: "throw",
        arg: X
      };
    }
  }
  e.wrap = u;
  var g = {};
  function p() {
  }
  function T() {
  }
  function M() {
  }
  var C = {};
  l(C, r, function() {
    return this;
  });
  var E = Object.getPrototypeOf, P = E && E(E(ue([])));
  P && P !== t && n.call(P, r) && (C = P);
  var F = M.prototype = p.prototype = Object.create(C);
  function D(W) {
    ["next", "throw", "return"].forEach(function(N) {
      l(W, N, function(G) {
        return this._invoke(N, G);
      });
    });
  }
  function H(W, N) {
    function G(J, re, se, de) {
      var pe = m(W[J], W, re);
      if (pe.type !== "throw") {
        var ve = pe.arg, Te = ve.value;
        return Te && typeof Te == "object" && n.call(Te, "__await") ? N.resolve(Te.__await).then(function(ot) {
          G("next", ot, se, de);
        }, function(ot) {
          G("throw", ot, se, de);
        }) : N.resolve(Te).then(function(ot) {
          ve.value = ot, se(ve);
        }, function(ot) {
          return G("throw", ot, se, de);
        });
      }
      de(pe.arg);
    }
    var X;
    o(this, "_invoke", {
      value: function(J, re) {
        function se() {
          return new N(function(de, pe) {
            G(J, re, de, pe);
          });
        }
        return X = X ? X.then(se, se) : se();
      }
    });
  }
  function B(W, N, G) {
    var X = "suspendedStart";
    return function(J, re) {
      if (X === "executing") throw new Error("Generator is already running");
      if (X === "completed") {
        if (J === "throw") throw re;
        return me();
      }
      for (G.method = J, G.arg = re; ; ) {
        var se = G.delegate;
        if (se) {
          var de = U(se, G);
          if (de) {
            if (de === g) continue;
            return de;
          }
        }
        if (G.method === "next") G.sent = G._sent = G.arg;
        else if (G.method === "throw") {
          if (X === "suspendedStart") throw X = "completed", G.arg;
          G.dispatchException(G.arg);
        } else G.method === "return" && G.abrupt("return", G.arg);
        X = "executing";
        var pe = m(W, N, G);
        if (pe.type === "normal") {
          if (X = G.done ? "completed" : "suspendedYield", pe.arg === g) continue;
          return {
            value: pe.arg,
            done: G.done
          };
        }
        pe.type === "throw" && (X = "completed", G.method = "throw", G.arg = pe.arg);
      }
    };
  }
  function U(W, N) {
    var G = N.method, X = W.iterator[G];
    if (X === void 0) return N.delegate = null, G === "throw" && W.iterator.return && (N.method = "return", N.arg = void 0, U(W, N), N.method === "throw") || G !== "return" && (N.method = "throw", N.arg = new TypeError("The iterator does not provide a '" + G + "' method")), g;
    var J = m(X, W.iterator, N.arg);
    if (J.type === "throw") return N.method = "throw", N.arg = J.arg, N.delegate = null, g;
    var re = J.arg;
    return re ? re.done ? (N[W.resultName] = re.value, N.next = W.nextLoc, N.method !== "return" && (N.method = "next", N.arg = void 0), N.delegate = null, g) : re : (N.method = "throw", N.arg = new TypeError("iterator result is not an object"), N.delegate = null, g);
  }
  function x(W) {
    var N = {
      tryLoc: W[0]
    };
    1 in W && (N.catchLoc = W[1]), 2 in W && (N.finallyLoc = W[2], N.afterLoc = W[3]), this.tryEntries.push(N);
  }
  function Z(W) {
    var N = W.completion || {};
    N.type = "normal", delete N.arg, W.completion = N;
  }
  function q(W) {
    this.tryEntries = [{
      tryLoc: "root"
    }], W.forEach(x, this), this.reset(!0);
  }
  function ue(W) {
    if (W) {
      var N = W[r];
      if (N) return N.call(W);
      if (typeof W.next == "function") return W;
      if (!isNaN(W.length)) {
        var G = -1, X = function J() {
          for (; ++G < W.length; ) if (n.call(W, G)) return J.value = W[G], J.done = !1, J;
          return J.value = void 0, J.done = !0, J;
        };
        return X.next = X;
      }
    }
    return {
      next: me
    };
  }
  function me() {
    return {
      value: void 0,
      done: !0
    };
  }
  return T.prototype = M, o(F, "constructor", {
    value: M,
    configurable: !0
  }), o(M, "constructor", {
    value: T,
    configurable: !0
  }), T.displayName = l(M, s, "GeneratorFunction"), e.isGeneratorFunction = function(W) {
    var N = typeof W == "function" && W.constructor;
    return !!N && (N === T || (N.displayName || N.name) === "GeneratorFunction");
  }, e.mark = function(W) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(W, M) : (W.__proto__ = M, l(W, s, "GeneratorFunction")), W.prototype = Object.create(F), W;
  }, e.awrap = function(W) {
    return {
      __await: W
    };
  }, D(H.prototype), l(H.prototype, a, function() {
    return this;
  }), e.AsyncIterator = H, e.async = function(W, N, G, X, J) {
    J === void 0 && (J = Promise);
    var re = new H(u(W, N, G, X), J);
    return e.isGeneratorFunction(N) ? re : re.next().then(function(se) {
      return se.done ? se.value : re.next();
    });
  }, D(F), l(F, s, "Generator"), l(F, r, function() {
    return this;
  }), l(F, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(W) {
    var N = Object(W), G = [];
    for (var X in N) G.push(X);
    return G.reverse(), function J() {
      for (; G.length; ) {
        var re = G.pop();
        if (re in N) return J.value = re, J.done = !1, J;
      }
      return J.done = !0, J;
    };
  }, e.values = ue, q.prototype = {
    constructor: q,
    reset: function(W) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(Z), !W) for (var N in this) N.charAt(0) === "t" && n.call(this, N) && !isNaN(+N.slice(1)) && (this[N] = void 0);
    },
    stop: function() {
      this.done = !0;
      var W = this.tryEntries[0].completion;
      if (W.type === "throw") throw W.arg;
      return this.rval;
    },
    dispatchException: function(W) {
      if (this.done) throw W;
      var N = this;
      function G(pe, ve) {
        return re.type = "throw", re.arg = W, N.next = pe, ve && (N.method = "next", N.arg = void 0), !!ve;
      }
      for (var X = this.tryEntries.length - 1; X >= 0; --X) {
        var J = this.tryEntries[X], re = J.completion;
        if (J.tryLoc === "root") return G("end");
        if (J.tryLoc <= this.prev) {
          var se = n.call(J, "catchLoc"), de = n.call(J, "finallyLoc");
          if (se && de) {
            if (this.prev < J.catchLoc) return G(J.catchLoc, !0);
            if (this.prev < J.finallyLoc) return G(J.finallyLoc);
          } else if (se) {
            if (this.prev < J.catchLoc) return G(J.catchLoc, !0);
          } else {
            if (!de) throw new Error("try statement without catch or finally");
            if (this.prev < J.finallyLoc) return G(J.finallyLoc);
          }
        }
      }
    },
    abrupt: function(W, N) {
      for (var G = this.tryEntries.length - 1; G >= 0; --G) {
        var X = this.tryEntries[G];
        if (X.tryLoc <= this.prev && n.call(X, "finallyLoc") && this.prev < X.finallyLoc) {
          var J = X;
          break;
        }
      }
      J && (W === "break" || W === "continue") && J.tryLoc <= N && N <= J.finallyLoc && (J = null);
      var re = J ? J.completion : {};
      return re.type = W, re.arg = N, J ? (this.method = "next", this.next = J.finallyLoc, g) : this.complete(re);
    },
    complete: function(W, N) {
      if (W.type === "throw") throw W.arg;
      return W.type === "break" || W.type === "continue" ? this.next = W.arg : W.type === "return" ? (this.rval = this.arg = W.arg, this.method = "return", this.next = "end") : W.type === "normal" && N && (this.next = N), g;
    },
    finish: function(W) {
      for (var N = this.tryEntries.length - 1; N >= 0; --N) {
        var G = this.tryEntries[N];
        if (G.finallyLoc === W) return this.complete(G.completion, G.afterLoc), Z(G), g;
      }
    },
    catch: function(W) {
      for (var N = this.tryEntries.length - 1; N >= 0; --N) {
        var G = this.tryEntries[N];
        if (G.tryLoc === W) {
          var X = G.completion;
          if (X.type === "throw") {
            var J = X.arg;
            Z(G);
          }
          return J;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(W, N, G) {
      return this.delegate = {
        iterator: ue(W),
        resultName: N,
        nextLoc: G
      }, this.method === "next" && (this.arg = void 0), g;
    }
  }, e;
}
function A0(e, t, n, o, i, r, a) {
  try {
    var s = e[r](a), l = s.value;
  } catch (u) {
    n(u);
    return;
  }
  s.done ? t(l) : Promise.resolve(l).then(o, i);
}
function bo(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(o, i) {
      var r = e.apply(t, n);
      function a(l) {
        A0(r, o, i, a, s, "next", l);
      }
      function s(l) {
        A0(r, o, i, a, s, "throw", l);
      }
      a(void 0);
    });
  };
}
function Rf(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function mhe(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, jf(o.key), o);
  }
}
function Bf(e, t, n) {
  return t && mhe(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _s(e, t, n) {
  return t = jf(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function phe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Ei(e, t);
}
function ki(e) {
  return ki = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, ki(e);
}
function Ei(e, t) {
  return Ei = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, i) {
    return o.__proto__ = i, o;
  }, Ei(e, t);
}
function Vf() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch (e) {
    return !1;
  }
}
function Cs(e, t, n) {
  return Vf() ? Cs = Reflect.construct.bind() : Cs = function(i, r, a) {
    var s = [null];
    s.push.apply(s, r);
    var l = Function.bind.apply(i, s), u = new l();
    return a && Ei(u, a.prototype), u;
  }, Cs.apply(null, arguments);
}
function fhe(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function p1(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return p1 = function(o) {
    if (o === null || !fhe(o)) return o;
    if (typeof o != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t != "undefined") {
      if (t.has(o)) return t.get(o);
      t.set(o, i);
    }
    function i() {
      return Cs(o, arguments, ki(this).constructor);
    }
    return i.prototype = Object.create(o.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Ei(i, o);
  }, p1(e);
}
function ws(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ghe(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ws(e);
}
function vhe(e) {
  var t = Vf();
  return function() {
    var o = ki(e), i;
    if (t) {
      var r = ki(this).constructor;
      i = Reflect.construct(o, arguments, r);
    } else
      i = o.apply(this, arguments);
    return ghe(this, i);
  };
}
function bhe(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function jf(e) {
  var t = bhe(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Uf = typeof global != "undefined" && {}.toString.call(global) === "[object global]";
function $0(e, t) {
  return e.indexOf(t.toLowerCase()) === 0 ? e : "".concat(t.toLowerCase()).concat(e.substr(0, 1).toUpperCase()).concat(e.substr(1));
}
function yhe(e) {
  return !!(e && e.nodeType === 1 && "nodeName" in e && e.ownerDocument && e.ownerDocument.defaultView);
}
function _he(e) {
  return !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e;
}
function Io(e) {
  return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(e);
}
function Gf(e) {
  var t = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
  return t.test(e);
}
function Che(e) {
  for (var t = (e || "").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/), n = (t && t[1] || "").replace("player.", ""), o = [".videoji.hk", ".vimeo.work", ".videoji.cn"], i = 0, r = o; i < r.length; i++) {
    var a = r[i];
    if (n.endsWith(a))
      return n;
  }
  return "vimeo.com";
}
function zf() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.id, n = e.url, o = t || n;
  if (!o)
    throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
  if (_he(o))
    return "https://vimeo.com/".concat(o);
  if (Io(o))
    return o.replace("http:", "https:");
  throw t ? new TypeError("“".concat(t, "” is not a valid video id.")) : new TypeError("“".concat(o, "” is not a vimeo.com url."));
}
var I0 = function(t, n, o) {
  var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "addEventListener", r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "removeEventListener", a = typeof n == "string" ? [n] : n;
  return a.forEach(function(s) {
    t[i](s, o);
  }), {
    cancel: function() {
      return a.forEach(function(l) {
        return t[r](l, o);
      });
    }
  };
}, whe = typeof Array.prototype.indexOf != "undefined", The = typeof window != "undefined" && typeof window.postMessage != "undefined";
if (!Uf && (!whe || !The))
  throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var dr = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function khe(e, t) {
  return t = { exports: {} }, e(t, t.exports), t.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function(e) {
  if (e.WeakMap)
    return;
  var t = Object.prototype.hasOwnProperty, n = Object.defineProperty && function() {
    try {
      return Object.defineProperty({}, "x", {
        value: 1
      }).x === 1;
    } catch (r) {
    }
  }(), o = function(r, a, s) {
    n ? Object.defineProperty(r, a, {
      configurable: !0,
      writable: !0,
      value: s
    }) : r[a] = s;
  };
  e.WeakMap = function() {
    function r() {
      if (this === void 0)
        throw new TypeError("Constructor WeakMap requires 'new'");
      if (o(this, "_id", s("_WeakMap")), arguments.length > 0)
        throw new TypeError("WeakMap iterable is not supported");
    }
    o(r.prototype, "delete", function(u) {
      if (a(this, "delete"), !i(u))
        return !1;
      var m = u[this._id];
      return m && m[0] === u ? (delete u[this._id], !0) : !1;
    }), o(r.prototype, "get", function(u) {
      if (a(this, "get"), !!i(u)) {
        var m = u[this._id];
        if (m && m[0] === u)
          return m[1];
      }
    }), o(r.prototype, "has", function(u) {
      if (a(this, "has"), !i(u))
        return !1;
      var m = u[this._id];
      return !!(m && m[0] === u);
    }), o(r.prototype, "set", function(u, m) {
      if (a(this, "set"), !i(u))
        throw new TypeError("Invalid value used as weak map key");
      var g = u[this._id];
      return g && g[0] === u ? (g[1] = m, this) : (o(u, this._id, [u, m]), this);
    });
    function a(u, m) {
      if (!i(u) || !t.call(u, "_id"))
        throw new TypeError(m + " method called on incompatible receiver " + typeof u);
    }
    function s(u) {
      return u + "_" + l() + "." + l();
    }
    function l() {
      return Math.random().toString().substring(2);
    }
    return o(r, "_polyfill", !0), r;
  }();
  function i(r) {
    return Object(r) === r;
  }
})(typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : dr);
var Ht = khe(function(e) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function(n, o, i) {
    o[n] = o[n] || i(), e.exports && (e.exports = o[n]);
  })("Promise", dr, function() {
    var n, o, i, r = Object.prototype.toString, a = typeof setImmediate != "undefined" ? function(D) {
      return setImmediate(D);
    } : setTimeout;
    try {
      Object.defineProperty({}, "x", {}), n = function(D, H, B, U) {
        return Object.defineProperty(D, H, {
          value: B,
          writable: !0,
          configurable: U !== !1
        });
      };
    } catch (F) {
      n = function(H, B, U) {
        return H[B] = U, H;
      };
    }
    i = /* @__PURE__ */ function() {
      var D, H, B;
      function U(x, Z) {
        this.fn = x, this.self = Z, this.next = void 0;
      }
      return {
        add: function(Z, q) {
          B = new U(Z, q), H ? H.next = B : D = B, H = B, B = void 0;
        },
        drain: function() {
          var Z = D;
          for (D = H = o = void 0; Z; )
            Z.fn.call(Z.self), Z = Z.next;
        }
      };
    }();
    function s(F, D) {
      i.add(F, D), o || (o = a(i.drain));
    }
    function l(F) {
      var D, H = typeof F;
      return F != null && (H == "object" || H == "function") && (D = F.then), typeof D == "function" ? D : !1;
    }
    function u() {
      for (var F = 0; F < this.chain.length; F++)
        m(this, this.state === 1 ? this.chain[F].success : this.chain[F].failure, this.chain[F]);
      this.chain.length = 0;
    }
    function m(F, D, H) {
      var B, U;
      try {
        D === !1 ? H.reject(F.msg) : (D === !0 ? B = F.msg : B = D.call(void 0, F.msg), B === H.promise ? H.reject(TypeError("Promise-chain cycle")) : (U = l(B)) ? U.call(B, H.resolve, H.reject) : H.resolve(B));
      } catch (x) {
        H.reject(x);
      }
    }
    function g(F) {
      var D, H = this;
      if (!H.triggered) {
        H.triggered = !0, H.def && (H = H.def);
        try {
          (D = l(F)) ? s(function() {
            var B = new M(H);
            try {
              D.call(F, function() {
                g.apply(B, arguments);
              }, function() {
                p.apply(B, arguments);
              });
            } catch (U) {
              p.call(B, U);
            }
          }) : (H.msg = F, H.state = 1, H.chain.length > 0 && s(u, H));
        } catch (B) {
          p.call(new M(H), B);
        }
      }
    }
    function p(F) {
      var D = this;
      D.triggered || (D.triggered = !0, D.def && (D = D.def), D.msg = F, D.state = 2, D.chain.length > 0 && s(u, D));
    }
    function T(F, D, H, B) {
      for (var U = 0; U < D.length; U++)
        (function(Z) {
          F.resolve(D[Z]).then(function(ue) {
            H(Z, ue);
          }, B);
        })(U);
    }
    function M(F) {
      this.def = F, this.triggered = !1;
    }
    function C(F) {
      this.promise = F, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
    }
    function E(F) {
      if (typeof F != "function")
        throw TypeError("Not a function");
      if (this.__NPO__ !== 0)
        throw TypeError("Not a promise");
      this.__NPO__ = 1;
      var D = new C(this);
      this.then = function(B, U) {
        var x = {
          success: typeof B == "function" ? B : !0,
          failure: typeof U == "function" ? U : !1
        };
        return x.promise = new this.constructor(function(q, ue) {
          if (typeof q != "function" || typeof ue != "function")
            throw TypeError("Not a function");
          x.resolve = q, x.reject = ue;
        }), D.chain.push(x), D.state !== 0 && s(u, D), x.promise;
      }, this.catch = function(B) {
        return this.then(void 0, B);
      };
      try {
        F.call(void 0, function(B) {
          g.call(D, B);
        }, function(B) {
          p.call(D, B);
        });
      } catch (H) {
        p.call(D, H);
      }
    }
    var P = n(
      {},
      "constructor",
      E,
      /*configurable=*/
      !1
    );
    return E.prototype = P, n(
      P,
      "__NPO__",
      0,
      /*configurable=*/
      !1
    ), n(E, "resolve", function(D) {
      var H = this;
      return D && typeof D == "object" && D.__NPO__ === 1 ? D : new H(function(U, x) {
        if (typeof U != "function" || typeof x != "function")
          throw TypeError("Not a function");
        U(D);
      });
    }), n(E, "reject", function(D) {
      return new this(function(B, U) {
        if (typeof B != "function" || typeof U != "function")
          throw TypeError("Not a function");
        U(D);
      });
    }), n(E, "all", function(D) {
      var H = this;
      return r.call(D) != "[object Array]" ? H.reject(TypeError("Not an array")) : D.length === 0 ? H.resolve([]) : new H(function(U, x) {
        if (typeof U != "function" || typeof x != "function")
          throw TypeError("Not a function");
        var Z = D.length, q = Array(Z), ue = 0;
        T(H, D, function(W, N) {
          q[W] = N, ++ue === Z && U(q);
        }, x);
      });
    }), n(E, "race", function(D) {
      var H = this;
      return r.call(D) != "[object Array]" ? H.reject(TypeError("Not an array")) : new H(function(U, x) {
        if (typeof U != "function" || typeof x != "function")
          throw TypeError("Not a function");
        T(H, D, function(q, ue) {
          U(ue);
        }, x);
      });
    }), E;
  });
}), Mn = /* @__PURE__ */ new WeakMap();
function Jr(e, t, n) {
  var o = Mn.get(e.element) || {};
  t in o || (o[t] = []), o[t].push(n), Mn.set(e.element, o);
}
function xs(e, t) {
  var n = Mn.get(e.element) || {};
  return n[t] || [];
}
function Ws(e, t, n) {
  var o = Mn.get(e.element) || {};
  if (!o[t])
    return !0;
  if (!n)
    return o[t] = [], Mn.set(e.element, o), !0;
  var i = o[t].indexOf(n);
  return i !== -1 && o[t].splice(i, 1), Mn.set(e.element, o), o[t] && o[t].length === 0;
}
function Ehe(e, t) {
  var n = xs(e, t);
  if (n.length < 1)
    return !1;
  var o = n.shift();
  return Ws(e, t, o), o;
}
function She(e, t) {
  var n = Mn.get(e);
  Mn.set(t, n), Mn.delete(e);
}
function La(e) {
  if (typeof e == "string")
    try {
      e = JSON.parse(e);
    } catch (t) {
      return console.warn(t), {};
    }
  return e;
}
function ho(e, t, n) {
  if (!(!e.element.contentWindow || !e.element.contentWindow.postMessage)) {
    var o = {
      method: t
    };
    n !== void 0 && (o.value = n);
    var i = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    i >= 8 && i < 10 && (o = JSON.stringify(o)), e.element.contentWindow.postMessage(o, e.origin);
  }
}
function Mhe(e, t) {
  t = La(t);
  var n = [], o;
  if (t.event) {
    if (t.event === "error") {
      var i = xs(e, t.data.method);
      i.forEach(function(a) {
        var s = new Error(t.data.message);
        s.name = t.data.name, a.reject(s), Ws(e, t.data.method, a);
      });
    }
    n = xs(e, "event:".concat(t.event)), o = t.data;
  } else if (t.method) {
    var r = Ehe(e, t.method);
    r && (n.push(r), o = t.value);
  }
  n.forEach(function(a) {
    try {
      if (typeof a == "function") {
        a.call(e, o);
        return;
      }
      a.resolve(o);
    } catch (s) {
    }
  });
}
var Ahe = ["airplay", "audio_tracks", "audiotrack", "autopause", "autoplay", "background", "byline", "cc", "chapter_id", "chapters", "chromecast", "color", "colors", "controls", "dnt", "end_time", "fullscreen", "height", "id", "interactive_params", "keyboard", "loop", "maxheight", "maxwidth", "muted", "play_button_position", "playsinline", "portrait", "progress_bar", "quality_selector", "responsive", "speed", "start_time", "texttrack", "title", "transcript", "transparent", "unmute_button", "url", "vimeo_logo", "volume", "watch_full_video", "width"];
function Kf(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Ahe.reduce(function(n, o) {
    var i = e.getAttribute("data-vimeo-".concat(o));
    return (i || i === "") && (n[o] = i === "" ? 1 : i), n;
  }, t);
}
function $u(e, t) {
  var n = e.html;
  if (!t)
    throw new TypeError("An element must be provided");
  if (t.getAttribute("data-vimeo-initialized") !== null)
    return t.querySelector("iframe");
  var o = document.createElement("div");
  return o.innerHTML = n, t.appendChild(o.firstChild), t.setAttribute("data-vimeo-initialized", "true"), t.querySelector("iframe");
}
function Zf(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  return new Promise(function(o, i) {
    if (!Io(e))
      throw new TypeError("“".concat(e, "” is not a vimeo.com url."));
    var r = Che(e), a = "https://".concat(r, "/api/oembed.json?url=").concat(encodeURIComponent(e));
    for (var s in t)
      t.hasOwnProperty(s) && (a += "&".concat(s, "=").concat(encodeURIComponent(t[s])));
    var l = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
    l.open("GET", a, !0), l.onload = function() {
      if (l.status === 404) {
        i(new Error("“".concat(e, "” was not found.")));
        return;
      }
      if (l.status === 403) {
        i(new Error("“".concat(e, "” is not embeddable.")));
        return;
      }
      try {
        var u = JSON.parse(l.responseText);
        if (u.domain_status_code === 403) {
          $u(u, n), i(new Error("“".concat(e, "” is not embeddable.")));
          return;
        }
        o(u);
      } catch (m) {
        i(m);
      }
    }, l.onerror = function() {
      var u = l.status ? " (".concat(l.status, ")") : "";
      i(new Error("There was an error fetching the embed code from Vimeo".concat(u, ".")));
    }, l.send();
  });
}
function $he() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t = [].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")), n = function(i) {
    "console" in window && console.error && console.error("There was an error creating an embed: ".concat(i));
  };
  t.forEach(function(o) {
    try {
      if (o.getAttribute("data-vimeo-defer") !== null)
        return;
      var i = Kf(o), r = zf(i);
      Zf(r, i, o).then(function(a) {
        return $u(a, o);
      }).catch(n);
    } catch (a) {
      n(a);
    }
  });
}
function Ihe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoPlayerResizeEmbeds_) {
    window.VimeoPlayerResizeEmbeds_ = !0;
    var t = function(o) {
      if (Io(o.origin) && !(!o.data || o.data.event !== "spacechange")) {
        for (var i = e.querySelectorAll("iframe"), r = 0; r < i.length; r++)
          if (i[r].contentWindow === o.source) {
            var a = i[r].parentElement;
            a.style.paddingBottom = "".concat(o.data.data[0].bottom, "px");
            break;
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function Dhe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoSeoMetadataAppended) {
    window.VimeoSeoMetadataAppended = !0;
    var t = function(o) {
      if (Io(o.origin)) {
        var i = La(o.data);
        if (!(!i || i.event !== "ready"))
          for (var r = e.querySelectorAll("iframe"), a = 0; a < r.length; a++) {
            var s = r[a], l = s.contentWindow === o.source;
            if (Gf(s.src) && l) {
              var u = new Iu(s);
              u.callMethod("appendVideoMetadata", window.location.href);
            }
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function Lhe() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoCheckedUrlTimeParam) {
    window.VimeoCheckedUrlTimeParam = !0;
    var t = function(i) {
      "console" in window && console.error && console.error("There was an error getting video Id: ".concat(i));
    }, n = function(i) {
      if (Io(i.origin)) {
        var r = La(i.data);
        if (!(!r || r.event !== "ready"))
          for (var a = e.querySelectorAll("iframe"), s = function() {
            var m = a[l], g = m.contentWindow === i.source;
            if (Gf(m.src) && g) {
              var p = new Iu(m);
              p.getVideoId().then(function(T) {
                var M = new RegExp("[?&]vimeo_t_".concat(T, "=([^&#]*)")).exec(window.location.href);
                if (M && M[1]) {
                  var C = decodeURI(M[1]);
                  p.setCurrentTime(C);
                }
              }).catch(t);
            }
          }, l = 0; l < a.length; l++)
            s();
      }
    };
    window.addEventListener("message", n);
  }
}
function Ohe() {
  var e = function() {
    for (var o, i = [
      ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
      // New WebKit
      ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
      // Old WebKit
      ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
      ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
      ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
    ], r = 0, a = i.length, s = {}; r < a; r++)
      if (o = i[r], o && o[1] in document) {
        for (r = 0; r < o.length; r++)
          s[i[0][r]] = o[r];
        return s;
      }
    return !1;
  }(), t = {
    fullscreenchange: e.fullscreenchange,
    fullscreenerror: e.fullscreenerror
  }, n = {
    request: function(i) {
      return new Promise(function(r, a) {
        var s = function u() {
          n.off("fullscreenchange", u), r();
        };
        n.on("fullscreenchange", s), i = i || document.documentElement;
        var l = i[e.requestFullscreen]();
        l instanceof Promise && l.then(s).catch(a);
      });
    },
    exit: function() {
      return new Promise(function(i, r) {
        if (!n.isFullscreen) {
          i();
          return;
        }
        var a = function l() {
          n.off("fullscreenchange", l), i();
        };
        n.on("fullscreenchange", a);
        var s = document[e.exitFullscreen]();
        s instanceof Promise && s.then(a).catch(r);
      });
    },
    on: function(i, r) {
      var a = t[i];
      a && document.addEventListener(a, r);
    },
    off: function(i, r) {
      var a = t[i];
      a && document.removeEventListener(a, r);
    }
  };
  return Object.defineProperties(n, {
    isFullscreen: {
      get: function() {
        return !!document[e.fullscreenElement];
      }
    },
    element: {
      enumerable: !0,
      get: function() {
        return document[e.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: !0,
      get: function() {
        return !!document[e.fullscreenEnabled];
      }
    }
  }), n;
}
var Nhe = {
  role: "viewer",
  autoPlayMuted: !0,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
}, Phe = /* @__PURE__ */ function(e) {
  phe(n, e);
  var t = vhe(n);
  function n(o, i) {
    var r, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    return Rf(this, n), r = t.call(this), _s(ws(r), "logger", void 0), _s(ws(r), "speedAdjustment", 0), _s(ws(r), "adjustSpeed", /* @__PURE__ */ function() {
      var l = bo(/* @__PURE__ */ dt().mark(function u(m, g) {
        var p;
        return dt().wrap(function(M) {
          for (; ; ) switch (M.prev = M.next) {
            case 0:
              if (r.speedAdjustment !== g) {
                M.next = 2;
                break;
              }
              return M.abrupt("return");
            case 2:
              return M.next = 4, m.getPlaybackRate();
            case 4:
              return M.t0 = M.sent, M.t1 = r.speedAdjustment, M.t2 = M.t0 - M.t1, M.t3 = g, p = M.t2 + M.t3, r.log("New playbackRate:  ".concat(p)), M.next = 12, m.setPlaybackRate(p);
            case 12:
              r.speedAdjustment = g;
            case 13:
            case "end":
              return M.stop();
          }
        }, u);
      }));
      return function(u, m) {
        return l.apply(this, arguments);
      };
    }()), r.logger = s, r.init(i, o, M0(M0({}, Nhe), a)), r;
  }
  return Bf(n, [{
    key: "disconnect",
    value: function() {
      this.dispatchEvent(new Event("disconnect"));
    }
    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: function() {
      var o = bo(/* @__PURE__ */ dt().mark(function r(a, s, l) {
        var u = this, m, g, p;
        return dt().wrap(function(M) {
          for (; ; ) switch (M.prev = M.next) {
            case 0:
              return M.next = 2, this.waitForTOReadyState(a, "open");
            case 2:
              if (l.role !== "viewer") {
                M.next = 10;
                break;
              }
              return M.next = 5, this.updatePlayer(a, s, l);
            case 5:
              m = I0(a, "change", function() {
                return u.updatePlayer(a, s, l);
              }), g = this.maintainPlaybackPosition(a, s, l), this.addEventListener("disconnect", function() {
                g.cancel(), m.cancel();
              }), M.next = 14;
              break;
            case 10:
              return M.next = 12, this.updateTimingObject(a, s);
            case 12:
              p = I0(s, ["seeked", "play", "pause", "ratechange"], function() {
                return u.updateTimingObject(a, s);
              }, "on", "off"), this.addEventListener("disconnect", function() {
                return p.cancel();
              });
            case 14:
            case "end":
              return M.stop();
          }
        }, r, this);
      }));
      function i(r, a, s) {
        return o.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: function() {
      var o = bo(/* @__PURE__ */ dt().mark(function r(a, s) {
        return dt().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.t0 = a, u.next = 3, s.getCurrentTime();
            case 3:
              return u.t1 = u.sent, u.next = 6, s.getPaused();
            case 6:
              if (!u.sent) {
                u.next = 10;
                break;
              }
              u.t2 = 0, u.next = 13;
              break;
            case 10:
              return u.next = 12, s.getPlaybackRate();
            case 12:
              u.t2 = u.sent;
            case 13:
              u.t3 = u.t2, u.t4 = {
                position: u.t1,
                velocity: u.t3
              }, u.t0.update.call(u.t0, u.t4);
            case 16:
            case "end":
              return u.stop();
          }
        }, r);
      }));
      function i(r, a) {
        return o.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: function() {
      var o = bo(/* @__PURE__ */ dt().mark(function r(a, s, l) {
        var u, m, g;
        return dt().wrap(function(T) {
          for (; ; ) switch (T.prev = T.next) {
            case 0:
              if (u = a.query(), m = u.position, g = u.velocity, typeof m == "number" && s.setCurrentTime(m), typeof g != "number") {
                T.next = 25;
                break;
              }
              if (g !== 0) {
                T.next = 11;
                break;
              }
              return T.next = 6, s.getPaused();
            case 6:
              if (T.t0 = T.sent, T.t0 !== !1) {
                T.next = 9;
                break;
              }
              s.pause();
            case 9:
              T.next = 25;
              break;
            case 11:
              if (!(g > 0)) {
                T.next = 25;
                break;
              }
              return T.next = 14, s.getPaused();
            case 14:
              if (T.t1 = T.sent, T.t1 !== !0) {
                T.next = 19;
                break;
              }
              return T.next = 18, s.play().catch(/* @__PURE__ */ function() {
                var M = bo(/* @__PURE__ */ dt().mark(function C(E) {
                  return dt().wrap(function(F) {
                    for (; ; ) switch (F.prev = F.next) {
                      case 0:
                        if (!(E.name === "NotAllowedError" && l.autoPlayMuted)) {
                          F.next = 5;
                          break;
                        }
                        return F.next = 3, s.setMuted(!0);
                      case 3:
                        return F.next = 5, s.play().catch(function(D) {
                          return console.error("Couldn't play the video from TimingSrcConnector. Error:", D);
                        });
                      case 5:
                      case "end":
                        return F.stop();
                    }
                  }, C);
                }));
                return function(C) {
                  return M.apply(this, arguments);
                };
              }());
            case 18:
              this.updatePlayer(a, s, l);
            case 19:
              return T.next = 21, s.getPlaybackRate();
            case 21:
              if (T.t2 = T.sent, T.t3 = g, T.t2 === T.t3) {
                T.next = 25;
                break;
              }
              s.setPlaybackRate(g);
            case 25:
            case "end":
              return T.stop();
          }
        }, r, this);
      }));
      function i(r, a, s) {
        return o.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function(i, r, a) {
      var s = this, l = a.allowedDrift, u = a.maxAllowedDrift, m = a.minCheckInterval, g = a.maxRateAdjustment, p = a.maxTimeToCatchUp, T = Math.min(p, Math.max(m, u)) * 1e3, M = /* @__PURE__ */ function() {
        var E = bo(/* @__PURE__ */ dt().mark(function P() {
          var F, D, H, B, U;
          return dt().wrap(function(Z) {
            for (; ; ) switch (Z.prev = Z.next) {
              case 0:
                if (Z.t0 = i.query().velocity === 0, Z.t0) {
                  Z.next = 6;
                  break;
                }
                return Z.next = 4, r.getPaused();
              case 4:
                Z.t1 = Z.sent, Z.t0 = Z.t1 === !0;
              case 6:
                if (!Z.t0) {
                  Z.next = 8;
                  break;
                }
                return Z.abrupt("return");
              case 8:
                return Z.t2 = i.query().position, Z.next = 11, r.getCurrentTime();
              case 11:
                if (Z.t3 = Z.sent, F = Z.t2 - Z.t3, D = Math.abs(F), s.log("Drift: ".concat(F)), !(D > u)) {
                  Z.next = 22;
                  break;
                }
                return Z.next = 18, s.adjustSpeed(r, 0);
              case 18:
                r.setCurrentTime(i.query().position), s.log("Resync by currentTime"), Z.next = 29;
                break;
              case 22:
                if (!(D > l)) {
                  Z.next = 29;
                  break;
                }
                return H = D / p, B = g, U = H < B ? (B - H) / 2 : B, Z.next = 28, s.adjustSpeed(r, U * Math.sign(F));
              case 28:
                s.log("Resync by playbackRate");
              case 29:
              case "end":
                return Z.stop();
            }
          }, P);
        }));
        return function() {
          return E.apply(this, arguments);
        };
      }(), C = setInterval(function() {
        return M();
      }, T);
      return {
        cancel: function() {
          return clearInterval(C);
        }
      };
    }
    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function(i) {
      var r;
      (r = this.logger) === null || r === void 0 || r.call(this, "TimingSrcConnector: ".concat(i));
    }
  }, {
    key: "waitForTOReadyState",
    value: (
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function(i, r) {
        return new Promise(function(a) {
          var s = function l() {
            i.readyState === r ? a() : i.addEventListener("readystatechange", l, {
              once: !0
            });
          };
          s();
        });
      }
    )
  }]), n;
}(/* @__PURE__ */ p1(EventTarget)), Yo = /* @__PURE__ */ new WeakMap(), El = /* @__PURE__ */ new WeakMap(), gt = {}, Iu = /* @__PURE__ */ function() {
  function e(t) {
    var n = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Rf(this, e), window.jQuery && t instanceof jQuery && (t.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), t = t[0]), typeof document != "undefined" && typeof t == "string" && (t = document.getElementById(t)), !yhe(t))
      throw new TypeError("You must pass either a valid element or a valid id.");
    if (t.nodeName !== "IFRAME") {
      var i = t.querySelector("iframe");
      i && (t = i);
    }
    if (t.nodeName === "IFRAME" && !Io(t.getAttribute("src") || ""))
      throw new Error("The player element passed isn’t a Vimeo embed.");
    if (Yo.has(t))
      return Yo.get(t);
    this._window = t.ownerDocument.defaultView, this.element = t, this.origin = "*";
    var r = new Ht(function(s, l) {
      if (n._onMessage = function(g) {
        if (!(!Io(g.origin) || n.element.contentWindow !== g.source)) {
          n.origin === "*" && (n.origin = g.origin);
          var p = La(g.data), T = p && p.event === "error", M = T && p.data && p.data.method === "ready";
          if (M) {
            var C = new Error(p.data.message);
            C.name = p.data.name, l(C);
            return;
          }
          var E = p && p.event === "ready", P = p && p.method === "ping";
          if (E || P) {
            n.element.setAttribute("data-ready", "true"), s();
            return;
          }
          Mhe(n, p);
        }
      }, n._window.addEventListener("message", n._onMessage), n.element.nodeName !== "IFRAME") {
        var u = Kf(t, o), m = zf(u);
        Zf(m, u, t).then(function(g) {
          var p = $u(g, t);
          return n.element = p, n._originalElement = t, She(t, p), Yo.set(n.element, n), g;
        }).catch(l);
      }
    });
    if (El.set(this, r), Yo.set(this.element, this), this.element.nodeName === "IFRAME" && ho(this, "ping"), gt.isEnabled) {
      var a = function() {
        return gt.exit();
      };
      this.fullscreenchangeHandler = function() {
        gt.isFullscreen ? Jr(n, "event:exitFullscreen", a) : Ws(n, "event:exitFullscreen", a), n.ready().then(function() {
          ho(n, "fullscreenchange", gt.isFullscreen);
        });
      }, gt.on("fullscreenchange", this.fullscreenchangeHandler);
    }
    return this;
  }
  return Bf(e, [{
    key: "callMethod",
    value: function(n) {
      var o = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return new Ht(function(r, a) {
        return o.ready().then(function() {
          Jr(o, n, {
            resolve: r,
            reject: a
          }), ho(o, n, i);
        }).catch(a);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function(n) {
      var o = this;
      return new Ht(function(i, r) {
        return n = $0(n, "get"), o.ready().then(function() {
          Jr(o, n, {
            resolve: i,
            reject: r
          }), ho(o, n);
        }).catch(r);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function(n, o) {
      var i = this;
      return new Ht(function(r, a) {
        if (n = $0(n, "set"), o == null)
          throw new TypeError("There must be a value to set.");
        return i.ready().then(function() {
          Jr(i, n, {
            resolve: r,
            reject: a
          }), ho(i, n, o);
        }).catch(a);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function(n, o) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (!o)
        throw new TypeError("You must pass a callback function.");
      if (typeof o != "function")
        throw new TypeError("The callback must be a function.");
      var i = xs(this, "event:".concat(n));
      i.length === 0 && this.callMethod("addEventListener", n).catch(function() {
      }), Jr(this, "event:".concat(n), o);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function(n, o) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (o && typeof o != "function")
        throw new TypeError("The callback must be a function.");
      var i = Ws(this, "event:".concat(n), o);
      i && this.callMethod("removeEventListener", n).catch(function(r) {
      });
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function(n) {
      return this.callMethod("loadVideo", n);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function() {
      var n = El.get(this) || new Ht(function(o, i) {
        i(new Error("Unknown player. Probably unloaded."));
      });
      return Ht.resolve(n);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function(n) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.callMethod("addCuePoint", {
        time: n,
        data: o
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function(n) {
      return this.callMethod("removeCuePoint", n);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function(n, o) {
      if (!n)
        throw new TypeError("You must pass a language.");
      return this.callMethod("enableTextTrack", {
        language: n,
        kind: o
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function() {
      return this.callMethod("disableTextTrack");
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function() {
      return this.callMethod("pause");
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function() {
      return this.callMethod("play");
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function() {
      return gt.isEnabled ? gt.request(this.element) : this.callMethod("requestFullscreen");
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function() {
      return gt.isEnabled ? gt.exit() : this.callMethod("exitFullscreen");
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function() {
      return gt.isEnabled ? Ht.resolve(gt.isFullscreen) : this.get("fullscreen");
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function() {
      return this.callMethod("requestPictureInPicture");
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function() {
      return this.callMethod("exitPictureInPicture");
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function() {
      return this.get("pictureInPicture");
    }
    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function() {
      return this.callMethod("remotePlaybackPrompt");
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function() {
      return this.callMethod("unload");
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function() {
      var n = this;
      return new Ht(function(o) {
        if (El.delete(n), Yo.delete(n.element), n._originalElement && (Yo.delete(n._originalElement), n._originalElement.removeAttribute("data-vimeo-initialized")), n.element && n.element.nodeName === "IFRAME" && n.element.parentNode && (n.element.parentNode.parentNode && n._originalElement && n._originalElement !== n.element.parentNode ? n.element.parentNode.parentNode.removeChild(n.element.parentNode) : n.element.parentNode.removeChild(n.element)), n.element && n.element.nodeName === "DIV" && n.element.parentNode) {
          n.element.removeAttribute("data-vimeo-initialized");
          var i = n.element.querySelector("iframe");
          i && i.parentNode && (i.parentNode.parentNode && n._originalElement && n._originalElement !== i.parentNode ? i.parentNode.parentNode.removeChild(i.parentNode) : i.parentNode.removeChild(i));
        }
        n._window.removeEventListener("message", n._onMessage), gt.isEnabled && gt.off("fullscreenchange", n.fullscreenchangeHandler), o();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function() {
      return this.get("autopause");
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function(n) {
      return this.set("autopause", n);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function() {
      return this.get("buffered");
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function() {
      return this.get("cameraProps");
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function(n) {
      return this.set("cameraProps", n);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function() {
      return this.get("chapters");
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function() {
      return this.get("currentChapter");
    }
    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function() {
      return this.get("color");
    }
    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function() {
      return Ht.all([this.get("colorOne"), this.get("colorTwo"), this.get("colorThree"), this.get("colorFour")]);
    }
    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function(n) {
      return this.set("color", n);
    }
    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function(n) {
      if (!Array.isArray(n))
        return new Ht(function(r, a) {
          return a(new TypeError("Argument must be an array."));
        });
      var o = new Ht(function(r) {
        return r(null);
      }), i = [n[0] ? this.set("colorOne", n[0]) : o, n[1] ? this.set("colorTwo", n[1]) : o, n[2] ? this.set("colorThree", n[2]) : o, n[3] ? this.set("colorFour", n[3]) : o];
      return Ht.all(i);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function() {
      return this.get("cuePoints");
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      return this.get("currentTime");
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function(n) {
      return this.set("currentTime", n);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function() {
      return this.get("duration");
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function() {
      return this.get("ended");
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function() {
      return this.get("loop");
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function(n) {
      return this.set("loop", n);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function(n) {
      return this.set("muted", n);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function() {
      return this.get("muted");
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function() {
      return this.get("paused");
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function() {
      return this.get("playbackRate");
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function(n) {
      return this.set("playbackRate", n);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function() {
      return this.get("played");
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function() {
      return this.get("qualities");
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function() {
      return this.get("quality");
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function(n) {
      return this.set("quality", n);
    }
    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function() {
      return this.get("remotePlaybackAvailability");
    }
    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function() {
      return this.get("remotePlaybackState");
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function() {
      return this.get("seekable");
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function() {
      return this.get("seeking");
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function() {
      return this.get("textTracks");
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function() {
      return this.get("videoEmbedCode");
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function() {
      return this.get("videoId");
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function() {
      return this.get("videoTitle");
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function() {
      return this.get("videoWidth");
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function() {
      return this.get("videoHeight");
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function() {
      return this.get("videoUrl");
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function() {
      return this.get("volume");
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function(n) {
      return this.set("volume", n);
    }
    /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */
    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: function() {
      var t = bo(/* @__PURE__ */ dt().mark(function o(i, r) {
        var a = this, s;
        return dt().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (i) {
                u.next = 2;
                break;
              }
              throw new TypeError("A Timing Object must be provided.");
            case 2:
              return u.next = 4, this.ready();
            case 4:
              return s = new Phe(this, i, r), ho(this, "notifyTimingObjectConnect"), s.addEventListener("disconnect", function() {
                return ho(a, "notifyTimingObjectDisconnect");
              }), u.abrupt("return", s);
            case 8:
            case "end":
              return u.stop();
          }
        }, o, this);
      }));
      function n(o, i) {
        return t.apply(this, arguments);
      }
      return n;
    }()
  }]), e;
}();
Uf || (gt = Ohe(), $he(), Ihe(), Dhe(), Lhe());
const Hhe = {
  name: "VideoPlayer",
  props: {
    url: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    typeVideo: {
      type: String,
      default: ""
    },
    elementId: {
      type: String,
      default: "playerVideo"
    },
    autoplay: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      player: {
        vimeo: null,
        youtube: null
      }
    };
  },
  watch: {
    async url() {
      if (this.player.vimeo)
        try {
          await this.player.vimeo.destroy(), this.player.vimeo = null;
        } catch (e) {
          console.error("Error destroying ");
        }
      else this.player.youtube && (this.player.youtube.destroy(), this.player.youtube = null);
      this.typeVideo === "vimeo" ? this.loadVimeoPlayer() : this.loadYoutubePlayer();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.typeVideo === "vimeo" ? this.loadVimeoPlayer() : this.loadYoutubePlayer();
    });
  },
  created() {
    this.$nextTick(() => {
      this.setStylesToIFrame();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.setStylesToIFrame();
    });
  },
  methods: {
    createVimeoPlayer() {
      return !this.$refs[this.elementId] || !this.$refs[this.elementId].id ? !1 : (this.player.vimeo = new Iu(this.$refs[this.elementId], {
        url: this.url,
        responsive: !0
      }), this.player.vimeo.on("play", () => {
        this.$emit("eventToEmit", { id: this.id, isPlaying: !0 });
      }), this.player.vimeo.on("pause", () => {
        this.$emit("eventToEmit", { id: this.id, isPlaying: !1 });
      }), !0);
    },
    createYoutubePlayer() {
      return !this.$refs[this.elementId] || !this.$refs[this.elementId].id ? !1 : (this.player.youtube = new hhe(this.$refs[this.elementId]), this.player.youtube.on("paused", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !1,
          elementId: this.elementId
        });
      }), this.player.youtube.on("ended", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !1,
          elementId: this.elementId
        });
      }), this.player.youtube.on("playing", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !0,
          elementId: this.elementId
        });
      }), !0);
    },
    loadVimeoPlayer() {
      !this.player.vimeo && !this.createVimeoPlayer() || (this.player.vimeo.loadVideo(this.url), this.player.vimeo.play());
    },
    loadYoutubePlayer() {
      !this.player.youtube && !this.createYoutubePlayer() || (this.player.youtube.load(this.id, this.autoplay), this.setStylesToIFrame());
    },
    setStylesToIFrame() {
      const e = this.$refs[this.elementId];
      e && (e.style.left = "0", e.style.top = "0", e.style.width = "100%", e.style.height = "100%", e.style.position = "absolute");
    }
  }
}, Fhe = {
  class: "video-player",
  "data-testid": "video-player"
}, Rhe = ["id"];
function Bhe(e, t, n, o, i, r) {
  return d(), h("div", Fhe, [
    c("div", {
      id: n.elementId,
      ref: n.elementId
    }, null, 8, Rhe)
  ]);
}
const xf = /* @__PURE__ */ O(Hhe, [["render", Bhe], ["__scopeId", "data-v-5fa63831"]]), Vhe = {
  name: "V1",
  components: {
    VideoPlayer: xf
  },
  mixins: [Mu],
  props: {
    componentId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    prevItem() {
      let e = this.activeItem - 1;
      return e < 0 && (e = this.videoItems.length - 1), this.videoItems[e];
    },
    nextItem() {
      let e = this.activeItem + 1;
      return e >= this.videoItems.length && (e = 0), this.videoItems[e];
    }
  },
  methods: {
    activateItem(e) {
      this.readMoreOpen = !1, this.activeItem = e, this.$emit("setCurrentVideoThrillshare", e);
    },
    activateNext() {
      let e = this.activeItem + 1;
      e >= this.videoItems.length && (e = 0), this.activateItem(e);
    },
    activatePrev() {
      let e = this.activeItem - 1;
      e < 0 && (e = this.videoItems.length - 1), this.activateItem(e);
    },
    readMoreToggle() {
      this.readMoreOpen = !this.readMoreOpen;
    },
    isOverflow() {
      this.$nextTick(() => this.$refs.description.offsetHeight < this.$refs.description.scrollHeight || this.$refs.description.offsetWidth < this.$refs.description.scrollWidth);
    }
  }
}, jhe = ["data-testid"], Uhe = ["data-testid"], Ghe = { class: "video-wrapper" }, zhe = {
  key: 0,
  class: "thumbnail"
}, Khe = ["src"], Zhe = { class: "buttons" }, xhe = ["aria-label"], Whe = ["aria-label"], qhe = { class: "mirrors" }, Yhe = { class: "prev" }, Xhe = { class: "thumbnail" }, Qhe = ["src"], Jhe = { class: "title" }, e0e = { class: "next" }, t0e = { class: "thumbnail" }, n0e = ["src"], o0e = { class: "title" }, r0e = { class: "video-info" }, i0e = {
  class: "title",
  "data-testid": "title"
}, s0e = {
  key: 1,
  class: "dots"
}, a0e = ["onClick"], l0e = {
  key: 2,
  class: "buttons"
}, u0e = ["aria-label"], d0e = ["aria-label"];
function c0e(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("VideoPlayer");
  return d(), h("div", {
    id: "video-component",
    class: v(e.theme.style),
    style: j(e.colors),
    "data-testid": "V1"
  }, [
    e.content.show_headline ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`,
          class: "no-border"
        }, [
          e.displayTopHeader ? (d(), h("span", {
            key: 0,
            class: "header-top",
            "data-testid": `header-${e.theme.style}-top`
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.content.component_header_top), 1)
            ], !0)
          ], 8, Uhe)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.content.headline), 1)
          ], !0)
        ], 8, jhe)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : b("", !0),
    c("div", Ghe, [
      c("div", {
        class: "video",
        tabindex: "0",
        onKeyup: [
          t[0] || (t[0] = V((...l) => r.activateNext && r.activateNext(...l), ["right"])),
          t[1] || (t[1] = V((...l) => r.activatePrev && r.activatePrev(...l), ["left"]))
        ]
      }, [
        w(e.$slots, "delete-btn", {
          index: e.currentItem.position
        }, void 0, !0),
        w(e.$slots, `video-item-${e.currentItem.position}`, {}, () => [
          e.isPlaceholder ? (d(), h("div", zhe, [
            c("img", {
              src: e.currentItem.thumbnail,
              alt: "",
              "data-testid": "current-image"
            }, null, 8, Khe)
          ])) : (d(), k(s, {
            key: 1,
            id: e.currentItem.videoId,
            ref: "main-video-player",
            "element-id": `${n.componentId}-main-video-player`,
            "video-id": e.currentItem.videoId,
            "type-video": e.currentItem.type,
            url: e.currentItem.url,
            autoplay: !1,
            responsive: !0,
            class: "player",
            onEventToEmit: e.setIsPlaying
          }, null, 8, ["id", "element-id", "video-id", "type-video", "url", "onEventToEmit"]))
        ], !0)
      ], 32),
      e.isDesktop && e.videoItems.length > 1 ? (d(), h(Y, { key: 0 }, [
        c("div", Zhe, [
          c("button", {
            class: "prev",
            "aria-label": e.translations.left_arrow || "Previous Video",
            onClick: t[2] || (t[2] = (...l) => r.activatePrev && r.activatePrev(...l)),
            onKeyup: t[3] || (t[3] = V((...l) => r.activatePrev && r.activatePrev(...l), ["left"]))
          }, t[11] || (t[11] = [
            c("div", { class: "icon" }, null, -1)
          ]), 40, xhe),
          c("button", {
            class: "next",
            "aria-label": e.translations.right_arrow || "Next Video",
            onClick: t[4] || (t[4] = (...l) => r.activateNext && r.activateNext(...l)),
            onKeyup: t[5] || (t[5] = V((...l) => r.activateNext && r.activateNext(...l), ["right"]))
          }, t[12] || (t[12] = [
            c("div", { class: "icon" }, null, -1)
          ]), 40, Whe)
        ]),
        c("div", qhe, [
          c("div", Yhe, [
            w(e.$slots, `video-item-${r.prevItem.position}`, {}, () => [
              c("div", Xhe, [
                c("img", {
                  src: r.prevItem.thumbnail,
                  alt: "",
                  "data-testid": "previous-image"
                }, null, 8, Qhe)
              ]),
              c("div", Jhe, y(r.prevItem.title), 1)
            ], !0)
          ]),
          c("div", e0e, [
            w(e.$slots, `video-item-${r.nextItem.position}`, {}, () => [
              c("div", t0e, [
                c("img", {
                  src: r.nextItem.thumbnail,
                  alt: "",
                  "data-testid": "next-image"
                }, null, 8, n0e)
              ]),
              c("div", o0e, y(r.nextItem.title), 1)
            ], !0)
          ])
        ])
      ], 64)) : b("", !0)
    ]),
    c("div", r0e, [
      w(e.$slots, "main-video-alt-text", {
        index: e.currentItem.position
      }, void 0, !0),
      c("div", i0e, [
        w(e.$slots, "main-video-title", {
          index: e.currentItem.position
        }, () => [
          A(y(e.currentItem.title), 1)
        ], !0)
      ]),
      c("div", {
        ref: "description",
        class: v(["description", { more: e.readMoreOpen }]),
        "data-testid": "description"
      }, [
        w(e.$slots, "main-video-description", {
          index: e.currentItem.position
        }, () => [
          A(y(e.currentItem.description), 1)
        ], !0)
      ], 2),
      r.isOverflow ? (d(), h("button", {
        key: 0,
        class: "read-more",
        onClick: t[6] || (t[6] = (...l) => r.readMoreToggle && r.readMoreToggle(...l))
      }, y(e.readMoreOpen ? "Read less" : "Read more"), 1)) : b("", !0)
    ]),
    e.videoItems.length > 1 ? (d(), h("div", s0e, [
      (d(!0), h(Y, null, ee(e.videoItems, (l, u) => (d(), h("div", {
        id: "dot-item",
        key: l.id,
        class: v(["dot", e.activeItem == u ? "active" : ""]),
        onClick: (m) => r.activateItem(u)
      }, null, 10, a0e))), 128))
    ])) : b("", !0),
    !e.isDesktop && e.videoItems.length > 1 ? (d(), h("div", l0e, [
      c("button", {
        class: "prev",
        "aria-label": e.translations.left_arrow || "Previous Video",
        onClick: t[7] || (t[7] = (...l) => r.activatePrev && r.activatePrev(...l)),
        onKeyup: t[8] || (t[8] = V((...l) => r.activatePrev && r.activatePrev(...l), ["left"]))
      }, t[13] || (t[13] = [
        c("div", { class: "icon" }, null, -1)
      ]), 40, u0e),
      c("button", {
        class: "next",
        "aria-label": e.translations.right_arrow || "Next Video",
        onClick: t[9] || (t[9] = (...l) => r.activateNext && r.activateNext(...l)),
        onKeyup: t[10] || (t[10] = V((...l) => r.activateNext && r.activateNext(...l), ["right"]))
      }, t[14] || (t[14] = [
        c("div", { class: "icon" }, null, -1)
      ]), 40, d0e)
    ])) : b("", !0)
  ], 6);
}
const h0e = /* @__PURE__ */ O(Vhe, [["render", c0e], ["__scopeId", "data-v-860fbe66"]]), m0e = {
  name: "V2",
  components: {
    VideoPlayer: xf
  },
  mixins: [Mu],
  props: {
    componentId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    activateItem(e) {
      this.activeItem = e, this.playPause(`${this.componentId}-main-video-player`, this.currentItem.type), this.$emit("setCurrentVideoThrillshare", e);
    }
  }
}, p0e = ["data-testid"], f0e = ["data-testid"], g0e = { class: "wrapper" }, v0e = ["aria-label"], b0e = { class: "video" }, y0e = {
  key: 0,
  class: "thumbnail"
}, _0e = ["src"], C0e = { class: "video-info" }, w0e = {
  class: "title",
  "data-testid": "title"
}, T0e = {
  ref: "description",
  class: "description",
  "data-testid": "description"
}, k0e = {
  key: 1,
  class: "sidebar"
}, E0e = ["id", "alert-label", "onClick", "onKeyup"], S0e = { class: "video" }, M0e = {
  class: "secondary-title",
  "data-testid": "title"
}, A0e = { class: "thumbnail" }, $0e = ["src"], I0e = {
  key: 0,
  class: "info"
}, D0e = { class: "title" }, L0e = { class: "description" };
function O0e(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("VideoPlayer");
  return d(), h("div", {
    id: "video-component",
    class: v(e.theme.style),
    style: j(e.colors),
    "data-testid": "V2"
  }, [
    e.content.show_headline ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`,
          class: "no-border"
        }, [
          e.displayTopHeader ? (d(), h("span", {
            key: 0,
            class: "header-top",
            "data-testid": `header-${e.theme.style}-top`
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.content.component_header_top), 1)
            ], !0)
          ], 8, f0e)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.content.headline), 1)
          ], !0)
        ], 8, p0e)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : b("", !0),
    c("div", g0e, [
      e.isDesktop || e.videoItems.length === 1 ? (d(), h("div", {
        key: 0,
        class: "main-video",
        tabindex: "0",
        "aria-label": `${e.translations.video_player || "Video player"}: ${e.currentItem.alt_text}`,
        role: "region"
      }, [
        c("div", b0e, [
          w(e.$slots, "delete-btn", {
            index: e.currentItem.position
          }, void 0, !0),
          w(e.$slots, `video-item-${e.currentItem.position}`, {}, () => [
            e.isPlaceholder ? (d(), h("div", y0e, [
              c("img", {
                src: e.currentItem.thumbnail,
                alt: "",
                "data-testid": "current-item"
              }, null, 8, _0e)
            ])) : (d(), k(s, {
              key: 1,
              id: e.currentItem.videoId,
              ref: "main-video-player",
              class: "player",
              "element-id": `${n.componentId}-main-video-player`,
              "video-id": e.currentItem.videoId,
              "type-video": e.currentItem.type,
              url: e.currentItem.url,
              autoplay: !1,
              responsive: !0,
              onEventToEmit: e.setIsPlaying
            }, null, 8, ["id", "element-id", "video-id", "type-video", "url", "onEventToEmit"]))
          ], !0)
        ]),
        c("div", C0e, [
          w(e.$slots, "main-video-alt-text", {
            altText: e.currentItem.alt_text,
            index: e.currentItem.position
          }, void 0, !0),
          c("div", w0e, [
            w(e.$slots, "main-video-title", {
              index: e.currentItem.position
            }, () => [
              A(y(e.currentItem.title), 1)
            ], !0)
          ]),
          c("div", T0e, [
            w(e.$slots, "main-video-description", {
              index: e.currentItem.position
            }, () => [
              A(y(e.currentItem.description), 1)
            ], !0)
          ], 512)
        ])
      ], 8, v0e)) : b("", !0),
      e.videoItems.length > 1 ? (d(), h("div", k0e, [
        (d(!0), h(Y, null, ee(e.videoItems, (l, u) => (d(), h("div", {
          id: `sidebar-item-${u}`,
          key: l.id,
          tabindex: 0,
          role: "button",
          class: v(["sidebar-item", e.activeItem === u && "active"]),
          "alert-label": `${e.translations.display_video || "Display video"}: ${l.alt_text}`,
          onClick: (m) => r.activateItem(u),
          onKeyup: V((m) => r.activateItem(u), ["enter"]),
          "on:eventToEmit": t[0] || (t[0] = (...m) => e.setIsPlaying && e.setIsPlaying(...m))
        }, [
          c("div", S0e, [
            w(e.$slots, "delete-btn", {
              index: l.position
            }, void 0, !0),
            w(e.$slots, `video-item-${l.position}`, {}, () => [
              c("div", {
                class: v(["video-mask", e.activeItem === u && !e.isDesktop && "hidden"])
              }, [
                c("div", {
                  class: v(["button", e.isPlaying && e.activeItem === u ? "pause" : "play"])
                }, null, 2),
                c("div", M0e, y(l.title), 1),
                c("div", A0e, [
                  c("img", {
                    src: l.thumbnail,
                    alt: ""
                  }, null, 8, $0e)
                ])
              ], 2)
            ], !0),
            e.isDesktop ? b("", !0) : (d(), k(s, {
              key: 0,
              id: l.videoId,
              ref_for: !0,
              ref: `video-player-${u}`,
              class: "player",
              "video-id": l.videoId,
              "type-video": l.type,
              url: l.url,
              autoplay: !1,
              responsive: !0,
              "element-id": `${n.componentId}-video-player-${u}`,
              onEventToEmit: e.setIsPlaying
            }, null, 8, ["id", "video-id", "type-video", "url", "element-id", "onEventToEmit"]))
          ]),
          e.isDesktop ? b("", !0) : (d(), h("div", I0e, [
            c("div", D0e, y(l.title), 1),
            c("div", L0e, y(l.description), 1)
          ]))
        ], 42, E0e))), 128))
      ])) : b("", !0)
    ])
  ], 6);
}
const N0e = /* @__PURE__ */ O(m0e, [["render", O0e], ["__scopeId", "data-v-4b61d270"]]), P0e = {
  name: "CmsVideo",
  components: {
    V1: h0e,
    V2: N0e
  },
  mixins: [Mu],
  data() {
    return {
      componentId: Math.floor(Math.random() * 1e5)
    };
  }
}, H0e = { id: "view-video" };
function F0e(e, t, n, o, i, r) {
  return d(), h("div", H0e, [
    (d(), k(K(e.theme.version), {
      theme: e.theme,
      content: e.content,
      "is-editing": e.isEditing,
      "component-id": i.componentId,
      "is-placeholder": e.isPlaceholder,
      "video-slots-items": e.videoSlotsItems,
      "current-video-thrillshare": e.currentVideoThrillshare,
      onSetCurrentVideoThrillshare: t[0] || (t[0] = (a) => e.$emit("setCurrentVideoThrillshare", a)),
      onDeleteVideo: t[1] || (t[1] = (a) => {
        e.$emit("deleteVideo", a);
      })
    }, H0({
      "header-top": _(() => [
        w(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: _(() => [
        w(e.$slots, "header", {}, void 0, !0)
      ]),
      "main-video-description": _(({ index: a }) => [
        w(e.$slots, "main-video-description", { index: a }, void 0, !0)
      ]),
      "main-video-title": _(({ index: a }) => [
        w(e.$slots, "main-video-title", { index: a }, void 0, !0)
      ]),
      "main-video-alt-text": _(({ index: a }) => [
        w(e.$slots, "main-video-alt-text", { index: a }, void 0, !0)
      ]),
      "delete-btn": _(({ index: a }) => [
        w(e.$slots, "delete-btn", { index: a }, void 0, !0)
      ]),
      "main-video-slot": _(({ index: a }) => [
        w(e.$slots, "main-video-slot", { index: a }, void 0, !0)
      ]),
      _: 2
    }, [
      ee(e.videoSlotsItems, (a) => ({
        name: a.name,
        fn: _(() => [
          w(e.$slots, a.name, {
            index: a.index
          }, void 0, !0)
        ])
      }))
    ]), 1064, ["theme", "content", "is-editing", "component-id", "is-placeholder", "video-slots-items", "current-video-thrillshare"]))
  ]);
}
const R0e = /* @__PURE__ */ O(P0e, [["render", F0e], ["__scopeId", "data-v-e4f3e80d"]]), Ri = {
  mixins: [mt],
  components: { DraggableWrapper: at },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    spotlights: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  },
  computed: {
    colors() {
      var t, n;
      const e = this.sharedThemeColors();
      return he(ie({}, e), {
        "--bg-color": S(this.theme, "bg_color.hex", "#fff"),
        "--top-heading-color": S(this.theme, "top_heading_color.hex", "#000000"),
        "--quote-color": S(this.theme, "quote_color.hex", "#000"),
        "--name-color": S(this.theme, "name_color.hex", "#000"),
        "--arrow-icon-color": S(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-background-color": S(this.theme, "arrow_background_color.hex", "initial"),
        "--arrow-background-opacity": `${(t = this.theme.arrow_background_opacity) != null ? t : "0"}%`,
        "--arrow-border-color": S(this.theme, "arrow_border_color.hex", "initial"),
        "--image-border-color": S(
          this.theme,
          "image_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--textarea-border-color": S(this.theme, "textarea_border_color.hex", "#00000014"),
        "--textarea-border-accent-color": S(
          this.theme,
          "textarea_border_accent_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--percentage-button-opacity": `${(n = this.theme.percentage_button_opacity) != null ? n : "0"}%`
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.spotlights.component_header_top || this.isEditing);
    },
    isLightStyle() {
      return this.theme.style === "light";
    },
    isBoldStyle() {
      return this.theme.style === "bold";
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    isMobile() {
      return this.screenSize < 600;
    },
    isDesktop() {
      return this.screenSize >= 960;
    }
  }
}, B0e = {
  props: {
    spotlight: {
      type: Object,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    },
    showName: {
      type: Boolean,
      default: !0
    },
    withSlider: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      sliderClass: this.withSlider ? "with-slider" : "no-slider"
    };
  }
}, V0e = ["src", "alt"], j0e = {
  key: 1,
  class: "no-image"
}, U0e = {
  class: "spotlight-text",
  "data-testid": "spotlight-text"
}, G0e = { key: 0 };
function z0e(e, t, n, o, i, r) {
  return d(), h("div", {
    class: v(i.sliderClass)
  }, [
    w(e.$slots, "controls"),
    c("div", {
      class: v(["spotlight-image rounded-image", i.sliderClass])
    }, [
      w(e.$slots, "image", {}, () => [
        n.spotlight.image.url ? (d(), h("img", {
          key: 0,
          src: n.spotlight.image.url,
          alt: n.spotlight.image.alt_text,
          class: "rounded-image",
          "data-testid": "spotlight-accent-border",
          loading: "lazy"
        }, null, 8, V0e)) : (d(), h("div", j0e))
      ])
    ], 2),
    c("div", U0e, [
      c("div", {
        class: v(["spotlight-quote", [n.theme.style, i.sliderClass]])
      }, [
        c("p", null, [
          w(e.$slots, "quote", {}, () => [
            A(y(n.spotlight.quote), 1)
          ])
        ])
      ], 2),
      n.showName ? (d(), h("div", {
        key: 0,
        class: v(["spotlight-author", i.sliderClass]),
        "data-testid": "spotlight-author-name"
      }, [
        c("p", null, [
          n.spotlight.quote.length > 0 && n.spotlight.author.length > 0 ? (d(), h("span", G0e, "- ")) : b("", !0),
          w(e.$slots, "author", {}, () => [
            A(y(n.spotlight.author), 1)
          ])
        ])
      ], 2)) : b("", !0)
    ])
  ], 2);
}
const K0e = /* @__PURE__ */ O(B0e, [["render", z0e], ["__scopeId", "data-v-8ecd974d"]]), Z0e = {
  name: "SL1",
  components: { Slider: Eu, SpotlightCard: K0e },
  mixins: [Ri, ut],
  computed: {
    content() {
      return this.spotlights.content;
    },
    showSlider() {
      return this.spotlights.show_slider && !this.isEditing;
    },
    sliderCenterSize() {
      return 599;
    }
  }
}, x0e = { key: 0 }, W0e = ["data-testid"], q0e = { class: "cards-slider-container" }, Y0e = ["aria-label"];
function X0e(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("SpotlightCard"), l = $("Slider"), u = Ve("touch");
  return d(), h("div", {
    id: "SL1",
    class: v(e.theme.style),
    style: j(e.colors)
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.displayHeaderTop ? (d(), h("h3", x0e, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.spotlights.component_header_top), 1)
          ], !0)
        ])) : b("", !0),
        c("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header", {}, () => [
            A(y(e.spotlights.component_header), 1)
          ], !0)
        ], 8, W0e)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), k(K(r.showSlider ? "div" : e.wrapperComponent), we({
      modelValue: e.spotlights.content,
      "onUpdate:modelValue": t[0] || (t[0] = (m) => e.spotlights.content = m)
    }, e.wrapperProps, {
      class: [{ editing: e.isEditing, "no-slider": !r.showSlider }, "spotlights-content"],
      "item-key": "id"
    }), H0({
      default: _(() => [
        r.showSlider ? (d(), k(l, {
          key: 0,
          "total-cards": r.content.length,
          "current-card": e.currentCard,
          "all-cards-visible": e.allCardsVisible,
          "section-header": e.spotlights.component_header,
          "hide-x-small": !1,
          "theme-styles": e.theme,
          class: "slider-container",
          "data-testid": "spotlight-slider",
          onScrollRight: e.scrollRight,
          onScrollLeft: e.scrollLeft
        }, {
          default: _(() => [
            c("div", {
              ref: "scrollWrapper",
              class: v([{ "all-cards-visible": e.allCardsVisible }, "cards-slider-content"]),
              "item-key": "index"
            }, [
              c("div", q0e, [
                (d(!0), h(Y, null, ee(e.spotlights.content, (m, g) => ge((d(), h("div", {
                  ref_for: !0,
                  ref: `sliderCard-${g}`,
                  key: g,
                  class: v(["spotlight with-slider", { "is-editing": e.isEditing }]),
                  "aria-label": `${g + 1} of ${e.spotlights.content.length}`,
                  role: "group",
                  "aria-roledescription": "slide",
                  "data-testid": "spotlights-content-item"
                }, [
                  L(s, {
                    theme: e.theme,
                    spotlight: m,
                    "show-name": e.spotlights.show_name,
                    "with-slider": !0
                  }, null, 8, ["theme", "spotlight", "show-name"])
                ], 10, Y0e)), [
                  [
                    u,
                    e.scrollRight,
                    "swipe",
                    { left: !0 }
                  ],
                  [
                    u,
                    e.scrollLeft,
                    "swipe",
                    { right: !0 }
                  ]
                ])), 128))
              ])
            ], 2)
          ]),
          _: 1
        }, 8, ["total-cards", "current-card", "all-cards-visible", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"])) : b("", !0)
      ]),
      _: 2
    }, [
      r.showSlider ? void 0 : {
        name: "item",
        fn: _(({ element: m, index: g }) => [
          L(s, {
            class: "spotlight no-slider",
            theme: e.theme,
            spotlight: m,
            "show-name": e.spotlights.show_name
          }, {
            controls: _(() => [
              w(e.$slots, "controls", { idx: g }, void 0, !0)
            ]),
            image: _(() => [
              w(e.$slots, "image", { idx: g }, void 0, !0)
            ]),
            quote: _(() => [
              w(e.$slots, "quote", { idx: g }, void 0, !0)
            ]),
            author: _(() => [
              w(e.$slots, "author", { idx: g }, void 0, !0)
            ]),
            _: 2
          }, 1032, ["theme", "spotlight", "show-name"])
        ]),
        key: "0"
      }
    ]), 1040, ["modelValue", "class"]))
  ], 6);
}
const Q0e = /* @__PURE__ */ O(Z0e, [["render", X0e], ["__scopeId", "data-v-73c2e755"]]), J0e = {
  name: "SL2",
  components: {
    CardSlider: Jt
  },
  mixins: [Ri, ut],
  computed: {
    content() {
      return this.spotlights.content;
    },
    sliderCenterSize() {
      return 599;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    setCardHeight() {
      if (this.isEditing)
        return;
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = "unset";
      });
      const e = Math.max(...this.content.map((t, n) => this.$refs[`spotlightCard-${n}`].clientHeight));
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = e ? `${e - 64}px` : "unset";
      });
    }
  }
}, e2e = ["data-testid"], t2e = ["data-testid"], n2e = ["aria-label"], o2e = ["src", "alt"], r2e = { class: "card-quote-text" }, i2e = {
  key: 0,
  class: "card-author-text",
  "data-testid": "spotlight-author"
};
function s2e(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("CardSlider");
  return d(), h("div", {
    id: "SL2",
    "data-testid": "SL2",
    style: j(e.colors),
    class: v([e.theme.style, e.isEditing && "editing"])
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.displayHeaderTop ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.spotlights.component_header_top), 1)
            ], !0)
          ], 8, t2e)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.spotlights.component_header), 1)
          ], !0)
        ], 8, e2e)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    L(s, {
      "nav-orientation": e.sliderCenterElements ? "bottom" : "top",
      "current-card": e.currentCard,
      "has-pager": !1,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": r.content.length,
      "theme-styles": e.theme,
      "section-header": e.spotlights.component_header,
      class: v([{ "show-accent-left": e.currentCard === 0, "buttons-top": !e.sliderCenterElements }, "spotlight-container"]),
      "pager-orientation": "left",
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: _(() => [
        (d(), k(K(e.wrapperComponent), we({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.spotlights.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.spotlights.content = l),
          class: [{ "all-cards-visible": e.allCardsVisible }, "spotlight-wrapper"],
          "item-key": "id"
        }), {
          item: _(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              "aria-label": `${u + 1} of ${r.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              class: "spotlight"
            }, [
              w(e.$slots, "controls", { idx: u }, void 0, !0),
              w(e.$slots, "image", { idx: u }, () => [
                c("img", {
                  src: l.image.url,
                  alt: l.image.alt_text,
                  class: "spotlight-image",
                  loading: "lazy"
                }, null, 8, o2e)
              ], !0),
              c("div", {
                ref: `spotlightCard-${u}`,
                "data-testid": "spotlight-card",
                class: "spotlight-card"
              }, [
                c("div", r2e, [
                  w(e.$slots, "quote", { idx: u }, () => [
                    A(y(l.quote), 1)
                  ], !0)
                ]),
                e.spotlights.show_name ? (d(), h("div", i2e, [
                  w(e.$slots, "author", { idx: u }, () => [
                    A(y(l.author), 1)
                  ], !0)
                ])) : b("", !0)
              ], 512)
            ], 8, n2e)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["nav-orientation", "current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "class", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const a2e = /* @__PURE__ */ O(J0e, [["render", s2e], ["__scopeId", "data-v-241d2edf"]]), l2e = {
  name: "SL3",
  components: {
    CardSlider: Jt
  },
  mixins: [Ri, ut],
  computed: {
    content() {
      return this.spotlights.content;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    setCardHeight() {
      if (this.isEditing)
        return;
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = "unset";
      });
      const e = Math.max(...this.content.map((t, n) => this.$refs[`spotlightCard-${n}`].clientHeight));
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = e ? `${e - 64}px` : "unset";
      });
    }
  }
}, u2e = ["data-testid"], d2e = ["data-testid"], c2e = ["aria-label"], h2e = { class: "card-quote-text" }, m2e = {
  key: 0,
  class: "card-author-text",
  "data-testid": "spotlight-author"
}, p2e = ["src", "alt"];
function f2e(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("CardSlider");
  return d(), h("div", {
    id: "SL3",
    "data-testid": "SL3",
    style: j(e.colors),
    class: v([e.theme.style, { editing: e.isEditing }])
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.displayHeaderTop ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.spotlights.component_header_top), 1)
            ], !0)
          ], 8, d2e)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.spotlights.component_header), 1)
          ], !0)
        ], 8, u2e)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    L(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": r.content.length,
      "theme-styles": e.theme,
      "section-header": e.spotlights.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: _(() => [
        (d(), k(K(e.wrapperComponent), we({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.spotlights.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.spotlights.content = l),
          class: [{ "all-cards-visible": e.allCardsVisible }, "spotlight-wrapper"],
          "item-key": "id"
        }), {
          item: _(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              "aria-label": `${u + 1} of ${r.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              class: "spotlight"
            }, [
              w(e.$slots, "controls", { idx: u }, void 0, !0),
              c("div", {
                ref: `spotlightCard-${u}`,
                "data-testid": "spotlight-card",
                class: "spotlight-card"
              }, [
                c("div", h2e, [
                  w(e.$slots, "quote", { idx: u }, () => [
                    A(y(l.quote), 1)
                  ], !0)
                ]),
                e.spotlights.show_name ? (d(), h("div", m2e, [
                  w(e.$slots, "author", { idx: u }, () => [
                    A(y(l.author), 1)
                  ], !0)
                ])) : b("", !0)
              ], 512),
              w(e.$slots, "image", { idx: u }, () => [
                c("img", {
                  src: l.image.url,
                  alt: l.image.alt_text,
                  class: "spotlight-image",
                  loading: "lazy"
                }, null, 8, p2e)
              ], !0)
            ], 8, c2e)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const g2e = /* @__PURE__ */ O(l2e, [["render", f2e], ["__scopeId", "data-v-0c9ba3f8"]]), v2e = {
  name: "IconButton",
  props: {
    iconColor: {
      type: String,
      default: "#fff"
    },
    backgroundColor: {
      type: String,
      default: "#000"
    },
    borderColor: {
      type: String,
      default: "#fff"
    },
    opacity: {
      type: String,
      default: "100"
    },
    width: {
      type: String,
      default: "60"
    },
    height: {
      type: String,
      default: "60"
    },
    mirror: {
      type: Boolean,
      default: !1
    },
    onClick: {
      type: Function,
      default: () => {
      }
    }
  },
  computed: {
    cssVars() {
      return {
        "--icon-color": this.iconColor,
        "--bg-color": this.backgroundColor,
        "--border-color": this.borderColor,
        "--opacity": `${this.opacity}%`,
        "--width": `${this.width}px`,
        "--height": `${this.height}px`
      };
    }
  }
};
function b2e(e, t, n, o, i, r) {
  return d(), h("button", {
    class: "icon-button",
    style: j(r.cssVars),
    onClick: t[0] || (t[0] = (a) => e.$emit("on-click"))
  }, [
    c("div", {
      class: v(["icon-wrapper", { mirror: n.mirror }])
    }, [
      w(e.$slots, "icon", {}, void 0, !0)
    ], 2)
  ], 4);
}
const y2e = /* @__PURE__ */ O(v2e, [["render", b2e], ["__scopeId", "data-v-c77efb17"]]), _2e = {
  name: "SL4",
  components: { IconButton: y2e },
  mixins: [Ri],
  data() {
    return {
      activeItem: 0,
      autoplayInterval: null,
      autoPlay: !0,
      isOverflow: !1
    };
  },
  computed: {
    content() {
      var e;
      return (e = this.spotlights.content) != null ? e : [];
    },
    currentItem() {
      return this.content.length > 0 ? this.content[this.activeItem] : {
        id: 0,
        author_id: 0,
        quote: "",
        author: "",
        role: "",
        image: { url: "", alt_text: "" },
        link: { name: "", href: "", target: "" }
      };
    },
    borderColor() {
      return ae(this.colors["--bg-color"]).isLight() ? "#000000" : "#FFFFFF";
    },
    cssVars() {
      return he(ie({}, this.colors), {
        "--image-border-color": this.borderColor
      });
    }
  },
  mounted() {
    this.isEditing || (this.$nextTick(() => {
      this.checkOverflow();
    }), window.addEventListener("resize", this.checkOverflow), this.startAutoplay());
  },
  beforeUnmount() {
    clearInterval(this.autoplayInterval), window.removeEventListener("resize", this.checkOverflow);
  },
  methods: {
    itemSelect(e) {
      this.activeItem = e, !this.isEditing && this.autoPlay && this.restartAutoplay();
    },
    previousItem() {
      this.itemSelect((this.activeItem - 1 + this.content.length) % this.content.length);
    },
    nextItem() {
      this.itemSelect((this.activeItem + 1) % this.content.length);
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(this.nextItem, 8e3);
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    },
    restartAutoplay() {
      this.stopAutoplay(), this.startAutoplay();
    },
    toggleAutoplay() {
      this.isEditing || (this.autoPlay = !this.autoPlay, this.autoPlay ? this.startAutoplay() : this.stopAutoplay());
    },
    checkOverflow() {
      this.isOverflow = this.isMobile ? !1 : this.$refs.thumbnails && this.$refs.thumbnails.scrollHeight > this.$refs.thumbnails.clientHeight;
    }
  }
}, C2e = { class: "spotlight-wrapper" }, w2e = ["data-testid"], T2e = ["data-testid"], k2e = { class: "col-1" }, E2e = { class: "spotlight-quote-container" }, S2e = { class: "col-2" }, M2e = {
  key: 0,
  class: "author-role-container"
}, A2e = { class: "gallery-container" }, $2e = { class: "gallery-track" }, I2e = ["fill"], D2e = {
  key: 1,
  width: "56",
  height: "12",
  viewBox: "0 0 6 12",
  xmlns: "http://www.w3.org/2000/svg"
}, L2e = ["fill"], O2e = {
  width: "22",
  height: "12",
  viewBox: "0 0 22 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, N2e = ["stroke"], P2e = ["onClick"], H2e = {
  key: 0,
  class: "author-role-container"
}, F2e = {
  width: "22",
  height: "12",
  viewBox: "0 0 22 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, R2e = ["stroke"], B2e = { class: "main-image" };
function V2e(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("IconButton");
  return d(), h("div", {
    class: v(["spotlight-v4", [e.theme.style, { editing: e.isEditing }]]),
    "data-testid": "SL4",
    style: j(r.cssVars)
  }, [
    c("div", C2e, [
      L(a, {
        "theme-options": e.theme,
        class: v(["see-all-top", e.theme.style])
      }, {
        header: _(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (d(), h("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              w(e.$slots, "header-top", {}, () => [
                A(y(e.spotlights.component_header_top), 1)
              ], !0)
            ], 8, T2e)) : b("", !0),
            w(e.$slots, "header", {}, () => [
              A(y(e.spotlights.component_header), 1)
            ], !0)
          ], 8, w2e)
        ]),
        default: _(() => {
          var l, u;
          return [
            e.isBoldStyle && !e.isMobile ? (d(), k(K(e.isEditing ? "button" : "a"), {
              key: 0,
              class: v(["see-all-button", e.theme.style]),
              href: (l = r.currentItem.link) == null ? void 0 : l.href,
              target: (u = r.currentItem.link) == null ? void 0 : u.target
            }, {
              default: _(() => [
                A(y(r.currentItem.link.name) + " ", 1),
                w(e.$slots, "link", { idx: i.activeItem }, void 0, !0)
              ]),
              _: 3
            }, 8, ["class", "href", "target"])) : b("", !0)
          ];
        }),
        _: 3
      }, 8, ["theme-options", "class"]),
      c("div", k2e, [
        c("div", E2e, [
          (d(!0), h(Y, null, ee(r.content, (l, u) => (d(), h("div", {
            key: u,
            class: v(["spotlight-quote-text", e.theme.style, { active: u === i.activeItem }])
          }, [
            w(e.$slots, "quote", { idx: i.activeItem }, () => [
              A(y(l.quote), 1)
            ], !0)
          ], 2))), 128))
        ]),
        e.isBoldStyle || e.isLightStyle && !e.isDesktop ? b("", !0) : (d(), k(a, {
          key: 0,
          class: v(e.theme.style),
          "theme-options": e.theme
        }, {
          default: _(() => {
            var l, u;
            return [
              (d(), k(K(e.isEditing ? "button" : "a"), {
                class: v(["see-all-button", e.theme.style]),
                href: (l = r.currentItem.link) == null ? void 0 : l.href,
                target: (u = r.currentItem.link) == null ? void 0 : u.target
              }, {
                default: _(() => {
                  var m;
                  return [
                    A(y((m = r.currentItem.link) == null ? void 0 : m.name) + " ", 1),
                    w(e.$slots, "link", { idx: i.activeItem }, void 0, !0)
                  ];
                }),
                _: 3
              }, 8, ["class", "href", "target"]))
            ];
          }),
          _: 3
        }, 8, ["class", "theme-options"]))
      ]),
      c("div", S2e, [
        e.isMobile ? (d(), h("div", M2e, [
          (d(!0), h(Y, null, ee(r.content, (l, u) => (d(), h("div", {
            key: u,
            class: v(["author-role-text", { active: u === i.activeItem }])
          }, [
            c("div", {
              class: v(["spotlight-author-text", e.theme.style])
            }, [
              w(e.$slots, "author", { idx: i.activeItem }, () => [
                A(y(l.author), 1)
              ], !0)
            ], 2),
            c("div", {
              class: v(["spotlight-role-text", e.theme.style])
            }, [
              w(e.$slots, "role", { idx: i.activeItem }, () => [
                A(y(l.role), 1)
              ], !0)
            ], 2)
          ], 2))), 128))
        ])) : b("", !0),
        c("div", A2e, [
          c("div", $2e, [
            e.isEditing ? b("", !0) : (d(), k(s, {
              key: 0,
              class: "play-button",
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex,
              onOnClick: r.toggleAutoplay
            }, {
              icon: _(() => [
                i.autoPlay ? (d(), h("svg", {
                  key: 0,
                  width: "56",
                  height: "56",
                  viewBox: "0 0 56 56",
                  fill: e.theme.arrow_icon_color.hex,
                  xmlns: "http://www.w3.org/2000/svg"
                }, t[0] || (t[0] = [
                  c("rect", {
                    x: "21",
                    y: "15",
                    width: "5",
                    height: "24"
                  }, null, -1),
                  c("rect", {
                    x: "30",
                    y: "15",
                    width: "5",
                    height: "24"
                  }, null, -1)
                ]), 8, I2e)) : (d(), h("svg", D2e, [
                  c("path", {
                    d: "M0 12L6 6L0 0V12Z",
                    fill: e.theme.arrow_icon_color.hex
                  }, null, 8, L2e)
                ]))
              ]),
              _: 1
            }, 8, ["background-color", "opacity", "border-color", "onOnClick"])),
            i.isOverflow ? (d(), k(s, {
              key: 1,
              class: "back-button",
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex,
              onOnClick: r.previousItem
            }, {
              icon: _(() => [
                (d(), h("svg", O2e, [
                  c("path", {
                    d: "M2 9.85742L10.3279 2.29789C10.7091 1.95181 11.2909 1.95181 11.6721 2.29789L20 9.85742",
                    stroke: e.theme.arrow_icon_color.hex,
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, 8, N2e)
                ]))
              ]),
              _: 1
            }, 8, ["background-color", "opacity", "border-color", "onOnClick"])) : b("", !0),
            c("div", {
              ref: "thumbnails",
              class: v(["thumbnails-container", { "is-overflow": i.isOverflow }])
            }, [
              (d(!0), h(Y, null, ee(r.content, (l, u) => (d(), h("div", {
                key: u,
                class: v([{ active: u === i.activeItem }, "thumbnail"]),
                onClick: (m) => r.itemSelect(u)
              }, [
                e.isMobile ? b("", !0) : (d(), h("div", H2e, [
                  c("div", {
                    class: v(["spotlight-author-text", e.theme.style])
                  }, [
                    w(e.$slots, "author", { idx: u }, () => [
                      A(y(l.author), 1)
                    ], !0)
                  ], 2),
                  c("div", {
                    class: v(["spotlight-author-text", e.theme.style])
                  }, [
                    w(e.$slots, "role", { idx: u }, () => [
                      A(y(l.role), 1)
                    ], !0)
                  ], 2)
                ])),
                (d(), k(K(l.image.url ? "img" : "div"), {
                  draggable: "false",
                  src: l.image.url,
                  alt: l.image.alt_text,
                  class: "mini-image"
                }, null, 8, ["src", "alt"]))
              ], 10, P2e))), 128))
            ], 2),
            i.isOverflow ? (d(), k(s, {
              key: 2,
              class: "next-button",
              mirror: "",
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex,
              onOnClick: r.nextItem
            }, {
              icon: _(() => [
                (d(), h("svg", F2e, [
                  c("path", {
                    d: "M2 9.85742L10.3279 2.29789C10.7091 1.95181 11.2909 1.95181 11.6721 2.29789L20 9.85742",
                    stroke: e.theme.arrow_icon_color.hex,
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, 8, R2e)
                ]))
              ]),
              _: 1
            }, 8, ["background-color", "opacity", "border-color", "onOnClick"])) : b("", !0)
          ]),
          c("div", B2e, [
            (d(!0), h(Y, null, ee(r.content, (l, u) => (d(), k(K(l.image.url ? "img" : "div"), {
              key: u,
              draggable: "false",
              src: r.currentItem.image.url,
              alt: r.currentItem.image.alt_text,
              class: v(["active-image", { active: u === i.activeItem }])
            }, null, 8, ["src", "alt", "class"]))), 128)),
            w(e.$slots, "image", { idx: i.activeItem }, void 0, !0)
          ])
        ])
      ]),
      e.isBoldStyle && e.isMobile || e.isLightStyle && !e.isDesktop ? (d(), k(a, {
        key: 0,
        class: v([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme
      }, {
        default: _(() => {
          var l, u;
          return [
            (d(), k(K(e.isEditing ? "button" : "a"), {
              class: v(["see-all-button", e.theme.style]),
              href: (l = r.currentItem.link) == null ? void 0 : l.href,
              target: (u = r.currentItem.link) == null ? void 0 : u.target
            }, {
              default: _(() => {
                var m;
                return [
                  A(y((m = r.currentItem.link) == null ? void 0 : m.name) + " ", 1),
                  w(e.$slots, "link", { idx: e.idx }, void 0, !0)
                ];
              }),
              _: 3
            }, 8, ["class", "href", "target"]))
          ];
        }),
        _: 3
      }, 8, ["class", "theme-options"])) : b("", !0)
    ])
  ], 6);
}
const j2e = /* @__PURE__ */ O(_2e, [["render", V2e], ["__scopeId", "data-v-84435ad0"]]), U2e = {
  name: "SL5",
  components: {
    CardSlider: Jt
  },
  mixins: [Ri, ut],
  data() {
    return {
      activeTabIdx: 0,
      defaultNestedContent: [
        {
          cards: [],
          icon: "",
          label: "",
          show_image_icons: !0,
          show_headline: !0,
          show_snippet: !0
        }
      ]
    };
  },
  computed: {
    nestedContent() {
      var e, t;
      return (t = (e = this.spotlights) == null ? void 0 : e.nested_content) != null ? t : this.defaultNestedContent;
    },
    activeTabData() {
      return this.nestedContent[this.activeTabIdx];
    },
    content() {
      return this.activeTabData.cards;
    },
    cssVars() {
      return he(ie({}, this.colors), {
        "--button-bg-color": S(this.theme, "button_bg_color.hex", "#5D5FEF"),
        "--button-border-color": S(this.theme, "button_border_color.hex", "#8f91ff"),
        "--button-icon-color": S(this.theme, "button_icon_color.hex", "#8f91ff"),
        "--button-text-color": S(this.theme, "button_text_color.hex", "#8f91ff"),
        "--button-active-bg-color": S(this.theme, "button_active_bg_color.hex", "#5D5FEF"),
        "--button-active-border-color": S(this.theme, "button_active_border_color.hex", "#fff"),
        "--button-active-icon-color": S(this.theme, "button_active_icon_color.hex", "#fff"),
        "--button-active-text-color": S(this.theme, "button_active_text_color.hex", "#fff"),
        "--image-gradient-color": S(this.theme, "image_gradient_color.hex", "#000000"),
        "--quote-icon-color": S(this.theme, "quote_icon_color.hex", "#fff"),
        "--role-color": S(this.theme, "role_color.hex", "#000"),
        "--line-color": S(this.theme, "line_color.hex", "#8f91ff")
      });
    }
  },
  methods: {
    tabActivate(e) {
      this.activeTabIdx = e, this.$emit("update:selectedIdx", this.activeTabIdx);
    }
  }
}, G2e = { class: "spotlight-wrapper" }, z2e = ["data-testid"], K2e = ["data-testid"], Z2e = ["onClick"], x2e = {
  key: 0,
  class: "icon-wrapper"
}, W2e = ["innerHTML"], q2e = ["aria-label"], Y2e = { class: "top" }, X2e = {
  key: 0,
  class: "mask"
}, Q2e = ["src", "alt"], J2e = {
  key: 2,
  class: "no-image"
}, eme = { class: "content" }, tme = {
  key: 0,
  class: "icon-wrapper"
}, nme = ["innerHTML"], ome = {
  key: 1,
  class: "snippet"
}, rme = { class: "bottom" }, ime = {
  key: 0,
  "data-testid": "spotlight-card",
  class: "name-role-wrapper"
}, sme = { class: "role" }, ame = ["aria-label"], lme = ["aria-label"];
function ume(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("CardSlider");
  return d(), h("div", {
    class: v(["spotlight-v5", [e.theme.style, { editing: e.isEditing }]]),
    "data-testid": "SL5",
    style: j(r.cssVars)
  }, [
    c("div", G2e, [
      L(a, {
        class: v([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: _(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.displayHeaderTop ? (d(), h("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              w(e.$slots, "header-top", {}, () => [
                A(y(e.spotlights.component_header_top), 1)
              ], !0)
            ], 8, K2e)) : b("", !0),
            w(e.$slots, "header", {}, () => [
              A(y(e.spotlights.component_header), 1)
            ], !0)
          ], 8, z2e)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
        modelValue: e.spotlights.nested_content,
        "onUpdate:modelValue": t[0] || (t[0] = (l) => e.spotlights.nested_content = l),
        "item-key": "id",
        class: ["spotlight-tabs", { editing: e.isEditing }]
      }), {
        item: _(({ element: l, index: u }) => [
          c("button", {
            class: v(["tab-button", { active: u === i.activeTabIdx }]),
            onClick: (m) => r.tabActivate(u)
          }, [
            w(e.$slots, "controls", { idx: u }, void 0, !0),
            e.spotlights.show_icons ? (d(), h("div", x2e, [
              w(e.$slots, "tab-icon", { idx: u }, () => [
                c("span", {
                  class: "icon",
                  innerHTML: l.icon
                }, null, 8, W2e)
              ], !0)
            ])) : b("", !0),
            e.spotlights.show_tab_labels ? (d(), h("div", {
              key: 1,
              class: v(["label", [e.theme.style]])
            }, [
              w(e.$slots, "label", { idx: u }, () => [
                A(y(l.label), 1)
              ], !0)
            ], 2)) : b("", !0)
          ], 10, Z2e)
        ]),
        _: 3
      }, 16, ["modelValue", "class"])),
      r.activeTabData && r.activeTabData.cards && r.activeTabData.cards.length ? (d(), k(s, {
        key: 0,
        "nav-orientation": "bottom",
        "pager-orientation": "right",
        "current-card": e.currentCard,
        "pager-section-count": e.pagerSectionCount,
        "total-cards": r.activeTabData.cards.length,
        "section-header": e.spotlights.component_header,
        "has-pager": !1,
        "theme-styles": e.theme,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft,
        onGoToSection: e.goToSection
      }, {
        "button-left": _(() => [
          c("button", {
            class: "slider-button left",
            "aria-label": e.translations.previous_item || "Previous Item",
            onKeyup: t[2] || (t[2] = V((...l) => e.scrollLeft && e.scrollLeft(...l), ["left"])),
            onClick: t[3] || (t[3] = (...l) => e.scrollLeft && e.scrollLeft(...l))
          }, t[6] || (t[6] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 40, ame)
        ]),
        "button-right": _(() => [
          c("button", {
            class: "slider-button right",
            "aria-label": e.translations.next_item || "Next Item",
            onKeyup: t[4] || (t[4] = V((...l) => e.scrollRight && e.scrollRight(...l), ["right"])),
            onClick: t[5] || (t[5] = (...l) => e.scrollRight && e.scrollRight(...l))
          }, t[7] || (t[7] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 40, lme)
        ]),
        default: _(() => [
          (d(), k(K(e.wrapperComponent), we({ ref: "scrollWrapper" }, e.wrapperProps, {
            modelValue: r.activeTabData.cards,
            "onUpdate:modelValue": t[1] || (t[1] = (l) => r.activeTabData.cards = l),
            "item-key": "id",
            class: "cards-wrapper"
          }), {
            item: _(({ element: l, index: u }) => [
              c("div", {
                ref: `sliderCard-${u}`,
                "aria-label": `${u + 1} of ${r.activeTabData.cards.length}`,
                role: "group",
                "aria-roledescription": "slide",
                class: v(["card", { editing: e.isEditing }])
              }, [
                c("div", Y2e, [
                  w(e.$slots, "tab-controls", {
                    idx: u,
                    tabIdx: i.activeTabIdx
                  }, void 0, !0),
                  l.image.url ? (d(), h("div", X2e)) : b("", !0),
                  l.image.url ? (d(), h("img", {
                    key: 1,
                    src: l.image.url,
                    alt: l.image.alt_text,
                    class: "image",
                    draggable: "false",
                    loading: "lazy"
                  }, null, 8, Q2e)) : b("", !0),
                  !l.image.url && e.isEditing ? (d(), h("div", J2e)) : b("", !0),
                  c("div", eme, [
                    r.activeTabData.show_image_icons ? (d(), h("div", tme, [
                      w(e.$slots, "icon", {
                        idx: u,
                        tabIdx: i.activeTabIdx
                      }, () => [
                        c("span", {
                          class: "icon",
                          innerHTML: l.icon
                        }, null, 8, nme)
                      ], !0)
                    ])) : b("", !0),
                    r.activeTabData.show_snippet ? (d(), h("p", ome, [
                      w(e.$slots, "snippet", {
                        idx: u,
                        tabIdx: i.activeTabIdx
                      }, () => [
                        A(y(l.snippet), 1)
                      ], !0)
                    ])) : b("", !0)
                  ])
                ]),
                c("div", rme, [
                  r.activeTabData.show_headline ? (d(), h("div", ime, [
                    c("div", {
                      class: v(["name", [e.theme.style]]),
                      "data-testid": "spotlight-name"
                    }, [
                      w(e.$slots, "author", {
                        idx: u,
                        tabIdx: i.activeTabIdx
                      }, () => [
                        A(y(l.name), 1)
                      ], !0)
                    ], 2),
                    c("div", sme, [
                      w(e.$slots, "role", {
                        idx: u,
                        tabIdx: i.activeTabIdx
                      }, () => [
                        A(y(l.role), 1)
                      ], !0)
                    ])
                  ])) : b("", !0)
                ])
              ], 10, q2e)
            ]),
            _: 3
          }, 16, ["modelValue"]))
        ]),
        _: 3
      }, 8, ["current-card", "pager-section-count", "total-cards", "section-header", "theme-styles", "onScrollRight", "onScrollLeft", "onGoToSection"])) : b("", !0)
    ])
  ], 6);
}
const dme = /* @__PURE__ */ O(U2e, [["render", ume], ["__scopeId", "data-v-a3f88a2f"]]), cme = {
  name: "Spotlight",
  components: {
    SL1: Q0e,
    SL2: a2e,
    SL3: g2e,
    SL4: j2e,
    SL5: dme
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  },
  methods: {
    handleSelectedIdx(e) {
      this.$emit("update:selectedIdx", e);
    }
  }
}, hme = { id: "view-spotlight" };
function mme(e, t, n, o, i, r) {
  return d(), h("div", hme, [
    (d(), k(K(n.theme.version), {
      theme: n.theme,
      spotlights: n.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "is-editing": n.isEditing,
      "onUpdate:selectedIdx": r.handleSelectedIdx
    }, {
      "header-top": _(() => [
        w(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: _(() => [
        w(e.$slots, "header", {}, void 0, !0)
      ]),
      controls: _(({ idx: a }) => [
        w(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      "tab-controls": _(({ idx: a, tabIdx: s }) => [
        w(e.$slots, "tab-controls", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      image: _(({ idx: a }) => [
        w(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      title: _(({ title: a, idx: s }) => [
        w(e.$slots, "title", {
          title: a,
          idx: s
        }, void 0, !0)
      ]),
      quote: _(({ quote: a, idx: s }) => [
        w(e.$slots, "quote", {
          quote: a,
          idx: s
        }, void 0, !0)
      ]),
      author: _(({ author: a, idx: s, tabIdx: l }) => [
        w(e.$slots, "author", {
          author: a,
          idx: s,
          tabIdx: l
        }, void 0, !0)
      ]),
      role: _(({ role: a, idx: s, tabIdx: l }) => [
        w(e.$slots, "role", {
          role: a,
          idx: s,
          tabIdx: l
        }, void 0, !0)
      ]),
      icon: _(({ idx: a, tabIdx: s }) => [
        w(e.$slots, "icon", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      "tab-icon": _(({ idx: a }) => [
        w(e.$slots, "tab-icon", { idx: a }, void 0, !0)
      ]),
      label: _(({ label: a, idx: s }) => [
        w(e.$slots, "label", {
          label: a,
          idx: s
        }, void 0, !0)
      ]),
      snippet: _(({ idx: a, tabIdx: s }) => [
        w(e.$slots, "snippet", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      link: _(({ idx: a }) => [
        w(e.$slots, "link", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "spotlights", "wrapper-component", "wrapper-props", "is-editing", "onUpdate:selectedIdx"]))
  ]);
}
const pme = /* @__PURE__ */ O(cme, [["render", mme], ["__scopeId", "data-v-f0dee26f"]]), fme = {
  mixins: [mt],
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    athletics: {
      type: Array,
      required: !0
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    athleticsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  computed: {
    theme() {
      return this.options;
    },
    colors() {
      const e = this.sharedThemeColors(), t = S(this.theme, "athletic_bg_color.hex", "none"), n = S(this.theme, "athletic_title_color.hex", "initial");
      return he(ie({}, e), {
        "--athletic-bg-color": t,
        "--athletic-title-color": n,
        "--date-color": S(this.theme, "date_color.hex", "initial"),
        "--time-color": S(this.theme, "time_color.hex", "initial"),
        "--athletic-separator-color": S(this.theme, "athletic_separator_color.hex", "#000"),
        "--athletic-card-border": S(
          this.theme,
          "athletic_card_border.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--vs-tag-bg-color": S(this.theme, "vs_tag_bg.hex", t),
        "--vs-tag-text-color": S(this.theme, "vs_tag_color.hex", n)
      });
    },
    translations() {
      return this.options.translations;
    },
    isMonterreyStyle() {
      return this.options.style === "monterrey";
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("athletics");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    }
  }
}, gme = {
  name: "A1",
  mixins: [fme]
}, vme = ["data-testid"], bme = { class: "athletics-match" }, yme = {
  key: 0,
  "data-testid": "versus"
}, _me = {
  key: 1,
  "data-testid": "non-versus"
};
function Cme(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    id: "athletics-a1",
    style: j(e.colors),
    "data-testid": "a1",
    class: v(e.theme.style)
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        e.isMonterreyStyle ? (d(), h("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header-top", {}, () => [
            A(y(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, vme)) : b("", !0),
        (d(), k(K(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: _(() => [
            w(e.$slots, "header", {}, () => [
              A(y(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: _(() => [
        e.options.style !== "purple" && e.screenSize > 600 ? (d(), k(K(e.isEditing ? "button" : "a"), {
          key: 0,
          class: v(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : b("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: v(["athletics-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), h(Y, null, ee(e.athletics.slice(0, 6), (s, l) => (d(), h("div", {
        key: `${l}-${s.title}`,
        class: "athletics-card athletic-accent-border",
        "data-testid": "athletic-accent-border"
      }, [
        c("p", {
          class: v(["athletics-date", e.options.style])
        }, y(s.month) + " " + y(s.day), 3),
        c("div", {
          class: v(["athletics-time", e.options.style])
        }, y(s.time), 3),
        c("div", {
          class: v(["athletics-filter", e.options.style])
        }, y(s.filter_name), 3),
        c("h3", bme, [
          s.versus ? (d(), h("div", yme, [
            A(y(s.away_team) + " ", 1),
            c("span", null, y(e.translations.at), 1),
            A(" " + y(s.home_team), 1)
          ])) : (d(), h("div", _me, y(s.title), 1))
        ])
      ]))), 128))
    ], 2),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), k(a, {
      key: 0,
      class: v([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: _(() => [
        (d(), k(K(e.isEditing ? "button" : "a"), {
          class: v(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: _(() => [
            A(y(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : b("", !0)
  ], 6);
}
const wme = /* @__PURE__ */ O(gme, [["render", Cme], ["__scopeId", "data-v-ca02bffd"]]), Tme = {
  name: "CmsAthletics",
  components: {
    A1: wme
  },
  props: {
    options: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    athleticsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  }
}, kme = { id: "view-athletics" };
function Eme(e, t, n, o, i, r) {
  return d(), h("div", kme, [
    (d(), k(K(n.options.version), {
      options: n.options,
      "component-id": n.componentId,
      athletics: n.content,
      "athletics-config": n.athleticsConfig,
      "is-editing": n.isEditing,
      "path-prefix": n.pathPrefix,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": _(() => [
        w(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: _(() => [
        w(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["options", "component-id", "athletics", "athletics-config", "is-editing", "path-prefix"]))
  ]);
}
const Sme = /* @__PURE__ */ O(Tme, [["render", Eme], ["__scopeId", "data-v-efaab17b"]]), Mme = {
  name: "SvgArrow"
}, Ame = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 21",
  fill: "none"
};
function $me(e, t, n, o, i, r) {
  return d(), h("svg", Ame, t[0] || (t[0] = [
    c("mask", {
      id: "path-1-inside-1_1",
      fill: "white"
    }, [
      c("path", { d: "M15.5 0L26 10.5L15 21L13.5 19.5L22 11.5H0V9.5H22L14 1.5L15.5 0Z" })
    ], -1),
    c("path", {
      d: "M15.5 0L26 10.5L15 21L13.5 19.5L22 11.5H0V9.5H22L14 1.5L15.5 0Z",
      class: "arrow_svg",
      "stroke-width": "4",
      mask: "url(#path-1-inside-1_1)"
    }, null, -1)
  ]));
}
const Ime = /* @__PURE__ */ O(Mme, [["render", $me]]), Oa = {
  mixins: [mt],
  components: { DraggableWrapper: at },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    buttons: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return he(ie({}, e), {
        "--bg-color": S(this.theme, "bg_color.hex", "#fff"),
        "--text-color": S(this.theme, "text_color.hex", "#000"),
        "--arrow-color": S(this.theme, "arrow_color.hex", "#000"),
        "--arrow-color-hover": S(this.theme, "arrow_color_hover.hex", "#000"),
        "--button-text-color": S(this.theme, "button_text_color.hex", "#fff"),
        "--button-bg-color": S(this.theme, "button_bg_color.hex", "#000"),
        "--border-radius": `${this.theme.border_radius}px`,
        "--percentage-opacity": `${100 - this.theme.percentage_opacity}%`,
        "--icon-and-text-color": S(this.theme, "icon_and_text_color.hex", "#fff")
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, Dme = {
  name: "B1",
  components: { SvgArrow: Ime },
  mixins: [Oa]
}, Lme = { "data-testid": "buttons-content" };
function Ome(e, t, n, o, i, r) {
  const a = $("SvgArrow");
  return d(), h("div", {
    id: "buttons-b1",
    "data-testid": "B1",
    class: v(e.theme.style),
    style: j(e.colors)
  }, [
    (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.buttons.content = s),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: _(({ element: s, index: l }) => [
        c("div", Lme, [
          (d(), k(K(e.isEditing ? "div" : "a"), {
            href: s.link,
            target: s.opens_in_new_tab ? "_blank" : "",
            class: "button-link"
          }, {
            default: _(() => [
              w(e.$slots, "controls", { idx: l }, void 0, !0),
              w(e.$slots, "title", { idx: l }, () => [
                A(y(s.title), 1)
              ], !0),
              L(a)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Nme = /* @__PURE__ */ O(Dme, [["render", Ome], ["__scopeId", "data-v-d157672d"]]), Pme = {
  name: "B2",
  mixins: [Oa]
};
function Hme(e, t, n, o, i, r) {
  return d(), h("div", {
    id: "buttons-b2",
    "data-testid": "B2",
    class: v([e.theme.style, { uppercase: e.theme.uppercase }]),
    style: j(e.colors)
  }, [
    (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => e.buttons.content = a),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: _(({ element: a, index: s }) => [
        c("div", null, [
          (d(), k(K(e.isEditing ? "div" : "a"), {
            href: a.link,
            target: a.opens_in_new_tab ? "_blank" : "",
            class: "button-link",
            "data-testid": "buttons-content"
          }, {
            default: _(() => [
              w(e.$slots, "controls", { idx: s }, void 0, !0),
              c("span", null, [
                w(e.$slots, "title", { idx: s }, () => [
                  A(y(a.title), 1)
                ], !0)
              ])
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Fme = /* @__PURE__ */ O(Pme, [["render", Hme], ["__scopeId", "data-v-dac6a587"]]), Rme = {
  name: "B3",
  mixins: [Oa],
  computed: {
    buttonCount() {
      return this.buttons.content.length;
    },
    iconsActive() {
      return this.buttons.icons_active;
    },
    buttonClasses() {
      return [`buttons-${this.buttonCount}`, { "can-stack": this.buttonCount > 4 }, this.theme.style];
    },
    borderColor() {
      return ae(this.colors["--button-bg-color"]).isLight() ? "rgba(0, 0, 0, 0.15)" : "rgba(255,255,255, 0.15)";
    },
    cssVars() {
      return he(ie({}, this.colors), {
        "--button-border": `1px solid ${this.borderColor}`
      });
    }
  }
}, Bme = {
  key: 0,
  class: "icon-wrapper",
  "aria-hidden": "true"
}, Vme = { class: "raw-svg" }, jme = ["innerHTML"], Ume = { class: "button-title" };
function Gme(e, t, n, o, i, r) {
  return d(), h("div", {
    id: "buttons-b3",
    "data-testid": "B3",
    class: v(e.theme.style),
    style: j(r.cssVars)
  }, [
    (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => e.buttons.content = a),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: _(({ element: a, index: s }) => [
        c("div", {
          class: v(["button", r.buttonClasses])
        }, [
          (d(), k(K(e.isEditing ? "div" : "a"), {
            href: a.link,
            class: v([[e.theme.style, !r.iconsActive && "no-icons"], "button-link"]),
            target: a.opens_in_new_tab ? "_blank" : "",
            "data-testid": "buttons-content"
          }, {
            default: _(() => [
              w(e.$slots, "controls", { idx: s }, void 0, !0),
              r.iconsActive ? (d(), h("div", Bme, [
                c("span", Vme, [
                  w(e.$slots, "icon", { idx: s }, () => [
                    c("span", {
                      "data-testid": "svg",
                      innerHTML: a.icon
                    }, null, 8, jme)
                  ], !0)
                ])
              ])) : b("", !0),
              c("span", Ume, [
                w(e.$slots, "title", { idx: s }, () => [
                  A(y(a.title), 1)
                ], !0)
              ])
            ]),
            _: 2
          }, 1032, ["href", "class", "target"]))
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const zme = /* @__PURE__ */ O(Rme, [["render", Gme], ["__scopeId", "data-v-2e00171e"]]), Kme = {
  name: "B4",
  mixins: [Oa],
  props: {
    logo: {
      type: String,
      required: !0
    }
  },
  computed: {
    content: {
      get() {
        return this.buttons.content.slice(0, 3);
      },
      set(e) {
        this.buttons.content = e;
      }
    },
    b4Colors() {
      return {
        // ...this.cssVars,
        "--button-1-bg-color": S(this.theme, "button_1_bg_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--button-1-border-color": S(this.theme, "button_1_border_color.hex", "#fff"),
        "--button-1-text-color": S(this.theme, "button_1_text_color.hex", "#fff"),
        "--button-2-bg-color": S(this.theme, "button_2_bg_color.hex", this.theme.globalThemeSettings.primaryColor),
        "--button-2-border-color": S(this.theme, "button_2_border_color.hex", "#fff"),
        "--button-2-text-color": S(this.theme, "button_2_text_color.hex", "#fff"),
        "--button-3-bg-color": S(this.theme, "button_3_bg_color.hex", "#000"),
        "--button-3-border-color": S(this.theme, "button_3_border_color.hex", "#fff"),
        "--button-3-text-color": S(this.theme, "button_3_text_color.hex", "#fff")
      };
    }
  }
}, Zme = { class: "button-title-wrapper" }, xme = ["src"];
function Wme(e, t, n, o, i, r) {
  return d(), h("div", {
    "data-testid": "B4",
    class: v(["B4", e.theme.style]),
    style: j(r.b4Colors)
  }, [
    (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
      modelValue: r.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => r.content = a),
      "item-key": "index",
      class: "button-wrapper"
    }), {
      item: _(({ element: a, index: s }) => [
        (d(), k(K(e.isEditing ? "div" : "a"), {
          class: v(["button", `button-style-${s + 1}`]),
          href: a.link,
          target: a.opens_in_new_tab ? "_blank" : "",
          "data-testid": "button"
        }, {
          default: _(() => [
            w(e.$slots, "controls", { idx: s }, void 0, !0),
            c("div", Zme, [
              c("div", {
                class: v([e.theme.style, "button-title"])
              }, [
                w(e.$slots, "title", {
                  title: a.title,
                  idx: s
                }, () => [
                  A(y(a.title), 1)
                ], !0)
              ], 2),
              c("img", {
                src: n.logo,
                alt: "",
                "data-testid": "button-image"
              }, null, 8, xme)
            ])
          ]),
          _: 2
        }, 1032, ["class", "href", "target"]))
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const qme = /* @__PURE__ */ O(Kme, [["render", Wme], ["__scopeId", "data-v-8248f642"]]), Yme = {
  name: "Buttons",
  components: {
    B1: Nme,
    B2: Fme,
    B3: zme,
    B4: qme
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    logo: {
      type: String,
      default: ""
    }
  }
};
function Xme(e, t, n, o, i, r) {
  return d(), k(K(n.theme.version), {
    theme: n.theme,
    buttons: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    logo: n.logo
  }, {
    controls: _(({ idx: a }) => [
      w(e.$slots, "controls", { idx: a })
    ]),
    icon: _(({ idx: a }) => [
      w(e.$slots, "icon", { idx: a })
    ]),
    title: _(({ title: a, idx: s }) => [
      w(e.$slots, "title", {
        title: a,
        idx: s
      })
    ]),
    _: 3
  }, 8, ["theme", "buttons", "wrapper-component", "wrapper-props", "is-editing", "logo"]);
}
const Qme = /* @__PURE__ */ O(Yme, [["render", Xme]]), Jme = {
  name: "IconLinkButtons",
  components: { DraggableWrapper: at },
  props: {
    modelValue: {
      type: Array,
      required: !0
    },
    buttons: {
      type: Array,
      required: !0
    },
    themeStyle: {
      type: String,
      default: "light"
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || e.name === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    buttonBgColor: {
      type: String,
      default: "#000"
    },
    buttonIconAndTextColor: {
      type: String,
      default: "#fff"
    },
    width: {
      type: String,
      default: ""
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    cssVars() {
      return {
        "--iconlink-button-bg-color": this.buttonBgColor,
        "--iconlink-button-icon-text-color": this.buttonIconAndTextColor,
        "--iconlink-container-width": this.width || `${Math.ceil(this.buttons.length / 2) * 182}px`,
        "--iconlink-border-color": `1px solid ${this.borderColor}`
      };
    },
    borderColor() {
      return ae(this.buttonBgColor).isLight() ? "rgba(0, 0, 0, 0.15)" : "rgba(255,255,255, 0.15)";
    },
    buttonModel: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, epe = { class: "button-container" }, tpe = {
  key: 0,
  class: "icon-wrapper",
  "aria-hidden": "true"
}, npe = { class: "raw-svg" }, ope = ["innerHTML"];
function rpe(e, t, n, o, i, r) {
  return d(), k(K(n.wrapperComponent), we(n.wrapperProps, {
    modelValue: r.buttonModel,
    "onUpdate:modelValue": t[0] || (t[0] = (a) => r.buttonModel = a),
    style: r.cssVars,
    "item-key": "index",
    class: "icon-link-buttons"
  }), {
    item: _(({ element: a, index: s }) => [
      (d(), k(K(!a.href || n.isEditing ? "div" : "a"), {
        href: a.href,
        target: a.target || "_self",
        class: "button",
        "data-testid": "icon-button"
      }, {
        default: _(() => [
          w(e.$slots, "controls", { idx: s }, void 0, !0),
          c("div", epe, [
            a.icon || n.isEditing ? (d(), h("div", tpe, [
              c("span", npe, [
                w(e.$slots, "icon", {
                  icon: a.icon,
                  idx: s
                }, () => [
                  c("span", {
                    innerHTML: a.icon
                  }, null, 8, ope)
                ], !0)
              ])
            ])) : b("", !0),
            c("span", {
              class: v(["button-title", n.themeStyle])
            }, [
              w(e.$slots, "title", {
                title: a.title,
                idx: s
              }, () => [
                A(y(a.title), 1)
              ], !0)
            ], 2)
          ])
        ]),
        _: 2
      }, 1032, ["href", "target"]))
    ]),
    _: 3
  }, 16, ["modelValue", "style"]);
}
const ipe = /* @__PURE__ */ O(Jme, [["render", rpe], ["__scopeId", "data-v-34984675"]]), Du = {
  mixins: [mt],
  components: {
    IconLinkButtons: ipe,
    DraggableWrapper: at
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    about: {
      type: Object,
      required: !0
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    watermark: {
      type: String,
      default: ""
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return he(ie({}, e), {
        "--top-heading-color": S(this.theme, "top_heading_color.hex", "#000"),
        "--text-color": S(this.theme, "text_color.hex", "#000"),
        "--text-link-color": S(this.theme, "text_link_color.hex", "#000"),
        "--watermark-url": `url(${this.watermark})`,
        "--card-top-header-color": S(this.theme, "card_top_header_color.hex", "#000"),
        "--card-bottom-header-color": S(this.theme, "card_bottom_header_color.hex", "#000")
      });
    },
    buttonBgColor() {
      return S(this.theme, "button_bg_color.hex", "#000");
    },
    buttonIconAndTextColor() {
      return S(this.theme, "icon_and_text_color.hex", "#fff");
    }
  }
}, spe = {
  name: "AboutV1",
  mixins: [Du],
  computed: {
    aboutImageUrl() {
      var e;
      return (e = this.about.image) == null ? void 0 : e.url;
    },
    aboutImageAltText() {
      var e;
      return (e = this.about.image) == null ? void 0 : e.alt_text;
    }
  }
}, ape = ["data-testid"], lpe = ["data-testid"], upe = { class: "main-content" }, dpe = { class: "left-content" }, cpe = ["src", "alt"], hpe = ["innerHTML"];
function mpe(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("IconLinkButtons");
  return d(), h("div", {
    id: "about-v1",
    class: v([e.theme.style, { editing: e.isEditing }]),
    style: j(e.colors),
    "data-testid": "AboutV1"
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.theme.style === "monterrey" && (e.about.component_header_top || e.isEditing) ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.about.component_header_top), 1)
            ], !0)
          ], 8, lpe)) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.about.component_header), 1)
          ], !0)
        ], 8, ape)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", upe, [
      c("div", dpe, [
        w(e.$slots, "image", {}, () => [
          e.about.has_image ? (d(), h("img", {
            key: 0,
            src: r.aboutImageUrl,
            alt: r.aboutImageAltText,
            class: "left-image",
            "data-testid": "about-image",
            loading: "lazy"
          }, null, 8, cpe)) : b("", !0)
        ], !0),
        w(e.$slots, "text", {}, () => [
          c("span", {
            class: "left-text text-block",
            innerHTML: e.about.component_text
          }, null, 8, hpe)
        ], !0)
      ]),
      L(s, {
        modelValue: e.about.links,
        "onUpdate:modelValue": t[0] || (t[0] = (l) => e.about.links = l),
        buttons: e.about.links,
        "wrapper-component": e.wrapperComponent,
        "wrapper-props": e.wrapperProps,
        "theme-style": e.theme.style,
        "button-bg-color": e.buttonBgColor,
        "button-icon-and-text-color": e.buttonIconAndTextColor,
        "is-editing": e.isEditing
      }, {
        controls: _(({ idx: l }) => [
          w(e.$slots, "controls", { idx: l }, void 0, !0)
        ]),
        icon: _(({ idx: l }) => [
          w(e.$slots, "icon", { idx: l }, void 0, !0)
        ]),
        title: _(({ title: l, idx: u }) => [
          w(e.$slots, "title", {
            title: l,
            idx: u
          }, void 0, !0)
        ]),
        _: 3
      }, 8, ["modelValue", "buttons", "wrapper-component", "wrapper-props", "theme-style", "button-bg-color", "button-icon-and-text-color", "is-editing"])
    ])
  ], 6);
}
const ppe = /* @__PURE__ */ O(spe, [["render", mpe], ["__scopeId", "data-v-87352126"]]), fpe = {
  name: "AboutV2",
  mixins: [Du, Tt],
  computed: {
    isDesktop() {
      return this.screenSize > 1280;
    }
  }
}, gpe = { class: "main-content" }, vpe = {
  key: 0,
  class: "image-wrapper"
}, bpe = ["src"], ype = ["data-testid"], _pe = { class: "main-text" }, Cpe = ["innerHTML"];
function wpe(e, t, n, o, i, r) {
  const a = $("IconLinkButtons");
  return d(), h("div", {
    class: v([{ editing: e.isEditing }, "about-v2"]),
    style: j(e.colors),
    "data-testid": "AboutV2"
  }, [
    c("div", gpe, [
      c("div", {
        class: v([e.theme.style, "top-content"])
      }, [
        e.about.has_accent_logo ? (d(), h("div", vpe, [
          t[1] || (t[1] = c("svg", {
            width: "16",
            height: "55",
            viewBox: "0 0 16 55",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "accent-icon"
          }, [
            c("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M7.67334 11.7812L7.67334 54.7812H8.67334L8.67334 11.7813L7.67334 11.7812Z",
              fill: "#000"
            }),
            c("rect", {
              width: "10.0781",
              height: "9.82776",
              transform: "matrix(0.704554 0.70965 -0.704554 0.70965 7.91162 0)",
              fill: "#000"
            })
          ], -1)),
          e.watermark ? (d(), h("img", {
            key: 0,
            src: e.watermark,
            alt: "",
            class: "left-image",
            loading: "lazy"
          }, null, 8, bpe)) : b("", !0)
        ])) : b("", !0),
        e.about.has_header ? (d(), h("h2", {
          key: 1,
          class: "header-text",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          w(e.$slots, "header", {}, () => [
            A(y(e.about.component_header), 1)
          ], !0)
        ], 8, ype)) : b("", !0),
        c("span", _pe, [
          w(e.$slots, "text", {}, () => [
            c("span", {
              innerHTML: e.about.component_text
            }, null, 8, Cpe)
          ], !0)
        ])
      ], 2),
      L(a, {
        modelValue: e.about.links,
        "onUpdate:modelValue": t[0] || (t[0] = (s) => e.about.links = s),
        buttons: e.about.links,
        "wrapper-component": e.wrapperComponent,
        "wrapper-props": e.wrapperProps,
        "theme-style": e.theme.style,
        "button-bg-color": e.buttonBgColor,
        "button-icon-and-text-color": e.buttonIconAndTextColor,
        width: r.isDesktop ? "100%" : "",
        "is-editing": e.isEditing
      }, {
        controls: _(({ idx: s }) => [
          w(e.$slots, "controls", { idx: s }, void 0, !0)
        ]),
        icon: _(({ idx: s }) => [
          w(e.$slots, "icon", { idx: s }, void 0, !0)
        ]),
        title: _(({ title: s, idx: l }) => [
          w(e.$slots, "title", {
            title: s,
            idx: l
          }, void 0, !0)
        ]),
        _: 3
      }, 8, ["modelValue", "buttons", "wrapper-component", "wrapper-props", "theme-style", "button-bg-color", "button-icon-and-text-color", "width", "is-editing"])
    ])
  ], 6);
}
const Tpe = /* @__PURE__ */ O(fpe, [["render", wpe], ["__scopeId", "data-v-3e2fce17"]]), kpe = {
  name: "AboutV3",
  mixins: [Du],
  data() {
    return {
      wrapperHeight: "unset"
    };
  },
  computed: {
    aboutLinks: {
      get() {
        return this.about.links.slice(0, 5);
      },
      set(e) {
        this.about.links = e;
      }
    }
  },
  async mounted() {
    window.addEventListener("resize", this.setHeight), await this.$nextTick(), this.setHeight();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setHeight);
  },
  methods: {
    setHeight() {
      const e = this.$refs[`card-${this.aboutLinks.length - 1}`];
      if (!e)
        return;
      const t = this.$refs.cardWrapper, o = e.getBoundingClientRect().top - t.$el.getBoundingClientRect().top + e.clientHeight;
      this.wrapperHeight = `${o}px`;
    }
  }
}, Epe = { class: "top-container" }, Spe = ["data-testid"], Mpe = ["data-testid"], Ape = ["innerHTML"], $pe = { class: "card-top-title" }, Ipe = { class: "card-title" }, Dpe = { class: "card-image" }, Lpe = ["src", "alt"];
function Ope(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    style: j(e.colors),
    class: v([e.theme.style, "about-v3"])
  }, [
    c("div", Epe, [
      L(a, {
        class: v([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: _(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}`,
            class: "no-border"
          }, [
            e.theme.style === "monterrey" && (e.about.component_header_top || e.isEditing) ? (d(), h("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              w(e.$slots, "header-top", {}, () => [
                A(y(e.about.component_header_top), 1)
              ])
            ], 8, Mpe)) : b("", !0),
            w(e.$slots, "header", {}, () => [
              A(y(e.about.component_header), 1)
            ])
          ], 8, Spe)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      w(e.$slots, "text", {}, () => [
        c("span", {
          class: "text-block",
          innerHTML: e.about.component_text
        }, null, 8, Ape)
      ])
    ]),
    (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
      ref: "cardWrapper",
      modelValue: r.aboutLinks,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => r.aboutLinks = s),
      style: { height: i.wrapperHeight },
      "item-key": "index",
      class: "card-wrapper"
    }), {
      item: _(({ element: s, index: l }) => [
        (d(), k(K(e.isEditing || !s.href ? "div" : "a"), {
          ref: `card-${l}`,
          href: s.href,
          target: s.target,
          class: "card",
          "data-testid": "about-card"
        }, {
          default: _(() => [
            w(e.$slots, "controls", { idx: l }),
            c("div", {
              class: v(["card-left", e.theme.style])
            }, [
              c("div", $pe, [
                w(e.$slots, "top-title", { idx: l }, () => [
                  A(y(s.top_title), 1)
                ])
              ]),
              c("div", Ipe, [
                w(e.$slots, "title", { idx: l }, () => [
                  A(y(s.title), 1)
                ])
              ])
            ], 2),
            c("div", Dpe, [
              w(e.$slots, "image", { idx: l }, () => [
                c("img", {
                  src: s.image && s.image.url,
                  alt: s.image && s.image.alt_text
                }, null, 8, Lpe)
              ])
            ])
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["modelValue", "style"]))
  ], 6);
}
const Npe = /* @__PURE__ */ O(kpe, [["render", Ope], ["__scopeId", "data-v-aebe3b92"]]), Ppe = {
  name: "About",
  components: {
    AboutV1: ppe,
    AboutV2: Tpe,
    AboutV3: Npe
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    watermark: {
      type: String,
      default: ""
    }
  }
}, Hpe = { id: "view-about" };
function Fpe(e, t, n, o, i, r) {
  return d(), h("div", Hpe, [
    (d(), k(K(n.theme.version), {
      theme: n.theme,
      about: n.content,
      "is-editing": n.isEditing,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      watermark: n.watermark
    }, {
      "header-top": _(() => [
        w(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: _(() => [
        w(e.$slots, "header", {}, void 0, !0)
      ]),
      image: _(({ idx: a }) => [
        w(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      text: _(() => [
        w(e.$slots, "text", {}, void 0, !0)
      ]),
      controls: _(({ idx: a }) => [
        w(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      icon: _(({ idx: a }) => [
        w(e.$slots, "icon", { idx: a }, void 0, !0)
      ]),
      "top-title": _(({ idx: a }) => [
        w(e.$slots, "top-title", { idx: a }, void 0, !0)
      ]),
      title: _(({ idx: a }) => [
        w(e.$slots, "title", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "about", "is-editing", "wrapper-component", "wrapper-props", "watermark"]))
  ]);
}
const Rpe = /* @__PURE__ */ O(Ppe, [["render", Fpe], ["__scopeId", "data-v-602a1639"]]);
/*!
  * focus-trap-vue v4.0.2
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
const Bpe = {
  escapeDeactivates: {
    type: Boolean,
    default: !0
  },
  returnFocusOnDeactivate: {
    type: Boolean,
    default: !0
  },
  allowOutsideClick: {
    type: [Boolean, Function],
    default: !0
  },
  clickOutsideDeactivates: [Boolean, Function],
  initialFocus: [String, Function, Boolean],
  fallbackFocus: [String, Function],
  checkCanFocusTrap: Function,
  checkCanReturnFocus: Function,
  delayInitialFocus: {
    type: Boolean,
    default: !0
  },
  document: Object,
  preventScroll: Boolean,
  setReturnFocus: [Object, String, Boolean, Function],
  tabbableOptions: Object
}, Wf = r5({
  props: Object.assign({
    active: {
      // TODO: could be options for activate but what about the options for deactivating?
      type: Boolean,
      default: !0
    }
  }, Bpe),
  emits: [
    "update:active",
    "activate",
    "postActivate",
    "deactivate",
    "postDeactivate"
  ],
  render() {
    return this.renderImpl();
  },
  setup(e, { slots: t, emit: n }) {
    let o;
    const i = Yn(null), r = Si(() => {
      const s = i.value;
      return s && (s instanceof HTMLElement ? s : s.$el);
    });
    function a() {
      return o || (o = cm(r.value, {
        escapeDeactivates: e.escapeDeactivates,
        allowOutsideClick: e.allowOutsideClick,
        returnFocusOnDeactivate: e.returnFocusOnDeactivate,
        clickOutsideDeactivates: e.clickOutsideDeactivates,
        onActivate: () => {
          n("update:active", !0), n("activate");
        },
        onDeactivate: () => {
          n("update:active", !1), n("deactivate");
        },
        onPostActivate: () => n("postActivate"),
        onPostDeactivate: () => n("postDeactivate"),
        initialFocus: e.initialFocus,
        fallbackFocus: e.fallbackFocus,
        tabbableOptions: e.tabbableOptions,
        delayInitialFocus: e.delayInitialFocus,
        preventScroll: e.preventScroll
      }));
    }
    return f1(() => {
      qs(() => e.active, (s) => {
        s && r.value ? a().activate() : o && (o.deactivate(), (!r.value || r.value.nodeType === Node.COMMENT_NODE) && (o = null));
      }, { immediate: !0, flush: "post" });
    }), i5(() => {
      o && o.deactivate(), o = null;
    }), {
      activate() {
        a().activate();
      },
      deactivate() {
        o && o.deactivate();
      },
      renderImpl() {
        if (!t.default)
          return null;
        const s = t.default().filter((u) => u.type !== s5);
        return !s || !s.length || s.length > 1 ? (console.error("[focus-trap-vue]: FocusTrap requires exactly one child."), s) : a5(s[0], { ref: i });
      }
    };
  }
});
function vt(e, ...t) {
  const n = t.find((o) => e[o]);
  return n ? e[n] : { hex: "" };
}
const Vpe = {
  name: "CmsAlertModal",
  components: {
    SvgClose: $i,
    FocusTrap: Wf
  },
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    alertContent: {
      type: String,
      default: ""
    },
    translations: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      hideCloseBtnFocusOutline: !0,
      isActive: !0
    };
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
  computed: {
    globalsInfo() {
      return this.globals && this.globals.info ? this.globals.info : {};
    },
    colors() {
      return {
        "--overlay-bg-color": vt(this.globalsInfo, "alert_lightbox_overlay").hex || "#000",
        "--container-bg-color": vt(this.globalsInfo, "alert_bg_color").hex || "#fff",
        "--body-text-color": vt(this.globalsInfo, "alert_text_color").hex || "#000",
        "--body-link-color": vt(this.globalsInfo, "alert_link_color").hex || "#000"
      };
    },
    closeBtnFocusOutlineCSSClass() {
      return this.hideCloseBtnFocusOutline ? "cms-alert-modal__close--no-focus-outline" : "";
    }
  },
  methods: {
    closeModal(e = !1) {
      this.isActive && (this.isActive = !1, this.$emit("close", { closedByKeyboard: e }));
    }
  }
}, jpe = { class: "cms-alert-modal__container-wrapper" }, Upe = ["aria-label"], Gpe = ["aria-label"], zpe = { class: "cms-alert-modal__body" }, Kpe = ["innerHTML"];
function Zpe(e, t, n, o, i, r) {
  const a = $("SvgClose"), s = $("FocusTrap");
  return d(), h("div", {
    id: "cms-alert-modal",
    style: j(r.colors)
  }, [
    c("div", jpe, [
      L(s, {
        "initial-focus": () => e.$refs["close-button"],
        "fallback-focus": () => e.$refs["close-button"],
        active: i.isActive,
        "click-outside-deactivates": "",
        "escape-deactivates": "",
        onDeactivate: r.closeModal
      }, {
        default: _(() => [
          c("section", {
            ref: "modal-container",
            class: "cms-alert-modal__container",
            "aria-label": n.translations.legacyContainer,
            role: "alertdialog",
            "aria-modal": "true"
          }, [
            c("button", {
              ref: "close-button",
              "aria-label": n.translations.legacyBody,
              class: v(["cms-alert-modal__close", r.closeBtnFocusOutlineCSSClass]),
              "aria-describedby": "alert-modal-body",
              onClick: t[0] || (t[0] = (l) => r.closeModal()),
              onKeydown: [
                t[1] || (t[1] = V(z((l) => r.closeModal(!0), ["exact", "prevent"]), ["enter"])),
                t[2] || (t[2] = V(z((l) => r.closeModal(!0), ["exact", "prevent"]), ["space"])),
                t[3] || (t[3] = V(z((...l) => e.closeAllModals && e.closeAllModals(...l), ["exact", "prevent"]), ["esc"])),
                t[4] || (t[4] = V(z((l) => i.hideCloseBtnFocusOutline = !1, ["exact"]), ["tab"]))
              ]
            }, [
              L(a)
            ], 42, Gpe),
            c("div", zpe, [
              c("div", {
                id: "alert-modal-body",
                class: "cms-alert-modal__body-content",
                innerHTML: n.alertContent
              }, null, 8, Kpe)
            ])
          ], 8, Upe)
        ]),
        _: 1
      }, 8, ["initial-focus", "fallback-focus", "active", "onDeactivate"])
    ])
  ], 4);
}
const xpe = /* @__PURE__ */ O(Vpe, [["render", Zpe], ["__scopeId", "data-v-a8b1fc60"]]), Wpe = {
  name: "AlertBanner",
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    alertContent: {
      type: String,
      default: ""
    }
  },
  computed: {
    globalsInfo() {
      return this.globals && this.globals.info ? this.globals.info : {};
    },
    colors() {
      return {
        "--banner-bg-color": vt(this.globalsInfo, "alert_bg_color").hex || "#cc314b",
        "--banner-text-color": vt(this.globalsInfo, "alert_text_color").hex || "#fff",
        "--banner-link-color": vt(this.globalsInfo, "alert_link_color").hex || "#fff"
      };
    }
  }
}, qpe = ["innerHTML"];
function Ype(e, t, n, o, i, r) {
  return d(), h("div", {
    id: "alert-banner",
    style: j(r.colors)
  }, [
    c("div", {
      class: "alert-banner__content",
      innerHTML: n.alertContent
    }, null, 8, qpe)
  ], 4);
}
const Xpe = /* @__PURE__ */ O(Wpe, [["render", Ype], ["__scopeId", "data-v-ac60c6f3"]]);
function Qpe(e, t, n, { maxPadding: o = 25, minPadding: i = 5, smallModalMaxRatioOfViewport: r = 0.3, largeModalMinRatioOfViewport: a = 0.9 } = {}) {
  const s = e / t;
  let l;
  if (s <= r)
    l = o;
  else if (s < a) {
    const m = (s - r) / (a - r);
    l = o - (o - i) * m;
  } else
    l = i;
  const u = Math.min(1, n / t);
  return l = l * u, Math.max(i, Math.min(l, o));
}
const Jpe = {
  name: "CmsAlertModalSeparate",
  components: {
    SvgClose: $i,
    FocusTrap: Wf
  },
  mixins: [Tt],
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    modalArray: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isFocusTrapActive: !1,
      containerHeight: 0
    };
  },
  mounted() {
    document.body.style.overflow = "hidden", this.focusByClassName(".close"), this.updateContainerHeight(), this.$nextTick(() => {
      this.activateFocusTrap();
    });
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
  computed: {
    dynamicPadding() {
      return typeof window != "undefined" ? `${Qpe(this.containerHeight, window.innerHeight, this.screenSize)}vh` : "0vh";
    },
    globalsInfo() {
      var e;
      return (e = this.globals.info) != null ? e : {};
    },
    colors() {
      return {
        "--overlay-bg-color": vt(this.globalsInfo, "alert_lightbox_overlay").hex || "#000",
        "--container-bg-color": vt(this.globalsInfo, "alert_bg_color").hex || "#fff",
        "--body-text-color": vt(this.globalsInfo, "alert_text_color").hex || "#000",
        "--body-link-color": vt(this.globalsInfo, "alert_link_color").hex || "#000"
      };
    },
    containsMultipleModals() {
      return this.modalArray.length > 1;
    },
    containsImage() {
      return this.modalArray.some((e) => e.image.url);
    },
    containsLongText() {
      return this.modalArray.some((e) => e.content.length > 100);
    },
    svgFillColor() {
      return ae(this.colors["--overlay-bg-color"]).isLight() ? "#000" : "#fff";
    }
  },
  watch: {
    screenSize() {
      this.updateContainerHeight();
    }
  },
  methods: {
    activateFocusTrap() {
      this.$refs.modalContainer && (this.isFocusTrapActive = !0, this.focusByClassName(".close"));
    },
    updateContainerHeight() {
      this.$nextTick(() => {
        this.$refs.modalContainer && (this.containerHeight = this.$refs.modalContainer.clientHeight);
      });
    },
    closeModal(e, t = !1) {
      const n = this.modalArray.length <= 1, i = { alertId: e, closedByKeyboard: n && t };
      this.$emit("close", i), n || (this.updateContainerHeight(), this.focusByClassName(".close"));
    },
    closeAllModals() {
      this.modalArray.forEach((e, t) => {
        const n = t === this.modalArray.length - 1;
        this.$emit("close", { alertId: e.id, closedByKeyboard: n });
      });
    },
    generateModalClasses() {
      return [
        this.containsMultipleModals ? "multi-modal" : "single-modal",
        this.containsImage ? "has-image" : "no-image",
        this.containsLongText ? "long-text" : "short-text"
      ];
    },
    focusByClassName(e) {
      this.$nextTick(() => {
        const t = this.$el.querySelector(e);
        t && t.focus();
      });
    }
  }
}, efe = {
  class: "container-wrapper",
  ref: "modalContainer"
}, tfe = ["onClick", "onKeydown", "aria-describedby"], nfe = {
  class: "container",
  role: "alertdialog",
  "aria-modal": "true"
}, ofe = {
  key: 0,
  class: "image"
}, rfe = ["src", "alt"], ife = ["id"], sfe = ["innerHTML"];
function afe(e, t, n, o, i, r) {
  const a = $("SvgClose"), s = $("FocusTrap");
  return d(), k(s, { active: i.isFocusTrapActive }, {
    default: _(() => [
      c("div", {
        class: "cms-alert-modal",
        style: j([r.colors, { paddingTop: r.dynamicPadding }]),
        onKeydown: t[1] || (t[1] = V(z((...l) => r.closeAllModals && r.closeAllModals(...l), ["exact", "prevent"]), ["esc"]))
      }, [
        c("div", efe, [
          (d(!0), h(Y, null, ee(n.modalArray, (l, u) => (d(), h("div", {
            key: u,
            class: v(["individual-container-wrapper", ...r.generateModalClasses()])
          }, [
            c("button", {
              class: "close",
              onClick: (m) => r.closeModal(l.id),
              onKeydown: [
                V(z((m) => r.closeModal(l.id, !0), ["exact", "prevent"]), ["enter"]),
                V(z((m) => r.closeModal(l.id, !0), ["exact", "prevent"]), ["space"])
              ],
              "aria-describedby": `alert-modal-body-'${l.id}`
            }, [
              L(a, { "fill-color": r.svgFillColor }, null, 8, ["fill-color"])
            ], 40, tfe),
            c("section", nfe, [
              l.image.url ? (d(), h("div", ofe, [
                c("img", {
                  src: l.image.url,
                  alt: l.image.alt_text,
                  onLoad: t[0] || (t[0] = (...m) => r.updateContainerHeight && r.updateContainerHeight(...m))
                }, null, 40, rfe)
              ])) : b("", !0),
              l.content ? (d(), h("div", {
                key: 1,
                id: "alert-modal-body-" + l.id,
                class: "body"
              }, [
                c("div", {
                  class: "body-content",
                  innerHTML: l.content
                }, null, 8, sfe)
              ], 8, ife)) : b("", !0)
            ])
          ], 2))), 128))
        ], 512)
      ], 36)
    ]),
    _: 1
  }, 8, ["active"]);
}
const lfe = /* @__PURE__ */ O(Jpe, [["render", afe], ["__scopeId", "data-v-e619a4b5"]]), ufe = {
  name: "CmsAlertBannerSeparate",
  components: {
    SvgClose: $i
  },
  data() {
    return {
      hideCloseBtnFocusOutline: !0
    };
  },
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    bannerArray: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    globalsInfo() {
      return this.globals && this.globals.info ? this.globals.info : {};
    },
    colors() {
      return {
        "--banner-bg-color": vt(this.globalsInfo, "alert_bg_color").hex || "#cc314b",
        "--banner-text-color": vt(this.globalsInfo, "alert_text_color").hex || "#fff",
        "--banner-link-color": vt(this.globalsInfo, "alert_link_color").hex || "#fff"
      };
    },
    closeBtnFocusOutlineCSSClass() {
      return this.hideCloseBtnFocusOutline ? "no-focus-outline" : "";
    },
    svgFillColor() {
      return ae(this.colors["--banner-bg-color"]).isLight() ? "#000" : "#fff";
    }
  },
  methods: {
    closeBanner(e) {
      this.$emit("close", { alertId: e });
    }
  }
}, dfe = { class: "alert-banners" }, cfe = { class: "banner-wrapper" }, hfe = ["innerHTML"], mfe = ["onClick", "onKeydown"];
function pfe(e, t, n, o, i, r) {
  const a = $("SvgClose");
  return d(), h("div", dfe, [
    (d(!0), h(Y, null, ee(n.bannerArray, (s) => (d(), h("div", {
      key: s.id,
      class: "banner",
      style: j(r.colors)
    }, [
      c("div", cfe, [
        c("div", {
          class: "content",
          innerHTML: s.content
        }, null, 8, hfe),
        c("button", {
          class: v(["close", r.closeBtnFocusOutlineCSSClass]),
          onClick: (l) => r.closeBanner(s.id),
          onKeydown: [
            V(z((l) => r.closeBanner(s.id), ["exact", "prevent"]), ["enter"]),
            V(z((l) => r.closeBanner(s.id), ["exact", "prevent"]), ["space"]),
            t[0] || (t[0] = V(z((l) => i.hideCloseBtnFocusOutline = !1, ["exact"]), ["tab"]))
          ]
        }, [
          L(a, { "fill-color": r.svgFillColor }, null, 8, ["fill-color"])
        ], 42, mfe)
      ])
    ], 4))), 128))
  ]);
}
const ffe = /* @__PURE__ */ O(ufe, [["render", pfe], ["__scopeId", "data-v-7140ef94"]]), gfe = {
  name: "Parallax",
  props: {
    config: {
      type: Object,
      required: !0
    }
  }
}, vfe = { class: "parallax-section" }, bfe = {
  ref: "parallax",
  class: "parallax-container"
}, yfe = { class: "image-container" }, _fe = ["src"];
function Cfe(e, t, n, o, i, r) {
  return d(), h("div", vfe, [
    c("div", bfe, [
      c("div", {
        class: "parallax",
        style: j({ backgroundImage: `url(${n.config.background_image.url})` })
      }, null, 4)
    ], 512),
    c("div", yfe, [
      c("img", {
        class: "full-image",
        src: n.config.background_image.url
      }, null, 8, _fe)
    ])
  ]);
}
const wfe = /* @__PURE__ */ O(gfe, [["render", Cfe], ["__scopeId", "data-v-e745b867"]]), Tfe = {
  computed: {
    colors() {
      return {
        "--button-one-bg-color": S(this.theme, "button_one.bg_color.hex", "#333"),
        "--button-one-icon-and-text-color": S(this.theme, "button_one.icon_and_text_color.hex", "#fff"),
        "--button-two-bg-color": S(this.theme, "button_two.bg_color.hex", "#fff"),
        "--button-two-icon-and-text-color": S(this.theme, "button_two.icon_and_text_color.hex", "#333"),
        "--button-three-bg-color": S(this.theme, "button_three.bg_color.hex", "#333"),
        "--button-three-icon-and-text-color": S(this.theme, "button_three.icon_and_text_color.hex", "#fff"),
        "--button-four-bg-color": S(this.theme, "button_four.bg_color.hex", "#fff"),
        "--button-four-icon-and-text-color": S(this.theme, "button_four.icon_and_text_color.hex", "#333"),
        "--button-five-bg-color": S(this.theme, "button_five.bg_color.hex", "#333"),
        "--button-five-icon-and-text-color": S(this.theme, "button_five.icon_and_text_color.hex", "#fff"),
        "--button-mobile-bg-color": S(this.theme, "button_mobile.bg_color.hex", "#333"),
        "--button-mobile-icon-and-text-color": S(this.theme, "button_mobile.icon_and_text_color.hex", "#fff")
      };
    },
    translations() {
      return S(this.theme, "translations", {});
    }
  }
}, kfe = {
  name: "MobileSvgArrow",
  props: {
    fillColor: {
      type: String,
      required: !0
    }
  }
}, Efe = {
  width: "17",
  height: "16",
  viewBox: "0 0 19 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Sfe = ["fill"];
function Mfe(e, t, n, o, i, r) {
  return d(), h("svg", Efe, [
    c("path", {
      d: "M18 9C18.5523 9 19 8.55228 19 8C19 7.44772 18.5523 7 18 7L18 9ZM0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM18 7L1 7L1 9L18 9L18 7Z",
      fill: n.fillColor
    }, null, 8, Sfe)
  ]);
}
const Afe = /* @__PURE__ */ O(kfe, [["render", Mfe]]), $fe = {
  name: "FN1",
  components: {
    mobileNavIcon: Afe
  },
  mixins: [Tfe],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    floatingNav: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      navExpanded: !1,
      pageYOffset: 0
    };
  },
  computed: {
    buttonShape() {
      return this.floatingNav.shape;
    },
    navPosition() {
      return this.floatingNav.is_fixed ? "nav-fixed" : "nav-absolute";
    },
    mobileFill() {
      return S(this.theme, "button_mobile.icon_and_text_color.hex", "#fff");
    },
    isScrolled() {
      return this.pageYOffset > 100;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    togglePanel() {
      this.navExpanded = !this.navExpanded;
    },
    buttonHref(e) {
      return e.mailto ? `mailto:${e.email_address}` : e.url;
    },
    onScroll() {
      this.pageYOffset = window.pageYOffset;
    }
  }
}, Ife = { class: "nav-wrapper" }, Dfe = { class: "button-link" }, Lfe = { class: "link-wrapper" }, Ofe = ["href", "target"], Nfe = { class: "link-wrapper" }, Pfe = {
  class: "icon-wrapper",
  "data-testid": "svg",
  "aria-hidden": "true"
}, Hfe = { class: "raw-svg" }, Ffe = ["innerHTML"];
function Rfe(e, t, n, o, i, r) {
  const a = $("mobile-nav-icon");
  return d(), h("div", {
    id: "floating-nav",
    "data-testid": "FN1",
    class: v([r.navPosition, { "is-scrolled": r.isScrolled }]),
    style: j([e.colors])
  }, [
    c("div", Ife, [
      c("div", {
        class: v(["mobile-menu-button button", [r.buttonShape, { expanded: i.navExpanded }]]),
        onClick: t[0] || (t[0] = (...s) => r.togglePanel && r.togglePanel(...s))
      }, [
        c("div", Dfe, [
          c("div", Lfe, [
            c("div", {
              class: v(["icon-wrapper", { expanded: i.navExpanded }]),
              "data-testid": "svg",
              "aria-hidden": "true"
            }, [
              L(a, { "fill-color": r.mobileFill }, null, 8, ["fill-color"])
            ], 2),
            c("span", {
              class: v(["button-title", n.theme.style])
            }, y(e.translations.mobile_menu_title || "Collapse Menu"), 3)
          ])
        ])
      ], 2),
      c("div", {
        class: v(["button-wrapper", i.navExpanded ? "expanded" : "hiddenButtons"])
      }, [
        (d(!0), h(Y, null, ee(n.floatingNav.buttons, (s, l) => (d(), h("div", {
          key: `floating-nav-${l}`,
          class: v(["button", r.buttonShape]),
          "data-testid": "fn1-button"
        }, [
          c("a", {
            class: v(["button-link", n.theme.style]),
            href: r.buttonHref(s),
            target: s.opens_in_new_tab ? "_blank" : "",
            "data-testid": "links"
          }, [
            c("div", Nfe, [
              c("div", Pfe, [
                c("span", Hfe, [
                  c("span", {
                    "data-testid": "svg",
                    innerHTML: s.icon
                  }, null, 8, Ffe)
                ])
              ]),
              c("span", {
                class: v(["button-title", n.theme.style])
              }, y(s.title), 3)
            ])
          ], 10, Ofe)
        ], 2))), 128))
      ], 2)
    ])
  ], 6);
}
const Bfe = /* @__PURE__ */ O($fe, [["render", Rfe], ["__scopeId", "data-v-b318b410"]]), Vfe = {
  name: "FloatingNav",
  components: {
    FN1: Bfe
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    floatingNav: {
      type: Object,
      default: () => ({})
    }
  }
};
function jfe(e, t, n, o, i, r) {
  return d(), k(K(n.theme.version), {
    theme: n.theme,
    "floating-nav": n.floatingNav
  }, null, 8, ["theme", "floating-nav"]);
}
const Ufe = /* @__PURE__ */ O(Vfe, [["render", jfe]]), Lu = {
  mixins: [mt],
  components: { DraggableWrapper: at },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    blocks: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    blockHasLink(e) {
      var t;
      return !this.isEditing && ((t = e.link) == null ? void 0 : t.href);
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return he(ie({}, e), {
        "--description-color": S(this.theme, "description_color.hex", "initial"),
        "--arrow-icon-color": S(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-background-color": S(this.theme, "arrow_background_color.hex", "initial"),
        "--pager-color": S(this.theme, "pager_color.hex", "#ffffff"),
        "--box-text-color": S(this.theme, "box_text_color.hex", "#000000"),
        "--box-bg-color": S(this.theme, "box_bg_color.hex", "#ffffff"),
        "--box-gradient-color": S(this.theme, "gradient_overlay.hex", "#ffffff")
      });
    },
    translations() {
      return this.theme.translations;
    },
    content() {
      return this.blocks.content;
    }
  }
}, Gfe = {
  name: "OS1",
  components: { CardSlider: Jt },
  mixins: [ut, Lu],
  computed: {
    sliderCenterSize() {
      return 599;
    },
    showDescription() {
      return this.blocks.has_description && !An(this.blocks.component_header_description) || this.blocks.has_description && this.isEditing;
    },
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    }
  },
  methods: {
    fourCardColorPattern(e) {
      return `card-style-${e % 5 + 1}`;
    }
  }
}, zfe = { class: "header-wrapper" }, Kfe = ["data-testid"], Zfe = ["data-testid"], xfe = {
  key: 0,
  class: "header-description",
  "data-testid": "component-header-description"
}, Wfe = ["data-testid", "aria-label"], qfe = { class: "box" };
function Yfe(e, t, n, o, i, r) {
  const a = $("SeeAllContainer"), s = $("CardSlider");
  return d(), h("div", {
    id: "our-schools-v1",
    "data-testid": "OS1",
    class: v([e.theme.style, e.isEditing && "editing"]),
    style: j(e.colors)
  }, [
    L(a, {
      class: v([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("div", zfe, [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (d(), h("span", {
              key: 0,
              class: "header-top",
              "data-testid": `header-${e.theme.style}-top`
            }, [
              w(e.$slots, "header-top", {}, () => [
                A(y(e.blocks.component_header_top), 1)
              ], !0)
            ], 8, Zfe)) : b("", !0),
            w(e.$slots, "header", {}, () => [
              A(y(e.blocks.component_header), 1)
            ], !0)
          ], 8, Kfe),
          r.showDescription ? (d(), h("div", xfe, [
            w(e.$slots, "header-description", {}, () => [
              A(y(e.blocks.component_header_description), 1)
            ], !0)
          ])) : b("", !0)
        ])
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    L(s, {
      class: v({ "all-cards-visible": e.allCardsVisible }),
      "nav-orientation": "wide",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "total-cards": e.blocks.content.length,
      "theme-styles": e.theme,
      "section-header": e.blocks.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: _(() => [
        (d(), k(K(e.wrapperComponent), we({
          ref: "scrollWrapper",
          modelValue: e.blocks.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.blocks.content = l),
          class: ["scroll-wrapper", { "all-cards-visible": e.allCardsVisible }]
        }, e.wrapperProps, {
          "item-key": "index",
          "data-testid": "blocks-array"
        }), {
          item: _(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              class: v([[`card-${u + 1}`, r.fourCardColorPattern(u)], "our-schools"]),
              "data-testid": `Card${u + 1}`,
              role: "group",
              "aria-roledescription": "slide",
              "aria-label": `${u + 1} of ${e.blocks.content.length}`
            }, [
              w(e.$slots, "controls", { idx: u }, void 0, !0),
              (d(), k(K(e.blockHasLink(l) ? "a" : "div"), {
                href: e.blockHasLink(l) && l.link.href,
                role: e.blockHasLink(l) && "link",
                target: e.blockHasLink(l) && l.link.target,
                "data-testid": "block-link"
              }, {
                default: _(() => [
                  c("span", qfe, [
                    w(e.$slots, "box", { idx: u }, () => [
                      A(y(l.box), 1)
                    ], !0)
                  ]),
                  w(e.$slots, "image", { idx: u }, () => [
                    (d(), k(K(l.image ? "img" : "div"), {
                      src: l.image.url,
                      alt: l.link.href ? "" : l.image.alt_text,
                      class: "our-schools-image",
                      "data-testid": "block-image",
                      loading: "lazy"
                    }, null, 8, ["src", "alt"]))
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "role", "target"]))
            ], 10, Wfe)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["class", "current-card", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const Xfe = /* @__PURE__ */ O(Gfe, [["render", Yfe], ["__scopeId", "data-v-cd6f874a"]]), Qfe = {
  name: "OS2",
  mixins: [Lu],
  data() {
    return {
      hoverIndex: -1
    };
  },
  computed: {
    colorsWithOpacity() {
      const e = this.colors["--box-gradient-color"], t = `rgba(${i0(e, 1)})`, n = `rgba(${i0(e, 0)})`;
      return he(ie({}, this.colors), {
        "--box-bg-color-initial-opacity": t,
        "--box-bg-color-final-opacity": n
      });
    },
    columnClass() {
      return this.blocks.content.length <= 3 ? "three-column" : this.blocks.num_columns === 4 ? "four-column" : "three-column";
    }
  }
}, Jfe = ["data-testid"], e5e = ["data-testid"], t5e = ["onMouseover"], n5e = ["src", "alt"], o5e = {
  key: 1,
  class: "our-schools-image"
}, r5e = {
  key: 1,
  class: "title-container",
  "data-testid": "no-link-block",
  maxlength: "26"
};
function i5e(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    class: v(["our-schools-v2", e.theme.style]),
    "data-testid": "OS2",
    style: j(r.colorsWithOpacity)
  }, [
    L(a, {
      class: v(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`,
          class: v({ "no-border": e.theme.style === "bold" })
        }, [
          e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (d(), h("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.blocks.component_header_top), 1)
            ], !0)
          ], 8, e5e)) : b("", !0),
          w(e.$slots, "header", {
            dataTestid: `header-${e.theme.style}`
          }, () => [
            A(y(e.blocks.component_header), 1)
          ], !0)
        ], 10, Jfe)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
      modelValue: e.blocks.content,
      "onUpdate:modelValue": t[1] || (t[1] = (s) => e.blocks.content = s),
      class: "our-schools-wrapper",
      "data-testid": "blocks-array",
      "item-key": "index"
    }), {
      item: _(({ element: s, index: l }) => [
        c("div", {
          class: v(["block", r.columnClass]),
          "data-testid": "our-schools-block-content"
        }, [
          w(e.$slots, "controls", { idx: l }, void 0, !0),
          c("div", {
            class: "image-wrapper image-border-accent",
            role: "dialog",
            onMouseover: (u) => i.hoverIndex = l,
            onMouseleave: t[0] || (t[0] = (u) => i.hoverIndex = -1)
          }, [
            s.image.url ? (d(), h("img", {
              key: 0,
              src: s.image.url,
              alt: s.image.alt_text,
              loading: "lazy",
              class: "our-schools-image"
            }, null, 8, n5e)) : (d(), h("div", o5e)),
            c("div", {
              class: v([[
                e.theme.style,
                {
                  "hover-enter": i.hoverIndex === l
                }
              ], "content-box gradient"])
            }, null, 2),
            c("div", {
              class: v([e.theme.style, "title"])
            }, [
              s.link.href ? (d(), k(K(e.isEditing ? "div" : "a"), {
                key: 0,
                class: "title-container",
                "data-testid": "link-block",
                href: s.link.href,
                target: s.link.target || "_self"
              }, {
                default: _(() => [
                  w(e.$slots, "box", { idx: l }, () => [
                    A(y(s.box), 1)
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "target"])) : (d(), h("p", r5e, [
                w(e.$slots, "box", { idx: l }, () => [
                  A(y(s.box), 1)
                ], !0)
              ]))
            ], 2)
          ], 40, t5e)
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const s5e = /* @__PURE__ */ O(Qfe, [["render", i5e], ["__scopeId", "data-v-fe3d0b84"]]), a5e = {
  name: "OS3",
  mixins: [Lu],
  computed: {
    OS3Colors() {
      var e, t;
      return he(ie({}, this.colors), {
        "--icon-color": ((e = this.theme.icon_color) == null ? void 0 : e.hex) || "#fff",
        "--icon-bg-color": ((t = this.theme.icon_bg_color) == null ? void 0 : t.hex) || "#000"
      });
    }
  },
  methods: {
    isLink({ link: e }) {
      return !this.isEditing && (e == null ? void 0 : e.href) && this.blocks.has_link;
    }
  }
}, l5e = {
  key: 0,
  class: "header-top"
}, u5e = {
  key: 0,
  class: "our-schools-icon"
}, d5e = {
  class: "icon-wrapper",
  "aria-hidden": "true"
}, c5e = { class: "raw-svg" }, h5e = ["innerHTML"];
function m5e(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    class: v(["our-schools-v3", e.theme.style]),
    style: j(r.OS3Colors)
  }, [
    L(a, {
      class: v(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: _(() => [
        c("h2", {
          class: v({ "no-border": e.theme.style === "bold" })
        }, [
          e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (d(), h("span", l5e, [
            w(e.$slots, "header-top", {}, () => [
              A(y(e.blocks.component_header_top), 1)
            ], !0)
          ])) : b("", !0),
          w(e.$slots, "header", {}, () => [
            A(y(e.blocks.component_header), 1)
          ], !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
      modelValue: e.blocks.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.blocks.content = s),
      class: "our-schools-wrapper",
      "item-key": "index"
    }), {
      item: _(({ element: s, index: l }) => {
        var u, m;
        return [
          (d(), k(K(r.isLink(s) ? "a" : "div"), {
            href: r.isLink(s) ? (u = s.link) == null ? void 0 : u.href : void 0,
            target: r.isLink(s) ? (m = s.link) == null ? void 0 : m.target : void 0,
            class: "our-schools-block"
          }, {
            default: _(() => [
              w(e.$slots, "controls", { idx: l }, void 0, !0),
              (d(), k(K(s.image ? "img" : "div"), {
                src: s.image.url,
                class: "our-schools-image",
                loading: "lazy",
                alt: ""
              }, null, 8, ["src"])),
              c("div", {
                class: v(["our-schools-block-text", e.theme.style])
              }, [
                w(e.$slots, "box", { idx: l }, () => [
                  A(y(s.box), 1)
                ], !0)
              ], 2),
              s.icon || e.isEditing ? (d(), h("div", u5e, [
                c("div", d5e, [
                  c("span", c5e, [
                    w(e.$slots, "icon", { idx: l }, () => [
                      c("span", {
                        innerHTML: s.icon
                      }, null, 8, h5e)
                    ], !0)
                  ])
                ])
              ])) : b("", !0)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ];
      }),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const p5e = /* @__PURE__ */ O(a5e, [["render", m5e], ["__scopeId", "data-v-75f4750e"]]), f5e = {
  name: "CmsOurSchools",
  components: {
    OS1: Xfe,
    OS2: s5e,
    OS3: p5e
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  }
}, g5e = { class: "our-schools-container" };
function v5e(e, t, n, o, i, r) {
  return d(), h("div", g5e, [
    (d(), k(K(n.theme.version), {
      theme: n.theme,
      blocks: n.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "is-editing": n.isEditing
    }, {
      "header-top": _(() => [
        w(e.$slots, "header-top", {}, void 0, !0)
      ]),
      "header-bottom": _(() => [
        w(e.$slots, "header-bottom", {}, void 0, !0)
      ]),
      header: _(() => [
        w(e.$slots, "header", {}, void 0, !0)
      ]),
      "header-description": _(() => [
        w(e.$slots, "header-description", {}, void 0, !0)
      ]),
      controls: _(({ idx: a }) => [
        w(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      image: _(({ idx: a }) => [
        w(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      box: _(({ idx: a }) => [
        w(e.$slots, "box", { idx: a }, void 0, !0)
      ]),
      icon: _(({ idx: a }) => [
        w(e.$slots, "icon", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "blocks", "wrapper-component", "wrapper-props", "is-editing"]))
  ]);
}
const b5e = /* @__PURE__ */ O(f5e, [["render", v5e], ["__scopeId", "data-v-89630ecf"]]), y5e = {
  components: {
    CustomHtml: Aa
  },
  props: {
    theme: {
      type: Object,
      default: () => {
      }
    },
    content: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    processedTheme() {
      if (!this.theme.section || this.theme.section.type === "none" || An(this.content))
        return this.theme;
      let e = "";
      try {
        e = of(this.theme.html_code, this.theme.section.type, this.content);
      } catch (t) {
        e = t;
      }
      return he(ie({}, this.theme), {
        html_code: e
      });
    }
  }
}, _5e = { class: "media-custom-code" };
function C5e(e, t, n, o, i, r) {
  const a = $("CustomHtml");
  return d(), h("div", _5e, [
    L(a, { theme: r.processedTheme }, null, 8, ["theme"])
  ]);
}
const w5e = /* @__PURE__ */ O(y5e, [["render", C5e]]), T5e = {
  mixins: [mt],
  components: { DraggableWrapper: at },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isActive: !1,
      isOverflow: !1
    };
  },
  created() {
    this.isActive = this.isPreview || this.isEditing;
  },
  mounted() {
    this.handleResize(), window.addEventListener("resize", this.handleResize), window.addEventListener("scroll", this.onWindowScroll);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize), window.removeEventListener("scroll", this.onWindowScroll);
  },
  methods: {
    handleResize() {
      this.isOverflow = this.$refs.flexWrapper.offsetWidth >= this.screenSize;
    },
    onScroll(e = "left", t = 120) {
      const i = {
        left: t * (e === "left" ? -1 : 1),
        behavior: "smooth"
      };
      this.$refs.scrollWrapper.scrollBy(ie({}, i));
    },
    stickyFooterActiveToggle() {
      this.isActive = !this.isActive;
    },
    onWindowScroll() {
      window.scrollY > window.innerHeight / 2 && (this.isActive = !0, window.removeEventListener("scroll", this.onWindowScroll));
    }
  },
  computed: {
    toggleButtonText() {
      return this.isActive ? this.content.hide_text_label || "hide" : this.content.show_text_label || "show";
    },
    hasPillButton() {
      return this.content.show_pill_button || this.isPreview;
    },
    hasSocialIcons() {
      return this.content.show_social_icons || this.isPreview;
    },
    cssVars() {
      const e = this.sharedThemeColors();
      return he(ie({}, e), {
        "--bg-color": S(this.theme, "bg_color.hex", "#333"),
        "--hide-button-and-bar-color": S(this.theme, "hide_button_and_bar_color.hex", "#f8cb43"),
        "--hide-button-text-color": S(this.theme, "hide_button_text_color.hex", "#fff"),
        "--icon-color": S(this.theme, "icon_color.hex", "#fff"),
        "--icon-text-color": S(this.theme, "icon_text_color.hex", "#fff"),
        "--pill-button-color": S(this.theme, "pill_button_color.hex", "#f8cb43"),
        "--pill-button-text-color": S(this.theme, "pill_button_text_color.hex", "#333"),
        "--separator-color": S(this.theme, "separator_color.hex", "#fff")
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, k5e = {
  name: "StickyFooterV1",
  mixins: [T5e]
}, E5e = { class: "text" }, S5e = {
  ref: "scrollWrapper",
  class: "scroll-wrapper"
}, M5e = {
  ref: "flexWrapper",
  class: "flex-wrapper"
}, A5e = { class: "icon-wrapper" }, $5e = ["innerHTML"], I5e = { class: "title" }, D5e = { class: "icon-wrapper" }, L5e = ["innerHTML"];
function O5e(e, t, n, o, i, r) {
  return d(), h("div", {
    class: v(["sticky-footer-v1", [
      e.theme.style,
      {
        "sf-active": e.isActive,
        "sf-overflow": e.isOverflow,
        "sf-editing": e.isEditing
      }
    ]]),
    style: j(e.cssVars),
    "data-testid": "StickyFooterV1"
  }, [
    w(e.$slots, "toggle", {}, () => [
      c("button", {
        class: v(["hs-toggle-button", [{ "sf-active": e.isActive }]]),
        onClick: t[0] || (t[0] = (...a) => e.stickyFooterActiveToggle && e.stickyFooterActiveToggle(...a))
      }, [
        c("span", E5e, y(e.toggleButtonText), 1),
        c("div", {
          class: v(["icon-arrow", { "sf-active": e.isActive }])
        }, null, 2)
      ], 2)
    ], !0),
    c("div", S5e, [
      e.isOverflow ? (d(), h("button", {
        key: 0,
        class: "scroll-button left",
        onClick: t[1] || (t[1] = (a) => e.onScroll("left"))
      }, t[5] || (t[5] = [
        c("div", { class: "icon-arrow" }, null, -1)
      ]))) : b("", !0),
      c("div", M5e, [
        e.hasPillButton ? (d(), k(K(e.isEditing ? "div" : "a"), {
          key: 0,
          class: "pill-button",
          "data-testid": "pill-button",
          href: e.content.pill_button.link,
          target: e.content.pill_button.opens_in_new_tab ? "_blank" : ""
        }, {
          default: _(() => [
            w(e.$slots, "pill-button-controls", {}, void 0, !0),
            w(e.$slots, "pill-button-title", {}, () => [
              A(y(e.content.pill_button.title), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["href", "target"])) : b("", !0),
        (d(), k(K(e.wrapperComponent), we(e.wrapperProps, {
          modelValue: e.content.icon_buttons,
          "onUpdate:modelValue": t[2] || (t[2] = (a) => e.content.icon_buttons = a),
          "item-key": "index",
          class: "icon-buttons"
        }), {
          item: _(({ element: a, index: s }) => [
            (d(), k(K(e.isEditing ? "div" : "a"), {
              id: a.icon_id,
              class: "button",
              "data-testid": "icon-button",
              href: a.link,
              target: a.opens_in_new_tab ? "_blank" : ""
            }, {
              default: _(() => [
                w(e.$slots, "icon-button-controls", { idx: s }, void 0, !0),
                c("div", A5e, [
                  w(e.$slots, "icon-button-icon", { idx: s }, () => [
                    c("span", {
                      innerHTML: a.icon
                    }, null, 8, $5e)
                  ], !0)
                ]),
                c("span", I5e, [
                  w(e.$slots, "icon-button-title", { idx: s }, () => [
                    A(y(a.title), 1)
                  ], !0)
                ])
              ]),
              _: 2
            }, 1032, ["id", "href", "target"]))
          ]),
          _: 3
        }, 16, ["modelValue"])),
        e.hasSocialIcons ? (d(), k(K(e.wrapperComponent), we({ key: 1 }, e.wrapperProps, {
          modelValue: e.content.social_media_icons,
          "onUpdate:modelValue": t[3] || (t[3] = (a) => e.content.social_media_icons = a),
          "item-key": "index",
          class: "social-media"
        }), {
          item: _(({ element: a, index: s }) => [
            (d(), k(K(e.isEditing ? "div" : "a"), {
              id: a.icon_id,
              class: "icons",
              "data-testid": "social-media-button",
              href: a.link,
              target: a.opens_in_new_tab ? "_blank" : ""
            }, {
              default: _(() => [
                w(e.$slots, "social-media-controls", { idx: s }, void 0, !0),
                c("div", D5e, [
                  w(e.$slots, "social-media-icon", { idx: s }, () => [
                    c("span", {
                      innerHTML: a.icon
                    }, null, 8, L5e)
                  ], !0)
                ])
              ]),
              _: 2
            }, 1032, ["id", "href", "target"]))
          ]),
          _: 3
        }, 16, ["modelValue"])) : b("", !0)
      ], 512),
      e.isOverflow ? (d(), h("button", {
        key: 1,
        class: "scroll-button right",
        onClick: t[4] || (t[4] = (a) => e.onScroll("right"))
      }, t[6] || (t[6] = [
        c("div", { class: "icon-arrow" }, null, -1)
      ]))) : b("", !0)
    ], 512)
  ], 6);
}
const N5e = /* @__PURE__ */ O(k5e, [["render", O5e], ["__scopeId", "data-v-8cad4dcb"]]), P5e = {
  name: "StickyFooter",
  components: {
    StickyFooterV1: N5e
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function H5e(e, t, n, o, i, r) {
  return d(), k(K(n.theme.version), {
    theme: n.theme,
    content: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-preview": n.isPreview,
    "is-editing": n.isEditing
  }, {
    toggle: _(() => [
      w(e.$slots, "toggle")
    ]),
    "pill-button-controls": _(() => [
      w(e.$slots, "pill-button-controls")
    ]),
    "pill-button-title": _(({ title: a }) => [
      w(e.$slots, "pill-button-title", { title: a })
    ]),
    "icon-button-controls": _(({ idx: a }) => [
      w(e.$slots, "icon-button-controls", { idx: a })
    ]),
    "icon-button-title": _(({ title: a, idx: s }) => [
      w(e.$slots, "icon-button-title", {
        title: a,
        idx: s
      })
    ]),
    "icon-button-icon": _(({ idx: a }) => [
      w(e.$slots, "icon-button-icon", { idx: a })
    ]),
    "social-media-controls": _(({ idx: a }) => [
      w(e.$slots, "social-media-controls", { idx: a })
    ]),
    "social-media-icon": _(({ idx: a }) => [
      w(e.$slots, "social-media-icon", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "is-preview", "is-editing"]);
}
const F5e = /* @__PURE__ */ O(P5e, [["render", H5e]]), R5e = {
  name: "CustomComponent",
  components: { DraggableWrapper: at },
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: Object,
      default: at,
      validator(e) {
        return (e == null ? void 0 : e.name) === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    }
  },
  computed: {
    cssCode() {
      return this.theme.css_code;
    },
    jsCode() {
      return this.theme.js_code;
    },
    htmlTree() {
      let e = {};
      try {
        e = RW(this.theme.html_code);
      } catch (t) {
        e = "";
      }
      return e;
    }
  },
  watch: {
    cssCode(e, t) {
      this.hasNewValue(e, t) && this.mountCss(e);
    },
    jsCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(e);
    },
    htmlCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(this.jsCode);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mountCss(this.cssCode), this.mountJs(this.jsCode);
    });
  },
  methods: {
    customComponent(e) {
      return {
        "cms-input": { slotName: "input", tag: "span" },
        "cms-textarea": {
          slotName: "textarea",
          tag: "span",
          style: "white-space: pre-line;"
        },
        "cms-image": { slotName: "image", tag: "span" },
        "cms-icon": { slotName: "icon", tag: "span" },
        "cms-richtextarea": {
          slotName: "richtextarea",
          tag: "span"
        }
      }[e];
    },
    hasNewValue(e, t) {
      return e && e.localeCompare && e.localeCompare(t) !== 0;
    },
    mountCss(e) {
      this.removeElementIfExists("style");
      const t = document.createElement("style");
      t.type = "text/css", t.appendChild(document.createTextNode(e)), this.$el.appendChild(t);
    },
    mountJs(e) {
      this.componentKey += 1, this.$nextTick(() => {
        this.removeElementIfExists("script");
        const t = document.createElement("script");
        t.type = "text/javascript", t.appendChild(document.createTextNode(e)), this.$el.appendChild(t);
      });
    },
    removeElementIfExists(e) {
      const t = document.querySelector(`#${this.id} ${e}`);
      t && t.remove();
    },
    dragHandler(e, t) {
      this.$emit("on-drag", {
        oldIndex: e.oldIndex,
        newIndex: e.newIndex,
        loopName: t
      });
    }
  },
  render() {
    var o;
    const e = (i) => {
      if (!i.properties) return {};
      const r = Object.entries(i.properties).filter(([a]) => a.startsWith("data"));
      return r.length ? r.reduce(
        (a, [s, l]) => he(ie({}, a), {
          [s.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()]: l
        }),
        {}
      ) : {};
    }, t = (i, r, a) => {
      var l, u, m, g, p, T, M, C, E;
      const s = ie({
        id: (l = i.properties) == null ? void 0 : l.id,
        class: (u = i.properties) == null ? void 0 : u.className,
        style: (m = this.customComponent(i.tagName)) == null ? void 0 : m.style,
        className: (p = (g = i.properties) == null ? void 0 : g.className) == null ? void 0 : p.join(" "),
        name: null,
        link: null,
        limit: null,
        src: (T = i.properties) == null ? void 0 : T.src,
        alt: (M = i.properties) == null ? void 0 : M.alt,
        "aspect-ratio": null
      }, e(i));
      if (i.tagName === "cms-loop") {
        const P = () => {
          var H, B;
          const F = ((H = this.content.loop) == null ? void 0 : H[i.properties.name]) || [];
          return [
            ...Array(this.isPreview ? Number((B = i.properties) == null ? void 0 : B.limit) || 5 : F.length || 1)
          ].map(
            (U, x) => {
              var Z, q, ue;
              return Pr("div", {}, [
                (q = (Z = this.$slots).dragControls) == null ? void 0 : q.call(Z, {
                  loopName: i.properties.name,
                  loopIndex: x
                })[0],
                ...(ue = i.children) == null ? void 0 : ue.map((me) => t(me, i.properties.name, x))
              ]);
            }
          );
        };
        return Pr(
          this.wrapperComponent,
          he(ie({}, s), {
            itemKey: "index",
            modelValue: P(),
            class: [...(s == null ? void 0 : s.class) || "", this.isEditing ? "custom-component-loop-wrapper" : ""],
            handle: ".drag-handle",
            onUpdate: (F) => this.dragHandler(F, i.properties.name)
          }),
          {
            item: ({ element: F }) => F,
            footer: () => {
              var F, D, H, B, U, x;
              return [
                [
                  !i.properties.limit || !((D = (F = this.content.loop) == null ? void 0 : F[i.properties.name]) != null && D.length) || Number(i.properties.limit) > ((B = (H = this.content.loop) == null ? void 0 : H[i.properties.name]) == null ? void 0 : B.length) ? (x = (U = this.$slots).addLoopElement) == null ? void 0 : x.call(U, {
                    loopName: i.properties.name
                  })[0] : []
                ]
              ];
            }
          }
        );
      }
      return this.customComponent(i.tagName) ? Pr(this.customComponent(i.tagName).tag, s, [
        this.$slots[this.customComponent(i.tagName).slotName]({
          customName: i.properties.name,
          link: i.properties.hasOwnProperty("link"),
          aspectRatio: (C = i.properties["aspect-ratio"]) != null ? C : "unset",
          inLoop: !!r,
          loopName: r,
          loopIndex: a
        })[0]
      ]) : i.type === "text" ? i.value : Pr(
        i.tagName,
        s,
        (E = i.children) == null ? void 0 : E.map((P) => t(P, r, a))
      );
    }, n = (o = this.htmlTree.children) == null ? void 0 : o.map((i) => t(i));
    return Pr("div", { id: this.theme.container_id }, n);
  }
}, B5e = {
  mixins: [mt, Mf],
  components: { DraggableWrapper: at },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    timeline: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      carrouselItems: this.timeline.items || [],
      isAutoScroll: this.timeline.auto_scroll
    };
  },
  mounted() {
    this.isAutoScroll && !this.isEditing && !this.timeline.hide_component && this.startAutoScroll();
  },
  methods: {
    getAriaLabel(e, t) {
      return `item ${this.getItemNumber(e)} of ${this.carrouselItems.length}, ${t.year}, ${t.title}, ${t.description}, 'Use the left and right arrow keys to navigate'`;
    }
  },
  computed: {
    playPauseAriaLabel() {
      return this.isAutoScroll ? "Pause timeline autoscroll" : "Start timeline autoscroll";
    },
    cssVars() {
      const e = this.sharedThemeColors();
      return he(ie({}, e), {
        "--bg-color": S(this.theme, "bg_color.hex", "#000"),
        "--button-bg-color": S(this.theme, "button_bg_color.hex", "#fff"),
        "--button-icon-color": S(this.theme, "button_icon_color.hex", "#fff"),
        "--name-color": S(this.theme, "name_color.hex", "#fff"),
        "--wave-line-color": S(this.theme, "wave_line_color.hex", "#fff"),
        "--scroll-text-color": S(this.theme, "scroll_text_color.hex", "#fff"),
        "--year-text-color": S(this.theme, "year_text_color.hex", "#fff"),
        "--year-bg-color": S(this.theme, "year_bg_color.hex", "#000"),
        "--card-text-color": S(this.theme, "card_text_color.hex", "#fff")
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, V5e = {
  name: "TimelineV1",
  mixins: [B5e]
}, j5e = { class: "timeline-wrapper" }, U5e = ["data-testid"], G5e = {
  key: 1,
  class: "timeline-box"
}, z5e = {
  class: "buttons-container",
  role: "none"
}, K5e = ["aria-label"], Z5e = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, x5e = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, W5e = ["id", "tabindex", "aria-label"], q5e = { class: "item-image" }, Y5e = { class: "item-year" }, X5e = { class: "item-body-text" }, Q5e = { class: "item-description" }, J5e = { class: "item-title" }, ege = {
  class: "navigation-instructions",
  "aria-live": "assertive",
  "aria-atomic": "true"
}, tge = { key: 0 }, nge = { class: "item carrousel-item" }, oge = { class: "item-image edit" }, rge = { class: "item-year" }, ige = { class: "item-body-text" }, sge = { class: "item-description" }, age = { class: "item-title" };
function lge(e, t, n, o, i, r) {
  const a = $("SeeAllContainer");
  return d(), h("div", {
    style: j(e.cssVars),
    class: v([
      "timeline-v1",
      e.theme.style,
      { "is-editing": e.isEditing },
      { animated: e.theme.wave_animations },
      { hide: e.timeline.hide_component }
    ]),
    "data-testid": "TimelineV1"
  }, [
    c("div", j5e, [
      e.timeline.show_component_header ? (d(), k(a, {
        key: 0,
        class: v(["timeline-header see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: _(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            w(e.$slots, "header", {}, () => [
              A(y(e.timeline.component_header), 1)
            ], !0)
          ], 8, U5e)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])) : b("", !0),
      e.isEditing ? (d(), k(K(e.wrapperComponent), we({ key: 2 }, e.wrapperProps, {
        modelValue: e.timeline.items,
        "onUpdate:modelValue": t[13] || (t[13] = (s) => e.timeline.items = s),
        "item-key": "id",
        class: "draggable-carrousel editable"
      }), {
        item: _(({ element: s, index: l }) => [
          c("div", nge, [
            c("div", oge, [
              w(e.$slots, "image", { idx: l }, void 0, !0),
              (d(), k(K(s.image.url ? "img" : "div"), {
                src: s.image.url,
                alt: s.image.alt_text,
                class: "image"
              }, null, 8, ["src", "alt"])),
              c("span", rge, [
                w(e.$slots, "year", { idx: l }, () => [
                  A(y(s.year), 1)
                ], !0)
              ]),
              c("div", ige, [
                c("span", sge, [
                  w(e.$slots, "description", { idx: l }, () => [
                    A(y(s.description), 1)
                  ], !0)
                ]),
                c("span", age, [
                  w(e.$slots, "title", { idx: l }, () => [
                    A(y(s.title), 1)
                  ], !0)
                ])
              ])
            ])
          ])
        ]),
        _: 3
      }, 16, ["modelValue"])) : (d(), h("div", G5e, [
        t[18] || (t[18] = c("svg", {
          class: "wave-line primary-wave",
          viewBox: "0 24 150 28",
          preserveAspectRatio: "none",
          "shape-rendering": "auto"
        }, [
          c("defs", null, [
            c("path", {
              id: "wave",
              d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            })
          ]),
          c("use", {
            "xlink:href": "#wave",
            x: "50",
            y: "0"
          })
        ], -1)),
        c("div", z5e, [
          e.timeline.auto_scroll ? b("", !0) : (d(), h("button", {
            key: 0,
            class: "slider-button left prev",
            "aria-label": "previous item",
            role: "none",
            onKeyup: t[0] || (t[0] = V((s) => e.moveItem({ direction: "prev" }), ["left"])),
            onClick: t[1] || (t[1] = (s) => e.moveItem({ direction: "prev" }))
          }, t[14] || (t[14] = [
            c("svg", {
              dth: "15",
              height: "28",
              viewBox: "0 0 15 28",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              c("path", {
                fill: "white",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3 14L15 1.5L13.5 -1.31134e-07L-1.30849e-05 14.0428L13.5 28L15 26.5L3 14Z"
              })
            ], -1)
          ]), 32)),
          e.timeline.auto_scroll ? b("", !0) : (d(), h("button", {
            key: 1,
            class: "slider-button right next",
            "aria-label": "next item",
            role: "none",
            onKeyup: t[2] || (t[2] = V((s) => e.moveItem({ direction: "next" }), ["right"])),
            onClick: t[3] || (t[3] = (s) => e.moveItem({ direction: "next" }))
          }, t[15] || (t[15] = [
            c("svg", {
              dth: "15",
              height: "28",
              viewBox: "0 0 15 28",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              c("path", {
                fill: "white",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3 14L15 1.5L13.5 -1.31134e-07L-1.30849e-05 14.0428L13.5 28L15 26.5L3 14Z"
              })
            ], -1)
          ]), 32)),
          e.timeline.auto_scroll ? (d(), h("button", {
            key: 2,
            class: "play-pause",
            "aria-label": e.playPauseAriaLabel,
            onClick: t[4] || (t[4] = (...s) => e.toggleAutoScroll && e.toggleAutoScroll(...s))
          }, [
            e.isAutoScroll ? (d(), h("svg", Z5e, t[16] || (t[16] = [
              c("g", null, [
                c("path", {
                  d: "M8 6V18",
                  "stroke-linecap": "round"
                }),
                c("path", {
                  d: "M16 6V18",
                  "stroke-linecap": "round"
                })
              ], -1)
            ]))) : (d(), h("svg", x5e, t[17] || (t[17] = [
              c("g", null, [
                c("path", { d: "M18.25 11.567C18.5833 11.7594 18.5833 12.2406 18.25 12.433L7.75 18.4952C7.41667 18.6876 7 18.4471 7 18.0622L7 5.93782C7 5.55292 7.41667 5.31236 7.75 5.50481L18.25 11.567Z" })
              ], -1)
            ])))
          ], 8, K5e)) : b("", !0)
        ]),
        c("div", {
          ref: "carrousel",
          role: "none",
          class: "carrousel",
          onTouchstart: t[9] || (t[9] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onTouchend: t[10] || (t[10] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s)),
          onMousedown: t[11] || (t[11] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onMouseup: t[12] || (t[12] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s))
        }, [
          (d(!0), h(Y, null, ee(e.content, (s, l) => (d(), h("div", {
            id: `carrousel-item-${l}`,
            key: l,
            tabindex: l === 3 ? 0 : -1,
            class: "item carrousel-item",
            "aria-label": e.getAriaLabel(l, s),
            role: "group",
            onKeyup: [
              t[5] || (t[5] = V((u) => e.moveItem({ direction: "prev", autofocus: !0 }), ["left"])),
              t[6] || (t[6] = V((u) => e.moveItem({ direction: "next", autofocus: !0 }), ["right"]))
            ],
            onFocus: t[7] || (t[7] = (...u) => e.handleFocus && e.handleFocus(...u)),
            onBlur: t[8] || (t[8] = (...u) => e.handleBlur && e.handleBlur(...u))
          }, [
            c("div", q5e, [
              (d(), k(K(s.image.url ? "img" : "div"), {
                src: s.image.url,
                alt: s.image.alt_text,
                class: "image"
              }, null, 8, ["src", "alt"])),
              c("span", Y5e, y(s.year), 1),
              c("div", X5e, [
                c("span", Q5e, y(s.description), 1),
                c("span", J5e, y(s.title), 1)
              ])
            ])
          ], 40, W5e))), 128))
        ], 544),
        t[19] || (t[19] = c("svg", {
          class: "wave-line secondary-wave",
          viewBox: "0 24 150 28",
          preserveAspectRatio: "none",
          "shape-rendering": "auto"
        }, [
          c("defs", null, [
            c("path", {
              id: "wave",
              d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            })
          ]),
          c("use", {
            "xlink:href": "#wave",
            x: "48",
            y: "3"
          })
        ], -1)),
        c("div", ege, [
          e.onFocus ? (d(), h("span", tge, "Use the left and right arrow keys to navigate")) : b("", !0)
        ])
      ])),
      e.timeline.show_scroll_text ? (d(), h("div", {
        key: 3,
        class: v(["scroll-text", e.theme.style])
      }, [
        w(e.$slots, "scroll", {}, () => [
          A(y(e.timeline.scroll_text), 1)
        ], !0)
      ], 2)) : b("", !0)
    ])
  ], 6);
}
const uge = /* @__PURE__ */ O(V5e, [["render", lge], ["__scopeId", "data-v-b253921a"]]), dge = {
  name: "Timeline",
  components: {
    TimelineV1: uge
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    timeline: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function cge(e, t, n, o, i, r) {
  return d(), k(K(n.theme.version), {
    theme: n.theme,
    timeline: n.timeline,
    "is-preview": n.isPreview,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing
  }, {
    header: _(() => [
      w(e.$slots, "header")
    ]),
    year: _(({ idx: a }) => [
      w(e.$slots, "year", { idx: a })
    ]),
    title: _(({ idx: a }) => [
      w(e.$slots, "title", { idx: a })
    ]),
    description: _(({ idx: a }) => [
      w(e.$slots, "description", { idx: a })
    ]),
    scroll: _(() => [
      w(e.$slots, "scroll")
    ]),
    image: _(({ idx: a }) => [
      w(e.$slots, "image", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "timeline", "is-preview", "wrapper-component", "wrapper-props", "is-editing"]);
}
const hge = /* @__PURE__ */ O(dge, [["render", cge]]), mge = {
  mixins: [Tt, mt],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      function t(n) {
        const o = S(n, "cta_color_option") === "solid", i = S(n, "cta_gradient_direction", "down"), r = S(n, "cta_background_color.hex", "initial"), a = o ? r : S(n, "cta_background_secondary_color.hex", r);
        return i == "center" ? {
          "--cta-gradient": `radial-gradient(${r}, ${a})`,
          "--cta-gradient-fancy": `radial-gradient(in oklch, ${r}, ${a})`
        } : {
          "--cta-gradient": `linear-gradient(to ${i}, ${r}, ${a})`,
          "--cta-gradient-fancy": `linear-gradient(in oklch to ${i}, ${r}, ${a})`
        };
      }
      return he(ie(ie({}, e), t(this.theme)), {
        "--cta-title-color": S(this.theme, "cta_title_color.hex", "initial"),
        "--cta-subtitle-color": S(this.theme, "cta_subtitle_color.hex", "initial"),
        "--cta-divider-color": S(this.theme, "cta_divider_color.hex", "initial"),
        "--cta-text-color": S(this.theme, "cta_text_color.hex", "initial"),
        "--cta-border-color": S(this.theme, "cta_border_color.hex", "initial"),
        "--cta-border-width": S(this.theme, "cta_border_width", "1") + "px",
        "--cta-button-color": S(this.theme, "cta_button_color.hex", "initial"),
        "--cta-button-text-color": S(this.theme, "cta_button_text_color.hex", "initial"),
        "--cta-button-hover": S(this.theme, "cta_button_hover.hex", "initial"),
        "--cta-overlay-color": ae(S(this.theme, "cta_overlay_color.hex", "initial")).setAlpha(0.85).toRgbString()
      });
    },
    translations() {
      return this.theme.translations;
    },
    isMobile() {
      return this.screenSize < 601;
    },
    isBordered() {
      return S(this.theme, "cta_border_enabled", !0);
    },
    isImageEnabled() {
      return S(this.theme, "cta_image_enabled", !0);
    },
    isParallaxEnabled() {
      return S(this.theme, "cta_parallax_enabled", !0);
    },
    buttonStyle() {
      return S(this.theme, "cta_button_style", "solid");
    }
  }
}, pge = {
  name: "CTA1",
  mixins: [mge],
  computed: {
    buttonComponent() {
      return this.isEditing ? "div" : this.isPreview ? "button" : "a";
    }
  }
}, fge = {
  key: 0,
  ref: "parallax",
  class: "parallax-container"
}, gge = {
  key: 1,
  class: "image-container"
}, vge = ["src"], bge = {
  key: 1,
  class: "solid-background"
}, yge = { class: "content-container" }, _ge = { class: "cta-title" }, Cge = {
  key: 0,
  class: "cta-subtitle"
}, wge = {
  key: 1,
  class: "cta-divider"
}, Tge = {
  key: 2,
  class: "cta-text-content"
}, kge = { class: "cta-buttons" };
function Ege(e, t, n, o, i, r) {
  var a, s, l, u, m, g, p, T, M;
  return d(), h("div", {
    id: "cta-v1",
    class: v([e.theme.style, { isPreview: e.isPreview, isEditing: e.isEditing }]),
    style: j(e.colors),
    "data-testid": "CTA1"
  }, [
    e.isImageEnabled && ((a = e.content) != null && a.image) && ((l = (s = e.content) == null ? void 0 : s.image) != null && l.url) ? (d(), h(Y, { key: 0 }, [
      e.isParallaxEnabled ? (d(), h("div", fge, [
        c("div", {
          class: "parallax",
          style: j({ backgroundImage: `url(${(m = (u = e.content) == null ? void 0 : u.image) == null ? void 0 : m.url})` })
        }, null, 4),
        t[0] || (t[0] = c("div", { class: "image-overlay" }, null, -1))
      ], 512)) : (d(), h("div", gge, [
        c("img", {
          class: "full-image",
          src: (p = (g = e.content) == null ? void 0 : g.image) == null ? void 0 : p.url,
          alt: ""
        }, null, 8, vge),
        t[1] || (t[1] = c("div", { class: "image-overlay" }, null, -1))
      ]))
    ], 64)) : (d(), h("div", bge)),
    c("div", {
      class: v(["content-overlay", [e.isBordered && "bordered"]])
    }, [
      c("div", yge, [
        c("h2", _ge, [
          w(e.$slots, "title", {
            title: e.content.title
          }, () => [
            A(y(e.content.title), 1)
          ], !0)
        ]),
        e.content.subtitle_enabled ? (d(), h("h3", Cge, [
          w(e.$slots, "subtitle", {
            subtitle: e.content.subtitle
          }, () => [
            A(y(e.content.subtitle), 1)
          ], !0)
        ])) : b("", !0),
        e.content.paragraph_enabled ? (d(), h("hr", wge)) : b("", !0),
        e.content.paragraph_enabled ? (d(), h("p", Tge, [
          w(e.$slots, "text", {
            text: e.content.text
          }, () => [
            A(y(e.content.text), 1)
          ], !0)
        ])) : b("", !0),
        c("div", kge, [
          (T = e.content.button_1) != null && T.enabled ? (d(), k(K(r.buttonComponent), {
            key: 0,
            class: v(["cta-button cta-button-1", e.buttonStyle]),
            href: e.content.button_1.link,
            target: e.content.button_1.opens_in_new_tab ? "_blank" : ""
          }, {
            default: _(() => [
              w(e.$slots, "button1", {
                button: e.content.button_1
              }, () => [
                A(y(e.content.button_1.label), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["class", "href", "target"])) : b("", !0),
          (M = e.content.button_2) != null && M.enabled ? (d(), k(K(r.buttonComponent), {
            key: 1,
            class: v(["cta-button cta-button-2", e.buttonStyle]),
            href: e.content.button_2.link,
            target: e.content.button_2.opens_in_new_tab ? "_blank" : ""
          }, {
            default: _(() => [
              w(e.$slots, "button2", {
                button: e.content.button_2
              }, () => [
                A(y(e.content.button_2.label), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["class", "href", "target"])) : b("", !0)
        ])
      ])
    ], 2)
  ], 6);
}
const Sge = /* @__PURE__ */ O(pge, [["render", Ege], ["__scopeId", "data-v-48f57ea5"]]), Mge = {
  name: "CallToAction",
  components: {
    CTA1: Sge
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  }
}, Age = { id: "view-call-to-aciton" };
function $ge(e, t, n, o, i, r) {
  return d(), h("div", Age, [
    (d(), k(K(n.theme.version), {
      theme: n.theme,
      content: n.content,
      "is-editing": n.isEditing,
      "is-preview": n.isPreview
    }, {
      title: _(() => [
        w(e.$slots, "title")
      ]),
      subtitle: _(() => [
        w(e.$slots, "subtitle")
      ]),
      text: _(() => [
        w(e.$slots, "text")
      ]),
      button1: _(() => [
        w(e.$slots, "button1")
      ]),
      button2: _(() => [
        w(e.$slots, "button2")
      ]),
      _: 3
    }, 8, ["theme", "content", "is-editing", "is-preview"]))
  ]);
}
const Ige = /* @__PURE__ */ O(Mge, [["render", $ge]]), D0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CmsAbout: Rpe,
  CmsAlertBanner: Xpe,
  CmsAlertBannerSeparate: ffe,
  CmsAlertModal: xpe,
  CmsAlertModalSeparate: lfe,
  CmsAthletics: Sme,
  CmsButtons: Qme,
  CmsCallToAction: Ige,
  CmsCustomComponent: R5e,
  CmsCustomHtml: Aa,
  CmsEvents: Vse,
  CmsFloatingNav: Ufe,
  CmsFooter: TQ,
  CmsGallery: ok,
  CmsHeader: Iq,
  CmsLiveFeed: U1e,
  CmsMediaCustomHtml: w5e,
  CmsMenu: nX,
  CmsOurSchools: b5e,
  CmsParallax: wfe,
  CmsPrograms: Rre,
  CmsSpotlight: pme,
  CmsStats: Jce,
  CmsStickyFooter: F5e,
  CmsTimeline: hge,
  CmsVideo: R0e,
  News: bv
}, Symbol.toStringTag, { value: "Module" })), Dge = {
  install(e) {
    e.use(u5), Object.keys(D0).forEach((t) => {
      e.component(t, D0[t]);
    });
  }
}, Nge = Dge;
export {
  Nge as plugin
};
//# sourceMappingURL=cms-components.es.js.map
